function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("425eT", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$331133c13a2bfcca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $jD5no;
    var $l06k4;
    var $dfBI5;
    var $7nKe3;
    var $x8FYU;
    var $1kpI8;
    var $l2N2a;
    var $9dbF6;
    var $9NiTW;
    var $l8ruj;
    const $331133c13a2bfcca$var$JiraBusinessCalendarApp = ()=>{
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const hasCreatePermission = Boolean(project?.permissions.createIssues);
        const canScheduleIssues = Boolean(project?.permissions.scheduleIssues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-business-calendar-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "business"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nKe3")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l06k4")).default), {
            hasInlineCreate: hasCreatePermission,
            hasScheduleIssues: canScheduleIssues,
            hasUnscheduledButton: canScheduleIssues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kpI8")).ViewPreferencesProvider), {
            view: "calendar",
            preferences: (0, (0, parcelRequire("x8FYU")).CALENDAR_VIEW_PREFERENCES)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dfBI5")).default), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "core"
        }))));
    };
    var $331133c13a2bfcca$export$2e2bcd8739ae039 = $331133c13a2bfcca$var$JiraBusinessCalendarApp;
});
parcelRegister("l06k4", function(module, exports) {
    $parcel$export(module.exports, "useCalendarFeatures", ()=>$e99482e220cf066d$export$eb876443ab848751);
    $parcel$export(module.exports, "default", ()=>$e99482e220cf066d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $e99482e220cf066d$var$defaultFeaturesContext = {
        featureView: 'calendar',
        hasFilterCustomFields: true,
        hasInlineCreate: true,
        hasInviteButton: true,
        hasOnboarding: true,
        hasPresence: true,
        hasScheduleIssues: true,
        hasShareButton: true,
        hasSoftwareReleases: true,
        hasUnscheduledButton: true,
        inviteButtonInteraction: 'default',
        issueViewInteraction: 'default'
    };
    const $e99482e220cf066d$var$CalendarFeaturesContext = (0, $5uXOq.createContext)($e99482e220cf066d$var$defaultFeaturesContext);
    const $e99482e220cf066d$export$eb876443ab848751 = ()=>(0, $5uXOq.useContext)($e99482e220cf066d$var$CalendarFeaturesContext);
    const $e99482e220cf066d$var$CalendarFeaturesProvider = ({ children: children, ...props })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                ...$e99482e220cf066d$var$defaultFeaturesContext,
                ...props
            }), [
            props
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e99482e220cf066d$var$CalendarFeaturesContext.Provider, {
            value: value
        }, children);
    };
    var $e99482e220cf066d$export$2e2bcd8739ae039 = $e99482e220cf066d$var$CalendarFeaturesProvider;
});
parcelRegister("dfBI5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0a0b05bc32acf1c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXhsp;
    var $AeWM3;
    var $eiOkd;
    var $adJfs;
    var $cm8b5;
    var $cLGgz;
    var $asqbQ;
    var $iXVV6;
    var $5oFIy;
    var $f42Sq;
    var $3RCti;
    var $l06k4;
    var $7Q0EF;
    var $detXF;
    const $f0a0b05bc32acf1c$var$analyticsSourceName = 'calendarView';
    const $f0a0b05bc32acf1c$var$analyticsContext = {
        viewType: 'month'
    };
    const $f0a0b05bc32acf1c$export$e3c8db6e5dc6436e = (0, $5uXOq.memo)(()=>{
        const { hasInlineCreate: hasInlineCreate, hasFilterCustomFields: hasFilterCustomFields } = (0, (0, parcelRequire("l06k4")).useCalendarFeatures)();
        const isUsingIssueTypesAndFields = hasInlineCreate || hasFilterCustomFields;
        const services = (0, (0, parcelRequire("7Q0EF")).useCreateIssue)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3RCti")).ConnectedProjectsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("detXF")).default), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("asqbQ")).IssueEventProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiOkd")).default), {
            withSidebar: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "calendar",
            attributes: $f0a0b05bc32acf1c$var$analyticsContext,
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: $f0a0b05bc32acf1c$var$analyticsSourceName
        }, isUsingIssueTypesAndFields ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adJfs")).IssueTypesAndFieldsContext), null, hasInlineCreate ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLGgz")).IssueCreateProvider), {
            onCreateIssue: services.createIssue,
            onRefetchIssue: services.refetchIssue
        }, content) : content) : content, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null))));
    });
    const $f0a0b05bc32acf1c$var$Calendar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("f42Sq")).MAIN_EXPERIENCE),
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0a0b05bc32acf1c$export$e3c8db6e5dc6436e, null)));
    var $f0a0b05bc32acf1c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f0a0b05bc32acf1c$var$Calendar);
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $dxpxC;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("clSzL")).Observable)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("dxpxC")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("clSzL")).Observable).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("clSzL")).Observable).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("dxpxC", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$4350c2bcf1320fcf$export$fb326ed954631f3f);
    var $clSzL;
    var $bFU4G;
    const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("eiOkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98d0f47ed36cd9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $6cG4N;
    var $bUSNl;
    var $lLfAu;
    var $aXDiy;
    const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
        const [{ content: sidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const isSidebarOpen = withSidebar && sidebarContent != null;
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, children);
        if (withSidebar) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLfAu")).SidebarLayout), {
            theme: sidebarTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $b98d0f47ed36cd9a$var$contentWrapperStyles,
                isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
            ]
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aXDiy")).ThemedContainer), {
            shouldAddPadding: shouldAddPadding,
            isSidebarOpen: isSidebarOpen,
            withSidebar: withSidebar,
            withDynamicHeight: withDynamicHeight,
            withOverflow: withOverflow,
            id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
            className: className
        }, content);
    };
    const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto'
    });
    const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingRight: 'space.300',
        paddingBottom: 'space.300'
    });
    var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';
parcelRegister("bUSNl", function(module, exports) {
    $parcel$export(module.exports, "getSidebarQueryParams", ()=>$39fc2da09b28cabf$export$ddc11e4d41e7cf62);
    $parcel$export(module.exports, "useSidebar", ()=>$39fc2da09b28cabf$export$54c70f22f548bff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $3hGWp;
    var $dCm1o;
    var $3sQ5x;
    var $iXqE5;
    var $jnA4H;
    const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
    const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
            (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
            (0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM)
        ];
    const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
    const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                content: content
            });
        };
    const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
            if (newWidth === state.sidebarWidth) return;
            setState({
                ...state,
                sidebarWidth: newWidth
            });
            (0, (0, parcelRequire("jnA4H")).localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
        };
    const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                onSidebarClose: onSidebarClose
            });
        };
    const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            state.onSidebarClose();
            setState({
                ...state,
                content: null,
                onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
            });
        };
    const $39fc2da09b28cabf$var$actions = {
        setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
        setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
        setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
        closeSidebar: $39fc2da09b28cabf$var$closeSidebar
    };
    const $39fc2da09b28cabf$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            content: null,
            sidebarWidth: (0, (0, parcelRequire("jnA4H")).localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
            onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $39fc2da09b28cabf$var$actions,
        name: 'JWMSidebarStore'
    });
    const $39fc2da09b28cabf$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($39fc2da09b28cabf$var$Store);
    const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
        const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
        const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
        const [, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
            const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                    [param]: undefined
                }), {});
            setQueryParams(newQueryParams);
        }, [
            setQueryParams,
            sidebarQueryParams
        ]);
        return [
            state,
            {
                ...hookActions,
                resetSidebarQueryParams: resetSidebarQueryParams
            }
        ];
    };
});
parcelRegister("hE5wF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", ()=>$bfd6cbe4770149b5$export$8386e51ba415e85d);
    $parcel$export(module.exports, "DEFAULT_AVATAR_RES", ()=>$bfd6cbe4770149b5$export$159fe44438c210e9);
    $parcel$export(module.exports, "FILTER_PARAM", ()=>$bfd6cbe4770149b5$export$d8301e0b33832d94);
    $parcel$export(module.exports, "INLINE_CREATE_PARAM", ()=>$bfd6cbe4770149b5$export$599c163c1570a353);
    $parcel$export(module.exports, "INVITE_OPEN_PARAM", ()=>$bfd6cbe4770149b5$export$3a74d1a195d2f007);
    $parcel$export(module.exports, "SELECTED_ISSUE_PARAM", ()=>$bfd6cbe4770149b5$export$c070acdc9b0f1be5);
    $parcel$export(module.exports, "SELECTED_COMMENT_PARAM", ()=>$bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
    $parcel$export(module.exports, "GROUP_BY_ASSIGNEE", ()=>$bfd6cbe4770149b5$export$dba794af6c0f2afc);
    $parcel$export(module.exports, "GROUP_BY_PRIORITY", ()=>$bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
    $parcel$export(module.exports, "GROUP_BY_CATEGORY", ()=>$bfd6cbe4770149b5$export$22ef551f315f2786);
    $parcel$export(module.exports, "GROUP_BY_STATUS", ()=>$bfd6cbe4770149b5$export$6d69efb296b78a);
    $parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e23e1d1ea45171c2);
    $parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e35c6e217c75dc4b);
    $parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", ()=>$bfd6cbe4770149b5$export$e5eab344feb92af9);
    $parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", ()=>$bfd6cbe4770149b5$export$a311e1b78816c048);
    $parcel$export(module.exports, "CARD_COVERS_TYPE", ()=>$bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$bfd6cbe4770149b5$export$5716e8bcb003888d);
    $parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$1f9fb9f15184100f);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$c72ea455b368cdd9);
    const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
    const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
    const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
    const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
    const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
    const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
    const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
    const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
    const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
    const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
    const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
    const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
    const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
    const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
    const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
    const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
    const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
    const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
    const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
    const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
    const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("jnA4H", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$301038d04a64b539$export$c2ed3351cac403d1);
    var $bSSG7;
    const $301038d04a64b539$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_common');
});
parcelRegister("lLfAu", function(module, exports) {
    $parcel$export(module.exports, "SidebarLayout", ()=>$1dbab6fa0f2d1b51$export$8295a33ab8a36876);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $getxR;
    var $He4jn;
    var $bUSNl;
    var $eHSp3;
    const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $1dbab6fa0f2d1b51$var$sidebarStyles,
                theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
            ],
            style: {
                width: sidebarWidth
            }
        }, children);
    const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
        (0, (0, parcelRequire("getxR")).useSidebarQueryParams)();
        const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, (0, parcelRequire("He4jn")).useResizer)();
        (0, $5uXOq.useEffect)(()=>()=>{
                setSidebarContent(null);
            }, [
            setSidebarContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).Wrapper), {
            isResizing: isResizing,
            "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
        }, children, content && (0, ($parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
            sidebarWidth: sidebarWidth,
            theme: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).ResizeHandle), {
            onMouseDown: onMouseDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).SidebarContent), null, content)));
    };
    const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface',
        flexGrow: 0,
        flexShrink: 0,
        position: 'relative',
        zIndex: 'card',
        maxWidth: '75%'
    });
    const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'border.radius.200',
        borderTopRightRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        marginRight: 'space.300',
        marginTop: 'space.300'
    });
});
parcelRegister("getxR", function(module, exports) {
    $parcel$export(module.exports, "useSidebarQueryParams", ()=>$7ddee5a34b903b90$export$34adbeffbeceba68);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $3hGWp;
    var $bUSNl;
    const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const sidebarQueryParams = (0, (0, parcelRequire("bUSNl")).getSidebarQueryParams)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const prevQueryParams = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(queryParams);
        const closeSidebar = (0, $5uXOq.useCallback)(()=>{
            resetSidebarQueryParams();
            setSidebarContent(null);
        }, [
            resetSidebarQueryParams,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarQueryParams.forEach((queryParam)=>{
                if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                    const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                            [param]: undefined
                        }), {});
                    setQueryParams(newQueryParams);
                }
            });
        }, [
            prevQueryParams,
            queryParams,
            setQueryParams,
            sidebarQueryParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleKeydown = (event)=>{
                if (!queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
                if (queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') return;
                if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                    closeSidebar();
                }
            };
            typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            closeSidebar,
            content?.key,
            createAnalyticsEvent,
            queryParams
        ]);
    };
});
parcelRegister("He4jn", function(module, exports) {
    $parcel$export(module.exports, "useResizer", ()=>$80d7a99fb39f1e91$export$faede3f1542958fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $bUSNl;
    const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
    const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
        const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const startRef = (0, $5uXOq.useRef)(0);
        const width = (0, $5uXOq.useRef)(0);
        const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
        const resize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((clientX)=>{
            const proposedWidth = width.current + startRef.current - clientX;
            setSidebarWidth(proposedWidth);
        }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
            setSidebarWidth
        ]);
        const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            resize(event.clientX);
        }, [
            resize
        ]);
        const onMouseUp = (0, $5uXOq.useCallback)(()=>{
            startRef.current = 0;
            width.current = 0;
            setIsResizing(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }, [
            onMouseMove,
            onMouseUp
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
            startRef.current = event.clientX;
            width.current = sidebarWidth;
            setIsResizing(true);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove,
            onMouseUp,
            sidebarWidth
        ]);
        return {
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            isResizing: isResizing
        };
    };
});
parcelRegister("eHSp3", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$71d20039839e60ab$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SidebarContent", ()=>$71d20039839e60ab$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "ResizeHandle", ()=>$71d20039839e60ab$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $71d20039839e60ab$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isResizing: isResizing, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
                __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$49e8f7b58a4df4ea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$33f2411a0ad35be7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aXDiy", function(module, exports) {
    $parcel$export(module.exports, "ThemedContainer", ()=>$0d3cb0cba7f538e9$export$2a4209ec8a7db359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0d3cb0cba7f538e9$export$2a4209ec8a7db359 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
                !__cmplp.withSidebar && "_syazfrbu",
                __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
                __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
                __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
                __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("adJfs", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesAndFieldsContext", ()=>$1c25c33c14b14fda$export$31eaf35dc72d0fa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $8zOmE;
    var $2NMNM;
    var $1T2vX;
    const $1c25c33c14b14fda$var$noop = ()=>{};
    const $1c25c33c14b14fda$var$TRACKING_TIMEOUT = 1000;
    const $1c25c33c14b14fda$export$31eaf35dc72d0fa0 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const IssueTypesAndFieldsViewContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'VIEW'
        });
        const IssueTypesAndFieldsCreateContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'CREATE'
        });
        const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return $1c25c33c14b14fda$var$noop;
            const timeoutId = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                    watches: client?.cache?.watches?.size
                });
            }, $1c25c33c14b14fda$var$TRACKING_TIMEOUT);
            return ()=>{
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [
            createAnalyticsEvent,
            loading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextView).Provider, {
            value: IssueTypesAndFieldsViewContextProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextCreate).Provider, {
            value: IssueTypesAndFieldsCreateContextProps
        }, children));
    };
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("1T2vX", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesAndFieldsService", ()=>$90cf08abf5e3ede7$export$3ef3324b7f7d6a38);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextView", ()=>$90cf08abf5e3ede7$export$77937175321fab39);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", ()=>$90cf08abf5e3ede7$export$fbd286e14113bfc);
    $parcel$export(module.exports, "useIssueTypesAndFields", ()=>$90cf08abf5e3ede7$export$d2121b02f0b65782);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $gN11a;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $1nb22;
    var $doZTA;
    var $8Zw8m;
    var $8tTgF;
    const $90cf08abf5e3ede7$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
    const $90cf08abf5e3ede7$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
    const $90cf08abf5e3ede7$var$isProjectPermissionError = (error)=>error.message.indexOf($90cf08abf5e3ede7$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($90cf08abf5e3ede7$export$4c72baf45fce4585) > -1 || error.extensions?.statusCode === 403 || error.extensions?.statusCode === 404;
    const $90cf08abf5e3ede7$export$6b9bc8a33ade0736 = (input)=>{
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(routerState?.match, routerState?.query);
        const variables = (0, $5uXOq.useMemo)(()=>({
                projectKey: projectKey,
                issueOperation: input.issueOperation,
                first: 100
            }), [
            input.issueOperation,
            projectKey
        ]);
        const { query: query, view: view } = (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)[0, (0, parcelRequire("8Zw8m")).DEFAULT];
        return (0, $5uXOq.useMemo)(()=>({
                loading: false,
                query: query,
                view: view,
                variables: variables
            }), [
            query,
            view,
            variables
        ]);
    };
    const $90cf08abf5e3ede7$export$1768f0a0f85b4de9 = (input)=>{
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { variables: queryVariables, query: query } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
        return (0, $5uXOq.useCallback)(({ findField: findField, updateItem: updateItem })=>{
            const getCacheData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: queryVariables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useIssueTypesAndFieldsCache',
                            packageName: 'jiraBusinessEntityProject',
                            teamName: 'wanjel'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(queryVariables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const cacheData = getCacheData();
            const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
            if (existingEdges == null) return;
            let shouldUpdate = false;
            const newEdges = existingEdges.map((edge)=>{
                const existingFields = edge?.node?.fields?.edges;
                if (existingFields == null) return edge;
                const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
                const existingField = existingFields[itemToUpdateIndex]?.node;
                if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
                const itemOverride = updateItem(existingField);
                if (itemOverride === undefined) return edge;
                const newFields = [
                    ...existingFields
                ];
                newFields[itemToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraIssueFieldEdge'
                };
                shouldUpdate = true;
                return {
                    ...edge,
                    node: {
                        ...edge?.node || {},
                        fields: {
                            edges: newFields,
                            __typename: 'JiraIssueFieldConnection'
                        }
                    }
                };
            });
            if (!shouldUpdate) return;
            const newData = {
                ...cacheData,
                jiraBusinessAvailableFields: {
                    ...cacheData?.jiraBusinessAvailableFields || {},
                    edges: newEdges
                }
            };
            try {
                client.writeQuery({
                    query: query,
                    variables: queryVariables,
                    notifyOnNetworkStatusChange: true,
                    data: newData
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            query,
            queryVariables
        ]);
    };
    const $90cf08abf5e3ede7$export$3ef3324b7f7d6a38 = (input)=>{
        const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $5uXOq.useState)(false);
        const fetchAttempts = (0, $5uXOq.useRef)(0);
        const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: queryVariables,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            onError: (apolloError)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if ($90cf08abf5e3ede7$var$isProjectPermissionError(apolloError)) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: `availableFields${view}ViewQuery`,
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: `Failed to fetch available fields in ${view} view`
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (onCompletedData)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if (onCompletedData?.jiraBusinessAvailableFields == null) throw error || new Error('No available fields data');
                onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                    const fieldEdges = e?.node?.fields?.edges;
                    if (fieldEdges == null || fieldEdges?.length === 0) {
                        const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                        const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                        if (fetchAttempts.current < 1) {
                            fetchAttempts.current += 1;
                            refetch();
                        } else throw emptyFieldsError;
                    }
                });
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (queryVariables && !hasStartedFetchingFields && !error) {
                setHasStartedFetchingFields(true);
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$7b887ee35f2b465e));
                getAvailableFields();
            }
        }, [
            error,
            getAvailableFields,
            hasStartedFetchingFields,
            queryVariables,
            view
        ]);
        const refetch = (0, $5uXOq.useCallback)(()=>{
            if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
            const err = new Error('availableFields refetch is undefined because the service has not been called yet');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'availableFieldsRefetchIsUndefined',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        }, [
            called,
            refetchQuery,
            queryVariables
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
        }, [
            hasStartedFetchingFields,
            error
        ]);
        const result = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResult)(data), [
            data
        ]);
        const typesWithFields = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResultToTypesWithFields)(data), [
            data
        ]);
        const hierarchyLevels = (0, $5uXOq.useMemo)(()=>result.issueTypes.map((issueType)=>({
                    level: issueType.hierarchyLevel,
                    name: issueType.name,
                    id: issueType.id
                })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
            result.issueTypes
        ]);
        const isFieldsLoading = hasStartedFetchingFields ? loading : true;
        return {
            error: error,
            loading: error ? false : isQueryLoading || isFieldsLoading,
            data: result,
            typesWithFields: typesWithFields,
            hierarchyLevels: hierarchyLevels,
            refetch: refetch
        };
    };
    const $90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue = {
        data: {
            fields: [],
            issueTypes: []
        },
        loading: false,
        error: undefined,
        typesWithFields: [],
        hierarchyLevels: []
    };
    const $90cf08abf5e3ede7$export$77937175321fab39 = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$fbd286e14113bfc = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$d2121b02f0b65782 = (input)=>{
        const issueTypesAndFieldsViewData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$77937175321fab39);
        const issueTypesAndFieldsCreateData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$fbd286e14113bfc);
        if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
        return issueTypesAndFieldsCreateData;
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("8Zw8m", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT", ()=>$c9bd1f086657e924$export$e6952b12ade67489);
    $parcel$export(module.exports, "HierarchyLevel", ()=>$c9bd1f086657e924$export$7faaf3222dfd10db);
    const $c9bd1f086657e924$export$e6952b12ade67489 = 'default';
    const $c9bd1f086657e924$export$7faaf3222dfd10db = Object.freeze({
        EPIC: 1,
        BASE: 0,
        SUBTASK: -1
    });
});
parcelRegister("8tTgF", function(module, exports) {
    $parcel$export(module.exports, "transformResult", ()=>$66b8ed432f1db6bc$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "transformResultToTypesWithFields", ()=>$66b8ed432f1db6bc$export$55ab7865f91ba09b);
    $parcel$export(module.exports, "JWMQueryByRouteMap", ()=>$66b8ed432f1db6bc$export$7188da46161cbb8f);
    var $65Ltd;
    var $5fc53;
    var $8Zw8m;
    var $e3MSU;
    const $66b8ed432f1db6bc$export$b07b0d8dc0894ecf = {
        fields: [],
        issueTypes: []
    };
    const $66b8ed432f1db6bc$var$emptyArray = [];
    const $66b8ed432f1db6bc$export$bffa388e20165996 = (node, issueType)=>{
        const fieldConfig = {
            isRequired: !!node.fieldConfig?.isRequired,
            isEditable: !!node.fieldConfig?.isEditable
        };
        if (node.type === 'priority') {
            fieldConfig.options = node.priorities.nodes;
            if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
            else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
        }
        if (node.type === 'issuetype') {
            fieldConfig.options = node.issueTypes.nodes;
            fieldConfig.avatarId = issueType.avatarId;
            fieldConfig.avatarUrl = issueType.avatar?.medium;
        }
        if (node.type === 'issuelinks' && node.issueLinkTypeRelations) fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find((linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || node.type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId,
                    color: color?.colorKey ?? null
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        return {
            id: node.fieldId,
            aliasFieldId: node.aliasFieldId,
            name: node.name,
            type: node.type,
            fieldConfig: fieldConfig,
            issueTypes: [],
            __typename: node.__typename
        };
    };
    const $66b8ed432f1db6bc$export$f13b29f9ed0c5a03 = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
            const issueFieldsById = {};
            const issueTypesById = {};
            data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
                issueTypesById[issueType.issueTypeId] = {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? null,
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                };
                fields.edges.map((edge)=>edge && edge.node || {}).forEach((node)=>{
                    if (node.fieldId) {
                        if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $66b8ed432f1db6bc$export$bffa388e20165996(node, issueType);
                        issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                        issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                    }
                });
            });
            return {
                fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
                issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
            };
        }
        return $66b8ed432f1db6bc$export$b07b0d8dc0894ecf;
    };
    const $66b8ed432f1db6bc$export$55ab7865f91ba09b = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
                issueType: {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? '',
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                },
                fields: fields.edges.map((edge)=>edge && edge.node || {}).map((node)=>$66b8ed432f1db6bc$export$bffa388e20165996(node, issueType))
            }));
        return $66b8ed432f1db6bc$var$emptyArray;
    };
    const $66b8ed432f1db6bc$export$7188da46161cbb8f = {
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM)]: {
            view: 'Form',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT)]: {
            view: 'FormSubmit',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR)]: {
            view: 'Calendar',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED)]: {
            view: 'CalendarEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST)]: {
            view: 'List',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED)]: {
            view: 'ListEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE)]: {
            view: 'Timeline',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED)]: {
            view: 'TimelineEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD)]: {
            view: 'Board',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED)]: {
            view: 'BoardEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("8Zw8m")).DEFAULT)]: {
            view: 'Common',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        }
    };
});
parcelRegister("e3MSU", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", ()=>$32ca725097f9e68f$export$ba5f98a8d6136727);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", ()=>$32ca725097f9e68f$export$cba408dff1091b60);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", ()=>$32ca725097f9e68f$export$363435cea078aa93);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", ()=>$32ca725097f9e68f$export$1641a42cf2cdb09a);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", ()=>$32ca725097f9e68f$export$7903c43b0ec55315);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", ()=>$32ca725097f9e68f$export$79304c172f5555ae);
    var $5cllN;
    const $32ca725097f9e68f$export$ec2562ca5badac3b = (0, (0, parcelRequire("5cllN")).default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
    const $32ca725097f9e68f$export$ba5f98a8d6136727 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$cba408dff1091b60 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$363435cea078aa93 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$1641a42cf2cdb09a = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$7903c43b0ec55315 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$79304c172f5555ae = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
});
parcelRegister("cLGgz", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateProvider", ()=>$dc15b071bf2d5f6e$export$a975cd9627cdf4b6);
    $parcel$export(module.exports, "useCreateIssue", ()=>$dc15b071bf2d5f6e$export$8af2d18142c8506c);
    $parcel$export(module.exports, "isOptimisticIssue", ()=>$dc15b071bf2d5f6e$export$8512029c7fc94e58);
    $parcel$export(module.exports, "useIsHighlighted", ()=>$dc15b071bf2d5f6e$export$2ecca9d8a7f031af);
    var $5uXOq = parcelRequire("5uXOq");
    var $dqDis;
    var $4R6GH;
    var $cYlk7;
    var $ja8d8;
    var $ecPXN;
    class $dc15b071bf2d5f6e$var$IssueCreateJob {
        constructor(createParams){
            this.createParams = createParams;
            this.promise = new Promise((resolve, reject)=>{
                this.reject = reject;
                this.resolve = resolve;
            });
        }
    }
    const $dc15b071bf2d5f6e$var$IssueCreateContext = (0, $5uXOq.createContext)(null);
    const $dc15b071bf2d5f6e$var$reducer = (state, action)=>{
        switch(action.type){
            case 'enqueue':
                return {
                    ...state,
                    jobQueue: [
                        ...state.jobQueue,
                        action.job
                    ]
                };
            case 'start-job':
                return {
                    ...state,
                    runningJob: state.jobQueue[0],
                    jobQueue: state.jobQueue.slice(1)
                };
            case 'end-job':
                return {
                    ...state,
                    runningJob: null
                };
            case 'highlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues,
                        action.issueId
                    ])
                };
            case 'unhighlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues
                    ].filter((id)=>id !== action.issueId))
                };
            case 'save-summary':
                return {
                    ...state,
                    summary: action.summary
                };
            default:
                return state;
        }
    };
    const $dc15b071bf2d5f6e$var$initialState = {
        jobQueue: [],
        runningJob: null,
        highlightedIssues: new Set(),
        summary: ''
    };
    const $dc15b071bf2d5f6e$export$a975cd9627cdf4b6 = ({ onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const currentUser = user;
        const nextIssueId = (0, $5uXOq.useRef)(-1);
        const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $5uXOq.useReducer)($dc15b071bf2d5f6e$var$reducer, $dc15b071bf2d5f6e$var$initialState);
        const createIssueController = (0, (0, parcelRequire("ja8d8")).useCreateIssue)(onCreateIssue, onRefetchIssue);
        const highlightIssue = (0, $5uXOq.useCallback)((issueId)=>dispatch({
                type: 'highlight',
                issueId: issueId
            }), []);
        const unhighlightIssue = (0, $5uXOq.useCallback)((issueId)=>setTimeout(()=>{
                dispatch({
                    type: 'unhighlight',
                    issueId: issueId
                });
            }, 2000), []);
        const createIssue = (0, $5uXOq.useCallback)((createParams)=>{
            const job = new $dc15b071bf2d5f6e$var$IssueCreateJob(createParams);
            dispatch({
                type: 'enqueue',
                job: job
            });
            let rank;
            if (createParams.input.rankAfter) rank = (0, (0, parcelRequire("dqDis")).getNextRank)(createParams.input.rankAfter.rank);
            else if (createParams.input.rankBefore) rank = (0, (0, parcelRequire("dqDis")).getPreviousRank)(createParams.input.rankBefore.rank);
            const reporter = {
                accountId: currentUser.accountId,
                avatarUrl: currentUser.avatarUrls['48x48'],
                displayName: currentUser.displayName
            };
            const optimisticIssuePayload = {
                issueId: nextIssueId.current--,
                rank: rank,
                reporter: reporter,
                ...createParams.input
            };
            return {
                optimisticIssuePayload: optimisticIssuePayload,
                promise: job.promise
            };
        }, [
            currentUser
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (jobQueue.length > 0 && !runningJob) {
                const job = jobQueue[0];
                dispatch({
                    type: 'start-job'
                });
                createIssueController({
                    createParams: job.createParams,
                    highlightIssue: highlightIssue,
                    unhighlightIssue: unhighlightIssue,
                    ignoreFiltersContext: ignoreFiltersContext
                }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                        type: 'end-job'
                    }));
            }
        }, [
            createIssueController,
            highlightedIssues,
            jobQueue,
            runningJob,
            highlightIssue,
            unhighlightIssue,
            ignoreFiltersContext
        ]);
        (0, (0, parcelRequire("ecPXN")).useCreateParamHandler)();
        const saveSummary = (0, $5uXOq.useCallback)((newSummary)=>{
            dispatch({
                type: 'save-summary',
                summary: newSummary
            });
        }, []);
        const value = (0, $5uXOq.useMemo)(()=>({
                createIssue: createIssue,
                highlightedIssues: highlightedIssues,
                summary: summary,
                saveSummary: saveSummary
            }), [
            createIssue,
            highlightedIssues,
            summary,
            saveSummary
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dc15b071bf2d5f6e$var$IssueCreateContext.Provider, {
            value: value
        }, children);
    };
    const $dc15b071bf2d5f6e$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
        const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
        const summaryRef = (0, $5uXOq.useRef)(summary);
        const hasExitedWithoutUserAction = (0, $5uXOq.useRef)(true);
        const submit = (0, $5uXOq.useCallback)((createParams)=>{
            const result = createIssue(createParams);
            onSubmit(result);
            hasExitedWithoutUserAction.current = false;
            setTimeout(()=>{
                hasExitedWithoutUserAction.current = true;
            }, 100);
            return result;
        }, [
            createIssue,
            onSubmit
        ]);
        const blur = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) onBlur?.(event);
            else onBlur?.();
            hasExitedWithoutUserAction.current = false;
        }, [
            onBlur
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
            }, [
            saveSummary
        ]);
        return {
            summaryRef: summaryRef,
            submit: submit,
            blur: blur
        };
    };
    const $dc15b071bf2d5f6e$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
    const $dc15b071bf2d5f6e$export$2ecca9d8a7f031af = ()=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
        const { highlightedIssues: highlightedIssues } = context;
        return (0, $5uXOq.useCallback)((issueId)=>$dc15b071bf2d5f6e$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
            highlightedIssues
        ]);
    };
});
parcelRegister("dqDis", function(module, exports) {
    $parcel$export(module.exports, "getNextRank", ()=>$d36f563d8781dd11$export$5c16a8b7eebff4b8);
    $parcel$export(module.exports, "getPreviousRank", ()=>$d36f563d8781dd11$export$e2047b3433d9f565);
    $parcel$export(module.exports, "useHasRankIssuePermission", ()=>$d36f563d8781dd11$export$2fbfa09555819a54);
    var $daQYX;
    const $d36f563d8781dd11$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
    const $d36f563d8781dd11$export$e2047b3433d9f565 = (s)=>{
        const lastCharCode = s.charCodeAt(s.length - 1);
        const previousLastChar = String.fromCharCode(lastCharCode - 1);
        if (lastCharCode === 0) return $d36f563d8781dd11$export$e2047b3433d9f565(s.substring(0, s.length - 1));
        return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
    };
    const $d36f563d8781dd11$export$2fbfa09555819a54 = ()=>{
        const { permissions: permissions } = (0, (0, parcelRequire("daQYX")).useProject)();
        return permissions.scheduleIssues && permissions.editIssues;
    };
});
parcelRegister("daQYX", function(module, exports) {
    $parcel$export(module.exports, "ProjectHookProvider", ()=>$cf7f84dff81db95f$export$f1938a4916a14d9f);
    $parcel$export(module.exports, "useProject", ()=>$cf7f84dff81db95f$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    const $cf7f84dff81db95f$var$Context = (0, $5uXOq.createContext)(null);
    const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
            value: project
        }, children);
    const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
        const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
        if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
        return project;
    };
});
parcelRegister("ja8d8", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$50507bfa414423fc$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $l9KLJ;
    var $jcw0u;
    var $6s1PB;
    var $jJZqs;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kpiI3;
    var $8roPX;
    var $lVeTj;
    var $fb3JB;
    const $50507bfa414423fc$export$8edbb6d449614942 = ()=>{
        const workflows = (0, (0, parcelRequire("l9KLJ")).useWorkflows)();
        return (0, $5uXOq.useCallback)((createInput)=>{
            if (createInput.status && workflows != null) {
                const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
                const { statusId: statusId } = createInput.status;
                const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
                return transition?.transitionId;
            }
        }, [
            workflows
        ]);
    };
    const $50507bfa414423fc$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
        const showCreateSuccessFlag = (0, (0, parcelRequire("lVeTj")).useShowCreateSuccessFlag)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        const getTransitionId = $50507bfa414423fc$export$8edbb6d449614942();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
            const transitionId = getTransitionId(createParams.input);
            try {
                if (!(0, (0, parcelRequire("kpiI3")).hasAllRequiredFields)({
                    issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                    createInput: createParams.input
                })) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Missing required fields');
                const response = await onCreateIssue(createParams, {
                    transitionId: transitionId
                });
                highlightIssue(response.itemIdentifiers.issueId);
                if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                    location: createParams.location
                });
                unhighlightIssue(response.itemIdentifiers.issueId);
                return response.item;
            } catch (error) {
                let finalError = error;
                try {
                    if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
                        const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                            transitionId: transitionId
                        });
                        highlightIssue(issueId);
                        const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                        if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                        unhighlightIssue(issueId);
                        return issue;
                    }
                    if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'JWMCreateIssueInline',
                            packageName: 'jiraBusinessIssueCreate',
                            teamName: 'wanjel'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } catch (refetchError) {
                    finalError = refetchError;
                }
                if (finalError instanceof (0, (0, parcelRequire("8roPX")).CancelledError)) return null;
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fb3JB")).default).errorFlagTitleIssueTermRefresh : (0, (0, parcelRequire("fb3JB")).default).errorFlagTitle),
                    description: formatMessage((0, (0, parcelRequire("fb3JB")).default).errorFlagDescription)
                });
                throw finalError;
            }
        }, [
            getTransitionId,
            typesWithFields,
            onCreateIssue,
            createAnalyticsEvent,
            showCreateSuccessFlag,
            showFlag,
            formatMessage,
            showCreateIssueDialog,
            onRefetchIssue
        ]);
    };
});
parcelRegister("l9KLJ", function(module, exports) {
    $parcel$export(module.exports, "WorkflowsProvider", ()=>$a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75);
    $parcel$export(module.exports, "useWorkflows", ()=>$a3eac8b2a2bf7ce6$export$437f9bd807b88beb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7HGHK;
    var $pa9q9;
    var $6ZYlM;
    var $lDVEA;
    const $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID = (0, (0, parcelRequire("7HGHK")).toFlagId)('fetch-board-error-flag');
    const $a3eac8b2a2bf7ce6$var$WorkflowsContext = (0, $5uXOq.createContext)(undefined);
    const $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { fetch: fetch, data: data, error: error } = (0, (0, parcelRequire("6ZYlM")).useFetchWorkflows)();
        (0, $5uXOq.useEffect)(()=>{
            if (enabled && workflows == null) fetch();
        }, [
            enabled,
            fetch,
            workflows
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) showFlag({
                id: $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID,
                type: 'error',
                title: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorTitle,
                description: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorDescription
            });
        }, [
            error,
            showFlag
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3eac8b2a2bf7ce6$var$WorkflowsContext.Provider, {
            value: workflows ?? data
        }, children);
    };
    const $a3eac8b2a2bf7ce6$export$437f9bd807b88beb = ()=>(0, $5uXOq.useContext)($a3eac8b2a2bf7ce6$var$WorkflowsContext);
});
parcelRegister("6ZYlM", function(module, exports) {
    $parcel$export(module.exports, "useFetchWorkflows", ()=>$8896012bd25091f7$export$41ba56ef14d1b9b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $jcw0u;
    var $6V9lc;
    const $8896012bd25091f7$export$41ba56ef14d1b9b1 = ()=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const [fetch, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("6V9lc")).WORKFLOWS_QUERY), {
            variables: {
                projectId: project.id,
                first: 100
            },
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmFetchWorkflows',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch workflows'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const workflowsDetails = (0, $5uXOq.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
                const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
                return {
                    workflowId: workflow.workflowId,
                    name: workflow?.name ?? undefined,
                    transitions: workflow.transitions.edges.map((transitionEdge)=>({
                            transitionId: transitionEdge.node.transitionId,
                            name: transitionEdge.node.name ?? undefined,
                            isInitial: transitionEdge.node.isInitial,
                            isGlobal: transitionEdge.node.isGlobal,
                            isConditional: transitionEdge.node.isConditional,
                            to: {
                                statusId: transitionEdge.node.to.statusId
                            }
                        })),
                    issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                            issueTypeId: issueTypeEdge.node.issueTypeId,
                            name: issueTypeEdge.node.name,
                            avatarUrl: issueTypeEdge.node.avatar.medium,
                            hierarchyLevel: issueTypeEdge.node.hierarchy.level
                        }))
                };
            }), [
            data
        ]);
        return {
            fetch: fetch,
            data: workflowsDetails,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("6V9lc", function(module, exports) {
    $parcel$export(module.exports, "WORKFLOWS_QUERY", ()=>$ece8b64659728495$export$d54deb6c2b9695b7);
    var $5cllN;
    const $ece8b64659728495$export$d54deb6c2b9695b7 = (0, (0, parcelRequire("5cllN")).default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;
});
parcelRegister("lDVEA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3db26a0042253e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a3db26a0042253e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        workflowsErrorTitle: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-title",
            "defaultMessage": "Failed to load workflows details"
        },
        workflowsErrorDescription: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-description",
            "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
        }
    });
});
parcelRegister("kpiI3", function(module, exports) {
    $parcel$export(module.exports, "hasAllRequiredFields", ()=>$5d73fa9073989726$export$146976a1cbd99cd0);
    var $hE5wF;
    var $5fc53;
    const $5d73fa9073989726$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
        if (!issueType) return false;
        return issueType.fields.every((field)=>{
            if (!field.fieldConfig?.isRequired) return true;
            if (!field.type && !field.aliasFieldId) return false;
            if (field.aliasFieldId && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
            if (field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
            if (field.type) switch(field.type){
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return true;
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return Boolean(createInput.summary);
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return Boolean(createInput.priority);
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                    return Boolean(createInput.assignee);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return Boolean(createInput.dueDate);
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return Boolean(createInput.category);
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return createInput.storyPointEstimate != null;
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    return Boolean(createInput.sprint);
                default:
                    break;
            }
            return false;
        });
    };
});
parcelRegister("8roPX", function(module, exports) {
    $parcel$export(module.exports, "CancelledError", ()=>$549ab3c244a8a20a$export$a8430ed4188f35a9);
    $parcel$export(module.exports, "useCreateIssueDialog", ()=>$549ab3c244a8a20a$export$8254d39962ec7361);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $5eGnF;
    var $9svjh;
    var $hULKg;
    var $5rzqz;
    var $dAmbh;
    var $3ZKGh;
    class $549ab3c244a8a20a$export$a8430ed4188f35a9 extends Error {
    }
    const $549ab3c244a8a20a$export$8d1d8a0d2a7917ac = ()=>{
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        return (0, $5uXOq.useCallback)((issueType, predicate)=>{
            if (!issueType) return undefined;
            const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
            return issueTypeWithFields?.fields.find(predicate);
        }, [
            typesWithFields
        ]);
    };
    const $549ab3c244a8a20a$export$8254d39962ec7361 = ()=>{
        const [, { openIssueCreateModal: openIssueCreateModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const getField = $549ab3c244a8a20a$export$8d1d8a0d2a7917ac();
        const { data: rankField } = (0, (0, parcelRequire("dAmbh")).useRankField)();
        return (0, $5uXOq.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
                const unsubscribe = subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                    onClose(null);
                });
                const onClose = (data)=>{
                    const result = data?.[0];
                    if (result) resolve(result);
                    else setTimeout(()=>{
                        reject(new $549ab3c244a8a20a$export$a8430ed4188f35a9('User cancelled'));
                    }, 100);
                    unsubscribe();
                };
                const { payload: payload, submitApiData: submitApiData } = (0, (0, parcelRequire("3ZKGh")).buildGICPayload)({
                    createInput: createInput,
                    extraPayload: extraPayload,
                    rankField: rankField,
                    getField: getField
                });
                const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
                openIssueCreateModal({
                    id: 'jwm-create-issue-dialog',
                    onClose: onClose,
                    payload: payload,
                    context: {
                        projectId: createInput.projectId,
                        submitApiData: submitApiData
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: (0, (0, parcelRequire("hULKg")).JWM_INLINE_CREATE),
                    disableProjectDropdown: true,
                    disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                    disableCreationSuccessFlag: true,
                    displayCreateAnotherIssueToggle: false,
                    minimizableModalView: 'mini'
                });
            }), [
            getField,
            openIssueCreateModal,
            rankField,
            subscribe
        ]);
    };
});
parcelRegister("5eGnF", function(module, exports) {
    $parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", ()=>$700db8c378cd19d9$export$876003a5b887f37e);
    const $700db8c378cd19d9$export$876003a5b887f37e = {
        MODAL_OPENED: 'MODAL_OPENED',
        MODAL_CLOSED: 'MODAL_CLOSED',
        MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
        MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
        MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
        MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
        MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
        CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
        CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
        ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
        PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
        ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
        RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
        USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
        STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
        CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
        CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
        FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
    };
});
parcelRegister("9svjh", function(module, exports) {
    $parcel$export(module.exports, "useGICLifeCycleEvents", ()=>$d9b2e43e4699b192$export$e3ff72f196296fcc);
    var $1mrD8;
    const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, (0, parcelRequire("1mrD8")).PubSubHub)();
    const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
            ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
        });
});
parcelRegister("1mrD8", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
    class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("hULKg", function(module, exports) {
    $parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", ()=>$62659eb193cd5c9c$export$a05673a22505d5ee);
    $parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$c78d329777576aa0);
    $parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$992ab052fd10f8e8);
    $parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", ()=>$62659eb193cd5c9c$export$affdc3af7a9a4677);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", ()=>$62659eb193cd5c9c$export$7e9cfd1f59e60910);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", ()=>$62659eb193cd5c9c$export$708499dcd016e5e9);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", ()=>$62659eb193cd5c9c$export$e1c8789144c4c810);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", ()=>$62659eb193cd5c9c$export$c5afabb7a17e802);
    $parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$2086a63173b79b56);
    $parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$fe1e5e4597147709);
    $parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$9bc326812a93707);
    $parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", ()=>$62659eb193cd5c9c$export$f352934e06f44599);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", ()=>$62659eb193cd5c9c$export$6ae07c77acc64360);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", ()=>$62659eb193cd5c9c$export$b41d0684e4b6ab1);
    $parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", ()=>$62659eb193cd5c9c$export$be9b2b1329ff7ec9);
    $parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", ()=>$62659eb193cd5c9c$export$aa348159181703a0);
    $parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$f90eec3841adf619);
    $parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$718822a309bffada);
    $parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", ()=>$62659eb193cd5c9c$export$2753dafac81e805c);
    $parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", ()=>$62659eb193cd5c9c$export$7c4d5cc5711d9294);
    $parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", ()=>$62659eb193cd5c9c$export$998dfc72404b9e14);
    $parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", ()=>$62659eb193cd5c9c$export$fc180a4b5785d2f4);
    $parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", ()=>$62659eb193cd5c9c$export$946ec0b21cb84fd0);
    $parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", ()=>$62659eb193cd5c9c$export$5b97e2844e620e54);
    $parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", ()=>$62659eb193cd5c9c$export$b99842c2cf46f6be);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", ()=>$62659eb193cd5c9c$export$8d987f6e80b74000);
    $parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$8de9fa43731c4b5b);
    $parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", ()=>$62659eb193cd5c9c$export$87249ccbfd10fb78);
    $parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", ()=>$62659eb193cd5c9c$export$c0eeeb31d264de76);
    $parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", ()=>$62659eb193cd5c9c$export$f546e18e46478c84);
    $parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", ()=>$62659eb193cd5c9c$export$1784e634ba79f1f9);
    $parcel$export(module.exports, "JWM_INLINE_CREATE", ()=>$62659eb193cd5c9c$export$145eb8935a34e85e);
    $parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", ()=>$62659eb193cd5c9c$export$32648b574a536c8b);
    $parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", ()=>$62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
    const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
    const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
    const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
    const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
    const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
    const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
    const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
    const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
    const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
    const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
    const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
    const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
    const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
    const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
    const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
    const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
    const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
    const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
    const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
    const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
    const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
    const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
    const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
    const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
    const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
    const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
    const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
    const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
    const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
    const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
    const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
    const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
    const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
    const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
    const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
    const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
    const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
    const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
    const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
    const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
    const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
    const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
    const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
    const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
    const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
    const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
        FIELD_IDS: [
            'description'
        ],
        TRIGGER_POINTS: [
            'service-desk-gen-ai-pir'
        ]
    };
});
parcelRegister("5rzqz", function(module, exports) {
    $parcel$export(module.exports, "useTriggerIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
    $parcel$export(module.exports, "useOpenIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$47cf258b1046080b);
    $parcel$export(module.exports, "withNewGICProvider", ()=>$0a31d64d52b4b5e9$export$558a195c5bfe3787);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $co1wz;
    var $4R6GH;
    var $1Nspv;
    var $bGrWH;
    var $8zOmE;
    var $2NMNM;
    var $f5nIZ;
    var $2YP9W;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hULKg;
    var $cKWWX;
    var $6k7U1;
    const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
        inProgressIssueID: undefined,
        isModalOpen: false,
        isSubsequentLoad: false,
        isSubTaskCreationOpen: false,
        isCreateLinkedIssue: false,
        wasStateRestored: false,
        payload: null,
        id: 'create-issue-dialog',
        title: null,
        sectionMessage: null,
        submitErrorMessage: undefined,
        globalEventNamespaces: [
            (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
        ],
        fieldsToAddInPublishedData: [],
        alertsToBeLinked: undefined,
        onIssueCreate: null,
        onClose: null,
        displayOnlyRequiredFields: false,
        disableCreationSuccessFlag: false,
        displayCreateAnotherIssueToggle: true,
        displaySitePicker: false,
        disableProjectDropdown: false,
        disableIssueTypeDropdown: false,
        triggerPointKey: (0, (0, parcelRequire("hULKg")).TRIGGER_POINT_KEY_NOT_DEFINED),
        context: undefined,
        minimizableModalView: 'modal',
        persistentModalView: undefined,
        shouldPushMiniModalDiscoverability: undefined,
        shouldShowMiniModalSpotlight: undefined,
        wasModalRetriggered: false,
        openIssueCreateModalNextState: {},
        shouldInitFetchConfig: false,
        interactedWithModalChangerButtons: false,
        isModalLoadInContext: false,
        disableMinimizableModal: false,
        displayMinimizableButtons: true,
        displayHeaderActionContainer: true,
        overrideUseRequestTypeFieldsToggleState: undefined,
        containerStyle: {},
        isMiniDesignEnabled: false,
        isEnrolledAndTargetedForGicMultipleLayouts: false,
        sessionId: undefined,
        FieldWrapperComponent: undefined,
        ExternalControls: undefined,
        isCustomBoardWithIcc: false,
        jqlSwimlaneId: undefined,
        swimlaneMode: undefined,
        prefilledCustomFields: {},
        ecosystemCallback: undefined,
        product: undefined,
        actionSource: undefined
    };
    const $0a31d64d52b4b5e9$export$e324594224ef24da = {
        restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
                const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
                if (!isModalOpen && stateToRestore.isModalOpen) (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(isSubsequentLoad);
                setState(stateToRestore);
            },
        openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isModalOpen) setState({
                    wasModalRetriggered: true,
                    openIssueCreateModalNextState: nextState
                });
                else {
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                    const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                    const nextModalView = isDiscoverabilityPushEnabled ? (0, (0, parcelRequire("6k7U1")).getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, (0, parcelRequire("6k7U1")).discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        ...nextState
                    });
                }
            },
        closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
                const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
                const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    callbackPayload: undefined,
                    ...shouldPersistDiscoverabilityState && {
                        shouldPushMiniModalDiscoverability: true
                    },
                    ...isDiscoverabilityPushEnabled && {
                        persistentModalView: currentState.persistentModalView
                    },
                    ...shouldUpdatePersistentModalView && {
                        persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                    },
                    isModalOpen: false,
                    isSubsequentLoad: true
                });
                (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).abort({
                    metadata: {
                        wasStateRestored: getState().wasStateRestored
                    }
                });
            },
        clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    sectionMessage: null
                });
            },
        setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    displayOnlyRequiredFields: nextState
                });
            },
        setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
                setState({
                    minimizableModalView: minimizableModalView,
                    interactedWithModalChangerButtons: true
                });
            },
        resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
                if (applyNextState) {
                    const currentState = getState();
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                            persistentModalView: currentState.persistentModalView
                        },
                        inProgressIssueID: currentState.inProgressIssueID,
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: false,
                        minimizableModalView: 'modal',
                        openIssueCreateModalNextState: {},
                        shouldInitFetchConfig: true,
                        ...currentState.openIssueCreateModalNextState
                    });
                } else setState({
                    minimizableModalView: 'modal',
                    wasModalRetriggered: false,
                    openIssueCreateModalNextState: {}
                });
            },
        resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
                setState({
                    shouldInitFetchConfig: false
                });
            },
        setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    callbackPayload: {
                        id: currentState.callbackPayload?.id ?? '',
                        data: callbackPayload
                    }
                });
            },
        setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
                });
            },
        dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldShowMiniModalSpotlight: false
                });
            },
        setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    persistentModalView: persistentModalView
                });
            },
        removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('linked-alerts-in-gic_onvr6')) return;
                const currentState = getState();
                const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
                setState({
                    alertsToBeLinked: alertsToBeLinked
                });
            },
        setSessionId: (sessionId)=>({ setState: setState })=>{
                setState({
                    sessionId: sessionId
                });
            }
    };
    const $0a31d64d52b4b5e9$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
        initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
        actions: $0a31d64d52b4b5e9$export$e324594224ef24da
    });
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
        const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
        const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
        const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal
        ]);
        return [
            createState,
            {
                ...otherActions,
                openIssueCreateModal: openIssueCreateModalWithAnalytics
            }
        ];
    };
    const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
        const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        return (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            if (nextState?.payload?.overrideCloudId && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) setSitePickerState({
                selectedCloudId: nextState?.payload?.overrideCloudId
            });
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal,
            setSitePickerState
        ]);
    };
    const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, (0, parcelRequire("51nlc")).createSubscriber)($0a31d64d52b4b5e9$var$store);
    function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
        return (props)=>{
            const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
            const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
            const currentIssueCreateVisibility = data && data?.gicOptInStatus;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                openIssueCreateModal: openIssueCreateModal,
                closeIssueCreateModal: closeIssueCreateModal,
                currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
                ...props
            });
        };
    }
});
parcelRegister("1Nspv", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueUFOExperience", ()=>$ff7fb599b8d98642$export$cd75c112ac11a83b);
    $parcel$export(module.exports, "StatusFieldLoad", ()=>$ff7fb599b8d98642$export$e890e797a25e655c);
    $parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", ()=>$ff7fb599b8d98642$export$70208657c8d471a7);
    $parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", ()=>$ff7fb599b8d98642$export$b2d8f8edec75f571);
    var $atdLB;
    var $duUGa;
    const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'global-issue-create.create-issue'
    });
    const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue.status-field', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('modern-global-issue-create.modal.issue-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'modern-global-issue-create.modal.issue-submit'
    });
    const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('ecosystem-api-new-gic-prefilling', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'ecosystem-api-new-gic-prefilling'
    });
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
parcelRegister("cKWWX", function(module, exports) {
    $parcel$export(module.exports, "useSitePickerContext", ()=>$c8055d212e869a3c$export$f8b5aae013e4cf77);
    var $3sQ5x;
    var $iXqE5;
    const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
        selectedCloudId: '',
        siteDomain: ''
    };
    const $c8055d212e869a3c$export$e324594224ef24da = {
        setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    selectedCloudId: selectedCloudId || '',
                    siteDomain: siteDomain || ''
                });
            }
    };
    const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue.fields.site-picker',
        initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
        actions: $c8055d212e869a3c$export$e324594224ef24da
    });
    const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, (0, parcelRequire("3sQ5x")).createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);
});
parcelRegister("6k7U1", function(module, exports) {
    $parcel$export(module.exports, "startGlobalIssueCreateMetrics", ()=>$8a2e4df39a48d5af$export$550b19803bc962ec);
    $parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", ()=>$8a2e4df39a48d5af$export$f6bc17a4d9120156);
    $parcel$export(module.exports, "discoverabilityPushModalViewOverride", ()=>$8a2e4df39a48d5af$export$8d246e5e04f0b424);
    $parcel$export(module.exports, "getNextModalView", ()=>$8a2e4df39a48d5af$export$720579602bb055a2);
    var $eTXmK;
    var $1Nspv;
    var $gEaAu;
    var $huY3x;
    const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).start();
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal');
        globalIssueCreateModalLoadMetric.start();
        (0, (0, parcelRequire("huY3x")).startGlobalIssueCreateTTIWithAdjustments)();
    };
    const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
        if (!triggerPoint) return false;
        const acceptedTriggerPoints = [
            'global-create-button',
            'keyboard-shortcut'
        ];
        return acceptedTriggerPoints.includes(triggerPoint);
    };
    const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
        if (!shouldPushDiscoverability) return undefined;
        return {
            minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
            shouldPushMiniModalDiscoverability: true,
            shouldShowMiniModalSpotlight: isTriggerAccepted
        };
    };
    const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
        if (isTriggerAccepted) return persistentView || defaultView;
        return defaultView;
    };
});
parcelRegister("gEaAu", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateModalLoad", ()=>$ee246606338fc99e$export$5a01a7fa84b239c8);
    $parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", ()=>$ee246606338fc99e$export$c50ad3c31b6fcfc6);
    $parcel$export(module.exports, "successFlagDisplay", ()=>$ee246606338fc99e$export$4b2382574525bb0f);
    $parcel$export(module.exports, "successFlagAddToSprintAction", ()=>$ee246606338fc99e$export$7839bdaa2f6a2385);
    $parcel$export(module.exports, "successFlagClearFiltersAction", ()=>$ee246606338fc99e$export$c1592e4d8d98963e);
    var $dGrdR;
    const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal'
    });
    const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal-subsequent'
    });
    const $ee246606338fc99e$export$4b2382574525bb0f = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-display'
    });
    const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
    });
    const $ee246606338fc99e$export$c1592e4d8d98963e = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
    });
});
parcelRegister("huY3x", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874);
    $parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$457c9fb71ad5b3a9);
    $parcel$export(module.exports, "markGicTti", ()=>$06c7e44c59602f0c$export$ef664dac649a716c);
    $parcel$export(module.exports, "stopTTI", ()=>$06c7e44c59602f0c$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$06c7e44c59602f0c$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$06c7e44c59602f0c$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$06c7e44c59602f0c$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$06c7e44c59602f0c$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-tti-with-adjustments',
        timings: [
            {
                key: 'gic-tti-delta',
                startMark: 'gic-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            },
            {
                key: 'gic-all-fields-tti',
                endMark: 'gic-all-fields-loaded'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
    };
    const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
    const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
            customData: customData
        });
    };
    const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
    };
    const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
    };
    const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
    };
    const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("3ZKGh", function(module, exports) {
    $parcel$export(module.exports, "buildGICPayload", ()=>$1e0041a78523c89b$export$eb18ffe6388f217a);
    var $f9ece;
    var $hE5wF;
    var $5fc53;
    const $1e0041a78523c89b$var$assigneeFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE);
    const $1e0041a78523c89b$var$categoryFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE);
    const $1e0041a78523c89b$var$dueDateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE);
    const $1e0041a78523c89b$var$priorityFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE);
    const $1e0041a78523c89b$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE);
    const $1e0041a78523c89b$var$storyPointsFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE) && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$sprintFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
    const $1e0041a78523c89b$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
        const payload = {
            defaultValues: {
                singleLineTextFields: [],
                singleSelectUserPickerFields: [],
                numberFields: [],
                datePickerFields: []
            },
            project: {
                projectId: createInput.projectId
            }
        };
        const additionalFields = {};
        let transition;
        if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
            fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            text: createInput.summary
        });
        if (createInput.issueType) payload.issueType = {
            issueTypeId: createInput.issueType.id
        };
        if (createInput.dueDate && getField(createInput.issueType, $1e0041a78523c89b$var$dueDateFieldPredicate)) {
            const formattedDueDate = (0, (0, parcelRequire("f9ece")).default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                date: {
                    formattedDate: formattedDueDate
                }
            });
            additionalFields.duedate = formattedDueDate;
        }
        const startDateField = getField(createInput.issueType, $1e0041a78523c89b$var$startDateFieldPredicate);
        if (createInput.startDate && startDateField) {
            const formattedStartDate = (0, (0, parcelRequire("f9ece")).default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: startDateField.id,
                date: {
                    formattedDate: formattedStartDate
                }
            });
            additionalFields[startDateField.id] = formattedStartDate;
        }
        if (createInput.assignee && getField(createInput.issueType, $1e0041a78523c89b$var$assigneeFieldPredicate)) {
            payload.defaultValues.singleSelectUserPickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                user: {
                    accountId: createInput.assignee.accountId
                }
            });
            additionalFields[0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE] = {
                id: createInput.assignee.accountId
            };
        }
        if (createInput.priority && getField(createInput.issueType, $1e0041a78523c89b$var$priorityFieldPredicate)) {
            payload.defaultValues.priority = {
                priorityId: createInput.priority.priorityId
            };
            additionalFields[0, (0, parcelRequire("5fc53")).PRIORITY_TYPE] = {
                id: createInput.priority.priorityId
            };
        }
        const categoryField = getField(createInput.issueType, $1e0041a78523c89b$var$categoryFieldPredicate);
        if (createInput.category && categoryField) {
            payload.defaultValues.singleSelectFields = [
                {
                    fieldId: categoryField.id,
                    option: {
                        id: createInput.category.optionId,
                        optionId: createInput.category.optionId
                    }
                }
            ];
            additionalFields[categoryField.id] = {
                id: createInput.category.optionId,
                value: createInput.category.value
            };
        }
        const storyPointEstimateField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointEstimateFieldPredicate);
        if (createInput.storyPointEstimate && storyPointEstimateField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            });
            additionalFields[storyPointEstimateField.id] = {
                id: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            };
        }
        const storyPointsField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointsFieldPredicate);
        if (createInput.storyPoints && storyPointsField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointsField.id,
                value: createInput.storyPoints
            });
            additionalFields[storyPointsField.id] = {
                id: storyPointsField.id,
                value: createInput.storyPoints
            };
        }
        const sprintField = getField(createInput.issueType, $1e0041a78523c89b$var$sprintFieldPredicate);
        if (createInput.sprint && sprintField) {
            payload.defaultValues.sprintsField = {
                fieldId: sprintField.id,
                sprints: [
                    {
                        sprintId: createInput.sprint.id
                    }
                ]
            };
            additionalFields[sprintField.id] = {
                id: sprintField.id,
                value: createInput.sprint.id
            };
        }
        if (createInput.parentIssueId) {
            payload.parentId = {
                parentId: createInput.parentIssueId
            };
            payload.defaultValues.parentField = {
                issueId: createInput.parentIssueId
            };
        }
        if (createInput.status && extraPayload?.transitionId) {
            payload.status = {
                statusId: createInput.status.statusId
            };
            transition = {
                id: extraPayload.transitionId
            };
        }
        if (rankField && (createInput.rankAfter || createInput.rankBefore)) additionalFields[rankField.id] = {
            ...createInput.rankAfter ? {
                rankAfterIssue: createInput.rankAfter.issueId
            } : {},
            ...createInput.rankBefore ? {
                rankBeforeIssue: createInput.rankBefore.issueId
            } : {}
        };
        return {
            payload: payload,
            submitApiData: {
                additionalFields: additionalFields,
                transition: transition
            }
        };
    };
});
parcelRegister("lVeTj", function(module, exports) {
    $parcel$export(module.exports, "useShowCreateSuccessFlag", ()=>$374f26855338ec61$export$dfe953d11a91d407);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $l0oHX;
    var $6s1PB;
    var $pa9q9;
    var $koVbs;
    var $ieDtd;
    var $7dMty;
    const $374f26855338ec61$export$dfe953d11a91d407 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        return (0, $5uXOq.useCallback)((issueKey)=>{
            const flagId = `jwm-create-success-flag-${issueKey}`;
            showFlag({
                id: flagId,
                isAutoDismiss: true,
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitle, {
                    issueKey: issueKey
                }),
                actions: [
                    {
                        content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).viewIssueLinkTextIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).viewIssueLinkText,
                        href: `/browse/${issueKey}`,
                        onClick: (event)=>{
                            if (event && !(0, (0, parcelRequire("l0oHX")).isModifiedEvent)(event)) {
                                setSelectedIssueKey(issueKey);
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            dismissFlag(flagId);
                        }
                    }
                ]
            });
        }, [
            dismissFlag,
            formatMessage,
            setSelectedIssueKey,
            showFlag
        ]);
    };
});
parcelRegister("l0oHX", function(module, exports) {
    $parcel$export(module.exports, "isModifiedEvent", ()=>$6c9cca471f547e7f$export$642c6f14f6d4bbd5);
    const $6c9cca471f547e7f$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
});
parcelRegister("7dMty", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ecb7a23bce33f96$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ecb7a23bce33f96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createSuccessFlagTitle: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
            "defaultMessage": "You've created issue \"{issueKey}\""
        },
        viewIssueLinkText: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
            "defaultMessage": "View issue"
        },
        createSuccessFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
            "defaultMessage": "You've created issue \"{issueKey}\""
        },
        viewIssueLinkTextIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
            "defaultMessage": "View work item "
        }
    });
});
parcelRegister("fb3JB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87c4612732d8fc8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87c4612732d8fc8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title",
            "defaultMessage": "We weren't able to create an issue"
        },
        errorFlagDescription: {
            "id": "business-issue-create.controllers.create-issue.error-flag-description",
            "defaultMessage": "Refresh the page and try again."
        },
        errorFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
            "defaultMessage": "We weren't able to create a work item"
        }
    });
});
parcelRegister("ecPXN", function(module, exports) {
    $parcel$export(module.exports, "useCreateParamHandler", ()=>$eb6f03408afb5aea$export$294bf5b0ba86140);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $daQYX;
    var $ieDtd;
    var $8roPX;
    const $eb6f03408afb5aea$export$294bf5b0ba86140 = ()=>{
        const [inlineCreateParam, setInlineCreateParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).INLINE_CREATE_PARAM));
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        (0, $5uXOq.useEffect)(()=>{
            if (inlineCreateParam != null) {
                showCreateIssueDialog({
                    projectId: String(project.id)
                }).catch(()=>{});
                setInlineCreateParam(undefined);
            }
        }, [
            inlineCreateParam,
            project,
            setInlineCreateParam,
            showCreateIssueDialog
        ]);
    };
});
parcelRegister("asqbQ", function(module, exports) {
    $parcel$export(module.exports, "IssueEventProvider", ()=>$6c794cc1228cf4a9$export$76fd0c61a5fdd54a);
    $parcel$export(module.exports, "useIssueEvents", ()=>$6c794cc1228cf4a9$export$bb1f0162b528beb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $9DpYo;
    const $6c794cc1228cf4a9$var$DEBOUNCE_DELAY = 100;
    const $6c794cc1228cf4a9$var$IssueEventContext = (0, $5uXOq.createContext)(null);
    const $6c794cc1228cf4a9$export$76fd0c61a5fdd54a = ({ children: children })=>{
        const [subscribers, setSubscribers] = (0, $5uXOq.useState)([]);
        const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            setSubscribers((prevSubscribers)=>[
                    ...prevSubscribers,
                    subscriber
                ]);
        }, []);
        const unsubscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            setSubscribers((prevSubscribers)=>prevSubscribers.filter((s)=>s !== subscriber));
        }, []);
        const notify = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9DpYo")).debounce)((ids)=>{
                subscribers.forEach((subscriber)=>subscriber(ids));
            }, $6c794cc1228cf4a9$var$DEBOUNCE_DELAY), [
            subscribers
        ]);
        const value = (0, $5uXOq.useMemo)(()=>({
                subscribe: subscribe,
                unsubscribe: unsubscribe,
                notify: notify
            }), [
            subscribe,
            unsubscribe,
            notify
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6c794cc1228cf4a9$var$IssueEventContext.Provider, {
            value: value
        }, children);
    };
    const $6c794cc1228cf4a9$export$bb1f0162b528beb8 = (onChange)=>{
        const { subscribe: subscribe, unsubscribe: unsubscribe, notify: notify } = (0, $5uXOq.useContext)($6c794cc1228cf4a9$var$IssueEventContext) ?? {};
        (0, $5uXOq.useEffect)(()=>{
            if (!onChange || !subscribe || !unsubscribe) return undefined;
            subscribe(onChange);
            return ()=>unsubscribe(onChange);
        }, [
            subscribe,
            unsubscribe,
            onChange
        ]);
        return notify;
    };
});
parcelRegister("9DpYo", function(module, exports) {
    $parcel$export(module.exports, "debounce", ()=>$93df584b99390635$export$61fc7d43ac8f84b0);
    const $93df584b99390635$export$61fc7d43ac8f84b0 = (fn, delay)=>{
        let timeoutId = null;
        let issueIds = new Set();
        return (issueId)=>{
            issueIds.add(issueId);
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                fn(Array.from(issueIds));
                issueIds = new Set();
            }, delay);
        };
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("f42Sq", function(module, exports) {
    $parcel$export(module.exports, "MAIN_EXPERIENCE", ()=>$c90f6986efab6f85$export$b3d8a68bfc68a411);
    $parcel$export(module.exports, "SCHEDULE_ITEM_EXPERIENCE", ()=>$c90f6986efab6f85$export$1f9cf4c341d296a1);
    $parcel$export(module.exports, "VIEW_UNSCHEDULED_SIDEBAR_EXPERIENCE", ()=>$c90f6986efab6f85$export$b4735f492051df1f);
    $parcel$export(module.exports, "FETCH_CONNECTED_JSW_PROJECTS_EXPERIENCE", ()=>$c90f6986efab6f85$export$f6c203eb9352b9ba);
    $parcel$export(module.exports, "CONNECT_JSW_PROJECT_EXPERIENCE", ()=>$c90f6986efab6f85$export$ac6ccaeabf1bf233);
    $parcel$export(module.exports, "DISCONNECT_JSW_PROJECT_EXPERIENCE", ()=>$c90f6986efab6f85$export$4af88d2c93d5ef03);
    $parcel$export(module.exports, "CLEAR_JSW_PROJECTS_EXPERIENCE", ()=>$c90f6986efab6f85$export$c4ee06baef14c3af);
    $parcel$export(module.exports, "RELEASES_IN_CALENDAR_SUPPORT_ARTICLE", ()=>$c90f6986efab6f85$export$853642e3b91fd958);
    $parcel$export(module.exports, "DRAGGING_UNSCHEDULED_ITEM_CLASS_NAME", ()=>$c90f6986efab6f85$export$9f15204fd3ff01d9);
    const $c90f6986efab6f85$export$b8b9d90f9e5bd72b = 'jiraBusinessCalendar';
    const $c90f6986efab6f85$export$b3d8a68bfc68a411 = {
        experience: 'calendarView',
        experienceId: 'main',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$64df40754332fb45 = {
        experience: 'inlineCreate',
        experienceId: 'calendar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$1f9cf4c341d296a1 = {
        experience: 'scheduleItem',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$b4735f492051df1f = {
        experience: 'viewUnscheduledSidebar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$248f5da802892ed2 = {
        experience: 'ViewReleaseInCalendar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$f6c203eb9352b9ba = {
        experience: 'fetchConnectedJswProjects',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-werewolves'
    };
    const $c90f6986efab6f85$export$ac6ccaeabf1bf233 = {
        experience: 'connectJswProjectInCalendar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$4af88d2c93d5ef03 = {
        experience: 'disconnectJswProjectInCalendar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$c4ee06baef14c3af = {
        experience: 'clearJswProjectsInCalendar',
        packageName: $c90f6986efab6f85$export$b8b9d90f9e5bd72b,
        teamName: 'jira-yurree'
    };
    const $c90f6986efab6f85$export$bb56abdaae974866 = 'ISSUE';
    const $c90f6986efab6f85$export$853642e3b91fd958 = 'https://support.atlassian.com/jira-work-management/docs/surface-software-team-releases-in-business-team-calendars/';
    const $c90f6986efab6f85$export$9f15204fd3ff01d9 = 'fc-dragging-unscheduled-item';
});
parcelRegister("3RCti", function(module, exports) {
    $parcel$export(module.exports, "ConnectedProjectsProvider", ()=>$0aaed1b7ad88a5a6$export$85dfd368e1d4d815);
    $parcel$export(module.exports, "useGetConnectedProjects", ()=>$0aaed1b7ad88a5a6$export$779279e5e675f866);
    $parcel$export(module.exports, "useChangeConnectedProjects", ()=>$0aaed1b7ad88a5a6$export$ce7c3edc10cad343);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ljMDN;
    var $cm8b5;
    var $2otlL;
    var $lUlJ6;
    var $koeKL;
    var $f42Sq;
    var $3uyqp;
    var $atA8L;
    var $di0v2;
    const $0aaed1b7ad88a5a6$export$dd03c980210fccd2 = (0, $5uXOq.createContext)(null);
    const $0aaed1b7ad88a5a6$var$useConnectedProjectsContext = ()=>{
        const context = (0, $5uXOq.useContext)($0aaed1b7ad88a5a6$export$dd03c980210fccd2);
        if (!context) throw new Error('useConnectedProjects must be used inside a ConnectedProjectsProvider');
        return context;
    };
    const $0aaed1b7ad88a5a6$export$85dfd368e1d4d815 = ({ children: children })=>{
        const [state, setState] = (0, $5uXOq.useState)({
            connectedProjects: undefined,
            loading: true,
            error: null
        });
        const value = (0, $5uXOq.useMemo)(()=>({
                ...state,
                setContext: setState
            }), [
            state
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0aaed1b7ad88a5a6$export$dd03c980210fccd2.Provider, {
            value: value
        }, children);
    };
    const $0aaed1b7ad88a5a6$export$779279e5e675f866 = (projectId)=>{
        const { connectedProjects: connectedProjects, error: error, loading: loading, setContext: setContext } = $0aaed1b7ad88a5a6$var$useConnectedProjectsContext();
        const { fetchConnectedProjects: fetchConnectedProjects, loading: loadingGql, error: errorGql } = (0, (0, parcelRequire("lUlJ6")).useFetchConnectedProjects)();
        const { shouldFetchFromRestWithoutMigration: shouldFetchFromRestWithoutMigration, migrateConnectedProjectPropertyIfNecessary: migrateConnectedProjectPropertyIfNecessary, fetchConnectedProjectFromRest: fetchConnectedProjectFromRest } = (0, (0, parcelRequire("atA8L")).useConnectedProjectMigrationToAgs)(projectId);
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("f42Sq")).FETCH_CONNECTED_JSW_PROJECTS_EXPERIENCE));
        const onExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("f42Sq")).FETCH_CONNECTED_JSW_PROJECTS_EXPERIENCE));
        const onExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("f42Sq")).FETCH_CONNECTED_JSW_PROJECTS_EXPERIENCE));
        (0, $5uXOq.useEffect)(()=>{
            if (connectedProjects !== undefined) return;
            (async ()=>{
                let connectedProjectsAgs = [];
                const setContextOnFailure = (err)=>setContext({
                        connectedProjects: [],
                        loading: false,
                        error: err
                    });
                let shouldFetchConnectedProjectsFromRest = false;
                try {
                    shouldFetchConnectedProjectsFromRest = await shouldFetchFromRestWithoutMigration();
                } catch (err) {
                    setContextOnFailure(err);
                    onExperienceFail('Failed to check if connected project property is migrated', err);
                    return;
                }
                if (shouldFetchConnectedProjectsFromRest) {
                    let connectedProjectsRest;
                    startExperience();
                    try {
                        connectedProjectsRest = await fetchConnectedProjectFromRest();
                    } catch (err) {
                        setContextOnFailure(err);
                        onExperienceFail('Failed to fetch connected project from REST', err);
                        return;
                    }
                    onExperienceSuccess();
                    setContext({
                        connectedProjects: connectedProjectsRest ? [
                            connectedProjectsRest
                        ] : [],
                        loading: false,
                        error: null
                    });
                    return;
                }
                startExperience();
                try {
                    connectedProjectsAgs = await fetchConnectedProjects(projectId);
                } catch (err) {
                    setContextOnFailure(err);
                    onExperienceFail('Failed to fetch connected projects from AGS', err);
                    return;
                }
                onExperienceSuccess();
                let migratedProject;
                try {
                    migratedProject = await migrateConnectedProjectPropertyIfNecessary();
                } catch (err) {
                    setContextOnFailure(err);
                    return;
                }
                setContext({
                    connectedProjects: migratedProject ? [
                        migratedProject
                    ] : connectedProjectsAgs,
                    loading: false,
                    error: null
                });
            })();
        }, [
            connectedProjects,
            fetchConnectedProjects,
            onExperienceFail,
            onExperienceSuccess,
            projectId,
            setContext,
            migrateConnectedProjectPropertyIfNecessary,
            startExperience,
            shouldFetchFromRestWithoutMigration,
            fetchConnectedProjectFromRest
        ]);
        return {
            connectedProjects: connectedProjects,
            error: error || errorGql,
            loading: loading || loadingGql
        };
    };
    const $0aaed1b7ad88a5a6$export$ce7c3edc10cad343 = (projectId)=>{
        const { connectedProjects: connectedProjects, loading: loading, error: error, setContext: setContext } = $0aaed1b7ad88a5a6$var$useConnectedProjectsContext();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const startConnectExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("f42Sq")).CONNECT_JSW_PROJECT_EXPERIENCE));
        const onSuccessConnect = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("f42Sq")).CONNECT_JSW_PROJECT_EXPERIENCE));
        const onFailConnect = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("f42Sq")).CONNECT_JSW_PROJECT_EXPERIENCE));
        const startDisconnectExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("f42Sq")).DISCONNECT_JSW_PROJECT_EXPERIENCE));
        const onSuccessDisconnect = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("f42Sq")).DISCONNECT_JSW_PROJECT_EXPERIENCE));
        const onFailDisconnect = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("f42Sq")).DISCONNECT_JSW_PROJECT_EXPERIENCE));
        const startClearExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("f42Sq")).CLEAR_JSW_PROJECTS_EXPERIENCE));
        const onSuccessClear = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("f42Sq")).CLEAR_JSW_PROJECTS_EXPERIENCE));
        const onFailClear = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("f42Sq")).CLEAR_JSW_PROJECTS_EXPERIENCE));
        const { onProjectConnect: onProjectConnect, onProjectDisconnect: onProjectDisconnect, onDisconnectAllProjects: onDisconnectAllProjects, loading: loadingGql } = (0, (0, parcelRequire("2otlL")).useConnectedProjects)(projectId);
        const connectProject = (0, $5uXOq.useCallback)(async (projectToConnect)=>{
            if (!projectToConnect) return;
            const newlyConnectedProject = {
                id: projectToConnect.value,
                resourceId: (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: projectToConnect.value
                }).toString(),
                name: projectToConnect.name,
                avatarUrl: projectToConnect.avatarUrl
            };
            startConnectExperience();
            setContext({
                connectedProjects: connectedProjects,
                loading: true,
                error: null
            });
            try {
                (0, (0, parcelRequire("3uyqp")).setProjectProperty)({
                    propertyValue: newlyConnectedProject,
                    projectKeyOrId: projectId
                }).catch((0, ($parcel$interopDefault($8Rkzz))));
                await onProjectConnect({
                    id: newlyConnectedProject.id,
                    name: newlyConnectedProject.name,
                    avatarUrl: newlyConnectedProject.avatarUrl
                });
                setContext({
                    loading: false,
                    error: null,
                    connectedProjects: undefined
                });
                onSuccessConnect();
            } catch (err) {
                setContext({
                    loading: false,
                    error: err,
                    connectedProjects: connectedProjects
                });
                onFailConnect('Failed to connect project', err);
                throw err;
            }
        }, [
            cloudId,
            connectedProjects,
            onFailConnect,
            onSuccessConnect,
            projectId,
            setContext,
            startConnectExperience,
            onProjectConnect
        ]);
        const disconnectProject = (0, $5uXOq.useCallback)(async (projectToDisconnect, actionMeta)=>{
            if (!projectToDisconnect) return;
            startDisconnectExperience();
            try {
                const lastConnectedProjectToSetInProjectProperty = (0, (0, parcelRequire("di0v2")).getLastConnectedProject)(connectedProjects, projectToDisconnect.value);
                if (lastConnectedProjectToSetInProjectProperty) (0, (0, parcelRequire("3uyqp")).setProjectProperty)({
                    propertyValue: lastConnectedProjectToSetInProjectProperty,
                    projectKeyOrId: projectId
                }).catch((0, ($parcel$interopDefault($8Rkzz))));
                else (0, (0, parcelRequire("3uyqp")).deleteProjectProperty)({
                    projectKeyOrId: projectId
                }).catch((0, ($parcel$interopDefault($8Rkzz))));
                await onProjectDisconnect({
                    id: projectToDisconnect.value,
                    name: projectToDisconnect.name ?? ''
                }, {
                    onClientError: ()=>{
                        onSuccessDisconnect();
                    },
                    actionMeta: actionMeta
                });
                setContext({
                    loading: false,
                    error: null,
                    connectedProjects: undefined
                });
                onSuccessDisconnect();
            } catch (err) {
                setContext({
                    loading: false,
                    error: err,
                    connectedProjects: connectedProjects
                });
                onFailDisconnect('Failed to disconnect project', err);
                throw err;
            }
        }, [
            startDisconnectExperience,
            connectedProjects,
            setContext,
            onSuccessDisconnect,
            projectId,
            onFailDisconnect,
            onProjectDisconnect
        ]);
        const disconnectAllProjects = (0, $5uXOq.useCallback)(async ()=>{
            if (!connectedProjects) return;
            startClearExperience();
            try {
                (0, (0, parcelRequire("3uyqp")).deleteProjectProperty)({
                    projectKeyOrId: projectId
                }).catch((0, ($parcel$interopDefault($8Rkzz))));
                await onDisconnectAllProjects(connectedProjects);
                setContext({
                    loading: false,
                    error: null,
                    connectedProjects: undefined
                });
                onSuccessClear();
            } catch (err) {
                setContext({
                    loading: false,
                    error: err,
                    connectedProjects: connectedProjects
                });
                onFailClear('Failed to clear connected projects', err);
                throw err;
            }
        }, [
            connectedProjects,
            onDisconnectAllProjects,
            onFailClear,
            onSuccessClear,
            projectId,
            setContext,
            startClearExperience
        ]);
        return {
            loading: loading || loadingGql,
            error: error,
            onProjectConnect: connectProject,
            onProjectDisconnect: disconnectProject,
            onDisconnectAllProjects: disconnectAllProjects,
            connectedProjects: connectedProjects
        };
    };
});
parcelRegister("2otlL", function(module, exports) {
    $parcel$export(module.exports, "useConnectedProjects", ()=>$3abaa412df4c1257$export$c52f58cb8b4d9a72);
    var $5uXOq = parcelRequire("5uXOq");
    var $ljMDN;
    var $pa9q9;
    var $koeKL;
    var $c4lrN;
    var $fVLzz;
    var $15RTq;
    var $8RBr5;
    const $3abaa412df4c1257$var$mapActionMeta = ({ action: action })=>{
        switch(action){
            case 'deselect-option':
                return 'unselected';
            default:
                return 'cleared';
        }
    };
    const $3abaa412df4c1257$export$c52f58cb8b4d9a72 = (currentProjectId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const currentProjectAri = (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
            siteId: cloudId,
            projectId: currentProjectId
        }).toString();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const [connectProjects, connectingProjects] = (0, (0, parcelRequire("c4lrN")).useConnectProjects)(currentProjectAri);
        const [disconnectProjects, disconnectingProjects] = (0, (0, parcelRequire("15RTq")).useDisconnectProjects)(currentProjectAri);
        const fireProjectChangeAnalytics = (0, (0, parcelRequire("fVLzz")).useConnectedProjectsChangeAnalytics)('multiConnectedProjectPicker');
        const onProjectDisconnect = (0, $5uXOq.useCallback)(async (project, options)=>{
            const projectAri = (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: project.id
            }).toString();
            try {
                await disconnectProjects([
                    projectAri
                ]);
            } catch (error) {
                if (error instanceof Error && (error.message === (0, $905b5fa95b4fd559$export$a0caab34915100a0) || error.message === (0, $905b5fa95b4fd559$export$19106fd0f3d5e6cc))) options?.onClientError?.(error);
                return;
            }
            showFlag((0, (0, parcelRequire("8RBr5")).createProjectsDisconnectionMultiSuccessFlagConfig)());
            fireProjectChangeAnalytics(options?.actionMeta ? $3abaa412df4c1257$var$mapActionMeta(options.actionMeta) : 'cleared');
        }, [
            cloudId,
            disconnectProjects,
            fireProjectChangeAnalytics,
            showFlag
        ]);
        const onDisconnectAllProjects = (0, $5uXOq.useCallback)(async (projects)=>{
            const projectAris = projects.map((project)=>(0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: project.id
                }).toString());
            try {
                await disconnectProjects(projectAris);
            } catch (error) {
                return;
            }
            showFlag((0, (0, parcelRequire("8RBr5")).createClearProjectsMultiSuccessFlagConfig)());
            fireProjectChangeAnalytics('cleared');
        }, [
            cloudId,
            disconnectProjects,
            fireProjectChangeAnalytics,
            showFlag
        ]);
        const onProjectConnect = (0, $5uXOq.useCallback)(async (project, options = {
            showSuccessFlag: true,
            fireAnalyticsOnSuccess: true
        })=>{
            const transformedNewlyConnectedProject = {
                id: project.id,
                name: project.name,
                avatarUrl: project.avatarUrl,
                resourceId: (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: project.id
                }).toString()
            };
            try {
                await connectProjects(transformedNewlyConnectedProject);
            } catch (error) {
                return;
            }
            if (options.showSuccessFlag) showFlag((0, (0, parcelRequire("8RBr5")).createProjectsConnectionMultiSuccessFlagConfig)());
            if (options.fireAnalyticsOnSuccess) fireProjectChangeAnalytics('selected', {
                isSwitchingConnectedProject: false
            });
        }, [
            cloudId,
            connectProjects,
            fireProjectChangeAnalytics,
            showFlag
        ]);
        return {
            initialised: !connectingProjects && !disconnectingProjects,
            loading: connectingProjects || disconnectingProjects,
            onProjectDisconnect: onProjectDisconnect,
            onDisconnectAllProjects: onDisconnectAllProjects,
            onProjectConnect: onProjectConnect
        };
    };
});
const $905b5fa95b4fd559$var$analyticsErrorPrefix = 'shared-software-dates';
const $905b5fa95b4fd559$export$b8b9d90f9e5bd72b = 'jiraSharedSoftwareDates';
const $905b5fa95b4fd559$export$d57b6b390e78d90f = 'jira-werewolves';
const $905b5fa95b4fd559$export$48ce19154660a070 = `${$905b5fa95b4fd559$var$analyticsErrorPrefix}.fetch-connected-projects`;
const $905b5fa95b4fd559$export$c72a2f64af6c01ff = `${$905b5fa95b4fd559$var$analyticsErrorPrefix}.connect-projects`;
const $905b5fa95b4fd559$export$3478c2be8e5b8a45 = `${$905b5fa95b4fd559$var$analyticsErrorPrefix}.disconnect-projects`;
const $905b5fa95b4fd559$export$a0caab34915100a0 = 'Server responded with 403';
const $905b5fa95b4fd559$export$19106fd0f3d5e6cc = 'Server responded with 404';
parcelRegister("c4lrN", function(module, exports) {
    $parcel$export(module.exports, "useConnectProjects", ()=>$218bb9aa994bbd25$export$db114f703f4ea71a);
    var $cacYU;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $koVbs;
    var $9YfF8;
    var $kWeoZ;
    var $ahvHk;
    var $dVYTe;
    const $218bb9aa994bbd25$export$db114f703f4ea71a = (currentProjectAri)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleError = (0, (0, parcelRequire("ahvHk")).useHandleError)();
        const showGenericFlag = (0, (0, parcelRequire("kWeoZ")).useGenericFlag)();
        const reportError = (error)=>(0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: (0, $905b5fa95b4fd559$export$c72a2f64af6c01ff),
                    packageName: (0, $905b5fa95b4fd559$export$b8b9d90f9e5bd72b),
                    teamName: (0, $905b5fa95b4fd559$export$d57b6b390e78d90f)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        const [connectProjectMutation, isConnectInFlight] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("cacYU")).default));
        const connectProjects = (0, $5uXOq.useCallback)((toProject)=>new Promise((resolve, reject)=>{
                connectProjectMutation({
                    variables: {
                        input: {
                            relationships: [
                                {
                                    from: currentProjectAri,
                                    to: toProject.resourceId
                                }
                            ]
                        }
                    },
                    onCompleted (response) {
                        try {
                            handleError(response.graphStore?.createProjectHasRelatedWorkWithProject, {
                                404: {
                                    title: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionNotFoundTitle),
                                    description: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionNotFoundDescription)
                                },
                                403: {
                                    title: formatMessage((0, (0, parcelRequire("9YfF8")).messages).connectPermissionsFailFlagTitle),
                                    description: formatMessage((0, (0, parcelRequire("9YfF8")).messages).connectPermissionsFailFlagDescription)
                                }
                            });
                        } catch (err) {
                            reportError(err);
                            reject(err);
                            return;
                        }
                        resolve();
                    },
                    onError (err) {
                        reportError(err);
                        showGenericFlag();
                        reject();
                    },
                    updater: (store, data)=>{
                        if (data?.graphStore?.createProjectHasRelatedWorkWithProject?.success) (0, (0, parcelRequire("dVYTe")).updateStore)(store, [
                            toProject
                        ], currentProjectAri);
                    }
                });
            }), [
            connectProjectMutation,
            currentProjectAri,
            handleError,
            formatMessage,
            showGenericFlag
        ]);
        return [
            connectProjects,
            isConnectInFlight
        ];
    };
});
parcelRegister("cacYU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33e0fbe8aa173ad6$export$2e2bcd8739ae039);
    const $33e0fbe8aa173ad6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "message"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
                "selections": [
                    {
                        "concreteType": "GraphStoreMutation",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
                                "kind": "LinkedField",
                                "name": "createProjectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v4
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
                "selections": [
                    {
                        "concreteType": "GraphStoreMutation",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
                                "kind": "LinkedField",
                                "name": "createProjectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v4,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "4513f81aaaf8e5ef12bfb3701b174a420bf76437023d3ba3827b725fad852948",
                "metadata": {},
                "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $33e0fbe8aa173ad6$var$node.hash = "2846b3362eafd7b13df7ab71229cd39c";
    var $33e0fbe8aa173ad6$export$2e2bcd8739ae039 = $33e0fbe8aa173ad6$var$node;
});
parcelRegister("9YfF8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bae9b00d1af1b062$export$defe85febe8b728c);
    var $7VHMR;
    const $bae9b00d1af1b062$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        connectedProjectsLoadFailureTitle: {
            "id": "shared-software-dates.common.connected-projects-load-failure-title",
            "defaultMessage": "We couldn't load connected projects"
        },
        projectConnectionFailureTitle: {
            "id": "shared-software-dates.common.project-connection-failure-title",
            "defaultMessage": "We couldn't connect to your project"
        },
        projectConnectionUnexpectedFailureDescription: {
            "id": "shared-software-dates.common.project-connection-unexpected-failure-description",
            "defaultMessage": "Make sure you're connected to the right network or contact your workspace admin for support."
        },
        connectPermissionsFailFlagTitle: {
            "id": "shared-software-dates.common.connect-permissions-fail-flag-title",
            "defaultMessage": "You don't have permission to connect this project"
        },
        connectPermissionsFailFlagDescription: {
            "id": "shared-software-dates.common.connect-permissions-fail-flag-description",
            "defaultMessage": "Contact your Jira admin for permission to add release dates of a software project."
        },
        disconnectPermissionsFailFlagTitle: {
            "id": "shared-software-dates.common.disconnect-permissions-fail-flag-title",
            "defaultMessage": "You don't have permission to disconnect this project"
        },
        disconnectPermissionsFailFlagDescription: {
            "id": "shared-software-dates.common.disconnect-permissions-fail-flag-description",
            "defaultMessage": "Contact your Jira admin for permission to remove release dates from a software project."
        },
        projectConnectionNotFoundTitle: {
            "id": "shared-software-dates.common.project-connection-not-found-title",
            "defaultMessage": "We couldn't find the connected software project"
        },
        projectConnectionNotFoundDescription: {
            "id": "shared-software-dates.common.project-connection-not-found-description",
            "defaultMessage": "The connected software project may have been deleted. Refresh the page, then try again."
        },
        projectsConnectionSuccessFlagHeading: {
            "id": "shared-software-dates.common.projects-connection-success-flag-heading",
            "defaultMessage": "You're showing software project release dates for {projectName}"
        },
        multiProjectsConnectionSuccessFlagHeading: {
            "id": "shared-software-dates.common.multi-projects-connection-success-flag-heading",
            "defaultMessage": "You've added a software project to your teams' calendar"
        },
        projectsConnectionSuccessFlagText: {
            "id": "shared-software-dates.common.projects-connection-success-flag-text",
            "defaultMessage": "All release dates from this project will appear in your calendar."
        },
        multiProjectsConnectionSuccessFlagText: {
            "id": "shared-software-dates.common.multi-projects-connection-success-flag-text",
            "defaultMessage": "Its release dates will be visible to everyone in your business team."
        },
        projectsConnectionFailureFlagHeading: {
            "id": "shared-software-dates.common.projects-connection-failure-flag-heading",
            "defaultMessage": "Trouble showing software project release dates"
        },
        projectsConnectionFailureFlagText: {
            "id": "shared-software-dates.common.projects-connection-failure-flag-text",
            "defaultMessage": "It looks like we're having some trouble showing and hiding software project release dates. Wait a few moments, then try again."
        },
        projectsDisconnectionSuccessFlagHeading: {
            "id": "shared-software-dates.common.projects-disconnection-success-flag-heading",
            "defaultMessage": "You've hidden software project release dates for {projectName}"
        },
        multiProjectsDisconnectionSuccessFlagHeading: {
            "id": "shared-software-dates.common.multi-projects-disconnection-success-flag-heading",
            "defaultMessage": "You've removed a software project from your teams' calendar"
        },
        projectsDisconnectionSuccessFlagText: {
            "id": "shared-software-dates.common.projects-disconnection-success-flag-text",
            "defaultMessage": "Release dates from this project will no longer show in your calendar."
        },
        multiProjectsDisconnectionSuccessFlagText: {
            "id": "shared-software-dates.common.multi-projects-disconnection-success-flag-text",
            "defaultMessage": "Its release dates will no longer be visible to your business team."
        },
        clearMultiProjectsSuccessFlagHeading: {
            "id": "shared-software-dates.common.clear-multi-projects-success-flag-heading",
            "defaultMessage": "You've removed all software projects from your teams' calendar"
        },
        clearMultiProjectsSuccessFlagText: {
            "id": "shared-software-dates.common.clear-multi-projects-success-flag-text",
            "defaultMessage": "Their release dates will no longer be visible to your business team."
        },
        showSoftwareReleasesToggleText: {
            "id": "shared-software-dates.common.show-software-releases-toggle-text",
            "defaultMessage": "Show software releases"
        }
    });
});
parcelRegister("kWeoZ", function(module, exports) {
    $parcel$export(module.exports, "useGenericFlag", ()=>$48c6e737674f21ef$export$1762f9e38cafc569);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $koVbs;
    var $9YfF8;
    const $48c6e737674f21ef$export$1762f9e38cafc569 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, $5uXOq.useCallback)(()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionFailureTitle),
                description: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionUnexpectedFailureDescription)
            });
        }, [
            showFlag,
            formatMessage
        ]);
    };
});
parcelRegister("ahvHk", function(module, exports) {
    $parcel$export(module.exports, "useHandleError", ()=>$44d322b61ced04c7$export$7ab84fea33af0d21);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $pa9q9;
    var $kWeoZ;
    const $44d322b61ced04c7$export$7ab84fea33af0d21 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const showGenericFlag = (0, (0, parcelRequire("kWeoZ")).useGenericFlag)();
        return (0, $5uXOq.useCallback)((extractedResponse, errorMessages)=>{
            if ((0, ($parcel$interopDefault($hGgHi)))(extractedResponse)) {
                showGenericFlag();
                throw new Error('No response available from BE');
            }
            if (!extractedResponse?.success) {
                const code = extractedResponse?.errors?.[0]?.extensions?.statusCode;
                if (code === 404) {
                    showFlag({
                        type: 'error',
                        title: errorMessages['404'].title,
                        description: errorMessages['404'].description
                    });
                    throw new Error((0, $905b5fa95b4fd559$export$19106fd0f3d5e6cc));
                }
                if (code === 403) {
                    showFlag({
                        type: 'error',
                        title: errorMessages['403'].title,
                        description: errorMessages['403'].description
                    });
                    throw new Error((0, $905b5fa95b4fd559$export$a0caab34915100a0));
                }
                showGenericFlag();
                throw new Error('Unknown BE error');
            }
        }, [
            showFlag,
            showGenericFlag
        ]);
    };
});
parcelRegister("dVYTe", function(module, exports) {
    $parcel$export(module.exports, "updateStore", ()=>$1e8c7b6a7ee1a1a8$export$168a0875d66dd4b7);
    var $eiowN = parcelRequire("eiowN");
    var $iJZ8l;
    const $1e8c7b6a7ee1a1a8$var$addMissingClientTypeIfNecessary = (store)=>{
        const clientRecordId = `client:__type:${(0, $b00a2a62cf7c8af1$export$9a6c1368adb7aff8)}`;
        let clientRecord = store.get(clientRecordId);
        if (!clientRecord) {
            clientRecord = store.create(clientRecordId, (0, $b00a2a62cf7c8af1$export$9a6c1368adb7aff8));
            clientRecord.setValue(clientRecordId, '__id');
            clientRecord.setValue(true, '__isNode');
            clientRecord.setValue('__TypeSchema', '__typename');
        }
    };
    const $1e8c7b6a7ee1a1a8$export$168a0875d66dd4b7 = (store, connectedProjectProxies, currentProjectAri)=>{
        const graphStoreRecord = store.getRoot().getLinkedRecord((0, $b00a2a62cf7c8af1$export$5671eec1442f4236));
        if (!graphStoreRecord) return;
        const connection = graphStoreRecord.getLinkedRecord((0, $b00a2a62cf7c8af1$export$5d6dda408bc5a867), {
            id: currentProjectAri
        });
        if (!connection) return;
        connectedProjectProxies.forEach((project)=>{
            const { id: id, name: name, avatarUrl: avatarUrl, resourceId: resourceId } = project;
            const projectNodeId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: resourceId
            }, (0, $b00a2a62cf7c8af1$export$9a6c1368adb7aff8));
            if (!projectNodeId) return;
            let projectNode = store.get(projectNodeId);
            if (!projectNode) {
                $1e8c7b6a7ee1a1a8$var$addMissingClientTypeIfNecessary(store);
                projectNode = store.create(projectNodeId, (0, $b00a2a62cf7c8af1$export$9a6c1368adb7aff8));
                projectNode.setValue(projectNodeId, 'id');
                projectNode.setValue(name, 'name');
                projectNode.setValue(id, 'projectId');
            }
            if (avatarUrl) {
                const avatarNodeId = (0, (0, parcelRequire("iJZ8l")).default)({
                    id: resourceId
                }, (0, $b00a2a62cf7c8af1$export$ccc034bb37e78deb));
                if (avatarNodeId && !store.get(avatarNodeId)) {
                    const avatarNode = store.create(avatarNodeId, (0, $b00a2a62cf7c8af1$export$ccc034bb37e78deb));
                    avatarNode.setValue(avatarNodeId, 'id');
                    avatarNode.setValue(avatarUrl, 'small');
                    projectNode.setLinkedRecord(avatarNode, 'avatar');
                }
            }
            const newEdge = (0, $eiowN.ConnectionHandler).createEdge(store, connection, projectNode, 'GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge');
            (0, $eiowN.ConnectionHandler).insertEdgeAfter(connection, newEdge);
        });
    };
});
const $b00a2a62cf7c8af1$export$5671eec1442f4236 = 'graphStore';
const $b00a2a62cf7c8af1$export$5d6dda408bc5a867 = 'projectHasRelatedWorkWithProject';
const $b00a2a62cf7c8af1$export$9a6c1368adb7aff8 = 'JiraProject';
const $b00a2a62cf7c8af1$export$ccc034bb37e78deb = 'JiraAvatar';
parcelRegister("fVLzz", function(module, exports) {
    $parcel$export(module.exports, "useConnectedProjectsChangeAnalytics", ()=>$d3facbf618be239d$export$a579764fcd563f30);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $d3facbf618be239d$export$a579764fcd563f30 = (eventName)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((action, attributes = {})=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), `project ${action}`, eventName, attributes);
        }, [
            createAnalyticsEvent,
            eventName
        ]);
    };
});
parcelRegister("15RTq", function(module, exports) {
    $parcel$export(module.exports, "useDisconnectProjects", ()=>$8158dda5aeaa88c1$export$f13496c46076bb0f);
    var $5I4tP;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $koVbs;
    var $9YfF8;
    var $kWeoZ;
    var $ahvHk;
    var $iz3mC;
    const $8158dda5aeaa88c1$export$f13496c46076bb0f = (currentProjectAri)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleError = (0, (0, parcelRequire("ahvHk")).useHandleError)();
        const showGenericFlag = (0, (0, parcelRequire("kWeoZ")).useGenericFlag)();
        const reportError = (error)=>(0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: (0, $905b5fa95b4fd559$export$3478c2be8e5b8a45),
                    packageName: (0, $905b5fa95b4fd559$export$b8b9d90f9e5bd72b),
                    teamName: (0, $905b5fa95b4fd559$export$d57b6b390e78d90f)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        const [disconnectProjectMutation, isDisconnectInFlight] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("5I4tP")).default));
        const disconnectProjects = (0, $5uXOq.useCallback)((toProjectAris)=>new Promise((resolve, reject)=>{
                disconnectProjectMutation({
                    variables: {
                        input: {
                            relationships: toProjectAris.map((toProjectAri)=>({
                                    from: currentProjectAri,
                                    to: toProjectAri
                                }))
                        }
                    },
                    onCompleted (response) {
                        try {
                            handleError(response.graphStore?.deleteProjectHasRelatedWorkWithProject, {
                                404: {
                                    title: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionNotFoundTitle),
                                    description: formatMessage((0, (0, parcelRequire("9YfF8")).messages).projectConnectionNotFoundDescription)
                                },
                                403: {
                                    title: formatMessage((0, (0, parcelRequire("9YfF8")).messages).disconnectPermissionsFailFlagTitle),
                                    description: formatMessage((0, (0, parcelRequire("9YfF8")).messages).disconnectPermissionsFailFlagDescription)
                                }
                            });
                        } catch (err) {
                            reportError(err);
                            reject(err);
                            return;
                        }
                        resolve();
                    },
                    onError (err) {
                        reportError(err);
                        showGenericFlag();
                        reject();
                    },
                    updater: (store, data)=>{
                        if (data?.graphStore?.deleteProjectHasRelatedWorkWithProject?.success) (0, (0, parcelRequire("iz3mC")).updateStore)(store, toProjectAris, currentProjectAri);
                    }
                });
            }), [
            showGenericFlag,
            currentProjectAri,
            disconnectProjectMutation,
            handleError,
            formatMessage
        ]);
        return [
            disconnectProjects,
            isDisconnectInFlight
        ];
    };
});
parcelRegister("5I4tP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7d727b6252c4435$export$2e2bcd8739ae039);
    const $b7d727b6252c4435$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "message"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
                "selections": [
                    {
                        "concreteType": "GraphStoreMutation",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload",
                                "kind": "LinkedField",
                                "name": "deleteProjectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v4
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
                "selections": [
                    {
                        "concreteType": "GraphStoreMutation",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload",
                                "kind": "LinkedField",
                                "name": "deleteProjectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v4,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9b6ff8d1b59d07779e9e239870041ef5d155c63c4284ce2073bb37d344790a79",
                "metadata": {},
                "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $b7d727b6252c4435$var$node.hash = "28ed51a7a4985efd66b750dbadac2ab1";
    var $b7d727b6252c4435$export$2e2bcd8739ae039 = $b7d727b6252c4435$var$node;
});
parcelRegister("iz3mC", function(module, exports) {
    $parcel$export(module.exports, "updateStore", ()=>$5ef559306c84aeb9$export$168a0875d66dd4b7);
    var $eiowN = parcelRequire("eiowN");
    var $iJZ8l;
    const $5ef559306c84aeb9$export$168a0875d66dd4b7 = (store, deletedProjectAris, currentProjectAri)=>{
        const graphStoreRecord = store.getRoot().getLinkedRecord((0, $b00a2a62cf7c8af1$export$5671eec1442f4236));
        if (!graphStoreRecord) return;
        const connection = graphStoreRecord.getLinkedRecord((0, $b00a2a62cf7c8af1$export$5d6dda408bc5a867), {
            id: currentProjectAri
        });
        if (!connection) return;
        deletedProjectAris.forEach((toProjectAri)=>{
            const deletedProjectNodeId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: toProjectAri
            }, (0, $b00a2a62cf7c8af1$export$9a6c1368adb7aff8));
            const deletedAvatarNodeId = (0, (0, parcelRequire("iJZ8l")).default)({
                id: toProjectAri
            }, (0, $b00a2a62cf7c8af1$export$ccc034bb37e78deb));
            if (deletedProjectNodeId && deletedAvatarNodeId) {
                (0, $eiowN.ConnectionHandler).deleteNode(connection, deletedProjectNodeId);
                (0, $eiowN.ConnectionHandler).deleteNode(connection, deletedAvatarNodeId);
                store.delete(deletedProjectNodeId);
                store.delete(deletedAvatarNodeId);
            }
        });
    };
});
parcelRegister("8RBr5", function(module, exports) {
    $parcel$export(module.exports, "createProjectsConnectionMultiSuccessFlagConfig", ()=>$2399cecb5da87e58$export$57499168868131c);
    $parcel$export(module.exports, "createProjectsDisconnectionMultiSuccessFlagConfig", ()=>$2399cecb5da87e58$export$4e29e9170e6344e1);
    $parcel$export(module.exports, "createClearProjectsMultiSuccessFlagConfig", ()=>$2399cecb5da87e58$export$af8cd27293521ef9);
    var $9YfF8;
    const $2399cecb5da87e58$export$d343684d4b1ca57f = (projectName)=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-connection-success-flag',
            type: 'success',
            title: [
                (0, (0, parcelRequire("9YfF8")).messages).projectsConnectionSuccessFlagHeading,
                {
                    projectName: projectName
                }
            ],
            description: (0, (0, parcelRequire("9YfF8")).messages).projectsConnectionSuccessFlagText
        });
    const $2399cecb5da87e58$export$57499168868131c = ()=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-connection-multi-success-flag',
            type: 'success',
            title: (0, (0, parcelRequire("9YfF8")).messages).multiProjectsConnectionSuccessFlagHeading,
            description: (0, (0, parcelRequire("9YfF8")).messages).multiProjectsConnectionSuccessFlagText
        });
    const $2399cecb5da87e58$export$733efe51397f7515 = ()=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-connection-failure-flag',
            type: 'error',
            title: (0, (0, parcelRequire("9YfF8")).messages).projectsConnectionFailureFlagHeading,
            description: (0, (0, parcelRequire("9YfF8")).messages).projectsConnectionFailureFlagText
        });
    const $2399cecb5da87e58$export$e883df642ca737f5 = (projectName)=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-disconnection-success-flag',
            type: 'success',
            title: [
                (0, (0, parcelRequire("9YfF8")).messages).projectsDisconnectionSuccessFlagHeading,
                {
                    projectName: projectName
                }
            ],
            description: (0, (0, parcelRequire("9YfF8")).messages).projectsDisconnectionSuccessFlagText
        });
    const $2399cecb5da87e58$export$4e29e9170e6344e1 = ()=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-disconnection-multi-success-flag',
            type: 'success',
            title: (0, (0, parcelRequire("9YfF8")).messages).multiProjectsDisconnectionSuccessFlagHeading,
            description: (0, (0, parcelRequire("9YfF8")).messages).multiProjectsDisconnectionSuccessFlagText
        });
    const $2399cecb5da87e58$export$af8cd27293521ef9 = ()=>({
            testId: 'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.clear-projects-multi-success-flag',
            type: 'success',
            title: (0, (0, parcelRequire("9YfF8")).messages).clearMultiProjectsSuccessFlagHeading,
            description: (0, (0, parcelRequire("9YfF8")).messages).clearMultiProjectsSuccessFlagText
        });
});
parcelRegister("lUlJ6", function(module, exports) {
    $parcel$export(module.exports, "useFetchConnectedProjects", ()=>$42f3df9db454f3b0$export$d1dbabbd5c09d305);
    var $5izAg;
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $ljMDN;
    var $jcw0u;
    var $pa9q9;
    var $5yJb9;
    var $5izAg;
    var $koeKL;
    var $9YfF8;
    const $42f3df9db454f3b0$var$GENERIC_ERROR_FLAG = {
        type: 'error',
        title: (0, (0, parcelRequire("9YfF8")).messages).connectedProjectsLoadFailureTitle,
        description: (0, (0, parcelRequire("9YfF8")).messages).projectConnectionUnexpectedFailureDescription
    };
    const $42f3df9db454f3b0$export$d1dbabbd5c09d305 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ data: data, loading: loading, error: error }, setState] = (0, $5uXOq.useState)({
            data: [],
            loading: false,
            error: null
        });
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const reportError = (reportedError)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: (0, $905b5fa95b4fd559$export$48ce19154660a070),
                    packageName: (0, $905b5fa95b4fd559$export$b8b9d90f9e5bd72b),
                    teamName: (0, $905b5fa95b4fd559$export$d57b6b390e78d90f)
                },
                error: reportedError,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const fetchConnectedProjects = (0, $5uXOq.useCallback)(async (currentProjectId)=>{
            const currentProjectAri = (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: currentProjectId
            }).toString();
            let connectedProjectsResponse;
            setState((prev)=>({
                    ...prev,
                    error: null,
                    loading: true
                }));
            const variables = {
                id: currentProjectAri
            };
            try {
                const query = (0, (0, parcelRequire("5izAg")).default);
                (0, (0, parcelRequire("5yJb9")).default)().retain((0, $eiowN.createOperationDescriptor)((0, (0, parcelRequire("5izAg")).default), variables));
                const fetchCallObservable$ = (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables, {
                    fetchPolicy: 'store-or-network',
                    networkCacheConfig: {
                        force: false
                    }
                });
                const fetchCallPromise = fetchCallObservable$.toPromise();
                connectedProjectsResponse = await fetchCallPromise;
            } catch (err) {
                const reportedError = err;
                reportError(reportedError);
                showFlag($42f3df9db454f3b0$var$GENERIC_ERROR_FLAG);
                setState({
                    data: [],
                    loading: false,
                    error: reportedError
                });
                throw reportedError;
            }
            if ((0, ($parcel$interopDefault($hGgHi)))(connectedProjectsResponse?.graphStore?.projectHasRelatedWorkWithProject?.edges)) {
                const unknownError = new Error('Unexpected response while fetching connected projects');
                reportError(unknownError);
                showFlag($42f3df9db454f3b0$var$GENERIC_ERROR_FLAG);
                setState({
                    data: [],
                    loading: false,
                    error: unknownError
                });
                throw unknownError;
            }
            const projects = connectedProjectsResponse.graphStore.projectHasRelatedWorkWithProject.edges.map((edge)=>{
                if (!edge?.node?.projectId?.length || !edge?.node?.name?.length) return null;
                return {
                    id: edge.node.projectId,
                    name: edge.node.name,
                    avatarUrl: edge?.node?.avatar?.small,
                    resourceId: (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: edge?.node?.projectId
                    }).toString()
                };
            }).filter(Boolean) ?? [];
            setState({
                data: projects,
                loading: false,
                error: null
            });
            return projects;
        }, [
            cloudId,
            showFlag
        ]);
        return {
            fetchConnectedProjects: fetchConnectedProjects,
            data: data,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("5izAg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3497b2f5b1c06ea$export$2e2bcd8739ae039);
    const $e3497b2f5b1c06ea$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        }, v4 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
                "selections": [
                    {
                        "concreteType": "GraphStore",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection",
                                "kind": "LinkedField",
                                "name": "projectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3,
                                                                "action": "THROW",
                                                                "path": "graphStore.projectHasRelatedWorkWithProject.edges.node.name"
                                                            },
                                                            v4
                                                        ],
                                                        "type": "JiraProject"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
                "selections": [
                    {
                        "concreteType": "GraphStore",
                        "kind": "LinkedField",
                        "name": "graphStore",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection",
                                "kind": "LinkedField",
                                "name": "projectHasRelatedWorkWithProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v2,
                                                            v3,
                                                            v4
                                                        ],
                                                        "type": "JiraProject"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v5
                                                        ],
                                                        "type": "Node",
                                                        "abstractKey": "__isNode"
                                                    }
                                                ]
                                            },
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c03225dbb59142b70bdc77143f6748d54be578263c61b66a60c5aad99af922fc",
                "metadata": {},
                "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e3497b2f5b1c06ea$var$node.hash = "a4e9cf70c3f9e4d374cbdbe2a5320ea0";
    var $e3497b2f5b1c06ea$export$2e2bcd8739ae039 = $e3497b2f5b1c06ea$var$node;
});
parcelRegister("3uyqp", function(module, exports) {
    $parcel$export(module.exports, "setProjectProperty", ()=>$a07805835351275b$export$5ba94dd47ae5c3cb);
    $parcel$export(module.exports, "getProjectProperty", ()=>$a07805835351275b$export$4ba01eb18377dd64);
    $parcel$export(module.exports, "deleteProjectProperty", ()=>$a07805835351275b$export$3d7d9ba588db227a);
    $parcel$export(module.exports, "getIsProjectMigratedProperty", ()=>$a07805835351275b$export$bb21efaf8b974a9b);
    $parcel$export(module.exports, "setIsProjectMigratedProperty", ()=>$a07805835351275b$export$8d2c90b0ee0130ba);
    var $jcw0u;
    var $fZneA;
    var $eusud;
    const $a07805835351275b$var$getUrl = (projectKeyOrId, propertyKey)=>`/rest/api/3/project/${projectKeyOrId}/properties/${propertyKey}`;
    const $a07805835351275b$var$handleErrorLogging = (operation, error, attributes)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: operation,
                packageName: 'jiraBusinessCalendar',
                teamName: 'jira-yurree'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: attributes
        });
    };
    const $a07805835351275b$var$createProjectPropertySetter = (PROPERTY_KEY)=>async ({ propertyValue: propertyValue, projectKeyOrId: projectKeyOrId })=>{
            const url = $a07805835351275b$var$getUrl(projectKeyOrId, PROPERTY_KEY);
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                    body: JSON.stringify(propertyValue)
                });
            } catch (error) {
                $a07805835351275b$var$handleErrorLogging('setProjectProperty', error, {
                    projectKeyOrId: projectKeyOrId,
                    propertyValue: JSON.stringify(propertyValue)
                });
                throw error;
            }
        };
    const $a07805835351275b$export$5ba94dd47ae5c3cb = $a07805835351275b$var$createProjectPropertySetter((0, $70178bad571b433c$export$9c1ad8c90da003d9));
    const $a07805835351275b$var$createProjectPropertyGetter = (PROPERTY_KEY)=>async ({ projectKeyOrId: projectKeyOrId })=>{
            const url = $a07805835351275b$var$getUrl(projectKeyOrId, PROPERTY_KEY);
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                return response;
            } catch (error) {
                if (error.statusCode === 404) return {
                    key: PROPERTY_KEY,
                    value: null
                };
                $a07805835351275b$var$handleErrorLogging('getProjectProperty', error, {
                    projectKeyOrId: projectKeyOrId
                });
                throw error;
            }
        };
    const $a07805835351275b$export$4ba01eb18377dd64 = $a07805835351275b$var$createProjectPropertyGetter((0, $70178bad571b433c$export$9c1ad8c90da003d9));
    const $a07805835351275b$export$3d7d9ba588db227a = async ({ projectKeyOrId: projectKeyOrId })=>{
        const url = $a07805835351275b$var$getUrl(projectKeyOrId, (0, $70178bad571b433c$export$9c1ad8c90da003d9));
        try {
            await (0, (0, parcelRequire("eusud")).performDeleteRequest)(url);
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error)) $a07805835351275b$var$handleErrorLogging('deleteProjectProperty', error, {
                projectKeyOrId: projectKeyOrId
            });
            throw error;
        }
    };
    const $a07805835351275b$export$bb21efaf8b974a9b = $a07805835351275b$var$createProjectPropertyGetter((0, $70178bad571b433c$export$efe407c634c8a0f4));
    const $a07805835351275b$export$8d2c90b0ee0130ba = $a07805835351275b$var$createProjectPropertySetter((0, $70178bad571b433c$export$efe407c634c8a0f4));
});
const $70178bad571b433c$export$9c1ad8c90da003d9 = 'connectedJswProject';
const $70178bad571b433c$export$efe407c634c8a0f4 = 'isConnectedJswProjectMigrated';
parcelRegister("atA8L", function(module, exports) {
    $parcel$export(module.exports, "useConnectedProjectMigrationToAgs", ()=>$f1884fa894f80e02$export$b86440a5dd81fae3);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $2otlL;
    var $5PVea;
    var $3uyqp;
    var $c2KC9;
    const $f1884fa894f80e02$export$b86440a5dd81fae3 = (projectId)=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const isProjectAdmin = project.permissions.administerProject;
        const { onProjectConnect: migrateConnectedProjectToAgs } = (0, (0, parcelRequire("2otlL")).useConnectedProjects)(projectId);
        const isMigratedFromRestToAgs = (0, $5uXOq.useRef)(false);
        const migrateConnectedProjectPropertyIfNecessary = (0, $5uXOq.useCallback)(async ()=>{
            if (isMigratedFromRestToAgs.current) return;
            let isMigratedFromRestToAgsProjectProperty;
            (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).start();
            try {
                isMigratedFromRestToAgsProjectProperty = await (0, (0, parcelRequire("3uyqp")).getIsProjectMigratedProperty)({
                    projectKeyOrId: projectId
                });
            } catch (err) {
                (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).failure({
                    metadata: {
                        location: 'Failed to fetch "is migrated" connected project property for admin user',
                        error: err?.message
                    }
                });
                throw err;
            }
            if (isMigratedFromRestToAgsProjectProperty.value) {
                (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).abort();
                isMigratedFromRestToAgs.current = true;
                return;
            }
            let connectedProjectProperty;
            try {
                connectedProjectProperty = await (0, (0, parcelRequire("3uyqp")).getProjectProperty)({
                    projectKeyOrId: projectId
                });
            } catch (err) {
                (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).failure({
                    metadata: {
                        location: 'Failed to fetch connected project via REST before migrating to AGS',
                        error: err?.message
                    }
                });
                throw err;
            }
            const { value: connectedProjectRest } = connectedProjectProperty;
            if (!connectedProjectRest) {
                try {
                    await (0, (0, parcelRequire("3uyqp")).setIsProjectMigratedProperty)({
                        projectKeyOrId: projectId,
                        propertyValue: true
                    });
                } catch (err) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'setIsProjectMigratedProperty',
                            packageName: 'jiraBusinessCalendar',
                            teamName: 'jira-yurree'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            projectId: projectId,
                            location: 'Failed to mark connected project as migrated to AGS when migration is not needed'
                        }
                    });
                }
                (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).success();
                isMigratedFromRestToAgs.current = true;
                return;
            }
            let connectedProjectAvatarUrl = '';
            try {
                connectedProjectAvatarUrl = await (0, (0, parcelRequire("5PVea")).fetchProjectAvatar)(connectedProjectRest.id);
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchProjectAvatar',
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId
                    }
                });
            }
            try {
                await migrateConnectedProjectToAgs({
                    id: connectedProjectRest.id,
                    name: connectedProjectRest.name,
                    avatarUrl: connectedProjectAvatarUrl
                }, {
                    showSuccessFlag: false,
                    fireAnalyticsOnSuccess: false
                });
            } catch (err) {
                (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).failure({
                    metadata: {
                        location: 'Failed to migrate connected project from project properties to AGS',
                        error: err?.message
                    }
                });
                throw err;
            }
            try {
                await (0, (0, parcelRequire("3uyqp")).setIsProjectMigratedProperty)({
                    projectKeyOrId: projectId,
                    propertyValue: true
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'setIsProjectMigratedProperty',
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId,
                        location: 'Failed to mark connected project as migrated to AGS after migration complete'
                    }
                });
            }
            (0, (0, parcelRequire("c2KC9")).migrateConnectedProjectToAgsExperience).success();
            isMigratedFromRestToAgs.current = true;
            return {
                id: connectedProjectRest.id,
                name: connectedProjectRest.name,
                avatarUrl: connectedProjectAvatarUrl,
                resourceId: connectedProjectRest.resourceId
            };
        }, [
            migrateConnectedProjectToAgs,
            projectId
        ]);
        const shouldFetchFromRestWithoutMigration = (0, $5uXOq.useCallback)(async ()=>{
            if (isMigratedFromRestToAgs.current || isProjectAdmin) return false;
            let isMigratedFromRestToAgsProjectProperty;
            try {
                isMigratedFromRestToAgsProjectProperty = await (0, (0, parcelRequire("3uyqp")).getIsProjectMigratedProperty)({
                    projectKeyOrId: projectId
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getIsProjectMigratedProperty',
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId,
                        location: 'Failed to fetch "is migrated" connected project property for non-admin user'
                    }
                });
                throw err;
            }
            if (isMigratedFromRestToAgsProjectProperty.value) {
                isMigratedFromRestToAgs.current = true;
                return false;
            }
            return true;
        }, [
            isProjectAdmin,
            projectId
        ]);
        const fetchConnectedProjectFromRest = (0, $5uXOq.useCallback)(async ()=>{
            let connectedProjectProperty;
            try {
                connectedProjectProperty = await (0, (0, parcelRequire("3uyqp")).getProjectProperty)({
                    projectKeyOrId: projectId
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getProjectProperty',
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId,
                        location: 'Failed to fetch connected project via REST'
                    }
                });
                throw err;
            }
            if (!connectedProjectProperty.value) return;
            const { value: connectedProjectRest } = connectedProjectProperty;
            let connectedProjectAvatarUrl = '';
            try {
                connectedProjectAvatarUrl = await (0, (0, parcelRequire("5PVea")).fetchProjectAvatar)(connectedProjectRest.id);
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchProjectAvatar',
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId
                    }
                });
            }
            return {
                id: connectedProjectRest.id,
                name: connectedProjectRest.name,
                avatarUrl: connectedProjectAvatarUrl,
                resourceId: connectedProjectRest.resourceId
            };
        }, [
            projectId
        ]);
        return {
            shouldFetchFromRestWithoutMigration: shouldFetchFromRestWithoutMigration,
            migrateConnectedProjectPropertyIfNecessary: migrateConnectedProjectPropertyIfNecessary,
            fetchConnectedProjectFromRest: fetchConnectedProjectFromRest
        };
    };
});
parcelRegister("5PVea", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectAvatar", ()=>$7fa2cc148531b4ab$export$9bb3c10c63e3f181);
    var $eusud;
    const $7fa2cc148531b4ab$export$9bb3c10c63e3f181 = async (projectId)=>{
        const foundProjects = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/project/search?${new URLSearchParams({
            id: projectId
        }).toString()}`);
        return foundProjects?.values?.[0]?.avatarUrls?.['48x48'] || '';
    };
});
parcelRegister("c2KC9", function(module, exports) {
    $parcel$export(module.exports, "migrateConnectedProjectToAgsExperience", ()=>$5c277afeebd0363f$export$3a0d36317d0f16c3);
    var $atdLB;
    var $duUGa;
    const $5c277afeebd0363f$export$3a0d36317d0f16c3 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jira-business.calendar.migrate-connected-project-to-ags-experience', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    });
});
parcelRegister("di0v2", function(module, exports) {
    $parcel$export(module.exports, "getLastConnectedProject", ()=>$38f73590d54b50e2$export$3c3ca3734de13d26);
    var $hYfgW = parcelRequire("hYfgW");
    const $38f73590d54b50e2$export$3c3ca3734de13d26 = (connectedProjects, projectIdToDisconnect)=>{
        if (connectedProjects) {
            const connectedProjectsWithoutDisconnectedProject = connectedProjects.filter((project)=>project.id !== projectIdToDisconnect);
            const lastConnectedProject = (0, ($parcel$interopDefault($hYfgW)))(connectedProjectsWithoutDisconnectedProject);
            if (lastConnectedProject) return {
                id: lastConnectedProject.id,
                resourceId: lastConnectedProject.resourceId,
                name: lastConnectedProject.name,
                avatarUrl: lastConnectedProject.avatarUrl
            };
        }
    };
});
parcelRegister("7Q0EF", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$da3a883fa11c8da8$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $egmQO;
    var $hE5wF;
    var $5YBrl;
    var $kRkJF;
    var $jlq4V;
    var $jJZqs;
    var $eCBf9;
    var $5fc53;
    var $dAmbh;
    var $koeKL;
    var $DVljb;
    var $5csQm;
    var $19env;
    function $da3a883fa11c8da8$export$fd83eea6ecd2d8fa(query) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, $5uXOq.useCallback)((variables)=>client.query({
                query: query,
                variables: variables,
                errorPolicy: 'all'
            }), [
            client,
            query
        ]);
    }
    const $da3a883fa11c8da8$export$8af2d18142c8506c = ()=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const filtersJQL = (0, (0, parcelRequire("kRkJF")).useFilteredViewJQL)();
        const refetchIssue = $da3a883fa11c8da8$export$fd83eea6ecd2d8fa((0, (0, parcelRequire("5csQm")).ISSUE_REFETCH_QUERY));
        const [createIssue] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("5csQm")).CREATE_ISSUE_MUTATION));
        const createIssueService = (0, $5uXOq.useCallback)(async (createParams)=>{
            const input = (0, (0, parcelRequire("19env")).buildInput)(createParams.input, locale, startDateField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: Array.from(fieldIdsSet)
                },
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, (0, parcelRequire("eCBf9")).MutationError)(firstMutationError);
                }
                throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    issueId: result.itemIdentifiers.issueId,
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        }, [
            createIssue,
            locale,
            startDateField
        ]);
        const refetchIssueService = (0, $5uXOq.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
            const jql = (0, (0, parcelRequire("egmQO")).generateJql)({
                jqlContext: jqlContext,
                quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
                issueIds: [
                    issueId
                ]
            });
            const fieldIdsSet = new Set(fieldIds);
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const fieldIdsToRequest = Array.from(fieldIdsSet);
            const { data: data } = await refetchIssue({
                jql: jql,
                fieldIds: fieldIdsToRequest,
                cloudId: cloudId,
                first: 1
            });
            const viewItems = data?.jira?.jwmViewItems;
            if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
            const issue = viewItems.edges?.[0]?.node;
            return issue ?? null;
        }, [
            cloudId,
            filtersJQL,
            jqlContext,
            refetchIssue
        ]);
        return {
            createIssue: createIssueService,
            refetchIssue: refetchIssueService
        };
    };
});
parcelRegister("egmQO", function(module, exports) {
    $parcel$export(module.exports, "generateJql", ()=>$da4d6eca1d928e18$export$d43e55153d6948c0);
    $parcel$export(module.exports, "getVariables", ()=>$da4d6eca1d928e18$export$a39eddd73bba62c1);
    var $hE5wF;
    var $42GbZ;
    const $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE = (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE);
    const $da4d6eca1d928e18$var$IS_EMPTY = 'IS EMPTY';
    const $da4d6eca1d928e18$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
    const $da4d6eca1d928e18$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
        const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
        const defaultSorting = `ORDER BY Rank ${(0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION)}`;
        const jql = [];
        const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
        const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, (0, parcelRequire("42GbZ")).getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
        if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
        if (jqlContext) jql.push(jqlContext);
        else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
        if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
            if (typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY})`);
        }
        if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
        if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
        if (groupQuery) {
            const { jqlTerm: jqlTerm, value: value } = groupQuery;
            if (!value) jql.push(`${jqlTerm} ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            else jql.push(`${jqlTerm} = ${value}`);
            if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
                if (typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
                else jql.push(`parent ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            }
        }
        if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
        return `${jql.join(' AND ')} ${sortByClause}`;
    };
    const $da4d6eca1d928e18$export$a39eddd73bba62c1 = (input)=>{
        const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
        const singleQueryJql = {
            jql: $da4d6eca1d928e18$export$d43e55153d6948c0(input, parentIssue)
        };
        const newFieldIds = Array.isArray(fieldIds) ? [
            ...fieldIds
        ] : [];
        const remoteIssueLinksIndex = newFieldIds.indexOf((0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE));
        const hasConfluenceLinks = remoteIssueLinksIndex > -1;
        if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
        return {
            ...singleQueryJql,
            first: parentIssue ? $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE : (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE),
            fieldIds: newFieldIds,
            withConfluenceLinks: hasConfluenceLinks,
            includeDoneItems: input.isHidingDoneItems === false,
            isParentFieldVisible: input.isParentFieldVisible ?? false,
            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false
        };
    };
});
const $8debe7dace56daea$export$9355e489ad16f98e = 'TASK';
const $8debe7dace56daea$export$3cb4a99a332e4186 = 'EPIC';
parcelRegister("42GbZ", function(module, exports) {
    $parcel$export(module.exports, "getJqlTerm", ()=>$f8ba3884a7b69792$export$43330b5a5235b231);
    var $6s1PB;
    var $5fc53;
    const $f8ba3884a7b69792$export$43330b5a5235b231 = (fieldId, fieldType)=>{
        if (fieldId.indexOf('customfield_') === 0) {
            const customFieldId = fieldId.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) && (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return 'component';
        return fieldId;
    };
});
parcelRegister("5YBrl", function(module, exports) {
    $parcel$export(module.exports, "JqlProvider", ()=>$81e54c5b62a4ab4d$export$fdc879e2ba0da048);
    $parcel$export(module.exports, "useJqlContext", ()=>$81e54c5b62a4ab4d$export$f32e2f688fc08561);
    var $5uXOq = parcelRequire("5uXOq");
    const $81e54c5b62a4ab4d$var$JqlContext = (0, $5uXOq.createContext)('');
    const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
            value: jqlContext
        }, children);
    const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);
});
parcelRegister("kRkJF", function(module, exports) {
    $parcel$export(module.exports, "useFilteredViewJQL", ()=>$6b3238559c925b96$export$a50cc7c1087f7d9b);
    $parcel$export(module.exports, "useFilteredViewContextInput", ()=>$6b3238559c925b96$export$d566b5d8a729afa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $4R6GH;
    var $5fc53;
    var $2UUq6;
    var $17ot5;
    var $l4Ejo;
    var $1T1ir;
    var $7VpiX;
    const $6b3238559c925b96$export$a50cc7c1087f7d9b = ()=>{
        const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlSanitised = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).sanitiseJql)(jql), [
            jql
        ]);
        const filtersJQL = (0, $5uXOq.useMemo)(()=>{
            if (isHidingDoneItems) {
                const filtersJql = [
                    jqlSanitised,
                    "StatusCategory != 'Complete'"
                ].filter(Boolean).join(' AND ');
                return addSimpleSearchToJQL(filtersJql);
            }
            return addSimpleSearchToJQL(jqlSanitised || null);
        }, [
            jqlSanitised,
            addSimpleSearchToJQL,
            isHidingDoneItems
        ]);
        return filtersJQL;
    };
    const $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
    const $6b3238559c925b96$export$d566b5d8a729afa0 = ({ view: view })=>{
        const filtersJQL = $6b3238559c925b96$export$a50cc7c1087f7d9b();
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const [sortingBy] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const isFiltering = jql != null || isSearching;
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
        const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).getJqlErrors)(jql), [
            jql
        ]);
        const sorting = (0, $5uXOq.useMemo)(()=>{
            if (sortingBy.sortBy === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return {
                ...sortingBy,
                sortBy: $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL
            };
            return sortingBy;
        }, [
            sortingBy
        ]);
        return {
            jqlContext: jqlContext,
            quickFiltersJql: filtersJQL,
            sorting: sorting,
            isFiltering: isFiltering,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            jqlErrors: jqlErrors
        };
    };
});
parcelRegister("2UUq6", function(module, exports) {
    $parcel$export(module.exports, "useSorting", ()=>$46c72127586d4f92$export$21ebc1ba2b2bee67);
    $parcel$export(module.exports, "useSorter", ()=>$46c72127586d4f92$export$f161a6f9d84a6fea);
    var $5uXOq = parcelRequire("5uXOq");
    var $ftuRD;
    var $1T2vX;
    var $x8FYU;
    var $1kpI8;
    var $8841m;
    var $h1cpf;
    var $8Yjb2;
    const $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE = {};
    const $46c72127586d4f92$export$21ebc1ba2b2bee67 = ()=>{
        const [sorting, setSorting] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).SORTING_PREFERENCE));
        return [
            sorting || $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE,
            setSorting
        ];
    };
    const $46c72127586d4f92$var$emptyArray = [];
    const $46c72127586d4f92$export$f161a6f9d84a6fea = ()=>{
        const [sorting] = $46c72127586d4f92$export$21ebc1ba2b2bee67();
        const [sortingFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: sorting.sortBy
        });
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: data } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
        const { statuses: statuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const priorities = priorityFieldConfig?.options || $46c72127586d4f92$var$emptyArray;
        const sortFunction = (0, $5uXOq.useCallback)((issues)=>{
            const getPrioritiesSortedList = ()=>[
                    ...priorities
                ].reverse().reduce((acc, next, index)=>{
                    acc[next.priorityId] = index;
                    return acc;
                }, {});
            const getIssueTypesSortedList = ()=>[
                    ...data.issueTypes
                ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const getStatusSortOrder = (key)=>{
                if (key in (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)) return (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)[key];
                return -1;
            };
            const getStatusesSortedList = ()=>[
                    ...statuses
                ].sort((a, b)=>{
                    const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                    if (orderComparison !== 0) return orderComparison;
                    return a.name.localeCompare(b.name);
                }).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const sortedLists = {
                priorities: getPrioritiesSortedList(),
                issueTypes: getIssueTypesSortedList(),
                statuses: getStatusesSortedList()
            };
            const { getters: getters, orders: orders } = (0, (0, parcelRequire("8Yjb2")).createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
            return (0, (0, parcelRequire("8Yjb2")).sortListBy)(issues, getters, orders);
        }, [
            sorting,
            sortingFieldConfigFieldType,
            priorities,
            data.issueTypes,
            statuses
        ]);
        return {
            sort: sortFunction
        };
    };
});
parcelRegister("ftuRD", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypeFieldConfig", ()=>$66b06940d67822ac$export$42e875bfb69ded2);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $1T2vX;
    const $66b06940d67822ac$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                [screen]: {
                    ...(0, ($parcel$interopDefault($9XE6b)))(getState(), [
                        screen
                    ], {}),
                    [issueTypeId]: configs
                }
            });
        };
    const $66b06940d67822ac$var$actions = {
        merge: $66b06940d67822ac$var$merge
    };
    const $66b06940d67822ac$export$cbf0f7fe9ca42a65 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $66b06940d67822ac$var$actions,
        name: 'issueTypeFieldConfig'
    });
    const $66b06940d67822ac$var$getIssueTypeFieldConfigSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
        if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
        return (0, ($parcel$interopDefault($9XE6b)))(state, [
            screen,
            issueTypeId,
            fieldId
        ], null);
    });
    const $66b06940d67822ac$export$47647eb426e85a25 = (0, (0, parcelRequire("3sQ5x")).createHook)($66b06940d67822ac$export$cbf0f7fe9ca42a65, {
        selector: $66b06940d67822ac$var$getIssueTypeFieldConfigSelector
    });
    const $66b06940d67822ac$export$42e875bfb69ded2 = (props)=>{
        const [state, fieldsConfigActions] = $66b06940d67822ac$export$47647eb426e85a25(props);
        const screen = props?.screen || 'VIEW';
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: screen
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (state != null) return [
                state,
                fieldsConfigActions,
                {
                    loading: false,
                    error: undefined
                }
            ];
            if (loading === false && (0, ($parcel$interopDefault($9XE6b)))(data, [
                'issueTypes'
            ], []).length > 0) data.issueTypes.forEach((issueType)=>{
                const config = {};
                data.fields.forEach((field)=>{
                    if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                        ...field.fieldConfig,
                        fieldType: field.type
                    };
                });
                fieldsConfigActions.merge(screen, issueType.id, config);
                if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
            });
            return [
                state,
                fieldsConfigActions,
                {
                    loading: loading,
                    error: error
                }
            ];
        }, [
            data,
            error,
            fieldsConfigActions,
            loading,
            screen,
            state
        ]);
    };
});
parcelRegister("x8FYU", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", ()=>$3a8fd327ed3934d4$export$5d3f940b56d7af28);
    $parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$8019dfa5a44f6d46);
    $parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$3ef984a9f784490f);
    $parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", ()=>$3a8fd327ed3934d4$export$2df4c3d44dcb1e5b);
    $parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", ()=>$3a8fd327ed3934d4$export$638c3932e4cbdede);
    $parcel$export(module.exports, "FIELDS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$e3ddfc509464e305);
    $parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ffcb5603c64e12d0);
    $parcel$export(module.exports, "FILTER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f50d5db589fb1475);
    $parcel$export(module.exports, "GROUPING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ac8a4771da7f03af);
    $parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$4aace169721c2927);
    $parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$983f0d3325e2938);
    $parcel$export(module.exports, "RANGE_MODE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f43988a3762bf711);
    $parcel$export(module.exports, "SORTING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$373eea1341dcff74);
    $parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$4ec60be96e9eadc0);
    $parcel$export(module.exports, "LIST_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$43fc1ec27b2f1801);
    $parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$14e2a519a8c2881a);
    $parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$8443f3f4fd94276);
    $parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$2e2923d9c9daba20);
    var $hE5wF;
    var $54zCO;
    const $3a8fd327ed3934d4$export$5d3f940b56d7af28 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('activeWorkflow');
    const $3a8fd327ed3934d4$export$8019dfa5a44f6d46 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('collapsedColumns');
    const $3a8fd327ed3934d4$export$3ef984a9f784490f = (0, (0, parcelRequire("54zCO")).createSimplePreference)('columnOrder');
    const $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b = (0, (0, parcelRequire("54zCO")).createSimplePreference)('createType');
    const $3a8fd327ed3934d4$export$638c3932e4cbdede = (0, (0, parcelRequire("54zCO")).createSimplePreference)('expandedIssues');
    const $3a8fd327ed3934d4$export$e3ddfc509464e305 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fields');
    const $3a8fd327ed3934d4$export$ffcb5603c64e12d0 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fieldsDetail');
    const $3a8fd327ed3934d4$export$f50d5db589fb1475 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
    const $3a8fd327ed3934d4$export$ac8a4771da7f03af = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('groupBy');
    const $3a8fd327ed3934d4$export$4aace169721c2927 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideDone');
    const $3a8fd327ed3934d4$export$983f0d3325e2938 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideSoftwareRelease');
    const $3a8fd327ed3934d4$export$f43988a3762bf711 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('rangeMode');
    const $3a8fd327ed3934d4$export$373eea1341dcff74 = {
        ...(0, (0, parcelRequire("54zCO")).createSimplePreference)('sorting'),
        queryParameter: {
            serialize: (value)=>({
                    sortBy: value?.sortBy,
                    direction: value?.direction
                }),
            deserialize: (value)=>value.sortBy ? {
                    sortBy: value.sortBy,
                    direction: value.direction
                } : undefined
        }
    };
    const $3a8fd327ed3934d4$export$4ec60be96e9eadc0 = [
        $3a8fd327ed3934d4$export$5d3f940b56d7af28,
        $3a8fd327ed3934d4$export$8019dfa5a44f6d46,
        $3a8fd327ed3934d4$export$3ef984a9f784490f,
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$638c3932e4cbdede,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af
    ];
    const $3a8fd327ed3934d4$export$43fc1ec27b2f1801 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$ffcb5603c64e12d0,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$373eea1341dcff74
    ];
    const $3a8fd327ed3934d4$export$14e2a519a8c2881a = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$983f0d3325e2938
    ];
    const $3a8fd327ed3934d4$export$8443f3f4fd94276 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$f43988a3762bf711
    ];
    const $3a8fd327ed3934d4$export$2e2923d9c9daba20 = [
        $3a8fd327ed3934d4$export$f50d5db589fb1475
    ];
});
parcelRegister("54zCO", function(module, exports) {
    $parcel$export(module.exports, "createSimplePreference", ()=>$7a26b5020c269cbd$export$464a71be397e5f3d);
    $parcel$export(module.exports, "createSimpleUrlPreference", ()=>$7a26b5020c269cbd$export$78f3983105936d30);
    var $etyzk = parcelRequire("etyzk");
    const $7a26b5020c269cbd$export$464a71be397e5f3d = (id)=>({
            id: id,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk)))
        });
    const $7a26b5020c269cbd$export$78f3983105936d30 = (queryParameter)=>({
            id: queryParameter,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk))),
            queryParameter: {
                serialize: (value)=>({
                        [queryParameter]: value
                    }),
                deserialize: (value)=>value[queryParameter]
            }
        });
});
parcelRegister("1kpI8", function(module, exports) {
    $parcel$export(module.exports, "ViewPreferencesProvider", ()=>$5141bcd6fd206946$export$1db44e21d818b27);
    $parcel$export(module.exports, "useViewPreference", ()=>$5141bcd6fd206946$export$ee494de6c0ff45d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $1XJ20;
    var $doZTA;
    var $kGDhO;
    const $5141bcd6fd206946$var$ViewPreferencesContext = (0, $5uXOq.createContext)(null);
    const $5141bcd6fd206946$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const [{ query: query }, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { updateQueryParam: updateQueryParam } = routerActions;
        const prevQuery = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(query);
        const [store, setStore] = (0, $5uXOq.useState)(()=>preferences.reduce((acc, preference)=>{
                let value;
                const { id: id, queryParameter: queryParameter } = preference;
                const queryValue = queryParameter && queryParameter.deserialize(query);
                if (queryValue) value = queryValue;
                else if (persistChanges) value = preference.deserialize((0, (0, parcelRequire("kGDhO")).getPreference)(entity.id, view, preference.id));
                acc[id] = value;
                return acc;
            }, {}));
        const setPreferenceValue = (0, $5uXOq.useCallback)((preference, value, action)=>{
            setStore((prevStore)=>{
                const newStore = {
                    ...prevStore,
                    [preference.id]: value
                };
                return newStore;
            });
            if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
            if (persistChanges) {
                const serializedValue = preference.serialize(value);
                (0, (0, parcelRequire("kGDhO")).setPreference)(entity.id, view, preference.id, serializedValue);
            }
        }, [
            persistChanges,
            updateQueryParam,
            entity.id,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!persistChanges) return;
            let restoredQuery = {};
            for (const preference of preferences){
                const value = store[preference.id];
                if (value && preference.queryParameter) restoredQuery = {
                    ...restoredQuery,
                    ...preference.queryParameter.serialize(value)
                };
            }
            updateQueryParam({
                ...restoredQuery,
                ...query
            }, 'replace');
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(prevQuery, query)) {
                const newState = preferences.reduce((acc, preference)=>{
                    const { id: id, queryParameter: queryParameter } = preference;
                    if (queryParameter) {
                        const queryValue = queryParameter.deserialize(query);
                        acc[id] = queryValue;
                    }
                    return acc;
                }, {});
                setStore({
                    ...store,
                    ...newState
                });
            }
        }, [
            preferences,
            query,
            store,
            entity.id,
            view,
            prevQuery
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                store: store,
                setPreferenceValue: setPreferenceValue
            }), [
            store,
            setPreferenceValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5141bcd6fd206946$var$ViewPreferencesContext.Provider, {
            value: contextValue
        }, children);
    };
    const $5141bcd6fd206946$export$ee494de6c0ff45d7 = (preference)=>{
        const { store: store, setPreferenceValue: setPreferenceValue } = (0, $5uXOq.useContext)($5141bcd6fd206946$var$ViewPreferencesContext);
        const setValue = (0, $5uXOq.useCallback)((value, action = 'push')=>{
            setPreferenceValue(preference, value, action);
        }, [
            preference,
            setPreferenceValue
        ]);
        const value = store[preference.id];
        return [
            value,
            setValue
        ];
    };
});
parcelRegister("54qG5", function(module, exports) {
    $parcel$export(module.exports, "BusinessEntityProvider", ()=>$a71d927d8f07dfcc$export$c800e064c3c327ef);
    $parcel$export(module.exports, "useBusinessEntity", ()=>$a71d927d8f07dfcc$export$ff2574b00bc1c100);
    var $5uXOq = parcelRequire("5uXOq");
    const $a71d927d8f07dfcc$var$BusinessEntityContext = (0, $5uXOq.createContext)(null);
    const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
            value: data
        }, children);
    const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
        const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
        return {
            data: entity
        };
    };
});
parcelRegister("kGDhO", function(module, exports) {
    $parcel$export(module.exports, "setPreference", ()=>$39001b1dd806b76a$export$c6483f3cdc3e51e1);
    $parcel$export(module.exports, "getPreference", ()=>$39001b1dd806b76a$export$5fa261395d19a143);
    var $bSSG7;
    const $39001b1dd806b76a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jwm-view-preferences');
    const $39001b1dd806b76a$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
    const $39001b1dd806b76a$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        $39001b1dd806b76a$var$store.set(key, value);
    };
    const $39001b1dd806b76a$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        return $39001b1dd806b76a$var$store.get(key);
    };
});
parcelRegister("8841m", function(module, exports) {
    $parcel$export(module.exports, "useProjectStatuses", ()=>$f2e77b2d189a9e48$export$11ff6a520db76faf);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qDUb = parcelRequire("7qDUb");
    var $3JOCw = parcelRequire("3JOCw");
    var $daQYX;
    var $dJl1T;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $f2e77b2d189a9e48$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
    const $f2e77b2d189a9e48$var$MAX_RETRIES = 3;
    const $f2e77b2d189a9e48$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
                [projectKey]: statuses
            });
    const $f2e77b2d189a9e48$var$actions = {
        set: $f2e77b2d189a9e48$var$set
    };
    const $f2e77b2d189a9e48$var$ProjectStatusesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $f2e77b2d189a9e48$var$actions,
        name: 'projectStatuses'
    });
    const $f2e77b2d189a9e48$var$getProjectStatusesSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
        if (projectKey === undefined || state[projectKey] == null) return [];
        return state[projectKey];
    });
    const $f2e77b2d189a9e48$export$482f388228eef22c = (0, (0, parcelRequire("3sQ5x")).createHook)($f2e77b2d189a9e48$var$ProjectStatusesStore, {
        selector: $f2e77b2d189a9e48$var$getProjectStatusesSelector
    });
    const $f2e77b2d189a9e48$var$emptyArray = [];
    const $f2e77b2d189a9e48$export$11ff6a520db76faf = ()=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [hasLoaded, setHasLoaded] = (0, $5uXOq.useState)(false);
        const [retriesCount, setRetriesCount] = (0, $5uXOq.useState)(0);
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const [statuses, statusActions] = $f2e77b2d189a9e48$export$482f388228eef22c({
            projectKey: projectKey
        });
        const retry = ()=>{
            setRetriesCount(retriesCount + 1);
            setIsLoading(false);
            setHasLoaded(false);
        };
        if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
            statuses: statuses,
            loading: isLoading
        };
        if (!isLoading && !hasLoaded) {
            fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
                const allStatuses = issueTypes.reduce((acc, next)=>acc.concat(next.statuses), []);
                const dedupedResults = (0, ($parcel$interopDefault($3JOCw)))(allStatuses, 'id');
                return (0, ($parcel$interopDefault($7qDUb)))(dedupedResults, [
                    'name'
                ]);
            }).then((uniqueStatuses)=>{
                statusActions.set(projectKey, uniqueStatuses);
                setIsLoading(false);
                setHasLoaded(true);
            }).catch(()=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f2e77b2d189a9e48$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
                if (retriesCount < $f2e77b2d189a9e48$var$MAX_RETRIES) retry();
            });
            setIsLoading(true);
        }
        return {
            statuses: $f2e77b2d189a9e48$var$emptyArray,
            loading: isLoading
        };
    };
});
parcelRegister("h1cpf", function(module, exports) {
    $parcel$export(module.exports, "STATUS_SORT_ORDER", ()=>$20cadc5cf5f0437c$export$de9c103e53e690d1);
    const $20cadc5cf5f0437c$export$de9c103e53e690d1 = {
        new: 1,
        indeterminate: 2,
        done: 3
    };
});
parcelRegister("8Yjb2", function(module, exports) {
    $parcel$export(module.exports, "sortListBy", ()=>$9b7a6804aae1eb73$export$3793ed28be8699ad);
    $parcel$export(module.exports, "createSortingGettersAndOrders", ()=>$9b7a6804aae1eb73$export$b3fdfcb601c683c3);
    var $1AkQu = parcelRequire("1AkQu");
    var $hE5wF;
    var $ijSZT;
    var $fCkUD;
    var $57lFd;
    var $gULOk;
    var $co1wz;
    var $4R6GH;
    var $5fc53;
    var $ixx6N;
    const $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
    const $9b7a6804aae1eb73$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
    const $9b7a6804aae1eb73$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, ($parcel$interopDefault($1AkQu)))(nodes, getters, orders.map($9b7a6804aae1eb73$var$toAcceptedOrder));
    const $9b7a6804aae1eb73$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, getMapValueCb)=>{
        const fieldValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
        return fieldValue.map(getMapValueCb).join(' ') || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$resolvePriorityOrder = (fields, priorities)=>{
        const priorityId = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'value.priorityId', '') : (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'priorityId', '');
        const priorityOrder = priorities[priorityId];
        if (priorityOrder == null) return -1;
        return priorityOrder;
    };
    const $9b7a6804aae1eb73$var$resolveStatusOrder = (fields, statuses)=>{
        const statusName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'name', '');
        const statusOrder = statuses[statusName];
        if (statusOrder == null) return -1;
        return statusOrder;
    };
    const $9b7a6804aae1eb73$var$resolveTypeOrder = (fields, types)=>{
        const typeName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'value', '');
        const typeOrder = types[typeName];
        if (typeOrder == null) return -1;
        return typeOrder;
    };
    const $9b7a6804aae1eb73$var$resolveIssueKeyOrder = (fields)=>{
        const [, issueKeyNumber = 0] = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuekey', 'value', '').split('-');
        return Number(issueKeyNumber);
    };
    const $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
        const value = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', null);
        return value != null ? value.toLowerCase() : $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
            const { rank: rank, fields: fields = [] } = node;
            if (fieldType != null && (0, (0, parcelRequire("ijSZT")).isSortingSupportedFieldTypePredicated)(fieldType) && (0, (0, parcelRequire("ijSZT")).isSortingSupported)(fieldType) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                const field = (0, (0, parcelRequire("57lFd")).getFieldValue)(fields, sortingField);
                if ((0, (0, parcelRequire("fCkUD")).isNewTransformedFieldPredicated)(field)) return (0, (0, parcelRequire("ijSZT")).getSorting)(fieldType, field) || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
            }
            switch(fieldType){
                case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [
                        ''
                    ], (label)=>label.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return $9b7a6804aae1eb73$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
                case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                    return $9b7a6804aae1eb73$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                    return $9b7a6804aae1eb73$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 'issuekey':
                    return $9b7a6804aae1eb73$var$resolveIssueKeyOrder(fields);
                case 0, (0, parcelRequire("5fc53")).CREATED:
                case 0, (0, parcelRequire("5fc53")).UPDATED:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '');
                case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID:
                    if ((0, (0, parcelRequire("co1wz")).ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                        if ((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, (0, parcelRequire("ixx6N")).resolveRank)((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                    } else return (0, (0, parcelRequire("ixx6N")).resolveRank)((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                    return rank ?? '';
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
                case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
                    return $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder(fields, sortingField);
                case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.timeInSeconds', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).URL_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    {
                        const sprintValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                        if (Array.isArray(sprintValue) && sprintValue.length) {
                            const { name: name, state: state } = sprintValue[0];
                            if (state === 'CLOSED') {
                                const statusId = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'value', '');
                                if (statusId?.toString() !== (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE].toString()) return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                            }
                            return name.toLowerCase();
                        }
                        return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                    }
                default:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), 'value', '');
            }
        };
    const $9b7a6804aae1eb73$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
        const getters = [];
        const orders = [];
        let sortFieldType = fieldType;
        if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
        if (sorting != null && sorting.sortBy != null) {
            orders.push(sorting.direction, sorting.direction);
            getters.push($9b7a6804aae1eb73$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        } else {
            orders.push((0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        }
        return {
            getters: getters,
            orders: orders
        };
    };
});
parcelRegister("1AkQu", function(module, exports) {
    var $kE90z = parcelRequire("kE90z");
    var $8LQ84 = parcelRequire("8LQ84");
    function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
        if (collection == null) return [];
        if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
            iteratees
        ];
        orders = guard ? undefined : orders;
        if (!$8LQ84(orders)) orders = orders == null ? [] : [
            orders
        ];
        return $kE90z(collection, iteratees, orders);
    }
    module.exports = $127952ba7d4c15a6$var$orderBy;
});
parcelRegister("ijSZT", function(module, exports) {
    $parcel$export(module.exports, "getSorting", ()=>$426da0baa4d91e21$export$654dceec98f3061f);
    $parcel$export(module.exports, "isSortingSupported", ()=>$426da0baa4d91e21$export$c6c6084d02f37d7e);
    $parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", ()=>$426da0baa4d91e21$export$190ed2ad153b150b);
    $parcel$export(module.exports, "getSortingDisabledFields", ()=>$426da0baa4d91e21$export$56c924491e5617ad);
    var $8QpSo;
    var $1OjAh;
    var $5nNdw;
    var $cBFqc;
    var $coSD0;
    var $55FhM;
    var $gjQcQ;
    var $4CML6;
    var $WhnfX;
    var $aK7yP;
    var $7LNXH;
    var $dtcdd;
    const $426da0baa4d91e21$var$createSortingHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("55FhM")).parentSortingHandler),
            ...(0, (0, parcelRequire("dtcdd")).versionSortingHandler),
            ...(0, (0, parcelRequire("WhnfX")).resolutionSortingHandler),
            ...(0, (0, parcelRequire("coSD0")).groupSortingHandler),
            ...(0, (0, parcelRequire("4CML6")).radioSelectSortingHandler),
            ...(0, (0, parcelRequire("1OjAh")).cascadingSelectSortingHandler),
            ...(0, (0, parcelRequire("gjQcQ")).projectSortingHandler)
        }));
    const $426da0baa4d91e21$export$654dceec98f3061f = (fieldType, ...args)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        if (handlers[fieldType] == null) return;
        return handlers[fieldType]?.(...args);
    };
    const $426da0baa4d91e21$export$c6c6084d02f37d7e = (fieldType)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        return handlers[fieldType] != null;
    };
    const $426da0baa4d91e21$export$190ed2ad153b150b = (fieldType)=>true;
    const $426da0baa4d91e21$export$56c924491e5617ad = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("5nNdw")).devSummaryDisabledSorting),
            ...(0, (0, parcelRequire("7LNXH")).teamDisabledSorting),
            ...(0, (0, parcelRequire("aK7yP")).statusCategoryDisabledSorting),
            ...(0, (0, parcelRequire("cBFqc")).goalsDisabledSorting)
        }));
});
parcelRegister("1OjAh", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectSortingHandler", ()=>$1924a50c91a471c7$export$7b0bfc6838ff3257);
    var $5fc53;
    var $jKNTt;
    const $1924a50c91a471c7$var$getCascadingSelectSorting = (field)=>(0, (0, parcelRequire("jKNTt")).getCascadingSelectStringValue)(field.value);
    const $1924a50c91a471c7$export$7b0bfc6838ff3257 = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $1924a50c91a471c7$var$getCascadingSelectSorting
    };
});
parcelRegister("jKNTt", function(module, exports) {
    $parcel$export(module.exports, "getCascadingSelectStringValue", ()=>$c7661401b6222cfb$export$f110a74eb752aa7e);
    $parcel$export(module.exports, "cascadingSelectStringValueHandler", ()=>$c7661401b6222cfb$export$f39c163ada81742a);
    $parcel$export(module.exports, "cascadingSelectRichValueHandler", ()=>$c7661401b6222cfb$export$af92c160980c340f);
    var $5fc53;
    const $c7661401b6222cfb$export$f110a74eb752aa7e = (fieldValue)=>{
        if (fieldValue && fieldValue.parentOptionValue) {
            if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
            return `${fieldValue.parentOptionValue.value}`;
        }
        return '';
    };
    const $c7661401b6222cfb$var$getCascadingSelectValue = (field)=>$c7661401b6222cfb$export$f110a74eb752aa7e(field.value);
    const $c7661401b6222cfb$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
    const $c7661401b6222cfb$export$f39c163ada81742a = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectValue
    };
    const $c7661401b6222cfb$export$af92c160980c340f = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectRichValue
    };
});
parcelRegister("5nNdw", function(module, exports) {
    $parcel$export(module.exports, "devSummaryDisabledSorting", ()=>$8d45926c3e16e57e$export$8cf683615a3ccf77);
    var $5fc53;
    const $8d45926c3e16e57e$export$8cf683615a3ccf77 = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: false
    };
});
parcelRegister("cBFqc", function(module, exports) {
    $parcel$export(module.exports, "goalsDisabledSorting", ()=>$c7872d24a62cd4a6$export$60ff70c996f5c362);
    var $5fc53;
    const $c7872d24a62cd4a6$export$60ff70c996f5c362 = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: false
    };
});
parcelRegister("coSD0", function(module, exports) {
    $parcel$export(module.exports, "groupSortingHandler", ()=>$a9d8ecbf0dcf5f2d$export$a577fd60fa30451d);
    var $5fc53;
    const $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
    const $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting
    };
});
parcelRegister("55FhM", function(module, exports) {
    $parcel$export(module.exports, "parentSortingHandler", ()=>$a7f27eceaa949fb5$export$20dbdacc158507c9);
    var $5fc53;
    const $a7f27eceaa949fb5$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
    const $a7f27eceaa949fb5$export$20dbdacc158507c9 = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $a7f27eceaa949fb5$var$getParentSorting
    };
});
parcelRegister("gjQcQ", function(module, exports) {
    $parcel$export(module.exports, "projectSortingHandler", ()=>$a97b41f281e121d8$export$18c888fa7805bbf9);
    var $5fc53;
    const $a97b41f281e121d8$var$getProjectSorting = (field)=>field.value?.name ?? '';
    const $a97b41f281e121d8$export$18c888fa7805bbf9 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $a97b41f281e121d8$var$getProjectSorting
    };
});
parcelRegister("4CML6", function(module, exports) {
    $parcel$export(module.exports, "radioSelectSortingHandler", ()=>$0a650a9e38d8f12d$export$d622730346571a2b);
    var $5fc53;
    const $0a650a9e38d8f12d$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
    const $0a650a9e38d8f12d$export$d622730346571a2b = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $0a650a9e38d8f12d$var$getRadioSelectSorting
    };
});
parcelRegister("WhnfX", function(module, exports) {
    $parcel$export(module.exports, "resolutionSortingHandler", ()=>$5149dcabcac386a7$export$596a643f093db9a7);
    var $5fc53;
    const $5149dcabcac386a7$var$getResolutionSorting = (field)=>field.value?.name ?? '';
    const $5149dcabcac386a7$export$596a643f093db9a7 = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: $5149dcabcac386a7$var$getResolutionSorting
    };
});
parcelRegister("aK7yP", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryDisabledSorting", ()=>$a8138d3f5e843f75$export$117cb43589655b27);
    var $5fc53;
    const $a8138d3f5e843f75$export$117cb43589655b27 = {
        [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: false
    };
});
parcelRegister("7LNXH", function(module, exports) {
    $parcel$export(module.exports, "teamDisabledSorting", ()=>$f566370ab4491013$export$1626c947db580b0f);
    var $5fc53;
    const $f566370ab4491013$export$1626c947db580b0f = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: false
    };
});
parcelRegister("dtcdd", function(module, exports) {
    $parcel$export(module.exports, "versionSortingHandler", ()=>$b3c9429c32861e4c$export$f2894a637a250eaa);
    var $5fc53;
    const $b3c9429c32861e4c$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
    const $b3c9429c32861e4c$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $b3c9429c32861e4c$export$f2894a637a250eaa = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getSingleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting
    };
});
parcelRegister("fCkUD", function(module, exports) {
    $parcel$export(module.exports, "isNewTransformedFieldPredicated", ()=>$fb9b3f13d18b237f$export$b018c2b58ea7e0de);
    const $fb9b3f13d18b237f$export$b018c2b58ea7e0de = (field)=>field != null;
});
parcelRegister("57lFd", function(module, exports) {
    $parcel$export(module.exports, "getFieldValue", ()=>$9c93e114366691a0$export$2e85048acc9aea83);
    $parcel$export(module.exports, "safeGetValue", ()=>$9c93e114366691a0$export$f17a5eaf5fe57cff);
    $parcel$export(module.exports, "safeGetTransformedFieldValue", ()=>$9c93e114366691a0$export$16456470899ab77f);
    $parcel$export(module.exports, "safeGetTransformedValue", ()=>$9c93e114366691a0$export$c1cc7bc9b4953394);
    var $9XE6b = parcelRequire("9XE6b");
    const $9c93e114366691a0$export$2e85048acc9aea83 = (fields, fieldKey)=>{
        if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
        return undefined;
    };
    const $9c93e114366691a0$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return (0, ($parcel$interopDefault($9XE6b)))(field, attributeName, defaultValue);
    };
    const $9c93e114366691a0$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return $9c93e114366691a0$export$c1cc7bc9b4953394(field, defaultValue);
    };
    const $9c93e114366691a0$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, ($parcel$interopDefault($9XE6b)))(field, 'value', defaultValue);
});
parcelRegister("ixx6N", function(module, exports) {
    $parcel$export(module.exports, "resolveRank", ()=>$0a08bd66273f9a8c$export$992090b26f7c7f11);
    const $0a08bd66273f9a8c$export$992090b26f7c7f11 = (parentIssue, rank)=>{
        const parentRank = parentIssue?.rank ?? '';
        return parentRank.concat(rank);
    };
});
parcelRegister("17ot5", function(module, exports) {
    $parcel$export(module.exports, "useHideDoneItems", ()=>$f683983c23bf92d0$export$c2cb7b17819b92d4);
    $parcel$export(module.exports, "useInferHideDoneItemsWithFilters", ()=>$f683983c23bf92d0$export$a14bc8305f71e469);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $gULOk;
    var $dpQnO;
    const $f683983c23bf92d0$export$c2cb7b17819b92d4 = ()=>{
        const [hideDoneItems, persistHideDoneItems] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).HIDE_DONE_ITEMS_PREFERENCE));
        const setHideDoneItems = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
            persistHideDoneItems
        ]);
        return [
            hideDoneItems === 'true',
            setHideDoneItems
        ];
    };
    const $f683983c23bf92d0$export$a14bc8305f71e469 = ({ filters: filters })=>{
        const [hideDoneItems, setHideDoneItems] = $f683983c23bf92d0$export$c2cb7b17819b92d4();
        const { quickFilters: quickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (hideDoneItems) {
                const isFilteringByDoneStatus = (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE]);
                if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
            }
        }, [
            filters,
            quickFilters?.DONE
        ]);
    };
});
parcelRegister("dpQnO", function(module, exports) {
    $parcel$export(module.exports, "useQuickFilters", ()=>$59496077a2cce3b6$export$3dae1bb95b659fd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $5fc53;
    var $g4ZHz;
    const $59496077a2cce3b6$var$quickFilterToJQLMapOld = {
        ASSIGNED_TO_ME: 'assignee = currentUser()',
        DONE: "StatusCategory = 'Complete'",
        DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
    };
    const $59496077a2cce3b6$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
        if (sprintJQLTerm == null) return $59496077a2cce3b6$var$quickFilterToJQLMapOld;
        return {
            ...$59496077a2cce3b6$var$quickFilterToJQLMapOld,
            ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
        };
    };
    const $59496077a2cce3b6$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const jqlClauses = Object.entries(quickFilters).map(([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
        const enabledFilters = jqlClauses.filter((jql)=>jql);
        return enabledFilters.join(' AND ') || null;
    };
    const $59496077a2cce3b6$export$9294471da4d3c33f = {
        ASSIGNED_TO_ME: false,
        DONE: false,
        DUE_THIS_WEEK: false,
        ACTIVE_SPRINTS: false
    };
    const $59496077a2cce3b6$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const quickFilters = {
            ...$59496077a2cce3b6$export$9294471da4d3c33f
        };
        if (!jql) return quickFilters;
        if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
        if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
        if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
        if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
        return quickFilters;
    };
    const $59496077a2cce3b6$var$useSprintFieldJQLTerm = ()=>{
        const { data: fields } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        return (0, $5uXOq.useMemo)(()=>{
            if (fields == null) return undefined;
            const sprintField = fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE));
            return sprintField != null ? sprintField.jqlTerm : undefined;
        }, [
            fields
        ]);
    };
    const $59496077a2cce3b6$export$3dae1bb95b659fd4 = ()=>{
        const sprintFieldJQLTerm = $59496077a2cce3b6$var$useSprintFieldJQLTerm();
        const quickFilterToJQLMap = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$808f76242d61e1a5(sprintFieldJQLTerm), [
            sprintFieldJQLTerm
        ]);
        const [filters, setFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters)=>{
            if (newQuickFilters) {
                const jql = $59496077a2cce3b6$var$buildJQLFromQuickFilters(newQuickFilters, {
                    quickFilterToJQLMap: quickFilterToJQLMap
                });
                if (jql == null) setFilters(undefined);
                else setFilters(jql);
            } else setFilters(undefined);
        }, [
            quickFilterToJQLMap,
            setFilters
        ]);
        const quickFilters = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$9692fc1a2fd983f5(filters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            }), [
            filters,
            quickFilterToJQLMap
        ]);
        return {
            quickFilters: quickFilters,
            persistQuickFilters: setQuickFilters,
            quickFiltersJql: $59496077a2cce3b6$var$buildJQLFromQuickFilters(quickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            })
        };
    };
});
parcelRegister("l4Ejo", function(module, exports) {
    $parcel$export(module.exports, "useFilters", ()=>$8a462d10017c11b6$export$973ca22476b0e05f);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $1tESh;
    const $8a462d10017c11b6$export$973ca22476b0e05f = ()=>{
        const [jql, saveFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setFilter = (0, $5uXOq.useCallback)((filters)=>{
            const serialisedJql = (0, (0, parcelRequire("1tESh")).serialiseJql)(filters);
            saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
        }, [
            saveFilters
        ]);
        return {
            setFilter: setFilter,
            jql: jql
        };
    };
});
parcelRegister("1tESh", function(module, exports) {
    $parcel$export(module.exports, "serialiseJql", ()=>$1e9d101255159a24$export$e1718e1e441cb0f6);
    $parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", ()=>$1e9d101255159a24$export$9ee6085825c9cbfa);
    var $gccSB = parcelRequire("gccSB");
    var $2nvJN = parcelRequire("2nvJN");
    var $gwejS;
    var $f9ece;
    var $iEIQF;
    var $bzbto;
    var $l0V05;
    var $7htvz;
    const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
    const $1e9d101255159a24$var$EMPTY = 'EMPTY';
    const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
    const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
        if (fieldName.indexOf('customfield_') === 0) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
        return fieldName;
    };
    const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
    const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
    const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
    const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
        const jqlQuery = (0, (0, parcelRequire("iEIQF")).default).query();
        Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
                if (options.value.to != null) {
                    const toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                    jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(toFieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_LT)), (0, (0, parcelRequire("iEIQF")).default).valueOperand(toDate)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                }
                if (options.value.from != null) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS)), (0, (0, parcelRequire("iEIQF")).default).valueOperand(options.value.from)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                return;
            }
            if (Array.isArray(options)) {
                const operands = options.map((option)=>{
                    if (option.isEmptyOption) return (0, (0, parcelRequire("iEIQF")).default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
                    if (option.value) return (0, (0, parcelRequire("iEIQF")).default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                    return null;
                }).filter((operand)=>operand != null);
                if (operands.length === 1) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS)), operands[0]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
                else if (operands.length > 1) jqlQuery.appendClause((0, (0, parcelRequire("iEIQF")).default).terminalClause((0, (0, parcelRequire("iEIQF")).default).field(fieldName), (0, (0, parcelRequire("iEIQF")).default).operator((0, (0, parcelRequire("bzbto")).OPERATOR_IN)), (0, (0, parcelRequire("iEIQF")).default).listOperand(operands)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            }
        });
        const jast = (0, (0, parcelRequire("iEIQF")).default).jast(jqlQuery);
        return (0, (0, parcelRequire("l0V05")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
        const pairs = Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).map(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
                let toDate;
                if (options.value.to) toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                else toDate = options.value.to;
                if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
                if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
                return `${toFieldName} < ${toDate}`;
            }
            if (Array.isArray(options)) {
                const values = options.map((option)=>option.value === (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
                if (options.length > 1) return `${fieldName} in (${values})`;
                if (options.length === 1) return `${fieldName} = ${values}`;
            }
            return null;
        });
        return pairs.join(' AND ');
    };
    const $1e9d101255159a24$var$extractField = (statement)=>{
        let fieldId;
        const dateOperatorRegex = />=|</;
        if (dateOperatorRegex.test(statement)) {
            const operator = statement.includes('>=') ? ' >= ' : ' < ';
            [fieldId] = statement.split(operator);
        }
        if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
        if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
        if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
    };
    const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
        if (!jql) return {};
        return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
            if (curr) acc[curr] = true;
            return acc;
        }, {});
    };
});
parcelRegister("2nvJN", function(module, exports) {
    var $kHBB0 = parcelRequire("kHBB0");
    var $6wH7T = parcelRequire("6wH7T");
    var $gvFfr = parcelRequire("gvFfr");
    var $4TR1Q = parcelRequire("4TR1Q");
    var $c2mKc = parcelRequire("c2mKc");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $jJVtR = parcelRequire("jJVtR");
    function $1bb6592c97235e03$var$trim(string, chars, guard) {
        string = $jJVtR(string);
        if (string && (guard || chars === undefined)) return $6wH7T(string);
        if (!string || !(chars = $kHBB0(chars))) return string;
        var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
        return $gvFfr(strSymbols, start, end).join('');
    }
    module.exports = $1bb6592c97235e03$var$trim;
});
parcelRegister("4TR1Q", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $39156edc40ecb497$var$charsEndIndex;
});
parcelRegister("c2mKc", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $8c37507367fba30b$var$charsStartIndex;
});
const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';
parcelRegister("iEIQF", function(module, exports) {
    $parcel$export(module.exports, "internalCreators", ()=>$76b4580b91797d8b$export$64d991963cfb5532);
    $parcel$export(module.exports, "default", ()=>$76b4580b91797d8b$export$2e2bcd8739ae039);
    var $gzGcl;
    var $awXvh;
    var $3hoxA;
    var $2TUEL;
    var $9TMIk;
    var $23cr9;
    var $an0VC;
    var $kO6UE;
    var $AZ9nU;
    var $9HHq9;
    var $6qN6D;
    var $3J4gf;
    var $her2D;
    var $j37YY;
    var $doe2p;
    var $k9DKN;
    var $jRA9z;
    var $bF1Nb;
    var $bW5aY;
    var $dgZwd;
    var $1zQFd;
    var $eWV0u;
    const $76b4580b91797d8b$export$64d991963cfb5532 = {
        query: (0, (0, parcelRequire("dgZwd")).queryInternal),
        compoundClause: (0, (0, parcelRequire("awXvh")).compoundClauseInternal),
        compoundOperator: (0, (0, parcelRequire("3hoxA")).compoundOperatorInternal),
        terminalClause: (0, (0, parcelRequire("1zQFd")).terminalClauseInternal),
        notClause: (0, (0, parcelRequire("9HHq9")).notClauseInternal),
        notClauseOperator: (0, (0, parcelRequire("6qN6D")).notClauseOperatorInternal),
        predicate: (0, (0, parcelRequire("jRA9z")).predicateInternal),
        predicateOperator: (0, (0, parcelRequire("bF1Nb")).predicateOperatorInternal),
        field: (0, (0, parcelRequire("2TUEL")).fieldInternal),
        property: (0, (0, parcelRequire("bW5aY")).propertyInternal),
        operator: (0, (0, parcelRequire("3J4gf")).operatorInternal),
        valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandInternal),
        keywordOperand: (0, (0, parcelRequire("kO6UE")).keywordOperandInternal),
        functionOperand: (0, (0, parcelRequire("9TMIk")).functionOperandInternal),
        functionString: (0, (0, parcelRequire("23cr9")).functionStringInternal),
        argument: (0, (0, parcelRequire("gzGcl")).argumentInternal),
        listOperand: (0, (0, parcelRequire("AZ9nU")).listOperandInternal),
        orderBy: (0, (0, parcelRequire("her2D")).orderByInternal),
        orderByOperator: (0, (0, parcelRequire("k9DKN")).orderByOperatorInternal),
        orderByField: (0, (0, parcelRequire("doe2p")).orderByFieldInternal),
        orderByDirection: (0, (0, parcelRequire("j37YY")).orderByDirectionInternal)
    };
    var $76b4580b91797d8b$export$2e2bcd8739ae039 = {
        jast: (0, parcelRequire("an0VC")).jast,
        query: (0, parcelRequire("dgZwd")).query,
        compoundClause: (0, parcelRequire("awXvh")).compoundClause,
        compoundOperator: (0, parcelRequire("3hoxA")).compoundOperator,
        terminalClause: (0, parcelRequire("1zQFd")).terminalClause,
        notClause: (0, parcelRequire("9HHq9")).notClause,
        notClauseOperator: (0, parcelRequire("6qN6D")).notClauseOperator,
        predicate: (0, parcelRequire("jRA9z")).predicate,
        predicateOperator: (0, parcelRequire("bF1Nb")).predicateOperator,
        field: (0, parcelRequire("2TUEL")).field,
        property: (0, parcelRequire("bW5aY")).property,
        operator: (0, parcelRequire("3J4gf")).operator,
        valueOperand: (0, parcelRequire("eWV0u")).valueOperand,
        keywordOperand: (0, parcelRequire("kO6UE")).keywordOperand,
        functionOperand: (0, parcelRequire("9TMIk")).functionOperand,
        functionString: (0, parcelRequire("23cr9")).functionString,
        argument: (0, parcelRequire("gzGcl")).argument,
        listOperand: (0, parcelRequire("AZ9nU")).listOperand,
        orderBy: (0, parcelRequire("her2D")).orderBy,
        orderByOperator: (0, parcelRequire("k9DKN")).orderByOperator,
        orderByField: (0, parcelRequire("doe2p")).orderByField,
        orderByDirection: (0, parcelRequire("j37YY")).orderByDirection,
        byText: {
            argument: (0, (0, parcelRequire("gzGcl")).argumentByText),
            valueOperand: (0, (0, parcelRequire("eWV0u")).valueOperandByText)
        }
    };
});
parcelRegister("gzGcl", function(module, exports) {
    $parcel$export(module.exports, "argument", ()=>$1f5307df81a07b07$export$6ea29ee575e3f5ff);
    $parcel$export(module.exports, "argumentInternal", ()=>$1f5307df81a07b07$export$5b341d50fa5bcdd5);
    $parcel$export(module.exports, "argumentByText", ()=>$1f5307df81a07b07$export$84c43d23f51170cb);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $1f5307df81a07b07$var$acceptArgument(visitor) {
        return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
    }
    function $1f5307df81a07b07$var$enterNode(listener) {
        listener.enterArgument && listener.enterArgument(this);
    }
    function $1f5307df81a07b07$var$exitNode(listener) {
        listener.exitArgument && listener.exitArgument(this);
    }
    const $1f5307df81a07b07$export$6ea29ee575e3f5ff = (value)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $1f5307df81a07b07$export$84c43d23f51170cb = (text)=>$1f5307df81a07b07$export$5b341d50fa5bcdd5((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $1f5307df81a07b07$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $1f5307df81a07b07$var$acceptArgument,
            enterNode: $1f5307df81a07b07$var$enterNode,
            exitNode: $1f5307df81a07b07$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("gq4pj", function(module, exports) {
    $parcel$export(module.exports, "normaliseJqlString", ()=>$dd481207f70e9cdd$export$cecf78a779acc0ff);
    const $dd481207f70e9cdd$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$d5efd6512db694fd = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $dd481207f70e9cdd$export$b86601123607fee5 = (maybeQuotedString)=>$dd481207f70e9cdd$export$7a0b99b892e0dda8(maybeQuotedString) || $dd481207f70e9cdd$export$d5efd6512db694fd(maybeQuotedString);
    const $dd481207f70e9cdd$export$cecf78a779acc0ff = (maybeQuotedString)=>{
        if ($dd481207f70e9cdd$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
        if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
        return maybeQuotedString;
    };
});
parcelRegister("2lgiK", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJqlString", ()=>$6e52f9b4063b6286$export$3eb9033c48208278);
    var $8QDwl = parcelRequire("8QDwl");
    const $6e52f9b4063b6286$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, ($parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
    const $6e52f9b4063b6286$export$3eb9033c48208278 = (jqlString)=>{
        if ($6e52f9b4063b6286$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
        return jqlString;
    };
});
parcelRegister("8QDwl", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
    function $6711d60dd8e02df4$var$escapeRegExp(string) {
        string = $jJVtR(string);
        return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
    }
    module.exports = $6711d60dd8e02df4$var$escapeRegExp;
});
parcelRegister("WCvOq", function(module, exports) {
    $parcel$export(module.exports, "noChildren", ()=>$90e2b276351fabc1$export$470bef71e654b804);
    $parcel$export(module.exports, "assignParent", ()=>$90e2b276351fabc1$export$a4685923af2913a);
    const $90e2b276351fabc1$export$470bef71e654b804 = ()=>[];
    const $90e2b276351fabc1$export$a4685923af2913a = (node)=>{
        node.getChildren().forEach((child)=>{
            child.parent = node;
        });
    };
});
parcelRegister("awXvh", function(module, exports) {
    $parcel$export(module.exports, "compoundClause", ()=>$3e337dfb3ad8a3f8$export$ab714e56a32c25f2);
    $parcel$export(module.exports, "compoundClauseInternal", ()=>$3e337dfb3ad8a3f8$export$cd65eed8c10b0911);
    var $3AraL;
    var $WCvOq;
    function $3e337dfb3ad8a3f8$var$acceptCompoundClause(visitor) {
        return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
    }
    function $3e337dfb3ad8a3f8$var$enterNode(listener) {
        listener.enterCompoundClause && listener.enterCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$exitNode(listener) {
        listener.exitCompoundClause && listener.exitCompoundClause(this);
    }
    function $3e337dfb3ad8a3f8$var$getChildren() {
        return [
            this.operator,
            ...this.clauses
        ];
    }
    const $3e337dfb3ad8a3f8$export$ab714e56a32c25f2 = (operator, clauses)=>{
        return $3e337dfb3ad8a3f8$export$cd65eed8c10b0911(operator, clauses);
    };
    const $3e337dfb3ad8a3f8$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b),
            operator: operator,
            clauses: clauses,
            position: position,
            accept: $3e337dfb3ad8a3f8$var$acceptCompoundClause,
            enterNode: $3e337dfb3ad8a3f8$var$enterNode,
            exitNode: $3e337dfb3ad8a3f8$var$exitNode,
            getChildren: $3e337dfb3ad8a3f8$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("3AraL")).appendClause,
            remove: (0, parcelRequire("3AraL")).remove,
            removeClause: (0, parcelRequire("3AraL")).removeClause,
            replace: (0, parcelRequire("3AraL")).replace,
            replaceClause: (0, parcelRequire("3AraL")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';
const $c1dc40b7a30d95e8$export$98dda21ec825792 = 'query';
const $c1dc40b7a30d95e8$export$2d205682cc545947 = 'clause';
const $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d = 'operand';
const $c1dc40b7a30d95e8$export$da0f73edded4a63d = 'order_by';
parcelRegister("3AraL", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function appendClause(clause) {
        let clausesToAppend = [
            clause
        ];
        if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
        this.clauses.push(...clausesToAppend);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        this.clauses = this.clauses.filter((val)=>val !== clause);
        if (this.clauses.length === 1) this.replace(this.clauses[0]);
        else if (this.clauses.length === 0) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        this.clauses = this.clauses.map((child)=>{
            return child === clause ? nextClause : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("3hoxA", function(module, exports) {
    $parcel$export(module.exports, "compoundOperator", ()=>$fe3f499b83b55a64$export$84bb3ebbba491aee);
    $parcel$export(module.exports, "compoundOperatorInternal", ()=>$fe3f499b83b55a64$export$63c33bc3fe74fee6);
    var $WCvOq;
    function $fe3f499b83b55a64$var$acceptCompoundOperator(visitor) {
        return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
    }
    function $fe3f499b83b55a64$var$enterNode(listener) {
        listener.enterCompoundOperator && listener.enterCompoundOperator(this);
    }
    function $fe3f499b83b55a64$var$exitNode(listener) {
        listener.exitCompoundOperator && listener.exitCompoundOperator(this);
    }
    const $fe3f499b83b55a64$export$84bb3ebbba491aee = (value)=>$fe3f499b83b55a64$export$63c33bc3fe74fee6(value, []);
    const $fe3f499b83b55a64$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
            value: value,
            positions: operatorPositions,
            position: null,
            accept: $fe3f499b83b55a64$var$acceptCompoundOperator,
            enterNode: $fe3f499b83b55a64$var$enterNode,
            exitNode: $fe3f499b83b55a64$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("2TUEL", function(module, exports) {
    $parcel$export(module.exports, "field", ()=>$1c31156a69528c72$export$e0f35d825088c098);
    $parcel$export(module.exports, "fieldInternal", ()=>$1c31156a69528c72$export$2193f8c541622b6);
    var $2lgiK;
    var $WCvOq;
    function $1c31156a69528c72$var$acceptField(visitor) {
        return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
    }
    function $1c31156a69528c72$var$enterNode(listener) {
        listener.enterField && listener.enterField(this);
    }
    function $1c31156a69528c72$var$exitNode(listener) {
        listener.exitField && listener.exitField(this);
    }
    function $1c31156a69528c72$var$getChildren() {
        return this.properties ? [
            ...this.properties
        ] : [];
    }
    const $1c31156a69528c72$export$e0f35d825088c098 = (value, properties)=>{
        return $1c31156a69528c72$export$2193f8c541622b6(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value), properties);
    };
    const $1c31156a69528c72$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
        const node = {
            text: text,
            value: value,
            properties: properties,
            position: position,
            accept: $1c31156a69528c72$var$acceptField,
            enterNode: $1c31156a69528c72$var$enterNode,
            exitNode: $1c31156a69528c72$var$exitNode,
            getChildren: $1c31156a69528c72$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("9TMIk", function(module, exports) {
    $parcel$export(module.exports, "functionOperand", ()=>$413f1d947acf321b$export$4f981b0e83488ce);
    $parcel$export(module.exports, "functionOperandInternal", ()=>$413f1d947acf321b$export$c1f2ce91dc05872a);
    var $WCvOq;
    function $413f1d947acf321b$var$acceptFunctionOperand(visitor) {
        return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
    }
    function $413f1d947acf321b$var$enterNode(listener) {
        listener.enterFunctionOperand && listener.enterFunctionOperand(this);
    }
    function $413f1d947acf321b$var$exitNode(listener) {
        listener.exitFunctionOperand && listener.exitFunctionOperand(this);
    }
    function $413f1d947acf321b$var$getChildren() {
        return [
            this.function,
            ...this.arguments
        ];
    }
    const $413f1d947acf321b$export$4f981b0e83488ce = (functionString, args = [])=>$413f1d947acf321b$export$c1f2ce91dc05872a(functionString, args);
    const $413f1d947acf321b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d),
            function: functionString,
            arguments: args,
            position: position,
            accept: $413f1d947acf321b$var$acceptFunctionOperand,
            enterNode: $413f1d947acf321b$var$enterNode,
            exitNode: $413f1d947acf321b$var$exitNode,
            getChildren: $413f1d947acf321b$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';
parcelRegister("23cr9", function(module, exports) {
    $parcel$export(module.exports, "functionString", ()=>$a67350f9199f98c5$export$4e1bb9a7ff8d0ef9);
    $parcel$export(module.exports, "functionStringInternal", ()=>$a67350f9199f98c5$export$7aa9944588b7a69f);
    var $2lgiK;
    var $WCvOq;
    function $a67350f9199f98c5$var$acceptFunctionString(visitor) {
        return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
    }
    function $a67350f9199f98c5$var$enterNode(listener) {
        listener.enterFunction && listener.enterFunction(this);
    }
    function $a67350f9199f98c5$var$exitNode(listener) {
        listener.exitFunction && listener.exitFunction(this);
    }
    const $a67350f9199f98c5$export$4e1bb9a7ff8d0ef9 = (value)=>$a67350f9199f98c5$export$7aa9944588b7a69f(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $a67350f9199f98c5$export$7aa9944588b7a69f = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $a67350f9199f98c5$var$acceptFunctionString,
            enterNode: $a67350f9199f98c5$var$enterNode,
            exitNode: $a67350f9199f98c5$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("an0VC", function(module, exports) {
    $parcel$export(module.exports, "jast", ()=>$99ec58cecea09c23$export$b9e70a00f479ff43);
    const $99ec58cecea09c23$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
            query: query,
            represents: represents,
            errors: errors
        });
});
parcelRegister("kO6UE", function(module, exports) {
    $parcel$export(module.exports, "keywordOperand", ()=>$374a6d53e0ec4f5c$export$2edd4971ed69f2ce);
    $parcel$export(module.exports, "keywordOperandInternal", ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b);
    var $WCvOq;
    function $374a6d53e0ec4f5c$var$acceptKeywordOperand(visitor) {
        return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
    }
    function $374a6d53e0ec4f5c$var$enterNode(listener) {
        listener.enterKeywordOperand && listener.enterKeywordOperand(this);
    }
    function $374a6d53e0ec4f5c$var$exitNode(listener) {
        listener.exitKeywordOperand && listener.exitKeywordOperand(this);
    }
    const $374a6d53e0ec4f5c$export$2edd4971ed69f2ce = ()=>$374a6d53e0ec4f5c$export$7cc55480b054047b((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
    const $374a6d53e0ec4f5c$export$7cc55480b054047b = (value, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$f6049126fd97001f),
            value: value,
            position: position,
            accept: $374a6d53e0ec4f5c$var$acceptKeywordOperand,
            enterNode: $374a6d53e0ec4f5c$var$enterNode,
            exitNode: $374a6d53e0ec4f5c$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("AZ9nU", function(module, exports) {
    $parcel$export(module.exports, "listOperand", ()=>$c52de47ddabd701d$export$769866c3e9d41d50);
    $parcel$export(module.exports, "listOperandInternal", ()=>$c52de47ddabd701d$export$663c7831528c984b);
    var $eDTUO;
    var $WCvOq;
    function $c52de47ddabd701d$var$acceptListOperand(visitor) {
        return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
    }
    function $c52de47ddabd701d$var$enterNode(listener) {
        listener.enterListOperand && listener.enterListOperand(this);
    }
    function $c52de47ddabd701d$var$exitNode(listener) {
        listener.exitListOperand && listener.exitListOperand(this);
    }
    function $c52de47ddabd701d$var$getChildren() {
        return [
            ...this.values
        ];
    }
    const $c52de47ddabd701d$export$769866c3e9d41d50 = (values)=>$c52de47ddabd701d$export$663c7831528c984b(values);
    const $c52de47ddabd701d$export$663c7831528c984b = (values, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$fabec4aebba3f4df),
            values: values,
            position: position,
            accept: $c52de47ddabd701d$var$acceptListOperand,
            enterNode: $c52de47ddabd701d$var$enterNode,
            exitNode: $c52de47ddabd701d$var$exitNode,
            getChildren: $c52de47ddabd701d$var$getChildren,
            parent: null,
            appendOperand: (0, parcelRequire("eDTUO")).appendOperand
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("eDTUO", function(module, exports) {
    $parcel$export(module.exports, "appendOperand", ()=>$9a86be0ad84d7cf1$export$d94c54f1aee177c4);
    var $WCvOq;
    function $9a86be0ad84d7cf1$export$d94c54f1aee177c4(operand) {
        this.values.push(...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
            operand
        ]);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
});
parcelRegister("9HHq9", function(module, exports) {
    $parcel$export(module.exports, "notClause", ()=>$ed106cb5124eff4e$export$b4734a9fedb4d44e);
    $parcel$export(module.exports, "notClauseInternal", ()=>$ed106cb5124eff4e$export$b25621824fea4548);
    var $fjrwK;
    var $WCvOq;
    var $6qN6D;
    function $ed106cb5124eff4e$var$acceptNotClause(visitor) {
        return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
    }
    function $ed106cb5124eff4e$var$enterNode(listener) {
        listener.enterNotClause && listener.enterNotClause(this);
    }
    function $ed106cb5124eff4e$var$exitNode(listener) {
        listener.exitNotClause && listener.exitNotClause(this);
    }
    function $ed106cb5124eff4e$var$getChildren() {
        return [
            this.operator,
            this.clause
        ];
    }
    const $ed106cb5124eff4e$export$b4734a9fedb4d44e = (clause)=>{
        return $ed106cb5124eff4e$export$b25621824fea4548(clause, (0, (0, parcelRequire("6qN6D")).notClauseOperator)());
    };
    const $ed106cb5124eff4e$export$b25621824fea4548 = (clause, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb),
            clause: clause,
            operator: operator,
            position: position,
            accept: $ed106cb5124eff4e$var$acceptNotClause,
            enterNode: $ed106cb5124eff4e$var$enterNode,
            exitNode: $ed106cb5124eff4e$var$exitNode,
            getChildren: $ed106cb5124eff4e$var$getChildren,
            parent: null,
            remove: (0, parcelRequire("fjrwK")).remove,
            removeClause: (0, parcelRequire("fjrwK")).removeClause,
            replace: (0, parcelRequire("fjrwK")).replace,
            replaceClause: (0, parcelRequire("fjrwK")).replaceClause
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("fjrwK", function(module, exports) {
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $WCvOq;
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        if (this.clause === clause) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        if (this.clause === clause) {
            this.clause = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
});
parcelRegister("6qN6D", function(module, exports) {
    $parcel$export(module.exports, "notClauseOperator", ()=>$467f41c633037180$export$d2cd8239f99c13d3);
    $parcel$export(module.exports, "notClauseOperatorInternal", ()=>$467f41c633037180$export$1b15a32bb57b9020);
    var $bzbto;
    var $WCvOq;
    function $467f41c633037180$var$acceptNotClauseOperator(visitor) {
        return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
    }
    function $467f41c633037180$var$enterNode(listener) {
        listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
    }
    function $467f41c633037180$var$exitNode(listener) {
        listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
    }
    const $467f41c633037180$export$d2cd8239f99c13d3 = ()=>$467f41c633037180$export$1b15a32bb57b9020();
    const $467f41c633037180$export$1b15a32bb57b9020 = (position = null)=>({
            value: (0, (0, parcelRequire("bzbto")).CLAUSE_OPERATOR_NOT),
            position: position,
            accept: $467f41c633037180$var$acceptNotClauseOperator,
            enterNode: $467f41c633037180$var$enterNode,
            exitNode: $467f41c633037180$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bzbto", function(module, exports) {
    $parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", ()=>$bee8c61d429e7e04$export$c6c71ceedb15cda9);
    $parcel$export(module.exports, "OPERATOR_EQUALS", ()=>$bee8c61d429e7e04$export$466517a888d00195);
    $parcel$export(module.exports, "OPERATOR_NOT_EQUALS", ()=>$bee8c61d429e7e04$export$6d0d8810623974a5);
    $parcel$export(module.exports, "OPERATOR_GT", ()=>$bee8c61d429e7e04$export$bcbb090ab3c498b3);
    $parcel$export(module.exports, "OPERATOR_LT", ()=>$bee8c61d429e7e04$export$4bf1a4aa659c6ea4);
    $parcel$export(module.exports, "OPERATOR_GT_EQUALS", ()=>$bee8c61d429e7e04$export$83ce674214a54b2a);
    $parcel$export(module.exports, "OPERATOR_LT_EQUALS", ()=>$bee8c61d429e7e04$export$9629fd1727ef62ee);
    $parcel$export(module.exports, "OPERATOR_IN", ()=>$bee8c61d429e7e04$export$c4e3fb55e320e979);
    $parcel$export(module.exports, "OPERATOR_NOT_IN", ()=>$bee8c61d429e7e04$export$f9857532eaa24ddc);
    $parcel$export(module.exports, "OPERATOR_LIKE", ()=>$bee8c61d429e7e04$export$221595834b8766ab);
    $parcel$export(module.exports, "OPERATOR_NOT_LIKE", ()=>$bee8c61d429e7e04$export$fcefabf94a9bffbf);
    $parcel$export(module.exports, "OPERATOR_IS", ()=>$bee8c61d429e7e04$export$4feeb3f4ff56bcef);
    $parcel$export(module.exports, "OPERATOR_IS_NOT", ()=>$bee8c61d429e7e04$export$d08d969a0da27188);
    $parcel$export(module.exports, "OPERATOR_WAS", ()=>$bee8c61d429e7e04$export$8f907e179985256d);
    $parcel$export(module.exports, "OPERATOR_WAS_IN", ()=>$bee8c61d429e7e04$export$cc7b9d0b3ee23193);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", ()=>$bee8c61d429e7e04$export$585d3c004af078bb);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT", ()=>$bee8c61d429e7e04$export$123eaa9ccc2d9445);
    $parcel$export(module.exports, "OPERATOR_CHANGED", ()=>$bee8c61d429e7e04$export$15f5b446ba8c941e);
    $parcel$export(module.exports, "EQUALS_OPERATORS", ()=>$bee8c61d429e7e04$export$643c6101f3fc8547);
    $parcel$export(module.exports, "LIKE_OPERATORS", ()=>$bee8c61d429e7e04$export$329664c9cf18cca6);
    $parcel$export(module.exports, "COMPARISON_OPERATORS", ()=>$bee8c61d429e7e04$export$1b167a3705885a8b);
    $parcel$export(module.exports, "IN_OPERATORS", ()=>$bee8c61d429e7e04$export$f25cf16c2270312f);
    $parcel$export(module.exports, "IS_OPERATORS", ()=>$bee8c61d429e7e04$export$eb58cfffe4a6b805);
    $parcel$export(module.exports, "WAS_OPERATORS", ()=>$bee8c61d429e7e04$export$c22a981f581de218);
    $parcel$export(module.exports, "WAS_IN_OPERATORS", ()=>$bee8c61d429e7e04$export$6d08c4699bb75284);
    $parcel$export(module.exports, "CHANGED_OPERATORS", ()=>$bee8c61d429e7e04$export$b7dc214eef214c1c);
    $parcel$export(module.exports, "OPERATORS", ()=>$bee8c61d429e7e04$export$184799fc79ccac89);
    $parcel$export(module.exports, "LIST_OPERATORS", ()=>$bee8c61d429e7e04$export$77c793736847e030);
    const $bee8c61d429e7e04$export$c6c71ceedb15cda9 = 'not';
    const $bee8c61d429e7e04$export$466517a888d00195 = '=';
    const $bee8c61d429e7e04$export$6d0d8810623974a5 = '!=';
    const $bee8c61d429e7e04$export$bcbb090ab3c498b3 = '>';
    const $bee8c61d429e7e04$export$4bf1a4aa659c6ea4 = '<';
    const $bee8c61d429e7e04$export$83ce674214a54b2a = '>=';
    const $bee8c61d429e7e04$export$9629fd1727ef62ee = '<=';
    const $bee8c61d429e7e04$export$c4e3fb55e320e979 = 'in';
    const $bee8c61d429e7e04$export$f9857532eaa24ddc = 'not in';
    const $bee8c61d429e7e04$export$221595834b8766ab = '~';
    const $bee8c61d429e7e04$export$fcefabf94a9bffbf = '!~';
    const $bee8c61d429e7e04$export$4feeb3f4ff56bcef = 'is';
    const $bee8c61d429e7e04$export$d08d969a0da27188 = 'is not';
    const $bee8c61d429e7e04$export$8f907e179985256d = 'was';
    const $bee8c61d429e7e04$export$cc7b9d0b3ee23193 = 'was in';
    const $bee8c61d429e7e04$export$585d3c004af078bb = 'was not in';
    const $bee8c61d429e7e04$export$123eaa9ccc2d9445 = 'was not';
    const $bee8c61d429e7e04$export$15f5b446ba8c941e = 'changed';
    const $bee8c61d429e7e04$export$643c6101f3fc8547 = [
        $bee8c61d429e7e04$export$466517a888d00195,
        $bee8c61d429e7e04$export$6d0d8810623974a5
    ];
    const $bee8c61d429e7e04$export$329664c9cf18cca6 = [
        $bee8c61d429e7e04$export$221595834b8766ab,
        $bee8c61d429e7e04$export$fcefabf94a9bffbf
    ];
    const $bee8c61d429e7e04$export$1b167a3705885a8b = [
        $bee8c61d429e7e04$export$4bf1a4aa659c6ea4,
        $bee8c61d429e7e04$export$bcbb090ab3c498b3,
        $bee8c61d429e7e04$export$9629fd1727ef62ee,
        $bee8c61d429e7e04$export$83ce674214a54b2a
    ];
    const $bee8c61d429e7e04$export$f25cf16c2270312f = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc
    ];
    const $bee8c61d429e7e04$export$eb58cfffe4a6b805 = [
        $bee8c61d429e7e04$export$4feeb3f4ff56bcef,
        $bee8c61d429e7e04$export$d08d969a0da27188
    ];
    const $bee8c61d429e7e04$export$c22a981f581de218 = [
        $bee8c61d429e7e04$export$8f907e179985256d,
        $bee8c61d429e7e04$export$123eaa9ccc2d9445
    ];
    const $bee8c61d429e7e04$export$6d08c4699bb75284 = [
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
    const $bee8c61d429e7e04$export$b7dc214eef214c1c = [
        $bee8c61d429e7e04$export$15f5b446ba8c941e
    ];
    const $bee8c61d429e7e04$export$184799fc79ccac89 = [
        ...$bee8c61d429e7e04$export$643c6101f3fc8547,
        ...$bee8c61d429e7e04$export$329664c9cf18cca6,
        ...$bee8c61d429e7e04$export$1b167a3705885a8b,
        ...$bee8c61d429e7e04$export$f25cf16c2270312f,
        ...$bee8c61d429e7e04$export$eb58cfffe4a6b805,
        ...$bee8c61d429e7e04$export$c22a981f581de218,
        ...$bee8c61d429e7e04$export$6d08c4699bb75284,
        ...$bee8c61d429e7e04$export$b7dc214eef214c1c
    ];
    const $bee8c61d429e7e04$export$77c793736847e030 = [
        $bee8c61d429e7e04$export$c4e3fb55e320e979,
        $bee8c61d429e7e04$export$f9857532eaa24ddc,
        $bee8c61d429e7e04$export$cc7b9d0b3ee23193,
        $bee8c61d429e7e04$export$585d3c004af078bb
    ];
});
parcelRegister("3J4gf", function(module, exports) {
    $parcel$export(module.exports, "operator", ()=>$6fd03a148f63af84$export$dbd72860f701d4f3);
    $parcel$export(module.exports, "operatorInternal", ()=>$6fd03a148f63af84$export$649025bc60ab9c3b);
    var $WCvOq;
    function $6fd03a148f63af84$var$acceptOperator(visitor) {
        return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
    }
    function $6fd03a148f63af84$var$enterNode(listener) {
        listener.enterOperator && listener.enterOperator(this);
    }
    function $6fd03a148f63af84$var$exitNode(listener) {
        listener.exitOperator && listener.exitOperator(this);
    }
    const $6fd03a148f63af84$export$dbd72860f701d4f3 = (value)=>$6fd03a148f63af84$export$649025bc60ab9c3b(value, value);
    const $6fd03a148f63af84$export$649025bc60ab9c3b = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $6fd03a148f63af84$var$acceptOperator,
            enterNode: $6fd03a148f63af84$var$enterNode,
            exitNode: $6fd03a148f63af84$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("her2D", function(module, exports) {
    $parcel$export(module.exports, "orderBy", ()=>$37cf08d9a2045c25$export$f18af21d6f4dafd8);
    $parcel$export(module.exports, "orderByInternal", ()=>$37cf08d9a2045c25$export$e4eb1fa6bc8465c1);
    var $5HQt3;
    var $WCvOq;
    var $k9DKN;
    function $37cf08d9a2045c25$var$acceptOrderBy(visitor) {
        return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
    }
    function $37cf08d9a2045c25$var$enterNode(listener) {
        listener.enterOrderBy && listener.enterOrderBy(this);
    }
    function $37cf08d9a2045c25$var$exitNode(listener) {
        listener.exitOrderBy && listener.exitOrderBy(this);
    }
    function $37cf08d9a2045c25$var$getChildren() {
        return [
            this.operator,
            ...this.fields
        ];
    }
    const $37cf08d9a2045c25$export$f18af21d6f4dafd8 = (fields)=>{
        return $37cf08d9a2045c25$export$e4eb1fa6bc8465c1(fields, (0, (0, parcelRequire("k9DKN")).orderByOperator)());
    };
    const $37cf08d9a2045c25$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$da0f73edded4a63d),
            operator: operator,
            fields: fields,
            position: position,
            accept: $37cf08d9a2045c25$var$acceptOrderBy,
            enterNode: $37cf08d9a2045c25$var$enterNode,
            exitNode: $37cf08d9a2045c25$var$exitNode,
            getChildren: $37cf08d9a2045c25$var$getChildren,
            parent: null,
            prependOrderField: (0, parcelRequire("5HQt3")).prependOrderField,
            setOrderDirection: (0, parcelRequire("5HQt3")).setOrderDirection,
            replace: (0, parcelRequire("5HQt3")).replace,
            replaceOrderField: (0, parcelRequire("5HQt3")).replaceOrderField,
            remove: (0, parcelRequire("5HQt3")).remove,
            removeOrderField: (0, parcelRequire("5HQt3")).removeOrderField
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("5HQt3", function(module, exports) {
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceOrderField", ()=>replaceOrderField);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeOrderField", ()=>removeOrderField);
    var $WCvOq;
    function prependOrderField(orderField) {
        this.fields.unshift(orderField);
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOrderDirection(orderDirection) {
        if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
    }
    function replace(nextOrderBy) {
        if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
    }
    function replaceOrderField(orderByField, nextOrderByField) {
        this.fields = this.fields.map((child)=>{
            return child === orderByField ? nextOrderByField : child;
        });
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeOrderBy();
    }
    function removeOrderField(orderByField) {
        this.fields = this.fields.filter((field)=>field !== orderByField);
        if (this.fields.length === 0) this.remove();
    }
});
parcelRegister("k9DKN", function(module, exports) {
    $parcel$export(module.exports, "orderByOperator", ()=>$0824f859de091a85$export$c7307b67924c61ea);
    $parcel$export(module.exports, "orderByOperatorInternal", ()=>$0824f859de091a85$export$739e30af23a08da0);
    var $WCvOq;
    function $0824f859de091a85$var$acceptOrderByOperator(visitor) {
        return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
    }
    function $0824f859de091a85$var$enterNode(listener) {
        listener.enterOrderByOperator && listener.enterOrderByOperator(this);
    }
    function $0824f859de091a85$var$exitNode(listener) {
        listener.exitOrderByOperator && listener.exitOrderByOperator(this);
    }
    const $0824f859de091a85$export$c7307b67924c61ea = ()=>$0824f859de091a85$export$739e30af23a08da0();
    const $0824f859de091a85$export$739e30af23a08da0 = (position = null)=>({
            value: (0, $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517),
            position: position,
            accept: $0824f859de091a85$var$acceptOrderByOperator,
            enterNode: $0824f859de091a85$var$enterNode,
            exitNode: $0824f859de091a85$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
const $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517 = 'ORDER BY';
const $9f1dbb2b39d4d9a2$export$6d60017b9e092e73 = 'ASC';
const $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899 = 'DESC';
parcelRegister("j37YY", function(module, exports) {
    $parcel$export(module.exports, "orderByDirection", ()=>$c155c373ff42c873$export$864d934efed3ccaa);
    $parcel$export(module.exports, "orderByDirectionInternal", ()=>$c155c373ff42c873$export$8c65cac1a7852d1f);
    var $WCvOq;
    function $c155c373ff42c873$var$acceptOrderByDirection(visitor) {
        return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
    }
    function $c155c373ff42c873$var$enterNode(listener) {
        listener.enterOrderByDirection && listener.enterOrderByDirection(this);
    }
    function $c155c373ff42c873$var$exitNode(listener) {
        listener.exitOrderByDirection && listener.exitOrderByDirection(this);
    }
    const $c155c373ff42c873$export$864d934efed3ccaa = (value)=>$c155c373ff42c873$export$8c65cac1a7852d1f(value);
    const $c155c373ff42c873$export$8c65cac1a7852d1f = (value, position = null)=>({
            value: value,
            position: position,
            accept: $c155c373ff42c873$var$acceptOrderByDirection,
            enterNode: $c155c373ff42c873$var$enterNode,
            exitNode: $c155c373ff42c873$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("doe2p", function(module, exports) {
    $parcel$export(module.exports, "orderByField", ()=>$b5422aff91034201$export$942df63e5e3d3899);
    $parcel$export(module.exports, "orderByFieldInternal", ()=>$b5422aff91034201$export$661a7786e3d15926);
    var $g2iOq;
    var $WCvOq;
    function $b5422aff91034201$var$acceptOrderByField(visitor) {
        return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
    }
    function $b5422aff91034201$var$enterNode(listener) {
        listener.enterOrderByField && listener.enterOrderByField(this);
    }
    function $b5422aff91034201$var$exitNode(listener) {
        listener.exitOrderByField && listener.exitOrderByField(this);
    }
    function $b5422aff91034201$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.direction) children.push(this.direction);
        return children;
    }
    const $b5422aff91034201$export$942df63e5e3d3899 = (field, direction)=>$b5422aff91034201$export$661a7786e3d15926(field, direction);
    const $b5422aff91034201$export$661a7786e3d15926 = (field, direction, position = null)=>{
        const node = {
            field: field,
            direction: direction,
            position: position,
            accept: $b5422aff91034201$var$acceptOrderByField,
            enterNode: $b5422aff91034201$var$enterNode,
            exitNode: $b5422aff91034201$var$exitNode,
            getChildren: $b5422aff91034201$var$getChildren,
            parent: null,
            setOrderDirection: (0, parcelRequire("g2iOq")).setOrderDirection,
            replace: (0, parcelRequire("g2iOq")).replace,
            remove: (0, parcelRequire("g2iOq")).remove
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("g2iOq", function(module, exports) {
    $parcel$export(module.exports, "setOrderDirection", ()=>$27f36e283e6ff201$export$b596730931a09703);
    $parcel$export(module.exports, "replace", ()=>$27f36e283e6ff201$export$77ad94ebf1c2b9ed);
    $parcel$export(module.exports, "remove", ()=>$27f36e283e6ff201$export$cd7f480d6b8286c3);
    var $WCvOq;
    function $27f36e283e6ff201$export$b596730931a09703(orderDirection) {
        this.direction = orderDirection;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function $27f36e283e6ff201$export$77ad94ebf1c2b9ed(orderByField) {
        if (this.parent) this.parent.replaceOrderField(this, orderByField);
    }
    function $27f36e283e6ff201$export$cd7f480d6b8286c3() {
        if (this.parent) this.parent.removeOrderField(this);
    }
});
parcelRegister("jRA9z", function(module, exports) {
    $parcel$export(module.exports, "predicate", ()=>$ff1c73953498b7ec$export$5fc51e445ce24faf);
    $parcel$export(module.exports, "predicateInternal", ()=>$ff1c73953498b7ec$export$a767a27ad05a38a2);
    var $WCvOq;
    function $ff1c73953498b7ec$var$acceptPredicate(visitor) {
        return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
    }
    function $ff1c73953498b7ec$var$enterNode(listener) {
        listener.enterPredicate && listener.enterPredicate(this);
    }
    function $ff1c73953498b7ec$var$exitNode(listener) {
        listener.exitPredicate && listener.exitPredicate(this);
    }
    function $ff1c73953498b7ec$var$getChildren() {
        const children = [
            this.operator
        ];
        if (this.operand) children.push(this.operand);
        return children;
    }
    const $ff1c73953498b7ec$export$5fc51e445ce24faf = (operator, operand)=>$ff1c73953498b7ec$export$a767a27ad05a38a2(operator, operand);
    const $ff1c73953498b7ec$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
        const node = {
            operator: operator,
            operand: operand,
            position: position,
            accept: $ff1c73953498b7ec$var$acceptPredicate,
            enterNode: $ff1c73953498b7ec$var$enterNode,
            exitNode: $ff1c73953498b7ec$var$exitNode,
            getChildren: $ff1c73953498b7ec$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("bF1Nb", function(module, exports) {
    $parcel$export(module.exports, "predicateOperator", ()=>$fb65b796ae9eab4e$export$5419b7f16910ea62);
    $parcel$export(module.exports, "predicateOperatorInternal", ()=>$fb65b796ae9eab4e$export$c69d893689716768);
    var $WCvOq;
    function $fb65b796ae9eab4e$var$acceptPredicateOperator(visitor) {
        return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
    }
    function $fb65b796ae9eab4e$var$enterNode(listener) {
        listener.enterPredicateOperator && listener.enterPredicateOperator(this);
    }
    function $fb65b796ae9eab4e$var$exitNode(listener) {
        listener.exitPredicateOperator && listener.exitPredicateOperator(this);
    }
    const $fb65b796ae9eab4e$export$5419b7f16910ea62 = (value)=>$fb65b796ae9eab4e$export$c69d893689716768(value, value);
    const $fb65b796ae9eab4e$export$c69d893689716768 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $fb65b796ae9eab4e$var$acceptPredicateOperator,
            enterNode: $fb65b796ae9eab4e$var$enterNode,
            exitNode: $fb65b796ae9eab4e$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("bW5aY", function(module, exports) {
    $parcel$export(module.exports, "property", ()=>$1f1ea1ef09d97bb3$export$d541bacb2bda4494);
    $parcel$export(module.exports, "propertyInternal", ()=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad);
    var $WCvOq;
    function $1f1ea1ef09d97bb3$var$acceptProperty(visitor) {
        return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
    }
    function $1f1ea1ef09d97bb3$var$enterNode(listener) {
        listener.enterProperty && listener.enterProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$exitNode(listener) {
        listener.exitProperty && listener.exitProperty(this);
    }
    function $1f1ea1ef09d97bb3$var$getChildren() {
        const children = [];
        if (this.key) children.push(this.key);
        if (this.path) return children.concat(this.path);
        return children;
    }
    const $1f1ea1ef09d97bb3$export$d541bacb2bda4494 = (key, path = [])=>$1f1ea1ef09d97bb3$export$1cbd90994fef1fad(key, path);
    const $1f1ea1ef09d97bb3$export$1cbd90994fef1fad = (key, path, position = null)=>{
        const node = {
            key: key,
            path: path,
            position: position,
            accept: $1f1ea1ef09d97bb3$var$acceptProperty,
            enterNode: $1f1ea1ef09d97bb3$var$enterNode,
            exitNode: $1f1ea1ef09d97bb3$var$exitNode,
            getChildren: $1f1ea1ef09d97bb3$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("dgZwd", function(module, exports) {
    $parcel$export(module.exports, "query", ()=>$3aa450a0eb1b166a$export$2fa187e846a241c4);
    $parcel$export(module.exports, "queryInternal", ()=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014);
    var $aqdKa;
    var $WCvOq;
    function $3aa450a0eb1b166a$var$acceptQuery(visitor) {
        return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
    }
    function $3aa450a0eb1b166a$var$enterNode(listener) {
        listener.enterQuery && listener.enterQuery(this);
    }
    function $3aa450a0eb1b166a$var$exitNode(listener) {
        listener.exitQuery && listener.exitQuery(this);
    }
    function $3aa450a0eb1b166a$var$getChildren() {
        const children = [];
        if (this.where) children.push(this.where);
        if (this.orderBy) children.push(this.orderBy);
        return children;
    }
    const $3aa450a0eb1b166a$export$2fa187e846a241c4 = (where, orderBy)=>$3aa450a0eb1b166a$export$bc2d6e2e1fd9014(where, orderBy);
    const $3aa450a0eb1b166a$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$98dda21ec825792),
            where: where,
            orderBy: orderBy,
            position: position,
            accept: $3aa450a0eb1b166a$var$acceptQuery,
            enterNode: $3aa450a0eb1b166a$var$enterNode,
            exitNode: $3aa450a0eb1b166a$var$exitNode,
            getChildren: $3aa450a0eb1b166a$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("aqdKa")).appendClause,
            prependOrderField: (0, parcelRequire("aqdKa")).prependOrderField,
            setOrderDirection: (0, parcelRequire("aqdKa")).setOrderDirection,
            removeClause: (0, parcelRequire("aqdKa")).removeClause,
            replaceClause: (0, parcelRequire("aqdKa")).replaceClause,
            replaceOrderBy: (0, parcelRequire("aqdKa")).replaceOrderBy,
            removeOrderBy: (0, parcelRequire("aqdKa")).removeOrderBy
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("aqdKa", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replaceOrderBy", ()=>replaceOrderBy);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    $parcel$export(module.exports, "removeOrderBy", ()=>removeOrderBy);
    var $iEIQF;
    var $WCvOq;
    function appendClause(clause, compoundOperatorValue) {
        if (!this.where) this.where = clause;
        else {
            const nextCompoundOperator = (0, (0, parcelRequire("iEIQF")).default).compoundOperator(compoundOperatorValue);
            const nextClause = (0, (0, parcelRequire("iEIQF")).default).compoundClause(nextCompoundOperator, []);
            nextClause.appendClause(this.where);
            nextClause.appendClause(clause);
            this.where = nextClause;
        }
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function prependOrderField(orderField) {
        if (!this.orderBy) {
            this.orderBy = (0, (0, parcelRequire("iEIQF")).default).orderBy([
                orderField
            ]);
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        } else this.orderBy.prependOrderField(orderField);
    }
    function setOrderDirection(orderDirection) {
        if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
    }
    function removeClause(clause) {
        if (this.where === clause) this.where = undefined;
    }
    function replaceOrderBy(orderBy) {
        if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
        else {
            this.orderBy = orderBy;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function replaceClause(clause, nextClause) {
        if (this.where === clause) {
            this.where = nextClause;
            (0, (0, parcelRequire("WCvOq")).assignParent)(this);
        }
    }
    function removeOrderBy() {
        this.orderBy = undefined;
    }
});
parcelRegister("1zQFd", function(module, exports) {
    $parcel$export(module.exports, "terminalClause", ()=>$ad22ef70da25a752$export$2627cbe08dd86b00);
    $parcel$export(module.exports, "terminalClauseInternal", ()=>$ad22ef70da25a752$export$cc08e43598d091fc);
    var $b6t5q;
    var $WCvOq;
    function $ad22ef70da25a752$var$acceptTerminalClause(visitor) {
        return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
    }
    function $ad22ef70da25a752$var$enterNode(listener) {
        listener.enterTerminalClause && listener.enterTerminalClause(this);
    }
    function $ad22ef70da25a752$var$exitNode(listener) {
        listener.exitTerminalClause && listener.exitTerminalClause(this);
    }
    function $ad22ef70da25a752$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.operator) children.push(this.operator);
        if (this.operand) children.push(this.operand);
        return children.concat(this.predicates);
    }
    const $ad22ef70da25a752$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
        return $ad22ef70da25a752$export$cc08e43598d091fc(field, operator, operand, predicates);
    };
    const $ad22ef70da25a752$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
        const node = {
            type: (0, $c1dc40b7a30d95e8$export$2d205682cc545947),
            clauseType: (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a),
            field: field,
            operator: operator,
            operand: operand,
            predicates: predicates,
            position: position,
            accept: $ad22ef70da25a752$var$acceptTerminalClause,
            enterNode: $ad22ef70da25a752$var$enterNode,
            exitNode: $ad22ef70da25a752$var$exitNode,
            getChildren: $ad22ef70da25a752$var$getChildren,
            parent: null,
            setOperator: (0, parcelRequire("b6t5q")).setOperator,
            setOperand: (0, parcelRequire("b6t5q")).setOperand,
            appendOperand: (0, parcelRequire("b6t5q")).appendOperand,
            remove: (0, parcelRequire("b6t5q")).remove,
            replace: (0, parcelRequire("b6t5q")).replace
        };
        (0, (0, parcelRequire("WCvOq")).assignParent)(node);
        return node;
    };
});
parcelRegister("b6t5q", function(module, exports) {
    $parcel$export(module.exports, "setOperator", ()=>setOperator);
    $parcel$export(module.exports, "setOperand", ()=>setOperand);
    $parcel$export(module.exports, "appendOperand", ()=>appendOperand);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "replace", ()=>replace);
    var $iEIQF;
    var $WCvOq;
    function setOperator(operator) {
        this.operator = operator;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function setOperand(operand) {
        this.operand = operand;
        (0, (0, parcelRequire("WCvOq")).assignParent)(this);
    }
    function appendOperand(operand) {
        if (this.operand) {
            if (this.operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
            else this.setOperand((0, (0, parcelRequire("iEIQF")).default).listOperand([
                this.operand,
                ...operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) ? operand.values : [
                    operand
                ]
            ]));
        } else this.setOperand(operand);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
});
parcelRegister("eWV0u", function(module, exports) {
    $parcel$export(module.exports, "valueOperand", ()=>$f1a80cb053576a13$export$2b6e4d2ed8d53bf3);
    $parcel$export(module.exports, "valueOperandInternal", ()=>$f1a80cb053576a13$export$79c37d97caac8627);
    $parcel$export(module.exports, "valueOperandByText", ()=>$f1a80cb053576a13$export$3ac9155bde56a45f);
    var $gq4pj;
    var $2lgiK;
    var $WCvOq;
    function $f1a80cb053576a13$var$acceptValueOperand(visitor) {
        return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
    }
    function $f1a80cb053576a13$var$enterNode(listener) {
        listener.enterValueOperand && listener.enterValueOperand(this);
    }
    function $f1a80cb053576a13$var$exitNode(listener) {
        listener.exitValueOperand && listener.exitValueOperand(this);
    }
    const $f1a80cb053576a13$export$2b6e4d2ed8d53bf3 = (value)=>$f1a80cb053576a13$export$79c37d97caac8627(value, (0, (0, parcelRequire("2lgiK")).sanitiseJqlString)(value));
    const $f1a80cb053576a13$export$3ac9155bde56a45f = (text)=>$f1a80cb053576a13$export$79c37d97caac8627((0, (0, parcelRequire("gq4pj")).normaliseJqlString)(text), text);
    const $f1a80cb053576a13$export$79c37d97caac8627 = (value, text, position = null)=>({
            type: (0, $c1dc40b7a30d95e8$export$d2f212d8ddbc8d1d),
            operandType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113),
            text: text,
            value: value,
            position: position,
            accept: $f1a80cb053576a13$var$acceptValueOperand,
            enterNode: $f1a80cb053576a13$var$enterNode,
            exitNode: $f1a80cb053576a13$var$exitNode,
            getChildren: (0, (0, parcelRequire("WCvOq")).noChildren),
            parent: null
        });
});
parcelRegister("l0V05", function(module, exports) {
    $parcel$export(module.exports, "print", ()=>$2a6ee55a17f6829c$export$c2d084dc44961371);
    var $3NMrl = parcelRequire("3NMrl");
    var $jcm7E;
    var $4gL4M;
    const $2a6ee55a17f6829c$export$c2d084dc44961371 = (jast, options = {})=>{
        return (0, (0, parcelRequire("4gL4M")).printDocToString)((0, (0, parcelRequire("jcm7E")).printAstToDoc)(jast, (0, ($parcel$interopDefault($3NMrl)))(options, [
            'operatorCase'
        ])), (0, ($parcel$interopDefault($3NMrl)))(options, [
            'printWidth'
        ]));
    };
});
parcelRegister("jcm7E", function(module, exports) {
    $parcel$export(module.exports, "printAstToDoc", ()=>$7ac43980ca69512e$export$f0ef38932978952);
    var $bv7J5;
    var $d4xUO;
    const $7ac43980ca69512e$var$formatOperator = (operator, operatorCase)=>{
        switch(operatorCase){
            case 'lower':
                return operator.toLowerCase();
            case 'upper':
                return operator.toUpperCase();
            case 'preserve':
                return operator;
        }
    };
    class $7ac43980ca69512e$export$27a275559a5c8102 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor({ operatorCase: operatorCase } = {}){
            super();
            this.operatorCase = operatorCase || 'preserve';
        }
        visitArgument(argument) {
            return argument.text;
        }
        joinNodes(nodes, separator) {
            const docs = [];
            nodes.forEach((node)=>{
                if (separator !== undefined && docs.length > 0) docs.push(separator);
                docs.push(node.accept(this));
            });
            return docs;
        }
        visitCompoundClause(compoundClause) {
            const operatorDoc = compoundClause.operator.accept(this);
            const clauseDocs = [];
            compoundClause.clauses.forEach((clause)=>{
                if (clauseDocs.length > 0) clauseDocs.push((0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '), operatorDoc, ' ');
                if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
                else clauseDocs.push(clause.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(clauseDocs);
        }
        visitCompoundOperator(compoundOperator) {
            return $7ac43980ca69512e$var$formatOperator(compoundOperator.value, this.operatorCase);
        }
        visitField(field) {
            const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
            return (0, (0, parcelRequire("d4xUO")).group)([
                field.text,
                ...propertyDocs
            ]);
        }
        visitFunction(functionString) {
            return functionString.text;
        }
        visitFunctionOperand(functionOperand) {
            const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                functionOperand.function.accept(this),
                '(',
                ...argumentDocs,
                ')'
            ]);
        }
        visitKeywordOperand(keywordOperand) {
            return keywordOperand.value;
        }
        visitListOperand(listOperand) {
            const operandDocs = this.joinNodes(listOperand.values, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                '(',
                ...operandDocs,
                ')'
            ]);
        }
        visitOperator(operator) {
            return $7ac43980ca69512e$var$formatOperator(operator.text, this.operatorCase);
        }
        visitOrderBy(orderBy) {
            const fieldDocs = this.joinNodes(orderBy.fields, ', ');
            return (0, (0, parcelRequire("d4xUO")).group)([
                orderBy.operator.accept(this),
                ' ',
                ...fieldDocs
            ]);
        }
        visitOrderByDirection(orderByDirection) {
            return orderByDirection.value;
        }
        visitOrderByField(orderByField) {
            const docs = [
                orderByField.field.accept(this)
            ];
            if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitOrderByOperator(orderByOperator) {
            return $7ac43980ca69512e$var$formatOperator(orderByOperator.value, this.operatorCase);
        }
        visitPredicate(predicate) {
            const docs = [
                predicate.operator.accept(this)
            ];
            if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitPredicateOperator(predicateOperator) {
            return $7ac43980ca69512e$var$formatOperator(predicateOperator.text, this.operatorCase);
        }
        visitProperty(property) {
            const docs = [];
            if (property.key) docs.push('[', property.key.accept(this), ']');
            if (property.path) {
                const pathDocs = this.joinNodes(property.path, ' ');
                docs.push(...pathDocs);
            }
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitQuery(query) {
            if (query.where && query.orderBy) return (0, (0, parcelRequire("d4xUO")).group)([
                query.where.accept(this),
                (0, (0, parcelRequire("d4xUO")).ifBreak)((0, (0, parcelRequire("d4xUO")).newLine)(), ' '),
                query.orderBy.accept(this)
            ]);
            else if (query.where) return query.where.accept(this);
            else if (query.orderBy) return query.orderBy.accept(this);
            return '';
        }
        visitTerminalClause(terminalClause) {
            const docs = [
                terminalClause.field.accept(this)
            ];
            if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
            if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
            terminalClause.predicates.forEach((predicate)=>{
                docs.push(' ', predicate.accept(this));
            });
            return (0, (0, parcelRequire("d4xUO")).group)(docs);
        }
        visitValueOperand(valueOperand) {
            return valueOperand.text;
        }
        visitNotClause(notClause) {
            const clauseDocs = [];
            if (notClause.clause.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
            else clauseDocs.push(notClause.clause.accept(this));
            return (0, (0, parcelRequire("d4xUO")).group)([
                notClause.operator.accept(this),
                ' ',
                ...clauseDocs
            ]);
        }
        visitNotClauseOperator(notClauseOperator) {
            return notClauseOperator.value;
        }
        visitChildren() {
            throw new Error('Required visit method not implemented for node');
        }
        defaultResult() {
            return '';
        }
    }
    const $7ac43980ca69512e$export$f0ef38932978952 = (jast, options)=>{
        const astToDocVisitor = new $7ac43980ca69512e$export$27a275559a5c8102(options);
        return jast.query ? jast.query.accept(astToDocVisitor) : '';
    };
});
parcelRegister("bv7J5", function(module, exports) {
    $parcel$export(module.exports, "AbstractJastVisitor", ()=>$564d8ceecff04d6a$export$51be62b46ee668fd);
    class $564d8ceecff04d6a$export$51be62b46ee668fd {
        visit(node) {
            return node.accept(this);
        }
        visitChildren(node) {
            let result = this.defaultResult();
            const children = node.getChildren();
            for(let i = 0; i < children.length; i++){
                if (!this.shouldVisitNextChild(node, result)) break;
                const childResult = children[i].accept(this);
                result = this.aggregateResult(result, childResult);
            }
            return result;
        }
        aggregateResult(aggregate, nextResult) {
            return nextResult;
        }
        shouldVisitNextChild(node, currentResult) {
            return true;
        }
    }
});
parcelRegister("d4xUO", function(module, exports) {
    $parcel$export(module.exports, "group", ()=>$9ef2b92937def9ad$export$e5e25fbcc1f7affe);
    $parcel$export(module.exports, "ifBreak", ()=>$9ef2b92937def9ad$export$1db8e61901dcb0fa);
    $parcel$export(module.exports, "newLine", ()=>$9ef2b92937def9ad$export$dc84f6841f96b7da);
    const $9ef2b92937def9ad$export$e5e25fbcc1f7affe = (contents)=>{
        return {
            type: 'group',
            contents: contents
        };
    };
    const $9ef2b92937def9ad$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
        return {
            type: 'if-break',
            breakContents: breakContents,
            flatContents: flatContents
        };
    };
    const $9ef2b92937def9ad$export$dc84f6841f96b7da = ()=>{
        return {
            type: 'new-line'
        };
    };
});
parcelRegister("4gL4M", function(module, exports) {
    $parcel$export(module.exports, "printDocToString", ()=>$b6450d092f32aba3$export$316fc7e94b95b118);
    const $b6450d092f32aba3$var$computeFlatWidth = (doc)=>{
        if (typeof doc === 'string') return doc.length;
        if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $b6450d092f32aba3$var$computeFlatWidth(innerDoc), 0);
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.contents);
            case 'if-break':
                return $b6450d092f32aba3$var$computeFlatWidth(doc.flatContents);
            case 'new-line':
                return 0;
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printDoc = (doc, context)=>{
        if (typeof doc === 'string') return {
            result: doc,
            endIndex: context.startIndex + doc.length
        };
        switch(doc.type){
            case 'group':
                return $b6450d092f32aba3$var$printGroup(doc, context);
            case 'if-break':
                return $b6450d092f32aba3$var$printIfBreak(doc, context);
            case 'new-line':
                return $b6450d092f32aba3$var$printNewLine();
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $b6450d092f32aba3$var$printGroup = (doc, context)=>{
        const docWidth = context.startIndex + $b6450d092f32aba3$var$computeFlatWidth(doc);
        const breakContents = context.printWidth !== null && docWidth > context.printWidth;
        return doc.contents.reduce((agg, innerDoc)=>{
            const innerContext = {
                ...context,
                startIndex: agg.endIndex,
                breakContents: breakContents
            };
            const output = $b6450d092f32aba3$var$printDoc(innerDoc, innerContext);
            return {
                result: agg.result + output.result,
                endIndex: output.endIndex
            };
        }, {
            result: '',
            endIndex: context.startIndex
        });
    };
    const $b6450d092f32aba3$var$printIfBreak = (doc, context)=>{
        if (context.breakContents) return $b6450d092f32aba3$var$printDoc(doc.breakContents, context);
        return $b6450d092f32aba3$var$printDoc(doc.flatContents, context);
    };
    const $b6450d092f32aba3$var$printNewLine = ()=>{
        return {
            result: '\n',
            endIndex: 0
        };
    };
    const $b6450d092f32aba3$var$defaultPrintWidth = 100;
    const $b6450d092f32aba3$export$316fc7e94b95b118 = (doc, options = {})=>{
        const { printWidth: printWidth = $b6450d092f32aba3$var$defaultPrintWidth } = options;
        const output = $b6450d092f32aba3$var$printDoc(doc, {
            printWidth: printWidth,
            startIndex: 0,
            breakContents: false
        });
        return output.result;
    };
});
parcelRegister("7htvz", function(module, exports) {
    $parcel$export(module.exports, "OPTIMISTIC_ID", ()=>$d5b40c70d7e37442$export$6e40821019289c70);
    $parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$d6ceedee35ae2c19);
    $parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$ca3691ea47eec823);
    $parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$2a5fce320f18ac6c);
    $parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$b0ec8deb6068dc3b);
    $parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$6c99c87a0ac0052a);
    $parcel$export(module.exports, "EMPTY_FILTER_VALUE", ()=>$d5b40c70d7e37442$export$9ebaf9fe814731d3);
    $parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", ()=>$d5b40c70d7e37442$export$9b72011e2eb8d7d0);
    const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
    const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
    const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
        experience: 'filtersCreateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
        experience: 'filtersUpdateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
        experience: 'filtersDeleteSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
        experience: 'filtersStarSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
        experience: 'filtersLoadSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
    const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';
});
parcelRegister("1T1ir", function(module, exports) {
    $parcel$export(module.exports, "useSimpleSearch", ()=>$9ff55c3a873f98f5$export$b549f44e7ca96280);
    $parcel$export(module.exports, "useSimpleSearchHighlight", ()=>$9ff55c3a873f98f5$export$fd04dfca01137d2);
    $parcel$export(module.exports, "useSearchText", ()=>$9ff55c3a873f98f5$export$119186efd4186c93);
    $parcel$export(module.exports, "useSimpleSearchJQL", ()=>$9ff55c3a873f98f5$export$42b8d8a5ec5bc873);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XS00;
    var $ieDtd;
    var $7htvz;
    const $9ff55c3a873f98f5$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const $9ff55c3a873f98f5$var$issueKeyRegex = new RegExp(`^${(0, (0, parcelRequire("9XS00")).ISSUEKEY_REGEX)}$`);
    const $9ff55c3a873f98f5$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    const $9ff55c3a873f98f5$export$b549f44e7ca96280 = ()=>{
        const [simpleSearch, persistSimpleSearch] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("7htvz")).SIMPLE_SEARCH_PARAM));
        const setSimpleSearch = (0, $5uXOq.useCallback)((searchText)=>{
            searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
        }, [
            persistSimpleSearch
        ]);
        return [
            simpleSearch ?? '',
            setSimpleSearch
        ];
    };
    const $9ff55c3a873f98f5$export$72839f749ccf76b2 = (text)=>{
        if (text == null) return [];
        return text.split(' ').filter((word)=>word !== '');
    };
    const $9ff55c3a873f98f5$export$fd04dfca01137d2 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        return (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(simpleSearch), [
            simpleSearch
        ]);
    };
    const $9ff55c3a873f98f5$export$abb78553baf1cfac = (text)=>{
        if (text == null || text.trim() === '') return '';
        let search = $9ff55c3a873f98f5$var$sanitize(text);
        if ($9ff55c3a873f98f5$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
        if (!$9ff55c3a873f98f5$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
        return `(summary ~ '${search}' OR description ~ '${search}')`;
    };
    const $9ff55c3a873f98f5$export$119186efd4186c93 = (text)=>{
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(text), [
            text
        ]);
        const highlight = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(text), [
            text
        ]);
        return {
            jql: jql,
            highlight: highlight
        };
    };
    const $9ff55c3a873f98f5$export$42b8d8a5ec5bc873 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(simpleSearch), [
            simpleSearch
        ]);
        const addSimpleSearchToJQL = (0, $5uXOq.useCallback)((currentJQL)=>{
            if (jql === '') return currentJQL;
            if (currentJQL == null) return jql;
            return `${currentJQL} AND ${jql}`;
        }, [
            jql
        ]);
        return {
            jql: jql,
            isSearching: jql !== '',
            addSimpleSearchToJQL: addSimpleSearchToJQL
        };
    };
    var $9ff55c3a873f98f5$export$2e2bcd8739ae039 = $9ff55c3a873f98f5$export$b549f44e7ca96280;
});
parcelRegister("9XS00", function(module, exports) {
    $parcel$export(module.exports, "ISSUEKEY_REGEX", ()=>$76f8b51a225e9798$export$b52c9cee589449a8);
    $parcel$export(module.exports, "default", ()=>$76f8b51a225e9798$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
    var $76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, {});
        const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
        const isMatchingHost = parsedUrl.host === host;
        const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
        const issueKey = matches && matches.length > 1 ? matches[1] : null;
        return isMatchingProtocol && isMatchingHost && issueKey || null;
    };
});
parcelRegister("7VpiX", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJql", ()=>$e5742a6c935cce4a$export$78c9a06ab18996fc);
    $parcel$export(module.exports, "getJqlErrors", ()=>$e5742a6c935cce4a$export$cc387523b0acb16d);
    var $eK6AG;
    var $l0V05;
    const $e5742a6c935cce4a$export$78c9a06ab18996fc = (jql)=>{
        if (!jql) return jql;
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
        return (0, (0, parcelRequire("l0V05")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $e5742a6c935cce4a$export$cc387523b0acb16d = (jql)=>{
        if (!jql) return [];
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        return jast.errors;
    };
});
parcelRegister("eK6AG", function(module, exports) {
    $parcel$export(module.exports, "JastBuilder", ()=>$ccc4ef92204502d2$export$99cae18a5a6ba8cf);
    var $hCaMj = parcelRequire("hCaMj");
    var $8QpSo;
    var $39War;
    var $k9No4;
    var $iEIQF;
    var $lKjSa;
    var $k9iwN;
    var $bK3p2;
    class $ccc4ef92204502d2$export$99cae18a5a6ba8cf {
        setErrorHandler(errorHandler) {
            this.errorHandler = errorHandler;
            return this;
        }
        setErrorListeners(errorListeners) {
            this.errorListeners = this.errorListeners.concat(errorListeners);
            return this;
        }
        build(value) {
            const tokens = this.getTokens(value);
            const parser = this.getParser(tokens);
            const astErrorListener = new (0, (0, parcelRequire("lKjSa")).JastBuilderErrorListener)();
            parser.removeErrorListeners();
            parser.addErrorListener(astErrorListener);
            this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
            if (this.errorHandler) {
                parser.errorHandler = this.errorHandler;
                this.errorHandler.reset(parser);
            }
            const visitor = new (0, (0, parcelRequire("bK3p2")).QueryVisitor)(tokens);
            try {
                const parseTree = parser.jqlQuery();
                const query = parseTree.accept(visitor);
                return (0, (0, parcelRequire("iEIQF")).default).jast(query, value, astErrorListener.errors);
            } catch (error) {
                return (0, (0, parcelRequire("iEIQF")).default).jast(undefined, value, [
                    new (0, (0, parcelRequire("k9iwN")).JQLParseError)(error.message, error)
                ]);
            }
        }
        constructor(){
            this.errorListeners = [];
            this.errorHandler = undefined;
            this.getTokens = (0, (0, parcelRequire("8QpSo")).default)((value)=>{
                const chars = (0, $hCaMj.CharStreams).fromString(value);
                const lexer = new (0, (0, parcelRequire("39War")).JQLLexer)(chars);
                return new (0, $hCaMj.CommonTokenStream)(lexer);
            });
            this.getParser = (0, (0, parcelRequire("8QpSo")).default)((tokens)=>new (0, (0, parcelRequire("k9No4")).JQLParser)(tokens));
        }
    }
});
parcelRegister("hCaMj", function(module, exports) {
    "use strict";
    var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
            enumerable: true,
            get: function() {
                return m[k];
            }
        });
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);
});
parcelRegister("fJ9SA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("1lYFk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("g8XSE", function(module, exports) {
    "use strict";
    var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ANTLRInputStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $d6D31 = parcelRequire("d6D31");
    var $ceaEj = parcelRequire("ceaEj");
    const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
    const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
    class $bc0bd7b6659a2632$var$ANTLRInputStream {
        constructor(input){
            this.p = 0;
            this.data = input;
            this.n = input.length;
        }
        reset() {
            this.p = 0;
        }
        consume() {
            if (this.p >= this.n) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new Error("cannot consume EOF");
            }
            if (this.p < this.n) this.p++;
        }
        LA(i) {
            if (i === 0) return 0;
            if (i < 0) {
                i++;
                if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF;
            }
            if (this.p + i - 1 >= this.n) return $ceaEj.IntStream.EOF;
            return this.data.charCodeAt(this.p + i - 1);
        }
        LT(i) {
            return this.LA(i);
        }
        get index() {
            return this.p;
        }
        get size() {
            return this.n;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            if (index <= this.p) {
                this.p = index;
                return;
            }
            index = Math.min(index, this.n);
            while(this.p < index)this.consume();
        }
        getText(interval) {
            let start = interval.a;
            let stop = interval.b;
            if (stop >= this.n) stop = this.n - 1;
            let count = stop - start + 1;
            if (start >= this.n) return "";
            return this.data.substr(start, count);
        }
        get sourceName() {
            if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return this.name;
        }
        toString() {
            return this.data;
        }
    }
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
    module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;
});
parcelRegister("bbHFU", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $825299b5d0c0a9a5$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $825299b5d0c0a9a5$var$_typeof(o);
    }
    function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
        var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
        return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
        if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $8JAro = parcelRequire("8JAro");
    var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;
    var $3ZLjA = parcelRequire("3ZLjA");
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
    var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;
    var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();
    var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();
    var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
    var $825299b5d0c0a9a5$var$errorCache = new Map();
    var $825299b5d0c0a9a5$var$isDeepEqual;
    var $825299b5d0c0a9a5$var$isDeepStrictEqual;
    var $825299b5d0c0a9a5$var$parseExpressionAt;
    var $825299b5d0c0a9a5$var$findNodeAround;
    var $825299b5d0c0a9a5$var$decoder;
    function $825299b5d0c0a9a5$var$lazyLoadComparison() {
        var comparison = (parcelRequire("dztjv"));
        $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
        $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
    }
    var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
    var $825299b5d0c0a9a5$var$meta = [
        "\\u0000",
        "\\u0001",
        "\\u0002",
        "\\u0003",
        "\\u0004",
        "\\u0005",
        "\\u0006",
        "\\u0007",
        '\\b',
        '',
        '',
        "\\u000b",
        '\\f',
        '',
        "\\u000e",
        "\\u000f",
        "\\u0010",
        "\\u0011",
        "\\u0012",
        "\\u0013",
        "\\u0014",
        "\\u0015",
        "\\u0016",
        "\\u0017",
        "\\u0018",
        "\\u0019",
        "\\u001a",
        "\\u001b",
        "\\u001c",
        "\\u001d",
        "\\u001e",
        "\\u001f"
    ];
    var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
        return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
    };
    var $825299b5d0c0a9a5$var$warned = false;
    var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
    var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
    function $825299b5d0c0a9a5$var$innerFail(obj) {
        if (obj.message instanceof Error) throw obj.message;
        throw new $3ZLjA(obj);
    }
    function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
        var argsLen = arguments.length;
        var internalMessage;
        if (argsLen === 0) internalMessage = 'Failed';
        else if (argsLen === 1) {
            message = actual;
            actual = undefined;
        } else {
            if ($825299b5d0c0a9a5$var$warned === false) {
                $825299b5d0c0a9a5$var$warned = true;
                var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
                warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
            }
            if (argsLen === 2) operator = '!=';
        }
        if (message instanceof Error) throw message;
        var errArgs = {
            actual: actual,
            expected: expected,
            operator: operator === undefined ? 'fail' : operator,
            stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
        };
        if (message !== undefined) errArgs.message = message;
        var err = new $3ZLjA(errArgs);
        if (internalMessage) {
            err.message = internalMessage;
            err.generatedMessage = true;
        }
        throw err;
    }
    $825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
    $825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
    function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
        if (!value) {
            var generatedMessage = false;
            if (argLen === 0) {
                generatedMessage = true;
                message = 'No value argument passed to `assert.ok()`';
            } else if (message instanceof Error) throw message;
            var err = new $3ZLjA({
                actual: value,
                expected: true,
                message: message,
                operator: '==',
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    function $825299b5d0c0a9a5$var$ok() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$ok,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
    $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '==',
            stackStartFn: equal
        });
    };
    $825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '!=',
            stackStartFn: notEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepEqual',
            stackStartFn: deepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepEqual',
            stackStartFn: notDeepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepStrictEqual',
            stackStartFn: deepStrictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
    function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepStrictEqual',
            stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
        });
    }
    $825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'strictEqual',
            stackStartFn: strictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notStrictEqual',
            stackStartFn: notStrictEqual
        });
    };
    var $825299b5d0c0a9a5$var$Comparison = $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
        var _this = this;
        $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
        keys.forEach(function(key) {
            if (key in obj) {
                if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                else _this[key] = obj[key];
            }
        });
    });
    function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
        if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
            if (!message) {
                var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
                var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
                var err = new $3ZLjA({
                    actual: a,
                    expected: b,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.actual = actual;
                err.expected = expected;
                err.operator = fn.name;
                throw err;
            }
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: fn.name,
                stackStartFn: fn
            });
        }
    }
    function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
        if (typeof expected !== 'function') {
            if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
            if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
                'Function',
                'RegExp'
            ], expected);
            if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
                var err = new $3ZLjA({
                    actual: actual,
                    expected: expected,
                    message: msg,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.operator = fn.name;
                throw err;
            }
            var keys = Object.keys(expected);
            if (expected instanceof Error) keys.push('name', 'message');
            else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
            if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
            keys.forEach(function(key) {
                if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
                $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
            });
            return true;
        }
        if (expected.prototype !== undefined && actual instanceof expected) return true;
        if (Error.isPrototypeOf(expected)) return false;
        return expected.call({}, actual) === true;
    }
    function $825299b5d0c0a9a5$var$getActual(fn) {
        if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
        try {
            fn();
        } catch (e) {
            return e;
        }
        return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
    }
    function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
        return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
    }
    function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
        return Promise.resolve().then(function() {
            var resultPromise;
            if (typeof promiseFn === 'function') {
                resultPromise = promiseFn();
                if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
            } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
            else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
                'Function',
                'Promise'
            ], promiseFn);
            return Promise.resolve().then(function() {
                return resultPromise;
            }).then(function() {
                return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
            }).catch(function(e) {
                return e;
            });
        });
    }
    function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
        if (typeof error === 'string') {
            if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
                'Object',
                'Error',
                'Function',
                'RegExp'
            ], error);
            if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
                if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
            } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
            message = error;
            error = undefined;
        } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
            var details = '';
            if (error && error.name) details += " (".concat(error.name, ")");
            details += message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: undefined,
                expected: error,
                operator: stackStartFn.name,
                message: "Missing expected ".concat(fnType).concat(details),
                stackStartFn: stackStartFn
            });
        }
        if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
    }
    function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
        if (typeof error === 'string') {
            message = error;
            error = undefined;
        }
        if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
            var details = message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: error,
                operator: stackStartFn.name,
                message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
                stackStartFn: stackStartFn
            });
        }
        throw actual;
    }
    $825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            throws,
            $825299b5d0c0a9a5$var$getActual(promiseFn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
                rejects,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotThrow,
            $825299b5d0c0a9a5$var$getActual(fn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
        return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
                doesNotReject,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
        if (err !== null && err !== undefined) {
            var message = 'ifError got unwanted exception: ';
            if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
                if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                else message += err.message;
            } else message += $825299b5d0c0a9a5$var$inspect(err);
            var newErr = new $3ZLjA({
                actual: err,
                expected: null,
                operator: 'ifError',
                message: message,
                stackStartFn: ifError
            });
            var origStack = err.stack;
            if (typeof origStack === 'string') {
                var tmp2 = origStack.split('\n');
                tmp2.shift();
                var tmp1 = newErr.stack.split('\n');
                for(var i = 0; i < tmp2.length; i++){
                    var pos = tmp1.indexOf(tmp2[i]);
                    if (pos !== -1) {
                        tmp1 = tmp1.slice(0, pos);
                        break;
                    }
                }
                newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
            }
            throw newErr;
        }
    };
    function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
        if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
        var match = fnName === 'match';
        if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
            if (message instanceof Error) throw message;
            var generatedMessage = !message;
            message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
            var err = new $3ZLjA({
                actual: string,
                expected: regexp,
                message: message,
                operator: fnName,
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    $825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
    };
    $825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
    };
    function $825299b5d0c0a9a5$var$strict() {
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$strict,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
        equal: $825299b5d0c0a9a5$var$assert.strictEqual,
        deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
        notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
        notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
    });
    $825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;
});
parcelRegister("8JAro", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$65becb1820e5a079$export$e45cb6485273080e, (v)=>$65becb1820e5a079$export$e45cb6485273080e = v);
    var $65becb1820e5a079$export$e45cb6485273080e;
    'use strict';
    function $65becb1820e5a079$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $65becb1820e5a079$var$_typeof(o);
    }
    function $65becb1820e5a079$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $65becb1820e5a079$var$_toPropertyKey(arg) {
        var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
        return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $65becb1820e5a079$var$_toPrimitive(input, hint) {
        if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $65becb1820e5a079$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
    }
    function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
        $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $65becb1820e5a079$var$_setPrototypeOf(o, p);
    }
    function $65becb1820e5a079$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
        };
    }
    function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
        if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $65becb1820e5a079$var$_assertThisInitialized(self);
    }
    function $65becb1820e5a079$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $65becb1820e5a079$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $65becb1820e5a079$var$_getPrototypeOf(o) {
        $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $65becb1820e5a079$var$_getPrototypeOf(o);
    }
    var $65becb1820e5a079$var$codes = {};
    var $65becb1820e5a079$var$assert;
    var $65becb1820e5a079$var$util;
    function $65becb1820e5a079$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $65becb1820e5a079$var$_inherits(NodeError, _Base);
            var _super = $65becb1820e5a079$var$_createSuper(NodeError);
            function NodeError(arg1, arg2, arg3) {
                var _this;
                $65becb1820e5a079$var$_classCallCheck(this, NodeError);
                _this = _super.call(this, getMessage(arg1, arg2, arg3));
                _this.code = code;
                return _this;
            }
            return $65becb1820e5a079$var$_createClass(NodeError);
        }(Base);
        $65becb1820e5a079$var$codes[code] = NodeError;
    }
    function $65becb1820e5a079$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $65becb1820e5a079$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $65becb1820e5a079$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $65becb1820e5a079$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
        var determiner;
        if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($65becb1820e5a079$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        else {
            var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
        return msg;
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
        var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
        if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
        var inspected = $65becb1820e5a079$var$util.inspect(value);
        if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
        return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
    }, TypeError, RangeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
        var type;
        if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
        else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
        return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
        var msg = 'The ';
        var len = args.length;
        args = args.map(function(a) {
            return "\"".concat(a, "\"");
        });
        switch(len){
            case 1:
                msg += "".concat(args[0], " argument");
                break;
            case 2:
                msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                break;
            default:
                msg += args.slice(0, len - 1).join(', ');
                msg += ", and ".concat(args[len - 1], " arguments");
                break;
        }
        return "".concat(msg, " must be specified");
    }, TypeError);
    $65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;
});
parcelRegister("9kAQu", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
    module.exports.format = function(f) {
        if (!$6cb29018fbdc8fcc$var$isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
            return objects.join(' ');
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
        else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
        return str;
    };
    module.exports.deprecate = function(fn, msg) {
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
        if (typeof $6cAn5 === 'undefined') return function() {
            return module.exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($6cAn5.throwDeprecation) throw new Error(msg);
                else if ($6cAn5.traceDeprecation) console.trace(msg);
                else console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var $6cb29018fbdc8fcc$var$debugs = {};
    var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
    var $6cb29018fbdc8fcc$var$debugEnv;
    module.exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!$6cb29018fbdc8fcc$var$debugs[set]) {
            if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
                var pid = $6cAn5.pid;
                $6cb29018fbdc8fcc$var$debugs[set] = function() {
                    var msg = module.exports.format.apply(module.exports, arguments);
                    console.error('%s %d: %s', set, pid, msg);
                };
            } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
        }
        return $6cb29018fbdc8fcc$var$debugs[set];
    };
    function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
        var ctx = {
            seen: [],
            stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
        };
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if ($6cb29018fbdc8fcc$var$isBoolean(opts)) ctx.showHidden = opts;
        else if (opts) module.exports._extend(ctx, opts);
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
        return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
    }
    module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
    $6cb29018fbdc8fcc$var$inspect.colors = {
        'bold': [
            1,
            22
        ],
        'italic': [
            3,
            23
        ],
        'underline': [
            4,
            24
        ],
        'inverse': [
            7,
            27
        ],
        'white': [
            37,
            39
        ],
        'grey': [
            90,
            39
        ],
        'black': [
            30,
            39
        ],
        'blue': [
            34,
            39
        ],
        'cyan': [
            36,
            39
        ],
        'green': [
            32,
            39
        ],
        'magenta': [
            35,
            39
        ],
        'red': [
            31,
            39
        ],
        'yellow': [
            33,
            39
        ]
    };
    $6cb29018fbdc8fcc$var$inspect.styles = {
        'special': 'cyan',
        'number': 'yellow',
        'boolean': 'yellow',
        'undefined': 'grey',
        'null': 'bold',
        'string': 'green',
        'date': 'magenta',
        'regexp': 'red'
    };
    function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
        var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
        if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
        else return str;
    }
    function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
        return str;
    }
    function $6cb29018fbdc8fcc$var$arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && value.inspect !== module.exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
        if (primitive) return primitive;
        var keys = Object.keys(value);
        var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0) {
            if ($6cb29018fbdc8fcc$var$isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
            }
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
            if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
        }
        var base = '', array = false, braces = [
            '{',
            '}'
        ];
        if ($6cb29018fbdc8fcc$var$isArray(value)) {
            array = true;
            braces = [
                '[',
                ']'
            ];
        }
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var n = value.name ? ': ' + value.name : '';
            base = ' [Function' + n + ']';
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
        if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
        if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            else return ctx.stylize('[Object]', 'special');
        }
        ctx.seen.push(value);
        var output;
        if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
    }
    function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
        if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
        if ($6cb29018fbdc8fcc$var$isString(value)) {
            var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
            return ctx.stylize(simple, 'string');
        }
        if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
        if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
        if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
    }
    function $6cb29018fbdc8fcc$var$formatError(value) {
        return '[' + Error.prototype.toString.call(value) + ']';
    }
    function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push('');
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
            else str = ctx.stylize('[Getter]', 'special');
        } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
        if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
                else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf('\n') > -1) {
                    if (array) str = str.split('\n').map(function(line) {
                        return '  ' + line;
                    }).join('\n').slice(2);
                    else str = '\n' + str.split('\n').map(function(line) {
                        return '   ' + line;
                    }).join('\n');
                }
            } else str = ctx.stylize('[Circular]', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify('' + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.slice(1, -1);
                name = ctx.stylize(name, 'name');
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
            }
        }
        return name + ': ' + str;
    }
    function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
            numLinesEst++;
            if (cur.indexOf('\n') >= 0) numLinesEst++;
            return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
        return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }
    module.exports.types = (parcelRequire("jGyMi"));
    function $6cb29018fbdc8fcc$var$isArray(ar) {
        return Array.isArray(ar);
    }
    module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
    function $6cb29018fbdc8fcc$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
    function $6cb29018fbdc8fcc$var$isNull(arg) {
        return arg === null;
    }
    module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
    function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
    function $6cb29018fbdc8fcc$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
    function $6cb29018fbdc8fcc$var$isString(arg) {
        return typeof arg === 'string';
    }
    module.exports.isString = $6cb29018fbdc8fcc$var$isString;
    function $6cb29018fbdc8fcc$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
    function $6cb29018fbdc8fcc$var$isUndefined(arg) {
        return arg === void 0;
    }
    module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
    function $6cb29018fbdc8fcc$var$isRegExp(re) {
        return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
    }
    module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    function $6cb29018fbdc8fcc$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
    function $6cb29018fbdc8fcc$var$isDate(d) {
        return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
    }
    module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
    module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
    function $6cb29018fbdc8fcc$var$isError(e) {
        return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
    }
    module.exports.isError = $6cb29018fbdc8fcc$var$isError;
    module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
    function $6cb29018fbdc8fcc$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
    function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;
    module.exports.isBuffer = (parcelRequire("kEU0N"));
    function $6cb29018fbdc8fcc$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function $6cb29018fbdc8fcc$var$pad(n) {
        return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }
    var $6cb29018fbdc8fcc$var$months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    function $6cb29018fbdc8fcc$var$timestamp() {
        var d = new Date();
        var time = [
            $6cb29018fbdc8fcc$var$pad(d.getHours()),
            $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
            $6cb29018fbdc8fcc$var$pad(d.getSeconds())
        ].join(':');
        return [
            d.getDate(),
            $6cb29018fbdc8fcc$var$months[d.getMonth()],
            time
        ].join(' ');
    }
    module.exports.log = function() {
        console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
    };
    module.exports.inherits = (parcelRequire("v3bBu"));
    module.exports._extend = function(origin, add) {
        if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
    module.exports.promisify = function promisify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
            var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
            if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    };
    module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
    function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
        if (!reason) {
            var newReason = new Error('Promise was rejected with a falsy value');
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function $6cb29018fbdc8fcc$var$callbackify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
            var self = this;
            var cb = function() {
                return maybeCb.apply(self, arguments);
            };
            original.apply(this, args).then(function(ret) {
                $6cAn5.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
        return callbackified;
    }
    module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;
});
parcelRegister("jGyMi", function(module, exports) {
    'use strict';
    var $eyPxb = parcelRequire("eyPxb");
    var $kF7vh = parcelRequire("kF7vh");
    var $hdl59;
    var $dFTgY;
    function $e54ceaba9c647d57$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
    var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
    var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
    var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
    var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
    var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
    if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
    if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
    function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== 'object') return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    module.exports.isArgumentsObject = $eyPxb;
    module.exports.isGeneratorFunction = $kF7vh;
    module.exports.isTypedArray = (0, parcelRequire("dFTgY"));
    function $e54ceaba9c647d57$var$isPromise(input) {
        return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
    }
    module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
    function $e54ceaba9c647d57$var$isArrayBufferView(value) {
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return (0, parcelRequire("dFTgY"))(value) || $e54ceaba9c647d57$var$isDataView(value);
    }
    module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
    function $e54ceaba9c647d57$var$isUint8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8Array';
    }
    module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
    function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8ClampedArray';
    }
    module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
    function $e54ceaba9c647d57$var$isUint16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint16Array';
    }
    module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
    function $e54ceaba9c647d57$var$isUint32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint32Array';
    }
    module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
    function $e54ceaba9c647d57$var$isInt8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int8Array';
    }
    module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
    function $e54ceaba9c647d57$var$isInt16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int16Array';
    }
    module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
    function $e54ceaba9c647d57$var$isInt32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int32Array';
    }
    module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
    function $e54ceaba9c647d57$var$isFloat32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float32Array';
    }
    module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
    function $e54ceaba9c647d57$var$isFloat64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float64Array';
    }
    module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
    function $e54ceaba9c647d57$var$isBigInt64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigInt64Array';
    }
    module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
    function $e54ceaba9c647d57$var$isBigUint64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigUint64Array';
    }
    module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
    function $e54ceaba9c647d57$var$isMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
    }
    $e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
    function $e54ceaba9c647d57$var$isMap(value) {
        if (typeof Map === 'undefined') return false;
        return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
    }
    module.exports.isMap = $e54ceaba9c647d57$var$isMap;
    function $e54ceaba9c647d57$var$isSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
    }
    $e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
    function $e54ceaba9c647d57$var$isSet(value) {
        if (typeof Set === 'undefined') return false;
        return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
    }
    module.exports.isSet = $e54ceaba9c647d57$var$isSet;
    function $e54ceaba9c647d57$var$isWeakMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
    }
    $e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
    function $e54ceaba9c647d57$var$isWeakMap(value) {
        if (typeof WeakMap === 'undefined') return false;
        return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
    }
    module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
    function $e54ceaba9c647d57$var$isWeakSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
    }
    $e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
    function $e54ceaba9c647d57$var$isWeakSet(value) {
        return $e54ceaba9c647d57$var$isWeakSetToString(value);
    }
    module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
    function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
    }
    $e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
    function $e54ceaba9c647d57$var$isArrayBuffer(value) {
        if (typeof ArrayBuffer === 'undefined') return false;
        return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
    function $e54ceaba9c647d57$var$isDataViewToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
    }
    $e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function $e54ceaba9c647d57$var$isDataView(value) {
        if (typeof DataView === 'undefined') return false;
        return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
    }
    module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
    var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
    function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
    }
    function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
        if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
        if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
        return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
    }
    module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
    function $e54ceaba9c647d57$var$isAsyncFunction(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
    }
    module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
    function $e54ceaba9c647d57$var$isMapIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
    }
    module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
    function $e54ceaba9c647d57$var$isSetIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
    }
    module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
    function $e54ceaba9c647d57$var$isGeneratorObject(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
    }
    module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
    function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
    }
    module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
    function $e54ceaba9c647d57$var$isNumberObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
    }
    module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
    function $e54ceaba9c647d57$var$isStringObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
    }
    module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
    function $e54ceaba9c647d57$var$isBooleanObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
    }
    module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
    function $e54ceaba9c647d57$var$isBigIntObject(value) {
        return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
    }
    module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
    function $e54ceaba9c647d57$var$isSymbolObject(value) {
        return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
    }
    module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
    function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
        return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
    }
    module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
    function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
        return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
    }
    module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
    [
        'isProxy',
        'isExternal',
        'isModuleNamespaceObject'
    ].forEach(function(method) {
        Object.defineProperty(module.exports, method, {
            enumerable: false,
            value: function() {
                throw new Error(method + ' is not supported in userland');
            }
        });
    });
});
parcelRegister("eyPxb", function(module, exports) {
    'use strict';
    var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $53KqO = parcelRequire("53KqO");
    var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
    var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
        return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
    };
    var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
        return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
    };
    var $a99c3747cd09063d$var$supportsStandardArguments = function() {
        return $a99c3747cd09063d$var$isStandardArguments(arguments);
    }();
    $a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments;
    module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;
});
parcelRegister("fmBzB", function(module, exports) {
    'use strict';
    var $9T9x9 = parcelRequire("9T9x9");
    module.exports = function hasToStringTagShams() {
        return $9T9x9() && !!Symbol.toStringTag;
    };
});
parcelRegister("kF7vh", function(module, exports) {
    'use strict';
    var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
    var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
    var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;
    var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
    var $f0ad750370f41c64$var$getGeneratorFunc = function() {
        if (!$f0ad750370f41c64$var$hasToStringTag) return false;
        try {
            return Function('return function*() {}')();
        } catch (e) {}
    };
    var $f0ad750370f41c64$var$GeneratorFunction;
    module.exports = function isGeneratorFunction(fn) {
        if (typeof fn !== 'function') return false;
        if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
        if (!$f0ad750370f41c64$var$hasToStringTag) {
            var str = $f0ad750370f41c64$var$toStr.call(fn);
            return str === '[object GeneratorFunction]';
        }
        if (!$f0ad750370f41c64$var$getProto) return false;
        if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
            var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
            $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
        }
        return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
    };
});
parcelRegister("hdl59", function(module, exports) {
    'use strict';
    var $258uT = parcelRequire("258uT");
    var $9ME5O;
    var $h05ZS = parcelRequire("h05ZS");
    var $53KqO = parcelRequire("53KqO");
    var $lBvcQ;
    var $c884010d01443113$var$$toString = $53KqO('Object.prototype.toString');
    var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    var $c884010d01443113$var$typedArrays = (0, parcelRequire("9ME5O"))();
    var $c884010d01443113$var$$slice = $53KqO('String.prototype.slice');
    var $c884010d01443113$var$getPrototypeOf = Object.getPrototypeOf;
    var $c884010d01443113$var$$indexOf = $53KqO('Array.prototype.indexOf', true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var $c884010d01443113$var$cache = {
        __proto__: null
    };
    if ($c884010d01443113$var$hasToStringTag && (0, parcelRequire("lBvcQ")) && $c884010d01443113$var$getPrototypeOf) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $c884010d01443113$var$getPrototypeOf(arr);
            var descriptor = (0, parcelRequire("lBvcQ"))(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $c884010d01443113$var$getPrototypeOf(proto);
                descriptor = (0, parcelRequire("lBvcQ"))(superProto, Symbol.toStringTag);
            }
            $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
        }
    });
    else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(fn);
    });
    var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, typedArray) {
            if (!found) try {
                if ('$' + getter(value) === typedArray) found = $c884010d01443113$var$$slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, name) {
            if (!found) try {
                getter(value);
                found = $c884010d01443113$var$$slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    module.exports = function whichTypedArray(value) {
        if (!value || typeof value !== 'object') return false;
        if (!$c884010d01443113$var$hasToStringTag) {
            var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
            if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
            if (tag !== 'Object') return false;
            return $c884010d01443113$var$trySlices(value);
        }
        if (!(0, parcelRequire("lBvcQ"))) return null;
        return $c884010d01443113$var$tryTypedArrays(value);
    };
});
parcelRegister("258uT", function(module, exports) {
    'use strict';
    var $f0Tdg = parcelRequire("f0Tdg");
    var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
    var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
        for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var $1842a3cb7df292b5$var$forEach = function forEach(list, iterator, thisArg) {
        if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if ($1842a3cb7df292b5$var$toStr.call(list) === '[object Array]') $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
        else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
        else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
    };
    module.exports = $1842a3cb7df292b5$var$forEach;
});
parcelRegister("f0Tdg", function(module, exports) {
    'use strict';
    var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
    var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
    var $02d21778b0eebae4$var$badArrayLike;
    var $02d21778b0eebae4$var$isCallableMarker;
    if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
        $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
            get: function() {
                throw $02d21778b0eebae4$var$isCallableMarker;
            }
        });
        $02d21778b0eebae4$var$isCallableMarker = {};
        $02d21778b0eebae4$var$reflectApply(function() {
            throw 42;
        }, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (_) {
        if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
    }
    else $02d21778b0eebae4$var$reflectApply = null;
    var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
    var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
            return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
            $02d21778b0eebae4$var$fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
    var $02d21778b0eebae4$var$objectClass = '[object Object]';
    var $02d21778b0eebae4$var$fnClass = '[object Function]';
    var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
    var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]';
    var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
    var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]';
    var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;
    var $02d21778b0eebae4$var$isIE68 = !(0 in [
        , 
    ]);
    var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === 'object') {
        var $02d21778b0eebae4$var$all = document.all;
        if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
            if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
                var str = $02d21778b0eebae4$var$toStr.call(value);
                return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 || str === $02d21778b0eebae4$var$objectClass) && value('') == null;
            } catch (e) {}
            return false;
        };
    }
    module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        try {
            $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
        } catch (e) {
            if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
        }
        return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
    } : function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        var strClass = $02d21778b0eebae4$var$toStr.call(value);
        if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
        return $02d21778b0eebae4$var$tryFunctionObject(value);
    };
});
parcelRegister("9ME5O", function(module, exports) {
    'use strict';
    var $8a51N;
    var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    module.exports = function availableTypedArrays() {
        var out = [];
        for(var i = 0; i < (0, parcelRequire("8a51N")).length; i++)if (typeof $71f7b254c38edcde$var$g[(0, parcelRequire("8a51N"))[i]] === 'function') out[out.length] = (0, parcelRequire("8a51N"))[i];
        return out;
    };
});
parcelRegister("8a51N", function(module, exports) {
    'use strict';
    module.exports = [
        'Float32Array',
        'Float64Array',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'BigInt64Array',
        'BigUint64Array'
    ];
});
parcelRegister("dFTgY", function(module, exports) {
    'use strict';
    var $hdl59;
    module.exports = function isTypedArray(value) {
        return !!(0, parcelRequire("hdl59"))(value);
    };
});
parcelRegister("kEU0N", function(module, exports) {
    module.exports = function isBuffer(arg) {
        return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("3ZLjA", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $2e8bc5606025d797$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $2e8bc5606025d797$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
                $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
        key = $2e8bc5606025d797$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $2e8bc5606025d797$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $2e8bc5606025d797$var$_toPropertyKey(arg) {
        var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
        return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
        if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
    }
    function $2e8bc5606025d797$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
        };
    }
    function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
        if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $2e8bc5606025d797$var$_assertThisInitialized(self);
    }
    function $2e8bc5606025d797$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
        };
        return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
    }
    function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
        if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
        else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return $2e8bc5606025d797$var$_construct.apply(null, arguments);
    }
    function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $2e8bc5606025d797$var$_isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
        $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
    }
    function $2e8bc5606025d797$var$_getPrototypeOf(o) {
        $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $2e8bc5606025d797$var$_getPrototypeOf(o);
    }
    function $2e8bc5606025d797$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $2e8bc5606025d797$var$_typeof(o);
    }
    var $9kAQu = parcelRequire("9kAQu");
    var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;
    var $8JAro = parcelRequire("8JAro");
    var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
    function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $2e8bc5606025d797$var$repeat(str, count) {
        count = Math.floor(count);
        if (str.length == 0 || count == 0) return '';
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while(count){
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
    var $2e8bc5606025d797$var$blue = '';
    var $2e8bc5606025d797$var$green = '';
    var $2e8bc5606025d797$var$red = '';
    var $2e8bc5606025d797$var$white = '';
    var $2e8bc5606025d797$var$kReadableOperator = {
        deepStrictEqual: 'Expected values to be strictly deep-equal:',
        strictEqual: 'Expected values to be strictly equal:',
        strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
        deepEqual: 'Expected values to be loosely deep-equal:',
        equal: 'Expected values to be loosely equal:',
        notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
        notStrictEqual: 'Expected "actual" to be strictly unequal to:',
        notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
        notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
        notEqual: 'Expected "actual" to be loosely unequal to:',
        notIdentical: 'Values identical but not reference-equal:'
    };
    var $2e8bc5606025d797$var$kMaxShortLength = 10;
    function $2e8bc5606025d797$var$copyError(source) {
        var keys = Object.keys(source);
        var target = Object.create(Object.getPrototypeOf(source));
        keys.forEach(function(key) {
            target[key] = source[key];
        });
        Object.defineProperty(target, 'message', {
            value: source.message
        });
        return target;
    }
    function $2e8bc5606025d797$var$inspectValue(val) {
        return $2e8bc5606025d797$var$inspect(val, {
            compact: false,
            customInspect: false,
            depth: 1000,
            maxArrayLength: Infinity,
            showHidden: false,
            breakLength: Infinity,
            showProxy: false,
            sorted: true,
            getters: true
        });
    }
    function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
        var other = '';
        var res = '';
        var lastPos = 0;
        var end = '';
        var skipped = false;
        var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
        var actualLines = actualInspected.split('\n');
        var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
        var i = 0;
        var indicator = '';
        if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
        if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
            var inputLength = actualLines[0].length + expectedLines[0].length;
            if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
                if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
            } else if (operator !== 'strictEqualObject') {
                var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
                if (inputLength < maxLength) {
                    while(actualLines[0][i] === expectedLines[0][i])i++;
                    if (i > 2) {
                        indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                        i = 0;
                    }
                }
            }
        }
        var a = actualLines[actualLines.length - 1];
        var b = expectedLines[expectedLines.length - 1];
        while(a === b){
            if (i++ < 2) end = "\n  ".concat(a).concat(end);
            else other = a;
            actualLines.pop();
            expectedLines.pop();
            if (actualLines.length === 0 || expectedLines.length === 0) break;
            a = actualLines[actualLines.length - 1];
            b = expectedLines[expectedLines.length - 1];
        }
        var maxLines = Math.max(actualLines.length, expectedLines.length);
        if (maxLines === 0) {
            var _actualLines = actualInspected.split('\n');
            if (_actualLines.length > 30) {
                _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                while(_actualLines.length > 27)_actualLines.pop();
            }
            return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
        }
        if (i > 3) {
            end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
            skipped = true;
        }
        if (other !== '') {
            end = "\n  ".concat(other).concat(end);
            other = '';
        }
        var printedLines = 0;
        var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
        var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
        for(i = 0; i < maxLines; i++){
            var cur = i - lastPos;
            if (actualLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(expectedLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(expectedLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
                printedLines++;
            } else if (expectedLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
                printedLines++;
            } else {
                var expectedLine = expectedLines[i];
                var actualLine = actualLines[i];
                var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
                if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                    divergingLines = false;
                    actualLine += ',';
                }
                if (divergingLines) {
                    if (cur > 1 && i > 2) {
                        if (cur > 4) {
                            res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                            skipped = true;
                        } else if (cur > 3) {
                            res += "\n  ".concat(actualLines[i - 2]);
                            printedLines++;
                        }
                        res += "\n  ".concat(actualLines[i - 1]);
                        printedLines++;
                    }
                    lastPos = i;
                    res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                    other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                    printedLines += 2;
                } else {
                    res += other;
                    other = '';
                    if (cur === 1 || i === 0) {
                        res += "\n  ".concat(actualLine);
                        printedLines++;
                    }
                }
            }
            if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
        }
        return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
    }
    var $2e8bc5606025d797$var$AssertionError = function(_Error, _inspect$custom) {
        $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
        var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
        function AssertionError(options) {
            var _this;
            $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
            if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
            var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
            var actual = options.actual, expected = options.expected;
            var limit = Error.stackTraceLimit;
            Error.stackTraceLimit = 0;
            if (message != null) _this = _super.call(this, String(message));
            else {
                if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                    if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                        $2e8bc5606025d797$var$blue = "\x1B[34m";
                        $2e8bc5606025d797$var$green = "\x1B[32m";
                        $2e8bc5606025d797$var$white = "\x1B[39m";
                        $2e8bc5606025d797$var$red = "\x1B[31m";
                    } else {
                        $2e8bc5606025d797$var$blue = '';
                        $2e8bc5606025d797$var$green = '';
                        $2e8bc5606025d797$var$white = '';
                        $2e8bc5606025d797$var$red = '';
                    }
                }
                if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                    actual = $2e8bc5606025d797$var$copyError(actual);
                    expected = $2e8bc5606025d797$var$copyError(expected);
                }
                if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
                else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                    var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                    var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                    if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                    if (res.length > 30) {
                        res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        while(res.length > 27)res.pop();
                    }
                    if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                    else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
                } else {
                    var _res = $2e8bc5606025d797$var$inspectValue(actual);
                    var other = '';
                    var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                    if (operator === 'notDeepEqual' || operator === 'notEqual') {
                        _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                        if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                    } else {
                        other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                        if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                        if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                        if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                        else other = " ".concat(operator, " ").concat(other);
                    }
                    _this = _super.call(this, "".concat(_res).concat(other));
                }
            }
            Error.stackTraceLimit = limit;
            _this.generatedMessage = !message;
            Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
                value: 'AssertionError [ERR_ASSERTION]',
                enumerable: false,
                writable: true,
                configurable: true
            });
            _this.code = 'ERR_ASSERTION';
            _this.actual = actual;
            _this.expected = expected;
            _this.operator = operator;
            if (Error.captureStackTrace) Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
            _this.stack;
            _this.name = 'AssertionError';
            return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
        }
        $2e8bc5606025d797$var$_createClass(AssertionError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                }
            },
            {
                key: _inspect$custom,
                value: function value(recurseTimes, ctx) {
                    return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                        customInspect: false,
                        depth: 0
                    }));
                }
            }
        ]);
        return AssertionError;
    }($2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
    module.exports = $2e8bc5606025d797$var$AssertionError;
});
parcelRegister("8s5ew", function(module, exports) {
    'use strict';
    var $3WQC3 = parcelRequire("3WQC3");
    var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
        if (!Object.assign) return false;
        var str = 'abcdefghijklmnopqrst';
        var letters = str.split('');
        var map = {};
        for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
        var obj = Object.assign({}, map);
        var actual = '';
        for(var k in obj)actual += k;
        return str !== actual;
    };
    var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
        if (!Object.assign || !Object.preventExtensions) return false;
        var thrower = Object.preventExtensions({
            1: 2
        });
        try {
            Object.assign(thrower, 'xy');
        } catch (e) {
            return thrower[1] === 'y';
        }
        return false;
    };
    module.exports = function getPolyfill() {
        if (!Object.assign) return $3WQC3;
        if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
        if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
        return Object.assign;
    };
});
parcelRegister("3WQC3", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();
    var $53KqO = parcelRequire("53KqO");
    var $2dff99ad8985d37e$var$toObject = Object;
    var $2dff99ad8985d37e$var$$push = $53KqO('Array.prototype.push');
    var $2dff99ad8985d37e$var$$propIsEnumerable = $53KqO('Object.prototype.propertyIsEnumerable');
    var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? Object.getOwnPropertySymbols : null;
    module.exports = function assign(target, source1) {
        if (target == null) throw new TypeError('target must be an object');
        var to = $2dff99ad8985d37e$var$toObject(target);
        if (arguments.length === 1) return to;
        for(var s = 1; s < arguments.length; ++s){
            var from = $2dff99ad8985d37e$var$toObject(arguments[s]);
            var keys = $dZMWQ(from);
            var getSymbols = $2dff99ad8985d37e$var$hasSymbols && (Object.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
            if (getSymbols) {
                var syms = getSymbols(from);
                for(var j = 0; j < syms.length; ++j){
                    var key = syms[j];
                    if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
                }
            }
            for(var i = 0; i < keys.length; ++i){
                var nextKey = keys[i];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                    var propValue = from[nextKey];
                    to[nextKey] = propValue;
                }
            }
        }
        return to;
    };
});
parcelRegister("dZMWQ", function(module, exports) {
    'use strict';
    var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;
    var $1Houy = parcelRequire("1Houy");
    var $a306f0f1bb5f232a$var$origKeys = Object.keys;
    var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
        return $a306f0f1bb5f232a$var$origKeys(o);
    } : (parcelRequire("eQVXL"));
    var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
    $a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
        if (Object.keys) {
            var keysWorksWithArguments = function() {
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
            }(1, 2);
            if (!keysWorksWithArguments) Object.keys = function keys(object) {
                if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
                return $a306f0f1bb5f232a$var$originalKeys(object);
            };
        } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
        return Object.keys || $a306f0f1bb5f232a$var$keysShim;
    };
    module.exports = $a306f0f1bb5f232a$var$keysShim;
});
parcelRegister("1Houy", function(module, exports) {
    'use strict';
    var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
    module.exports = function isArguments(value) {
        var str = $13ccce2fa6936c75$var$toStr.call(value);
        var isArgs = str === '[object Arguments]';
        if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
        return isArgs;
    };
});
parcelRegister("eQVXL", function(module, exports) {
    'use strict';
    var $ad02e23a59d3730f$var$keysShim;
    if (!Object.keys) {
        var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
        var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
        var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy"));
        var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
        var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
            toString: null
        }, 'toString');
        var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
        var $ad02e23a59d3730f$var$dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var $ad02e23a59d3730f$var$excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
            if (typeof window === 'undefined') return false;
            for(var k in window)try {
                if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                    $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
                } catch (e) {
                    return true;
                }
            } catch (e) {
                return true;
            }
            return false;
        }();
        var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
            if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            try {
                return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
        $ad02e23a59d3730f$var$keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
            var isArguments = $ad02e23a59d3730f$var$isArgs(object);
            var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
            var theKeys = [];
            if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
            var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
            if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
            else {
                for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
            }
            if ($ad02e23a59d3730f$var$hasDontEnumBug) {
                var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
                for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
            }
            return theKeys;
        };
    }
    module.exports = $ad02e23a59d3730f$var$keysShim;
});
parcelRegister("eJazH", function(module, exports) {
    'use strict';
    var $iwNFM = parcelRequire("iwNFM");
    module.exports = function getPolyfill() {
        return typeof Object.is === 'function' ? Object.is : $iwNFM;
    };
});
parcelRegister("iwNFM", function(module, exports) {
    'use strict';
    var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
        return value !== value;
    };
    module.exports = function is(a, b) {
        if (a === 0 && b === 0) return 1 / a === 1 / b;
        if (a === b) return true;
        if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
        return false;
    };
});
parcelRegister("dztjv", function(module, exports) {
    'use strict';
    function $9e15485748de85e6$var$_slicedToArray(arr, i) {
        return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
    }
    function $9e15485748de85e6$var$_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    }
    function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function $9e15485748de85e6$var$_arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function $9e15485748de85e6$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $9e15485748de85e6$var$_typeof(o);
    }
    var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
    var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
        var array = [];
        set.forEach(function(value) {
            return array.push(value);
        });
        return array;
    };
    var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
        var array = [];
        map.forEach(function(value, key) {
            return array.push([
                key,
                value
            ]);
        });
        return array;
    };
    var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
    var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
        return [];
    };
    var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
    function $9e15485748de85e6$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
    var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
    var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);
    var $9kAQu = parcelRequire("9kAQu");
    var $9e15485748de85e6$require$_require$types = $9kAQu.types;
    var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
    function $9e15485748de85e6$var$isNonIndex(key) {
        if (key.length === 0 || key.length > 10) return true;
        for(var i = 0; i < key.length; i++){
            var code = key.charCodeAt(i);
            if (code < 48 || code > 57) return true;
        }
        return key.length === 10 && key >= Math.pow(2, 32);
    }
    function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
        return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
    }
    function $9e15485748de85e6$var$compare(a, b) {
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }
    var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
    var $9e15485748de85e6$var$kStrict = true;
    var $9e15485748de85e6$var$kLoose = false;
    var $9e15485748de85e6$var$kNoIterator = 0;
    var $9e15485748de85e6$var$kIsArray = 1;
    var $9e15485748de85e6$var$kIsSet = 2;
    var $9e15485748de85e6$var$kIsMap = 3;
    function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
        return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
    }
    function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        for(var offset = 0; offset < a.byteLength; offset++){
            if (a[offset] !== b[offset]) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
    }
    function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
        return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
    }
    function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
        if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
        if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
        return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
    }
    function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
        if (val1 === val2) {
            if (val1 !== 0) return true;
            return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
        }
        if (strict) {
            if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
            if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
            if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
        } else {
            if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
                if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return val1 == val2;
                return false;
            }
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
        }
        var val1Tag = $9e15485748de85e6$var$objectToString(val1);
        var val2Tag = $9e15485748de85e6$var$objectToString(val2);
        if (val1Tag !== val2Tag) return false;
        if (Array.isArray(val1)) {
            if (val1.length !== val2.length) return false;
            var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (keys1.length !== keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
        }
        if (val1Tag === '[object Object]') {
            if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
        }
        if ($9e15485748de85e6$var$isDate(val1)) {
            if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
        } else if ($9e15485748de85e6$var$isRegExp(val1)) {
            if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
            if (val1.message !== val2.message || val1.name !== val2.name) return false;
        } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
            if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
                if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
            } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
            var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (_keys.length !== _keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
        } else if ($9e15485748de85e6$var$isSet(val1)) {
            if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
        } else if ($9e15485748de85e6$var$isMap(val1)) {
            if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
        } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
            if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
    }
    function $9e15485748de85e6$var$getEnumerables(val, keys) {
        return keys.filter(function(k) {
            return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
        });
    }
    function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
        if (arguments.length === 5) {
            aKeys = Object.keys(val1);
            var bKeys = Object.keys(val2);
            if (aKeys.length !== bKeys.length) return false;
        }
        var i = 0;
        for(; i < aKeys.length; i++){
            if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
        }
        if (strict && arguments.length === 5) {
            var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
            if (symbolKeysA.length !== 0) {
                var count = 0;
                for(i = 0; i < symbolKeysA.length; i++){
                    var key = symbolKeysA[i];
                    if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                        if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                        aKeys.push(key);
                        count++;
                    } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                }
                var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
            } else {
                var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
            }
        }
        if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
        if (memos === undefined) memos = {
            val1: new Map(),
            val2: new Map(),
            position: 0
        };
        else {
            var val2MemoA = memos.val1.get(val1);
            if (val2MemoA !== undefined) {
                var val2MemoB = memos.val2.get(val2);
                if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
            }
            memos.position++;
        }
        memos.val1.set(val1, memos.position);
        memos.val2.set(val2, memos.position);
        var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
        memos.val1.delete(val1);
        memos.val2.delete(val2);
        return areEq;
    }
    function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var val2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
                set.delete(val2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
        switch($9e15485748de85e6$var$_typeof(prim)){
            case 'undefined':
                return null;
            case 'object':
                return undefined;
            case 'symbol':
                return false;
            case 'string':
                prim = +prim;
            case 'number':
                if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        return b.has(altValue) && !a.has(altValue);
    }
    function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        var curB = b.get(altValue);
        if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
        return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
    }
    function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
        var set = null;
        var aValues = $9e15485748de85e6$var$arrayFromSet(a);
        for(var i = 0; i < aValues.length; i++){
            var val = aValues[i];
            if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
                if (set === null) set = new Set();
                set.add(val);
            } else if (!b.has(val)) {
                if (strict) return false;
                if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
                if (set === null) set = new Set();
                set.add(val);
            }
        }
        if (set !== null) {
            var bValues = $9e15485748de85e6$var$arrayFromSet(b);
            for(var _i = 0; _i < bValues.length; _i++){
                var _val = bValues[_i];
                if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                    if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
                } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var key2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
                set.delete(key2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
        var set = null;
        var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
        for(var i = 0; i < aEntries.length; i++){
            var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
            if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
                if (set === null) set = new Set();
                set.add(key);
            } else {
                var item2 = b.get(key);
                if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                    if (strict) return false;
                    if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                    if (set === null) set = new Set();
                    set.add(key);
                }
            }
        }
        if (set !== null) {
            var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
            for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                    if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
        var i = 0;
        if (iterationType === $9e15485748de85e6$var$kIsSet) {
            if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
            if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
            if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
                if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
            } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
            else {
                var keysA = Object.keys(a);
                for(; i < keysA.length; i++){
                    var key = keysA[i];
                    if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
                }
                if (keysA.length !== Object.keys(b).length) return false;
                return true;
            }
        }
        for(i = 0; i < keys.length; i++){
            var _key2 = keys[i];
            if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
    }
    function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
    }
    module.exports = {
        isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
        isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
    };
});
parcelRegister("joK88", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $iwNFM = parcelRequire("iwNFM");
    var $eJazH = parcelRequire("eJazH");
    var $90RaO = parcelRequire("90RaO");
    var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
    $d94D2($e1f40ab7009ea590$var$polyfill, {
        getPolyfill: $eJazH,
        implementation: $iwNFM,
        shim: $90RaO
    });
    module.exports = $e1f40ab7009ea590$var$polyfill;
});
parcelRegister("d94D2", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
    var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
    var $991fb4ca00f3da54$var$concat = Array.prototype.concat;
    var $le88V;
    var $991fb4ca00f3da54$var$isFunction = function(fn) {
        return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
    };
    var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
    var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
        if (name in object) {
            if (predicate === true) {
                if (object[name] === value) return;
            } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
        }
        if ($991fb4ca00f3da54$var$supportsDescriptors) (0, parcelRequire("le88V"))(object, name, value, true);
        else (0, parcelRequire("le88V"))(object, name, value);
    };
    var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
        var predicates = arguments.length > 2 ? arguments[2] : {};
        var props = $dZMWQ(map);
        if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
        for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    };
    $991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
    module.exports = $991fb4ca00f3da54$var$defineProperties;
});
parcelRegister("90RaO", function(module, exports) {
    'use strict';
    var $eJazH = parcelRequire("eJazH");
    var $d94D2 = parcelRequire("d94D2");
    module.exports = function shimObjectIs() {
        var polyfill = $eJazH();
        $d94D2(Object, {
            is: polyfill
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("laO4W", function(module, exports) {
    'use strict';
    var $h05ZS = parcelRequire("h05ZS");
    var $d94D2 = parcelRequire("d94D2");
    var $hdPWo = parcelRequire("hdPWo");
    var $gmOnv = parcelRequire("gmOnv");
    var $hXuHX = parcelRequire("hXuHX");
    var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
    $d94D2($f6a160b687432d3b$var$polyfill, {
        getPolyfill: $gmOnv,
        implementation: $hdPWo,
        shim: $hXuHX
    });
    module.exports = $f6a160b687432d3b$var$polyfill;
});
parcelRegister("hdPWo", function(module, exports) {
    'use strict';
    module.exports = function isNaN(value) {
        return value !== value;
    };
});
parcelRegister("gmOnv", function(module, exports) {
    'use strict';
    var $hdPWo = parcelRequire("hdPWo");
    module.exports = function getPolyfill() {
        if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
        return $hdPWo;
    };
});
parcelRegister("hXuHX", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $gmOnv = parcelRequire("gmOnv");
    module.exports = function shimNumberIsNaN() {
        var polyfill = $gmOnv();
        $d94D2(Number, {
            isNaN: polyfill
        }, {
            isNaN: function testIsNaN() {
                return Number.isNaN !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("d6D31", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
    function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {}
    module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
    function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {}
    module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
    function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {}
    module.exports.Override = $98aa1ff32ce30be5$var$Override;
    function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
        return (target, propertyKey, descriptor)=>{};
    }
    module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;
});
parcelRegister("ceaEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntStream = void 0;
    var $8e6f0d8930cd60b2$var$IntStream;
    (function(IntStream) {
        IntStream.EOF = -1;
        IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
    })($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));
});
parcelRegister("b0kN8", function(module, exports) {
    "use strict";
    var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BailErrorStrategy = void 0;
    var $4CCJj = parcelRequire("4CCJj");
    var $iLUMi = parcelRequire("iLUMi");
    var $d6D31 = parcelRequire("d6D31");
    var $3kXUy = parcelRequire("3kXUy");
    class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
        recover(recognizer, e) {
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        recoverInline(recognizer) {
            let e = new $iLUMi.InputMismatchException(recognizer);
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        sync(recognizer) {}
    }
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
    module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;
});
parcelRegister("4CCJj", function(module, exports) {
    "use strict";
    var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultErrorStrategy = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $hGRod = parcelRequire("hGRod");
    var $hKCjP = parcelRequire("hKCjP");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $d6D31 = parcelRequire("d6D31");
    class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
        constructor(){
            this.errorRecoveryMode = false;
            this.lastErrorIndex = -1;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
        }
        reset(recognizer) {
            this.endErrorCondition(recognizer);
        }
        beginErrorCondition(recognizer) {
            this.errorRecoveryMode = true;
        }
        inErrorRecoveryMode(recognizer) {
            return this.errorRecoveryMode;
        }
        endErrorCondition(recognizer) {
            this.errorRecoveryMode = false;
            this.lastErrorStates = undefined;
            this.lastErrorIndex = -1;
        }
        reportMatch(recognizer) {
            this.endErrorCondition(recognizer);
        }
        reportError(recognizer, e) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
            else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
            else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
            else {
                console.error(`unknown recognition error type: ${e}`);
                this.notifyErrorListeners(recognizer, e.toString(), e);
            }
        }
        notifyErrorListeners(recognizer, message, e) {
            let offendingToken = e.getOffendingToken(recognizer);
            if (offendingToken === undefined) offendingToken = null;
            recognizer.notifyErrorListeners(message, offendingToken, e);
        }
        recover(recognizer, e) {
            if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) recognizer.consume();
            this.lastErrorIndex = recognizer.inputStream.index;
            if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
            this.lastErrorStates.add(recognizer.state);
            let followSet = this.getErrorRecoverySet(recognizer);
            this.consumeUntil(recognizer, followSet);
        }
        sync(recognizer) {
            let s = recognizer.interpreter.atn.states[recognizer.state];
            if (this.inErrorRecoveryMode(recognizer)) return;
            let tokens = recognizer.inputStream;
            let la = tokens.LA(1);
            let nextTokens = recognizer.atn.nextTokens(s);
            if (nextTokens.contains(la)) {
                this.nextTokensContext = undefined;
                this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
                return;
            }
            if (nextTokens.contains($2DVsz.Token.EPSILON)) {
                if (this.nextTokensContext === undefined) {
                    this.nextTokensContext = recognizer.context;
                    this.nextTokensState = recognizer.state;
                }
                return;
            }
            switch(s.stateType){
                case $1bs3X.ATNStateType.BLOCK_START:
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    if (this.singleTokenDeletion(recognizer)) return;
                    throw new $iLUMi.InputMismatchException(recognizer);
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    this.reportUnwantedToken(recognizer);
                    let expecting = recognizer.getExpectedTokens();
                    let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                    this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                    break;
                default:
                    break;
            }
        }
        reportNoViableAlternative(recognizer, e) {
            let tokens = recognizer.inputStream;
            let input;
            if (tokens) {
                if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
                else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
            } else input = "<unknown input>";
            let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportInputMismatch(recognizer, e) {
            let expected = e.expectedTokens;
            let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
            let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportFailedPredicate(recognizer, e) {
            let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
            let msg = "rule " + ruleName + " " + e.message;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportUnwantedToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let tokenName = this.getTokenErrorDisplay(t);
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        reportMissingToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        recoverInline(recognizer) {
            let matchedSymbol = this.singleTokenDeletion(recognizer);
            if (matchedSymbol) {
                recognizer.consume();
                return matchedSymbol;
            }
            if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
            if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
            else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
        }
        singleTokenInsertion(recognizer) {
            let currentSymbolType = recognizer.inputStream.LA(1);
            let currentState = recognizer.interpreter.atn.states[recognizer.state];
            let next = currentState.transition(0).target;
            let atn = recognizer.interpreter.atn;
            let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
            if (expectingAtLL2.contains(currentSymbolType)) {
                this.reportMissingToken(recognizer);
                return true;
            }
            return false;
        }
        singleTokenDeletion(recognizer) {
            let nextTokenType = recognizer.inputStream.LA(2);
            let expecting = this.getExpectedTokens(recognizer);
            if (expecting.contains(nextTokenType)) {
                this.reportUnwantedToken(recognizer);
                recognizer.consume();
                let matchedSymbol = recognizer.currentToken;
                this.reportMatch(recognizer);
                return matchedSymbol;
            }
            return undefined;
        }
        getMissingSymbol(recognizer) {
            let currentSymbol = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
            if (!expecting.isNil) expectedTokenType = expecting.minElement;
            let tokenText;
            if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
            else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
            let current = currentSymbol;
            let lookback = recognizer.inputStream.tryLT(-1);
            if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
            return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
        }
        constructToken(tokenSource, expectedTokenType, tokenText, current) {
            let factory = tokenSource.tokenFactory;
            let x = current.tokenSource;
            let stream = x ? x.inputStream : undefined;
            return factory.create({
                source: tokenSource,
                stream: stream
            }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
        }
        getExpectedTokens(recognizer) {
            return recognizer.getExpectedTokens();
        }
        getTokenErrorDisplay(t) {
            if (!t) return "<no token>";
            let s = this.getSymbolText(t);
            if (!s) {
                if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
                else s = `<${this.getSymbolType(t)}>`;
            }
            return this.escapeWSAndQuote(s);
        }
        getSymbolText(symbol) {
            return symbol.text;
        }
        getSymbolType(symbol) {
            return symbol.type;
        }
        escapeWSAndQuote(s) {
            s = s.replace("\n", "\\n");
            s = s.replace("\r", "\\r");
            s = s.replace("\t", "\\t");
            return "'" + s + "'";
        }
        getErrorRecoverySet(recognizer) {
            let atn = recognizer.interpreter.atn;
            let ctx = recognizer.context;
            let recoverSet = new $hGRod.IntervalSet();
            while(ctx && ctx.invokingState >= 0){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                let follow = atn.nextTokens(rt.followState);
                recoverSet.addAll(follow);
                ctx = ctx._parent;
            }
            recoverSet.remove($2DVsz.Token.EPSILON);
            return recoverSet;
        }
        consumeUntil(recognizer, set) {
            let ttype = recognizer.inputStream.LA(1);
            while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
                recognizer.consume();
                ttype = recognizer.inputStream.LA(1);
            }
        }
    }
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
    module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;
});
parcelRegister("7j0Pc", function(module, exports) {
    "use strict";
    var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
    class $551af28bc8fe1b8c$var$ATNState {
        constructor(){
            this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
            this.ruleIndex = 0;
            this.epsilonOnlyTransitions = false;
            this.transitions = [];
            this.optimizedTransitions = this.transitions;
        }
        getStateNumber() {
            return this.stateNumber;
        }
        get nonStopStateNumber() {
            return this.getStateNumber();
        }
        hashCode() {
            return this.stateNumber;
        }
        equals(o) {
            if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
            return false;
        }
        get isNonGreedyExitState() {
            return false;
        }
        toString() {
            return String(this.stateNumber);
        }
        getTransitions() {
            return this.transitions.slice(0);
        }
        get numberOfTransitions() {
            return this.transitions.length;
        }
        addTransition(e, index) {
            if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
            else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
                this.epsilonOnlyTransitions = false;
                throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
            }
            this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
        }
        transition(i) {
            return this.transitions[i];
        }
        setTransition(i, e) {
            this.transitions[i] = e;
        }
        removeTransition(index) {
            return this.transitions.splice(index, 1)[0];
        }
        get onlyHasEpsilonTransitions() {
            return this.epsilonOnlyTransitions;
        }
        setRuleIndex(ruleIndex) {
            this.ruleIndex = ruleIndex;
        }
        get isOptimized() {
            return this.optimizedTransitions !== this.transitions;
        }
        get numberOfOptimizedTransitions() {
            return this.optimizedTransitions.length;
        }
        getOptimizedTransition(i) {
            return this.optimizedTransitions[i];
        }
        addOptimizedTransition(e) {
            if (!this.isOptimized) this.optimizedTransitions = new Array();
            this.optimizedTransitions.push(e);
        }
        setOptimizedTransition(i, e) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions[i] = e;
        }
        removeOptimizedTransition(i) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions.splice(i, 1);
        }
    }
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
    module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
    (function(ATNState) {
        ATNState.INVALID_STATE_NUMBER = -1;
    })($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));
});
parcelRegister("1bs3X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNStateType = void 0;
    var $0dcc96396a04e502$var$ATNStateType;
    (function(ATNStateType) {
        ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
        ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
        ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
        ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
        ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
        ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
        ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
        ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
        ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
        ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
        ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
        ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
        ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
    })($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));
});
parcelRegister("ea0YW", function(module, exports) {
    "use strict";
    var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.FailedPredicateException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $hnaRv = parcelRequire("hnaRv");
    let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
        constructor(recognizer, predicate, message){
            super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
            let s = recognizer.interpreter.atn.states[recognizer.state];
            let trans = s.transition(0);
            if (trans instanceof $hnaRv.PredicateTransition) {
                this._ruleIndex = trans.ruleIndex;
                this._predicateIndex = trans.predIndex;
            } else {
                this._ruleIndex = 0;
                this._predicateIndex = 0;
            }
            this._predicate = predicate;
            super.setOffendingToken(recognizer, recognizer.currentToken);
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get predicateIndex() {
            return this._predicateIndex;
        }
        get predicate() {
            return this._predicate;
        }
        static formatMessage(predicate, message) {
            if (message) return message;
            return `failed predicate: {${predicate}}?`;
        }
    };
    $a4f2c2ded442ae18$var$__decorate([
        $d6D31.NotNull
    ], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
    $a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
        $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
    ], $a4f2c2ded442ae18$var$FailedPredicateException);
    module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;
});
parcelRegister("fLdDn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RecognitionException = void 0;
    class $b795d243382c1d9c$var$RecognitionException extends Error {
        constructor(recognizer, input, ctx, message){
            super(message);
            this._offendingState = -1;
            this._recognizer = recognizer;
            this.input = input;
            this.ctx = ctx;
            if (recognizer) this._offendingState = recognizer.state;
        }
        get offendingState() {
            return this._offendingState;
        }
        setOffendingState(offendingState) {
            this._offendingState = offendingState;
        }
        get expectedTokens() {
            if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
            return undefined;
        }
        get context() {
            return this.ctx;
        }
        get inputStream() {
            return this.input;
        }
        getOffendingToken(recognizer) {
            if (recognizer && recognizer !== this._recognizer) return undefined;
            return this.offendingToken;
        }
        setOffendingToken(recognizer, offendingToken) {
            if (recognizer === this._recognizer) this.offendingToken = offendingToken;
        }
        get recognizer() {
            return this._recognizer;
        }
    }
    module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;
});
parcelRegister("hnaRv", function(module, exports) {
    "use strict";
    var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, ruleIndex, predIndex, isCtxDependent){
            super(target);
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 4;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
        }
        toString() {
            return "pred_" + this.ruleIndex + ":" + this.predIndex;
        }
    };
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
    $ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
        $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
    ], $ca5d02a3d9cef56c$var$PredicateTransition);
    module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;
});
parcelRegister("fMVaR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AbstractPredicateTransition = void 0;
    var $5tcOQ = parcelRequire("5tcOQ");
    class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
    }
    module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;
});
parcelRegister("5tcOQ", function(module, exports) {
    "use strict";
    var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Transition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $3fb99acb0a3a1848$var$Transition = class Transition {
        constructor(target){
            if (target == null) throw new Error("target cannot be null.");
            this.target = target;
        }
        get isEpsilon() {
            return false;
        }
        get label() {
            return undefined;
        }
    };
    $3fb99acb0a3a1848$var$Transition.serializationNames = [
        "INVALID",
        "EPSILON",
        "RANGE",
        "RULE",
        "PREDICATE",
        "ATOM",
        "ACTION",
        "SET",
        "NOT_SET",
        "WILDCARD",
        "PRECEDENCE"
    ];
    $3fb99acb0a3a1848$var$__decorate([
        $d6D31.NotNull
    ], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
    $3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
        $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
    ], $3fb99acb0a3a1848$var$Transition);
    module.exports.Transition = $3fb99acb0a3a1848$var$Transition;
});
parcelRegister("eHMgW", function(module, exports) {
    "use strict";
    var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SemanticContext = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $2IEP9 = parcelRequire("2IEP9");
    function $ab4a86b5def51fe2$var$max(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison < 0) result = current;
        }
        return result;
    }
    function $ab4a86b5def51fe2$var$min(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison > 0) result = current;
        }
        return result;
    }
    class $ab4a86b5def51fe2$var$SemanticContext {
        static get NONE() {
            if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
            return $ab4a86b5def51fe2$var$SemanticContext._NONE;
        }
        evalPrecedence(parser, parserCallStack) {
            return this;
        }
        static and(a, b) {
            if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
            if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
        static or(a, b) {
            if (!a) return b;
            if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
    }
    module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
    (function(SemanticContext) {
        const AND_HASHCODE = 40363613;
        const OR_HASHCODE = 486279973;
        function filterPrecedencePredicates(collection) {
            let result = [];
            for(let i = 0; i < collection.length; i++){
                let context = collection[i];
                if (context instanceof SemanticContext.PrecedencePredicate) {
                    result.push(context);
                    collection.splice(i, 1);
                    i--;
                }
            }
            return result;
        }
        class Predicate extends SemanticContext {
            constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
                super();
                this.ruleIndex = ruleIndex;
                this.predIndex = predIndex;
                this.isCtxDependent = isCtxDependent;
            }
            eval(parser, parserCallStack) {
                let localctx = this.isCtxDependent ? parserCallStack : undefined;
                return parser.sempred(localctx, this.ruleIndex, this.predIndex);
            }
            hashCode() {
                let hashCode = $iXFjm.MurmurHash.initialize();
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof Predicate)) return false;
                if (this === obj) return true;
                return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
            }
            toString() {
                return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "toString", null);
        SemanticContext.Predicate = Predicate;
        class PrecedencePredicate extends SemanticContext {
            constructor(precedence){
                super();
                this.precedence = precedence;
            }
            eval(parser, parserCallStack) {
                return parser.precpred(parserCallStack, this.precedence);
            }
            evalPrecedence(parser, parserCallStack) {
                if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
                else return undefined;
            }
            compareTo(o) {
                return this.precedence - o.precedence;
            }
            hashCode() {
                let hashCode = 1;
                hashCode = 31 * hashCode + this.precedence;
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof PrecedencePredicate)) return false;
                if (this === obj) return true;
                return this.precedence === obj.precedence;
            }
            toString() {
                return "{" + this.precedence + ">=prec}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "compareTo", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "toString", null);
        SemanticContext.PrecedencePredicate = PrecedencePredicate;
        class Operator extends SemanticContext {
        }
        SemanticContext.Operator = Operator;
        let AND = class AND extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof AND) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof AND) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof AND)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (!opnd.eval(parser, parserCallStack)) return false;
                }
                return true;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated == null) return undefined;
                    else if (evaluated !== SemanticContext.NONE) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return SemanticContext.NONE;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "&&");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "toString", null);
        AND = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], AND);
        SemanticContext.AND = AND;
        let OR = class OR extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof OR) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof OR) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof OR)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (opnd.eval(parser, parserCallStack)) return true;
                }
                return false;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated === SemanticContext.NONE) return SemanticContext.NONE;
                    else if (evaluated) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return undefined;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "||");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "toString", null);
        OR = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], OR);
        SemanticContext.OR = OR;
    })($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));
});
parcelRegister("7Veax", function(module, exports) {
    "use strict";
    var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashSet = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $1EUnG = parcelRequire("1EUnG");
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16;
    const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
    class $5c48d8f2b0160dc3$var$Array2DHashSet {
        constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                this.comparator = comparatorOrSet.comparator;
                this.buckets = comparatorOrSet.buckets.slice(0);
                for(let i = 0; i < this.buckets.length; i++){
                    let bucket = this.buckets[i];
                    if (bucket) this.buckets[i] = bucket.slice(0);
                }
                this.n = comparatorOrSet.n;
                this.threshold = comparatorOrSet.threshold;
            } else {
                this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
                this.buckets = this.createBuckets(initialCapacity);
            }
        }
        getOrAdd(o) {
            if (this.n > this.threshold) this.expand();
            return this.getOrAddImpl(o);
        }
        getOrAddImpl(o) {
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) {
                bucket = [
                    o
                ];
                this.buckets[b] = bucket;
                this.n++;
                return o;
            }
            for (let existing of bucket){
                if (this.comparator.equals(existing, o)) return existing;
            }
            bucket.push(o);
            this.n++;
            return o;
        }
        get(o) {
            if (o == null) return o;
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) return undefined;
            for (let e of bucket){
                if (this.comparator.equals(e, o)) return e;
            }
            return undefined;
        }
        getBucket(o) {
            let hash = this.comparator.hashCode(o);
            let b = hash & this.buckets.length - 1;
            return b;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
                }
            }
            hash = $iXFjm.MurmurHash.finish(hash, this.size);
            return hash;
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
            if (o.size !== this.size) return false;
            let same = this.containsAll(o);
            return same;
        }
        expand() {
            let old = this.buckets;
            let newCapacity = this.buckets.length * 2;
            let newTable = this.createBuckets(newCapacity);
            this.buckets = newTable;
            this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            let oldSize = this.size;
            for (let bucket of old){
                if (!bucket) continue;
                for (let o of bucket){
                    let b = this.getBucket(o);
                    let newBucket = this.buckets[b];
                    if (!newBucket) {
                        newBucket = [];
                        this.buckets[b] = newBucket;
                    }
                    newBucket.push(o);
                }
            }
            $bbHFU(this.n === oldSize);
        }
        add(t) {
            let existing = this.getOrAdd(t);
            return existing === t;
        }
        get size() {
            return this.n;
        }
        get isEmpty() {
            return this.n === 0;
        }
        contains(o) {
            return this.containsFast(this.asElementType(o));
        }
        containsFast(obj) {
            if (obj == null) return false;
            return this.get(obj) != null;
        }
        *[Symbol.iterator]() {
            yield* this.toArray();
        }
        toArray() {
            const a = new Array(this.size);
            let i = 0;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    a[i++] = o;
                }
            }
            return a;
        }
        containsAll(collection) {
            if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                let s = collection;
                for (let bucket of s.buckets){
                    if (bucket == null) continue;
                    for (let o of bucket){
                        if (o == null) break;
                        if (!this.containsFast(this.asElementType(o))) return false;
                    }
                }
            } else for (let o of collection){
                if (!this.containsFast(this.asElementType(o))) return false;
            }
            return true;
        }
        addAll(c) {
            let changed = false;
            for (let o of c){
                let existing = this.getOrAdd(o);
                if (existing !== o) changed = true;
            }
            return changed;
        }
        clear() {
            this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        }
        toString() {
            if (this.size === 0) return "{}";
            let buf = "{";
            let first = true;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (first) first = false;
                    else buf += ", ";
                    buf += o.toString();
                }
            }
            buf += "}";
            return buf;
        }
        toTableString() {
            let buf = "";
            for (let bucket of this.buckets){
                if (bucket == null) {
                    buf += "null\n";
                    continue;
                }
                buf += "[";
                let first = true;
                for (let o of bucket){
                    if (first) first = false;
                    else buf += " ";
                    if (o == null) buf += "_";
                    else buf += o.toString();
                }
                buf += "]\n";
            }
            return buf;
        }
        asElementType(o) {
            return o;
        }
        createBuckets(capacity) {
            return new Array(capacity);
        }
    }
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.NotNull
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
    module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;
});
parcelRegister("1EUnG", function(module, exports) {
    "use strict";
    var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $135542f8f0124ec7$var$DefaultEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
                obj
            ]);
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (typeof a === "string" || typeof a === "number") return a === b;
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
        }
    }
    $135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
    module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;
});
parcelRegister("iXFjm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.MurmurHash = void 0;
    var $dcddc83c17bb111f$var$MurmurHash;
    (function(MurmurHash) {
        const DEFAULT_SEED = 0;
        function initialize(seed = DEFAULT_SEED) {
            return seed;
        }
        MurmurHash.initialize = initialize;
        function update(hash, value) {
            const c1 = 0xCC9E2D51;
            const c2 = 0x1B873593;
            const r1 = 15;
            const r2 = 13;
            const m = 5;
            const n = 0xE6546B64;
            if (value == null) value = 0;
            else if (typeof value === "string") value = hashString(value);
            else if (typeof value === "object") value = value.hashCode();
            let k = value;
            k = Math.imul(k, c1);
            k = k << r1 | k >>> 32 - r1;
            k = Math.imul(k, c2);
            hash = hash ^ k;
            hash = hash << r2 | hash >>> 32 - r2;
            hash = Math.imul(hash, m) + n;
            return hash & 0xFFFFFFFF;
        }
        MurmurHash.update = update;
        function finish(hash, numberOfWords) {
            hash = hash ^ numberOfWords * 4;
            hash = hash ^ hash >>> 16;
            hash = Math.imul(hash, 0x85EBCA6B);
            hash = hash ^ hash >>> 13;
            hash = Math.imul(hash, 0xC2B2AE35);
            hash = hash ^ hash >>> 16;
            return hash;
        }
        MurmurHash.finish = finish;
        function hashCode(data, seed = DEFAULT_SEED) {
            let hash = initialize(seed);
            let length = 0;
            for (let value of data){
                hash = update(hash, value);
                length++;
            }
            hash = finish(hash, length);
            return hash;
        }
        MurmurHash.hashCode = hashCode;
        function hashString(str) {
            let len = str.length;
            if (len === 0) return 0;
            let hash = 0;
            for(let i = 0; i < len; i++){
                let c = str.charCodeAt(i);
                hash = (hash << 5 >>> 0) - hash + c;
                hash |= 0;
            }
            return hash;
        }
    })($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));
});
parcelRegister("a4Flx", function(module, exports) {
    "use strict";
    var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ObjectEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $755a59a5b7943f39$var$ObjectEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return obj.hashCode();
        }
        equals(a, b) {
            if (a == null) return b == null;
            return a.equals(b);
        }
    }
    $755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
    module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;
});
parcelRegister("3sNxf", function(module, exports) {
    "use strict";
    var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ArrayEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $285a6946513e4d3e$var$ArrayEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return $iXFjm.MurmurHash.hashCode(obj, 0);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (b == null) return false;
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
            }
            return true;
        }
    }
    $285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
    module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;
});
parcelRegister("2IEP9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
    function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
        return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
    }
    module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
    function $1faf5ba696168af5$var$join(collection, separator) {
        let buf = "";
        let first = true;
        for (let current of collection){
            if (first) first = false;
            else buf += separator;
            buf += current;
        }
        return buf;
    }
    module.exports.join = $1faf5ba696168af5$var$join;
    function $1faf5ba696168af5$var$equals(x, y) {
        if (x === y) return true;
        if (x === undefined || y === undefined) return false;
        return x.equals(y);
    }
    module.exports.equals = $1faf5ba696168af5$var$equals;
    function $1faf5ba696168af5$var$toMap(keys) {
        let m = new Map();
        for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
        return m;
    }
    module.exports.toMap = $1faf5ba696168af5$var$toMap;
    function $1faf5ba696168af5$var$toCharArray(str) {
        if (typeof str === "string") {
            let result = new Uint16Array(str.length);
            for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
            return result;
        } else return str.toCharArray();
    }
    module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray;
});
parcelRegister("iLUMi", function(module, exports) {
    "use strict";
    var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InputMismatchException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
        constructor(recognizer, state, context){
            if (context === undefined) context = recognizer.context;
            super(recognizer, recognizer.inputStream, context);
            if (state !== undefined) this.setOffendingState(state);
            this.setOffendingToken(recognizer, recognizer.currentToken);
        }
    };
    $daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
        $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
    ], $daa8a8b6b270e309$var$InputMismatchException);
    module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;
});
parcelRegister("hGRod", function(module, exports) {
    "use strict";
    var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntervalSet = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $ce0fc5f35b4fec79$var$IntervalSet {
        constructor(intervals){
            this.readonly = false;
            if (intervals != null) this._intervals = intervals.slice(0);
            else this._intervals = [];
        }
        static get COMPLETE_CHAR_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
        }
        static get EMPTY_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
        }
        static of(a, b = a) {
            let s = new $ce0fc5f35b4fec79$var$IntervalSet();
            s.add(a, b);
            return s;
        }
        clear() {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            this._intervals.length = 0;
        }
        add(a, b = a) {
            this.addRange($gcfUE.Interval.of(a, b));
        }
        addRange(addition) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            if (addition.b < addition.a) return;
            for(let i = 0; i < this._intervals.length; i++){
                let r = this._intervals[i];
                if (addition.equals(r)) return;
                if (addition.adjacent(r) || !addition.disjoint(r)) {
                    let bigger = addition.union(r);
                    this._intervals[i] = bigger;
                    while(i < this._intervals.length - 1){
                        i++;
                        let next = this._intervals[i];
                        if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                        this._intervals.splice(i, 1);
                        i--;
                        this._intervals[i] = bigger.union(next);
                    }
                    return;
                }
                if (addition.startsBeforeDisjoint(r)) {
                    this._intervals.splice(i, 0, addition);
                    return;
                }
            }
            this._intervals.push(addition);
        }
        static or(sets) {
            let r = new $ce0fc5f35b4fec79$var$IntervalSet();
            for (let s of sets)r.addAll(s);
            return r;
        }
        addAll(set) {
            if (set == null) return this;
            if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
                let other = set;
                let n = other._intervals.length;
                for(let i = 0; i < n; i++){
                    let I = other._intervals[i];
                    this.add(I.a, I.b);
                }
            } else for (let value of set.toArray())this.add(value);
            return this;
        }
        complementRange(minElement, maxElement) {
            return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
        }
        complement(vocabulary) {
            if (vocabulary.isNil) return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
            let vocabularyIS;
            if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
            else {
                vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
                vocabularyIS.addAll(vocabulary);
            }
            return vocabularyIS.subtract(this);
        }
        subtract(a) {
            if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
            if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
            let other = new $ce0fc5f35b4fec79$var$IntervalSet();
            other.addAll(a);
            return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
        }
        static subtract(left, right) {
            if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
            if (right.isNil) return result;
            let resultI = 0;
            let rightI = 0;
            while(resultI < result._intervals.length && rightI < right._intervals.length){
                let resultInterval = result._intervals[resultI];
                let rightInterval = right._intervals[rightI];
                if (rightInterval.b < resultInterval.a) {
                    rightI++;
                    continue;
                }
                if (rightInterval.a > resultInterval.b) {
                    resultI++;
                    continue;
                }
                let beforeCurrent;
                let afterCurrent;
                if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
                if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
                if (beforeCurrent) {
                    if (afterCurrent) {
                        result._intervals[resultI] = beforeCurrent;
                        result._intervals.splice(resultI + 1, 0, afterCurrent);
                        resultI++;
                        rightI++;
                        continue;
                    } else {
                        result._intervals[resultI] = beforeCurrent;
                        resultI++;
                        continue;
                    }
                } else if (afterCurrent) {
                    result._intervals[resultI] = afterCurrent;
                    rightI++;
                    continue;
                } else {
                    result._intervals.splice(resultI, 1);
                    continue;
                }
            }
            return result;
        }
        or(a) {
            let o = new $ce0fc5f35b4fec79$var$IntervalSet();
            o.addAll(this);
            o.addAll(a);
            return o;
        }
        and(other) {
            if (other.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let myIntervals = this._intervals;
            let theirIntervals = other._intervals;
            let intersection;
            let mySize = myIntervals.length;
            let theirSize = theirIntervals.length;
            let i = 0;
            let j = 0;
            while(i < mySize && j < theirSize){
                let mine = myIntervals[i];
                let theirs = theirIntervals[j];
                if (mine.startsBeforeDisjoint(theirs)) i++;
                else if (theirs.startsBeforeDisjoint(mine)) j++;
                else if (mine.properlyContains(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    j++;
                } else if (theirs.properlyContains(mine)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    i++;
                } else if (!mine.disjoint(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    if (mine.startsAfterNonDisjoint(theirs)) j++;
                    else if (theirs.startsAfterNonDisjoint(mine)) i++;
                }
            }
            if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
            return intersection;
        }
        contains(el) {
            let n = this._intervals.length;
            let l = 0;
            let r = n - 1;
            while(l <= r){
                let m = l + r >> 1;
                let I = this._intervals[m];
                let a = I.a;
                let b = I.b;
                if (b < el) l = m + 1;
                else if (a > el) r = m - 1;
                else return true;
            }
            return false;
        }
        get isNil() {
            return this._intervals == null || this._intervals.length === 0;
        }
        get maxElement() {
            if (this.isNil) throw new RangeError("set is empty");
            let last = this._intervals[this._intervals.length - 1];
            return last.b;
        }
        get minElement() {
            if (this.isNil) throw new RangeError("set is empty");
            return this._intervals[0].a;
        }
        get intervals() {
            return this._intervals;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let I of this._intervals){
                hash = $iXFjm.MurmurHash.update(hash, I.a);
                hash = $iXFjm.MurmurHash.update(hash, I.b);
            }
            hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
            return hash;
        }
        equals(o) {
            if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
        }
        toString(elemAreChar = false) {
            let buf = "";
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) {
                    if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                    else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                    else buf += a;
                } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
                else buf += a + ".." + b;
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        toStringVocabulary(vocabulary) {
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            let buf = "";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) buf += this.elementName(vocabulary, a);
                else for(let i = a; i <= b; i++){
                    if (i > a) buf += ", ";
                    buf += this.elementName(vocabulary, i);
                }
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        elementName(vocabulary, a) {
            if (a === $2DVsz.Token.EOF) return "<EOF>";
            else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
            else return vocabulary.getDisplayName(a);
        }
        get size() {
            let n = 0;
            let numIntervals = this._intervals.length;
            if (numIntervals === 1) {
                let firstInterval = this._intervals[0];
                return firstInterval.b - firstInterval.a + 1;
            }
            for(let i = 0; i < numIntervals; i++){
                let I = this._intervals[i];
                n += I.b - I.a + 1;
            }
            return n;
        }
        toIntegerList() {
            let values = new $37SGk.IntegerList(this.size);
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.add(v);
            }
            return values;
        }
        toSet() {
            let s = new Set();
            for (let I of this._intervals){
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)s.add(v);
            }
            return s;
        }
        toArray() {
            let values = new Array();
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.push(v);
            }
            return values;
        }
        remove(el) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                if (el < a) break;
                if (el === a && el === b) {
                    this._intervals.splice(i, 1);
                    break;
                }
                if (el === a) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                    break;
                }
                if (el === b) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                    break;
                }
                if (el > a && el < b) {
                    let oldb = I.b;
                    this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1);
                    this.add(el + 1, oldb);
                }
            }
        }
        get isReadonly() {
            return this.readonly;
        }
        setReadonly(readonly) {
            if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
            this.readonly = readonly;
        }
    }
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull,
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
    module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;
});
parcelRegister("37SGk", function(module, exports) {
    "use strict";
    var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerList = void 0;
    var $9yG1X = parcelRequire("9yG1X");
    var $d6D31 = parcelRequire("d6D31");
    const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
    const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
    const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
    class $246c712c5583aa9c$var$IntegerList {
        constructor(arg){
            if (!arg) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
                this._data = arg._data.slice(0);
                this._size = arg._size;
            } else if (typeof arg === "number") {
                if (arg === 0) {
                    this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                    this._size = 0;
                } else {
                    this._data = new Int32Array(arg);
                    this._size = 0;
                }
            } else {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
                for (let value of arg)this.add(value);
            }
        }
        add(value) {
            if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
            this._data[this._size] = value;
            this._size++;
        }
        addAll(list) {
            if (Array.isArray(list)) {
                this.ensureCapacity(this._size + list.length);
                this._data.subarray(this._size, this._size + list.length).set(list);
                this._size += list.length;
            } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
                this.ensureCapacity(this._size + list._size);
                this._data.subarray(this._size, this._size + list.size).set(list._data);
                this._size += list._size;
            } else {
                this.ensureCapacity(this._size + list.size);
                let current = 0;
                for (let xi of list){
                    this._data[this._size + current] = xi;
                    current++;
                }
                this._size += list.size;
            }
        }
        get(index) {
            if (index < 0 || index >= this._size) throw RangeError();
            return this._data[index];
        }
        contains(value) {
            for(let i = 0; i < this._size; i++){
                if (this._data[i] === value) return true;
            }
            return false;
        }
        set(index, value) {
            if (index < 0 || index >= this._size) throw RangeError();
            let previous = this._data[index];
            this._data[index] = value;
            return previous;
        }
        removeAt(index) {
            let value = this.get(index);
            this._data.copyWithin(index, index + 1, this._size);
            this._data[this._size - 1] = 0;
            this._size--;
            return value;
        }
        removeRange(fromIndex, toIndex) {
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
            if (fromIndex > toIndex) throw RangeError();
            this._data.copyWithin(toIndex, fromIndex, this._size);
            this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
            this._size -= toIndex - fromIndex;
        }
        get isEmpty() {
            return this._size === 0;
        }
        get size() {
            return this._size;
        }
        trimToSize() {
            if (this._data.length === this._size) return;
            this._data = this._data.slice(0, this._size);
        }
        clear() {
            this._data.fill(0, 0, this._size);
            this._size = 0;
        }
        toArray() {
            if (this._size === 0) return [];
            return Array.from(this._data.subarray(0, this._size));
        }
        sort() {
            this._data.subarray(0, this._size).sort();
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
            if (this._size !== o._size) return false;
            for(let i = 0; i < this._size; i++){
                if (this._data[i] !== o._data[i]) return false;
            }
            return true;
        }
        hashCode() {
            let hashCode = 1;
            for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
            return hashCode;
        }
        toString() {
            return this._data.toString();
        }
        binarySearch(key, fromIndex, toIndex) {
            if (fromIndex === undefined) fromIndex = 0;
            if (toIndex === undefined) toIndex = this._size;
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
            if (fromIndex > toIndex) throw new RangeError();
            return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
        }
        ensureCapacity(capacity) {
            if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
            let newLength;
            if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
            else newLength = this._data.length;
            while(newLength < capacity){
                newLength = newLength * 2;
                if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
            }
            let tmp = new Int32Array(newLength);
            tmp.set(this._data);
            this._data = tmp;
        }
        toCharArray() {
            let resultArray = new Uint16Array(this._size);
            let resultIdx = 0;
            let calculatedPreciseResultSize = false;
            for(let i = 0; i < this._size; i++){
                let codePoint = this._data[i];
                if (codePoint >= 0 && codePoint < 0x10000) {
                    resultArray[resultIdx] = codePoint;
                    resultIdx++;
                    continue;
                }
                if (!calculatedPreciseResultSize) {
                    let newResultArray = new Uint16Array(this.charArraySize());
                    newResultArray.set(resultArray, 0);
                    resultArray = newResultArray;
                    calculatedPreciseResultSize = true;
                }
                let pair = String.fromCodePoint(codePoint);
                resultArray[resultIdx] = pair.charCodeAt(0);
                resultArray[resultIdx + 1] = pair.charCodeAt(1);
                resultIdx += 2;
            }
            return resultArray;
        }
        charArraySize() {
            let result = 0;
            for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
            return result;
        }
    }
    $246c712c5583aa9c$var$__decorate([
        $d6D31.NotNull
    ], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
    module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;
});
parcelRegister("9yG1X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Arrays = void 0;
    var $6f57e46e4dc9d39b$var$Arrays;
    (function(Arrays) {
        function binarySearch(array, key, fromIndex, toIndex) {
            return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
        }
        Arrays.binarySearch = binarySearch;
        function binarySearch0(array, fromIndex, toIndex, key) {
            let low = fromIndex;
            let high = toIndex - 1;
            while(low <= high){
                let mid = low + high >>> 1;
                let midVal = array[mid];
                if (midVal < key) low = mid + 1;
                else if (midVal > key) high = mid - 1;
                else return mid;
            }
            return -(low + 1);
        }
        function toString(array) {
            let result = "[";
            let first = true;
            for (let element of array){
                if (first) first = false;
                else result += ", ";
                if (element === null) result += "null";
                else if (element === undefined) result += "undefined";
                else result += element;
            }
            result += "]";
            return result;
        }
        Arrays.toString = toString;
    })($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));
});
parcelRegister("gcfUE", function(module, exports) {
    "use strict";
    var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Interval = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
    class $bcaa1c4749d34439$var$Interval {
        constructor(a, b){
            this.a = a;
            this.b = b;
        }
        static get INVALID() {
            return $bcaa1c4749d34439$var$Interval._INVALID;
        }
        static of(a, b) {
            if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
            if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
            return $bcaa1c4749d34439$var$Interval.cache[a];
        }
        get length() {
            if (this.b < this.a) return 0;
            return this.b - this.a + 1;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
            return this.a === o.a && this.b === o.b;
        }
        hashCode() {
            let hash = 23;
            hash = hash * 31 + this.a;
            hash = hash * 31 + this.b;
            return hash;
        }
        startsBeforeDisjoint(other) {
            return this.a < other.a && this.b < other.a;
        }
        startsBeforeNonDisjoint(other) {
            return this.a <= other.a && this.b >= other.a;
        }
        startsAfter(other) {
            return this.a > other.a;
        }
        startsAfterDisjoint(other) {
            return this.a > other.b;
        }
        startsAfterNonDisjoint(other) {
            return this.a > other.a && this.a <= other.b;
        }
        disjoint(other) {
            return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
        }
        adjacent(other) {
            return this.a === other.b + 1 || this.b === other.a - 1;
        }
        properlyContains(other) {
            return other.a >= this.a && other.b <= this.b;
        }
        union(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
        }
        intersection(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
        }
        differenceNotProperlyContained(other) {
            let diff;
            if (other.startsBeforeNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
            else if (other.startsAfterNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
            return diff;
        }
        toString() {
            return this.a + ".." + this.b;
        }
    }
    $bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
    $bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
    module.exports.Interval = $bcaa1c4749d34439$var$Interval;
});
parcelRegister("igNLf", function(module, exports) {
    "use strict";
    var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Lexer = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $6Kebn = parcelRequire("6Kebn");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $lQecE = parcelRequire("lQecE");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2DVsz = parcelRequire("2DVsz");
    class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            this._tokenStartCharIndex = -1;
            this._tokenStartLine = 0;
            this._tokenStartCharPositionInLine = 0;
            this._hitEOF = false;
            this._channel = 0;
            this._type = 0;
            this._modeStack = new $6Kebn.IntegerStack();
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: input
            };
        }
        static get DEFAULT_TOKEN_CHANNEL() {
            return $2DVsz.Token.DEFAULT_CHANNEL;
        }
        static get HIDDEN() {
            return $2DVsz.Token.HIDDEN_CHANNEL;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this._input.seek(0);
            this._token = undefined;
            this._type = $2DVsz.Token.INVALID_TYPE;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this._tokenStartCharIndex = -1;
            this._tokenStartCharPositionInLine = -1;
            this._tokenStartLine = -1;
            this._text = undefined;
            this._hitEOF = false;
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._modeStack.clear();
            this.interpreter.reset();
        }
        nextToken() {
            if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
            let tokenStartMarker = this._input.mark();
            try {
                outer: while(true){
                    if (this._hitEOF) return this.emitEOF();
                    this._token = undefined;
                    this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                    this._tokenStartCharIndex = this._input.index;
                    this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                    this._tokenStartLine = this.interpreter.line;
                    this._text = undefined;
                    do {
                        this._type = $2DVsz.Token.INVALID_TYPE;
                        let ttype;
                        try {
                            ttype = this.interpreter.match(this._input, this._mode);
                        } catch (e) {
                            if (e instanceof $fOEQQ.LexerNoViableAltException) {
                                this.notifyListeners(e);
                                this.recover(e);
                                ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                            } else throw e;
                        }
                        if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                        if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                        if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                    }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE)
                    if (this._token == null) return this.emit();
                    return this._token;
                }
            } finally{
                this._input.release(tokenStartMarker);
            }
        }
        skip() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
        }
        more() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
        }
        mode(m) {
            this._mode = m;
        }
        pushMode(m) {
            if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
            this._modeStack.push(this._mode);
            this.mode(m);
        }
        popMode() {
            if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
            if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
            this.mode(this._modeStack.pop());
            return this._mode;
        }
        get tokenFactory() {
            return this._factory;
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: this._input
            };
        }
        get sourceName() {
            return this._input.sourceName;
        }
        emit(token) {
            if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
            this._token = token;
            return token;
        }
        emitEOF() {
            let cpos = this.charPositionInLine;
            let line = this.line;
            let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
            this.emit(eof);
            return eof;
        }
        get line() {
            return this.interpreter.line;
        }
        set line(line) {
            this.interpreter.line = line;
        }
        get charPositionInLine() {
            return this.interpreter.charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this.interpreter.charPositionInLine = charPositionInLine;
        }
        get charIndex() {
            return this._input.index;
        }
        get text() {
            if (this._text != null) return this._text;
            return this.interpreter.getText(this._input);
        }
        set text(text) {
            this._text = text;
        }
        get token() {
            return this._token;
        }
        set token(_token) {
            this._token = _token;
        }
        set type(ttype) {
            this._type = ttype;
        }
        get type() {
            return this._type;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        getAllTokens() {
            let tokens = [];
            let t = this.nextToken();
            while(t.type !== $2DVsz.Token.EOF){
                tokens.push(t);
                t = this.nextToken();
            }
            return tokens;
        }
        notifyListeners(e) {
            let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
            let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
        }
        getErrorDisplay(s) {
            if (typeof s === "number") {
                switch(s){
                    case $2DVsz.Token.EOF:
                        return "<EOF>";
                    case 0x0a:
                        return "\\n";
                    case 0x09:
                        return "\\t";
                    case 0x0d:
                        return "\\r";
                }
                return String.fromCharCode(s);
            }
            return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        }
        getCharErrorDisplay(c) {
            let s = this.getErrorDisplay(c);
            return "'" + s + "'";
        }
        recover(re) {
            if (re instanceof $fOEQQ.LexerNoViableAltException) {
                if (this._input.LA(1) !== $ceaEj.IntStream.EOF) this.interpreter.consume(this._input);
            } else this._input.consume();
        }
    }
    $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
    $d4d0521f20d9c4ac$var$Lexer.MORE = -2;
    $d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
    $d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
    $d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
    module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;
});
parcelRegister("gWaB3", function(module, exports) {
    "use strict";
    var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenFactory = void 0;
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $c54a4863b793dbc8$var$CommonTokenFactory {
        constructor(copyText = false){
            this.copyText = copyText;
        }
        create(source, type, text, channel, start, stop, line, charPositionInLine) {
            let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
            t.line = line;
            t.charPositionInLine = charPositionInLine;
            if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
            return t;
        }
        createSimple(type, text) {
            return new $j53rr.CommonToken(type, text);
        }
    }
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
    module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
    (function(CommonTokenFactory) {
        CommonTokenFactory.DEFAULT = new CommonTokenFactory();
    })($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));
});
parcelRegister("j53rr", function(module, exports) {
    "use strict";
    var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonToken = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $de41275c931ca469$var$CommonToken = class CommonToken {
        constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
            this._line = 0;
            this._charPositionInLine = -1;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this.index = -1;
            this._text = text;
            this._type = type;
            this.source = source;
            this._channel = channel;
            this.start = start;
            this.stop = stop;
            if (source.source != null) {
                this._line = source.source.line;
                this._charPositionInLine = source.source.charPositionInLine;
            }
        }
        static fromToken(oldToken) {
            let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
            result._line = oldToken.line;
            result.index = oldToken.tokenIndex;
            result._charPositionInLine = oldToken.charPositionInLine;
            if (oldToken instanceof CommonToken) {
                result._text = oldToken._text;
                result.source = oldToken.source;
            } else {
                result._text = oldToken.text;
                result.source = {
                    source: oldToken.tokenSource,
                    stream: oldToken.inputStream
                };
            }
            return result;
        }
        get type() {
            return this._type;
        }
        set type(type) {
            this._type = type;
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get text() {
            if (this._text != null) return this._text;
            let input = this.inputStream;
            if (input == null) return undefined;
            let n = input.size;
            if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
            else return "<EOF>";
        }
        set text(text) {
            this._text = text;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        get channel() {
            return this._channel;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get startIndex() {
            return this.start;
        }
        set startIndex(start) {
            this.start = start;
        }
        get stopIndex() {
            return this.stop;
        }
        set stopIndex(stop) {
            this.stop = stop;
        }
        get tokenIndex() {
            return this.index;
        }
        set tokenIndex(index) {
            this.index = index;
        }
        get tokenSource() {
            return this.source.source;
        }
        get inputStream() {
            return this.source.stream;
        }
        toString(recognizer) {
            let channelStr = "";
            if (this._channel > 0) channelStr = ",channel=" + this._channel;
            let txt = this.text;
            if (txt != null) {
                txt = txt.replace(/\n/g, "\\n");
                txt = txt.replace(/\r/g, "\\r");
                txt = txt.replace(/\t/g, "\\t");
            } else txt = "<no text>";
            let typeString = String(this._type);
            if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
            return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
        }
    };
    $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
        source: undefined,
        stream: undefined
    };
    $de41275c931ca469$var$__decorate([
        $d6D31.NotNull
    ], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "type", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "line", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "text", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
    $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(0, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken, "fromToken", null);
    $de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(2, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken);
    module.exports.CommonToken = $de41275c931ca469$var$CommonToken;
});
parcelRegister("2DVsz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Token = void 0;
    var $ceaEj = parcelRequire("ceaEj");
    var $1ecbcb9fde4eac7e$var$Token;
    (function(Token) {
        Token.INVALID_TYPE = 0;
        Token.EPSILON = -2;
        Token.MIN_USER_TOKEN_TYPE = 1;
        Token.EOF = $ceaEj.IntStream.EOF;
        Token.DEFAULT_CHANNEL = 0;
        Token.HIDDEN_CHANNEL = 1;
        Token.MIN_USER_CHANNEL_VALUE = 2;
    })($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));
});
parcelRegister("6Kebn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerStack = void 0;
    var $37SGk = parcelRequire("37SGk");
    class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
        constructor(arg){
            super(arg);
        }
        push(value) {
            this.add(value);
        }
        pop() {
            return this.removeAt(this.size - 1);
        }
        peek() {
            return this.get(this.size - 1);
        }
    }
    module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;
});
parcelRegister("lQecE", function(module, exports) {
    "use strict";
    var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $2jevZ = parcelRequire("2jevZ");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $igNLf = parcelRequire("igNLf");
    var $3AYVu = parcelRequire("3AYVu");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $9tIYC = parcelRequire("9tIYC");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, recog){
            super(atn);
            this.optimize_tail_calls = true;
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
            this.prevAccept = new LexerATNSimulator.SimState();
            this.recog = recog;
        }
        copyState(simulator) {
            this._charPositionInLine = simulator.charPositionInLine;
            this._line = simulator._line;
            this.mode = simulator.mode;
            this.startIndex = simulator.startIndex;
        }
        match(input, mode) {
            this.mode = mode;
            let mark = input.mark();
            try {
                this.startIndex = input.index;
                this.prevAccept.reset();
                let s0 = this.atn.modeToDFA[mode].s0;
                if (s0 == null) return this.matchATN(input);
                else return this.execATN(input, s0);
            } finally{
                input.release(mark);
            }
        }
        reset() {
            this.prevAccept.reset();
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
        }
        matchATN(input) {
            let startState = this.atn.modeToStartState[this.mode];
            if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
            let old_mode = this.mode;
            let s0_closure = this.computeStartState(input, startState);
            let suppressEdge = s0_closure.hasSemanticContext;
            if (suppressEdge) s0_closure.hasSemanticContext = false;
            let next = this.addDFAState(s0_closure);
            if (!suppressEdge) {
                let dfa = this.atn.modeToDFA[this.mode];
                if (!dfa.s0) dfa.s0 = next;
                else next = dfa.s0;
            }
            let predict = this.execATN(input, next);
            if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
            return predict;
        }
        execATN(input, ds0) {
            if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
            if (ds0.isAcceptState) this.captureSimState(this.prevAccept, input, ds0);
            let t = input.LA(1);
            let s = ds0;
            while(true){
                if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
                let target = this.getExistingTargetState(s, t);
                if (target == null) target = this.computeTargetState(input, s, t);
                if (target === $kr9A1.ATNSimulator.ERROR) break;
                if (t !== $ceaEj.IntStream.EOF) this.consume(input);
                if (target.isAcceptState) {
                    this.captureSimState(this.prevAccept, input, target);
                    if (t === $ceaEj.IntStream.EOF) break;
                }
                t = input.LA(1);
                s = target;
            }
            return this.failOrAccept(this.prevAccept, input, s.configs, t);
        }
        getExistingTargetState(s, t) {
            let target = s.getTarget(t);
            if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
            return target;
        }
        computeTargetState(input, s, t) {
            let reach = new $9tIYC.OrderedATNConfigSet();
            this.getReachableConfigSet(input, s.configs, reach, t);
            if (reach.isEmpty) {
                if (!reach.hasSemanticContext) this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return $kr9A1.ATNSimulator.ERROR;
            }
            return this.addDFAEdge(s, t, reach);
        }
        failOrAccept(prevAccept, input, reach, t) {
            if (prevAccept.dfaState != null) {
                let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
                this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
                return prevAccept.dfaState.prediction;
            } else {
                if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
                throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
            }
        }
        getReachableConfigSet(input, closure, reach, t) {
            let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of closure){
                let currentAltReachedAcceptState = c.alt === skipAlt;
                if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
                if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(trans, t);
                    if (target != null) {
                        let lexerActionExecutor = c.lexerActionExecutor;
                        let config;
                        if (lexerActionExecutor != null) {
                            lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                            config = c.transform(target, true, lexerActionExecutor);
                        } else {
                            $bbHFU(c.lexerActionExecutor == null);
                            config = c.transform(target, true);
                        }
                        let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                        if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                            skipAlt = c.alt;
                            break;
                        }
                    }
                }
            }
        }
        accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
            if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
            input.seek(index);
            this._line = line;
            this._charPositionInLine = charPos;
            if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
        }
        getReachableTarget(trans, t) {
            if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
            return undefined;
        }
        computeStartState(input, p) {
            let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
            let configs = new $9tIYC.OrderedATNConfigSet();
            for(let i = 0; i < p.numberOfTransitions; i++){
                let target = p.transition(i).target;
                let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
                this.closure(input, c, configs, false, false, false);
            }
            return configs;
        }
        closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
            if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (LexerATNSimulator.debug) {
                    if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                    else console.log(`closure at rule stop ${config}`);
                }
                let context = config.context;
                if (context.isEmpty) {
                    configs.add(config);
                    return true;
                } else if (context.hasEmpty) {
                    configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                    currentAltReachedAcceptState = true;
                }
                for(let i = 0; i < context.size; i++){
                    let returnStateNumber = context.getReturnState(i);
                    if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let newContext = context.getParent(i);
                    let returnState = this.atn.states[returnStateNumber];
                    let c = config.transform(returnState, false, newContext);
                    currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
                }
                return currentAltReachedAcceptState;
            }
            if (!config.state.onlyHasEpsilonTransitions) {
                if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
            }
            let p = config.state;
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                let t = p.getOptimizedTransition(i);
                let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
                if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
            let c;
            switch(t.serializationType){
                case 3:
                    let ruleTransition = t;
                    if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                    else {
                        let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                        c = config.transform(t.target, true, newContext);
                    }
                    break;
                case 10:
                    throw new Error("Precedence predicates are not supported in lexers.");
                case 4:
                    let pt = t;
                    if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                    configs.hasSemanticContext = true;
                    if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                    else c = undefined;
                    break;
                case 6:
                    if (config.context.hasEmpty) {
                        let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                        c = config.transform(t.target, true, lexerActionExecutor);
                        break;
                    } else {
                        c = config.transform(t.target, true);
                        break;
                    }
                case 1:
                    c = config.transform(t.target, true);
                    break;
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                            c = config.transform(t.target, false);
                            break;
                        }
                    }
                    c = undefined;
                    break;
                default:
                    c = undefined;
                    break;
            }
            return c;
        }
        evaluatePredicate(input, ruleIndex, predIndex, speculative) {
            if (this.recog == null) return true;
            if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
            let savedCharPositionInLine = this._charPositionInLine;
            let savedLine = this._line;
            let index = input.index;
            let marker = input.mark();
            try {
                this.consume(input);
                return this.recog.sempred(undefined, ruleIndex, predIndex);
            } finally{
                this._charPositionInLine = savedCharPositionInLine;
                this._line = savedLine;
                input.seek(index);
                input.release(marker);
            }
        }
        captureSimState(settings, input, dfaState) {
            settings.index = input.index;
            settings.line = this._line;
            settings.charPos = this._charPositionInLine;
            settings.dfaState = dfaState;
        }
        addDFAEdge(p, t, q) {
            if (q instanceof $c1ClW.ATNConfigSet) {
                let suppressEdge = q.hasSemanticContext;
                if (suppressEdge) q.hasSemanticContext = false;
                let to = this.addDFAState(q);
                if (suppressEdge) return to;
                this.addDFAEdge(p, t, to);
                return to;
            } else {
                if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
                if (p != null) p.setTarget(t, q);
            }
        }
        addDFAState(configs) {
            $bbHFU(!configs.hasSemanticContext);
            let proposed = new $2jevZ.DFAState(configs);
            let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
            if (existing != null) return existing;
            configs.optimizeConfigs(this);
            let newState = new $2jevZ.DFAState(configs.clone(true));
            let firstConfigWithRuleStopState;
            for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
                firstConfigWithRuleStopState = c;
                break;
            }
            if (firstConfigWithRuleStopState != null) {
                let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
                let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
                newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
            }
            return this.atn.modeToDFA[this.mode].addState(newState);
        }
        getDFA(mode) {
            return this.atn.modeToDFA[mode];
        }
        getText(input) {
            return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        consume(input) {
            let curChar = input.LA(1);
            if (curChar === "\n".charCodeAt(0)) {
                this._line++;
                this._charPositionInLine = 0;
            } else this._charPositionInLine++;
            input.consume();
        }
        getTokenName(t) {
            if (t === -1) return "EOF";
            return "'" + String.fromCharCode(t) + "'";
        }
    };
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.Override
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
    $fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator);
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
    (function(LexerATNSimulator) {
        LexerATNSimulator.debug = false;
        LexerATNSimulator.dfa_debug = false;
        class SimState {
            constructor(){
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
            }
            reset() {
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
                this.dfaState = undefined;
            }
        }
        LexerATNSimulator.SimState = SimState;
    })($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
});
parcelRegister("41NTU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AcceptStateInfo = void 0;
    class $2eedf6a56837c02c$var$AcceptStateInfo {
        constructor(prediction, lexerActionExecutor){
            this._prediction = prediction;
            this._lexerActionExecutor = lexerActionExecutor;
        }
        get prediction() {
            return this._prediction;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
    }
    module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;
});
parcelRegister("bcnvE", function(module, exports) {
    "use strict";
    var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATN = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $jJRyp = parcelRequire("jJRyp");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iiE1V = parcelRequire("iiE1V");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $82730d2c6766359c$var$ATN = class ATN {
        constructor(grammarType, maxTokenType){
            this.states = [];
            this.decisionToState = [];
            this.modeNameToStartState = new Map();
            this.modeToStartState = [];
            this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.decisionToDFA = [];
            this.modeToDFA = [];
            this.LL1Table = new Map();
            this.grammarType = grammarType;
            this.maxTokenType = maxTokenType;
        }
        clearDFA() {
            this.decisionToDFA = new Array(this.decisionToState.length);
            for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
            this.modeToDFA = new Array(this.modeToStartState.length);
            for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
            this.contextCache.clear();
            this.LL1Table.clear();
        }
        get contextCacheSize() {
            return this.contextCache.size;
        }
        getCachedContext(context) {
            return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
        }
        getDecisionToDFA() {
            $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
            return this.decisionToDFA;
        }
        nextTokens(s, ctx) {
            if (ctx) {
                let anal = new $iiE1V.LL1Analyzer(this);
                let next = anal.LOOK(s, ctx);
                return next;
            } else {
                if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
                s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
                s.nextTokenWithinRule.setReadonly(true);
                return s.nextTokenWithinRule;
            }
        }
        addState(state) {
            state.atn = this;
            state.stateNumber = this.states.length;
            this.states.push(state);
        }
        removeState(state) {
            let invalidState = new $l4Nh1.InvalidState();
            invalidState.atn = this;
            invalidState.stateNumber = state.stateNumber;
            this.states[state.stateNumber] = invalidState;
        }
        defineMode(name, s) {
            this.modeNameToStartState.set(name, s);
            this.modeToStartState.push(s);
            this.modeToDFA.push(new $jJRyp.DFA(s));
            this.defineDecisionState(s);
        }
        defineDecisionState(s) {
            this.decisionToState.push(s);
            s.decision = this.decisionToState.length - 1;
            this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
            return s.decision;
        }
        getDecisionState(decision) {
            if (this.decisionToState.length > 0) return this.decisionToState[decision];
            return undefined;
        }
        get numberOfDecisions() {
            return this.decisionToState.length;
        }
        getExpectedTokens(stateNumber, context) {
            if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
            let ctx = context;
            let s = this.states[stateNumber];
            let following = this.nextTokens(s);
            if (!following.contains($2DVsz.Token.EPSILON)) return following;
            let expected = new $hGRod.IntervalSet();
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = this.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = this.nextTokens(rt.followState);
                expected.addAll(following);
                expected.remove($2DVsz.Token.EPSILON);
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
            return expected;
        }
    };
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
        $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
    $82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN);
    module.exports.ATN = $82730d2c6766359c$var$ATN;
    (function(ATN) {
        ATN.INVALID_ALT_NUMBER = 0;
    })($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
    module.exports.ATN = $82730d2c6766359c$var$ATN;
});
parcelRegister("fP17P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashMap = void 0;
    var $7Veax = parcelRequire("7Veax");
    class $b84c7de35a10478c$var$MapKeyEqualityComparator {
        constructor(keyComparator){
            this.keyComparator = keyComparator;
        }
        hashCode(obj) {
            return this.keyComparator.hashCode(obj.key);
        }
        equals(a, b) {
            return this.keyComparator.equals(a.key, b.key);
        }
    }
    class $b84c7de35a10478c$var$Array2DHashMap {
        constructor(keyComparer){
            if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
            else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
        }
        clear() {
            this.backingStore.clear();
        }
        containsKey(key) {
            return this.backingStore.contains({
                key: key
            });
        }
        get(key) {
            let bucket = this.backingStore.get({
                key: key
            });
            if (!bucket) return undefined;
            return bucket.value;
        }
        get isEmpty() {
            return this.backingStore.isEmpty;
        }
        put(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else {
                result = element.value;
                element.value = value;
            }
            return result;
        }
        putIfAbsent(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else result = element.value;
            return result;
        }
        get size() {
            return this.backingStore.size;
        }
        hashCode() {
            return this.backingStore.hashCode();
        }
        equals(o) {
            if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
            return this.backingStore.equals(o.backingStore);
        }
    }
    module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;
});
parcelRegister("jJRyp", function(module, exports) {
    "use strict";
    var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFA = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $c1ClW = parcelRequire("c1ClW");
    var $yhTtv = parcelRequire("yhTtv");
    var $2jevZ = parcelRequire("2jevZ");
    var $aeRGo = parcelRequire("aeRGo");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $f9raX = parcelRequire("f9raX");
    var $3n2FE = parcelRequire("3n2FE");
    let $e5ebc30517b3d229$var$DFA = class DFA {
        constructor(atnStartState, decision = 0){
            this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.nextStateNumber = 0;
            if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
            this.atnStartState = atnStartState;
            this.atn = atnStartState.atn;
            this.decision = decision;
            let isPrecedenceDfa = false;
            if (atnStartState instanceof $f9raX.StarLoopEntryState) {
                if (atnStartState.precedenceRuleDecision) {
                    isPrecedenceDfa = true;
                    this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                    this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                }
            }
            this.precedenceDfa = isPrecedenceDfa;
        }
        get isPrecedenceDfa() {
            return this.precedenceDfa;
        }
        getPrecedenceStartState(precedence, fullContext) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (fullContext) return this.s0full.getTarget(precedence);
            else return this.s0.getTarget(precedence);
        }
        setPrecedenceStartState(precedence, fullContext, startState) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (precedence < 0) return;
            if (fullContext) this.s0full.setTarget(precedence, startState);
            else this.s0.setTarget(precedence, startState);
        }
        get isEmpty() {
            if (this.isPrecedenceDfa) return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
            return this.s0 == null && this.s0full == null;
        }
        get isContextSensitive() {
            if (this.isPrecedenceDfa) return this.s0full.getEdgeMap().size > 0;
            return this.s0full != null;
        }
        addState(state) {
            state.stateNumber = this.nextStateNumber++;
            return this.states.getOrAdd(state);
        }
        toString(vocabulary, ruleNames) {
            if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            if (!this.s0) return "";
            let serializer;
            if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
            else serializer = new $yhTtv.DFASerializer(this, vocabulary);
            return serializer.toString();
        }
        toLexerString() {
            if (!this.s0) return "";
            let serializer = new $aeRGo.LexerDFASerializer(this);
            return serializer.toString();
        }
    };
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
    $e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
        $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
    ], $e5ebc30517b3d229$var$DFA);
    module.exports.DFA = $e5ebc30517b3d229$var$DFA;
});
parcelRegister("c1ClW", function(module, exports) {
    "use strict";
    var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfigSet = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    var $2IEP9 = parcelRequire("2IEP9");
    class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
        hashCode(key) {
            return key.state ^ key.alt;
        }
        equals(a, b) {
            return a.state === b.state && a.alt === b.alt;
        }
    }
    $8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
    function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
        if (map) return new $fP17P.Array2DHashMap(map);
        else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
    }
    class $8c13542112ebfd78$var$ATNConfigSet {
        constructor(set, readonly){
            this._uniqueAlt = 0;
            this._hasSemanticContext = false;
            this._dipsIntoOuterContext = false;
            this.outermostConfigSet = false;
            this.cachedHashCode = -1;
            if (!set) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
                this.configs = [];
                this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            } else {
                if (readonly) {
                    this.mergedConfigs = undefined;
                    this.unmerged = undefined;
                } else if (!set.isReadOnly) {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                    this.unmerged = set.unmerged.slice(0);
                } else {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                    this.unmerged = [];
                }
                this.configs = set.configs.slice(0);
                this._dipsIntoOuterContext = set._dipsIntoOuterContext;
                this._hasSemanticContext = set._hasSemanticContext;
                this.outermostConfigSet = set.outermostConfigSet;
                if (readonly || !set.isReadOnly) {
                    this._uniqueAlt = set._uniqueAlt;
                    this._conflictInfo = set._conflictInfo;
                }
            }
        }
        getRepresentedAlternatives() {
            if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
            let alts = new $5BPMp.BitSet();
            for (let config of this)alts.set(config.alt);
            return alts;
        }
        get isReadOnly() {
            return this.mergedConfigs == null;
        }
        get isOutermostConfigSet() {
            return this.outermostConfigSet;
        }
        set isOutermostConfigSet(outermostConfigSet) {
            if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
            $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
            this.outermostConfigSet = outermostConfigSet;
        }
        getStates() {
            let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            for (let c of this.configs)states.add(c.state);
            return states;
        }
        optimizeConfigs(interpreter) {
            if (this.configs.length === 0) return;
            for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
        }
        clone(readonly) {
            let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this.configs);
            return copy;
        }
        get size() {
            return this.configs.length;
        }
        get isEmpty() {
            return this.configs.length === 0;
        }
        contains(o) {
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (this.mergedConfigs && this.unmerged) {
                let config = o;
                let configKey = this.getKey(config);
                let mergedConfig = this.mergedConfigs.get(configKey);
                if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
                for (let c of this.unmerged){
                    if (c.contains(o)) return true;
                }
            } else for (let c of this.configs){
                if (c.contains(o)) return true;
            }
            return false;
        }
        *[Symbol.iterator]() {
            yield* this.configs;
        }
        toArray() {
            return this.configs;
        }
        add(e, contextCache) {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let addKey;
            let key = this.getKey(e);
            let mergedConfig = this.mergedConfigs.get(key);
            addKey = mergedConfig == null;
            if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
                mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (mergedConfig.context === joined) return false;
                mergedConfig.context = joined;
                return true;
            }
            for(let i = 0; i < this.unmerged.length; i++){
                let unmergedConfig = this.unmerged[i];
                if (this.canMerge(e, key, unmergedConfig)) {
                    unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                    if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                    let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                    this.updatePropertiesForMergedConfig(e);
                    if (unmergedConfig.context === joined) return false;
                    unmergedConfig.context = joined;
                    if (addKey) {
                        this.mergedConfigs.put(key, unmergedConfig);
                        this.unmerged.splice(i, 1);
                    }
                    return true;
                }
            }
            this.configs.push(e);
            if (addKey) this.mergedConfigs.put(key, e);
            else this.unmerged.push(e);
            this.updatePropertiesForAddedConfig(e);
            return true;
        }
        updatePropertiesForMergedConfig(config) {
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        updatePropertiesForAddedConfig(config) {
            if (this.configs.length === 1) this._uniqueAlt = config.alt;
            else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        canMerge(left, leftKey, right) {
            if (left.state.stateNumber !== right.state.stateNumber) return false;
            if (leftKey.alt !== right.alt) return false;
            return left.semanticContext.equals(right.semanticContext);
        }
        getKey(e) {
            return {
                state: e.state.stateNumber,
                alt: e.alt
            };
        }
        containsAll(c) {
            for (let o of c){
                if (!(o instanceof $gcX0f.ATNConfig)) return false;
                if (!this.contains(o)) return false;
            }
            return true;
        }
        addAll(c, contextCache) {
            this.ensureWritable();
            let changed = false;
            for (let group of c)if (this.add(group, contextCache)) changed = true;
            return changed;
        }
        clear() {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            this.mergedConfigs.clear();
            this.unmerged.length = 0;
            this.configs.length = 0;
            this._dipsIntoOuterContext = false;
            this._hasSemanticContext = false;
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._conflictInfo = undefined;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
            return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
        }
        hashCode() {
            if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
            let hashCode = 1;
            hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
            hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
            if (this.isReadOnly) this.cachedHashCode = hashCode;
            return hashCode;
        }
        toString(showContext) {
            if (showContext == null) showContext = false;
            let buf = "";
            let sortedConfigs = this.configs.slice(0);
            sortedConfigs.sort((o1, o2)=>{
                if (o1.alt !== o2.alt) return o1.alt - o2.alt;
                else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
                else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
            });
            buf += "[";
            for(let i = 0; i < sortedConfigs.length; i++){
                if (i > 0) buf += ", ";
                buf += sortedConfigs[i].toString(undefined, true, showContext);
            }
            buf += "]";
            if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
            if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
            if (this._conflictInfo != null) {
                buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
                if (!this._conflictInfo.isExact) buf += "*";
            }
            if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
            return buf.toString();
        }
        get uniqueAlt() {
            return this._uniqueAlt;
        }
        get hasSemanticContext() {
            return this._hasSemanticContext;
        }
        set hasSemanticContext(value) {
            this.ensureWritable();
            this._hasSemanticContext = value;
        }
        get conflictInfo() {
            return this._conflictInfo;
        }
        set conflictInfo(conflictInfo) {
            this.ensureWritable();
            this._conflictInfo = conflictInfo;
        }
        get conflictingAlts() {
            if (this._conflictInfo == null) return undefined;
            return this._conflictInfo.conflictedAlts;
        }
        get isExactConflict() {
            if (this._conflictInfo == null) return false;
            return this._conflictInfo.isExact;
        }
        get dipsIntoOuterContext() {
            return this._dipsIntoOuterContext;
        }
        get(index) {
            return this.configs[index];
        }
        ensureWritable() {
            if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
        }
    }
    $8c13542112ebfd78$var$__decorate([
        $d6D31.NotNull
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
    module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;
});
parcelRegister("gcX0f", function(module, exports) {
    "use strict";
    var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfig = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $dPYn6 = parcelRequire("dPYn6");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
    let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
        constructor(state, altOrConfig, context){
            if (typeof altOrConfig === "number") {
                $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig;
                this._context = context;
            } else {
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
                this._context = context;
            }
        }
        static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
            } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
            else return new ATNConfig(state, alt, context);
        }
        get state() {
            return this._state;
        }
        get alt() {
            return this.altAndOuterContextDepth & 0x00FFFFFF;
        }
        get context() {
            return this._context;
        }
        set context(context) {
            this._context = context;
        }
        get reachesIntoOuterContext() {
            return this.outerContextDepth !== 0;
        }
        get outerContextDepth() {
            return this.altAndOuterContextDepth >>> 24 & 0x7F;
        }
        set outerContextDepth(outerContextDepth) {
            $bbHFU(outerContextDepth >= 0);
            outerContextDepth = Math.min(outerContextDepth, 0x7F);
            this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
        }
        get lexerActionExecutor() {
            return undefined;
        }
        get semanticContext() {
            return $eHMgW.SemanticContext.NONE;
        }
        get hasPassedThroughNonGreedyDecision() {
            return false;
        }
        clone() {
            return this.transform(this.state, false);
        }
        transform(state, checkNonGreedy, arg2) {
            if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
            else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
        }
        transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
            let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
            } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
            else return new ATNConfig(state, this, context);
        }
        static checkNonGreedyDecision(source, target) {
            return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
        }
        appendContext(context, contextCache) {
            if (typeof context === "number") {
                let appendedContext = this.context.appendSingleContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            } else {
                let appendedContext = this.context.appendContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            }
        }
        contains(subconfig) {
            if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
            let leftWorkList = [];
            let rightWorkList = [];
            leftWorkList.push(this.context);
            rightWorkList.push(subconfig.context);
            while(true){
                let left = leftWorkList.pop();
                let right = rightWorkList.pop();
                if (!left || !right) break;
                if (left === right) return true;
                if (left.size < right.size) return false;
                if (right.isEmpty) return left.hasEmpty;
                else for(let i = 0; i < right.size; i++){
                    let index = left.findReturnState(right.getReturnState(i));
                    if (index < 0) return false;
                    leftWorkList.push(left.getParent(index));
                    rightWorkList.push(right.getParent(i));
                }
            }
            return false;
        }
        get isPrecedenceFilterSuppressed() {
            return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
        }
        set isPrecedenceFilterSuppressed(value) {
            if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
            else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ATNConfig)) return false;
            return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
            return hashCode;
        }
        toDotString() {
            let builder = "";
            builder += "digraph G {\n";
            builder += "rankdir=LR;\n";
            let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
            let workList = [];
            function getOrAddContext(context) {
                let newNumber = visited.size;
                let result = visited.putIfAbsent(context, newNumber);
                if (result != null) return result;
                workList.push(context);
                return newNumber;
            }
            workList.push(this.context);
            visited.put(this.context, 0);
            while(true){
                let current = workList.pop();
                if (!current) break;
                for(let i = 0; i < current.size; i++){
                    builder += "  s" + getOrAddContext(current);
                    builder += "->";
                    builder += "s" + getOrAddContext(current.getParent(i));
                    builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
                }
            }
            builder += "}\n";
            return builder.toString();
        }
        toString(recog, showAlt, showContext) {
            if (showContext == null) showContext = showAlt != null;
            if (showAlt == null) showAlt = true;
            let buf = "";
            let contexts;
            if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
            else contexts = [
                "?"
            ];
            let first = true;
            for (let contextDesc of contexts){
                if (first) first = false;
                else buf += ", ";
                buf += "(";
                buf += this.state;
                if (showAlt) {
                    buf += ",";
                    buf += this.alt;
                }
                if (this.context) {
                    buf += ",";
                    buf += contextDesc;
                }
                if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                    buf += ",";
                    buf += this.semanticContext;
                }
                if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
                buf += ")";
            }
            return buf.toString();
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull,
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig, "create", null);
    $bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig);
    module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
    let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(semanticContext, state, altOrConfig, context){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else super(state, altOrConfig, context);
            this._semanticContext = semanticContext;
        }
        get semanticContext() {
            return this._semanticContext;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig);
    let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else {
                super(state, altOrConfig, context);
                if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
            }
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionATNConfig);
    let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
        constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
            else super(semanticContext, state, altOrConfig, context);
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);
});
parcelRegister("dPYn6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DecisionState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.decision = -1;
            this.nonGreedy = false;
            this.sll = false;
        }
    }
    module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;
});
parcelRegister("8DTT0", function(module, exports) {
    "use strict";
    var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $6vF7J = parcelRequire("6vF7J");
    var $bbHFU = parcelRequire("bbHFU");
    const $64ad510fde44ff92$var$INITIAL_HASH = 1;
    class $64ad510fde44ff92$var$PredictionContext {
        constructor(cachedHashCode){
            this.cachedHashCode = cachedHashCode;
        }
        static calculateEmptyHashCode() {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.finish(hash, 0);
            return hash;
        }
        static calculateSingleHashCode(parent, returnState) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.update(hash, parent);
            hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2);
            return hash;
        }
        static calculateHashCode(parents, returnStates) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
            for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
            return hash;
        }
        static fromRuleContext(atn, outerContext, fullContext = true) {
            if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let parent;
            if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
            else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let state = atn.states[outerContext.invokingState];
            let transition = state.transition(0);
            return parent.getChild(transition.followState.stateNumber);
        }
        static addEmptyContext(context) {
            return context.addEmptyContext();
        }
        static removeEmptyContext(context) {
            return context.removeEmptyContext();
        }
        static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
            if (context0 === context1) return context0;
            if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
            else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
            let context0size = context0.size;
            let context1size = context1.size;
            if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
                let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
                if (merged === context0.getParent(0)) return context0;
                else if (merged === context1.getParent(0)) return context1;
                else return merged.getChild(context0.getReturnState(0));
            }
            let count = 0;
            let parentsList = new Array(context0size + context1size);
            let returnStatesList = new Array(parentsList.length);
            let leftIndex = 0;
            let rightIndex = 0;
            let canReturnLeft = true;
            let canReturnRight = true;
            while(leftIndex < context0size && rightIndex < context1size){
                if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                    parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                    canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                    leftIndex++;
                    rightIndex++;
                } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                    parentsList[count] = context0.getParent(leftIndex);
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnRight = false;
                    leftIndex++;
                } else {
                    $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                    parentsList[count] = context1.getParent(rightIndex);
                    returnStatesList[count] = context1.getReturnState(rightIndex);
                    canReturnLeft = false;
                    rightIndex++;
                }
                count++;
            }
            while(leftIndex < context0size){
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                leftIndex++;
                canReturnRight = false;
                count++;
            }
            while(rightIndex < context1size){
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                rightIndex++;
                canReturnLeft = false;
                count++;
            }
            if (canReturnLeft) return context0;
            else if (canReturnRight) return context1;
            if (count < parentsList.length) {
                parentsList = parentsList.slice(0, count);
                returnStatesList = returnStatesList.slice(0, count);
            }
            if (parentsList.length === 0) return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
            else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
            else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
        }
        static isEmptyLocal(context) {
            return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        }
        static getCachedContext(context, contextCache, visited) {
            if (context.isEmpty) return context;
            let existing = visited.get(context);
            if (existing) return existing;
            existing = contextCache.get(context);
            if (existing) {
                visited.put(context, existing);
                return existing;
            }
            let changed = false;
            let parents = new Array(context.size);
            for(let i = 0; i < parents.length; i++){
                let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
                if (changed || parent !== context.getParent(i)) {
                    if (!changed) {
                        parents = new Array(context.size);
                        for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                        changed = true;
                    }
                    parents[i] = parent;
                }
            }
            if (!changed) {
                existing = contextCache.putIfAbsent(context, context);
                visited.put(context, existing != null ? existing : context);
                return context;
            }
            let updated;
            if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
            else {
                let returnStates = new Array(context.size);
                for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
                updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
            }
            existing = contextCache.putIfAbsent(updated, updated);
            visited.put(updated, existing || updated);
            visited.put(context, existing || updated);
            return updated;
        }
        appendSingleContext(returnContext, contextCache) {
            return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
        }
        getChild(returnState) {
            return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
        }
        hashCode() {
            return this.cachedHashCode;
        }
        toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
            let result = [];
            outer: for(let perm = 0;; perm++){
                let offset = 0;
                let last = true;
                let p = this;
                let stateNumber = currentState;
                let localBuffer = "";
                localBuffer += "[";
                while(!p.isEmpty && p !== stop){
                    let index = 0;
                    if (p.size > 0) {
                        let bits = 1;
                        while(1 << bits >>> 0 < p.size)bits++;
                        let mask = (1 << bits >>> 0) - 1;
                        index = perm >> offset & mask;
                        last = last && index >= p.size - 1;
                        if (index >= p.size) continue outer;
                        offset += bits;
                    }
                    if (recognizer) {
                        if (localBuffer.length > 1) localBuffer += " ";
                        let atn = recognizer.atn;
                        let s = atn.states[stateNumber];
                        let ruleName = recognizer.ruleNames[s.ruleIndex];
                        localBuffer += ruleName;
                    } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                        if (!p.isEmpty) {
                            if (localBuffer.length > 1) localBuffer += " ";
                            localBuffer += p.getReturnState(index);
                        }
                    }
                    stateNumber = p.getReturnState(index);
                    p = p.getParent(index);
                }
                localBuffer += "]";
                result.push(localBuffer);
                if (last) break;
            }
            return result;
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "join", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
    module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
    class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(fullContext){
            super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
            this.fullContext = fullContext;
        }
        get isFullContext() {
            return this.fullContext;
        }
        addEmptyContext() {
            return this;
        }
        removeEmptyContext() {
            throw new Error("Cannot remove the empty context from itself.");
        }
        getParent(index) {
            throw new Error("index out of bounds");
        }
        getReturnState(index) {
            throw new Error("index out of bounds");
        }
        findReturnState(returnState) {
            return -1;
        }
        get size() {
            return 0;
        }
        appendSingleContext(returnContext, contextCache) {
            return contextCache.getChild(this, returnContext);
        }
        appendContext(suffix, contextCache) {
            return suffix;
        }
        get isEmpty() {
            return true;
        }
        get hasEmpty() {
            return true;
        }
        equals(o) {
            return this === o;
        }
        toStrings(recognizer, currentState, stop) {
            return [
                "[]"
            ];
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
    let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parents, returnStates, hashCode){
            super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
            $bbHFU(parents.length === returnStates.length);
            $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
            this.parents = parents;
            this.returnStates = returnStates;
        }
        getParent(index) {
            return this.parents[index];
        }
        getReturnState(index) {
            return this.returnStates[index];
        }
        findReturnState(returnState) {
            return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
        }
        get size() {
            return this.returnStates.length;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        addEmptyContext() {
            if (this.hasEmpty) return this;
            let parents2 = this.parents.slice(0);
            let returnStates2 = this.returnStates.slice(0);
            parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
            returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
        removeEmptyContext() {
            if (!this.hasEmpty) return this;
            if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
            else {
                let parents2 = this.parents.slice(0, this.parents.length - 1);
                let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
                return new ArrayPredictionContext(parents2, returnStates2);
            }
        }
        appendContext(suffix, contextCache) {
            return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
        }
        static appendContextImpl(context, suffix, visited) {
            if (suffix.isEmpty) {
                if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                    if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                    throw new Error("what to do here?");
                }
                return context;
            }
            if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
            let result = visited.get(context);
            if (!result) {
                if (context.isEmpty) result = suffix;
                else {
                    let parentCount = context.size;
                    if (context.hasEmpty) parentCount--;
                    let updatedParents = new Array(parentCount);
                    let updatedReturnStates = new Array(parentCount);
                    for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                    for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                    if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                    else {
                        $bbHFU(updatedParents.length > 1);
                        result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                    }
                    if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
                }
                visited.put(context, result);
            }
            return result;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ArrayPredictionContext)) return false;
            if (this.hashCode() !== o.hashCode()) return false;
            let other = o;
            return this.equalsImpl(other, new $7Veax.Array2DHashSet());
        }
        equalsImpl(other, visited) {
            let selfWorkList = [];
            let otherWorkList = [];
            selfWorkList.push(this);
            otherWorkList.push(other);
            while(true){
                let currentSelf = selfWorkList.pop();
                let currentOther = otherWorkList.pop();
                if (!currentSelf || !currentOther) break;
                let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
                if (!visited.add(operands)) continue;
                let selfSize = operands.x.size;
                if (selfSize === 0) {
                    if (!operands.x.equals(operands.y)) return false;
                    continue;
                }
                let otherSize = operands.y.size;
                if (selfSize !== otherSize) return false;
                for(let i = 0; i < selfSize; i++){
                    if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                    let selfParent = operands.x.getParent(i);
                    let otherParent = operands.y.getParent(i);
                    if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                    if (selfParent !== otherParent) {
                        selfWorkList.push(selfParent);
                        otherWorkList.push(otherParent);
                    }
                }
            }
            return true;
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$ArrayPredictionContext);
    let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parent, returnState){
            super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
            this.parent = parent;
            this.returnState = returnState;
        }
        getParent(index) {
            return this.parent;
        }
        getReturnState(index) {
            return this.returnState;
        }
        findReturnState(returnState) {
            return this.returnState === returnState ? 0 : -1;
        }
        get size() {
            return 1;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return false;
        }
        appendContext(suffix, contextCache) {
            return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
        }
        addEmptyContext() {
            let parents = [
                this.parent,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
            ];
            let returnStates = [
                this.returnState,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
            ];
            return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
        }
        removeEmptyContext() {
            return this;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof SingletonPredictionContext)) return false;
            let other = o;
            if (this.hashCode() !== other.hashCode()) return false;
            return this.returnState === other.returnState && this.parent.equals(other.parent);
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$SingletonPredictionContext);
    module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
    (function(PredictionContext) {
        PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
        PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
        PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
        PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
        class IdentityHashMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(IdentityEqualityComparator.INSTANCE);
            }
        }
        PredictionContext.IdentityHashMap = IdentityHashMap;
        class IdentityEqualityComparator {
            IdentityEqualityComparator() {}
            hashCode(obj) {
                return obj.hashCode();
            }
            equals(a, b) {
                return a === b;
            }
        }
        IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "hashCode", null);
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "equals", null);
        PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
    })($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));
});
parcelRegister("6vF7J", function(module, exports) {
    "use strict";
    var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionContextCache = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $4bd589a149816580$var$PredictionContextCache {
        constructor(enableCache = true){
            this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.enableCache = enableCache;
        }
        getAsCached(context) {
            if (!this.enableCache) return context;
            let result = this.contexts.get(context);
            if (!result) {
                result = context;
                this.contexts.put(context, context);
            }
            return result;
        }
        getChild(context, invokingState) {
            if (!this.enableCache) return context.getChild(invokingState);
            let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
            let result = this.childContexts.get(operands);
            if (!result) {
                result = context.getChild(invokingState);
                result = this.getAsCached(result);
                this.childContexts.put(operands, result);
            }
            return result;
        }
        join(x, y) {
            if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
            let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
            let result = this.joinContexts.get(operands);
            if (result) return result;
            result = $8DTT0.PredictionContext.join(x, y, this);
            result = this.getAsCached(result);
            this.joinContexts.put(operands, result);
            return result;
        }
    }
    module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
    $4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
    (function(PredictionContextCache) {
        class PredictionContextAndInt {
            constructor(obj, value){
                this.obj = obj;
                this.value = value;
            }
            equals(obj) {
                if (!(obj instanceof PredictionContextAndInt)) return false;
                else if (obj === this) return true;
                let other = obj;
                return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
            }
            hashCode() {
                let hashCode = 5;
                hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
                hashCode = 7 * hashCode + this.value;
                return hashCode;
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "hashCode", null);
        PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
        class IdentityCommutativePredictionContextOperands {
            constructor(x, y){
                $bbHFU(x != null);
                $bbHFU(y != null);
                this._x = x;
                this._y = y;
            }
            get x() {
                return this._x;
            }
            get y() {
                return this._y;
            }
            equals(o) {
                if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
                else if (this === o) return true;
                let other = o;
                return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
            }
            hashCode() {
                return this._x.hashCode() ^ this._y.hashCode();
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
        PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
    })($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));
});
parcelRegister("5BPMp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BitSet = void 0;
    var $9kAQu = parcelRequire("9kAQu");
    var $iXFjm = parcelRequire("iXFjm");
    const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
    function $415892d73e8925a4$var$getIndex(bitNumber) {
        return bitNumber >>> 4;
    }
    function $415892d73e8925a4$var$unIndex(n) {
        return n * 16;
    }
    function $415892d73e8925a4$var$findLSBSet(word) {
        let bit = 1;
        for(let i = 0; i < 16; i++){
            if ((word & bit) !== 0) return i;
            bit = bit << 1 >>> 0;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$findMSBSet(word) {
        let bit = 32768;
        for(let i = 15; i >= 0; i--){
            if ((word & bit) !== 0) return i;
            bit = bit >>> 1;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
        fromBit &= 0xF;
        toBit &= 0xF;
        if (fromBit === toBit) return 1 << fromBit >>> 0;
        return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
    }
    const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
    for(let i = 0; i < 16; i++){
        const stride = 1 << i >>> 0;
        let index = 0;
        while(index < $415892d73e8925a4$var$POP_CNT.length){
            index += stride;
            for(let j = 0; j < stride; j++){
                $415892d73e8925a4$var$POP_CNT[index]++;
                index++;
            }
        }
    }
    class $415892d73e8925a4$var$BitSet {
        constructor(arg){
            if (!arg) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (typeof arg === "number") {
                if (arg < 0) throw new RangeError("nbits cannot be negative");
                else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
            } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0);
            else {
                let max = -1;
                for (let v of arg)if (max < v) max = v;
                this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
                for (let v of arg)this.set(v);
            }
        }
        and(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        andNot(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i] ^ 0xFFFF;
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        cardinality() {
            if (this.isEmpty) return 0;
            const data = this.data;
            const length = data.length;
            let result = 0;
            for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
            return result;
        }
        clear(fromIndex, toIndex) {
            if (fromIndex == null) this.data.fill(0);
            else if (toIndex == null) this.set(fromIndex, false);
            else this.set(fromIndex, toIndex, false);
        }
        flip(fromIndex, toIndex) {
            if (toIndex == null) toIndex = fromIndex;
            if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
            else {
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
                while(word < lastWord)this.data[word++] ^= 0xFFFF;
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
            }
        }
        get(fromIndex, toIndex) {
            if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
            else {
                let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
                for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
                return result;
            }
        }
        intersects(set) {
            let smallerLength = Math.min(this.length(), set.length());
            if (smallerLength === 0) return false;
            let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
            for(let i = 0; i <= bound; i++){
                if ((this.data[i] & set.data[i]) !== 0) return true;
            }
            return false;
        }
        get isEmpty() {
            return this.length() === 0;
        }
        length() {
            if (!this.data.length) return 0;
            return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
        }
        nextClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] | ignore) === 0xFFFF) {
                word++;
                ignore = 0;
                for(; word < length; word++){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word === length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        nextSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] & mask) === 0) {
                word++;
                mask = 0xFFFF;
                for(; word < length; word++){
                    if (data[word] !== 0) break;
                }
                if (word >= length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
        }
        or(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] | other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord);
        }
        previousClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] | ignore) === 0xFFFF) {
                ignore = 0;
                word--;
                for(; word >= 0; word--){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        previousSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] & mask) === 0) {
                word--;
                mask = 0xFFFF;
                for(; word >= 0; word--){
                    if (data[word] !== 0) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
        }
        set(fromIndex, toIndex, value) {
            if (toIndex === undefined) {
                toIndex = fromIndex;
                value = true;
            } else if (typeof toIndex === "boolean") {
                value = toIndex;
                toIndex = fromIndex;
            }
            if (value === undefined) value = true;
            if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (value && lastWord >= this.data.length) {
                let temp = new Uint16Array(lastWord + 1);
                this.data.forEach((value, index)=>temp[index] = value);
                this.data = temp;
            } else if (!value) {
                if (word >= this.data.length) return;
                if (lastWord >= this.data.length) {
                    lastWord = this.data.length - 1;
                    toIndex = this.data.length * 16 - 1;
                }
            }
            if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
            else {
                this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
                while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
                this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
            }
        }
        _setBits(word, value, mask) {
            if (value) this.data[word] |= mask;
            else this.data[word] &= 0xFFFF ^ mask;
        }
        get size() {
            return this.data.byteLength * 8;
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.data, 22);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
            const len = this.length();
            if (len !== obj.length()) return false;
            if (len === 0) return true;
            let bound = $415892d73e8925a4$var$getIndex(len - 1);
            for(let i = 0; i <= bound; i++){
                if (this.data[i] !== obj.data[i]) return false;
            }
            return true;
        }
        toString() {
            let result = "{";
            let first = true;
            for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
                if (first) first = false;
                else result += ", ";
                result += i;
            }
            result += "}";
            return result;
        }
        xor(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] ^ other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord + 1);
        }
        clone() {
            return new $415892d73e8925a4$var$BitSet(this);
        }
        [Symbol.iterator]() {
            return new $415892d73e8925a4$var$BitSetIterator(this.data);
        }
        [$9kAQu.inspect.custom]() {
            return "BitSet " + this.toString();
        }
    }
    module.exports.BitSet = $415892d73e8925a4$var$BitSet;
    class $415892d73e8925a4$var$BitSetIterator {
        constructor(data){
            this.data = data;
            this.index = 0;
            this.mask = 0xFFFF;
        }
        next() {
            while(this.index < this.data.length){
                const bits = this.data[this.index] & this.mask;
                if (bits !== 0) {
                    const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                    this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                    return {
                        done: false,
                        value: bitNumber
                    };
                }
                this.index++;
                this.mask = 0xFFFF;
            }
            return {
                done: true,
                value: -1
            };
        }
        [Symbol.iterator]() {
            return this;
        }
    }
});
parcelRegister("yhTtv", function(module, exports) {
    "use strict";
    var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFASerializer = void 0;
    var $kr9A1 = parcelRequire("kr9A1");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $3n2FE = parcelRequire("3n2FE");
    class $06710e6ae1da410a$var$DFASerializer {
        constructor(dfa, vocabulary, ruleNames, atn){
            if (vocabulary instanceof $kBaAZ.Recognizer) {
                ruleNames = vocabulary.ruleNames;
                atn = vocabulary.atn;
                vocabulary = vocabulary.vocabulary;
            } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            this.dfa = dfa;
            this.vocabulary = vocabulary;
            this.ruleNames = ruleNames;
            this.atn = atn;
        }
        toString() {
            if (!this.dfa.s0) return "";
            let buf = "";
            if (this.dfa.states) {
                let states = new Array(...this.dfa.states.toArray());
                states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
                for (let s of states){
                    let edges = s.getEdgeMap();
                    let edgeKeys = [
                        ...edges.keys()
                    ].sort((a, b)=>a - b);
                    let contextEdges = s.getContextEdgeMap();
                    let contextEdgeKeys = [
                        ...contextEdges.keys()
                    ].sort((a, b)=>a - b);
                    for (let entry of edgeKeys){
                        let value = edges.get(entry);
                        if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                        let contextSymbol = false;
                        buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                        if (s.isContextSymbol(entry)) {
                            buf += "!";
                            contextSymbol = true;
                        }
                        let t = value;
                        if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                        else if (contextSymbol) buf += "ctx\n";
                    }
                    if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
                }
            }
            let output = buf;
            if (output.length === 0) return "";
            return output;
        }
        getContextLabel(i) {
            if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
            else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
            if (this.atn && i > 0 && i <= this.atn.states.length) {
                let state = this.atn.states[i];
                let ruleIndex = state.ruleIndex;
                if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
            }
            return "ctx:" + String(i);
        }
        getEdgeLabel(i) {
            return this.vocabulary.getDisplayName(i);
        }
        getStateString(s) {
            if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
            let n = s.stateNumber;
            let stateStr = "s" + n;
            if (s.isAcceptState) {
                if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
                else stateStr = ":s" + n + "=>" + s.prediction;
            }
            if (s.isContextSensitive) {
                stateStr += "*";
                for (let config of s.configs)if (config.reachesIntoOuterContext) {
                    stateStr += "*";
                    break;
                }
            }
            return stateStr;
        }
    }
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.Override
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
    module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;
});
parcelRegister("kr9A1", function(module, exports) {
    "use strict";
    var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNSimulator = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $2jevZ = parcelRequire("2jevZ");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
        constructor(atn){
            this.atn = atn;
        }
        static get ERROR() {
            if (!ATNSimulator._ERROR) {
                ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            }
            return ATNSimulator._ERROR;
        }
        clearDFA() {
            this.atn.clearDFA();
        }
    };
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
    $ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
        $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
    ], $ee0dc2a763a7368a$var$ATNSimulator);
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
    (function(ATNSimulator) {
        const RULE_VARIANT_DELIMITER = "$";
        const RULE_LF_VARIANT_MARKER = "$lf$";
        const RULE_NOLF_VARIANT_MARKER = "$nolf$";
    })($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
});
parcelRegister("2jevZ", function(module, exports) {
    "use strict";
    var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFAState = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $5BPMp = parcelRequire("5BPMp");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $1ae89d7ac78d8bff$var$DFAState {
        constructor(configs){
            this.stateNumber = -1;
            this.configs = configs;
            this.edges = new Map();
            this.contextEdges = new Map();
        }
        get isContextSensitive() {
            return !!this.contextSymbols;
        }
        isContextSymbol(symbol) {
            if (!this.isContextSensitive) return false;
            return this.contextSymbols.get(symbol);
        }
        setContextSymbol(symbol) {
            $bbHFU(this.isContextSensitive);
            this.contextSymbols.set(symbol);
        }
        setContextSensitive(atn) {
            $bbHFU(!this.configs.isOutermostConfigSet);
            if (this.isContextSensitive) return;
            if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
        }
        get acceptStateInfo() {
            return this._acceptStateInfo;
        }
        set acceptStateInfo(acceptStateInfo) {
            this._acceptStateInfo = acceptStateInfo;
        }
        get isAcceptState() {
            return !!this._acceptStateInfo;
        }
        get prediction() {
            if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            return this._acceptStateInfo.prediction;
        }
        get lexerActionExecutor() {
            if (!this._acceptStateInfo) return undefined;
            return this._acceptStateInfo.lexerActionExecutor;
        }
        getTarget(symbol) {
            return this.edges.get(symbol);
        }
        setTarget(symbol, target) {
            this.edges.set(symbol, target);
        }
        getEdgeMap() {
            return this.edges;
        }
        getContextTarget(invokingState) {
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            return this.contextEdges.get(invokingState);
        }
        setContextTarget(invokingState, target) {
            if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            this.contextEdges.set(invokingState, target);
        }
        getContextEdgeMap() {
            let map = new Map(this.contextEdges);
            let existing = map.get(-1);
            if (existing !== undefined) {
                if (map.size === 1) {
                    let result = new Map();
                    result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                    return result;
                } else {
                    map.delete(-1);
                    map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                }
            }
            return map;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize(7);
            hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
            hash = $iXFjm.MurmurHash.finish(hash, 1);
            return hash;
        }
        equals(o) {
            if (this === o) return true;
            if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
            let other = o;
            let sameSet = this.configs.equals(other.configs);
            return sameSet;
        }
        toString() {
            let buf = "";
            buf += this.stateNumber + ":" + this.configs;
            if (this.isAcceptState) {
                buf += "=>";
                if (this.predicates) buf += this.predicates;
                else buf += this.prediction;
            }
            return buf.toString();
        }
    }
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
    module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
    (function(DFAState) {
        let PredPrediction = class PredPrediction {
            constructor(pred, alt){
                this.alt = alt;
                this.pred = pred;
            }
            toString() {
                return "(" + this.pred + ", " + this.alt + ")";
            }
        };
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.NotNull
        ], PredPrediction.prototype, "pred", void 0);
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.Override
        ], PredPrediction.prototype, "toString", null);
        PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
            $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
        ], PredPrediction);
        DFAState.PredPrediction = PredPrediction;
    })($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));
});
parcelRegister("kBaAZ", function(module, exports) {
    "use strict";
    var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Recognizer = void 0;
    var $e5mHr = parcelRequire("e5mHr");
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $efef7b6bec20bc2a$var$Recognizer {
        constructor(){
            this._listeners = [
                $e5mHr.ConsoleErrorListener.INSTANCE
            ];
            this._stateNumber = -1;
        }
        getTokenTypeMap() {
            let vocabulary = this.vocabulary;
            let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
            if (result == null) {
                let intermediateResult = new Map();
                for(let i = 0; i <= this.atn.maxTokenType; i++){
                    let literalName = vocabulary.getLiteralName(i);
                    if (literalName != null) intermediateResult.set(literalName, i);
                    let symbolicName = vocabulary.getSymbolicName(i);
                    if (symbolicName != null) intermediateResult.set(symbolicName, i);
                }
                intermediateResult.set("EOF", $2DVsz.Token.EOF);
                result = intermediateResult;
                $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
            }
            return result;
        }
        getRuleIndexMap() {
            let ruleNames = this.ruleNames;
            if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
            let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
            if (result == null) {
                result = $2IEP9.toMap(ruleNames);
                $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
            }
            return result;
        }
        getTokenType(tokenName) {
            let ttype = this.getTokenTypeMap().get(tokenName);
            if (ttype != null) return ttype;
            return $2DVsz.Token.INVALID_TYPE;
        }
        get serializedATN() {
            throw new Error("there is no serialized ATN");
        }
        get atn() {
            return this._interp.atn;
        }
        get interpreter() {
            return this._interp;
        }
        set interpreter(interpreter) {
            this._interp = interpreter;
        }
        get parseInfo() {
            return Promise.resolve(undefined);
        }
        getErrorHeader(e) {
            let token = e.getOffendingToken();
            if (!token) return "";
            let line = token.line;
            let charPositionInLine = token.charPositionInLine;
            return "line " + line + ":" + charPositionInLine;
        }
        addErrorListener(listener) {
            if (!listener) throw new TypeError("listener must not be null");
            this._listeners.push(listener);
        }
        removeErrorListener(listener) {
            let position = this._listeners.indexOf(listener);
            if (position !== -1) this._listeners.splice(position, 1);
        }
        removeErrorListeners() {
            this._listeners.length = 0;
        }
        getErrorListeners() {
            return this._listeners.slice(0);
        }
        getErrorListenerDispatch() {
            return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
        }
        sempred(_localctx, ruleIndex, actionIndex) {
            return true;
        }
        precpred(localctx, precedence) {
            return true;
        }
        action(_localctx, ruleIndex, actionIndex) {}
        get state() {
            return this._stateNumber;
        }
        set state(atnState) {
            this._stateNumber = atnState;
        }
    }
    $efef7b6bec20bc2a$var$Recognizer.EOF = -1;
    $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.SuppressWarnings("serial"),
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
    module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;
});
parcelRegister("e5mHr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConsoleErrorListener = void 0;
    class $a413240156cc2e50$var$ConsoleErrorListener {
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            console.error(`line ${line}:${charPositionInLine} ${msg}`);
        }
    }
    module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
    $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();
});
parcelRegister("65iNZ", function(module, exports) {
    "use strict";
    var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyErrorListener = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
        constructor(delegates){
            this.delegates = delegates;
            if (!delegates) throw new Error("Invalid delegates");
        }
        getDelegates() {
            return this.delegates;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            this.delegates.forEach((listener)=>{
                if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
            });
        }
    }
    $46e1cc07c7f5b3d6$var$__decorate([
        $d6D31.Override,
        $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
        $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
    ], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
    module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;
});
parcelRegister("3n2FE", function(module, exports) {
    "use strict";
    var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.VocabularyImpl = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $27459777e7d4e735$var$VocabularyImpl {
        constructor(literalNames, symbolicNames, displayNames){
            this.literalNames = literalNames;
            this.symbolicNames = symbolicNames;
            this.displayNames = displayNames;
            this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
        }
        get maxTokenType() {
            return this._maxTokenType;
        }
        getLiteralName(tokenType) {
            if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
            return undefined;
        }
        getSymbolicName(tokenType) {
            if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
            if (tokenType === $2DVsz.Token.EOF) return "EOF";
            return undefined;
        }
        getDisplayName(tokenType) {
            if (tokenType >= 0 && tokenType < this.displayNames.length) {
                let displayName = this.displayNames[tokenType];
                if (displayName) return displayName;
            }
            let literalName = this.getLiteralName(tokenType);
            if (literalName) return literalName;
            let symbolicName = this.getSymbolicName(tokenType);
            if (symbolicName) return symbolicName;
            return String(tokenType);
        }
    }
    $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
    module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;
});
parcelRegister("aeRGo", function(module, exports) {
    "use strict";
    var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerDFASerializer = void 0;
    var $yhTtv = parcelRequire("yhTtv");
    var $d6D31 = parcelRequire("d6D31");
    var $3n2FE = parcelRequire("3n2FE");
    let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
        constructor(dfa){
            super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
        }
        getEdgeLabel(i) {
            return "'" + String.fromCodePoint(i) + "'";
        }
    };
    $7744da7bed4bb192$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
    $7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
        $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
    ], $7744da7bed4bb192$var$LexerDFASerializer);
    module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;
});
parcelRegister("f9raX", function(module, exports) {
    "use strict";
    var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopEntryState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
        constructor(){
            super(...arguments);
            this.precedenceRuleDecision = false;
            this.precedenceLoopbackStates = new $5BPMp.BitSet();
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
        }
    }
    $b07cc6cfd56668a7$var$__decorate([
        $d6D31.Override
    ], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
    module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;
});
parcelRegister("l4Nh1", function(module, exports) {
    "use strict";
    var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InvalidState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $d6D31 = parcelRequire("d6D31");
    class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
        get stateType() {
            return $1bs3X.ATNStateType.INVALID_TYPE;
        }
    }
    $f580316b3d8851ef$var$__decorate([
        $d6D31.Override
    ], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
    module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;
});
parcelRegister("4yiuQ", function(module, exports) {
    "use strict";
    var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BASIC;
        }
    }
    $3508af691e74fe3f$var$__decorate([
        $d6D31.Override
    ], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
    module.exports.BasicState = $3508af691e74fe3f$var$BasicState;
});
parcelRegister("iiE1V", function(module, exports) {
    "use strict";
    var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LL1Analyzer = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $7Veax = parcelRequire("7Veax");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $2DVsz = parcelRequire("2DVsz");
    var $aPmi9 = parcelRequire("aPmi9");
    let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
        constructor(atn){
            this.atn = atn;
        }
        getDecisionLookahead(s) {
            if (s == null) return undefined;
            let look = new Array(s.numberOfTransitions);
            for(let alt = 0; alt < s.numberOfTransitions; alt++){
                let current = new $hGRod.IntervalSet();
                look[alt] = current;
                let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                let seeThruPreds = false;
                this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
                if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                    current = undefined;
                    look[alt] = current;
                }
            }
            return look;
        }
        LOOK(s, ctx, stopState) {
            if (stopState === undefined) {
                if (s.atn == null) throw new Error("Illegal state");
                stopState = s.atn.ruleToStopState[s.ruleIndex];
            } else if (stopState === null) stopState = undefined;
            let r = new $hGRod.IntervalSet();
            let seeThruPreds = true;
            let addEOF = true;
            this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
            return r;
        }
        _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
            let c = $gcX0f.ATNConfig.create(s, 0, ctx);
            if (!lookBusy.add(c)) return;
            if (s === stopState) {
                if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    look.add($2DVsz.Token.EPSILON);
                    return;
                } else if (ctx.isEmpty) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
            }
            if (s instanceof $4kGBm.RuleStopState) {
                if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
                let removed = calledRuleStack.get(s.ruleIndex);
                try {
                    calledRuleStack.clear(s.ruleIndex);
                    for(let i = 0; i < ctx.size; i++){
                        if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                        let returnState = this.atn.states[ctx.getReturnState(i)];
                        this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    }
                } finally{
                    if (removed) calledRuleStack.set(s.ruleIndex);
                }
            }
            let n = s.numberOfTransitions;
            for(let i = 0; i < n; i++){
                let t = s.transition(i);
                if (t instanceof $aybFP.RuleTransition) {
                    if (calledRuleStack.get(t.ruleIndex)) continue;
                    let newContext = ctx.getChild(t.followState.stateNumber);
                    try {
                        calledRuleStack.set(t.ruleIndex);
                        this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    } finally{
                        calledRuleStack.clear(t.ruleIndex);
                    }
                } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                    if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    else look.add(LL1Analyzer.HIT_PRED);
                } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                else {
                    let set = t.label;
                    if (set != null) {
                        if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                        look.addAll(set);
                    }
                }
            }
        }
    };
    $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull,
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
    $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
    $d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer);
    module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;
});
parcelRegister("FLEKS", function(module, exports) {
    "use strict";
    var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NotSetTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $Np2R3 = parcelRequire("Np2R3");
    let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
        constructor(target, set){
            super(target, set);
        }
        get serializationType() {
            return 8;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
        }
        toString() {
            return "~" + super.toString();
        }
    };
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
    $07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
        $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
        $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
    ], $07d8cc01972b24a7$var$NotSetTransition);
    module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;
});
parcelRegister("Np2R3", function(module, exports) {
    "use strict";
    var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SetTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
        constructor(target, set){
            super(target);
            if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
            this.set = set;
        }
        get serializationType() {
            return 7;
        }
        get label() {
            return this.set;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this.set.contains(symbol);
        }
        toString() {
            return this.set.toString();
        }
    };
    $094801244c2d1a04$var$__decorate([
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
    $094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
        $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
        $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
    ], $094801244c2d1a04$var$SetTransition);
    module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;
});
parcelRegister("4kGBm", function(module, exports) {
    "use strict";
    var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStopState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
        get nonStopStateNumber() {
            return -1;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_STOP;
        }
    }
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
    module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;
});
parcelRegister("aybFP", function(module, exports) {
    "use strict";
    var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
        constructor(ruleStart, ruleIndex, precedence, followState){
            super(ruleStart);
            this.tailCall = false;
            this.optimizedTailCall = false;
            this.ruleIndex = ruleIndex;
            this.precedence = precedence;
            this.followState = followState;
        }
        get serializationType() {
            return 3;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
    };
    $7ae622834621fa3c$var$__decorate([
        $d6D31.NotNull
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
    $7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
        $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
        $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
    ], $7ae622834621fa3c$var$RuleTransition);
    module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;
});
parcelRegister("aPmi9", function(module, exports) {
    "use strict";
    var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.WildcardTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
        get serializationType() {
            return 9;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
        }
        toString() {
            return ".";
        }
    };
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
    $7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
        $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
    ], $7e1ff581bbf7382f$var$WildcardTransition);
    module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;
});
parcelRegister("3AYVu", function(module, exports) {
    "use strict";
    var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerActionExecutor = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $4LVXs = parcelRequire("4LVXs");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
        constructor(lexerActions){
            this._lexerActions = lexerActions;
            let hash = $iXFjm.MurmurHash.initialize();
            for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
            this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
        }
        static append(lexerActionExecutor, lexerAction) {
            if (!lexerActionExecutor) return new LexerActionExecutor([
                lexerAction
            ]);
            let lexerActions = lexerActionExecutor._lexerActions.slice(0);
            lexerActions.push(lexerAction);
            return new LexerActionExecutor(lexerActions);
        }
        fixOffsetBeforeMatch(offset) {
            let updatedLexerActions;
            for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
                if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
                updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
            }
            if (!updatedLexerActions) return this;
            return new LexerActionExecutor(updatedLexerActions);
        }
        get lexerActions() {
            return this._lexerActions;
        }
        execute(lexer, input, startIndex) {
            let requiresSeek = false;
            let stopIndex = input.index;
            try {
                for (let lexerAction of this._lexerActions){
                    if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                        let offset = lexerAction.offset;
                        input.seek(startIndex + offset);
                        lexerAction = lexerAction.action;
                        requiresSeek = startIndex + offset !== stopIndex;
                    } else if (lexerAction.isPositionDependent) {
                        input.seek(stopIndex);
                        requiresSeek = false;
                    }
                    lexerAction.execute(lexer);
                }
            } finally{
                if (requiresSeek) input.seek(stopIndex);
            }
        }
        hashCode() {
            return this.cachedHashCode;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerActionExecutor)) return false;
            return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
        }
    };
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
    $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull,
        $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
    $29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor);
    module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;
});
parcelRegister("4LVXs", function(module, exports) {
    "use strict";
    var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerIndexedCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
        constructor(offset, action){
            this._offset = offset;
            this._action = action;
        }
        get offset() {
            return this._offset;
        }
        get action() {
            return this._action;
        }
        get actionType() {
            return this._action.actionType;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            this._action.execute(lexer);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this._offset);
            hash = $iXFjm.MurmurHash.update(hash, this._action);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerIndexedCustomAction)) return false;
            return this._offset === obj._offset && this._action.equals(obj._action);
        }
    };
    $3798827adeb28bf0$var$__decorate([
        $d6D31.NotNull
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
    $3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
        $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction);
    module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;
});
parcelRegister("fOEQQ", function(module, exports) {
    "use strict";
    var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerNoViableAltException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    var $2IEP9 = parcelRequire("2IEP9");
    let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
        constructor(lexer, input, startIndex, deadEndConfigs){
            super(lexer, input);
            this._startIndex = startIndex;
            this._deadEndConfigs = deadEndConfigs;
        }
        get startIndex() {
            return this._startIndex;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
        get inputStream() {
            return super.inputStream;
        }
        toString() {
            let symbol = "";
            if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
                symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
                symbol = $2IEP9.escapeWhitespace(symbol, false);
            }
            return `LexerNoViableAltException('${symbol}')`;
        }
    };
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
    $b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
        $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
    ], $b83b36c534666cfd$var$LexerNoViableAltException);
    module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;
});
parcelRegister("9tIYC", function(module, exports) {
    "use strict";
    var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.OrderedATNConfigSet = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $d6D31 = parcelRequire("d6D31");
    class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
        constructor(set, readonly){
            if (set != null && readonly != null) super(set, readonly);
            else super();
        }
        clone(readonly) {
            let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this);
            return copy;
        }
        getKey(e) {
            return {
                state: 0,
                alt: e.hashCode()
            };
        }
        canMerge(left, leftKey, right) {
            return left.equals(right);
        }
    }
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
    module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;
});
parcelRegister("hKCjP", function(module, exports) {
    "use strict";
    var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NoViableAltException = void 0;
    var $jIG0W = parcelRequire("jIG0W");
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
        constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
            if (recognizer instanceof $jIG0W.Parser) {
                if (input === undefined) input = recognizer.inputStream;
                if (startToken === undefined) startToken = recognizer.currentToken;
                if (offendingToken === undefined) offendingToken = recognizer.currentToken;
                if (ctx === undefined) ctx = recognizer.context;
            }
            super(recognizer, input, ctx);
            this._deadEndConfigs = deadEndConfigs;
            this._startToken = startToken;
            this.setOffendingToken(recognizer, offendingToken);
        }
        get startToken() {
            return this._startToken;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
    }
    $cec474d99a10f341$var$__decorate([
        $d6D31.NotNull
    ], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
    module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;
});
parcelRegister("jIG0W", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Parser = void 0;
    var $2IEP9 = parcelRequire("2IEP9");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $dvgsl = parcelRequire("dvgsl");
    var $4CCJj = parcelRequire("4CCJj");
    var $cdCft = parcelRequire("cdCft");
    var $6Kebn = parcelRequire("6Kebn");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $3iOjI = parcelRequire("3iOjI");
    var $kzbnL = parcelRequire("kzbnL");
    var $5xwgp = parcelRequire("5xwgp");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    class $e5b2b780657df507$var$TraceListener {
        constructor(ruleNames, tokenStream){
            this.ruleNames = ruleNames;
            this.tokenStream = tokenStream;
        }
        enterEveryRule(ctx) {
            console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        exitEveryRule(ctx) {
            console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        visitErrorNode(node) {}
        visitTerminal(node) {
            let parent = node.parent.ruleContext;
            let token = node.symbol;
            console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
        }
    }
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);
    class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._errHandler = new $4CCJj.DefaultErrorStrategy();
            this._precedenceStack = new $6Kebn.IntegerStack();
            this._buildParseTrees = true;
            this._parseListeners = [];
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this._precedenceStack.push(0);
            this.inputStream = input;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this.inputStream.seek(0);
            this._errHandler.reset(this);
            this._ctx = undefined;
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this.isTrace = false;
            this._precedenceStack.clear();
            this._precedenceStack.push(0);
            let interpreter = this.interpreter;
            if (interpreter != null) interpreter.reset();
        }
        match(ttype) {
            let t = this.currentToken;
            if (t.type === ttype) {
                if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        matchWildcard() {
            let t = this.currentToken;
            if (t.type > 0) {
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        set buildParseTree(buildParseTrees) {
            this._buildParseTrees = buildParseTrees;
        }
        get buildParseTree() {
            return this._buildParseTrees;
        }
        getParseListeners() {
            return this._parseListeners;
        }
        addParseListener(listener) {
            if (listener == null) throw new TypeError("listener cannot be null");
            this._parseListeners.push(listener);
        }
        removeParseListener(listener) {
            let index = this._parseListeners.findIndex((l)=>l === listener);
            if (index !== -1) this._parseListeners.splice(index, 1);
        }
        removeParseListeners() {
            this._parseListeners.length = 0;
        }
        triggerEnterRuleEvent() {
            for (let listener of this._parseListeners){
                if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
                this._ctx.enterRule(listener);
            }
        }
        triggerExitRuleEvent() {
            for(let i = this._parseListeners.length - 1; i >= 0; i--){
                let listener = this._parseListeners[i];
                this._ctx.exitRule(listener);
                if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
            }
        }
        get numberOfSyntaxErrors() {
            return this._syntaxErrors;
        }
        get tokenFactory() {
            return this._input.tokenSource.tokenFactory;
        }
        getATNWithBypassAlts() {
            let serializedAtn = this.serializedATN;
            if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
            let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
            if (result == null) {
                let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
                deserializationOptions.isGenerateRuleBypassTransitions = true;
                result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
                $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
            }
            return result;
        }
        compileParseTreePattern(pattern, patternRuleIndex, lexer) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                if (!lexer) {
                    if (this.inputStream) {
                        let tokenSource = this.inputStream.tokenSource;
                        if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                    }
                    if (!lexer) throw new Error("Parser can't discover a lexer to use");
                }
                let currentLexer = lexer;
                let m = yield Promise.resolve().then(()=>(parcelRequire("dE6Cn")));
                let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
                return matcher.compile(pattern, patternRuleIndex);
            });
        }
        get errorHandler() {
            return this._errHandler;
        }
        set errorHandler(handler) {
            this._errHandler = handler;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
        }
        get currentToken() {
            return this._input.LT(1);
        }
        notifyErrorListeners(msg, offendingToken, e) {
            if (offendingToken === undefined) offendingToken = this.currentToken;
            else if (offendingToken === null) offendingToken = undefined;
            this._syntaxErrors++;
            let line = -1;
            let charPositionInLine = -1;
            if (offendingToken != null) {
                line = offendingToken.line;
                charPositionInLine = offendingToken.charPositionInLine;
            }
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
        }
        consume() {
            let o = this.currentToken;
            if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
            let hasListener = this._parseListeners.length !== 0;
            if (this._buildParseTrees || hasListener) {
                if (this._errHandler.inErrorRecoveryMode(this)) {
                    let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                    }
                } else {
                    let node = this.createTerminalNode(this._ctx, o);
                    this._ctx.addChild(node);
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                    }
                }
            }
            return o;
        }
        createTerminalNode(parent, t) {
            return new $kYC92.TerminalNode(t);
        }
        createErrorNode(parent, t) {
            return new $cdCft.ErrorNode(t);
        }
        addContextToParseTree() {
            let parent = this._ctx._parent;
            if (parent != null) parent.addChild(this._ctx);
        }
        enterRule(localctx, state, ruleIndex) {
            this.state = state;
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        enterLeftFactoredRule(localctx, state, ruleIndex) {
            this.state = state;
            if (this._buildParseTrees) {
                let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
                this._ctx.removeLastChild();
                factoredContext._parent = localctx;
                localctx.addChild(factoredContext);
            }
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        exitRule() {
            if (this.matchedEOF) this._ctx._stop = this._input.LT(1);
            else this._ctx._stop = this._input.tryLT(-1);
            this.triggerExitRuleEvent();
            this.state = this._ctx.invokingState;
            this._ctx = this._ctx._parent;
        }
        enterOuterAlt(localctx, altNum) {
            localctx.altNumber = altNum;
            if (this._buildParseTrees && this._ctx !== localctx) {
                let parent = this._ctx._parent;
                if (parent != null) {
                    parent.removeLastChild();
                    parent.addChild(localctx);
                }
            }
            this._ctx = localctx;
        }
        get precedence() {
            if (this._precedenceStack.isEmpty) return -1;
            return this._precedenceStack.peek();
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this.state = state;
            this._precedenceStack.push(precedence);
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            this.triggerEnterRuleEvent();
        }
        pushNewRecursionContext(localctx, state, ruleIndex) {
            let previous = this._ctx;
            previous._parent = localctx;
            previous.invokingState = state;
            previous._stop = this._input.tryLT(-1);
            this._ctx = localctx;
            this._ctx._start = previous._start;
            if (this._buildParseTrees) this._ctx.addChild(previous);
            this.triggerEnterRuleEvent();
        }
        unrollRecursionContexts(_parentctx) {
            this._precedenceStack.pop();
            this._ctx._stop = this._input.tryLT(-1);
            let retctx = this._ctx;
            if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
                this.triggerExitRuleEvent();
                this._ctx = this._ctx._parent;
            }
            else this._ctx = _parentctx;
            retctx._parent = _parentctx;
            if (this._buildParseTrees && _parentctx != null) _parentctx.addChild(retctx);
        }
        getInvokingContext(ruleIndex) {
            let p = this._ctx;
            while(p && p.ruleIndex !== ruleIndex)p = p._parent;
            return p;
        }
        get context() {
            return this._ctx;
        }
        set context(ctx) {
            this._ctx = ctx;
        }
        precpred(localctx, precedence) {
            return precedence >= this._precedenceStack.peek();
        }
        getErrorListenerDispatch() {
            return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
        }
        inContext(context) {
            return false;
        }
        isExpectedToken(symbol) {
            let atn = this.interpreter.atn;
            let ctx = this._ctx;
            let s = atn.states[this.state];
            let following = atn.nextTokens(s);
            if (following.contains(symbol)) return true;
            if (!following.contains($2DVsz.Token.EPSILON)) return false;
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = atn.nextTokens(rt.followState);
                if (following.contains(symbol)) return true;
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
            return false;
        }
        get isMatchedEOF() {
            return this.matchedEOF;
        }
        getExpectedTokens() {
            return this.atn.getExpectedTokens(this.state, this.context);
        }
        getExpectedTokensWithinCurrentRule() {
            let atn = this.interpreter.atn;
            let s = atn.states[this.state];
            return atn.nextTokens(s);
        }
        getRuleIndex(ruleName) {
            let ruleIndex = this.getRuleIndexMap().get(ruleName);
            if (ruleIndex != null) return ruleIndex;
            return -1;
        }
        get ruleContext() {
            return this._ctx;
        }
        getRuleInvocationStack(ctx = this._ctx) {
            let p = ctx;
            let ruleNames = this.ruleNames;
            let stack = [];
            while(p != null){
                let ruleIndex = p.ruleIndex;
                if (ruleIndex < 0) stack.push("n/a");
                else stack.push(ruleNames[ruleIndex]);
                p = p._parent;
            }
            return stack;
        }
        getDFAStrings() {
            let s = [];
            for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
            return s;
        }
        dumpDFA() {
            let seenOne = false;
            for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
                if (seenOne) console.log();
                console.log("Decision " + dfa.decision + ":");
                $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
                seenOne = true;
            }
        }
        get sourceName() {
            return this._input.sourceName;
        }
        get parseInfo() {
            return Promise.resolve().then(()=>(parcelRequire("kSEFX"))).then((m)=>{
                let interp = this.interpreter;
                if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
                return undefined;
            });
        }
        setProfile(profile) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                let m = yield Promise.resolve().then(()=>(parcelRequire("kSEFX")));
                let interp = this.interpreter;
                if (profile) {
                    if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
                } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
                this.interpreter.setPredictionMode(interp.getPredictionMode());
            });
        }
        set isTrace(trace) {
            if (!trace) {
                if (this._tracer) {
                    this.removeParseListener(this._tracer);
                    this._tracer = undefined;
                }
            } else {
                if (this._tracer) this.removeParseListener(this._tracer);
                else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
                this.addParseListener(this._tracer);
            }
        }
        get isTrace() {
            return this._tracer != null;
        }
    }
    $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "match", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull,
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override,
        $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
    ], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
    module.exports.Parser = $e5b2b780657df507$var$Parser;
});
parcelRegister("2M2qJ", function(module, exports) {
    "use strict";
    var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializationOptions = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $2051f30d0c577226$var$ATNDeserializationOptions {
        constructor(options){
            this.readOnly = false;
            if (options) {
                this.verifyATN = options.verifyATN;
                this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
                this.optimize = options.optimize;
            } else {
                this.verifyATN = true;
                this.generateRuleBypassTransitions = false;
                this.optimize = true;
            }
        }
        static get defaultOptions() {
            if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
            }
            return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
        }
        get isReadOnly() {
            return this.readOnly;
        }
        makeReadOnly() {
            this.readOnly = true;
        }
        get isVerifyATN() {
            return this.verifyATN;
        }
        set isVerifyATN(verifyATN) {
            this.throwIfReadOnly();
            this.verifyATN = verifyATN;
        }
        get isGenerateRuleBypassTransitions() {
            return this.generateRuleBypassTransitions;
        }
        set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
            this.throwIfReadOnly();
            this.generateRuleBypassTransitions = generateRuleBypassTransitions;
        }
        get isOptimize() {
            return this.optimize;
        }
        set isOptimize(optimize) {
            this.throwIfReadOnly();
            this.optimize = optimize;
        }
        throwIfReadOnly() {
            if (this.isReadOnly) throw new Error("The object is read only.");
        }
    }
    $2051f30d0c577226$var$__decorate([
        $d6D31.NotNull
    ], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
    module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;
});
parcelRegister("dvgsl", function(module, exports) {
    "use strict";
    var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializer = void 0;
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $bcnvE = parcelRequire("bcnvE");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $gAm9p = parcelRequire("gAm9p");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $5BPMp = parcelRequire("5BPMp");
    var $loKp0 = parcelRequire("loKp0");
    var $65vNG = parcelRequire("65vNG");
    var $dPYn6 = parcelRequire("dPYn6");
    var $jJRyp = parcelRequire("jJRyp");
    var $bpnRH = parcelRequire("bpnRH");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iw4Ko = parcelRequire("iw4Ko");
    var $RgRAX = parcelRequire("RgRAX");
    var $jgJtt = parcelRequire("jgJtt");
    var $l606e = parcelRequire("l606e");
    var $6hIs4 = parcelRequire("6hIs4");
    var $a9nIX = parcelRequire("a9nIX");
    var $2Gb96 = parcelRequire("2Gb96");
    var $ayRdK = parcelRequire("ayRdK");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $kzbnL = parcelRequire("kzbnL");
    var $d1V7w = parcelRequire("d1V7w");
    var $7qlbM = parcelRequire("7qlbM");
    var $7KGEQ = parcelRequire("7KGEQ");
    var $hnaRv = parcelRequire("hnaRv");
    var $aISkF = parcelRequire("aISkF");
    var $j2zc8 = parcelRequire("j2zc8");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $Np2R3 = parcelRequire("Np2R3");
    var $jEsaF = parcelRequire("jEsaF");
    var $bjwd1 = parcelRequire("bjwd1");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    var $WS4d7 = parcelRequire("WS4d7");
    var $kWxOc = parcelRequire("kWxOc");
    var $aPmi9 = parcelRequire("aPmi9");
    var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
    (function(UnicodeDeserializingMode) {
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
    })($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
    class $9d4aef733dce84f9$var$ATNDeserializer {
        constructor(deserializationOptions){
            if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
            this.deserializationOptions = deserializationOptions;
        }
        static get SERIALIZED_VERSION() {
            return 3;
        }
        static isFeatureSupported(feature, actualUuid) {
            let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
            if (featureIndex < 0) return false;
            return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
        }
        static getUnicodeDeserializer(mode) {
            if (mode === 0) return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                },
                size: 1
            };
            else return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
                },
                size: 2
            };
        }
        deserialize(data) {
            data = data.slice(0);
            for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
            let p = 0;
            let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
                let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
                throw new Error(reason);
            }
            let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
            p += 8;
            if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
                let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
                throw new Error(reason);
            }
            let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
            let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let atn = new $bcnvE.ATN(grammarType, maxTokenType);
            let loopBackStateNumbers = [];
            let endStateNumbers = [];
            let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nstates; i++){
                let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                    atn.addState(new $l4Nh1.InvalidState());
                    continue;
                }
                let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (ruleIndex === 0xFFFF) ruleIndex = -1;
                let s = this.stateFactory(stype, ruleIndex);
                if (stype === $1bs3X.ATNStateType.LOOP_END) {
                    let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    loopBackStateNumbers.push([
                        s,
                        loopBackStateNumber
                    ]);
                } else if (s instanceof $65vNG.BlockStartState) {
                    let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    endStateNumbers.push([
                        s,
                        endStateNumber
                    ]);
                }
                atn.addState(s);
            }
            for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
            for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
            let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numNonGreedyStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].nonGreedy = true;
            }
            let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numSllDecisions; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].sll = true;
            }
            let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numPrecedenceStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].isPrecedenceRule = true;
            }
            let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (atn.grammarType === 0) atn.ruleToTokenType = new Int32Array(nrules);
            atn.ruleToStartState = new Array(nrules);
            for(let i = 0; i < nrules; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let startState = atn.states[s];
                startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                atn.ruleToStartState[i] = startState;
                if (atn.grammarType === 0) {
                    let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                    atn.ruleToTokenType[i] = tokenType;
                    if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                        let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                    }
                }
            }
            atn.ruleToStopState = new Array(nrules);
            for (let state of atn.states){
                if (!(state instanceof $4kGBm.RuleStopState)) continue;
                atn.ruleToStopState[state.ruleIndex] = state;
                atn.ruleToStartState[state.ruleIndex].stopState = state;
            }
            let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nmodes; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.modeToStartState.push(atn.states[s]);
            }
            atn.modeToDFA = new Array(nmodes);
            for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
            let sets = [];
            p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0));
            if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1));
            let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nedges; i++){
                let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
                let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
                let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
                let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
                let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
                let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
                let srcState = atn.states[src];
                srcState.addTransition(trans);
                p += 6;
            }
            let returnTransitionsSet = new $7Veax.Array2DHashSet({
                hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
                equals: (a, b)=>{
                    return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
                }
            });
            let returnTransitions = [];
            for (let state of atn.states){
                let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let t = state.transition(i);
                    if (!(t instanceof $aybFP.RuleTransition)) continue;
                    let ruleTransition = t;
                    let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                    if (!returningFromLeftFactored && returningToLeftFactored) continue;
                    let outermostPrecedenceReturn = -1;
                    if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                        if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                    }
                    let current = {
                        stopState: ruleTransition.target.ruleIndex,
                        returnState: ruleTransition.followState.stateNumber,
                        outermostPrecedenceReturn: outermostPrecedenceReturn
                    };
                    if (returnTransitionsSet.add(current)) returnTransitions.push(current);
                }
            }
            for (let returnTransition of returnTransitions){
                let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
                atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
            }
            for (let state of atn.states){
                if (state instanceof $65vNG.BlockStartState) {
                    if (state.endState === undefined) throw new Error("IllegalStateException");
                    if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                    state.endState.startState = state;
                }
                if (state instanceof $7qlbM.PlusLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                    }
                } else if (state instanceof $bjwd1.StarLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                    }
                }
            }
            let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 1; i <= ndecisions; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let decState = atn.states[s];
                atn.decisionToState.push(decState);
                decState.decision = i - 1;
            }
            if (atn.grammarType === 0) {
                if (supportsLexerActions) {
                    atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                    for(let i = 0; i < atn.lexerActions.length; i++){
                        let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data1 === 0xFFFF) data1 = -1;
                        let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data2 === 0xFFFF) data2 = -1;
                        let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                        atn.lexerActions[i] = lexerAction;
                    }
                } else {
                    let legacyLexerActions = [];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                        let ruleIndex = transition.ruleIndex;
                        let actionIndex = transition.actionIndex;
                        let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                        state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                        legacyLexerActions.push(lexerAction);
                    }
                    atn.lexerActions = legacyLexerActions;
                }
            }
            this.markPrecedenceDecisions(atn);
            atn.decisionToDFA = new Array(ndecisions);
            for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
            if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1) {
                atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
                for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
                for(let i = 0; i < atn.ruleToStartState.length; i++){
                    let bypassStart = new $gAm9p.BasicBlockStartState();
                    bypassStart.ruleIndex = i;
                    atn.addState(bypassStart);
                    let bypassStop = new $loKp0.BlockEndState();
                    bypassStop.ruleIndex = i;
                    atn.addState(bypassStop);
                    bypassStart.endState = bypassStop;
                    atn.defineDecisionState(bypassStart);
                    bypassStop.startState = bypassStart;
                    let endState;
                    let excludeTransition;
                    if (atn.ruleToStartState[i].isPrecedenceRule) {
                        endState = undefined;
                        for (let state of atn.states){
                            if (state.ruleIndex !== i) continue;
                            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                            let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                            if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                            if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                                endState = state;
                                break;
                            }
                        }
                        if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                        excludeTransition = endState.loopBackState.transition(0);
                    } else endState = atn.ruleToStopState[i];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (transition === excludeTransition) continue;
                        if (transition.target === endState) transition.target = bypassStop;
                    }
                    while(atn.ruleToStartState[i].numberOfTransitions > 0){
                        let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                        bypassStart.addTransition(transition);
                    }
                    atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                    bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                    let matchState = new $4yiuQ.BasicState();
                    atn.addState(matchState);
                    matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                    bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            if (this.deserializationOptions.isOptimize) {
                while(true){
                    let optimizationCount = 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                    let preserveOrder = atn.grammarType === 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                    if (optimizationCount === 0) break;
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
            return atn;
        }
        deserializeSets(data, p, sets, unicodeDeserializer) {
            let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nsets; i++){
                let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                p++;
                let set = new $hGRod.IntervalSet();
                sets.push(set);
                let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                if (containsEof) set.add(-1);
                for(let j = 0; j < nintervals; j++){
                    let a = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    let b = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    set.add(a, b);
                }
            }
            return p;
        }
        markPrecedenceDecisions(atn) {
            let rulePrecedenceDecisions = new Map();
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                    let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                    if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            rulePrecedenceDecisions.set(state.ruleIndex, state);
                            state.precedenceRuleDecision = true;
                            state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                        }
                    }
                }
            }
            for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
                if (transition.serializationType !== 1) continue;
                let epsilonTransition = transition;
                if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
                precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
            }
        }
        verifyATN(atn) {
            for (let state of atn.states){
                this.checkCondition(state !== undefined, "ATN states should not be undefined.");
                if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
                this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
                if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $f9raX.StarLoopEntryState) {
                    let starLoopEntryState = state;
                    this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                    this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                    if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                        this.checkCondition(!starLoopEntryState.nonGreedy);
                    } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                        this.checkCondition(starLoopEntryState.nonGreedy);
                    } else throw new Error("IllegalStateException");
                }
                if (state instanceof $bjwd1.StarLoopbackState) {
                    this.checkCondition(state.numberOfTransitions === 1);
                    this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
                }
                if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
                if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
                if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
                if (state instanceof $dPYn6.DecisionState) {
                    let decisionState = state;
                    this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
                } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
            }
        }
        checkCondition(condition, message) {
            if (!condition) throw new Error("IllegalStateException: " + message);
        }
        static inlineSetRules(atn) {
            let inlinedCalls = 0;
            let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let startState = atn.ruleToStartState[i];
                let middleState = startState;
                while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1)middleState = middleState.getOptimizedTransition(0).target;
                if (middleState.numberOfOptimizedTransitions !== 1) continue;
                let matchTransition = middleState.getOptimizedTransition(0);
                let matchTarget = matchTransition.target;
                if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
                switch(matchTransition.serializationType){
                    case 5:
                    case 2:
                    case 7:
                        ruleToInlineTransition[i] = matchTransition;
                        break;
                    case 8:
                    case 9:
                        continue;
                    default:
                        continue;
                }
            }
            for (let state of atn.states){
                if (state.ruleIndex < 0) continue;
                let optimizedTransitions;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    let ruleTransition = transition;
                    let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                    if (effective === undefined) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                    }
                    inlinedCalls++;
                    let target = ruleTransition.followState;
                    let intermediateState = new $4yiuQ.BasicState();
                    intermediateState.setRuleIndex(target.ruleIndex);
                    atn.addState(intermediateState);
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                    switch(effective.serializationType){
                        case 5:
                            intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                            break;
                        case 2:
                            intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                            break;
                        case 7:
                            intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                            break;
                        default:
                            throw new Error("UnsupportedOperationException");
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
            return inlinedCalls;
        }
        static combineChainedEpsilons(atn) {
            let removedEdges = 0;
            for (let state of atn.states){
                if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
                let optimizedTransitions;
                nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    let intermediate = transition.target;
                    if (transition.serializationType !== 1 || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    removedEdges++;
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                        let target = intermediate.getOptimizedTransition(j).target;
                        optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
            return removedEdges;
        }
        static optimizeSets(atn, preserveOrder) {
            if (preserveOrder) return 0;
            let removedPaths = 0;
            let decisions = atn.decisionToState;
            for (let decision of decisions){
                let setTransitions = new $hGRod.IntervalSet();
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                    let epsTransition = decision.getOptimizedTransition(i);
                    if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                    if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                    let transition = epsTransition.target.getOptimizedTransition(0);
                    if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                    if (transition instanceof $FLEKS.NotSetTransition) continue;
                    if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
                }
                if (setTransitions.size <= 1) continue;
                let optimizedTransitions = [];
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
                let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
                let matchSet = new $hGRod.IntervalSet();
                for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                    let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                    if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                    else matchSet.addAll(matchTransition.label);
                }
                let newTransition;
                if (matchSet.intervals.length === 1) {
                    if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                    else {
                        let matchInterval = matchSet.intervals[0];
                        newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                    }
                } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
                let setOptimizedState = new $4yiuQ.BasicState();
                setOptimizedState.setRuleIndex(decision.ruleIndex);
                atn.addState(setOptimizedState);
                setOptimizedState.addTransition(newTransition);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
                removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
                if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
            return removedPaths;
        }
        static identifyTailCalls(atn) {
            for (let state of atn.states){
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
                if (!state.isOptimized) continue;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
            }
        }
        static testTailCall(atn, transition, optimizedPath) {
            if (!optimizedPath && transition.tailCall) return true;
            if (optimizedPath && transition.optimizedTailCall) return true;
            let reachable = new $5BPMp.BitSet(atn.states.length);
            let worklist = [];
            worklist.push(transition.followState);
            while(true){
                let state = worklist.pop();
                if (!state) break;
                if (reachable.get(state.stateNumber)) continue;
                if (state instanceof $4kGBm.RuleStopState) continue;
                if (!state.onlyHasEpsilonTransitions) return false;
                let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
                for(let i = 0; i < transitionCount; i++){
                    let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                    if (t.serializationType !== 1) return false;
                    worklist.push(t.target);
                }
            }
            return true;
        }
        static toInt(c) {
            return c;
        }
        static toInt32(data, offset) {
            return (data[offset] | data[offset + 1] << 16) >>> 0;
        }
        static toUUID(data, offset) {
            let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
            let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
            let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
            let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
            return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
            let target = atn.states[trg];
            switch(type){
                case 1:
                    return new $bpnRH.EpsilonTransition(target);
                case 2:
                    if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                    else return new $aISkF.RangeTransition(target, arg1, arg2);
                case 3:
                    let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                    return rt;
                case 4:
                    let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                    return pt;
                case 10:
                    return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
                case 5:
                    if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                    else return new $5r7n7.AtomTransition(target, arg1);
                case 6:
                    let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                    return a;
                case 7:
                    return new $Np2R3.SetTransition(target, sets[arg1]);
                case 8:
                    return new $FLEKS.NotSetTransition(target, sets[arg1]);
                case 9:
                    return new $aPmi9.WildcardTransition(target);
            }
            throw new Error("The specified transition type is not valid.");
        }
        stateFactory(type, ruleIndex) {
            let s;
            switch(type){
                case $1bs3X.ATNStateType.INVALID_TYPE:
                    return new $l4Nh1.InvalidState();
                case $1bs3X.ATNStateType.BASIC:
                    s = new $4yiuQ.BasicState();
                    break;
                case $1bs3X.ATNStateType.RULE_START:
                    s = new $j2zc8.RuleStartState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_START:
                    s = new $gAm9p.BasicBlockStartState();
                    break;
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                    s = new $d1V7w.PlusBlockStartState();
                    break;
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                    s = new $jEsaF.StarBlockStartState();
                    break;
                case $1bs3X.ATNStateType.TOKEN_START:
                    s = new $WS4d7.TokensStartState();
                    break;
                case $1bs3X.ATNStateType.RULE_STOP:
                    s = new $4kGBm.RuleStopState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_END:
                    s = new $loKp0.BlockEndState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    s = new $bjwd1.StarLoopbackState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    s = new $f9raX.StarLoopEntryState();
                    break;
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                    s = new $7qlbM.PlusLoopbackState();
                    break;
                case $1bs3X.ATNStateType.LOOP_END:
                    s = new $kfqEk.LoopEndState();
                    break;
                default:
                    let message = `The specified state type ${type} is not valid.`;
                    throw new Error(message);
            }
            s.ruleIndex = ruleIndex;
            return s;
        }
        lexerActionFactory(type, data1, data2) {
            switch(type){
                case 0:
                    return new $iw4Ko.LexerChannelAction(data1);
                case 1:
                    return new $RgRAX.LexerCustomAction(data1, data2);
                case 2:
                    return new $jgJtt.LexerModeAction(data1);
                case 3:
                    return $l606e.LexerMoreAction.INSTANCE;
                case 4:
                    return $6hIs4.LexerPopModeAction.INSTANCE;
                case 5:
                    return new $a9nIX.LexerPushModeAction(data1);
                case 6:
                    return $2Gb96.LexerSkipAction.INSTANCE;
                case 7:
                    return new $ayRdK.LexerTypeAction(data1);
                default:
                    let message = `The specified lexer action type ${type} is not valid.`;
                    throw new Error(message);
            }
        }
    }
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
    $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
        $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
    ];
    $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull,
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
    module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;
});
parcelRegister("gxlfY", function(module, exports) {
    "use strict";
    var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ActionTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
        constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
            super(target);
            this.ruleIndex = ruleIndex;
            this.actionIndex = actionIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 6;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "action_" + this.ruleIndex + ":" + this.actionIndex;
        }
    };
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
    $c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
        $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
    ], $c0a0378a1b984eee$var$ActionTransition);
    module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;
});
parcelRegister("5r7n7", function(module, exports) {
    "use strict";
    var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AtomTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
        constructor(target, label){
            super(target);
            this._label = label;
        }
        get serializationType() {
            return 5;
        }
        get label() {
            return $hGRod.IntervalSet.of(this._label);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this._label === symbol;
        }
        toString() {
            return String(this.label);
        }
    };
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
    $010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
        $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
    ], $010580cb6b5878c3$var$AtomTransition);
    module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;
});
parcelRegister("gAm9p", function(module, exports) {
    "use strict";
    var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_START;
        }
    }
    $c13130ce46eb4f6a$var$__decorate([
        $d6D31.Override
    ], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
    module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;
});
parcelRegister("65vNG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockStartState = void 0;
    var $dPYn6 = parcelRequire("dPYn6");
    class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
    }
    module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;
});
parcelRegister("loKp0", function(module, exports) {
    "use strict";
    var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_END;
        }
    }
    $f93fd5601d243552$var$__decorate([
        $d6D31.Override
    ], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
    module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;
});
parcelRegister("bpnRH", function(module, exports) {
    "use strict";
    var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.EpsilonTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
        constructor(target, outermostPrecedenceReturn = -1){
            super(target);
            this._outermostPrecedenceReturn = outermostPrecedenceReturn;
        }
        get outermostPrecedenceReturn() {
            return this._outermostPrecedenceReturn;
        }
        get serializationType() {
            return 1;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "epsilon";
        }
    };
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
    $84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
        $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
    ], $84e48a9cb4812173$var$EpsilonTransition);
    module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;
});
parcelRegister("iw4Ko", function(module, exports) {
    "use strict";
    var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerChannelAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $d7aee5df2113a2bc$var$LexerChannelAction {
        constructor(channel){
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        get actionType() {
            return 0;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.channel = this._channel;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._channel);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
            return this._channel === obj._channel;
        }
        toString() {
            return `channel(${this._channel})`;
        }
    }
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override,
        $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
    module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;
});
parcelRegister("RgRAX", function(module, exports) {
    "use strict";
    var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $0a0208144418eb04$var$LexerCustomAction {
        constructor(ruleIndex, actionIndex){
            this._ruleIndex = ruleIndex;
            this._actionIndex = actionIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get actionIndex() {
            return this._actionIndex;
        }
        get actionType() {
            return 1;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            lexer.action(undefined, this._ruleIndex, this._actionIndex);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
            hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
            return $iXFjm.MurmurHash.finish(hash, 3);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
            return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
        }
    }
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override,
        $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
    module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;
});
parcelRegister("jgJtt", function(module, exports) {
    "use strict";
    var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $e072c93b157fdb6e$var$LexerModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 2;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.mode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `mode(${this._mode})`;
        }
    }
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override,
        $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
    module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;
});
parcelRegister("l606e", function(module, exports) {
    "use strict";
    var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerMoreAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $f5ba3c4a18e49934$var$LexerMoreAction {
        constructor(){}
        get actionType() {
            return 3;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.more();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "more";
        }
    }
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override,
        $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
    module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
    (function(LexerMoreAction) {
        LexerMoreAction.INSTANCE = new LexerMoreAction();
    })($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));
});
parcelRegister("6hIs4", function(module, exports) {
    "use strict";
    var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPopModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $4936cfc70a1820aa$var$LexerPopModeAction {
        constructor(){}
        get actionType() {
            return 4;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.popMode();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "popMode";
        }
    }
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override,
        $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
    module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
    (function(LexerPopModeAction) {
        LexerPopModeAction.INSTANCE = new LexerPopModeAction();
    })($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));
});
parcelRegister("a9nIX", function(module, exports) {
    "use strict";
    var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPushModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $763d25c4cd7cf3b5$var$LexerPushModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 5;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.pushMode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `pushMode(${this._mode})`;
        }
    }
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override,
        $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
    module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;
});
parcelRegister("2Gb96", function(module, exports) {
    "use strict";
    var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerSkipAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $1f3826579173f858$var$LexerSkipAction {
        constructor(){}
        get actionType() {
            return 6;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.skip();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "skip";
        }
    }
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override,
        $1f3826579173f858$var$__param(0, $d6D31.NotNull)
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
    module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
    (function(LexerSkipAction) {
        LexerSkipAction.INSTANCE = new LexerSkipAction();
    })($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));
});
parcelRegister("ayRdK", function(module, exports) {
    "use strict";
    var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerTypeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $7b065cdfc5f207e7$var$LexerTypeAction {
        constructor(type){
            this._type = type;
        }
        get type() {
            return this._type;
        }
        get actionType() {
            return 7;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.type = this._type;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._type);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
            return this._type === obj._type;
        }
        toString() {
            return `type(${this._type})`;
        }
    }
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override,
        $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
    module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;
});
parcelRegister("kfqEk", function(module, exports) {
    "use strict";
    var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LoopEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.LOOP_END;
        }
    }
    $ebd9e16490628daf$var$__decorate([
        $d6D31.Override
    ], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
    module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;
});
parcelRegister("kzbnL", function(module, exports) {
    "use strict";
    var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $5BPMp = parcelRequire("5BPMp");
    var $gsRaX = parcelRequire("gsRaX");
    var $dPYn6 = parcelRequire("dPYn6");
    var $2jevZ = parcelRequire("2jevZ");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $hKCjP = parcelRequire("hKCjP");
    var $a4Flx = parcelRequire("a4Flx");
    var $6bmaO = parcelRequire("6bmaO");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $gDZVV = parcelRequire("gDZVV");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $eHMgW = parcelRequire("eHMgW");
    var $Np2R3 = parcelRequire("Np2R3");
    var $g7SCF = parcelRequire("g7SCF");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $bbHFU = parcelRequire("bbHFU");
    const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
    const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
    let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, parser){
            super(atn);
            this.predictionMode = $gDZVV.PredictionMode.LL;
            this.force_global_context = false;
            this.always_try_local_context = true;
            this.enable_global_context_dfa = false;
            this.optimize_unique_closure = true;
            this.optimize_ll1 = true;
            this.optimize_tail_calls = true;
            this.tail_call_preserves_sll = true;
            this.treat_sllk1_conflict_as_ambiguity = false;
            this.reportAmbiguities = false;
            this.userWantsCtxSensitive = true;
            this._parser = parser;
        }
        getPredictionMode() {
            return this.predictionMode;
        }
        setPredictionMode(predictionMode) {
            this.predictionMode = predictionMode;
        }
        reset() {}
        adaptivePredict(input, decision, outerContext, useContext) {
            if (useContext === undefined) useContext = false;
            let dfa = this.atn.decisionToDFA[decision];
            $bbHFU(dfa != null);
            if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
                let ll_1 = input.LA(1);
                if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                    let key = (decision << 16 >>> 0) + ll_1;
                    let alt = this.atn.LL1Table.get(key);
                    if (alt != null) return alt;
                }
            }
            this.dfa = dfa;
            if (this.force_global_context) useContext = true;
            else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
            this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            let state;
            if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
            if (state == null) {
                if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
                if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
                state = this.computeStartState(dfa, outerContext, useContext);
            }
            let m = input.mark();
            let index = input.index;
            try {
                let alt = this.execDFA(dfa, input, index, state);
                if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                return alt;
            } finally{
                this.dfa = undefined;
                input.seek(index);
                input.release(m);
            }
        }
        getStartState(dfa, input, outerContext, useContext) {
            if (!useContext) {
                if (dfa.isPrecedenceDfa) {
                    let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                    if (state == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
                } else {
                    if (dfa.s0 == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
                }
            }
            if (!this.enable_global_context_dfa) return undefined;
            let remainingContext = outerContext;
            $bbHFU(outerContext != null);
            let s0;
            if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
            else s0 = dfa.s0full;
            while(remainingContext != null && s0 != null && s0.isContextSensitive){
                remainingContext = this.skipTailCalls(remainingContext);
                s0 = s0.getContextTarget(this.getReturnState(remainingContext));
                if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
                else remainingContext = remainingContext.parent;
            }
            if (s0 == null) return undefined;
            return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
        }
        execDFA(dfa, input, startIndex, state) {
            let outerContext = state.outerContext;
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            let s = state.s0;
            let t = input.LA(1);
            let remainingOuterContext = state.remainingOuterContext;
            while(true){
                if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
                if (state.useContext) while(s.isContextSymbol(t)){
                    let next;
                    if (remainingOuterContext != null) {
                        remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                        next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                    }
                    if (next == null) {
                        let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                        return this.execATN(dfa, input, startIndex, initialState);
                    }
                    $bbHFU(remainingOuterContext != null);
                    remainingOuterContext = remainingOuterContext.parent;
                    s = next;
                }
                if (this.isAcceptState(s, state.useContext)) {
                    if (s.predicates != null) {
                        if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                    } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                    break;
                }
                $bbHFU(!this.isAcceptState(s, state.useContext));
                let target = this.getExistingTargetState(s, t);
                if (target == null) {
                    if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                    let alt;
                    if (ParserATNSimulator.dfa_debug) {
                        let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                        console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                    }
                    let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    alt = this.execATN(dfa, input, startIndex, initialState);
                    if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                    if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                    return alt;
                } else if (target === $kr9A1.ATNSimulator.ERROR) {
                    let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    return this.handleNoViableAlt(input, startIndex, errorState);
                }
                s = target;
                if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
            if (!state.useContext && s.configs.conflictInfo != null) {
                if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                    if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                    else {
                        $bbHFU(!state.useContext);
                        let conflictingAlts;
                        let predicates = s.predicates;
                        if (predicates != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                            if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                        if (this.reportAmbiguities) {
                            let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                            this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                        }
                        input.seek(startIndex);
                        return this.adaptivePredict(input, dfa.decision, outerContext, true);
                    }
                }
            }
            let predicates = s.predicates;
            if (predicates != null) {
                let stopIndex = input.index;
                if (startIndex !== stopIndex) input.seek(startIndex);
                let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
                switch(alts.cardinality()){
                    case 0:
                        throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (startIndex !== stopIndex) input.seek(stopIndex);
                        this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                        return alts.nextSetBit(0);
                }
            }
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
            return s.prediction;
        }
        isAcceptState(state, useContext) {
            if (!state.isAcceptState) return false;
            if (state.configs.conflictingAlts == null) return true;
            if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
            return true;
        }
        execATN(dfa, input, startIndex, initialState) {
            if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
            let outerContext = initialState.outerContext;
            let useContext = initialState.useContext;
            let t = input.LA(1);
            let previous = initialState;
            let contextCache = new $6vF7J.PredictionContextCache();
            while(true){
                let nextState = this.computeReachSet(dfa, previous, t, contextCache);
                if (nextState == null) {
                    this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                    return this.handleNoViableAlt(input, startIndex, previous);
                }
                let D = nextState.s0;
                $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
                $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
                if (this.isAcceptState(D, useContext)) {
                    let conflictingAlts = D.configs.conflictingAlts;
                    let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                    if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                        if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                            if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                                let key = (dfa.decision << 16 >>> 0) + t;
                                this.atn.LL1Table.set(key, predictedAlt);
                            }
                        }
                        if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                    }
                    predictedAlt = D.prediction;
                    let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                    if (attemptFullContext) attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                    if (D.configs.hasSemanticContext) {
                        let predPredictions = D.predicates;
                        if (predPredictions != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                            switch(conflictingAlts.cardinality()){
                                case 0:
                                    throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                                case 1:
                                    return conflictingAlts.nextSetBit(0);
                                default:
                                    break;
                            }
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                    }
                    if (!attemptFullContext) {
                        if (conflictingAlts != null) {
                            if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                            predictedAlt = conflictingAlts.nextSetBit(0);
                        }
                        return predictedAlt;
                    } else {
                        $bbHFU(!useContext);
                        $bbHFU(this.isAcceptState(D, false));
                        if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                        let fullContextState = this.computeStartState(dfa, outerContext, true);
                        if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                        input.seek(startIndex);
                        return this.execATN(dfa, input, startIndex, fullContextState);
                    }
                }
                previous = nextState;
                if (t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
        }
        handleNoViableAlt(input, startIndex, previous) {
            if (previous.s0 != null) {
                let alts = new $5BPMp.BitSet();
                let maxAlt = 0;
                for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                    alts.set(config.alt);
                    maxAlt = Math.max(maxAlt, config.alt);
                }
                switch(alts.cardinality()){
                    case 0:
                        break;
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (!previous.s0.configs.hasSemanticContext) return alts.nextSetBit(0);
                        let filteredConfigs = new $c1ClW.ATNConfigSet();
                        for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                        let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                        if (altToPred != null) {
                            let predicates = this.getPredicatePredictions(alts, altToPred);
                            if (predicates != null) {
                                let stopIndex = input.index;
                                try {
                                    input.seek(startIndex);
                                    let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                    if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                                } finally{
                                    input.seek(stopIndex);
                                }
                            }
                        }
                        return alts.nextSetBit(0);
                }
            }
            throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
        }
        computeReachSet(dfa, previous, t, contextCache) {
            let useContext = previous.useContext;
            let remainingGlobalContext = previous.remainingOuterContext;
            let s = previous.s0;
            if (useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingGlobalContext != null) {
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
                }
                if (next == null) break;
                $bbHFU(remainingGlobalContext != null);
                remainingGlobalContext = remainingGlobalContext.parent;
                s = next;
            }
            $bbHFU(!this.isAcceptState(s, useContext));
            if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
            let s0 = s;
            let target = this.getExistingTargetState(s0, t);
            if (target == null) {
                let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
                target = result[0];
                remainingGlobalContext = result[1];
            }
            if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
            $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
            return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
        }
        getExistingTargetState(s, t) {
            return s.getTarget(t);
        }
        computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
            let closureConfigs = s.configs.toArray();
            let contextElements;
            let reach = new $c1ClW.ATNConfigSet();
            let stepIntoGlobal;
            do {
                let hasMoreContext = !useContext || remainingGlobalContext != null;
                if (!hasMoreContext) reach.isOutermostConfigSet = true;
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let skippedStopStates;
                for (let c of closureConfigs){
                    if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                    if (c.state instanceof $4kGBm.RuleStopState) {
                        $bbHFU(c.context.isEmpty);
                        if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                            if (skippedStopStates == null) skippedStopStates = [];
                            skippedStopStates.push(c);
                        }
                        continue;
                    }
                    let n = c.state.numberOfOptimizedTransitions;
                    for(let ti = 0; ti < n; ti++){
                        let trans = c.state.getOptimizedTransition(ti);
                        let target = this.getReachableTarget(c, trans, t);
                        if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                    }
                }
                if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                    reach = reachIntermediate;
                    break;
                }
                let collectPredicates = false;
                let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
                this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
                stepIntoGlobal = reach.dipsIntoOuterContext;
                if (t === $ceaEj.IntStream.EOF) reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
                if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                    $bbHFU(skippedStopStates.length > 0);
                    for (let c of skippedStopStates)reach.add(c, contextCache);
                }
                if (useContext && stepIntoGlobal) {
                    reach.clear();
                    remainingGlobalContext;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    let nextContextElement = this.getReturnState(remainingGlobalContext);
                    if (contextElements == null) contextElements = new $37SGk.IntegerList();
                    if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                    else remainingGlobalContext = remainingGlobalContext.parent;
                    contextElements.add(nextContextElement);
                    if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
                }
            }while (useContext && stepIntoGlobal)
            if (reach.isEmpty) {
                this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return [
                    $kr9A1.ATNSimulator.ERROR,
                    remainingGlobalContext
                ];
            }
            let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
            return [
                result,
                remainingGlobalContext
            ];
        }
        removeAllConfigsNotInRuleStopState(configs, contextCache) {
            if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
            let result = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
                result.add(config, contextCache);
            }
            return result;
        }
        computeStartState(dfa, globalContext, useContext) {
            let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
            if (s0 != null) {
                if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
                s0.setContextSensitive(this.atn);
            }
            let decision = dfa.decision;
            let p = dfa.atnStartState;
            let previousContext = 0;
            let remainingGlobalContext = globalContext;
            let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL;
            let contextCache = new $6vF7J.PredictionContextCache();
            if (useContext) {
                if (!this.enable_global_context_dfa) {
                    while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                }
                while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                    let next;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    if (remainingGlobalContext.isEmpty) {
                        next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        next = s0.getContextTarget(previousContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                    if (next == null) break;
                    s0 = next;
                }
            }
            if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
            let configs = new $c1ClW.ATNConfigSet();
            while(true){
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let n = p.numberOfTransitions;
                for(let ti = 0; ti < n; ti++){
                    let target = p.transition(ti).target;
                    reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
                }
                let hasMoreContext = remainingGlobalContext != null;
                if (!hasMoreContext) configs.isOutermostConfigSet = true;
                let collectPredicates = true;
                this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
                let stepIntoGlobal = configs.dipsIntoOuterContext;
                let next;
                if (useContext && !this.enable_global_context_dfa) {
                    s0 = this.addDFAState(dfa, configs, contextCache);
                    break;
                } else if (s0 == null) {
                    if (!dfa.isPrecedenceDfa) {
                        next = this.addDFAState(dfa, configs, contextCache);
                        if (useContext) {
                            if (!dfa.s0full) dfa.s0full = next;
                            else next = dfa.s0full;
                        } else if (!dfa.s0) dfa.s0 = next;
                        else next = dfa.s0;
                    } else {
                        configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                        next = this.addDFAState(dfa, configs, contextCache);
                        dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                    }
                } else {
                    if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    s0.setContextTarget(previousContext, next);
                }
                s0 = next;
                if (!useContext || !stepIntoGlobal) break;
                next.setContextSensitive(this.atn);
                remainingGlobalContext;
                configs.clear();
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
                previousContext = nextContextElement;
            }
            return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        }
        applyPrecedenceFilter(configs, globalContext, contextCache) {
            let statesFromAlt1 = new Map();
            let configSet = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (config.alt !== 1) continue;
                let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
                if (updatedContext == null) continue;
                statesFromAlt1.set(config.state.stateNumber, config.context);
                if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
                else configSet.add(config, contextCache);
            }
            for (let config of configs){
                if (config.alt === 1) continue;
                if (!config.isPrecedenceFilterSuppressed) {
                    let context = statesFromAlt1.get(config.state.stateNumber);
                    if (context != null && context.equals(config.context)) continue;
                }
                configSet.add(config, contextCache);
            }
            return configSet;
        }
        getReachableTarget(source, trans, ttype) {
            if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
            return undefined;
        }
        predicateDFAState(D, configs, nalts) {
            let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
            if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
            if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
            let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
            let predPredictions;
            if (altToPred != null) {
                predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
                D.predicates = predPredictions;
            }
            return predPredictions;
        }
        getPredsForAmbigAlts(ambigAlts, configs, nalts) {
            let altToPred = new Array(nalts + 1);
            let n = altToPred.length;
            for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
            let nPredAlts = 0;
            for(let i = 0; i < n; i++){
                if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
                else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
            }
            let result = altToPred;
            if (nPredAlts === 0) result = undefined;
            if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
            return result;
        }
        getPredicatePredictions(ambigAlts, altToPred) {
            let pairs = [];
            let containsPredicate = false;
            for(let i = 1; i < altToPred.length; i++){
                let pred = altToPred[i];
                $bbHFU(pred != null);
                if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                else if (pred !== $eHMgW.SemanticContext.NONE) {
                    containsPredicate = true;
                    pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                }
            }
            if (!containsPredicate) return undefined;
            return pairs;
        }
        evalSemanticContext(predPredictions, outerContext, complete) {
            let predictions = new $5BPMp.BitSet();
            for (let pair of predPredictions){
                if (pair.pred === $eHMgW.SemanticContext.NONE) {
                    predictions.set(pair.alt);
                    if (!complete) break;
                    continue;
                }
                let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
                if (evaluatedResult) {
                    if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                    predictions.set(pair.alt);
                    if (!complete) break;
                }
            }
            return predictions;
        }
        evalSemanticContextImpl(pred, parserCallStack, alt) {
            return pred.eval(this._parser, parserCallStack);
        }
        closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let currentConfigs = sourceConfigs;
            let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            while(currentConfigs.size > 0){
                let intermediate = new $c1ClW.ATNConfigSet();
                for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
                currentConfigs = intermediate;
            }
        }
        closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
            if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (!config.context.isEmpty) {
                    let hasEmpty = config.context.hasEmpty;
                    let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                    for(let i = 0; i < nonEmptySize; i++){
                        let newContext = config.context.getParent(i);
                        let returnState = this.atn.states[config.context.getReturnState(i)];
                        let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                        c.outerContextDepth = config.outerContextDepth;
                        c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                        $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                    }
                    if (!hasEmpty || !hasMoreContexts) return;
                    config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                } else if (!hasMoreContexts) {
                    configs.add(config, contextCache);
                    return;
                } else {
                    if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                    if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                    else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) configs.add(config, contextCache);
                }
            }
            let p = config.state;
            if (!p.onlyHasEpsilonTransitions) {
                configs.add(config, contextCache);
                if (ParserATNSimulator.debug) console.log("added config " + configs);
            }
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                    let precedenceDecision = p;
                    let suppress = true;
                    for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                        suppress = false;
                        break;
                    }
                    if (suppress) continue;
                }
                let t = p.getOptimizedTransition(i);
                let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
                let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
                if (c != null) {
                    if (t instanceof $aybFP.RuleTransition) {
                        if (intermediate != null && !collectPredicates) {
                            intermediate.add(c, contextCache);
                            continue;
                        }
                    }
                    let newDepth = depth;
                    if (config.state instanceof $4kGBm.RuleStopState) {
                        if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                            let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                            if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                        }
                        c.outerContextDepth = c.outerContextDepth + 1;
                        if (!closureBusy.add(c)) continue;
                        $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        newDepth--;
                        if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                    } else if (t instanceof $aybFP.RuleTransition) {
                        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                            $bbHFU(c.context === config.context);
                            if (newDepth === 0) {
                                newDepth--;
                                if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) c.outerContextDepth = c.outerContextDepth + 1;
                            }
                        } else if (newDepth >= 0) newDepth++;
                    } else {
                        if (!t.isEpsilon && !closureBusy.add(c)) continue;
                    }
                    this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
                }
            }
        }
        getRuleName(index) {
            if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
            return "<rule " + index + ">";
        }
        getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
            switch(t.serializationType){
                case 3:
                    return this.ruleTransition(config, t, contextCache);
                case 10:
                    return this.precedenceTransition(config, t, collectPredicates, inContext);
                case 4:
                    return this.predTransition(config, t, collectPredicates, inContext);
                case 6:
                    return this.actionTransition(config, t);
                case 1:
                    return config.transform(t.target, false);
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                    }
                    return undefined;
                default:
                    return undefined;
            }
        }
        actionTransition(config, t) {
            if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
            return config.transform(t.target, false);
        }
        precedenceTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && inContext) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        predTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        ruleTransition(config, t, contextCache) {
            if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
            let returnState = t.followState;
            let newContext;
            if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
            else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
            else newContext = config.context.getChild(returnState.stateNumber);
            return config.transform(t.target, false, newContext);
        }
        isConflicted(configset, contextCache) {
            if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
            let configs = configset.toArray();
            configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
            let exact = !configset.dipsIntoOuterContext;
            let alts = new $5BPMp.BitSet();
            let minAlt = configs[0].alt;
            alts.set(minAlt);
            let currentState = configs[0].state.nonStopStateNumber;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                if (stateNumber !== currentState) {
                    if (config.alt !== minAlt) return undefined;
                    currentState = stateNumber;
                }
            }
            let representedAlts;
            if (exact) {
                currentState = configs[0].state.nonStopStateNumber;
                representedAlts = new $5BPMp.BitSet();
                let maxAlt = minAlt;
                for (let config of configs){
                    if (config.state.nonStopStateNumber !== currentState) break;
                    let alt = config.alt;
                    representedAlts.set(alt);
                    maxAlt = alt;
                }
                currentState = configs[0].state.nonStopStateNumber;
                let currentAlt = minAlt;
                for (let config of configs){
                    let stateNumber = config.state.nonStopStateNumber;
                    let alt = config.alt;
                    if (stateNumber !== currentState) {
                        if (currentAlt !== maxAlt) {
                            exact = false;
                            break;
                        }
                        currentState = stateNumber;
                        currentAlt = minAlt;
                    } else if (alt !== currentAlt) {
                        if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                            exact = false;
                            break;
                        }
                        currentAlt = alt;
                    }
                }
            }
            currentState = configs[0].state.nonStopStateNumber;
            let firstIndexCurrentState = 0;
            let lastIndexCurrentStateMinAlt = 0;
            let joinedCheckContext = configs[0].context;
            for(let i = 1; i < configs.length; i++){
                let config = configs[i];
                if (config.alt !== minAlt) break;
                if (config.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
            }
            for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
                let config = configs[i];
                let state = config.state;
                alts.set(config.alt);
                if (state.nonStopStateNumber !== currentState) {
                    currentState = state.nonStopStateNumber;
                    firstIndexCurrentState = i;
                    lastIndexCurrentStateMinAlt = i;
                    joinedCheckContext = config.context;
                    for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                        let config2 = configs[j];
                        if (config2.alt !== minAlt) break;
                        if (config2.state.nonStopStateNumber !== currentState) break;
                        lastIndexCurrentStateMinAlt = j;
                        joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                    }
                    i = lastIndexCurrentStateMinAlt;
                    continue;
                }
                let joinedCheckContext2 = config.context;
                let currentAlt = config.alt;
                let lastIndexCurrentStateCurrentAlt = i;
                for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== currentAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateCurrentAlt = j;
                    joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
                }
                i = lastIndexCurrentStateCurrentAlt;
                let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
                if (!joinedCheckContext.equals(check)) return undefined;
                exact = exact && joinedCheckContext.equals(joinedCheckContext2);
            }
            return new $gsRaX.ConflictInfo(alts, exact);
        }
        getConflictingAltsFromConfigSet(configs) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                conflictingAlts = new $5BPMp.BitSet();
                conflictingAlts.set(configs.uniqueAlt);
            }
            return conflictingAlts;
        }
        getTokenName(t) {
            if (t === $2DVsz.Token.EOF) return "EOF";
            let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            let displayName = vocabulary.getDisplayName(t);
            if (displayName === String(t)) return displayName;
            return displayName + "<" + t + ">";
        }
        getLookaheadName(input) {
            return this.getTokenName(input.LA(1));
        }
        dumpDeadEndConfigs(nvae) {
            console.log("dead end configs: ");
            let deadEndConfigs = nvae.deadEndConfigs;
            if (!deadEndConfigs) return;
            for (let c of deadEndConfigs){
                let trans = "no edges";
                if (c.state.numberOfOptimizedTransitions > 0) {
                    let t = c.state.getOptimizedTransition(0);
                    if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                    else if (t instanceof $Np2R3.SetTransition) {
                        let not = t instanceof $FLEKS.NotSetTransition;
                        trans = (not ? "~" : "") + "Set " + t.set.toString();
                    }
                }
                console.log(c.toString(this._parser, true) + ":" + trans);
            }
        }
        noViableAlt(input, outerContext, configs, startIndex) {
            return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
        }
        getUniqueAlt(configs) {
            let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of configs){
                if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt;
                else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            }
            return alt;
        }
        configWithAltAtStopState(configs, alt) {
            for (let c of configs)if (c.alt === alt) {
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
            $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
            let from = fromState;
            let to = this.addDFAState(dfa, toConfigs, contextCache);
            if (contextTransitions != null) for (let context of contextTransitions.toArray()){
                if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (from.configs.isOutermostConfigSet) continue;
                }
                from.setContextSensitive(this.atn);
                from.setContextSymbol(t);
                let next = from.getContextTarget(context);
                if (next != null) {
                    from = next;
                    continue;
                }
                next = this.addDFAContextState(dfa, from.configs, context, contextCache);
                $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
                from.setContextTarget(context, next);
                from = next;
            }
            if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
            this.setDFAEdge(from, t, to);
            if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
            return to;
        }
        setDFAEdge(p, t, q) {
            if (p != null) p.setTarget(t, q);
        }
        addDFAContextState(dfa, configs, returnContext, contextCache) {
            if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                let contextConfigs = new $c1ClW.ATNConfigSet();
                for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
                return this.addDFAState(dfa, contextConfigs, contextCache);
            } else {
                $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
                configs = configs.clone(true);
                configs.isOutermostConfigSet = true;
                return this.addDFAState(dfa, configs, contextCache);
            }
        }
        addDFAState(dfa, configs, contextCache) {
            let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
            if (enableDfa) {
                if (!configs.isReadOnly) configs.optimizeConfigs(this);
                let proposed = this.createDFAState(dfa, configs);
                let existing = dfa.states.get(proposed);
                if (existing != null) return existing;
            }
            if (!configs.isReadOnly) {
                if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
            }
            let newState = this.createDFAState(dfa, configs.clone(true));
            let decisionState = this.atn.getDecisionState(dfa.decision);
            let predictedAlt = this.getUniqueAlt(configs);
            if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
            else if (configs.conflictingAlts != null) {
                let conflictingAlts = configs.conflictingAlts;
                if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
            }
            if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
            if (!enableDfa) return newState;
            let added = dfa.addState(newState);
            if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
            return added;
        }
        createDFAState(dfa, configs) {
            return new $2jevZ.DFAState(configs);
        }
        reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            }
        }
        reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
            }
        }
        reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            }
        }
        getReturnState(context) {
            if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            let state = this.atn.states[context.invokingState];
            let transition = state.transition(0);
            return transition.followState.stateNumber;
        }
        skipTailCalls(context) {
            if (!this.optimize_tail_calls) return context;
            while(!context.isEmpty){
                let state = this.atn.states[context.invokingState];
                $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3);
                let transition = state.transition(0);
                if (!transition.tailCall) break;
                context = context.parent;
            }
            return context;
        }
        get parser() {
            return this._parser;
        }
    };
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
        let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
        if (diff !== 0) return diff;
        diff = o1.alt - o2.alt;
        if (diff !== 0) return diff;
        return 0;
    };
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Override
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
    $ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
    module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;
});
parcelRegister("gsRaX", function(module, exports) {
    "use strict";
    var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConflictInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2IEP9 = parcelRequire("2IEP9");
    class $bfc8827830a146f2$var$ConflictInfo {
        constructor(conflictedAlts, exact){
            this._conflictedAlts = conflictedAlts;
            this.exact = exact;
        }
        get conflictedAlts() {
            return this._conflictedAlts;
        }
        get isExact() {
            return this.exact;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
            return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
        }
        hashCode() {
            return this.conflictedAlts.hashCode();
        }
    }
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
    module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;
});
parcelRegister("6bmaO", function(module, exports) {
    "use strict";
    var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserRuleContext = void 0;
    var $cdCft = parcelRequire("cdCft");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $c8jEe = parcelRequire("c8jEe");
    var $kYC92 = parcelRequire("kYC92");
    class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber == null) super();
            else super(parent, invokingStateNumber);
        }
        static emptyContext() {
            return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
        }
        copyFrom(ctx) {
            this._parent = ctx._parent;
            this.invokingState = ctx.invokingState;
            this._start = ctx._start;
            this._stop = ctx._stop;
            if (ctx.children) {
                this.children = [];
                for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
            }
        }
        enterRule(listener) {}
        exitRule(listener) {}
        addAnyChild(t) {
            if (!this.children) this.children = [
                t
            ];
            else this.children.push(t);
            return t;
        }
        addChild(t) {
            let result;
            if (t instanceof $kYC92.TerminalNode) {
                t.setParent(this);
                this.addAnyChild(t);
                return;
            } else if (t instanceof $c8jEe.RuleContext) {
                this.addAnyChild(t);
                return;
            } else {
                t = new $kYC92.TerminalNode(t);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        addErrorNode(node) {
            if (node instanceof $cdCft.ErrorNode) {
                const errorNode = node;
                errorNode.setParent(this);
                return this.addAnyChild(errorNode);
            } else {
                const badToken = node;
                let t = new $cdCft.ErrorNode(badToken);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        removeLastChild() {
            if (this.children) this.children.pop();
        }
        get parent() {
            let parent = super.parent;
            if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
            throw new TypeError("Invalid parent type for ParserRuleContext");
        }
        getChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
            if (ctxType == null) return this.children[i];
            let result = this.tryGetChild(i, ctxType);
            if (result === undefined) throw new Error("The specified node does not exist");
            return result;
        }
        tryGetChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof ctxType) {
                j++;
                if (j === i) return o;
            }
            return undefined;
        }
        getToken(ttype, i) {
            let result = this.tryGetToken(ttype, i);
            if (result === undefined) throw new Error("The specified token does not exist");
            return result;
        }
        tryGetToken(ttype, i) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) {
                    j++;
                    if (j === i) return o;
                }
            }
            return undefined;
        }
        getTokens(ttype) {
            let tokens = [];
            if (!this.children) return tokens;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) tokens.push(o);
            }
            return tokens;
        }
        get ruleContext() {
            return this;
        }
        getRuleContext(i, ctxType) {
            return this.getChild(i, ctxType);
        }
        tryGetRuleContext(i, ctxType) {
            return this.tryGetChild(i, ctxType);
        }
        getRuleContexts(ctxType) {
            let contexts = [];
            if (!this.children) return contexts;
            for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
            return contexts;
        }
        get childCount() {
            return this.children ? this.children.length : 0;
        }
        get sourceInterval() {
            if (!this._start) return $gcfUE.Interval.INVALID;
            if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1);
            return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
        }
        get start() {
            return this._start;
        }
        get stop() {
            return this._stop;
        }
        toInfoString(recognizer) {
            let rules = recognizer.getRuleInvocationStack(this).reverse();
            return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
        }
    }
    $4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
    module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;
});
parcelRegister("cdCft", function(module, exports) {
    "use strict";
    var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ErrorNode = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $kYC92 = parcelRequire("kYC92");
    class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
        constructor(token){
            super(token);
        }
        accept(visitor) {
            return visitor.visitErrorNode(this);
        }
    }
    $8e545e4dd69efabc$var$__decorate([
        $d6D31.Override
    ], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
    module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;
});
parcelRegister("kYC92", function(module, exports) {
    "use strict";
    var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TerminalNode = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $f4570001c9e8b34c$var$TerminalNode {
        constructor(symbol){
            this._symbol = symbol;
        }
        getChild(i) {
            throw new RangeError("Terminal Node has no children.");
        }
        get symbol() {
            return this._symbol;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this._symbol;
        }
        get sourceInterval() {
            let tokenIndex = this._symbol.tokenIndex;
            return new $gcfUE.Interval(tokenIndex, tokenIndex);
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitTerminal(this);
        }
        get text() {
            return this._symbol.text || "";
        }
        toStringTree(parser) {
            return this.toString();
        }
        toString() {
            if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
            return this._symbol.text || "";
        }
    }
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
    module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;
});
parcelRegister("c8jEe", function(module, exports) {
    "use strict";
    var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContext = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2WQcE = parcelRequire("2WQcE");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $axprj = parcelRequire("axprj");
    var $6bmaO = parcelRequire("6bmaO");
    class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
        constructor(parent, invokingState){
            super();
            this._parent = parent;
            this.invokingState = invokingState != null ? invokingState : -1;
        }
        static getChildContext(parent, invokingState) {
            return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
        }
        depth() {
            let n = 0;
            let p = this;
            while(p){
                p = p._parent;
                n++;
            }
            return n;
        }
        get isEmpty() {
            return this.invokingState === -1;
        }
        get sourceInterval() {
            return $gcfUE.Interval.INVALID;
        }
        get ruleContext() {
            return this;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this;
        }
        get text() {
            if (this.childCount === 0) return "";
            let builder = "";
            for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
            return builder.toString();
        }
        get ruleIndex() {
            return -1;
        }
        get altNumber() {
            return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        set altNumber(altNumber) {}
        getChild(i) {
            throw new RangeError("i must be greater than or equal to 0 and less than childCount");
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitChildren(this);
        }
        toStringTree(recog) {
            return $axprj.Trees.toStringTree(this, recog);
        }
        toString(arg1, stop) {
            const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
            stop = stop || $6bmaO.ParserRuleContext.emptyContext();
            let buf = "";
            let p = this;
            buf += "[";
            while(p && p !== stop){
                if (!ruleNames) {
                    if (!p.isEmpty) buf += p.invokingState;
                } else {
                    let ruleIndex = p.ruleIndex;
                    let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                    buf += ruleName;
                }
                if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
                p = p._parent;
            }
            buf += "]";
            return buf.toString();
        }
    }
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
    module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;
});
parcelRegister("2WQcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleNode = void 0;
    class $22597dffc9942eb7$var$RuleNode {
    }
    module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;
});
parcelRegister("axprj", function(module, exports) {
    "use strict";
    var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Trees = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $j53rr = parcelRequire("j53rr");
    var $cdCft = parcelRequire("cdCft");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $2WQcE = parcelRequire("2WQcE");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $7ac0b835c35ad12a$var$Trees {
        static toStringTree(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else ruleNames = arg2;
            let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            if (t.childCount === 0) return s;
            let buf = "";
            buf += "(";
            s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            buf += s;
            buf += " ";
            for(let i = 0; i < t.childCount; i++){
                if (i > 0) buf += " ";
                buf += this.toStringTree(t.getChild(i), ruleNames);
            }
            buf += ")";
            return buf;
        }
        static getNodeText(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else if (arg2) ruleNames = arg2;
            else {
                let payload = t.payload;
                if (typeof payload.text === "string") return payload.text;
                return t.payload.toString();
            }
            if (t instanceof $2WQcE.RuleNode) {
                let ruleContext = t.ruleContext;
                let ruleIndex = ruleContext.ruleIndex;
                let ruleName = ruleNames[ruleIndex];
                let altNumber = ruleContext.altNumber;
                if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
                return ruleName;
            } else if (t instanceof $cdCft.ErrorNode) return t.toString();
            else if (t instanceof $kYC92.TerminalNode) {
                let symbol = t.symbol;
                return symbol.text || "";
            }
            throw new TypeError("Unexpected node type");
        }
        static getChildren(t) {
            let kids = [];
            for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
            return kids;
        }
        static getAncestors(t) {
            let ancestors = [];
            let p = t.parent;
            while(p){
                ancestors.unshift(p);
                p = p.parent;
            }
            return ancestors;
        }
        static isAncestorOf(t, u) {
            if (!t || !u || !t.parent) return false;
            let p = u.parent;
            while(p){
                if (t === p) return true;
                p = p.parent;
            }
            return false;
        }
        static findAllTokenNodes(t, ttype) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
        }
        static findAllRuleNodes(t, ruleIndex) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
        }
        static findAllNodes(t, index, findTokens) {
            let nodes = [];
            $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
            return nodes;
        }
        static _findAllNodes(t, index, findTokens, nodes) {
            if (findTokens && t instanceof $kYC92.TerminalNode) {
                if (t.symbol.type === index) nodes.push(t);
            } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
                if (t.ruleIndex === index) nodes.push(t);
            }
            for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
        }
        static getDescendants(t) {
            let nodes = [];
            function recurse(e) {
                nodes.push(e);
                const n = e.childCount;
                for(let i = 0; i < n; i++)recurse(e.getChild(i));
            }
            recurse(t);
            return nodes;
        }
        static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let child = t.getChild(i);
                let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
                if (r) return r;
            }
            if (t instanceof $6bmaO.ParserRuleContext) {
                let stopToken = t.stop;
                if (startTokenIndex >= t.start.tokenIndex && (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) return t;
            }
            return undefined;
        }
        static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
            if (!t) return;
            let count = t.childCount;
            for(let i = 0; i < count; i++){
                let child = t.getChild(i);
                let range = child.sourceInterval;
                if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                    if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                        let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                        t.children[i] = new $kYC92.TerminalNode(abbrev);
                    }
                }
            }
        }
        static findNodeSuchThat(t, pred) {
            if (pred(t)) return t;
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
                if (u !== undefined) return u;
            }
            return undefined;
        }
    }
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
    $7ac0b835c35ad12a$var$__decorate([
        $d6D31.NotNull,
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
    module.exports.Trees = $7ac0b835c35ad12a$var$Trees;
});
parcelRegister("gDZVV", function(module, exports) {
    "use strict";
    var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionMode = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $4kGBm = parcelRequire("4kGBm");
    var $c1e05489d1cdbc78$var$PredictionMode;
    (function(PredictionMode) {
        PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
        PredictionMode[PredictionMode["LL"] = 1] = "LL";
        PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
    (function(PredictionMode) {
        class AltAndContextMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(AltAndContextConfigEqualityComparator.INSTANCE);
            }
        }
        class AltAndContextConfigEqualityComparator {
            AltAndContextConfigEqualityComparator() {}
            hashCode(o) {
                let hashCode = $iXFjm.MurmurHash.initialize(7);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
                return hashCode;
            }
            equals(a, b) {
                if (a === b) return true;
                if (a == null || b == null) return false;
                return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
            }
        }
        AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
        function hasConfigInRuleStopState(configs) {
            for (let c of configs){
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
        function allConfigsInRuleStopStates(configs) {
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
            }
            return true;
        }
        PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
});
parcelRegister("g7SCF", function(module, exports) {
    "use strict";
    var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SimulatorState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
        constructor(outerContext, s0, useContext, remainingOuterContext){
            this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
            this.s0 = s0;
            this.useContext = useContext;
            this.remainingOuterContext = remainingOuterContext;
        }
    };
    $bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
        $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
    ], $bbd7abb561fe52b9$var$SimulatorState);
    module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;
});
parcelRegister("d1V7w", function(module, exports) {
    "use strict";
    var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_BLOCK_START;
        }
    }
    $97c7ad4039a43616$var$__decorate([
        $d6D31.Override
    ], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
    module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;
});
parcelRegister("7qlbM", function(module, exports) {
    "use strict";
    var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusLoopbackState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
        }
    }
    $567b65d0d9bb1bcd$var$__decorate([
        $d6D31.Override
    ], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
    module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;
});
parcelRegister("7KGEQ", function(module, exports) {
    "use strict";
    var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PrecedencePredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, precedence){
            super(target);
            this.precedence = precedence;
        }
        get serializationType() {
            return 10;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
        }
        toString() {
            return this.precedence + " >= _p";
        }
    };
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
    $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
        $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
    module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;
});
parcelRegister("aISkF", function(module, exports) {
    "use strict";
    var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RangeTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
        constructor(target, from, to){
            super(target);
            this.from = from;
            this.to = to;
        }
        get serializationType() {
            return 2;
        }
        get label() {
            return $hGRod.IntervalSet.of(this.from, this.to);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= this.from && symbol <= this.to;
        }
        toString() {
            return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
        }
    };
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
    $7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
        $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
    ], $7ce828b1bf424f49$var$RangeTransition);
    module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;
});
parcelRegister("j2zc8", function(module, exports) {
    "use strict";
    var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStartState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.isPrecedenceRule = false;
            this.leftFactored = false;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_START;
        }
    }
    $ddc981289e81a506$var$__decorate([
        $d6D31.Override
    ], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
    module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;
});
parcelRegister("jEsaF", function(module, exports) {
    "use strict";
    var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.STAR_BLOCK_START;
        }
    }
    $e4e79af439480b0e$var$__decorate([
        $d6D31.Override
    ], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
    module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;
});
parcelRegister("bjwd1", function(module, exports) {
    "use strict";
    var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopbackState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
        get loopEntryState() {
            return this.transition(0).target;
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_BACK;
        }
    }
    $83ca741f127bc1b0$var$__decorate([
        $d6D31.Override
    ], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
    module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;
});
parcelRegister("WS4d7", function(module, exports) {
    "use strict";
    var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TokensStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.TOKEN_START;
        }
    }
    $0b0f5b750847d473$var$__decorate([
        $d6D31.Override
    ], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
    module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;
});
parcelRegister("kWxOc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.UUID = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    class $f3f3731a7838b7f9$var$UUID {
        constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
            this.data = new Uint32Array(4);
            this.data[0] = mostSigBits;
            this.data[1] = moreSigBits;
            this.data[2] = lessSigBits;
            this.data[3] = leastSigBits;
        }
        static fromString(data) {
            if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
            let segments = data.split("-");
            let mostSigBits = parseInt(segments[0], 16);
            let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
            let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
            let leastSigBits = parseInt(segments[4].substr(-8), 16);
            return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode([
                this.data[0],
                this.data[1],
                this.data[2],
                this.data[3]
            ]);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
            return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
        }
        toString() {
            return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
        }
    }
    module.exports.UUID = $f3f3731a7838b7f9$var$UUID;
});
parcelRegister("3iOjI", function(module, exports) {
    "use strict";
    var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $267a15775466fb93$var$ParseInfo = class ParseInfo {
        constructor(atnSimulator){
            this.atnSimulator = atnSimulator;
        }
        getDecisionInfo() {
            return this.atnSimulator.getDecisionInfo();
        }
        getLLDecisions() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let LL = [];
            for(let i = 0; i < decisions.length; i++){
                let fallBack = decisions[i].LL_Fallback;
                if (fallBack > 0) LL.push(i);
            }
            return LL;
        }
        getTotalTimeInPrediction() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let t = 0;
            for (let decision of decisions)t += decision.timeInPrediction;
            return t;
        }
        getTotalSLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_TotalLook;
            return k;
        }
        getTotalLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_TotalLook;
            return k;
        }
        getTotalSLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_ATNTransitions;
            return k;
        }
        getTotalLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_ATNTransitions;
            return k;
        }
        getTotalATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions){
                k += decision.SLL_ATNTransitions;
                k += decision.LL_ATNTransitions;
            }
            return k;
        }
        getDFASize(decision) {
            if (decision) {
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
                return decisionToDFA.states.size;
            } else {
                let n = 0;
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
                for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
                return n;
            }
        }
    };
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
    $267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
        $267a15775466fb93$var$__param(0, $d6D31.NotNull)
    ], $267a15775466fb93$var$ParseInfo);
    module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;
});
parcelRegister("5xwgp", function(module, exports) {
    "use strict";
    var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyParserErrorListener = void 0;
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
        constructor(delegates){
            super(delegates);
        }
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            });
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            });
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
            });
        }
    }
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
    module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;
});
parcelRegister("dE6Cn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1rIkv").then(()=>parcelRequire('gpWGO'));
});
parcelRegister("kSEFX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d6qIW").then(()=>parcelRequire('cJzXV'));
});
parcelRegister("3kXUy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseCancellationException = void 0;
    class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
        constructor(cause){
            super(cause.message);
            this.cause = cause;
            this.stack = cause.stack;
        }
        getCause() {
            return this.cause;
        }
    }
    module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;
});
parcelRegister("1UkCC", function(module, exports) {
    "use strict";
    var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BufferedTokenStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
        constructor(tokenSource){
            this.tokens = [];
            this.p = -1;
            this.fetchedEOF = false;
            if (tokenSource == null) throw new Error("tokenSource cannot be null");
            this._tokenSource = tokenSource;
        }
        get tokenSource() {
            return this._tokenSource;
        }
        set tokenSource(tokenSource) {
            this._tokenSource = tokenSource;
            this.tokens.length = 0;
            this.p = -1;
            this.fetchedEOF = false;
        }
        get index() {
            return this.p;
        }
        mark() {
            return 0;
        }
        release(marker) {}
        seek(index) {
            this.lazyInit();
            this.p = this.adjustSeekIndex(index);
        }
        get size() {
            return this.tokens.length;
        }
        consume() {
            let skipEofCheck;
            if (this.p >= 0) {
                if (this.fetchedEOF) skipEofCheck = this.p < this.tokens.length - 1;
                else skipEofCheck = this.p < this.tokens.length;
            } else skipEofCheck = false;
            if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
            if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
        }
        sync(i) {
            $bbHFU(i >= 0);
            let n = i - this.tokens.length + 1;
            if (n > 0) {
                let fetched = this.fetch(n);
                return fetched >= n;
            }
            return true;
        }
        fetch(n) {
            if (this.fetchedEOF) return 0;
            for(let i = 0; i < n; i++){
                let t = this.tokenSource.nextToken();
                if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
                this.tokens.push(t);
                if (t.type === $2DVsz.Token.EOF) {
                    this.fetchedEOF = true;
                    return i + 1;
                }
            }
            return n;
        }
        get(i) {
            if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
            return this.tokens[i];
        }
        getRange(start, stop) {
            if (start < 0 || stop < 0) return [];
            this.lazyInit();
            let subset = new Array();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                subset.push(t);
            }
            return subset;
        }
        LA(i) {
            let token = this.LT(i);
            if (!token) return $2DVsz.Token.INVALID_TYPE;
            return token.type;
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            return this.tokens[this.p - k];
        }
        LT(k) {
            let result = this.tryLT(k);
            if (result === undefined) throw new RangeError("requested lookback index out of range");
            return result;
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p + k - 1;
            this.sync(i);
            if (i >= this.tokens.length) return this.tokens[this.tokens.length - 1];
            return this.tokens[i];
        }
        adjustSeekIndex(i) {
            return i;
        }
        lazyInit() {
            if (this.p === -1) this.setup();
        }
        setup() {
            this.sync(0);
            this.p = this.adjustSeekIndex(0);
        }
        getTokens(start, stop, types) {
            this.lazyInit();
            if (start === undefined) {
                $bbHFU(stop === undefined && types === undefined);
                return this.tokens;
            } else if (stop === undefined) stop = this.tokens.length - 1;
            if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
            if (start > stop) return [];
            if (types === undefined) return this.tokens.slice(start, stop + 1);
            else if (typeof types === "number") types = new Set().add(types);
            let typesSet = types;
            let filteredTokens = this.tokens.slice(start, stop + 1);
            filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
            return filteredTokens;
        }
        nextTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            let token = this.tokens[i];
            while(token.channel !== channel){
                if (token.type === $2DVsz.Token.EOF) return i;
                i++;
                this.sync(i);
                token = this.tokens[i];
            }
            return i;
        }
        previousTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            while(i >= 0){
                let token = this.tokens[i];
                if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
                i--;
            }
            return i;
        }
        getHiddenTokensToRight(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            let to;
            let from = tokenIndex + 1;
            if (nextOnChannel === -1) to = this.size - 1;
            else to = nextOnChannel;
            return this.filterForChannel(from, to, channel);
        }
        getHiddenTokensToLeft(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            if (tokenIndex === 0) return [];
            let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            if (prevOnChannel === tokenIndex - 1) return [];
            let from = prevOnChannel + 1;
            let to = tokenIndex - 1;
            return this.filterForChannel(from, to, channel);
        }
        filterForChannel(from, to, channel) {
            let hidden = new Array();
            for(let i = from; i <= to; i++){
                let t = this.tokens[i];
                if (channel === -1) {
                    if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
                } else if (t.channel === channel) hidden.push(t);
            }
            return hidden;
        }
        get sourceName() {
            return this.tokenSource.sourceName;
        }
        getText(interval) {
            if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
            else if (!(interval instanceof $gcfUE.Interval)) interval = interval.sourceInterval;
            let start = interval.a;
            let stop = interval.b;
            if (start < 0 || stop < 0) return "";
            this.fill();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            let buf = "";
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                buf += t.text;
            }
            return buf.toString();
        }
        getTextFromRange(start, stop) {
            if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
            return "";
        }
        fill() {
            this.lazyInit();
            const blockSize = 1000;
            while(true){
                let fetched = this.fetch(blockSize);
                if (fetched < blockSize) return;
            }
        }
        isWritableToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
        isToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
    };
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
    $163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
        $163b0480402006d6$var$__param(0, $d6D31.NotNull)
    ], $163b0480402006d6$var$BufferedTokenStream);
    module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;
});
parcelRegister("QidO0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9NnFz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CharStreams = void 0;
    var $1Olk0 = parcelRequire("1Olk0");
    var $7ufNj = parcelRequire("7ufNj");
    var $ceaEj = parcelRequire("ceaEj");
    var $721b0cebe5798117$var$CharStreams;
    (function(CharStreams) {
        function fromString(s, sourceName) {
            if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
            let cb = new Uint16Array(s.length);
            for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
            codePointBufferBuilder.append(cb);
            return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
        }
        CharStreams.fromString = fromString;
    })($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));
});
parcelRegister("1Olk0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointBuffer = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $gIRNa = parcelRequire("gIRNa");
    class $151b0001e5dcadf1$var$CodePointBuffer {
        constructor(buffer, size){
            this.buffer = buffer;
            this._position = 0;
            this._size = size;
        }
        static withArray(buffer) {
            return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
        }
        get position() {
            return this._position;
        }
        set position(newPosition) {
            if (newPosition < 0 || newPosition > this._size) throw new RangeError();
            this._position = newPosition;
        }
        get remaining() {
            return this._size - this.position;
        }
        get(offset) {
            return this.buffer[offset];
        }
        array() {
            return this.buffer.slice(0, this._size);
        }
        static builder(initialBufferSize) {
            return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
        }
    }
    module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
    (function(CodePointBuffer) {
        let Type;
        (function(Type) {
            Type[Type["BYTE"] = 0] = "BYTE";
            Type[Type["CHAR"] = 1] = "CHAR";
            Type[Type["INT"] = 2] = "INT";
        })(Type || (Type = {}));
        class Builder {
            constructor(initialBufferSize){
                this.type = 0;
                this.buffer = new Uint8Array(initialBufferSize);
                this.prevHighSurrogate = -1;
                this.position = 0;
            }
            build() {
                return new CodePointBuffer(this.buffer, this.position);
            }
            static roundUpToNextPowerOfTwo(i) {
                let nextPowerOfTwo = 32 - Math.clz32(i - 1);
                return Math.pow(2, nextPowerOfTwo);
            }
            ensureRemaining(remainingNeeded) {
                switch(this.type){
                    case 0:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint8Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 1:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint16Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 2:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Int32Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                }
            }
            append(utf16In) {
                this.ensureRemaining(utf16In.length);
                this.appendArray(utf16In);
            }
            appendArray(utf16In) {
                switch(this.type){
                    case 0:
                        this.appendArrayByte(utf16In);
                        break;
                    case 1:
                        this.appendArrayChar(utf16In);
                        break;
                    case 2:
                        this.appendArrayInt(utf16In);
                        break;
                }
            }
            appendArrayByte(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outByte = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (c <= 0xFF) outByte[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        if (!$gIRNa.isHighSurrogate(c)) {
                            this.byteToCharBuffer(utf16In.length);
                            this.appendArrayChar(utf16In);
                            return;
                        } else {
                            this.byteToIntBuffer(utf16In.length);
                            this.appendArrayInt(utf16In);
                            return;
                        }
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayChar(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outChar = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        this.charToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayInt(utf16In) {
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outInt = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    inOffset++;
                    if (this.prevHighSurrogate !== -1) {
                        if ($gIRNa.isLowSurrogate(c)) {
                            outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        } else {
                            outInt[outOffset] = this.prevHighSurrogate;
                            outOffset++;
                            if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                            else {
                                outInt[outOffset] = c;
                                outOffset++;
                                this.prevHighSurrogate = -1;
                            }
                        }
                    } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                    else {
                        outInt[outOffset] = c;
                        outOffset++;
                    }
                }
                if (this.prevHighSurrogate !== -1) {
                    outInt[outOffset] = this.prevHighSurrogate;
                    outOffset++;
                }
                this.position = outOffset;
            }
            byteToCharBuffer(toAppend) {
                let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 1;
                this.buffer = newBuffer;
            }
            byteToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
            charToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
        }
        CodePointBuffer.Builder = Builder;
    })($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));
});
parcelRegister("gIRNa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
    function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
        return ch >= 0xD800 && ch <= 0xDBFF;
    }
    module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
    function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
        return ch >= 0xDC00 && ch <= 0xDFFF;
    }
    module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
    function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
        return ch >= 0x10000;
    }
    module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;
});
parcelRegister("7ufNj", function(module, exports) {
    "use strict";
    var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointCharStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $ceaEj = parcelRequire("ceaEj");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $57379632ac21bb89$var$CodePointCharStream {
        constructor(array, position, remaining, name){
            $bbHFU(position === 0);
            this._array = array;
            this._size = remaining;
            this._name = name;
            this._position = 0;
        }
        get internalStorage() {
            return this._array;
        }
        static fromBuffer(codePointBuffer, name) {
            if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
        }
        consume() {
            if (this._size - this._position === 0) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new RangeError("cannot consume EOF");
            }
            this._position++;
        }
        get index() {
            return this._position;
        }
        get size() {
            return this._size;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            this._position = index;
        }
        get sourceName() {
            return this._name;
        }
        toString() {
            return this.getText($gcfUE.Interval.of(0, this.size - 1));
        }
        LA(i) {
            let offset;
            switch(Math.sign(i)){
                case -1:
                    offset = this.index + i;
                    if (offset < 0) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
                case 0:
                    return 0;
                case 1:
                    offset = this.index + i - 1;
                    if (offset >= this.size) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
            }
            throw new RangeError("Not reached");
        }
        getText(interval) {
            const startIdx = Math.min(interval.a, this.size);
            const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
            if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
            else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        }
    }
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
    module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;
});
parcelRegister("a0nC0", function(module, exports) {
    "use strict";
    var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenStream = void 0;
    var $1UkCC = parcelRequire("1UkCC");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
        constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
            super(tokenSource);
            this.channel = channel;
        }
        adjustSeekIndex(i) {
            return this.nextTokenOnChannel(i, this.channel);
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            let i = this.p;
            let n = 1;
            while(n <= k && i > 0){
                i = this.previousTokenOnChannel(i - 1, this.channel);
                n++;
            }
            if (i < 0) return undefined;
            return this.tokens[i];
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p;
            let n = 1;
            while(n < k){
                if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
                n++;
            }
            return this.tokens[i];
        }
        getNumberOfOnChannelTokens() {
            let n = 0;
            this.fill();
            for (let t of this.tokens){
                if (t.channel === this.channel) n++;
                if (t.type === $2DVsz.Token.EOF) break;
            }
            return n;
        }
    };
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
    $748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
        $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
    ], $748c38524e2afd86$var$CommonTokenStream);
    module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;
});
parcelRegister("4a3G0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Dependents = void 0;
    var $307af2a6cd217eb5$var$Dependents;
    (function(Dependents) {
        Dependents[Dependents["SELF"] = 0] = "SELF";
        Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
        Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
        Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
        Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
        Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
        Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
        Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
        Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
        Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
    })($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));
});
parcelRegister("5Poq6", function(module, exports) {
    "use strict";
    var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DiagnosticErrorListener = void 0;
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    class $43e4a87e035cc726$var$DiagnosticErrorListener {
        constructor(exactOnly = true){
            this.exactOnly = exactOnly;
            this.exactOnly = exactOnly;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {}
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (this.exactOnly && !exact) return;
            let decision = this.getDecisionDescription(recognizer, dfa);
            let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            let format = "reportAttemptingFullContext d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            let format = "reportContextSensitivity d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportContextSensitivity d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        getDecisionDescription(recognizer, dfa) {
            let decision = dfa.decision;
            let ruleIndex = dfa.atnStartState.ruleIndex;
            let ruleNames = recognizer.ruleNames;
            if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
            let ruleName = ruleNames[ruleIndex];
            if (!ruleName) return decision.toString();
            return `${decision} (${ruleName})`;
        }
        getConflictingAlts(reportedAlts, configs) {
            if (reportedAlts != null) return reportedAlts;
            let result = new $5BPMp.BitSet();
            for (let config of configs)result.set(config.alt);
            return result;
        }
    }
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
    $43e4a87e035cc726$var$__decorate([
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.NotNull,
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
    module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;
});
parcelRegister("5FrZ8", function(module, exports) {
    "use strict";
    var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InterpreterRuleContext = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
        constructor(ruleIndex, parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._ruleIndex = ruleIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
    }
    $42067d58e54221f4$var$__decorate([
        $d6D31.Override
    ], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
    module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;
});
parcelRegister("gMbxO", function(module, exports) {
    "use strict";
    var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerInterpreter = void 0;
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
        constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
            super(input);
            if (atn.grammarType !== 0) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._channelNames = channelNames.slice(0);
            this._modeNames = modeNames.slice(0);
            this._vocabulary = vocabulary;
            this._interp = new $lQecE.LexerATNSimulator(atn, this);
        }
        get atn() {
            return this._atn;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get channelNames() {
            return this._channelNames;
        }
        get modeNames() {
            return this._modeNames;
        }
        get vocabulary() {
            return this._vocabulary;
        }
    };
    $c36a1586c540a239$var$__decorate([
        $d6D31.NotNull
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
    $c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
        $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
    ], $c36a1586c540a239$var$LexerInterpreter);
    module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;
});
parcelRegister("drCaH", function(module, exports) {
    "use strict";
    var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ListTokenSource = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
        constructor(tokens, sourceName){
            this.i = 0;
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            if (tokens == null) throw new Error("tokens cannot be null");
            this.tokens = tokens;
            this._sourceName = sourceName;
        }
        get charPositionInLine() {
            if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
            else if (this.eofToken != null) return this.eofToken.charPositionInLine;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    let lastNewLine = tokenText.lastIndexOf("\n");
                    if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
                }
                return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
            }
            return 0;
        }
        nextToken() {
            if (this.i >= this.tokens.length) {
                if (this.eofToken == null) {
                    let start = -1;
                    if (this.tokens.length > 0) {
                        let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                        if (previousStop !== -1) start = previousStop + 1;
                    }
                    let stop = Math.max(-1, start - 1);
                    this.eofToken = this._factory.create({
                        source: this,
                        stream: this.inputStream
                    }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
                }
                return this.eofToken;
            }
            let t = this.tokens[this.i];
            if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
            this.i++;
            return t;
        }
        get line() {
            if (this.i < this.tokens.length) return this.tokens[this.i].line;
            else if (this.eofToken != null) return this.eofToken.line;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let line = lastToken.line;
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
                }
                return line;
            }
            return 1;
        }
        get inputStream() {
            if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
            else if (this.eofToken != null) return this.eofToken.inputStream;
            else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
            return undefined;
        }
        get sourceName() {
            if (this._sourceName) return this._sourceName;
            let inputStream = this.inputStream;
            if (inputStream != null) return inputStream.sourceName;
            return "List";
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get tokenFactory() {
            return this._factory;
        }
    };
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull,
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
    $9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource);
    module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;
});
parcelRegister("2pQQd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dReoi", function(module, exports) {
    "use strict";
    var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserInterpreter = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $5FrZ8 = parcelRequire("5FrZ8");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
        constructor(grammarFileName, vocabulary, ruleNames, atn, input){
            super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
            this._parentContextStack = [];
            this.overrideDecision = -1;
            this.overrideDecisionInputIndex = -1;
            this.overrideDecisionAlt = -1;
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
            if (grammarFileName instanceof ParserInterpreter) {
                let old = grammarFileName;
                this._grammarFileName = old._grammarFileName;
                this._atn = old._atn;
                this.pushRecursionContextStates = old.pushRecursionContextStates;
                this._ruleNames = old._ruleNames;
                this._vocabulary = old._vocabulary;
                this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
            } else {
                vocabulary;
                ruleNames;
                atn;
                this._grammarFileName = grammarFileName;
                this._atn = atn;
                this._ruleNames = ruleNames.slice(0);
                this._vocabulary = vocabulary;
                this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
                for (let state of atn.states){
                    if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                    if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
                }
                this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
            }
        }
        reset(resetInput) {
            if (resetInput === undefined) super.reset();
            else super.reset(resetInput);
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
        }
        get atn() {
            return this._atn;
        }
        get vocabulary() {
            return this._vocabulary;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        parse(startRuleIndex) {
            let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
            this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
            if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
            else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
            while(true){
                let p = this.atnState;
                switch(p.stateType){
                    case $1bs3X.ATNStateType.RULE_STOP:
                        if (this._ctx.isEmpty) {
                            if (startRuleStartState.isPrecedenceRule) {
                                let result = this._ctx;
                                let parentContext = this._parentContextStack.pop();
                                this.unrollRecursionContexts(parentContext[0]);
                                return result;
                            } else {
                                this.exitRule();
                                return this._rootContext;
                            }
                        }
                        this.visitRuleStopState(p);
                        break;
                    default:
                        try {
                            this.visitState(p);
                        } catch (e) {
                            if (e instanceof $fLdDn.RecognitionException) {
                                this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                                this.context.exception = e;
                                this.errorHandler.reportError(this, e);
                                this.recover(e);
                            } else throw e;
                        }
                        break;
                }
            }
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this._parentContextStack.push([
                this._ctx,
                localctx.invokingState
            ]);
            super.enterRecursionRule(localctx, state, ruleIndex, precedence);
        }
        get atnState() {
            return this._atn.states[this.state];
        }
        visitState(p) {
            let predictedAlt = 1;
            if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
            let transition = p.transition(predictedAlt - 1);
            switch(transition.serializationType){
                case 1:
                    if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                        let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                        let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                        this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                    }
                    break;
                case 5:
                    this.match(transition._label);
                    break;
                case 2:
                case 7:
                case 8:
                    if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                    this.matchWildcard();
                    break;
                case 9:
                    this.matchWildcard();
                    break;
                case 3:
                    let ruleStartState = transition.target;
                    let ruleIndex = ruleStartState.ruleIndex;
                    let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                    if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                    else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                    break;
                case 4:
                    let predicateTransition = transition;
                    if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                    break;
                case 6:
                    let actionTransition = transition;
                    this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                    break;
                case 10:
                    if (!this.precpred(this._ctx, transition.precedence)) {
                        let precedence = transition.precedence;
                        throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                    }
                    break;
                default:
                    throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
            }
            this.state = transition.target.stateNumber;
        }
        visitDecisionState(p) {
            let predictedAlt;
            this.errorHandler.sync(this);
            let decision = p.decision;
            if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
                predictedAlt = this.overrideDecisionAlt;
                this.overrideDecisionReached = true;
            } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
            return predictedAlt;
        }
        createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
            return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
        }
        visitRuleStopState(p) {
            let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
            if (ruleStartState.isPrecedenceRule) {
                let parentContext = this._parentContextStack.pop();
                this.unrollRecursionContexts(parentContext[0]);
                this.state = parentContext[1];
            } else this.exitRule();
            let ruleTransition = this._atn.states[this.state].transition(0);
            this.state = ruleTransition.followState.stateNumber;
        }
        addDecisionOverride(decision, tokenIndex, forcedAlt) {
            this.overrideDecision = decision;
            this.overrideDecisionInputIndex = tokenIndex;
            this.overrideDecisionAlt = forcedAlt;
        }
        get overrideDecisionRoot() {
            return this._overrideDecisionRoot;
        }
        recover(e) {
            let i = this._input.index;
            this.errorHandler.recover(this, e);
            if (this._input.index === i) {
                let tok = e.getOffendingToken();
                if (!tok) throw new Error("Expected exception to have an offending token");
                let source = tok.tokenSource;
                let stream = source !== undefined ? source.inputStream : undefined;
                let sourcePair = {
                    source: source,
                    stream: stream
                };
                if (e instanceof $iLUMi.InputMismatchException) {
                    let expectedTokens = e.expectedTokens;
                    if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                    let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                    if (!expectedTokens.isNil) expectedTokenType = expectedTokens.minElement;
                    let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                } else {
                    let source = tok.tokenSource;
                    let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                }
            }
        }
        recoverInline() {
            return this._errHandler.recoverInline(this);
        }
        get rootContext() {
            return this._rootContext;
        }
    };
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.NotNull
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
    $a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
        $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
    ], $a16b634f90dd81f4$var$ParserInterpreter);
    module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;
});
parcelRegister("77rdV", function(module, exports) {
    "use strict";
    var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContextWithAltNum = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        get altNumber() {
            return this._altNumber;
        }
        set altNumber(altNum) {
            this._altNumber = altNum;
        }
    }
    $52ee4de454858848$var$__decorate([
        $d6D31.Override
    ], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
    module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;
});
parcelRegister("5IgvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleDependency = void 0;
    function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;
});
parcelRegister("1ivK9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleVersion = void 0;
    function $0f201872a8ca959f$var$RuleVersion(version) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;
});
parcelRegister("eftJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9rAj4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("5jPdD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dIykH", function(module, exports) {
    "use strict";
    var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $9fca043c2d5f0853$var$TokenStreamRewriter {
        constructor(tokens){
            this.tokens = tokens;
            this.programs = new Map();
            this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
            this.lastRewriteTokenIndexes = new Map();
        }
        getTokenStream() {
            return this.tokens;
        }
        rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let is = this.programs.get(programName);
            if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
        }
        deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
        }
        insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        replaceSingle(index, text) {
            if (typeof index === "number") this.replace(index, index, text);
            else this.replace(index, index, text);
        }
        replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (typeof from !== "number") from = from.tokenIndex;
            if (typeof to !== "number") to = to.tokenIndex;
            if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
            rewrites.push(op);
        }
        delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (to === undefined) to = from;
            if (typeof from === "number") this.replace(from, to, "", programName);
            else this.replace(from, to, "", programName);
        }
        getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let I = this.lastRewriteTokenIndexes.get(programName);
            if (I == null) return -1;
            return I;
        }
        setLastRewriteTokenIndex(programName, i) {
            this.lastRewriteTokenIndexes.set(programName, i);
        }
        getProgram(name) {
            let is = this.programs.get(name);
            if (is == null) is = this.initializeProgram(name);
            return is;
        }
        initializeProgram(name) {
            let is = [];
            this.programs.set(name, is);
            return is;
        }
        getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let interval;
            if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
            else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
            if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
            let rewrites = this.programs.get(programName);
            let start = interval.a;
            let stop = interval.b;
            if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
            if (start < 0) start = 0;
            if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval);
            let buf = [];
            let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
            let i = start;
            while(i <= stop && i < this.tokens.size){
                let op = indexToOp.get(i);
                indexToOp.delete(i);
                let t = this.tokens.get(i);
                if (op == null) {
                    if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                    i++;
                } else i = op.execute(buf);
            }
            if (stop === this.tokens.size - 1) {
                for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
            }
            return buf.join("");
        }
        reduceToSingleOperationPerIndex(rewrites) {
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
                let rop = op;
                let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let iop of inserts){
                    if (iop.index === rop.index) {
                        rewrites[iop.instructionIndex] = undefined;
                        rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                    } else if (iop.index > rop.index && iop.index <= rop.lastIndex) rewrites[iop.instructionIndex] = undefined;
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let prevRop of prevReplaces){
                    if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        continue;
                    }
                    let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                    if (prevRop.text == null && rop.text == null && !disjoint) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        rop.index = Math.min(prevRop.index, rop.index);
                        rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                    } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
                }
            }
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
                let iop = op;
                let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                    if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                        iop.text = this.catOpText(prevIop.text, iop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                        iop.text = this.catOpText(iop.text, prevIop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    }
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let rop of prevReplaces){
                    if (iop.index === rop.index) {
                        rop.text = this.catOpText(iop.text, rop.text);
                        rewrites[i] = undefined;
                        continue;
                    }
                    if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
                }
            }
            let m = new Map();
            for (let op of rewrites){
                if (op == null) continue;
                if (m.get(op.index) != null) throw new Error("should only be one op per index");
                m.set(op.index, op);
            }
            return m;
        }
        catOpText(a, b) {
            let x = "";
            let y = "";
            if (a != null) x = a.toString();
            if (b != null) y = b.toString();
            return x + y;
        }
        getKindOfOps(rewrites, kind, before) {
            let ops = [];
            for(let i = 0; i < before && i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (op instanceof kind) ops.push(op);
            }
            return ops;
        }
    }
    module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
    $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
    $9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
    $9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
    class $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            this.tokens = tokens;
            this.instructionIndex = instructionIndex;
            this.index = index;
            this.text = text === undefined ? "" : text;
        }
        execute(buf) {
            return this.index;
        }
        toString() {
            let opName = this.constructor.name;
            let $index = opName.indexOf("$");
            opName = opName.substring($index + 1, opName.length);
            return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
    module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
    class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index, instructionIndex, text);
        }
        execute(buf) {
            buf.push(this.text.toString());
            if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
            return this.index + 1;
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
    class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index + 1, instructionIndex, text);
        }
    }
    class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, from, to, instructionIndex, text){
            super(tokens, from, instructionIndex, text);
            this.lastIndex = to;
        }
        execute(buf) {
            if (this.text != null) buf.push(this.text.toString());
            return this.lastIndex + 1;
        }
        toString() {
            if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
            return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);
});
parcelRegister("1MVGg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("6UcB4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("39War", function(module, exports) {
    $parcel$export(module.exports, "JQLLexer", ()=>$801b4612eb9312ce$export$375c79404cc64c7f);
    var $dvgsl = parcelRequire("dvgsl");
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $801b4612eb9312ce$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.QUOTED_STR = 1;
        }
        static{
            this.SQUOTED_STR = 2;
        }
        static{
            this.channelNames = [
                'DEFAULT_TOKEN_CHANNEL',
                'HIDDEN'
            ];
        }
        static{
            this.modeNames = [
                'DEFAULT_MODE',
                'QUOTED_STR',
                'SQUOTED_STR'
            ];
        }
        static{
            this.ruleNames = [
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'LQUOTE',
                'LSQUOTE',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'QUOTED_CONTENT',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'SQUOTED_CONTENT',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING',
                'VALID_UNQUOTED_CHARS',
                'VALID_QUOTED_CHARS',
                'VALID_SQUOTED_CHARS',
                'RESERVED_CHARS',
                'QUOTE',
                'SQUOTE',
                'BSLASH',
                'NL',
                'CR',
                'SPACE',
                'AMPER',
                'AMPER_AMPER',
                'PIPE',
                'PIPE_PIPE',
                'ESCAPE',
                'NEWLINE',
                'HEXDIGIT',
                'WS',
                'MINUS',
                'DIGIT',
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($801b4612eb9312ce$export$375c79404cc64c7f._LITERAL_NAMES, $801b4612eb9312ce$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.VOCABULARY;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $lQecE.LexerATNSimulator)($801b4612eb9312ce$export$375c79404cc64c7f._ATN, this);
        }
        get grammarFileName() {
            return 'JQLLexer.g4';
        }
        get ruleNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.ruleNames;
        }
        get serializedATN() {
            return $801b4612eb9312ce$export$375c79404cc64c7f._serializedATN;
        }
        get channelNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.channelNames;
        }
        get modeNames() {
            return $801b4612eb9312ce$export$375c79404cc64c7f.modeNames;
        }
        static{
            this._serializedATNSegments = 3;
        }
        static{
            this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
        }
        static{
            this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
        }
        static{
            this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
        }
        static{
            this._serializedATN = $2IEP9.join([
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment0,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment1,
                $801b4612eb9312ce$export$375c79404cc64c7f._serializedATNSegment2
            ], '');
        }
        static get _ATN() {
            if (!$801b4612eb9312ce$export$375c79404cc64c7f.__ATN) $801b4612eb9312ce$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($801b4612eb9312ce$export$375c79404cc64c7f._serializedATN));
            return $801b4612eb9312ce$export$375c79404cc64c7f.__ATN;
        }
    }
});
parcelRegister("k9No4", function(module, exports) {
    $parcel$export(module.exports, "JQLParser", ()=>$371e898df891458a$export$9c4772e191bdb810);
    var $dvgsl = parcelRequire("dvgsl");
    var $hKCjP = parcelRequire("hKCjP");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $371e898df891458a$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.RULE_jqlQuery = 0;
        }
        static{
            this.RULE_jqlWhere = 1;
        }
        static{
            this.RULE_jqlOrClause = 2;
        }
        static{
            this.RULE_jqlAndClause = 3;
        }
        static{
            this.RULE_jqlNotClause = 4;
        }
        static{
            this.RULE_jqlSubClause = 5;
        }
        static{
            this.RULE_jqlTerminalClause = 6;
        }
        static{
            this.RULE_jqlTerminalClauseRhs = 7;
        }
        static{
            this.RULE_jqlEqualsOperator = 8;
        }
        static{
            this.RULE_jqlLikeOperator = 9;
        }
        static{
            this.RULE_jqlComparisonOperator = 10;
        }
        static{
            this.RULE_jqlInOperator = 11;
        }
        static{
            this.RULE_jqlIsOperator = 12;
        }
        static{
            this.RULE_jqlWasOperator = 13;
        }
        static{
            this.RULE_jqlWasInOperator = 14;
        }
        static{
            this.RULE_jqlChangedOperator = 15;
        }
        static{
            this.RULE_jqlField = 16;
        }
        static{
            this.RULE_jqlFieldProperty = 17;
        }
        static{
            this.RULE_jqlCustomField = 18;
        }
        static{
            this.RULE_jqlString = 19;
        }
        static{
            this.RULE_jqlNumber = 20;
        }
        static{
            this.RULE_jqlOperand = 21;
        }
        static{
            this.RULE_jqlEmpty = 22;
        }
        static{
            this.RULE_jqlValue = 23;
        }
        static{
            this.RULE_jqlFunction = 24;
        }
        static{
            this.RULE_jqlFunctionName = 25;
        }
        static{
            this.RULE_jqlArgumentList = 26;
        }
        static{
            this.RULE_jqlList = 27;
        }
        static{
            this.RULE_jqlListStart = 28;
        }
        static{
            this.RULE_jqlListEnd = 29;
        }
        static{
            this.RULE_jqlPropertyArgument = 30;
        }
        static{
            this.RULE_jqlArgument = 31;
        }
        static{
            this.RULE_jqlWasPredicate = 32;
        }
        static{
            this.RULE_jqlChangedPredicate = 33;
        }
        static{
            this.RULE_jqlDatePredicateOperator = 34;
        }
        static{
            this.RULE_jqlDateRangePredicateOperator = 35;
        }
        static{
            this.RULE_jqlUserPredicateOperator = 36;
        }
        static{
            this.RULE_jqlValuePredicateOperator = 37;
        }
        static{
            this.RULE_jqlPredicateOperand = 38;
        }
        static{
            this.RULE_jqlOrderBy = 39;
        }
        static{
            this.RULE_jqlSearchSort = 40;
        }
        static{
            this.ruleNames = [
                'jqlQuery',
                'jqlWhere',
                'jqlOrClause',
                'jqlAndClause',
                'jqlNotClause',
                'jqlSubClause',
                'jqlTerminalClause',
                'jqlTerminalClauseRhs',
                'jqlEqualsOperator',
                'jqlLikeOperator',
                'jqlComparisonOperator',
                'jqlInOperator',
                'jqlIsOperator',
                'jqlWasOperator',
                'jqlWasInOperator',
                'jqlChangedOperator',
                'jqlField',
                'jqlFieldProperty',
                'jqlCustomField',
                'jqlString',
                'jqlNumber',
                'jqlOperand',
                'jqlEmpty',
                'jqlValue',
                'jqlFunction',
                'jqlFunctionName',
                'jqlArgumentList',
                'jqlList',
                'jqlListStart',
                'jqlListEnd',
                'jqlPropertyArgument',
                'jqlArgument',
                'jqlWasPredicate',
                'jqlChangedPredicate',
                'jqlDatePredicateOperator',
                'jqlDateRangePredicateOperator',
                'jqlUserPredicateOperator',
                'jqlValuePredicateOperator',
                'jqlPredicateOperand',
                'jqlOrderBy',
                'jqlSearchSort'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($371e898df891458a$export$9c4772e191bdb810._LITERAL_NAMES, $371e898df891458a$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $371e898df891458a$export$9c4772e191bdb810.VOCABULARY;
        }
        get grammarFileName() {
            return 'JQLParser.g4';
        }
        get ruleNames() {
            return $371e898df891458a$export$9c4772e191bdb810.ruleNames;
        }
        get serializedATN() {
            return $371e898df891458a$export$9c4772e191bdb810._serializedATN;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $kzbnL.ParserATNSimulator)($371e898df891458a$export$9c4772e191bdb810._ATN, this);
        }
        jqlQuery() {
            let _localctx = new $371e898df891458a$export$ff413535b9575c8(this._ctx, this.state);
            this.enterRule(_localctx, 0, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 83;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LPAREN | 1 << $371e898df891458a$export$9c4772e191bdb810.BANG | 1 << $371e898df891458a$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 82;
                    this.jqlWhere();
                }
                this.state = 86;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ORDER) {
                    this.state = 85;
                    this.jqlOrderBy();
                }
                this.state = 88;
                this.match($371e898df891458a$export$9c4772e191bdb810.EOF);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWhere() {
            let _localctx = new $371e898df891458a$export$4148a879cab28017(this._ctx, this.state);
            this.enterRule(_localctx, 2, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 90;
                this.jqlOrClause();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrClause() {
            let _localctx = new $371e898df891458a$export$d69831d387793480(this._ctx, this.state);
            this.enterRule(_localctx, 4, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 92;
                this.jqlAndClause();
                this.state = 97;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.OR){
                    this.state = 93;
                    this.match($371e898df891458a$export$9c4772e191bdb810.OR);
                    this.state = 94;
                    this.jqlAndClause();
                    this.state = 99;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlAndClause() {
            let _localctx = new $371e898df891458a$export$f16819001158b9e(this._ctx, this.state);
            this.enterRule(_localctx, 6, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 100;
                this.jqlNotClause();
                this.state = 105;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.AND){
                    this.state = 101;
                    this.match($371e898df891458a$export$9c4772e191bdb810.AND);
                    this.state = 102;
                    this.jqlNotClause();
                    this.state = 107;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNotClause() {
            let _localctx = new $371e898df891458a$export$5e9146f8d5cf1330(this._ctx, this.state);
            this.enterRule(_localctx, 8, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause);
            let _la;
            try {
                this.state = 112;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BANG:
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 108;
                        _la = this._input.LA(1);
                        if (!(_la === $371e898df891458a$export$9c4772e191bdb810.BANG || _la === $371e898df891458a$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                        else {
                            if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 109;
                        this.jqlNotClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 110;
                        this.jqlSubClause();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 111;
                        this.jqlTerminalClause();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSubClause() {
            let _localctx = new $371e898df891458a$export$a136a0e9655bfb04(this._ctx, this.state);
            this.enterRule(_localctx, 10, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 114;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 115;
                this.jqlOrClause();
                this.state = 116;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClause() {
            let _localctx = new $371e898df891458a$export$23486a2f2ddd5bcd(this._ctx, this.state);
            this.enterRule(_localctx, 12, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 118;
                this.jqlField();
                this.state = 119;
                this.jqlTerminalClauseRhs();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClauseRhs() {
            let _localctx = new $371e898df891458a$export$93924a205c12d32c(this._ctx, this.state);
            this.enterRule(_localctx, 14, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
            let _la;
            try {
                this.state = 176;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                    case 1:
                        _localctx = new $371e898df891458a$export$c428f709a58396e5(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 121;
                        this.jqlEqualsOperator();
                        this.state = 125;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                            case 1:
                                this.state = 122;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 123;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 124;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 2:
                        _localctx = new $371e898df891458a$export$1b131204ef9fa33d(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 127;
                        this.jqlLikeOperator();
                        this.state = 131;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                            case 1:
                                this.state = 128;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 129;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 130;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 3:
                        _localctx = new $371e898df891458a$export$d83706ee80a9852a(_localctx);
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 133;
                        this.jqlComparisonOperator();
                        this.state = 136;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                            case 1:
                                this.state = 134;
                                this.jqlValue();
                                break;
                            case 2:
                                this.state = 135;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 4:
                        _localctx = new $371e898df891458a$export$2934b8ff22fddd2d(_localctx);
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 138;
                        this.jqlInOperator();
                        this.state = 141;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 139;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 140;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        break;
                    case 5:
                        _localctx = new $371e898df891458a$export$8b84310182afcf93(_localctx);
                        this.enterOuterAlt(_localctx, 5);
                        this.state = 143;
                        this.jqlIsOperator();
                        this.state = 144;
                        this.jqlEmpty();
                        break;
                    case 6:
                        _localctx = new $371e898df891458a$export$5df295dc7a2cac7c(_localctx);
                        this.enterOuterAlt(_localctx, 6);
                        this.state = 146;
                        this.jqlWasOperator();
                        this.state = 150;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                            case 1:
                                this.state = 147;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 148;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 149;
                                this.jqlFunction();
                                break;
                        }
                        this.state = 155;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 152;
                            this.jqlWasPredicate();
                            this.state = 157;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 7:
                        _localctx = new $371e898df891458a$export$9ac3367aee261b32(_localctx);
                        this.enterOuterAlt(_localctx, 7);
                        this.state = 158;
                        this.jqlWasInOperator();
                        this.state = 161;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.LPAREN:
                                this.state = 159;
                                this.jqlList();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 160;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 166;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 163;
                            this.jqlWasPredicate();
                            this.state = 168;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 8:
                        _localctx = new $371e898df891458a$export$7a7defca8628a13c(_localctx);
                        this.enterOuterAlt(_localctx, 8);
                        this.state = 169;
                        this.jqlChangedOperator();
                        this.state = 173;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.FROM | 1 << $371e898df891458a$export$9c4772e191bdb810.TO | 1 << $371e898df891458a$export$9c4772e191bdb810.ON | 1 << $371e898df891458a$export$9c4772e191bdb810.DURING | 1 << $371e898df891458a$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 170;
                            this.jqlChangedPredicate();
                            this.state = 175;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEqualsOperator() {
            let _localctx = new $371e898df891458a$export$41e475fc1988e413(this._ctx, this.state);
            this.enterRule(_localctx, 16, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 178;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.EQUALS || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlLikeOperator() {
            let _localctx = new $371e898df891458a$export$b76fe5387fdd7efd(this._ctx, this.state);
            this.enterRule(_localctx, 18, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 180;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.LIKE || _la === $371e898df891458a$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlComparisonOperator() {
            let _localctx = new $371e898df891458a$export$d821da0716b3ec95(this._ctx, this.state);
            this.enterRule(_localctx, 20, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 182;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.LT | 1 << $371e898df891458a$export$9c4772e191bdb810.GT | 1 << $371e898df891458a$export$9c4772e191bdb810.GTEQ | 1 << $371e898df891458a$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlInOperator() {
            let _localctx = new $371e898df891458a$export$178478bfa8292f72(this._ctx, this.state);
            this.enterRule(_localctx, 22, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator);
            try {
                this.state = 187;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.IN:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 184;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 185;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 186;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlIsOperator() {
            let _localctx = new $371e898df891458a$export$e64c31d2830b66e4(this._ctx, this.state);
            this.enterRule(_localctx, 24, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator);
            try {
                this.state = 192;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 189;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 190;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IS);
                        this.state = 191;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasOperator() {
            let _localctx = new $371e898df891458a$export$7e283636700e4a6c(this._ctx, this.state);
            this.enterRule(_localctx, 26, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator);
            try {
                this.state = 197;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 194;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 195;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 196;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasInOperator() {
            let _localctx = new $371e898df891458a$export$b9118b1ed9a78d66(this._ctx, this.state);
            this.enterRule(_localctx, 28, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator);
            try {
                this.state = 204;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 199;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 200;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 201;
                        this.match($371e898df891458a$export$9c4772e191bdb810.WAS);
                        this.state = 202;
                        this.match($371e898df891458a$export$9c4772e191bdb810.NOT);
                        this.state = 203;
                        this.match($371e898df891458a$export$9c4772e191bdb810.IN);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedOperator() {
            let _localctx = new $371e898df891458a$export$493d626ed78ca66(this._ctx, this.state);
            this.enterRule(_localctx, 30, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 206;
                this.match($371e898df891458a$export$9c4772e191bdb810.CHANGED);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlField() {
            let _localctx = new $371e898df891458a$export$b33300c3d916229a(this._ctx, this.state);
            this.enterRule(_localctx, 32, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField);
            let _la;
            try {
                this.state = 219;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        _localctx = new $371e898df891458a$export$11fec15307d2e17b(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 208;
                        this.jqlNumber();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        _localctx = new $371e898df891458a$export$b8b24f99f985ebb3(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 211;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $371e898df891458a$export$9c4772e191bdb810.STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                            case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 209;
                                this.jqlString();
                                break;
                            case $371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD:
                                this.state = 210;
                                this.jqlCustomField();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 216;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while(_la === $371e898df891458a$export$9c4772e191bdb810.LBRACKET){
                            this.state = 213;
                            this.jqlFieldProperty();
                            this.state = 218;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFieldProperty() {
            let _localctx = new $371e898df891458a$export$b02d0b6637ce0593(this._ctx, this.state);
            this.enterRule(_localctx, 34, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 221;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 222;
                this.jqlArgument();
                this.state = 223;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
                this.state = 228;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                    this.state = 225;
                    this.jqlPropertyArgument();
                    this.state = 230;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlCustomField() {
            let _localctx = new $371e898df891458a$export$401a038855cc5b15(this._ctx, this.state);
            this.enterRule(_localctx, 36, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 231;
                this.match($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD);
                this.state = 232;
                this.match($371e898df891458a$export$9c4772e191bdb810.LBRACKET);
                this.state = 233;
                this.match($371e898df891458a$export$9c4772e191bdb810.POSNUMBER);
                this.state = 234;
                this.match($371e898df891458a$export$9c4772e191bdb810.RBRACKET);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlString() {
            let _localctx = new $371e898df891458a$export$bde73d8ad7c8b71e(this._ctx, this.state);
            this.enterRule(_localctx, 38, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 236;
                _la = this._input.LA(1);
                if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNumber() {
            let _localctx = new $371e898df891458a$export$8737d94a1880e8b3(this._ctx, this.state);
            this.enterRule(_localctx, 40, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 238;
                _localctx._jqlNum = this._input.LT(1);
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.POSNUMBER || _la === $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOperand() {
            let _localctx = new $371e898df891458a$export$2eaac5a9828bf647(this._ctx, this.state);
            this.enterRule(_localctx, 42, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand);
            try {
                this.state = 244;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 240;
                        this.jqlEmpty();
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 241;
                        this.jqlValue();
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 242;
                        this.jqlFunction();
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 243;
                        this.jqlList();
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEmpty() {
            let _localctx = new $371e898df891458a$export$d85a062f90025e5c(this._ctx, this.state);
            this.enterRule(_localctx, 44, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 246;
                this.match($371e898df891458a$export$9c4772e191bdb810.EMPTY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValue() {
            let _localctx = new $371e898df891458a$export$2e17d457b0933bec(this._ctx, this.state);
            this.enterRule(_localctx, 46, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue);
            try {
                this.state = 250;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 248;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 249;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunction() {
            let _localctx = new $371e898df891458a$export$ebf0cc785e9ee41a(this._ctx, this.state);
            this.enterRule(_localctx, 48, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 252;
                this.jqlFunctionName();
                this.state = 253;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
                this.state = 255;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $371e898df891458a$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 254;
                    this.jqlArgumentList();
                }
                this.state = 257;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunctionName() {
            let _localctx = new $371e898df891458a$export$1f5f7ac816788f44(this._ctx, this.state);
            this.enterRule(_localctx, 50, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName);
            try {
                this.state = 261;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 259;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 260;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgumentList() {
            let _localctx = new $371e898df891458a$export$83d7c13849b931c3(this._ctx, this.state);
            this.enterRule(_localctx, 52, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 263;
                this.jqlArgument();
                this.state = 268;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 264;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 265;
                    this.jqlArgument();
                    this.state = 270;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlList() {
            let _localctx = new $371e898df891458a$export$9cb97a63f2be4864(this._ctx, this.state);
            this.enterRule(_localctx, 54, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 271;
                this.jqlListStart();
                this.state = 272;
                this.jqlOperand();
                this.state = 277;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 273;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 274;
                    this.jqlOperand();
                    this.state = 279;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 280;
                this.jqlListEnd();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListStart() {
            let _localctx = new $371e898df891458a$export$c419f717bfc46a5d(this._ctx, this.state);
            this.enterRule(_localctx, 56, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 282;
                this.match($371e898df891458a$export$9c4772e191bdb810.LPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListEnd() {
            let _localctx = new $371e898df891458a$export$f6cd3e372f5ab120(this._ctx, this.state);
            this.enterRule(_localctx, 58, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 284;
                this.match($371e898df891458a$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPropertyArgument() {
            let _localctx = new $371e898df891458a$export$e20ce4a2ed16372c(this._ctx, this.state);
            this.enterRule(_localctx, 60, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 286;
                this.jqlArgument();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgument() {
            let _localctx = new $371e898df891458a$export$a95583953c237f88(this._ctx, this.state);
            this.enterRule(_localctx, 62, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument);
            try {
                this.state = 290;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING:
                    case $371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 288;
                        this.jqlString();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.POSNUMBER:
                    case $371e898df891458a$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 289;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasPredicate() {
            let _localctx = new $371e898df891458a$export$9fa1e4d63f31b911(this._ctx, this.state);
            this.enterRule(_localctx, 64, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 295;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 292;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 293;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 294;
                        this.jqlUserPredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 297;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedPredicate() {
            let _localctx = new $371e898df891458a$export$e77e479a48133015(this._ctx, this.state);
            this.enterRule(_localctx, 66, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 303;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $371e898df891458a$export$9c4772e191bdb810.BEFORE:
                    case $371e898df891458a$export$9c4772e191bdb810.AFTER:
                    case $371e898df891458a$export$9c4772e191bdb810.ON:
                        this.state = 299;
                        this.jqlDatePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.DURING:
                        this.state = 300;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.BY:
                        this.state = 301;
                        this.jqlUserPredicateOperator();
                        break;
                    case $371e898df891458a$export$9c4772e191bdb810.FROM:
                    case $371e898df891458a$export$9c4772e191bdb810.TO:
                        this.state = 302;
                        this.jqlValuePredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 305;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDatePredicateOperator() {
            let _localctx = new $371e898df891458a$export$dc01290aee731418(this._ctx, this.state);
            this.enterRule(_localctx, 68, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 307;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $371e898df891458a$export$9c4772e191bdb810.BEFORE | 1 << $371e898df891458a$export$9c4772e191bdb810.AFTER | 1 << $371e898df891458a$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDateRangePredicateOperator() {
            let _localctx = new $371e898df891458a$export$75412b8b6a6442e1(this._ctx, this.state);
            this.enterRule(_localctx, 70, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 309;
                this.match($371e898df891458a$export$9c4772e191bdb810.DURING);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlUserPredicateOperator() {
            let _localctx = new $371e898df891458a$export$ad402332075c8656(this._ctx, this.state);
            this.enterRule(_localctx, 72, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 311;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValuePredicateOperator() {
            let _localctx = new $371e898df891458a$export$4239d7c0fbafd3f1(this._ctx, this.state);
            this.enterRule(_localctx, 74, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 313;
                _la = this._input.LA(1);
                if (!(_la === $371e898df891458a$export$9c4772e191bdb810.FROM || _la === $371e898df891458a$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPredicateOperand() {
            let _localctx = new $371e898df891458a$export$6b796c5a4b8c18e(this._ctx, this.state);
            this.enterRule(_localctx, 76, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 315;
                this.jqlOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrderBy() {
            let _localctx = new $371e898df891458a$export$534469b9c8f44139(this._ctx, this.state);
            this.enterRule(_localctx, 78, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 317;
                this.match($371e898df891458a$export$9c4772e191bdb810.ORDER);
                this.state = 318;
                this.match($371e898df891458a$export$9c4772e191bdb810.BY);
                this.state = 319;
                this.jqlSearchSort();
                this.state = 324;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $371e898df891458a$export$9c4772e191bdb810.COMMA){
                    this.state = 320;
                    this.match($371e898df891458a$export$9c4772e191bdb810.COMMA);
                    this.state = 321;
                    this.jqlSearchSort();
                    this.state = 326;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSearchSort() {
            let _localctx = new $371e898df891458a$export$c7d8f03f36952a46(this._ctx, this.state);
            this.enterRule(_localctx, 80, $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 327;
                this.jqlField();
                this.state = 329;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC) {
                    this.state = 328;
                    _la = this._input.LA(1);
                    if (!(_la === $371e898df891458a$export$9c4772e191bdb810.ASC || _la === $371e898df891458a$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        static{
            this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
        }
        static get _ATN() {
            if (!$371e898df891458a$export$9c4772e191bdb810.__ATN) $371e898df891458a$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($371e898df891458a$export$9c4772e191bdb810._serializedATN));
            return $371e898df891458a$export$9c4772e191bdb810.__ATN;
        }
    }
    class $371e898df891458a$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
        EOF() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EOF, 0);
        }
        jqlWhere() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4148a879cab28017);
        }
        jqlOrderBy() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$534469b9c8f44139);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlQuery;
        }
        enterRule(listener) {
            if (listener.enterJqlQuery) listener.enterJqlQuery(this);
        }
        exitRule(listener) {
            if (listener.exitJqlQuery) listener.exitJqlQuery(this);
        }
        accept(visitor) {
            if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWhere;
        }
        enterRule(listener) {
            if (listener.enterJqlWhere) listener.enterJqlWhere(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWhere) listener.exitJqlWhere(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
        jqlAndClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$f16819001158b9e);
            else return this.getRuleContext(i, $371e898df891458a$export$f16819001158b9e);
        }
        OR(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.OR);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.OR, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrClause;
        }
        enterRule(listener) {
            if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$5e9146f8d5cf1330);
            else return this.getRuleContext(i, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        AND(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.AND);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.AND, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlAndClause;
        }
        enterRule(listener) {
            if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$5e9146f8d5cf1330);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        BANG() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BANG, 0);
        }
        jqlSubClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a136a0e9655bfb04);
        }
        jqlTerminalClause() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$23486a2f2ddd5bcd);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNotClause;
        }
        enterRule(listener) {
            if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        jqlOrClause() {
            return this.getRuleContext(0, $371e898df891458a$export$d69831d387793480);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSubClause;
        }
        enterRule(listener) {
            if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        jqlTerminalClauseRhs() {
            return this.getRuleContext(0, $371e898df891458a$export$93924a205c12d32c);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClause;
        }
        enterRule(listener) {
            if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$c428f709a58396e5 extends $371e898df891458a$export$93924a205c12d32c {
        jqlEqualsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$41e475fc1988e413);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1b131204ef9fa33d extends $371e898df891458a$export$93924a205c12d32c {
        jqlLikeOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b76fe5387fdd7efd);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d83706ee80a9852a extends $371e898df891458a$export$93924a205c12d32c {
        jqlComparisonOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$d821da0716b3ec95);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2934b8ff22fddd2d extends $371e898df891458a$export$93924a205c12d32c {
        jqlInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$178478bfa8292f72);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlInClause) listener.enterJqlInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInClause) listener.exitJqlInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8b84310182afcf93 extends $371e898df891458a$export$93924a205c12d32c {
        jqlIsOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$e64c31d2830b66e4);
        }
        jqlEmpty() {
            return this.getRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$5df295dc7a2cac7c extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$7e283636700e4a6c);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9ac3367aee261b32 extends $371e898df891458a$export$93924a205c12d32c {
        jqlWasInOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$b9118b1ed9a78d66);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $371e898df891458a$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7a7defca8628a13c extends $371e898df891458a$export$93924a205c12d32c {
        jqlChangedOperator() {
            return this.getRuleContext(0, $371e898df891458a$export$493d626ed78ca66);
        }
        jqlChangedPredicate(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e77e479a48133015);
            else return this.getRuleContext(i, $371e898df891458a$export$e77e479a48133015);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
        EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.EQUALS, 0);
        }
        NOT_EQUALS() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_EQUALS, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
        LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LIKE, 0);
        }
        NOT_LIKE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT_LIKE, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlLikeOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
        LT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LT, 0);
        }
        GT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GT, 0);
        }
        LTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LTEQ, 0);
        }
        GTEQ() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.GTEQ, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
        IS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlIsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.WAS, 0);
        }
        IN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
        CHANGED() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CHANGED, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlField;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $371e898df891458a$export$11fec15307d2e17b extends $371e898df891458a$export$b33300c3d916229a {
        jqlNumber() {
            return this.getRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b8b24f99f985ebb3 extends $371e898df891458a$export$b33300c3d916229a {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlCustomField() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$401a038855cc5b15);
        }
        jqlFieldProperty(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$b02d0b6637ce0593);
            else return this.getRuleContext(i, $371e898df891458a$export$b02d0b6637ce0593);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
        LBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        RBRACKET() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        jqlPropertyArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$e20ce4a2ed16372c);
            else return this.getRuleContext(i, $371e898df891458a$export$e20ce4a2ed16372c);
        }
        jqlArgument() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFieldProperty;
        }
        enterRule(listener) {
            if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
        CUSTOMFIELD() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.CUSTOMFIELD, 0);
        }
        LBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LBRACKET, 0);
        }
        POSNUMBER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        RBRACKET() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RBRACKET, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlCustomField;
        }
        enterRule(listener) {
            if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
        STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.STRING, 0);
        }
        QUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.QUOTE_STRING, 0);
        }
        SQUOTE_STRING() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.SQUOTE_STRING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlString;
        }
        enterRule(listener) {
            if (listener.enterJqlString) listener.enterJqlString(this);
        }
        exitRule(listener) {
            if (listener.exitJqlString) listener.exitJqlString(this);
        }
        accept(visitor) {
            if (visitor.visitJqlString) return visitor.visitJqlString(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
        POSNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        NEGNUMBER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.NEGNUMBER, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlNumber;
        }
        enterRule(listener) {
            if (listener.enterJqlNumber) listener.enterJqlNumber(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumber) listener.exitJqlNumber(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
        jqlEmpty() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ebf0cc785e9ee41a);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$9cb97a63f2be4864);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlOperand) listener.enterJqlOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOperand) listener.exitJqlOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
        EMPTY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.EMPTY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlEmpty;
        }
        enterRule(listener) {
            if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValue;
        }
        enterRule(listener) {
            if (listener.enterJqlValue) listener.enterJqlValue(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValue) listener.exitJqlValue(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
        jqlFunctionName() {
            return this.getRuleContext(0, $371e898df891458a$export$1f5f7ac816788f44);
        }
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        jqlArgumentList() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$83d7c13849b931c3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunction;
        }
        enterRule(listener) {
            if (listener.enterJqlFunction) listener.enterJqlFunction(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunction) listener.exitJqlFunction(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlFunctionName;
        }
        enterRule(listener) {
            if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$a95583953c237f88);
            else return this.getRuleContext(i, $371e898df891458a$export$a95583953c237f88);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgumentList;
        }
        enterRule(listener) {
            if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
        jqlListStart() {
            return this.getRuleContext(0, $371e898df891458a$export$c419f717bfc46a5d);
        }
        jqlOperand(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$2eaac5a9828bf647);
            else return this.getRuleContext(i, $371e898df891458a$export$2eaac5a9828bf647);
        }
        jqlListEnd() {
            return this.getRuleContext(0, $371e898df891458a$export$f6cd3e372f5ab120);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlList;
        }
        enterRule(listener) {
            if (listener.enterJqlList) listener.enterJqlList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlList) listener.exitJqlList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlList) return visitor.visitJqlList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.LPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListStart;
        }
        enterRule(listener) {
            if (listener.enterJqlListStart) listener.enterJqlListStart(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListStart) listener.exitJqlListStart(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
        RPAREN() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlListEnd;
        }
        enterRule(listener) {
            if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument() {
            return this.getRuleContext(0, $371e898df891458a$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlArgument) listener.enterJqlArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgument) listener.exitJqlArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlWasPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$ad402332075c8656);
        }
        jqlValuePredicateOperator() {
            return this.tryGetRuleContext(0, $371e898df891458a$export$4239d7c0fbafd3f1);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
        AFTER() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.AFTER, 0);
        }
        BEFORE() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.BEFORE, 0);
        }
        ON() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ON, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
        DURING() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.DURING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
        FROM() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.FROM, 0);
        }
        TO() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.TO, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
        jqlOperand() {
            return this.getRuleContext(0, $371e898df891458a$export$2eaac5a9828bf647);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
        ORDER() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.ORDER, 0);
        }
        BY() {
            return this.getToken($371e898df891458a$export$9c4772e191bdb810.BY, 0);
        }
        jqlSearchSort(i) {
            if (i === undefined) return this.getRuleContexts($371e898df891458a$export$c7d8f03f36952a46);
            else return this.getRuleContext(i, $371e898df891458a$export$c7d8f03f36952a46);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($371e898df891458a$export$9c4772e191bdb810.COMMA);
            else return this.getToken($371e898df891458a$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlOrderBy;
        }
        enterRule(listener) {
            if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
            else return visitor.visitChildren(this);
        }
    }
    class $371e898df891458a$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $371e898df891458a$export$b33300c3d916229a);
        }
        DESC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.DESC, 0);
        }
        ASC() {
            return this.tryGetToken($371e898df891458a$export$9c4772e191bdb810.ASC, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $371e898df891458a$export$9c4772e191bdb810.RULE_jqlSearchSort;
        }
        enterRule(listener) {
            if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
            else return visitor.visitChildren(this);
        }
    }
});
parcelRegister("lKjSa", function(module, exports) {
    $parcel$export(module.exports, "JastBuilderErrorListener", ()=>$6eeebc6d04d5cc03$export$d0857f60ff1f385);
    var $k9iwN;
    var $gbJ9P;
    class $6eeebc6d04d5cc03$export$d0857f60ff1f385 {
        constructor(){
            this.errors = [];
            this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
                if (offendingSymbol === undefined) this.errors.push(new (0, (0, parcelRequire("k9iwN")).JQLParseError)(msg));
                else this.errors.push(new (0, (0, parcelRequire("gbJ9P")).JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
            };
        }
    }
});
parcelRegister("k9iwN", function(module, exports) {
    $parcel$export(module.exports, "JQLParseError", ()=>$c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b);
    class $c014cc1dfc254ce5$export$e8cfe2b2c93fbd4b extends Error {
        constructor(message, cause){
            super(message);
            this.name = 'JQLParseError';
            this.cause = cause;
            this.description = message;
        }
    }
});
parcelRegister("gbJ9P", function(module, exports) {
    $parcel$export(module.exports, "JQLSyntaxError", ()=>$59495a4ee8e45f22$export$3276184116160c41);
    var $k9iwN;
    class $59495a4ee8e45f22$export$3276184116160c41 extends (0, (0, parcelRequire("k9iwN")).JQLParseError) {
        constructor(message, start, stop, line, charPositionInLine){
            super(message);
            this.name = 'JQLSyntaxError';
            this.start = start;
            this.stop = stop;
            this.line = line;
            this.charPositionInLine = charPositionInLine;
        }
    }
});
parcelRegister("bK3p2", function(module, exports) {
    $parcel$export(module.exports, "QueryVisitor", ()=>$0cc7bd3e15dd4aeb$export$418003b930734805);
    var $iEIQF;
    var $flxWO;
    var $fcxPF;
    var $gW3lb;
    class $0cc7bd3e15dd4aeb$export$418003b930734805 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.whereVisitor = new (0, (0, parcelRequire("gW3lb")).WhereVisitor)(this.tokens);
            this.orderByVisitor = new (0, (0, parcelRequire("fcxPF")).OrderByVisitor)(this.tokens);
            this.visitJqlQuery = (ctx)=>{
                const whereContext = ctx.jqlWhere();
                const orderByContext = ctx.jqlOrderBy();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("flxWO", function(module, exports) {
    $parcel$export(module.exports, "JastBuildingVisitor", ()=>$4f91741519176bb0$export$d3c14d7188b09387);
    $parcel$export(module.exports, "getPositionFromToken", ()=>$4f91741519176bb0$export$85a4e6d858dbc6fb);
    $parcel$export(module.exports, "getPositionFromContext", ()=>$4f91741519176bb0$export$264629d4cd3cad3f);
    $parcel$export(module.exports, "getPositionsFromTerminalNodes", ()=>$4f91741519176bb0$export$30d51184879cbaa8);
    $parcel$export(module.exports, "normalizeText", ()=>$4f91741519176bb0$export$7c2714a5250b9239);
    class $4f91741519176bb0$export$d3c14d7188b09387 {
        constructor(tokens){
            this.tokens = tokens;
        }
        visit(tree) {
            throw new Error('Unsupported operation visit(ParseTree)');
        }
        visitChildren(node) {
            throw new Error('Unsupported operation visitChildren(RuleNode)');
        }
        visitErrorNode(node) {
            throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
        }
        visitTerminal(node) {
            throw new Error('Unsupported operation visitTerminal(TerminalNode)');
        }
    }
    const $4f91741519176bb0$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
            startToken.startIndex,
            (stopToken || startToken).stopIndex + 1
        ];
    const $4f91741519176bb0$export$264629d4cd3cad3f = (ctx)=>[
            ctx.start.startIndex,
            ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
        ];
    const $4f91741519176bb0$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$4f91741519176bb0$export$85a4e6d858dbc6fb(node.payload));
    const $4f91741519176bb0$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');
});
parcelRegister("fcxPF", function(module, exports) {
    $parcel$export(module.exports, "OrderByVisitor", ()=>$10359fbb24d00401$export$2774b71b99734811);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    class $10359fbb24d00401$export$2774b71b99734811 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.searchSortVisitor = new $10359fbb24d00401$var$SearchSortVisitor(this.tokens);
            this.visitJqlOrderBy = (ctx)=>{
                if (ctx.exception) return undefined;
                const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
                const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderBy(fields, operator, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $10359fbb24d00401$var$SearchSortVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens);
            this.visitJqlSearchSort = (ctx)=>{
                const fieldCtx = ctx.jqlField();
                if (fieldCtx.exception) return undefined;
                let direction;
                const desc = ctx.DESC();
                const asc = ctx.ASC();
                if (desc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(desc.payload));
                else if (asc !== undefined) direction = (0, (0, parcelRequire("iEIQF")).internalCreators).orderByDirection((0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(asc.payload));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("kzRYu", function(module, exports) {
    $parcel$export(module.exports, "notUndefined", ()=>$7297aaf6104af1ea$export$9a1adf421b69c6a);
    function $7297aaf6104af1ea$export$9a1adf421b69c6a(x) {
        return x !== undefined;
    }
});
parcelRegister("8sbD2", function(module, exports) {
    $parcel$export(module.exports, "FieldVisitor", ()=>$3b522eccd35764cb$export$c6a85c4c3bf2317d);
    var $iEIQF;
    var $31uE9;
    var $flxWO;
    var $gpYZF;
    class $3b522eccd35764cb$export$c6a85c4c3bf2317d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens);
            this.fieldPropertyVisitor = new $3b522eccd35764cb$var$FieldPropertyVisitor(this.tokens);
            this.visitJqlNumberField = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, undefined, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
            this.visitJqlNonNumberField = (ctx)=>{
                const stringContext = ctx.jqlString();
                const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).field(stringValue.value, stringValue.text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).field(text, text, properties, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$FieldPropertyVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens);
            this.propertyArgumentVisitor = new $3b522eccd35764cb$var$PropertyArgumentVisitor(this.tokens);
            this.visitJqlFieldProperty = (ctx)=>{
                const argumentContext = ctx.jqlArgument();
                const propertyArgumentContext = ctx.jqlPropertyArgument();
                const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $3b522eccd35764cb$var$PropertyArgumentVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens);
            this.visitJqlPropertyArgument = (ctx)=>{
                return ctx.jqlArgument().accept(this.argumentVisitor);
            };
        }
    }
});
parcelRegister("31uE9", function(module, exports) {
    $parcel$export(module.exports, "ArgumentVisitor", ()=>$11f58529c551c5c5$export$46b5a1f6d962d533);
    var $iEIQF;
    var $flxWO;
    var $gpYZF;
    class $11f58529c551c5c5$export$46b5a1f6d962d533 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens);
            this.visitJqlArgument = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).argument(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
});
parcelRegister("gpYZF", function(module, exports) {
    $parcel$export(module.exports, "StringVisitor", ()=>$15b8c92276e87e16$export$617850cb96304515);
    var $flxWO;
    class $15b8c92276e87e16$export$617850cb96304515 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlString = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                let value;
                if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
                else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
                else value = text;
                return {
                    text: text,
                    value: value,
                    position: position
                };
            };
        }
    }
});
parcelRegister("gW3lb", function(module, exports) {
    $parcel$export(module.exports, "WhereVisitor", ()=>$e8ab3cb2e5350018$export$c573472f1d20e15d);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $aSD70;
    class $e8ab3cb2e5350018$export$c573472f1d20e15d extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.terminalClauseVisitor = new (0, (0, parcelRequire("aSD70")).TerminalClauseVisitor)(this.tokens);
            this.visitJqlWhere = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
            this.visitJqlOrClause = (ctx)=>{
                const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.OR()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            };
            this.visitJqlAndClause = (ctx)=>{
                const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("iEIQF")).internalCreators).compoundOperator((0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97), (0, (0, parcelRequire("flxWO")).getPositionsFromTerminalNodes)(ctx.AND()));
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            };
            this.visitJqlNotClause = (ctx)=>{
                const notClauseContext = ctx.jqlNotClause();
                const subClauseContext = ctx.jqlSubClause();
                const terminalClauseContext = ctx.jqlTerminalClause();
                let clause;
                if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
                else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
                else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
                let notToken = ctx.NOT();
                notToken = notToken === undefined ? ctx.BANG() : notToken;
                if (notToken && clause) return (0, (0, parcelRequire("iEIQF")).internalCreators).notClause(clause, (0, (0, parcelRequire("iEIQF")).internalCreators).notClauseOperator((0, (0, parcelRequire("flxWO")).getPositionFromToken)(notToken.payload)), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                return clause;
            };
            this.visitJqlSubClause = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
        }
    }
});
parcelRegister("aSD70", function(module, exports) {
    $parcel$export(module.exports, "TerminalClauseVisitor", ()=>$059f8caffc466ad5$export$14576ae5bd1874a9);
    var $iEIQF;
    var $kzRYu;
    var $flxWO;
    var $8sbD2;
    var $dE1pq;
    var $hUHF5;
    var $3qoPC;
    class $059f8caffc466ad5$export$14576ae5bd1874a9 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.fieldVisitor = new (0, (0, parcelRequire("8sbD2")).FieldVisitor)(this.tokens);
            this.terminalClauseRhsVisitor = new $059f8caffc466ad5$var$TerminalClauseRhsVisitor(this.tokens);
            this.visitJqlTerminalClause = (ctx)=>{
                const field = ctx.jqlField().accept(this.fieldVisitor);
                const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).terminalClause(field, operator, operand, predicates, position);
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseRhsVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operatorVisitor = new (0, (0, parcelRequire("hUHF5")).OperatorVisitor)(this.tokens);
            this.terminalClauseOperandVisitor = new $059f8caffc466ad5$var$TerminalClauseOperandVisitor(this.tokens);
            this.predicateVisitor = new (0, (0, parcelRequire("3qoPC")).PredicateVisitor)(this.tokens);
            this.visitJqlEqualsClause = (ctx)=>{
                const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlLikeClause = (ctx)=>{
                const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlComparisonClause = (ctx)=>{
                const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlInClause = (ctx)=>{
                const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlIsClause = (ctx)=>{
                const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlWasClause = (ctx)=>{
                const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            };
            this.visitJqlWasInClause = (ctx)=>{
                const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            };
            this.visitJqlChangedClause = (ctx)=>{
                const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
                const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: predicates
                };
            };
            this.visitChildren = (node)=>{
                const operator = node.accept(this.operatorVisitor);
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: []
                };
            };
        }
    }
    class $059f8caffc466ad5$var$TerminalClauseOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens);
            this.visitJqlEqualsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlLikeClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlComparisonClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlIsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty()
                ]);
            };
            this.visitJqlWasClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlWasInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            };
            this.getOperandForContexts = (contexts)=>{
                const operandContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("dE1pq", function(module, exports) {
    $parcel$export(module.exports, "OperandVisitor", ()=>$f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af);
    var $iEIQF;
    var $kzRYu;
    var $31uE9;
    var $flxWO;
    var $h5KaL;
    var $gpYZF;
    class $f0dc0c50bebb9cb5$export$ef8ae1aa15d9c9af extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens);
            this.numberVisitor = new (0, (0, parcelRequire("h5KaL")).NumberVisitor)(this.tokens);
            this.functionNameVisitor = new $f0dc0c50bebb9cb5$var$FunctionNameVisitor(this.tokens);
            this.argumentListVisitor = new $f0dc0c50bebb9cb5$var$ArgumentListVisitor(this.tokens);
            this.visitJqlOperand = (ctx)=>{
                const operandContext = [
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ].find((0, (0, parcelRequire("kzRYu")).notUndefined));
                return operandContext?.accept(this);
            };
            this.visitJqlEmpty = (ctx)=>{
                if (ctx.exception) return undefined;
                return (0, (0, parcelRequire("iEIQF")).internalCreators).keywordOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd), (0, (0, parcelRequire("flxWO")).getPositionFromToken)(ctx.EMPTY().payload));
            };
            this.visitJqlValue = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
                }
                const numberContext = ctx.jqlNumber();
                if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
            };
            this.visitJqlList = (ctx)=>{
                const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, (0, parcelRequire("kzRYu")).notUndefined));
                return (0, (0, parcelRequire("iEIQF")).internalCreators).listOperand(values, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
            this.visitJqlFunction = (ctx)=>{
                const argumentListContext = ctx.jqlArgumentList();
                return (0, (0, parcelRequire("iEIQF")).internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$FunctionNameVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("gpYZF")).StringVisitor)(this.tokens);
            this.visitJqlFunctionName = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("iEIQF")).internalCreators).functionString(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
                }
            };
        }
    }
    class $f0dc0c50bebb9cb5$var$ArgumentListVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("31uE9")).ArgumentVisitor)(this.tokens);
            this.visitJqlArgumentList = (ctx)=>{
                return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
            };
        }
    }
});
parcelRegister("h5KaL", function(module, exports) {
    $parcel$export(module.exports, "NumberVisitor", ()=>$949fba49fb4026f9$export$a55432f0884633e4);
    var $iEIQF;
    var $flxWO;
    class $949fba49fb4026f9$export$a55432f0884633e4 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlNumber = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).valueOperand(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("hUHF5", function(module, exports) {
    $parcel$export(module.exports, "OperatorVisitor", ()=>$ce76282d2f3e5bd1$export$e56f89ba95b51d2a);
    var $iEIQF;
    var $dI0u8;
    var $flxWO;
    class $ce76282d2f3e5bd1$export$e56f89ba95b51d2a extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        visitJqlEqualsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlLikeOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlComparisonOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("dI0u8")).isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(text, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isInOperator)(value)) return undefined;
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlIsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlWasInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        visitJqlChangedOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
            if (!(0, (0, parcelRequire("dI0u8")).isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
            return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
        }
        constructor(...args){
            super(...args);
            this.visitChildren = (node)=>{
                const { sourceInterval: sourceInterval } = node;
                const text = this.tokens.getText(sourceInterval);
                if (text) {
                    const value = (0, (0, parcelRequire("flxWO")).normalizeText)(text);
                    const { a: startIndex, b: stopIndex } = sourceInterval;
                    const startToken = this.tokens.get(startIndex);
                    const stopToken = this.tokens.get(stopIndex);
                    const position = (0, (0, parcelRequire("flxWO")).getPositionFromToken)(startToken, stopToken);
                    if ((0, (0, parcelRequire("dI0u8")).isOperator)(value)) return (0, (0, parcelRequire("iEIQF")).internalCreators).operator(value, text, position);
                }
            };
        }
    }
});
parcelRegister("dI0u8", function(module, exports) {
    $parcel$export(module.exports, "isOperator", ()=>$ced3977476a8d3df$export$4e40859592ee7ac2);
    $parcel$export(module.exports, "isEqualsOperator", ()=>$ced3977476a8d3df$export$6d0fc196fa8a1673);
    $parcel$export(module.exports, "isLikeOperator", ()=>$ced3977476a8d3df$export$ad91b6d6a89cb64e);
    $parcel$export(module.exports, "isComparisonOperator", ()=>$ced3977476a8d3df$export$4477c442bd5c2a6d);
    $parcel$export(module.exports, "isInOperator", ()=>$ced3977476a8d3df$export$c5e1cdef30e30bff);
    $parcel$export(module.exports, "isIsOperator", ()=>$ced3977476a8d3df$export$ccc3334744e395c7);
    $parcel$export(module.exports, "isWasOperator", ()=>$ced3977476a8d3df$export$2b1c5d7e7856f91d);
    $parcel$export(module.exports, "isWasInOperator", ()=>$ced3977476a8d3df$export$55d8c9b20d99509f);
    $parcel$export(module.exports, "isChangedOperator", ()=>$ced3977476a8d3df$export$b65d23d23ade534b);
    $parcel$export(module.exports, "isListOperator", ()=>$ced3977476a8d3df$export$b09522e4061bbdd6);
    var $bzbto;
    const $ced3977476a8d3df$export$4e40859592ee7ac2 = (operator)=>(0, (0, parcelRequire("bzbto")).OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$6d0fc196fa8a1673 = (operator)=>(0, (0, parcelRequire("bzbto")).EQUALS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ad91b6d6a89cb64e = (operator)=>(0, (0, parcelRequire("bzbto")).LIKE_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$4477c442bd5c2a6d = (operator)=>(0, (0, parcelRequire("bzbto")).COMPARISON_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$c5e1cdef30e30bff = (operator)=>(0, (0, parcelRequire("bzbto")).IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$ccc3334744e395c7 = (operator)=>(0, (0, parcelRequire("bzbto")).IS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$2b1c5d7e7856f91d = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$55d8c9b20d99509f = (operator)=>(0, (0, parcelRequire("bzbto")).WAS_IN_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b65d23d23ade534b = (operator)=>(0, (0, parcelRequire("bzbto")).CHANGED_OPERATORS).includes(operator);
    const $ced3977476a8d3df$export$b09522e4061bbdd6 = (operator)=>(0, (0, parcelRequire("bzbto")).LIST_OPERATORS).includes(operator);
});
parcelRegister("3qoPC", function(module, exports) {
    $parcel$export(module.exports, "PredicateVisitor", ()=>$377f729dab70cce1$export$33bb52a35c693109);
    var $iEIQF;
    var $k75oj;
    var $kzRYu;
    var $flxWO;
    var $dE1pq;
    class $377f729dab70cce1$export$33bb52a35c693109 extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.predicateOperatorVisitor = new $377f729dab70cce1$var$PredicateOperatorVisitor(this.tokens);
            this.predicateOperandVisitor = new $377f729dab70cce1$var$PredicateOperandVisitor(this.tokens);
            this.visitJqlWasPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            };
            this.visitJqlChangedPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator(),
                    ctx.jqlValuePredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicate(operator, operand, position);
            };
            this.getOperatorForContexts = (contexts)=>{
                const operatorContext = contexts.find((0, (0, parcelRequire("kzRYu")).notUndefined));
                if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
                else throw new Error('Undefined predicate operator context');
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperatorVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlDatePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlDateRangePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlUserPredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlValuePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.getPredicateOperator = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const value = text.toLowerCase().replace(/\s+/g, ' ');
                if (!(0, (0, parcelRequire("k75oj")).isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
                return (0, (0, parcelRequire("iEIQF")).internalCreators).predicateOperator(value, text, (0, (0, parcelRequire("flxWO")).getPositionFromContext)(ctx));
            };
        }
    }
    class $377f729dab70cce1$var$PredicateOperandVisitor extends (0, (0, parcelRequire("flxWO")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operandVisitor = new (0, (0, parcelRequire("dE1pq")).OperandVisitor)(this.tokens);
            this.visitJqlPredicateOperand = (ctx)=>{
                return ctx.jqlOperand().accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("k75oj", function(module, exports) {
    $parcel$export(module.exports, "isPredicateOperator", ()=>$d2e5ca8020522bfa$export$188978ad94919403);
    var $2OsFJ;
    const $d2e5ca8020522bfa$export$188978ad94919403 = (operator)=>(0, (0, parcelRequire("2OsFJ")).PREDICATE_OPERATORS).includes(operator);
});
parcelRegister("2OsFJ", function(module, exports) {
    $parcel$export(module.exports, "PREDICATE_OPERATORS", ()=>$7ee5a5e33e4550f1$export$e200440af9f1d9f);
    const $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9 = 'after';
    const $7ee5a5e33e4550f1$export$f0a816341603bb63 = 'before';
    const $7ee5a5e33e4550f1$export$cdc81c84f768d513 = 'by';
    const $7ee5a5e33e4550f1$export$8a5280c65e704c3d = 'during';
    const $7ee5a5e33e4550f1$export$71f882dcac65f97a = 'from';
    const $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8 = 'on';
    const $7ee5a5e33e4550f1$export$5a83c4789e531a = 'to';
    const $7ee5a5e33e4550f1$export$e200440af9f1d9f = [
        $7ee5a5e33e4550f1$export$3d56e2ae1b4bbbf9,
        $7ee5a5e33e4550f1$export$f0a816341603bb63,
        $7ee5a5e33e4550f1$export$cdc81c84f768d513,
        $7ee5a5e33e4550f1$export$8a5280c65e704c3d,
        $7ee5a5e33e4550f1$export$71f882dcac65f97a,
        $7ee5a5e33e4550f1$export$5685a35c6b0a7ee8,
        $7ee5a5e33e4550f1$export$5a83c4789e531a
    ];
});
parcelRegister("eCBf9", function(module, exports) {
    $parcel$export(module.exports, "MutationError", ()=>$5fe48c9a5d56428c$export$10c788363424e94e);
    const $5fe48c9a5d56428c$export$bd0568a021288e41 = 'MutationError';
    class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.message = payload.message ?? '';
            this.extensions = payload.extensions;
            this.statusCode = payload.extensions?.statusCode ?? null;
        }
    }
});
parcelRegister("5csQm", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_MUTATION", ()=>$a7f1fb6ca1e2f180$export$f5c1cac020b22be4);
    $parcel$export(module.exports, "ISSUE_REFETCH_QUERY", ()=>$a7f1fb6ca1e2f180$export$834c81726d4c51eb);
    var $5cllN;
    var $kkA5E;
    var $848a3;
    const $a7f1fb6ca1e2f180$export$f5c1cac020b22be4 = (0, (0, parcelRequire("5cllN")).default)`
mutation JWMCalendarInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!){
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CalendarViewItem
        }
        ...CreateIssueFragment
    }
}
${(0, (0, parcelRequire("kkA5E")).CREATE_ISSUE_FRAGMENT)}
${(0, (0, parcelRequire("848a3")).VIEW_ITEM_FRAGMENT)}
`;
    const $a7f1fb6ca1e2f180$export$834c81726d4c51eb = (0, (0, parcelRequire("5cllN")).default)`
query JWMCalendarInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {    
                        ...CalendarViewItem
                    }
                }
            }        
        }
    }
}
${(0, (0, parcelRequire("848a3")).VIEW_ITEM_FRAGMENT)}
`;
});
parcelRegister("kkA5E", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", ()=>$22484cc131c517f0$export$47232071d0e9dfb);
    var $5cllN;
    const $22484cc131c517f0$export$47232071d0e9dfb = (0, (0, parcelRequire("5cllN")).default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;
});
parcelRegister("848a3", function(module, exports) {
    $parcel$export(module.exports, "VIEW_ITEM_FRAGMENT", ()=>$69990e2f8d0d6019$export$a6e6e2287400dfc7);
    $parcel$export(module.exports, "QUERY", ()=>$69990e2f8d0d6019$export$2b91517d6d5b4365);
    var $5cllN;
    const $69990e2f8d0d6019$export$a6e6e2287400dfc7 = (0, (0, parcelRequire("5cllN")).default)`
  fragment CalendarViewItem on JiraWorkManagementViewItem {
    __typename
    id
    issueId
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      __typename
      ... on JiraDatePickerField {
        fieldId
        aliasFieldId
        name
        date
        fieldConfig {
          isEditable
        }
      }
      ...on JiraSingleLineTextField {
        fieldId
        aliasFieldId
        name
        text
        type
        fieldConfig {
          isEditable
        }
      }
      ...on JiraIssueTypeField {
        fieldId
        name
        issueType {
          issueTypeId
          name
          type
          avatar {
            medium
          }
        }
      }
      ...on JiraPriorityField {
        fieldId
        name
        priority {
          name
          priorityId
          iconUrl
        }
      }
      ... on JiraStatusField {
        fieldId
        name
        status {
          name
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraSingleSelectUserPickerField {
        fieldId
        aliasFieldId
        user {
          picture
          name
          accountId
          accountStatus
          __typename
        }
        fieldConfig {
          isEditable
        }
      }
    }
  }
`;
    const $69990e2f8d0d6019$export$2b91517d6d5b4365 = (0, (0, parcelRequire("5cllN")).default)`
  query JWMCalendarPaginatedItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "calendarList", filter:["jql"]) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${$69990e2f8d0d6019$export$a6e6e2287400dfc7}
`;
    const $69990e2f8d0d6019$export$40748511f99d6ef9 = (0, (0, parcelRequire("5cllN")).default)`
  query JWMCalendarItemDetails($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
        }
      }
    }
  }
  ${$69990e2f8d0d6019$export$a6e6e2287400dfc7}
`;
});
parcelRegister("19env", function(module, exports) {
    $parcel$export(module.exports, "buildInput", ()=>$5ffd07761d34326f$export$f4db126e014728a3);
    var $5fc53;
    var $1p96B;
    const $5ffd07761d34326f$export$f4db126e014728a3 = (input, locale, startDateField)=>{
        const singleLineTextFields = [
            {
                fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                text: input.summary
            }
        ];
        const datePickerFields = [];
        if (input.startDate && startDateField?.id) datePickerFields.push({
            fieldId: startDateField?.id,
            date: {
                formattedDate: (0, (0, parcelRequire("1p96B")).formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
            }
        });
        if (input.dueDate) datePickerFields.push({
            fieldId: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
            date: {
                formattedDate: (0, (0, parcelRequire("1p96B")).formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
            }
        });
        const fields = {
            singleLineTextFields: singleLineTextFields,
            datePickerFields: datePickerFields
        };
        const result = {
            projectId: input.projectId,
            issueType: input.issueType.id,
            fields: fields
        };
        return result;
    };
});
parcelRegister("detXF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa6a45e1b755aae0$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $34ck9 = parcelRequire("34ck9");
    var $e5UFT;
    var $9uFES;
    var $fHusM;
    var $f9ece;
    var $pyK8a;
    var $1dJ6S;
    var $fNobW;
    var $bG3pQ;
    var $hE5wF;
    var $54qG5;
    var $5YBrl;
    var $e21nk;
    var $cm8b5;
    var $6sVa1;
    var $3qoA4;
    var $cLGgz;
    var $asqbQ;
    var $3kVj2;
    var $ksKCJ;
    var $kzL7M;
    var $8HvEs;
    var $7Wnap;
    var $kI8fv;
    var $7yduy;
    var $co1wz;
    var $467lJ;
    var $LJaTB;
    var $koVbs;
    var $2gCtH;
    var $cE2Qr;
    var $4kK95;
    var $2OMDV;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $9BwsJ;
    var $dAmbh;
    var $g5X3G;
    var $3t5QD;
    var $2Qe3m;
    var $4O2fF;
    var $DVljb;
    var $ieDtd;
    var $f42Sq;
    var $65zj8;
    var $8qzrN;
    var $RHNrk;
    var $l06k4;
    var $3H67w;
    var $2f0va;
    var $iHu7r;
    var $jQtQM;
    var $7w6wS;
    var $1gwj3;
    var $NqSu5;
    var $8fX1C;
    var $82SCS;
    var $86Mrh;
    var $hdHHP;
    const $aa6a45e1b755aae0$export$e4933234e34e8d88 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('calendarView', {
        dateClick: 'clicked',
        eventDrop: 'dragged issue',
        eventResize: 'resized issue',
        select: 'dragged selection'
    })((0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...otherProps }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e5UFT")).default), {
            ref: ref,
            ...otherProps
        })));
    const $aa6a45e1b755aae0$var$FULL_CALENDAR_PLUGINS = [
        (0, (0, parcelRequire("9uFES")).default),
        (0, (0, parcelRequire("fHusM")).default)
    ];
    const $aa6a45e1b755aae0$var$CalendarView = ()=>{
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarWrapperRef = (0, $5uXOq.useRef)(null);
        const isPopoverOpen = (0, $5uXOq.useRef)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const [hasItemRequirements, setHasItemRequirements] = (0, $5uXOq.useState)(false);
        const [projectState] = (0, (0, parcelRequire("cE2Qr")).useProjectState)();
        const { hasInlineCreate: hasInlineCreate, hasOnboarding: hasOnboarding, issueViewInteraction: issueViewInteraction, featureView: featureView, hasSoftwareReleases: hasSoftwareReleases, hasScheduleIssues: hasScheduleIssues } = (0, (0, parcelRequire("l06k4")).useCalendarFeatures)();
        const [selectedIssueKey, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const viewMode = (0, (0, parcelRequire("2gCtH")).useViewMode)();
        const isViewModeSideBar = viewMode === 'SIDEBAR';
        const pageHeading = formatMessage((0, (0, parcelRequire("8fX1C")).default).calendarHeading);
        const [calendarViewRangeDateOnly, setCalendarViewRangeDateOnly] = (0, $5uXOq.useState)((0, (0, parcelRequire("hdHHP")).getInitialCalendarViewRangeDateOnly)());
        const { isUnscheduledSidebarOpen: isUnscheduledSidebarOpen, onClickUnscheduledButton: onClickUnscheduledButton, showIssueFromUnscheduledSidebar: showIssueFromUnscheduledSidebar } = (0, (0, parcelRequire("3H67w")).useUnscheduledSidebar)({
            UnscheduledSidebar: (0, parcelRequire("86Mrh")).default,
            cleanSelectedIssueKey: setSelectedIssueKey
        });
        const [weekStartDay] = (0, (0, parcelRequire("iHu7r")).useWeekStartDay)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const request = (0, $5uXOq.useMemo)(()=>({
                jqlContext: jqlContext,
                startDate: calendarViewRangeDateOnly.activeRange.start,
                endDate: calendarViewRangeDateOnly.activeRange.end
            }), [
            calendarViewRangeDateOnly,
            jqlContext
        ]);
        const { issues: issues, loading: areIssuesLoading, error: issuesError, refetch: issuesRefetch, setOptimisticItem: setOptimisticItem, analyticsAttributes: issuesAnalyticsAttributes } = (0, (0, parcelRequire("8qzrN")).useCalendarIssues)(request);
        const projectContext = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldShowMultiProjectEpMessage = (projectContext?.data?.isProjectAdmin ?? true) && hasSoftwareReleases;
        const { calendarReleasesData: { releases: releases, isLoading: areReleasesLoading }, CalendarReleasesInitializer: CalendarReleasesInitializer, analyticsAttributes: releasesAnalyticsAttributes } = (0, (0, parcelRequire("65zj8")).useCalendarReleasesForMultipleProjectsInitializer)({
            releaseDateBefore: calendarViewRangeDateOnly.activeRange.start,
            releaseDateAfter: calendarViewRangeDateOnly.activeRange.end
        });
        const loading = areIssuesLoading || areReleasesLoading;
        const [placeholder, setPlaceholder] = (0, $5uXOq.useState)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, (0, parcelRequire("cm8b5")).useQueryBasedViewAutomaticTracking)((0, (0, parcelRequire("f42Sq")).MAIN_EXPERIENCE), {
            loading: loading,
            error: issuesError
        });
        const { loading: startDateFieldLoading } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        (0, $5uXOq.useEffect)(()=>{
            if (!hasOnboarding || hasItemRequirements === true || issues.length < 3) return;
            let count = 0;
            issues.some((issue)=>{
                if (issue?.extendedProps?.issue?.duedate != null) count += 1;
                if (count === 3) setHasItemRequirements(true);
                return count === 3;
            });
        }, [
            issues,
            hasItemRequirements,
            hasOnboarding
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onClickOutsideCalendar = (event)=>{
                if (event.target instanceof Node && !calendarWrapperRef?.current?.contains(event.target)) isPopoverOpen.current = false;
            };
            if (typeof document !== 'undefined') document.addEventListener('mousedown', onClickOutsideCalendar);
            return ()=>{
                if (typeof document !== 'undefined') document.removeEventListener('mousedown', onClickOutsideCalendar);
            };
        }, []);
        const updateDates = (0, (0, parcelRequire("2f0va")).useUpdateDates)();
        const [isSaving, setIsSaving] = (0, $5uXOq.useState)(false);
        const onEventChange = (0, $5uXOq.useCallback)(async ({ event: event, revert: revert }, analyticsEvent)=>{
            const { issue: issue } = event.extendedProps;
            if (!issue) return;
            const newStartDate = event.startStr;
            let newDueDate = event.startStr;
            if (!(0, ($parcel$interopDefault($gccSB)))(event.endStr)) {
                const endDateMinusOneDay = (0, (0, parcelRequire("pyK8a")).default)(new Date(event.endStr), 1);
                newDueDate = (0, (0, parcelRequire("f9ece")).default)(endDateMinusOneDay, 'UTC', 'yyyy-MM-dd');
            }
            setIsSaving(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
            try {
                await updateDates({
                    issueKey: issue.key,
                    issueId: issue.id,
                    newStartDate: newStartDate,
                    newDueDate: newDueDate
                });
                await issuesRefetch();
            } catch (e) {
                revert();
            }
            setIsSaving(false);
        }, [
            issuesRefetch,
            updateDates
        ]);
        const isDragging = (0, $5uXOq.useRef)(false);
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            isDragging.current = true;
        }, []);
        const onDragStop = (0, $5uXOq.useCallback)(()=>{
            isDragging.current = false;
            isPopoverOpen.current = false;
        }, []);
        const isResizing = (0, $5uXOq.useRef)(false);
        const onResizeStart = (0, $5uXOq.useCallback)(()=>{
            isResizing.current = true;
        }, []);
        const onResizeStop = (0, $5uXOq.useCallback)(()=>{
            isResizing.current = false;
        }, []);
        const [isCreating, setIsCreating] = (0, $5uXOq.useState)(false);
        const onCreatingStart = (0, $5uXOq.useCallback)(()=>{
            setIsCreating(true);
        }, []);
        const onCreatingStop = (0, $5uXOq.useCallback)(()=>{
            setIsCreating(false);
        }, []);
        const isEditing = isDragging.current || isResizing.current || isSaving;
        const { dayCellDidMount: dayCellDidMount } = (0, (0, parcelRequire("RHNrk")).useDragUnscheduledItem)({
            setPlaceholder: setPlaceholder,
            refetch: issuesRefetch,
            setIsSaving: setIsSaving,
            calendarWrapperRef: calendarWrapperRef
        });
        const allItems = (0, $5uXOq.useMemo)(()=>placeholder ? [
                ...issues,
                placeholder
            ] : [
                ...issues
            ], [
            issues,
            placeholder
        ]);
        const mappedItems = (0, $5uXOq.useRef)(allItems);
        if (!isEditing) mappedItems.current = allItems;
        const refresh = (0, $5uXOq.useCallback)(()=>{
            if (!isEditing && !isCreating) issuesRefetch();
        }, [
            isEditing,
            isCreating,
            issuesRefetch
        ]);
        const updateStartEndDate = (0, $5uXOq.useCallback)(()=>{
            if (calendarRef.current) {
                const { currentRange: currentRange, activeRange: activeRange } = (0, (0, parcelRequire("hdHHP")).getFullCalendarDateProfile)(calendarRef.current.getApi());
                const updatedCalendarViewRangeDateOnly = {
                    currentRange: {
                        start: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(currentRange.start),
                        end: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(currentRange.end)
                    },
                    activeRange: {
                        start: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(activeRange.start),
                        end: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(activeRange.end)
                    }
                };
                if (updatedCalendarViewRangeDateOnly.currentRange.start.getMonth() === calendarViewRangeDateOnly.currentRange.start.getMonth()) return;
                setCalendarViewRangeDateOnly(updatedCalendarViewRangeDateOnly);
            }
        }, [
            calendarViewRangeDateOnly.currentRange.start
        ]);
        const onNextClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            let monthsFromToday = 0;
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                calendarApi.next();
                updateStartEndDate();
                const { currentRange: currentRange } = (0, (0, parcelRequire("hdHHP")).getFullCalendarDateProfile)(calendarApi);
                monthsFromToday = (0, (0, parcelRequire("hdHHP")).monthsBetweenCurrentDateOnly)((0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(currentRange.start));
            }
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'calendarHeaderNext', {
                monthsFromToday: monthsFromToday
            });
        }, [
            updateStartEndDate
        ]);
        const onPrevClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            let monthsFromToday = 0;
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                calendarApi.prev();
                updateStartEndDate();
                const { currentRange: currentRange } = (0, (0, parcelRequire("hdHHP")).getFullCalendarDateProfile)(calendarApi);
                monthsFromToday = (0, (0, parcelRequire("hdHHP")).monthsBetweenCurrentDateOnly)((0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(currentRange.start));
            }
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'calendarHeaderPrevious', {
                monthsFromToday: monthsFromToday
            });
        }, [
            updateStartEndDate
        ]);
        const onTodayClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            if (calendarRef.current) {
                calendarRef.current.getApi().today();
                updateStartEndDate();
            }
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'calendarHeaderToday', {
                monthsFromToday: 0
            });
        }, [
            updateStartEndDate
        ]);
        const onDragSelect = (0, $5uXOq.useCallback)(({ startStr: startStr, endStr: endStr }, analyticsEvent)=>{
            if (startDateFieldLoading) return;
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                calendarApi.unselect();
            }
            if (isPopoverOpen.current === true) {
                isPopoverOpen.current = false;
                return;
            }
            setPlaceholder({
                allDay: true,
                start: startStr,
                end: endStr
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dates', {
                startDate: startStr,
                endDate: endStr
            });
        }, [
            startDateFieldLoading
        ]);
        const onModalIssueClose = (0, $5uXOq.useCallback)(()=>{
            setSelectedIssueKey(undefined);
        }, [
            setSelectedIssueKey
        ]);
        const throttledUpdateCalendarSize = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($34ck9)))(()=>{
                if (!calendarRef.current) return;
                calendarRef.current.getApi().updateSize();
            }, 100), [
            calendarRef
        ]);
        (0, (0, parcelRequire("kI8fv")).useResizeObserver)(calendarWrapperRef.current, throttledUpdateCalendarSize);
        const onCalendarIssueClick = (0, $5uXOq.useCallback)((issueKey)=>{
            if (!issueKey) return;
            if (issueViewInteraction === 'openNewTab') {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'calendarEmbedIssue');
                (0, (0, parcelRequire("bG3pQ")).openViewFromEmbed)({
                    key: (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
                    value: issueKey
                });
            } else setSelectedIssueKey(issueKey);
        }, [
            createAnalyticsEvent,
            issueViewInteraction,
            setSelectedIssueKey
        ]);
        const notifyIssueEvent = (0, (0, parcelRequire("asqbQ")).useIssueEvents)(refresh);
        const onRealtimeEvent = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("3qoA4")).isIssueEvent)(event)) notifyIssueEvent?.(Number(event.payload.issueId));
        }, [
            notifyIssueEvent
        ]);
        const calendarViews = (0, $5uXOq.useMemo)(()=>({
                dayGridMonth: {
                    dayMaxEvents: 3,
                    dayCellDidMount: dayCellDidMount,
                    dayCellContent: (dayCellInfo)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3t5QD")).ConditionalNudgeWrapper), {
                            conditionsToApplyWrapper: dayCellInfo.isToday && !isPopoverOpen.current,
                            Wrapper: (0, (0, parcelRequire("co1wz")).ff)('jwm.onboarding.trello-cross-flow') && !projectState?.isSampleProject ? (0, (0, parcelRequire("2Qe3m")).AddItemsCalendarNudgeAsync) : (0, (0, parcelRequire("4O2fF")).AddItemsCalendarNudgeAsync)
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$var$DateWrapper, {
                            isToday: dayCellInfo.isToday
                        }, dayCellInfo.date.getDate())),
                    dayHeaderContent: (dayHeaderInfo)=>(0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$export$468356b44a1d875e, null, dayHeaderInfo.text),
                    moreLinkContent: (moreLinkInfo)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jQtQM")).EventWrapper), {
                            backgroundColor: "transparent",
                            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
                            hoverColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`
                        }, moreLinkInfo.text),
                    dayPopoverFormat: {
                        weekday: 'short'
                    },
                    moreLinkClick: ()=>{
                        isPopoverOpen.current = true;
                        return 'popover';
                    }
                }
            }), [
            dayCellDidMount,
            projectState?.isSampleProject
        ]);
        const renderEventContent = (0, $5uXOq.useCallback)((eventInfo)=>{
            const { event: event } = eventInfo;
            const issue = event.extendedProps?.issue;
            if (issue) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jQtQM")).CalendarIssue), {
                issue: issue,
                onClick: ()=>onCalendarIssueClick(issue.key)
            });
            const release = event.extendedProps?.release;
            if (release) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("NqSu5")).default), {
                releaseRef: release
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7w6wS")).default), {
                withInlineCreate: eventInfo.isStart && !eventInfo.isMirror,
                startStr: event.startStr,
                endStr: event.endStr,
                setOptimisticItem: setOptimisticItem,
                onDismiss: ()=>setPlaceholder(null),
                request: request,
                onCreatingStart: onCreatingStart,
                onCreatingStop: onCreatingStop
            });
        }, [
            setOptimisticItem,
            request,
            onCreatingStart,
            onCreatingStop,
            onCalendarIssueClick
        ]);
        const onPageVisibilityChange = (0, $5uXOq.useCallback)(({ isVisible: isVisible })=>{
            if (isVisible) refresh();
        }, [
            refresh
        ]);
        const bentoView = (0, $5uXOq.useMemo)(()=>selectedIssueKey != null && (!isViewModeSideBar || showIssueFromUnscheduledSidebar) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kVj2")).default), {
                issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(selectedIssueKey),
                onClose: onModalIssueClose,
                viewModeSwitchDisabled: showIssueFromUnscheduledSidebar
            }), [
            onModalIssueClose,
            isViewModeSideBar,
            selectedIssueKey,
            showIssueFromUnscheduledSidebar
        ]);
        const eventSources = (0, $5uXOq.useMemo)(()=>[
                mappedItems.current,
                releases
            ], [
            releases,
            mappedItems.current
        ]);
        const onEventDataTransform = (0, $5uXOq.useCallback)((event)=>{
            const issue = event?.extendedProps?.issue;
            if (issue) {
                const isDraggingAllowed = !(0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(issue.id);
                return {
                    ...event,
                    editable: isDraggingAllowed
                };
            }
            return event;
        }, []);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                ...releasesAnalyticsAttributes,
                ...issuesAnalyticsAttributes
            }), [
            issuesAnalyticsAttributes,
            releasesAnalyticsAttributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "calendar-view",
            hold: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).RenderStartMark), {
            view: featureView,
            loading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e21nk")).BusinessDocumentTitle), {
            pageHeading: pageHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("82SCS")).Toolbar), {
            onNextClick: onNextClick,
            onPrevClick: onPrevClick,
            onTodayClick: onTodayClick,
            onUnscheduledClick: onClickUnscheduledButton,
            isUnscheduledSidebarOpen: isUnscheduledSidebarOpen,
            isDisabled: loading,
            currentViewStartDateOnly: calendarViewRangeDateOnly.currentRange.start
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$var$CalendarWrapper, {
            "data-testid": "business-calendar.ui.calendar-view.calendar-wrapper"
        }, (loading || !isViewModeSideBar && selectedIssueKey != null || isSaving) && (0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$var$LoadingWrapper, {
            "data-testid": "business-calendar.ui.calendar-view.loading-wrapper"
        }), issuesError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
            flag: (0, (0, parcelRequire("467lJ")).default).genericError()
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: calendarWrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9BwsJ")).ReleaseFlyoutUFOContextProvider), {
            location: "calendar",
            suffixKey: "business"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$export$e4933234e34e8d88, {
            ref: calendarRef,
            timeZone: "local",
            locale: locale.replace('_', '-'),
            headerToolbar: false,
            plugins: $aa6a45e1b755aae0$var$FULL_CALENDAR_PLUGINS,
            initialView: "dayGridMonth",
            aspectRatio: 1.75,
            handleWindowResize: false,
            height: "auto",
            editable: placeholder == null && hasScheduleIssues,
            eventBorderColor: "transparent",
            eventBackgroundColor: "transparent",
            eventDataTransform: onEventDataTransform,
            eventDrop: onEventChange,
            eventResize: onEventChange,
            eventDragStart: onDragStart,
            eventDragStop: onDragStop,
            eventResizeStart: onResizeStart,
            eventResizeStop: onResizeStop,
            eventResizableFromStart: true,
            initialDate: calendarViewRangeDateOnly.currentRange.start.toLocalDate(),
            views: calendarViews,
            eventSources: eventSources,
            eventOrder: (0, (0, parcelRequire("hdHHP")).calendarEventOrderSort),
            eventContent: renderEventContent,
            firstDay: weekStartDay,
            selectable: true,
            select: hasInlineCreate ? onDragSelect : undefined
        }))), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "calendar viewed",
            attributes: analyticsAttributes
        })), isViewModeSideBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ksKCJ")).SidebarIssueView), {
            issueKey: showIssueFromUnscheduledSidebar ? undefined : selectedIssueKey,
            onClose: onModalIssueClose,
            analyticsSource: (0, $fcf97b7a09088940$export$82540942fb014b0a)
        }), bentoView, shouldShowMultiProjectEpMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gwj3")).CalendarReleaseMultiProjectOnboardingModal), null), hasSoftwareReleases && (0, ($parcel$interopDefault($5uXOq))).createElement(CalendarReleasesInitializer, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sVa1")).GqlsRealtime), {
            appId: "business-calendar",
            entityId: entity?.id,
            onReceive: onRealtimeEvent
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kzL7M")).PageVisibility), {
            onChange: onPageVisibilityChange
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8HvEs")).PerformanceAnalytics), {
            view: featureView,
            loading: loading
        }), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yduy")).JWMSpaStatePageReady), null));
    };
    var $aa6a45e1b755aae0$export$2e2bcd8739ae039 = $aa6a45e1b755aae0$var$CalendarView;
    const $aa6a45e1b755aae0$export$468356b44a1d875e = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($aa6a45e1b755aae0$var$DayHeaderTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall",
            as: "div"
        }, children));
    const $aa6a45e1b755aae0$var$CalendarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1j86c5bs _syaz1fxt _bfhkvuon _2rkoftgi _16jlkb7n _1o9zkb7n _i0dl1wug _1reo1wug _18m91wug _1yt4h8dc _kqswh2mm _ajd4vuon _138hidpf _1d34idpf _d1qtidpf _1806idpf _1v6yvuon _onqm1h6o _8zxmh2mm _9nd8kb7n _x0vfglyw _1x4midpf _7quqidpf _1rdpidpf _mnsfidpf _ao3r1a45 _d83918uv _uk1oglyw _teienqa1 _2k8yglyw _uurd11ux _8x1qd3j3 _bwo418uv _89yfglyw _mwjcnqa1 _8y7b15vq _1hpu15vq _113x1l2s _4b3i1q9c _1twx1ule _784a18uv _i5keglyw _1te1nqa1 _f07ac2ym _14v4glyw _76ga5szm _1m4u1bhr _16e41mxi _c3ns1y44 _ulpv1ck0 _1v3a1rc1 _1yi3p3fh _hfnaglyw _1bfu1l7b _1h5n1xoy _1oknhp5a _ozxs1wug _1yjt1wug _hxjv1wug _y4wo1wug _f57pangw _1v4316g6 _5o3midpf _10zmglyw _utp218iy _1d1jhp5a _3u6l1bk4 _o7tnqdok _1d5m1joy _1t05n7od _8cty1txw _1ddo1h6o _1jzu1h6o _1kqfidpf _1qyaidpf _1m9aidpf _9z73idpf",
                __cmplp.className
            ])
        });
    });
    const $aa6a45e1b755aae0$var$DateWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isToday: isToday, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c816g6 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _2rko1ul9 _80omtlke",
                __cmplp.isToday ? "_bfhkgkf6" : "_bfhk18uv",
                __cmplp.isToday ? "_syaz15cr" : "_syaz1a45",
                __cmplp.isToday ? "_irr3gkf6" : "_irr314ae",
                __cmplp.className
            ])
        });
    });
    const $aa6a45e1b755aae0$var$DayHeaderTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1p1dangw _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $aa6a45e1b755aae0$var$LoadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1xi2idpf _1ltvidpf _bfhk987y _1pbyqfx8",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e5UFT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a42d7eb8764e47c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5nZSg;
    var $Jd88K;
    class $a42d7eb8764e47c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(){
            super(...arguments);
            this.elRef = (0, $5uXOq.createRef)();
            this.needsCustomRenderingResize = false;
            this.isInitialRender = true;
            this.state = {
                customRenderingMap: new Map()
            };
        }
        render() {
            const portalNodes = [];
            for (const customRendering of this.state.customRenderingMap.values()){
                const { generatorMeta: generatorMeta } = customRendering;
                const vnode = typeof generatorMeta === 'function' ? generatorMeta(customRendering.renderProps) : generatorMeta;
                portalNodes.push((0, $7nsd3.createPortal)(vnode, customRendering.containerEl, customRendering.id));
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.elRef
            }, portalNodes);
        }
        componentDidMount() {
            const customRenderingStore = new (0, (0, parcelRequire("Jd88K")).cy)();
            this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
            this.calendar = new (0, (0, parcelRequire("5nZSg")).Calendar)(this.elRef.current, Object.assign(Object.assign({}, this.props), {
                handleCustomRendering: this.handleCustomRendering
            }));
            this.calendar.render();
            customRenderingStore.subscribe((customRenderingMap)=>{
                if (this.isInitialRender) this.doCustomRendering(customRenderingMap);
                else this.requestCustomRendering(customRenderingMap);
            });
        }
        requestCustomRendering(customRenderingMap) {
            this.cancelCustomRendering();
            this.customRenderingRequestId = requestAnimationFrame(()=>{
                $a42d7eb8764e47c9$export$2e2bcd8739ae039.act(()=>{
                    this.doCustomRendering(customRenderingMap);
                });
            });
        }
        doCustomRendering(customRenderingMap) {
            this.needsCustomRenderingResize = true;
            this.setState({
                customRenderingMap: customRenderingMap
            });
        }
        cancelCustomRendering() {
            if (this.customRenderingRequestId) {
                cancelAnimationFrame(this.customRenderingRequestId);
                this.customRenderingRequestId = undefined;
            }
        }
        componentDidUpdate() {
            this.isInitialRender = false;
            this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), {
                handleCustomRendering: this.handleCustomRendering
            }));
            if (this.needsCustomRenderingResize) {
                this.needsCustomRenderingResize = false;
                this.calendar.updateSize();
            }
        }
        componentWillUnmount() {
            this.calendar.destroy();
            this.cancelCustomRendering();
        }
        getApi() {
            return this.calendar;
        }
    }
    $a42d7eb8764e47c9$export$2e2bcd8739ae039.act = (f)=>{
        f();
    };
});
parcelRegister("5nZSg", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$3ebf18a91682a4bf$export$ae829ec7b2625219);
    $parcel$export(module.exports, "Calendar", ()=>$3ebf18a91682a4bf$export$e1aef45b828286de);
    var $Jd88K;
    var $77d02 = parcelRequire("77d02");
    parcelRequire("j8P0R");
    const $3ebf18a91682a4bf$export$794e7bef9c0b12d9 = [];
    const $3ebf18a91682a4bf$var$MINIMAL_RAW_EN_LOCALE = {
        code: 'en',
        week: {
            dow: 0,
            doy: 4
        },
        direction: 'ltr',
        buttonText: {
            prev: 'prev',
            next: 'next',
            prevYear: 'prev year',
            nextYear: 'next year',
            year: 'year',
            today: 'today',
            month: 'month',
            week: 'week',
            day: 'day',
            list: 'list'
        },
        weekText: 'W',
        weekTextLong: 'Week',
        closeHint: 'Close',
        timeHint: 'Time',
        eventHint: 'Event',
        allDayText: 'all-day',
        moreLinkText: 'more',
        noEventsText: 'No events to display'
    };
    const $3ebf18a91682a4bf$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $3ebf18a91682a4bf$var$MINIMAL_RAW_EN_LOCALE), {
        buttonHints: {
            prev: 'Previous $0',
            next: 'Next $0',
            today (buttonText, unit) {
                return unit === 'day' ? 'Today' : `This ${buttonText}`;
            }
        },
        viewHint: '$0 view',
        navLinkHint: 'Go to $0',
        moreLinkHint (eventCnt) {
            return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
        }
    });
    function $3ebf18a91682a4bf$var$organizeRawLocales(explicitRawLocales) {
        let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
        let allRawLocales = $3ebf18a91682a4bf$export$794e7bef9c0b12d9.concat(explicitRawLocales);
        let rawLocaleMap = {
            en: $3ebf18a91682a4bf$var$RAW_EN_LOCALE
        };
        for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
        return {
            map: rawLocaleMap,
            defaultCode: defaultCode
        };
    }
    function $3ebf18a91682a4bf$var$buildLocale(inputSingular, available) {
        if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return $3ebf18a91682a4bf$var$parseLocale(inputSingular.code, [
            inputSingular.code
        ], inputSingular);
        return $3ebf18a91682a4bf$var$queryLocale(inputSingular, available);
    }
    function $3ebf18a91682a4bf$var$queryLocale(codeArg, available) {
        let codes = [].concat(codeArg || []);
        let raw = $3ebf18a91682a4bf$var$queryRawLocale(codes, available) || $3ebf18a91682a4bf$var$RAW_EN_LOCALE;
        return $3ebf18a91682a4bf$var$parseLocale(codeArg, codes, raw);
    }
    function $3ebf18a91682a4bf$var$queryRawLocale(codes, available) {
        for(let i = 0; i < codes.length; i += 1){
            let parts = codes[i].toLocaleLowerCase().split('-');
            for(let j = parts.length; j > 0; j -= 1){
                let simpleId = parts.slice(0, j).join('-');
                if (available[simpleId]) return available[simpleId];
            }
        }
        return null;
    }
    function $3ebf18a91682a4bf$var$parseLocale(codeArg, codes, raw) {
        let merged = (0, (0, parcelRequire("Jd88K")).m)([
            $3ebf18a91682a4bf$var$MINIMAL_RAW_EN_LOCALE,
            raw
        ], [
            'buttonText'
        ]);
        delete merged.code;
        let { week: week } = merged;
        delete merged.week;
        return {
            codeArg: codeArg,
            codes: codes,
            week: week,
            simpleNumberFormat: new Intl.NumberFormat(codeArg),
            options: merged
        };
    }
    function $3ebf18a91682a4bf$export$ae829ec7b2625219(input) {
        return {
            id: (0, (0, parcelRequire("Jd88K")).g)(),
            name: input.name,
            premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
            deps: input.deps || [],
            reducers: input.reducers || [],
            isLoadingFuncs: input.isLoadingFuncs || [],
            contextInit: [].concat(input.contextInit || []),
            eventRefiners: input.eventRefiners || {},
            eventDefMemberAdders: input.eventDefMemberAdders || [],
            eventSourceRefiners: input.eventSourceRefiners || {},
            isDraggableTransformers: input.isDraggableTransformers || [],
            eventDragMutationMassagers: input.eventDragMutationMassagers || [],
            eventDefMutationAppliers: input.eventDefMutationAppliers || [],
            dateSelectionTransformers: input.dateSelectionTransformers || [],
            datePointTransforms: input.datePointTransforms || [],
            dateSpanTransforms: input.dateSpanTransforms || [],
            views: input.views || {},
            viewPropsTransformers: input.viewPropsTransformers || [],
            isPropsValid: input.isPropsValid || null,
            externalDefTransforms: input.externalDefTransforms || [],
            viewContainerAppends: input.viewContainerAppends || [],
            eventDropTransformers: input.eventDropTransformers || [],
            componentInteractions: input.componentInteractions || [],
            calendarInteractions: input.calendarInteractions || [],
            themeClasses: input.themeClasses || {},
            eventSourceDefs: input.eventSourceDefs || [],
            cmdFormatter: input.cmdFormatter,
            recurringTypes: input.recurringTypes || [],
            namedTimeZonedImpl: input.namedTimeZonedImpl,
            initialView: input.initialView || '',
            elementDraggingImpl: input.elementDraggingImpl,
            optionChangeHandlers: input.optionChangeHandlers || {},
            scrollGridImpl: input.scrollGridImpl || null,
            listenerRefiners: input.listenerRefiners || {},
            optionRefiners: input.optionRefiners || {},
            propSetHandlers: input.propSetHandlers || {}
        };
    }
    function $3ebf18a91682a4bf$var$buildPluginHooks(pluginDefs, globalDefs) {
        let currentPluginIds = {};
        let hooks = {
            premiumReleaseDate: undefined,
            reducers: [],
            isLoadingFuncs: [],
            contextInit: [],
            eventRefiners: {},
            eventDefMemberAdders: [],
            eventSourceRefiners: {},
            isDraggableTransformers: [],
            eventDragMutationMassagers: [],
            eventDefMutationAppliers: [],
            dateSelectionTransformers: [],
            datePointTransforms: [],
            dateSpanTransforms: [],
            views: {},
            viewPropsTransformers: [],
            isPropsValid: null,
            externalDefTransforms: [],
            viewContainerAppends: [],
            eventDropTransformers: [],
            componentInteractions: [],
            calendarInteractions: [],
            themeClasses: {},
            eventSourceDefs: [],
            cmdFormatter: null,
            recurringTypes: [],
            namedTimeZonedImpl: null,
            initialView: '',
            elementDraggingImpl: null,
            optionChangeHandlers: {},
            scrollGridImpl: null,
            listenerRefiners: {},
            optionRefiners: {},
            propSetHandlers: {}
        };
        function addDefs(defs) {
            for (let def of defs){
                const pluginName = def.name;
                const currentId = currentPluginIds[pluginName];
                if (currentId === undefined) {
                    currentPluginIds[pluginName] = def.id;
                    addDefs(def.deps);
                    hooks = $3ebf18a91682a4bf$var$combineHooks(hooks, def);
                } else if (currentId !== def.id) console.warn(`Duplicate plugin '${pluginName}'`);
            }
        }
        if (pluginDefs) addDefs(pluginDefs);
        addDefs(globalDefs);
        return hooks;
    }
    function $3ebf18a91682a4bf$var$buildBuildPluginHooks() {
        let currentOverrideDefs = [];
        let currentGlobalDefs = [];
        let currentHooks;
        return (overrideDefs, globalDefs)=>{
            if (!currentHooks || !(0, (0, parcelRequire("Jd88K")).i)(overrideDefs, currentOverrideDefs) || !(0, (0, parcelRequire("Jd88K")).i)(globalDefs, currentGlobalDefs)) currentHooks = $3ebf18a91682a4bf$var$buildPluginHooks(overrideDefs, globalDefs);
            currentOverrideDefs = overrideDefs;
            currentGlobalDefs = globalDefs;
            return currentHooks;
        };
    }
    function $3ebf18a91682a4bf$var$combineHooks(hooks0, hooks1) {
        return {
            premiumReleaseDate: $3ebf18a91682a4bf$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
            reducers: hooks0.reducers.concat(hooks1.reducers),
            isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
            contextInit: hooks0.contextInit.concat(hooks1.contextInit),
            eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
            eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
            eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
            isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
            eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
            eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
            dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
            datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
            dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
            views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
            viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
            isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
            externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
            viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
            eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
            calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
            componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
            themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
            eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
            cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
            recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
            namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
            initialView: hooks0.initialView || hooks1.initialView,
            elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
            optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
            scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
            listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
            optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
            propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
        };
    }
    function $3ebf18a91682a4bf$var$compareOptionalDates(date0, date1) {
        if (date0 === undefined) return date1;
        if (date1 === undefined) return date0;
        return new Date(Math.max(date0.valueOf(), date1.valueOf()));
    }
    class $3ebf18a91682a4bf$var$StandardTheme extends (0, (0, parcelRequire("Jd88K")).T) {
    }
    $3ebf18a91682a4bf$var$StandardTheme.prototype.classes = {
        root: 'fc-theme-standard',
        tableCellShaded: 'fc-cell-shaded',
        buttonGroup: 'fc-button-group',
        button: 'fc-button fc-button-primary',
        buttonActive: 'fc-button-active'
    };
    $3ebf18a91682a4bf$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
    $3ebf18a91682a4bf$var$StandardTheme.prototype.iconClasses = {
        close: 'fc-icon-x',
        prev: 'fc-icon-chevron-left',
        next: 'fc-icon-chevron-right',
        prevYear: 'fc-icon-chevrons-left',
        nextYear: 'fc-icon-chevrons-right'
    };
    $3ebf18a91682a4bf$var$StandardTheme.prototype.rtlIconClasses = {
        prev: 'fc-icon-chevron-right',
        next: 'fc-icon-chevron-left',
        prevYear: 'fc-icon-chevrons-right',
        nextYear: 'fc-icon-chevrons-left'
    };
    $3ebf18a91682a4bf$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
    $3ebf18a91682a4bf$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
    $3ebf18a91682a4bf$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
    function $3ebf18a91682a4bf$var$compileViewDefs(defaultConfigs, overrideConfigs) {
        let hash = {};
        let viewType;
        for(viewType in defaultConfigs)$3ebf18a91682a4bf$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
        for(viewType in overrideConfigs)$3ebf18a91682a4bf$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
        return hash;
    }
    function $3ebf18a91682a4bf$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
        if (hash[viewType]) return hash[viewType];
        let viewDef = $3ebf18a91682a4bf$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
        if (viewDef) hash[viewType] = viewDef;
        return viewDef;
    }
    function $3ebf18a91682a4bf$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
        let defaultConfig = defaultConfigs[viewType];
        let overrideConfig = overrideConfigs[viewType];
        let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
        let theComponent = queryProp('component');
        let superType = queryProp('superType');
        let superDef = null;
        if (superType) {
            if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
            superDef = $3ebf18a91682a4bf$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
        }
        if (!theComponent && superDef) theComponent = superDef.component;
        if (!theComponent) return null;
        return {
            type: viewType,
            component: theComponent,
            defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
            overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
        };
    }
    function $3ebf18a91682a4bf$var$parseViewConfigs(inputs) {
        return (0, (0, parcelRequire("Jd88K")).a)(inputs, $3ebf18a91682a4bf$var$parseViewConfig);
    }
    function $3ebf18a91682a4bf$var$parseViewConfig(input) {
        let rawOptions = typeof input === 'function' ? {
            component: input
        } : input;
        let { component: component } = rawOptions;
        if (rawOptions.content) component = $3ebf18a91682a4bf$var$createViewHookComponent(rawOptions);
        return {
            superType: rawOptions.type,
            component: component,
            rawOptions: rawOptions
        };
    }
    function $3ebf18a91682a4bf$var$createViewHookComponent(options) {
        return (viewProps)=>(0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).V).Consumer, null, (context)=>(0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).C), {
                    elTag: "div",
                    elClasses: (0, (0, parcelRequire("Jd88K")).b)(context.viewSpec),
                    renderProps: Object.assign(Object.assign({}, viewProps), {
                        nextDayThreshold: context.options.nextDayThreshold
                    }),
                    generatorName: undefined,
                    customGenerator: options.content,
                    classNameGenerator: options.classNames,
                    didMount: options.didMount,
                    willUnmount: options.willUnmount
                }));
    }
    function $3ebf18a91682a4bf$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
        let defaultConfigs = $3ebf18a91682a4bf$var$parseViewConfigs(defaultInputs);
        let overrideConfigs = $3ebf18a91682a4bf$var$parseViewConfigs(optionOverrides.views);
        let viewDefs = $3ebf18a91682a4bf$var$compileViewDefs(defaultConfigs, overrideConfigs);
        return (0, (0, parcelRequire("Jd88K")).a)(viewDefs, (viewDef)=>$3ebf18a91682a4bf$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
    }
    function $3ebf18a91682a4bf$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
        let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
        let duration = null;
        let durationUnit = '';
        let singleUnit = '';
        let singleUnitOverrides = {};
        if (durationInput) {
            duration = $3ebf18a91682a4bf$var$createDurationCached(durationInput);
            if (duration) {
                let denom = (0, (0, parcelRequire("Jd88K")).c)(duration);
                durationUnit = denom.unit;
                if (denom.value === 1) {
                    singleUnit = durationUnit;
                    singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
                }
            }
        }
        let queryButtonText = (optionsSubset)=>{
            let buttonTextMap = optionsSubset.buttonText || {};
            let buttonTextKey = viewDef.defaults.buttonTextKey;
            if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
            if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
            if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
            return null;
        };
        let queryButtonTitle = (optionsSubset)=>{
            let buttonHints = optionsSubset.buttonHints || {};
            let buttonKey = viewDef.defaults.buttonTextKey;
            if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
            if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
            if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
            return null;
        };
        return {
            type: viewDef.type,
            component: viewDef.component,
            duration: duration,
            durationUnit: durationUnit,
            singleUnit: singleUnit,
            optionDefaults: viewDef.defaults,
            optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
            buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || viewDef.overrides.buttonText,
            buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, (0, parcelRequire("Jd88K")).B)) || viewDef.type,
            buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
            buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, (0, parcelRequire("Jd88K")).B))
        };
    }
    let $3ebf18a91682a4bf$var$durationInputMap = {};
    function $3ebf18a91682a4bf$var$createDurationCached(durationInput) {
        let json = JSON.stringify(durationInput);
        let res = $3ebf18a91682a4bf$var$durationInputMap[json];
        if (res === undefined) {
            res = (0, (0, parcelRequire("Jd88K")).d)(durationInput);
            $3ebf18a91682a4bf$var$durationInputMap[json] = res;
        }
        return res;
    }
    function $3ebf18a91682a4bf$var$reduceViewType(viewType, action) {
        switch(action.type){
            case 'CHANGE_VIEW_TYPE':
                viewType = action.viewType;
        }
        return viewType;
    }
    function $3ebf18a91682a4bf$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
        switch(action.type){
            case 'SET_OPTION':
                return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                    [action.optionName]: action.rawOptionValue
                });
            default:
                return dynamicOptionOverrides;
        }
    }
    function $3ebf18a91682a4bf$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
        let dp;
        switch(action.type){
            case 'CHANGE_VIEW_TYPE':
                return dateProfileGenerator.build(action.dateMarker || currentDate);
            case 'CHANGE_DATE':
                return dateProfileGenerator.build(action.dateMarker);
            case 'PREV':
                dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
                if (dp.isValid) return dp;
                break;
            case 'NEXT':
                dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
                if (dp.isValid) return dp;
                break;
        }
        return currentDateProfile;
    }
    function $3ebf18a91682a4bf$var$initEventSources(calendarOptions, dateProfile, context) {
        let activeRange = dateProfile ? dateProfile.activeRange : null;
        return $3ebf18a91682a4bf$var$addSources({}, $3ebf18a91682a4bf$var$parseInitialSources(calendarOptions, context), activeRange, context);
    }
    function $3ebf18a91682a4bf$var$reduceEventSources(eventSources, action, dateProfile, context) {
        let activeRange = dateProfile ? dateProfile.activeRange : null;
        switch(action.type){
            case 'ADD_EVENT_SOURCES':
                return $3ebf18a91682a4bf$var$addSources(eventSources, action.sources, activeRange, context);
            case 'REMOVE_EVENT_SOURCE':
                return $3ebf18a91682a4bf$var$removeSource(eventSources, action.sourceId);
            case 'PREV':
            case 'NEXT':
            case 'CHANGE_DATE':
            case 'CHANGE_VIEW_TYPE':
                if (dateProfile) return $3ebf18a91682a4bf$var$fetchDirtySources(eventSources, activeRange, context);
                return eventSources;
            case 'FETCH_EVENT_SOURCES':
                return $3ebf18a91682a4bf$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, (0, parcelRequire("Jd88K")).e)(action.sourceIds) : $3ebf18a91682a4bf$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
            case 'RECEIVE_EVENTS':
            case 'RECEIVE_EVENT_ERROR':
                return $3ebf18a91682a4bf$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
            case 'REMOVE_ALL_EVENT_SOURCES':
                return {};
            default:
                return eventSources;
        }
    }
    function $3ebf18a91682a4bf$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
        let activeRange = dateProfile ? dateProfile.activeRange : null;
        return $3ebf18a91682a4bf$var$fetchSourcesByIds(eventSources, $3ebf18a91682a4bf$var$excludeStaticSources(eventSources, context), activeRange, true, context);
    }
    function $3ebf18a91682a4bf$var$computeEventSourcesLoading(eventSources) {
        for(let sourceId in eventSources){
            if (eventSources[sourceId].isFetching) return true;
        }
        return false;
    }
    function $3ebf18a91682a4bf$var$addSources(eventSourceHash, sources, fetchRange, context) {
        let hash = {};
        for (let source of sources)hash[source.sourceId] = source;
        if (fetchRange) hash = $3ebf18a91682a4bf$var$fetchDirtySources(hash, fetchRange, context);
        return Object.assign(Object.assign({}, eventSourceHash), hash);
    }
    function $3ebf18a91682a4bf$var$removeSource(eventSourceHash, sourceId) {
        return (0, (0, parcelRequire("Jd88K")).f)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
    }
    function $3ebf18a91682a4bf$var$fetchDirtySources(sourceHash, fetchRange, context) {
        return $3ebf18a91682a4bf$var$fetchSourcesByIds(sourceHash, (0, (0, parcelRequire("Jd88K")).f)(sourceHash, (eventSource)=>$3ebf18a91682a4bf$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
    }
    function $3ebf18a91682a4bf$var$isSourceDirty(eventSource, fetchRange, context) {
        if (!$3ebf18a91682a4bf$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
        return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
    }
    function $3ebf18a91682a4bf$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
        let nextSources = {};
        for(let sourceId in prevSources){
            let source = prevSources[sourceId];
            if (sourceIdHash[sourceId]) nextSources[sourceId] = $3ebf18a91682a4bf$var$fetchSource(source, fetchRange, isRefetch, context);
            else nextSources[sourceId] = source;
        }
        return nextSources;
    }
    function $3ebf18a91682a4bf$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
        let { options: options, calendarApi: calendarApi } = context;
        let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
        let fetchId = (0, (0, parcelRequire("Jd88K")).g)();
        sourceDef.fetch({
            eventSource: eventSource,
            range: fetchRange,
            isRefetch: isRefetch,
            context: context
        }, (res)=>{
            let { rawEvents: rawEvents } = res;
            if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
            if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
            context.dispatch({
                type: 'RECEIVE_EVENTS',
                sourceId: eventSource.sourceId,
                fetchId: fetchId,
                fetchRange: fetchRange,
                rawEvents: rawEvents
            });
        }, (error)=>{
            let errorHandled = false;
            if (options.eventSourceFailure) {
                options.eventSourceFailure.call(calendarApi, error);
                errorHandled = true;
            }
            if (eventSource.failure) {
                eventSource.failure(error);
                errorHandled = true;
            }
            if (!errorHandled) console.warn(error.message, error);
            context.dispatch({
                type: 'RECEIVE_EVENT_ERROR',
                sourceId: eventSource.sourceId,
                fetchId: fetchId,
                fetchRange: fetchRange,
                error: error
            });
        });
        return Object.assign(Object.assign({}, eventSource), {
            isFetching: true,
            latestFetchId: fetchId
        });
    }
    function $3ebf18a91682a4bf$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
        let eventSource = sourceHash[sourceId];
        if (eventSource && fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
            [sourceId]: Object.assign(Object.assign({}, eventSource), {
                isFetching: false,
                fetchRange: fetchRange
            })
        });
        return sourceHash;
    }
    function $3ebf18a91682a4bf$var$excludeStaticSources(eventSources, context) {
        return (0, (0, parcelRequire("Jd88K")).f)(eventSources, (eventSource)=>$3ebf18a91682a4bf$var$doesSourceNeedRange(eventSource, context));
    }
    function $3ebf18a91682a4bf$var$parseInitialSources(rawOptions, context) {
        let refiners = (0, (0, parcelRequire("Jd88K")).h)(context);
        let rawSources = [].concat(rawOptions.eventSources || []);
        let sources = [];
        if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
        if (rawOptions.events) rawSources.unshift(rawOptions.events);
        for (let rawSource of rawSources){
            let source = (0, (0, parcelRequire("Jd88K")).p)(rawSource, context, refiners);
            if (source) sources.push(source);
        }
        return sources;
    }
    function $3ebf18a91682a4bf$var$doesSourceNeedRange(eventSource, context) {
        let defs = context.pluginHooks.eventSourceDefs;
        return !defs[eventSource.sourceDefId].ignoreRange;
    }
    function $3ebf18a91682a4bf$var$reduceDateSelection(currentSelection, action) {
        switch(action.type){
            case 'UNSELECT_DATES':
                return null;
            case 'SELECT_DATES':
                return action.selection;
            default:
                return currentSelection;
        }
    }
    function $3ebf18a91682a4bf$var$reduceSelectedEvent(currentInstanceId, action) {
        switch(action.type){
            case 'UNSELECT_EVENT':
                return '';
            case 'SELECT_EVENT':
                return action.eventInstanceId;
            default:
                return currentInstanceId;
        }
    }
    function $3ebf18a91682a4bf$var$reduceEventDrag(currentDrag, action) {
        let newDrag;
        switch(action.type){
            case 'UNSET_EVENT_DRAG':
                return null;
            case 'SET_EVENT_DRAG':
                newDrag = action.state;
                return {
                    affectedEvents: newDrag.affectedEvents,
                    mutatedEvents: newDrag.mutatedEvents,
                    isEvent: newDrag.isEvent
                };
            default:
                return currentDrag;
        }
    }
    function $3ebf18a91682a4bf$var$reduceEventResize(currentResize, action) {
        let newResize;
        switch(action.type){
            case 'UNSET_EVENT_RESIZE':
                return null;
            case 'SET_EVENT_RESIZE':
                newResize = action.state;
                return {
                    affectedEvents: newResize.affectedEvents,
                    mutatedEvents: newResize.mutatedEvents,
                    isEvent: newResize.isEvent
                };
            default:
                return currentResize;
        }
    }
    function $3ebf18a91682a4bf$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
        let header = calendarOptions.headerToolbar ? $3ebf18a91682a4bf$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
        let footer = calendarOptions.footerToolbar ? $3ebf18a91682a4bf$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
        return {
            header: header,
            footer: footer
        };
    }
    function $3ebf18a91682a4bf$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
        let sectionWidgets = {};
        let viewsWithButtons = [];
        let hasTitle = false;
        for(let sectionName in sectionStrHash){
            let sectionStr = sectionStrHash[sectionName];
            let sectionRes = $3ebf18a91682a4bf$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
            sectionWidgets[sectionName] = sectionRes.widgets;
            viewsWithButtons.push(...sectionRes.viewsWithButtons);
            hasTitle = hasTitle || sectionRes.hasTitle;
        }
        return {
            sectionWidgets: sectionWidgets,
            viewsWithButtons: viewsWithButtons,
            hasTitle: hasTitle
        };
    }
    function $3ebf18a91682a4bf$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
        let isRtl = calendarOptions.direction === 'rtl';
        let calendarCustomButtons = calendarOptions.customButtons || {};
        let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
        let calendarButtonText = calendarOptions.buttonText || {};
        let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
        let calendarButtonHints = calendarOptions.buttonHints || {};
        let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
        let viewsWithButtons = [];
        let hasTitle = false;
        let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
                if (buttonName === 'title') {
                    hasTitle = true;
                    return {
                        buttonName: buttonName
                    };
                }
                let customButtonProps;
                let viewSpec;
                let buttonClick;
                let buttonIcon;
                let buttonText;
                let buttonHint;
                if (customButtonProps = calendarCustomButtons[buttonName]) {
                    buttonClick = (ev)=>{
                        if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target);
                    };
                    (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                    buttonHint = customButtonProps.hint || customButtonProps.text;
                } else if (viewSpec = viewSpecs[buttonName]) {
                    viewsWithButtons.push(buttonName);
                    buttonClick = ()=>{
                        calendarApi.changeView(buttonName);
                    };
                    (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                    let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                    buttonHint = (0, (0, parcelRequire("Jd88K")).j)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                        textFallback,
                        buttonName
                    ], textFallback);
                } else if (calendarApi[buttonName]) {
                    buttonClick = ()=>{
                        calendarApi[buttonName]();
                    };
                    (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]);
                    if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                        let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                        buttonHint = (0, (0, parcelRequire("Jd88K")).j)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                            calendarButtonText.year || 'year',
                            'year'
                        ], calendarButtonText[buttonName]);
                    } else buttonHint = (navUnit)=>(0, (0, parcelRequire("Jd88K")).j)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                            calendarButtonText[navUnit] || navUnit,
                            navUnit
                        ], calendarButtonText[buttonName]);
                }
                return {
                    buttonName: buttonName,
                    buttonClick: buttonClick,
                    buttonIcon: buttonIcon,
                    buttonText: buttonText,
                    buttonHint: buttonHint
                };
            }));
        return {
            widgets: widgets,
            viewsWithButtons: viewsWithButtons,
            hasTitle: hasTitle
        };
    }
    class $3ebf18a91682a4bf$var$ViewImpl {
        constructor(type, getCurrentData, dateEnv){
            this.type = type;
            this.getCurrentData = getCurrentData;
            this.dateEnv = dateEnv;
        }
        get calendar() {
            return this.getCurrentData().calendarApi;
        }
        get title() {
            return this.getCurrentData().viewTitle;
        }
        get activeStart() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
        }
        get activeEnd() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
        }
        get currentStart() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
        }
        get currentEnd() {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
        }
        getOption(name) {
            return this.getCurrentData().options[name];
        }
    }
    let $3ebf18a91682a4bf$var$eventSourceDef$2 = {
        ignoreRange: true,
        parseMeta (refined) {
            if (Array.isArray(refined.events)) return refined.events;
            return null;
        },
        fetch (arg, successCallback) {
            successCallback({
                rawEvents: arg.eventSource.meta
            });
        }
    };
    const $3ebf18a91682a4bf$var$arrayEventSourcePlugin = $3ebf18a91682a4bf$export$ae829ec7b2625219({
        name: 'array-event-source',
        eventSourceDefs: [
            $3ebf18a91682a4bf$var$eventSourceDef$2
        ]
    });
    let $3ebf18a91682a4bf$var$eventSourceDef$1 = {
        parseMeta (refined) {
            if (typeof refined.events === 'function') return refined.events;
            return null;
        },
        fetch (arg, successCallback, errorCallback) {
            const { dateEnv: dateEnv } = arg.context;
            const func = arg.eventSource.meta;
            (0, (0, parcelRequire("Jd88K")).u)(func.bind(null, (0, (0, parcelRequire("Jd88K")).k)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                    rawEvents: rawEvents
                }), errorCallback);
        }
    };
    const $3ebf18a91682a4bf$var$funcEventSourcePlugin = $3ebf18a91682a4bf$export$ae829ec7b2625219({
        name: 'func-event-source',
        eventSourceDefs: [
            $3ebf18a91682a4bf$var$eventSourceDef$1
        ]
    });
    const $3ebf18a91682a4bf$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
        method: String,
        extraParams: (0, (0, parcelRequire("Jd88K")).l),
        startParam: String,
        endParam: String,
        timeZoneParam: String
    };
    let $3ebf18a91682a4bf$var$eventSourceDef = {
        parseMeta (refined) {
            if (refined.url && (refined.format === 'json' || !refined.format)) return {
                url: refined.url,
                format: 'json',
                method: (refined.method || 'GET').toUpperCase(),
                extraParams: refined.extraParams,
                startParam: refined.startParam,
                endParam: refined.endParam,
                timeZoneParam: refined.timeZoneParam
            };
            return null;
        },
        fetch (arg, successCallback, errorCallback) {
            const { meta: meta } = arg.eventSource;
            const requestParams = $3ebf18a91682a4bf$var$buildRequestParams(meta, arg.range, arg.context);
            (0, (0, parcelRequire("Jd88K")).r)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
                successCallback({
                    rawEvents: rawEvents,
                    response: response
                });
            }, errorCallback);
        }
    };
    const $3ebf18a91682a4bf$var$jsonFeedEventSourcePlugin = $3ebf18a91682a4bf$export$ae829ec7b2625219({
        name: 'json-event-source',
        eventSourceRefiners: $3ebf18a91682a4bf$var$JSON_FEED_EVENT_SOURCE_REFINERS,
        eventSourceDefs: [
            $3ebf18a91682a4bf$var$eventSourceDef
        ]
    });
    function $3ebf18a91682a4bf$var$buildRequestParams(meta, range, context) {
        let { dateEnv: dateEnv, options: options } = context;
        let startParam;
        let endParam;
        let timeZoneParam;
        let customRequestParams;
        let params = {};
        startParam = meta.startParam;
        if (startParam == null) startParam = options.startParam;
        endParam = meta.endParam;
        if (endParam == null) endParam = options.endParam;
        timeZoneParam = meta.timeZoneParam;
        if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
        if (typeof meta.extraParams === 'function') customRequestParams = meta.extraParams();
        else customRequestParams = meta.extraParams || {};
        Object.assign(params, customRequestParams);
        params[startParam] = dateEnv.formatIso(range.start);
        params[endParam] = dateEnv.formatIso(range.end);
        if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
        return params;
    }
    const $3ebf18a91682a4bf$var$SIMPLE_RECURRING_REFINERS = {
        daysOfWeek: (0, (0, parcelRequire("Jd88K")).l),
        startTime: (0, (0, parcelRequire("Jd88K")).d),
        endTime: (0, (0, parcelRequire("Jd88K")).d),
        duration: (0, (0, parcelRequire("Jd88K")).d),
        startRecur: (0, (0, parcelRequire("Jd88K")).l),
        endRecur: (0, (0, parcelRequire("Jd88K")).l)
    };
    let $3ebf18a91682a4bf$var$recurring = {
        parse (refined, dateEnv) {
            if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
                let recurringData = {
                    daysOfWeek: refined.daysOfWeek || null,
                    startTime: refined.startTime || null,
                    endTime: refined.endTime || null,
                    startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                    endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null
                };
                let duration;
                if (refined.duration) duration = refined.duration;
                if (!duration && refined.startTime && refined.endTime) duration = (0, (0, parcelRequire("Jd88K")).s)(refined.endTime, refined.startTime);
                return {
                    allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                    duration: duration,
                    typeData: recurringData
                };
            }
            return null;
        },
        expand (typeData, framingRange, dateEnv) {
            let clippedFramingRange = (0, (0, parcelRequire("Jd88K")).n)(framingRange, {
                start: typeData.startRecur,
                end: typeData.endRecur
            });
            if (clippedFramingRange) return $3ebf18a91682a4bf$var$expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
            return [];
        }
    };
    const $3ebf18a91682a4bf$var$simpleRecurringEventsPlugin = $3ebf18a91682a4bf$export$ae829ec7b2625219({
        name: 'simple-recurring-event',
        recurringTypes: [
            $3ebf18a91682a4bf$var$recurring
        ],
        eventRefiners: $3ebf18a91682a4bf$var$SIMPLE_RECURRING_REFINERS
    });
    function $3ebf18a91682a4bf$var$expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
        let dowHash = daysOfWeek ? (0, (0, parcelRequire("Jd88K")).e)(daysOfWeek) : null;
        let dayMarker = (0, (0, parcelRequire("Jd88K")).o)(framingRange.start);
        let endMarker = framingRange.end;
        let instanceStarts = [];
        while(dayMarker < endMarker){
            let instanceStart;
            if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
                if (startTime) instanceStart = dateEnv.add(dayMarker, startTime);
                else instanceStart = dayMarker;
                instanceStarts.push(instanceStart);
            }
            dayMarker = (0, (0, parcelRequire("Jd88K")).q)(dayMarker, 1);
        }
        return instanceStarts;
    }
    const $3ebf18a91682a4bf$var$changeHandlerPlugin = $3ebf18a91682a4bf$export$ae829ec7b2625219({
        name: 'change-handler',
        optionChangeHandlers: {
            events (events, context) {
                $3ebf18a91682a4bf$var$handleEventSources([
                    events
                ], context);
            },
            eventSources: $3ebf18a91682a4bf$var$handleEventSources
        }
    });
    function $3ebf18a91682a4bf$var$handleEventSources(inputs, context) {
        let unfoundSources = (0, (0, parcelRequire("Jd88K")).t)(context.getCurrentData().eventSources);
        if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
            context.dispatch({
                type: 'RESET_RAW_EVENTS',
                sourceId: unfoundSources[0].sourceId,
                rawEvents: inputs[0]
            });
            return;
        }
        let newInputs = [];
        for (let input of inputs){
            let inputFound = false;
            for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1);
                inputFound = true;
                break;
            }
            if (!inputFound) newInputs.push(input);
        }
        for (let unfoundSource of unfoundSources)context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: unfoundSource.sourceId
        });
        for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
    }
    function $3ebf18a91682a4bf$var$handleDateProfile(dateProfile, context) {
        context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, (0, parcelRequire("Jd88K")).k)(dateProfile.activeRange, context.dateEnv)), {
            view: context.viewApi
        }));
    }
    function $3ebf18a91682a4bf$var$handleEventStore(eventStore, context) {
        let { emitter: emitter } = context;
        if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, (0, parcelRequire("Jd88K")).v)(eventStore, context));
    }
    const $3ebf18a91682a4bf$export$905153d94e0757fa = [
        $3ebf18a91682a4bf$var$arrayEventSourcePlugin,
        $3ebf18a91682a4bf$var$funcEventSourcePlugin,
        $3ebf18a91682a4bf$var$jsonFeedEventSourcePlugin,
        $3ebf18a91682a4bf$var$simpleRecurringEventsPlugin,
        $3ebf18a91682a4bf$var$changeHandlerPlugin,
        $3ebf18a91682a4bf$export$ae829ec7b2625219({
            name: 'misc',
            isLoadingFuncs: [
                (state)=>$3ebf18a91682a4bf$var$computeEventSourcesLoading(state.eventSources)
            ],
            propSetHandlers: {
                dateProfile: $3ebf18a91682a4bf$var$handleDateProfile,
                eventStore: $3ebf18a91682a4bf$var$handleEventStore
            }
        })
    ];
    class $3ebf18a91682a4bf$var$TaskRunner {
        constructor(runTaskOption, drainedOption){
            this.runTaskOption = runTaskOption;
            this.drainedOption = drainedOption;
            this.queue = [];
            this.delayedRunner = new (0, (0, parcelRequire("Jd88K")).D)(this.drain.bind(this));
        }
        request(task, delay) {
            this.queue.push(task);
            this.delayedRunner.request(delay);
        }
        pause(scope) {
            this.delayedRunner.pause(scope);
        }
        resume(scope, force) {
            this.delayedRunner.resume(scope, force);
        }
        drain() {
            let { queue: queue } = this;
            while(queue.length){
                let completedTasks = [];
                let task;
                while(task = queue.shift()){
                    this.runTask(task);
                    completedTasks.push(task);
                }
                this.drained(completedTasks);
            }
        }
        runTask(task) {
            if (this.runTaskOption) this.runTaskOption(task);
        }
        drained(completedTasks) {
            if (this.drainedOption) this.drainedOption(completedTasks);
        }
    }
    function $3ebf18a91682a4bf$var$buildTitle(dateProfile, viewOptions, dateEnv) {
        let range;
        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
        else range = dateProfile.activeRange;
        return dateEnv.formatRange(range.start, range.end, (0, (0, parcelRequire("Jd88K")).w)(viewOptions.titleFormat || $3ebf18a91682a4bf$var$buildTitleFormat(dateProfile)), {
            isEndExclusive: dateProfile.isRangeAllDay,
            defaultSeparator: viewOptions.titleRangeSeparator
        });
    }
    function $3ebf18a91682a4bf$var$buildTitleFormat(dateProfile) {
        let { currentRangeUnit: currentRangeUnit } = dateProfile;
        if (currentRangeUnit === 'year') return {
            year: 'numeric'
        };
        if (currentRangeUnit === 'month') return {
            year: 'numeric',
            month: 'long'
        };
        let days = (0, (0, parcelRequire("Jd88K")).x)(dateProfile.currentRange.start, dateProfile.currentRange.end);
        if (days !== null && days > 1) return {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        };
        return {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
    }
    class $3ebf18a91682a4bf$var$CalendarDataManager {
        constructor(props){
            this.computeCurrentViewData = (0, (0, parcelRequire("Jd88K")).y)(this._computeCurrentViewData);
            this.organizeRawLocales = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$organizeRawLocales);
            this.buildLocale = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildLocale);
            this.buildPluginHooks = $3ebf18a91682a4bf$var$buildBuildPluginHooks();
            this.buildDateEnv = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildDateEnv$1);
            this.buildTheme = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildTheme);
            this.parseToolbars = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$parseToolbars);
            this.buildViewSpecs = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildViewSpecs);
            this.buildDateProfileGenerator = (0, (0, parcelRequire("Jd88K")).z)($3ebf18a91682a4bf$var$buildDateProfileGenerator);
            this.buildViewApi = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildViewApi);
            this.buildViewUiProps = (0, (0, parcelRequire("Jd88K")).z)($3ebf18a91682a4bf$var$buildViewUiProps);
            this.buildEventUiBySource = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildEventUiBySource, (0, (0, parcelRequire("Jd88K")).A));
            this.buildEventUiBases = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildEventUiBases);
            this.parseContextBusinessHours = (0, (0, parcelRequire("Jd88K")).z)($3ebf18a91682a4bf$var$parseContextBusinessHours);
            this.buildTitle = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildTitle);
            this.emitter = new (0, (0, parcelRequire("Jd88K")).E)();
            this.actionRunner = new $3ebf18a91682a4bf$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
            this.currentCalendarOptionsInput = {};
            this.currentCalendarOptionsRefined = {};
            this.currentViewOptionsInput = {};
            this.currentViewOptionsRefined = {};
            this.currentCalendarOptionsRefiners = {};
            this.optionsForRefining = [];
            this.optionsForHandling = [];
            this.getCurrentData = ()=>this.data;
            this.dispatch = (action)=>{
                this.actionRunner.request(action);
            };
            this.props = props;
            this.actionRunner.pause();
            let dynamicOptionOverrides = {};
            let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
            let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
            let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
            props.calendarApi.currentDataManager = this;
            this.emitter.setThisContext(props.calendarApi);
            this.emitter.setOptions(currentViewData.options);
            let currentDate = (0, (0, parcelRequire("Jd88K")).F)(optionsData.calendarOptions, optionsData.dateEnv);
            let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
            if (!(0, (0, parcelRequire("Jd88K")).G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
            let calendarContext = {
                dateEnv: optionsData.dateEnv,
                options: optionsData.calendarOptions,
                pluginHooks: optionsData.pluginHooks,
                calendarApi: props.calendarApi,
                dispatch: this.dispatch,
                emitter: this.emitter,
                getCurrentData: this.getCurrentData
            };
            for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
            let eventSources = $3ebf18a91682a4bf$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
            let initialState = {
                dynamicOptionOverrides: dynamicOptionOverrides,
                currentViewType: currentViewType,
                currentDate: currentDate,
                dateProfile: dateProfile,
                businessHours: this.parseContextBusinessHours(calendarContext),
                eventSources: eventSources,
                eventUiBases: {},
                eventStore: (0, (0, parcelRequire("Jd88K")).H)(),
                renderableEventStore: (0, (0, parcelRequire("Jd88K")).H)(),
                dateSelection: null,
                eventSelection: '',
                eventDrag: null,
                eventResize: null,
                selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
            };
            let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
            for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
            if ($3ebf18a91682a4bf$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true);
            this.state = initialState;
            this.updateData();
            this.actionRunner.resume();
        }
        resetOptions(optionOverrides, changedOptionNames) {
            let { props: props } = this;
            if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
            else {
                props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
                this.optionsForRefining.push(...changedOptionNames);
            }
            if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
                type: 'NOTHING'
            });
        }
        _handleAction(action) {
            let { props: props, state: state, emitter: emitter } = this;
            let dynamicOptionOverrides = $3ebf18a91682a4bf$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
            let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
            let currentViewType = $3ebf18a91682a4bf$var$reduceViewType(state.currentViewType, action);
            let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
            props.calendarApi.currentDataManager = this;
            emitter.setThisContext(props.calendarApi);
            emitter.setOptions(currentViewData.options);
            let calendarContext = {
                dateEnv: optionsData.dateEnv,
                options: optionsData.calendarOptions,
                pluginHooks: optionsData.pluginHooks,
                calendarApi: props.calendarApi,
                dispatch: this.dispatch,
                emitter: emitter,
                getCurrentData: this.getCurrentData
            };
            let { currentDate: currentDate, dateProfile: dateProfile } = state;
            if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
            currentDate = (0, (0, parcelRequire("Jd88K")).I)(currentDate, action);
            dateProfile = $3ebf18a91682a4bf$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
            if (action.type === 'PREV' || action.type === 'NEXT' || !(0, (0, parcelRequire("Jd88K")).G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
            let eventSources = $3ebf18a91682a4bf$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
            let eventStore = (0, (0, parcelRequire("Jd88K")).J)(state.eventStore, action, eventSources, dateProfile, calendarContext);
            let isEventsLoading = $3ebf18a91682a4bf$var$computeEventSourcesLoading(eventSources);
            let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
            let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext);
            let eventUiBySource = this.buildEventUiBySource(eventSources);
            let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
            let newState = {
                dynamicOptionOverrides: dynamicOptionOverrides,
                currentViewType: currentViewType,
                currentDate: currentDate,
                dateProfile: dateProfile,
                eventSources: eventSources,
                eventStore: eventStore,
                renderableEventStore: renderableEventStore,
                selectionConfig: selectionConfig,
                eventUiBases: eventUiBases,
                businessHours: this.parseContextBusinessHours(calendarContext),
                dateSelection: $3ebf18a91682a4bf$var$reduceDateSelection(state.dateSelection, action),
                eventSelection: $3ebf18a91682a4bf$var$reduceSelectedEvent(state.eventSelection, action),
                eventDrag: $3ebf18a91682a4bf$var$reduceEventDrag(state.eventDrag, action),
                eventResize: $3ebf18a91682a4bf$var$reduceEventResize(state.eventResize, action)
            };
            let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
            for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState));
            let wasLoading = $3ebf18a91682a4bf$var$computeIsLoading(state, calendarContext);
            let isLoading = $3ebf18a91682a4bf$var$computeIsLoading(newState, calendarContext);
            if (!wasLoading && isLoading) emitter.trigger('loading', true);
            else if (wasLoading && !isLoading) emitter.trigger('loading', false);
            this.state = newState;
            if (props.onAction) props.onAction(action);
        }
        updateData() {
            let { props: props, state: state } = this;
            let oldData = this.data;
            let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
            let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
            let data = this.data = Object.assign(Object.assign(Object.assign({
                viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
                calendarApi: props.calendarApi,
                dispatch: this.dispatch,
                emitter: this.emitter,
                getCurrentData: this.getCurrentData
            }, optionsData), currentViewData), state);
            let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
            let oldCalendarOptions = oldData && oldData.calendarOptions;
            let newCalendarOptions = optionsData.calendarOptions;
            if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
                if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                    state.eventSources = data.eventSources = $3ebf18a91682a4bf$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                    state.eventStore = data.eventStore = (0, (0, parcelRequire("Jd88K")).K)(data.eventStore, oldData.dateEnv, data.dateEnv);
                }
                for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
            }
            this.optionsForHandling = [];
            if (props.onData) props.onData(data);
        }
        computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
            if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
            let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
            $3ebf18a91682a4bf$var$warnUnknownOptions(extra);
            let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
            let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
            let theme = this.buildTheme(refinedOptions, pluginHooks);
            let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
            return this.stableCalendarOptionsData = {
                calendarOptions: refinedOptions,
                pluginHooks: pluginHooks,
                dateEnv: dateEnv,
                viewSpecs: viewSpecs,
                theme: theme,
                toolbarConfig: toolbarConfig,
                localeDefaults: localeDefaults,
                availableRawLocales: availableLocaleData.map
            };
        }
        processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
            let { locales: locales, locale: locale } = (0, (0, parcelRequire("Jd88K")).L)([
                (0, (0, parcelRequire("Jd88K")).B),
                optionOverrides,
                dynamicOptionOverrides
            ]);
            let availableLocaleData = this.organizeRawLocales(locales);
            let availableRawLocales = availableLocaleData.map;
            let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
            let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $3ebf18a91682a4bf$export$905153d94e0757fa);
            let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, (0, parcelRequire("Jd88K")).M)), (0, (0, parcelRequire("Jd88K")).N)), (0, (0, parcelRequire("Jd88K")).O)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
            let extra = {};
            let raw = (0, (0, parcelRequire("Jd88K")).L)([
                (0, (0, parcelRequire("Jd88K")).B),
                localeDefaults,
                optionOverrides,
                dynamicOptionOverrides
            ]);
            let refined = {};
            let currentRaw = this.currentCalendarOptionsInput;
            let currentRefined = this.currentCalendarOptionsRefined;
            let anyChanges = false;
            for(let optionName in raw){
                if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, (0, parcelRequire("Jd88K")).P)[optionName] && optionName in currentRaw && (0, (0, parcelRequire("Jd88K")).P)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
                else if (refiners[optionName]) {
                    refined[optionName] = refiners[optionName](raw[optionName]);
                    anyChanges = true;
                } else extra[optionName] = currentRaw[optionName];
            }
            if (anyChanges) {
                this.currentCalendarOptionsInput = raw;
                this.currentCalendarOptionsRefined = refined;
                this.stableOptionOverrides = optionOverrides;
                this.stableDynamicOptionOverrides = dynamicOptionOverrides;
            }
            this.optionsForHandling.push(...this.optionsForRefining);
            this.optionsForRefining = [];
            return {
                rawOptions: this.currentCalendarOptionsInput,
                refinedOptions: this.currentCalendarOptionsRefined,
                pluginHooks: pluginHooks,
                availableLocaleData: availableLocaleData,
                localeDefaults: localeDefaults,
                extra: extra
            };
        }
        _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
            let viewSpec = optionsData.viewSpecs[viewType];
            if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
            let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
            $3ebf18a91682a4bf$var$warnUnknownOptions(extra);
            let dateProfileGenerator = this.buildDateProfileGenerator({
                dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
                duration: viewSpec.duration,
                durationUnit: viewSpec.durationUnit,
                usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
                dateEnv: optionsData.dateEnv,
                calendarApi: this.props.calendarApi,
                slotMinTime: refinedOptions.slotMinTime,
                slotMaxTime: refinedOptions.slotMaxTime,
                showNonCurrentDates: refinedOptions.showNonCurrentDates,
                dayCount: refinedOptions.dayCount,
                dateAlignment: refinedOptions.dateAlignment,
                dateIncrement: refinedOptions.dateIncrement,
                hiddenDays: refinedOptions.hiddenDays,
                weekends: refinedOptions.weekends,
                nowInput: refinedOptions.now,
                validRangeInput: refinedOptions.validRange,
                visibleRangeInput: refinedOptions.visibleRange,
                fixedWeekCount: refinedOptions.fixedWeekCount
            });
            let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
            return {
                viewSpec: viewSpec,
                options: refinedOptions,
                dateProfileGenerator: dateProfileGenerator,
                viewApi: viewApi
            };
        }
        processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
            let raw = (0, (0, parcelRequire("Jd88K")).L)([
                (0, (0, parcelRequire("Jd88K")).B),
                viewSpec.optionDefaults,
                localeDefaults,
                optionOverrides,
                viewSpec.optionOverrides,
                dynamicOptionOverrides
            ]);
            let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, (0, parcelRequire("Jd88K")).M)), (0, (0, parcelRequire("Jd88K")).N)), (0, (0, parcelRequire("Jd88K")).O)), (0, (0, parcelRequire("Jd88K")).Q)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
            let refined = {};
            let currentRaw = this.currentViewOptionsInput;
            let currentRefined = this.currentViewOptionsRefined;
            let anyChanges = false;
            let extra = {};
            for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, (0, parcelRequire("Jd88K")).P)[optionName] && (0, (0, parcelRequire("Jd88K")).P)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
            else {
                if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, (0, parcelRequire("Jd88K")).P)[optionName] && (0, (0, parcelRequire("Jd88K")).P)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                    if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
                else extra[optionName] = raw[optionName];
                anyChanges = true;
            }
            if (anyChanges) {
                this.currentViewOptionsInput = raw;
                this.currentViewOptionsRefined = refined;
            }
            return {
                rawOptions: this.currentViewOptionsInput,
                refinedOptions: this.currentViewOptionsRefined,
                extra: extra
            };
        }
    }
    function $3ebf18a91682a4bf$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
        let locale = $3ebf18a91682a4bf$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
        return new (0, (0, parcelRequire("Jd88K")).R)({
            calendarSystem: 'gregory',
            timeZone: timeZone,
            namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
            locale: locale,
            weekNumberCalculation: weekNumberCalculation,
            firstDay: firstDay,
            weekText: weekText,
            cmdFormatter: pluginHooks.cmdFormatter,
            defaultSeparator: defaultSeparator
        });
    }
    function $3ebf18a91682a4bf$var$buildTheme(options, pluginHooks) {
        let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $3ebf18a91682a4bf$var$StandardTheme;
        return new ThemeClass(options);
    }
    function $3ebf18a91682a4bf$var$buildDateProfileGenerator(props) {
        let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, (0, parcelRequire("Jd88K")).S);
        return new DateProfileGeneratorClass(props);
    }
    function $3ebf18a91682a4bf$var$buildViewApi(type, getCurrentData, dateEnv) {
        return new $3ebf18a91682a4bf$var$ViewImpl(type, getCurrentData, dateEnv);
    }
    function $3ebf18a91682a4bf$var$buildEventUiBySource(eventSources) {
        return (0, (0, parcelRequire("Jd88K")).a)(eventSources, (eventSource)=>eventSource.ui);
    }
    function $3ebf18a91682a4bf$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
        let eventUiBases = {
            '': eventUiSingleBase
        };
        for(let defId in eventDefs){
            let def = eventDefs[defId];
            if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
        }
        return eventUiBases;
    }
    function $3ebf18a91682a4bf$var$buildViewUiProps(calendarContext) {
        let { options: options } = calendarContext;
        return {
            eventUiSingleBase: (0, (0, parcelRequire("Jd88K")).U)({
                display: options.eventDisplay,
                editable: options.editable,
                startEditable: options.eventStartEditable,
                durationEditable: options.eventDurationEditable,
                constraint: options.eventConstraint,
                overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
                allow: options.eventAllow,
                backgroundColor: options.eventBackgroundColor,
                borderColor: options.eventBorderColor,
                textColor: options.eventTextColor,
                color: options.eventColor
            }, calendarContext),
            selectionConfig: (0, (0, parcelRequire("Jd88K")).U)({
                constraint: options.selectConstraint,
                overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
                allow: options.selectAllow
            }, calendarContext)
        };
    }
    function $3ebf18a91682a4bf$var$computeIsLoading(state, context) {
        for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
            if (isLoadingFunc(state)) return true;
        }
        return false;
    }
    function $3ebf18a91682a4bf$var$parseContextBusinessHours(calendarContext) {
        return (0, (0, parcelRequire("Jd88K")).W)(calendarContext.options.businessHours, calendarContext);
    }
    function $3ebf18a91682a4bf$var$warnUnknownOptions(options, viewName) {
        for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
    }
    class $3ebf18a91682a4bf$var$ToolbarSection extends (0, (0, parcelRequire("Jd88K")).X) {
        render() {
            let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
            return (0, $77d02.createElement)('div', {
                className: 'fc-toolbar-chunk'
            }, ...children);
        }
        renderWidgetGroup(widgetGroup) {
            let { props: props } = this;
            let { theme: theme } = this.context;
            let children = [];
            let isOnlyButtons = true;
            for (let widget of widgetGroup){
                let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
                if (buttonName === 'title') {
                    isOnlyButtons = false;
                    children.push((0, $77d02.createElement)("h2", {
                        className: "fc-toolbar-title",
                        id: props.titleId
                    }, props.title));
                } else {
                    let isPressed = buttonName === props.activeButton;
                    let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                    let buttonClasses = [
                        `fc-${buttonName}-button`,
                        theme.getClass('button')
                    ];
                    if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                    children.push((0, $77d02.createElement)("button", {
                        type: "button",
                        title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                        disabled: isDisabled,
                        "aria-pressed": isPressed,
                        className: buttonClasses.join(' '),
                        onClick: buttonClick
                    }, buttonText || (buttonIcon ? (0, $77d02.createElement)("span", {
                        className: buttonIcon
                    }) : '')));
                }
            }
            if (children.length > 1) {
                let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
                return (0, $77d02.createElement)('div', {
                    className: groupClassName
                }, ...children);
            }
            return children[0];
        }
    }
    class $3ebf18a91682a4bf$var$Toolbar extends (0, (0, parcelRequire("Jd88K")).X) {
        render() {
            let { model: model, extraClassName: extraClassName } = this.props;
            let forceLtr = false;
            let startContent;
            let endContent;
            let sectionWidgets = model.sectionWidgets;
            let centerContent = sectionWidgets.center;
            if (sectionWidgets.left) {
                forceLtr = true;
                startContent = sectionWidgets.left;
            } else startContent = sectionWidgets.start;
            if (sectionWidgets.right) {
                forceLtr = true;
                endContent = sectionWidgets.right;
            } else endContent = sectionWidgets.end;
            let classNames = [
                extraClassName || '',
                'fc-toolbar',
                forceLtr ? 'fc-toolbar-ltr' : ''
            ];
            return (0, $77d02.createElement)("div", {
                className: classNames.join(' ')
            }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
        }
        renderSection(key, widgetGroups) {
            let { props: props } = this;
            return (0, $77d02.createElement)($3ebf18a91682a4bf$var$ToolbarSection, {
                key: key,
                widgetGroups: widgetGroups,
                title: props.title,
                navUnit: props.navUnit,
                activeButton: props.activeButton,
                isTodayEnabled: props.isTodayEnabled,
                isPrevEnabled: props.isPrevEnabled,
                isNextEnabled: props.isNextEnabled,
                titleId: props.titleId
            });
        }
    }
    class $3ebf18a91682a4bf$var$ViewHarness extends (0, (0, parcelRequire("Jd88K")).X) {
        constructor(){
            super(...arguments);
            this.state = {
                availableWidth: null
            };
            this.handleEl = (el)=>{
                this.el = el;
                (0, (0, parcelRequire("Jd88K")).Y)(this.props.elRef, el);
                this.updateAvailableWidth();
            };
            this.handleResize = ()=>{
                this.updateAvailableWidth();
            };
        }
        render() {
            let { props: props, state: state } = this;
            let { aspectRatio: aspectRatio } = props;
            let classNames = [
                'fc-view-harness',
                aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' : 'fc-view-harness-passive'
            ];
            let height = '';
            let paddingBottom = '';
            if (aspectRatio) {
                if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
                else paddingBottom = `${1 / aspectRatio * 100}%`;
            } else height = props.height || '';
            return (0, $77d02.createElement)("div", {
                "aria-labelledby": props.labeledById,
                ref: this.handleEl,
                className: classNames.join(' '),
                style: {
                    height: height,
                    paddingBottom: paddingBottom
                }
            }, props.children);
        }
        componentDidMount() {
            this.context.addResizeHandler(this.handleResize);
        }
        componentWillUnmount() {
            this.context.removeResizeHandler(this.handleResize);
        }
        updateAvailableWidth() {
            if (this.el && this.props.aspectRatio) this.setState({
                availableWidth: this.el.offsetWidth
            });
        }
    }
    class $3ebf18a91682a4bf$var$EventClicking extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.handleSegClick = (ev, segEl)=>{
                let { component: component } = this;
                let { context: context } = component;
                let seg = (0, (0, parcelRequire("Jd88K"))._)(segEl);
                if (seg && component.isValidSegDownEl(ev.target)) {
                    let hasUrlContainer = (0, (0, parcelRequire("Jd88K")).$)(ev.target, '.fc-event-forced-url');
                    let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                    context.emitter.trigger('eventClick', {
                        el: segEl,
                        event: new (0, (0, parcelRequire("Jd88K")).a0)(component.context, seg.eventRange.def, seg.eventRange.instance),
                        jsEvent: ev,
                        view: context.viewApi
                    });
                    if (url && !ev.defaultPrevented) window.location.href = url;
                }
            };
            this.destroy = (0, (0, parcelRequire("Jd88K")).a1)(settings.el, 'click', '.fc-event', this.handleSegClick);
        }
    }
    class $3ebf18a91682a4bf$var$EventHovering extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.handleEventElRemove = (el)=>{
                if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
            };
            this.handleSegEnter = (ev, segEl)=>{
                if ((0, (0, parcelRequire("Jd88K"))._)(segEl)) {
                    this.currentSegEl = segEl;
                    this.triggerEvent('eventMouseEnter', ev, segEl);
                }
            };
            this.handleSegLeave = (ev, segEl)=>{
                if (this.currentSegEl) {
                    this.currentSegEl = null;
                    this.triggerEvent('eventMouseLeave', ev, segEl);
                }
            };
            this.removeHoverListeners = (0, (0, parcelRequire("Jd88K")).a2)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
        }
        destroy() {
            this.removeHoverListeners();
        }
        triggerEvent(publicEvName, ev, segEl) {
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, (0, parcelRequire("Jd88K"))._)(segEl);
            if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
                el: segEl,
                event: new (0, (0, parcelRequire("Jd88K")).a0)(context, seg.eventRange.def, seg.eventRange.instance),
                jsEvent: ev,
                view: context.viewApi
            });
        }
    }
    class $3ebf18a91682a4bf$var$CalendarContent extends (0, (0, parcelRequire("Jd88K")).a3) {
        constructor(){
            super(...arguments);
            this.buildViewContext = (0, (0, parcelRequire("Jd88K")).y)((0, (0, parcelRequire("Jd88K")).a4));
            this.buildViewPropTransformers = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildViewPropTransformers);
            this.buildToolbarProps = (0, (0, parcelRequire("Jd88K")).y)($3ebf18a91682a4bf$var$buildToolbarProps);
            this.headerRef = (0, $77d02.createRef)();
            this.footerRef = (0, $77d02.createRef)();
            this.interactionsStore = {};
            this.state = {
                viewLabelId: (0, (0, parcelRequire("Jd88K")).a5)()
            };
            this.registerInteractiveComponent = (component, settingsInput)=>{
                let settings = (0, (0, parcelRequire("Jd88K")).a6)(component, settingsInput);
                let DEFAULT_INTERACTIONS = [
                    $3ebf18a91682a4bf$var$EventClicking,
                    $3ebf18a91682a4bf$var$EventHovering
                ];
                let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
                let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
                this.interactionsStore[component.uid] = interactions;
                (0, (0, parcelRequire("Jd88K")).a7)[component.uid] = settings;
            };
            this.unregisterInteractiveComponent = (component)=>{
                let listeners = this.interactionsStore[component.uid];
                if (listeners) {
                    for (let listener of listeners)listener.destroy();
                    delete this.interactionsStore[component.uid];
                }
                delete (0, (0, parcelRequire("Jd88K")).a7)[component.uid];
            };
            this.resizeRunner = new (0, (0, parcelRequire("Jd88K")).D)(()=>{
                this.props.emitter.trigger('_resize', true);
                this.props.emitter.trigger('windowResize', {
                    view: this.props.viewApi
                });
            });
            this.handleWindowResize = (ev)=>{
                let { options: options } = this.props;
                if (options.handleWindowResize && ev.target === window) this.resizeRunner.request(options.windowResizeDelay);
            };
        }
        render() {
            let { props: props } = this;
            let { toolbarConfig: toolbarConfig, options: options } = props;
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, (0, (0, parcelRequire("Jd88K")).a8)(props.options.now, props.dateEnv), props.viewTitle);
            let viewVGrow = false;
            let viewHeight = '';
            let viewAspectRatio;
            if (props.isHeightAuto || props.forPrint) viewHeight = '';
            else if (options.height != null) viewVGrow = true;
            else if (options.contentHeight != null) viewHeight = options.contentHeight;
            else viewAspectRatio = Math.max(options.aspectRatio, 0.5);
            let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
            let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : '';
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).V).Provider, {
                value: viewContext
            }, toolbarConfig.header && (0, $77d02.createElement)($3ebf18a91682a4bf$var$Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, $77d02.createElement)($3ebf18a91682a4bf$var$ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $77d02.createElement)($3ebf18a91682a4bf$var$Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }
        componentDidMount() {
            let { props: props } = this;
            this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
            window.addEventListener('resize', this.handleWindowResize);
            let { propSetHandlers: propSetHandlers } = props.pluginHooks;
            for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
        }
        componentDidUpdate(prevProps) {
            let { props: props } = this;
            let { propSetHandlers: propSetHandlers } = props.pluginHooks;
            for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.handleWindowResize);
            this.resizeRunner.clear();
            for (let interaction of this.calendarInteractions)interaction.destroy();
            this.props.emitter.trigger('_unmount');
        }
        buildAppendContent() {
            let { props: props } = this;
            let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
            return (0, $77d02.createElement)((0, $77d02.Fragment), {}, ...children);
        }
        renderView(props) {
            let { pluginHooks: pluginHooks } = props;
            let { viewSpec: viewSpec } = props;
            let viewProps = {
                dateProfile: props.dateProfile,
                businessHours: props.businessHours,
                eventStore: props.renderableEventStore,
                eventUiBases: props.eventUiBases,
                dateSelection: props.dateSelection,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                isHeightAuto: props.isHeightAuto,
                forPrint: props.forPrint
            };
            let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
            for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
            let ViewComponent = viewSpec.component;
            return (0, $77d02.createElement)(ViewComponent, Object.assign({}, viewProps));
        }
    }
    function $3ebf18a91682a4bf$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
        let todayInfo = dateProfileGenerator.build(now, undefined, false);
        let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
        let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
        return {
            title: title,
            activeButton: viewSpec.type,
            navUnit: viewSpec.singleUnit,
            isTodayEnabled: todayInfo.isValid && !(0, (0, parcelRequire("Jd88K")).G)(dateProfile.currentRange, now),
            isPrevEnabled: prevInfo.isValid,
            isNextEnabled: nextInfo.isValid
        };
    }
    function $3ebf18a91682a4bf$var$buildViewPropTransformers(theClasses) {
        return theClasses.map((TheClass)=>new TheClass());
    }
    class $3ebf18a91682a4bf$export$e1aef45b828286de extends (0, (0, parcelRequire("Jd88K")).a9) {
        constructor(el, optionOverrides = {}){
            super();
            this.isRendering = false;
            this.isRendered = false;
            this.currentClassNames = [];
            this.customContentRenderId = 0;
            this.handleAction = (action)=>{
                switch(action.type){
                    case 'SET_EVENT_DRAG':
                    case 'SET_EVENT_RESIZE':
                        this.renderRunner.tryDrain();
                }
            };
            this.handleData = (data)=>{
                this.currentData = data;
                this.renderRunner.request(data.calendarOptions.rerenderDelay);
            };
            this.handleRenderRequest = ()=>{
                if (this.isRendering) {
                    this.isRendered = true;
                    let { currentData: currentData } = this;
                    (0, (0, parcelRequire("Jd88K")).aa)(()=>{
                        (0, $77d02.render)((0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).ab), {
                            options: currentData.calendarOptions,
                            theme: currentData.theme,
                            emitter: currentData.emitter
                        }, (classNames, height, isHeightAuto, forPrint)=>{
                            this.setClassNames(classNames);
                            this.setHeight(height);
                            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).ac).Provider, {
                                value: this.customContentRenderId
                            }, (0, $77d02.createElement)($3ebf18a91682a4bf$var$CalendarContent, Object.assign({
                                isHeightAuto: isHeightAuto,
                                forPrint: forPrint
                            }, currentData)));
                        }), this.el);
                    });
                } else if (this.isRendered) {
                    this.isRendered = false;
                    (0, $77d02.render)(null, this.el);
                    this.setClassNames([]);
                    this.setHeight('');
                }
            };
            (0, (0, parcelRequire("Jd88K")).ad)(el);
            this.el = el;
            this.renderRunner = new (0, (0, parcelRequire("Jd88K")).D)(this.handleRenderRequest);
            new $3ebf18a91682a4bf$var$CalendarDataManager({
                optionOverrides: optionOverrides,
                calendarApi: this,
                onAction: this.handleAction,
                onData: this.handleData
            });
        }
        render() {
            let wasRendering = this.isRendering;
            if (!wasRendering) this.isRendering = true;
            else this.customContentRenderId += 1;
            this.renderRunner.request();
            if (wasRendering) this.updateSize();
        }
        destroy() {
            if (this.isRendering) {
                this.isRendering = false;
                this.renderRunner.request();
            }
        }
        updateSize() {
            (0, (0, parcelRequire("Jd88K")).aa)(()=>{
                super.updateSize();
            });
        }
        batchRendering(func) {
            this.renderRunner.pause('batchRendering');
            func();
            this.renderRunner.resume('batchRendering');
        }
        pauseRendering() {
            this.renderRunner.pause('pauseRendering');
        }
        resumeRendering() {
            this.renderRunner.resume('pauseRendering', true);
        }
        resetOptions(optionOverrides, changedOptionNames) {
            this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
        }
        setClassNames(classNames) {
            if (!(0, (0, parcelRequire("Jd88K")).i)(classNames, this.currentClassNames)) {
                let { classList: classList } = this.el;
                for (let className of this.currentClassNames)classList.remove(className);
                for (let className of classNames)classList.add(className);
                this.currentClassNames = classNames;
            }
        }
        setHeight(height) {
            (0, (0, parcelRequire("Jd88K")).ae)(this.el, 'height', height);
        }
    }
    function $3ebf18a91682a4bf$export$3ae94a2503e890a1(dateInput, options = {}) {
        let dateEnv = $3ebf18a91682a4bf$var$buildDateEnv(options);
        let formatter = (0, (0, parcelRequire("Jd88K")).w)(options);
        let dateMeta = dateEnv.createMarkerMeta(dateInput);
        if (!dateMeta) return '';
        return dateEnv.format(dateMeta.marker, formatter, {
            forcedTzo: dateMeta.forcedTzo
        });
    }
    function $3ebf18a91682a4bf$export$9b1080e2eec9158(startInput, endInput, options) {
        let dateEnv = $3ebf18a91682a4bf$var$buildDateEnv(typeof options === 'object' && options ? options : {});
        let formatter = (0, (0, parcelRequire("Jd88K")).w)(options);
        let startMeta = dateEnv.createMarkerMeta(startInput);
        let endMeta = dateEnv.createMarkerMeta(endInput);
        if (!startMeta || !endMeta) return '';
        return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
            forcedStartTzo: startMeta.forcedTzo,
            forcedEndTzo: endMeta.forcedTzo,
            isEndExclusive: options.isEndExclusive,
            defaultSeparator: (0, (0, parcelRequire("Jd88K")).B).defaultRangeSeparator
        });
    }
    function $3ebf18a91682a4bf$var$buildDateEnv(settings) {
        let locale = $3ebf18a91682a4bf$var$buildLocale(settings.locale || 'en', $3ebf18a91682a4bf$var$organizeRawLocales([]).map);
        return new (0, (0, parcelRequire("Jd88K")).R)(Object.assign(Object.assign({
            timeZone: (0, (0, parcelRequire("Jd88K")).B).timeZone,
            calendarSystem: 'gregory'
        }, settings), {
            locale: locale
        }));
    }
    function $3ebf18a91682a4bf$export$3b384895d0cca0f2(props, allDay) {
        return (0, (0, parcelRequire("Jd88K")).af)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
    }
    const $3ebf18a91682a4bf$export$83d89fbfd8236492 = '6.1.5';
});
parcelRegister("Jd88K", function(module, exports) {
    $parcel$export(module.exports, "cw", ()=>$087e637c79acc198$export$c373adc892eb6355);
    $parcel$export(module.exports, "ad", ()=>$087e637c79acc198$export$4c3d22f3d993c33f);
    $parcel$export(module.exports, "D", ()=>$087e637c79acc198$export$96f57966bedc81b4);
    $parcel$export(module.exports, "aO", ()=>$087e637c79acc198$export$c03999cb2f36933f);
    $parcel$export(module.exports, "$", ()=>$087e637c79acc198$export$3d8c2f653ac9d0b9);
    $parcel$export(module.exports, "aQ", ()=>$087e637c79acc198$export$f96d196f7728bb5);
    $parcel$export(module.exports, "aP", ()=>$087e637c79acc198$export$2ed0fc6709e59212);
    $parcel$export(module.exports, "ae", ()=>$087e637c79acc198$export$f787f51d84a910ad);
    $parcel$export(module.exports, "aR", ()=>$087e637c79acc198$export$738ab4df8bf92ae9);
    $parcel$export(module.exports, "a5", ()=>$087e637c79acc198$export$a8550f7dbe79f93a);
    $parcel$export(module.exports, "a1", ()=>$087e637c79acc198$export$3c2fa207a37baaea);
    $parcel$export(module.exports, "a2", ()=>$087e637c79acc198$export$ce26c07117d59d6a);
    $parcel$export(module.exports, "b2", ()=>$087e637c79acc198$export$2ec5befb9e6c97d4);
    $parcel$export(module.exports, "g", ()=>$087e637c79acc198$export$39b482c5e57630a8);
    $parcel$export(module.exports, "ax", ()=>$087e637c79acc198$export$9fa96a7d116ea3ce);
    $parcel$export(module.exports, "aw", ()=>$087e637c79acc198$export$92108d983e8ee699);
    $parcel$export(module.exports, "ar", ()=>$087e637c79acc198$export$d24c54395ce0c509);
    $parcel$export(module.exports, "as", ()=>$087e637c79acc198$export$6554612db691658e);
    $parcel$export(module.exports, "at", ()=>$087e637c79acc198$export$493d36ec626b6698);
    $parcel$export(module.exports, "au", ()=>$087e637c79acc198$export$1fbe638ecf81657e);
    $parcel$export(module.exports, "j", ()=>$087e637c79acc198$export$35e795649ee09318);
    $parcel$export(module.exports, "av", ()=>$087e637c79acc198$export$d66dc83d8cfc8dd);
    $parcel$export(module.exports, "d", ()=>$087e637c79acc198$export$4368d992c4eafac0);
    $parcel$export(module.exports, "s", ()=>$087e637c79acc198$export$2408f22a0fab9ae5);
    $parcel$export(module.exports, "c", ()=>$087e637c79acc198$export$db3b6bfb95261072);
    $parcel$export(module.exports, "i", ()=>$087e637c79acc198$export$23f2a1d2818174ef);
    $parcel$export(module.exports, "bh", ()=>$087e637c79acc198$export$31e67cf12fc9668);
    $parcel$export(module.exports, "q", ()=>$087e637c79acc198$export$9e5f44173e64f162);
    $parcel$export(module.exports, "bg", ()=>$087e637c79acc198$export$136fd86de524d3c2);
    $parcel$export(module.exports, "bi", ()=>$087e637c79acc198$export$62d08d6fa708df47);
    $parcel$export(module.exports, "o", ()=>$087e637c79acc198$export$ae1af26003f05816);
    $parcel$export(module.exports, "x", ()=>$087e637c79acc198$export$d141bba7fdc215a3);
    $parcel$export(module.exports, "bv", ()=>$087e637c79acc198$export$5dbe06c6d8c68cfb);
    $parcel$export(module.exports, "bx", ()=>$087e637c79acc198$export$26a0a7676ca7aa04);
    $parcel$export(module.exports, "y", ()=>$087e637c79acc198$export$4a5767248b18ef41);
    $parcel$export(module.exports, "z", ()=>$087e637c79acc198$export$df995fae86a55f06);
    $parcel$export(module.exports, "A", ()=>$087e637c79acc198$export$ebd11618f299a286);
    $parcel$export(module.exports, "w", ()=>$087e637c79acc198$export$efccba1c4a2ef57b);
    $parcel$export(module.exports, "M", ()=>$087e637c79acc198$export$3a1a48c8f6ef640e);
    $parcel$export(module.exports, "l", ()=>$087e637c79acc198$export$882b5998b3b9117c);
    $parcel$export(module.exports, "B", ()=>$087e637c79acc198$export$ef35774e6d314e91);
    $parcel$export(module.exports, "N", ()=>$087e637c79acc198$export$a07804094c3ecf2d);
    $parcel$export(module.exports, "O", ()=>$087e637c79acc198$export$c4ce752e73470fba);
    $parcel$export(module.exports, "P", ()=>$087e637c79acc198$export$56c0d5a1e737357d);
    $parcel$export(module.exports, "Q", ()=>$087e637c79acc198$export$3722cfe417b6ed86);
    $parcel$export(module.exports, "L", ()=>$087e637c79acc198$export$61196ced6d74a310);
    $parcel$export(module.exports, "m", ()=>$087e637c79acc198$export$953cecd6e717a553);
    $parcel$export(module.exports, "f", ()=>$087e637c79acc198$export$2d1720544b23b823);
    $parcel$export(module.exports, "a", ()=>$087e637c79acc198$export$407448d2b89b1813);
    $parcel$export(module.exports, "e", ()=>$087e637c79acc198$export$f1e1789686576879);
    $parcel$export(module.exports, "t", ()=>$087e637c79acc198$export$625550452a3fa3ec);
    $parcel$export(module.exports, "R", ()=>$087e637c79acc198$export$db202ddc8be9136);
    $parcel$export(module.exports, "T", ()=>$087e637c79acc198$export$971d5caa766a69d7);
    $parcel$export(module.exports, "aa", ()=>$087e637c79acc198$export$7910e0436ed8d1de);
    $parcel$export(module.exports, "V", ()=>$087e637c79acc198$export$e7c866399fa523f5);
    $parcel$export(module.exports, "a4", ()=>$087e637c79acc198$export$efca4cbe5dd06740);
    $parcel$export(module.exports, "a3", ()=>$087e637c79acc198$export$6559d589eb85fbb6);
    $parcel$export(module.exports, "X", ()=>$087e637c79acc198$export$78acf4525d8a74c4);
    $parcel$export(module.exports, "Y", ()=>$087e637c79acc198$export$8743009a87fcb00f);
    $parcel$export(module.exports, "ac", ()=>$087e637c79acc198$export$2219238a014317b0);
    $parcel$export(module.exports, "C", ()=>$087e637c79acc198$export$e7094788287c5e9b);
    $parcel$export(module.exports, "ct", ()=>$087e637c79acc198$export$e9316ff9106cdb75);
    $parcel$export(module.exports, "b", ()=>$087e637c79acc198$export$8b22cf2602fb60ce);
    $parcel$export(module.exports, "n", ()=>$087e637c79acc198$export$7ccc53e8f1e7dfc5);
    $parcel$export(module.exports, "b9", ()=>$087e637c79acc198$export$4ae495d48253603d);
    $parcel$export(module.exports, "G", ()=>$087e637c79acc198$export$2329c99376c9d0a4);
    $parcel$export(module.exports, "aA", ()=>$087e637c79acc198$export$91c6e00c14e7e6fd);
    $parcel$export(module.exports, "I", ()=>$087e637c79acc198$export$9bb611d729802a56);
    $parcel$export(module.exports, "F", ()=>$087e637c79acc198$export$d66501df72047452);
    $parcel$export(module.exports, "a8", ()=>$087e637c79acc198$export$c3950d9923825c02);
    $parcel$export(module.exports, "S", ()=>$087e637c79acc198$export$25ce5a424b770e84);
    $parcel$export(module.exports, "aj", ()=>$087e637c79acc198$export$3b513254972cfc9c);
    $parcel$export(module.exports, "al", ()=>$087e637c79acc198$export$ab83b03e4111b1d0);
    $parcel$export(module.exports, "ak", ()=>$087e637c79acc198$export$21579262ef46735b);
    $parcel$export(module.exports, "U", ()=>$087e637c79acc198$export$3a6d5c9ae78a2c08);
    $parcel$export(module.exports, "H", ()=>$087e637c79acc198$export$7f8ddf7c7c20b3cd);
    $parcel$export(module.exports, "aW", ()=>$087e637c79acc198$export$9d0e2d13d04f7070);
    $parcel$export(module.exports, "aV", ()=>$087e637c79acc198$export$1ee57be6f6687d2c);
    $parcel$export(module.exports, "p", ()=>$087e637c79acc198$export$ffb5f4729a158638);
    $parcel$export(module.exports, "h", ()=>$087e637c79acc198$export$dda1d9f60106f0e9);
    $parcel$export(module.exports, "J", ()=>$087e637c79acc198$export$b4171a6734a65d42);
    $parcel$export(module.exports, "K", ()=>$087e637c79acc198$export$3466f893ebf79586);
    $parcel$export(module.exports, "E", ()=>$087e637c79acc198$export$a9c23c6ac3fc3eca);
    $parcel$export(module.exports, "W", ()=>$087e637c79acc198$export$71cec2538cb2c617);
    $parcel$export(module.exports, "cu", ()=>$087e637c79acc198$export$9ddbdd0bfc5623a);
    $parcel$export(module.exports, "cv", ()=>$087e637c79acc198$export$1776704b6532a19a);
    $parcel$export(module.exports, "bX", ()=>$087e637c79acc198$export$6d1e945284085e64);
    $parcel$export(module.exports, "a0", ()=>$087e637c79acc198$export$34aec0b863436764);
    $parcel$export(module.exports, "v", ()=>$087e637c79acc198$export$90a7f3efeed30595);
    $parcel$export(module.exports, "af", ()=>$087e637c79acc198$export$c9170ad7d4cd7e57);
    $parcel$export(module.exports, "_", ()=>$087e637c79acc198$export$71511d61b312f219);
    $parcel$export(module.exports, "bR", ()=>$087e637c79acc198$export$4d522598b426bb73);
    $parcel$export(module.exports, "bQ", ()=>$087e637c79acc198$export$993a080e5cb62d74);
    $parcel$export(module.exports, "bS", ()=>$087e637c79acc198$export$6dabbe08653f866f);
    $parcel$export(module.exports, "bT", ()=>$087e637c79acc198$export$1314441b8d04e1d5);
    $parcel$export(module.exports, "bU", ()=>$087e637c79acc198$export$e0c3a065614c6254);
    $parcel$export(module.exports, "bf", ()=>$087e637c79acc198$export$151db275011178c4);
    $parcel$export(module.exports, "k", ()=>$087e637c79acc198$export$342063e11d6c3cad);
    $parcel$export(module.exports, "u", ()=>$087e637c79acc198$export$3b14a55fb2447963);
    $parcel$export(module.exports, "r", ()=>$087e637c79acc198$export$43caf9889c228507);
    $parcel$export(module.exports, "ab", ()=>$087e637c79acc198$export$555508cbc6add439);
    $parcel$export(module.exports, "Z", ()=>$087e637c79acc198$export$dc98b0b04f4c7758);
    $parcel$export(module.exports, "a6", ()=>$087e637c79acc198$export$2e2af4578d910ddf);
    $parcel$export(module.exports, "bG", ()=>$087e637c79acc198$export$aff10ba49ece4b91);
    $parcel$export(module.exports, "a7", ()=>$087e637c79acc198$export$a93c5207d687da10);
    $parcel$export(module.exports, "a9", ()=>$087e637c79acc198$export$a9c996f45e5784d0);
    $parcel$export(module.exports, "aF", ()=>$087e637c79acc198$export$cf2f7c5792f80b46);
    $parcel$export(module.exports, "aE", ()=>$087e637c79acc198$export$158acd800e1ef08b);
    $parcel$export(module.exports, "aG", ()=>$087e637c79acc198$export$53a70dd1ebbae346);
    $parcel$export(module.exports, "aH", ()=>$087e637c79acc198$export$a33b77bbdbb8366c);
    $parcel$export(module.exports, "aI", ()=>$087e637c79acc198$export$b9a6b53f9be3734);
    $parcel$export(module.exports, "b0", ()=>$087e637c79acc198$export$8c78c7c36408ea29);
    $parcel$export(module.exports, "b3", ()=>$087e637c79acc198$export$53c86fa97d611818);
    $parcel$export(module.exports, "b6", ()=>$087e637c79acc198$export$c18d01048907ea92);
    $parcel$export(module.exports, "b5", ()=>$087e637c79acc198$export$7a0bdf7d4a91ea88);
    $parcel$export(module.exports, "ba", ()=>$087e637c79acc198$export$7060da4b5db56fb9);
    $parcel$export(module.exports, "bb", ()=>$087e637c79acc198$export$c5d1328b37d47994);
    $parcel$export(module.exports, "bc", ()=>$087e637c79acc198$export$d22783b3c2400a3a);
    $parcel$export(module.exports, "bd", ()=>$087e637c79acc198$export$7f557e5eb95176c2);
    $parcel$export(module.exports, "be", ()=>$087e637c79acc198$export$51b138e5a065c2bb);
    $parcel$export(module.exports, "bA", ()=>$087e637c79acc198$export$2e63b696b2c9441b);
    $parcel$export(module.exports, "bF", ()=>$087e637c79acc198$export$b2bcef12bcefba04);
    $parcel$export(module.exports, "bB", ()=>$087e637c79acc198$export$eb84e45a33f6ba7c);
    $parcel$export(module.exports, "bH", ()=>$087e637c79acc198$export$60bb826a6acf3081);
    $parcel$export(module.exports, "bI", ()=>$087e637c79acc198$export$27d1aff6bea49709);
    $parcel$export(module.exports, "bJ", ()=>$087e637c79acc198$export$1abb261478089fe6);
    $parcel$export(module.exports, "ch", ()=>$087e637c79acc198$export$6e4b1d19c6e2e012);
    $parcel$export(module.exports, "bK", ()=>$087e637c79acc198$export$ebc5e65867841cbe);
    $parcel$export(module.exports, "bO", ()=>$087e637c79acc198$export$2538633961795d6b);
    $parcel$export(module.exports, "bV", ()=>$087e637c79acc198$export$dabba94403d45c8e);
    $parcel$export(module.exports, "bW", ()=>$087e637c79acc198$export$6b179bb11f7fd3a0);
    $parcel$export(module.exports, "bZ", ()=>$087e637c79acc198$export$c667925124dac624);
    $parcel$export(module.exports, "b_", ()=>$087e637c79acc198$export$c69d65aa55814164);
    $parcel$export(module.exports, "cf", ()=>$087e637c79acc198$export$49e6ee724f7f1ace);
    $parcel$export(module.exports, "ca", ()=>$087e637c79acc198$export$89e9012e902952b6);
    $parcel$export(module.exports, "cc", ()=>$087e637c79acc198$export$a1edd97dd51cd48d);
    $parcel$export(module.exports, "cb", ()=>$087e637c79acc198$export$54c4fabc2291e9c0);
    $parcel$export(module.exports, "b$", ()=>$087e637c79acc198$export$add49c223b9ce4ea);
    $parcel$export(module.exports, "cn", ()=>$087e637c79acc198$export$1343a74baacb0543);
    $parcel$export(module.exports, "cj", ()=>$087e637c79acc198$export$d92db8a7dc823bb0);
    $parcel$export(module.exports, "cl", ()=>$087e637c79acc198$export$b975d55abac2bbe3);
    $parcel$export(module.exports, "cm", ()=>$087e637c79acc198$export$b02498c06ddfef28);
    $parcel$export(module.exports, "cp", ()=>$087e637c79acc198$export$cd571ca6d1702b73);
    $parcel$export(module.exports, "co", ()=>$087e637c79acc198$export$87b6ab1c2cb8b955);
    $parcel$export(module.exports, "cq", ()=>$087e637c79acc198$export$a3c9165b94390bcd);
    $parcel$export(module.exports, "cr", ()=>$087e637c79acc198$export$cbfbec548517f2b6);
    $parcel$export(module.exports, "cy", ()=>$087e637c79acc198$export$aea64bc1b6f8f415);
    var $77d02 = parcelRequire("77d02");
    var $j8P0R = parcelRequire("j8P0R");
    const $087e637c79acc198$var$styleTexts = [];
    const $087e637c79acc198$var$styleEndMarkers = new Map();
    const $087e637c79acc198$var$commentText = ' fullcalendar styles ';
    if (typeof document !== 'undefined') $087e637c79acc198$var$registerStylesRoot(document, document.head, document.head.querySelector('script,link,style'));
    function $087e637c79acc198$export$c373adc892eb6355(styleText) {
        $087e637c79acc198$var$styleTexts.push(styleText);
        $087e637c79acc198$var$styleEndMarkers.forEach((endMarker)=>{
            $087e637c79acc198$var$injectStylesBefore(styleText, endMarker);
        });
    }
    function $087e637c79acc198$export$4c3d22f3d993c33f(el) {
        $087e637c79acc198$var$registerStylesRoot(el.getRootNode());
    }
    function $087e637c79acc198$var$registerStylesRoot(rootNode, parentEl = rootNode, insertBefore = parentEl.firstChild) {
        if (!$087e637c79acc198$var$styleEndMarkers.has(rootNode)) {
            const startMarker = document.createComment($087e637c79acc198$var$commentText);
            const endMarker = document.createComment(` END${$087e637c79acc198$var$commentText}`);
            parentEl.insertBefore(endMarker, insertBefore);
            parentEl.insertBefore(startMarker, endMarker);
            $087e637c79acc198$var$styleEndMarkers.set(rootNode, endMarker);
            $087e637c79acc198$var$hydrateStylesRoot(endMarker);
        }
    }
    function $087e637c79acc198$var$hydrateStylesRoot(endMarker) {
        for (const styleText of $087e637c79acc198$var$styleTexts)$087e637c79acc198$var$injectStylesBefore(styleText, endMarker);
    }
    function $087e637c79acc198$var$injectStylesBefore(styleText, endMarker) {
        const styleNode = document.createElement('style');
        const nonce = $087e637c79acc198$var$getNonceValue();
        if (nonce) styleNode.nonce = nonce;
        styleNode.innerText = styleText;
        endMarker.parentNode.insertBefore(styleNode, endMarker);
    }
    let $087e637c79acc198$var$queriedNonceValue;
    function $087e637c79acc198$var$getNonceValue() {
        if ($087e637c79acc198$var$queriedNonceValue === undefined) $087e637c79acc198$var$queriedNonceValue = $087e637c79acc198$var$queryNonceValue();
        return $087e637c79acc198$var$queriedNonceValue;
    }
    function $087e637c79acc198$var$queryNonceValue() {
        const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
        if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
        const elWithNonce = document.querySelector('script[nonce]');
        if (elWithNonce) return elWithNonce.nonce || '';
        return '';
    }
    var $087e637c79acc198$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button::-moz-focus-inner{border-style:none;padding:0}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
    $087e637c79acc198$export$c373adc892eb6355($087e637c79acc198$var$css_248z);
    class $087e637c79acc198$export$96f57966bedc81b4 {
        constructor(drainedOption){
            this.drainedOption = drainedOption;
            this.isRunning = false;
            this.isDirty = false;
            this.pauseDepths = {};
            this.timeoutId = 0;
        }
        request(delay) {
            this.isDirty = true;
            if (!this.isPaused()) {
                this.clearTimeout();
                if (delay == null) this.tryDrain();
                else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
            }
        }
        pause(scope = '') {
            let { pauseDepths: pauseDepths } = this;
            pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
            this.clearTimeout();
        }
        resume(scope = '', force) {
            let { pauseDepths: pauseDepths } = this;
            if (scope in pauseDepths) {
                if (force) delete pauseDepths[scope];
                else {
                    pauseDepths[scope] -= 1;
                    let depth = pauseDepths[scope];
                    if (depth <= 0) delete pauseDepths[scope];
                }
                this.tryDrain();
            }
        }
        isPaused() {
            return Object.keys(this.pauseDepths).length;
        }
        tryDrain() {
            if (!this.isRunning && !this.isPaused()) {
                this.isRunning = true;
                while(this.isDirty){
                    this.isDirty = false;
                    this.drained();
                }
                this.isRunning = false;
            }
        }
        clear() {
            this.clearTimeout();
            this.isDirty = false;
            this.pauseDepths = {};
        }
        clearTimeout() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = 0;
            }
        }
        drained() {
            if (this.drainedOption) this.drainedOption();
        }
    }
    function $087e637c79acc198$export$c03999cb2f36933f(el) {
        if (el.parentNode) el.parentNode.removeChild(el);
    }
    function $087e637c79acc198$export$3d8c2f653ac9d0b9(el, selector) {
        if (el.closest) return el.closest(selector);
        if (!document.documentElement.contains(el)) return null;
        do {
            if ($087e637c79acc198$export$f96d196f7728bb5(el, selector)) return el;
            el = el.parentElement || el.parentNode;
        }while (el !== null && el.nodeType === 1)
        return null;
    }
    function $087e637c79acc198$export$f96d196f7728bb5(el, selector) {
        let method = el.matches || el.matchesSelector || el.msMatchesSelector;
        return method.call(el, selector);
    }
    function $087e637c79acc198$export$9f4f30ee63539e24(container, selector) {
        let containers = container instanceof HTMLElement ? [
            container
        ] : container;
        let allMatches = [];
        for(let i = 0; i < containers.length; i += 1){
            let matches = containers[i].querySelectorAll(selector);
            for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
        }
        return allMatches;
    }
    function $087e637c79acc198$export$faec65b429be379(parent, selector) {
        let parents = parent instanceof HTMLElement ? [
            parent
        ] : parent;
        let allMatches = [];
        for(let i = 0; i < parents.length; i += 1){
            let childNodes = parents[i].children;
            for(let j = 0; j < childNodes.length; j += 1){
                let childNode = childNodes[j];
                if (!selector || $087e637c79acc198$export$f96d196f7728bb5(childNode, selector)) allMatches.push(childNode);
            }
        }
        return allMatches;
    }
    const $087e637c79acc198$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
    function $087e637c79acc198$export$2ed0fc6709e59212(el, props) {
        for(let propName in props)$087e637c79acc198$export$f787f51d84a910ad(el, propName, props[propName]);
    }
    function $087e637c79acc198$export$f787f51d84a910ad(el, name, val) {
        if (val == null) el.style[name] = '';
        else if (typeof val === 'number' && $087e637c79acc198$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
        else el.style[name] = val;
    }
    function $087e637c79acc198$export$738ab4df8bf92ae9(ev) {
        var _a, _b;
        return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
    }
    let $087e637c79acc198$var$guid$1 = 0;
    function $087e637c79acc198$export$a8550f7dbe79f93a() {
        $087e637c79acc198$var$guid$1 += 1;
        return 'fc-dom-' + $087e637c79acc198$var$guid$1;
    }
    function $087e637c79acc198$export$d29e374196577086(ev) {
        ev.preventDefault();
    }
    function $087e637c79acc198$var$buildDelegationHandler(selector, handler) {
        return (ev)=>{
            let matchedChild = $087e637c79acc198$export$3d8c2f653ac9d0b9(ev.target, selector);
            if (matchedChild) handler.call(matchedChild, ev, matchedChild);
        };
    }
    function $087e637c79acc198$export$3c2fa207a37baaea(container, eventType, selector, handler) {
        let attachedHandler = $087e637c79acc198$var$buildDelegationHandler(selector, handler);
        container.addEventListener(eventType, attachedHandler);
        return ()=>{
            container.removeEventListener(eventType, attachedHandler);
        };
    }
    function $087e637c79acc198$export$ce26c07117d59d6a(container, selector, onMouseEnter, onMouseLeave) {
        let currentMatchedChild;
        return $087e637c79acc198$export$3c2fa207a37baaea(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
            if (matchedChild !== currentMatchedChild) {
                currentMatchedChild = matchedChild;
                onMouseEnter(mouseOverEv, matchedChild);
                let realOnMouseLeave = (mouseLeaveEv)=>{
                    currentMatchedChild = null;
                    onMouseLeave(mouseLeaveEv, matchedChild);
                    matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
                };
                matchedChild.addEventListener('mouseleave', realOnMouseLeave);
            }
        });
    }
    const $087e637c79acc198$var$transitionEventNames = [
        'webkitTransitionEnd',
        'otransitionend',
        'oTransitionEnd',
        'msTransitionEnd',
        'transitionend'
    ];
    function $087e637c79acc198$export$2ec5befb9e6c97d4(el, callback) {
        let realCallback = (ev)=>{
            callback(ev);
            $087e637c79acc198$var$transitionEventNames.forEach((eventName)=>{
                el.removeEventListener(eventName, realCallback);
            });
        };
        $087e637c79acc198$var$transitionEventNames.forEach((eventName)=>{
            el.addEventListener(eventName, realCallback);
        });
    }
    function $087e637c79acc198$var$createAriaClickAttrs(handler) {
        return Object.assign({
            onClick: handler
        }, $087e637c79acc198$var$createAriaKeyboardAttrs(handler));
    }
    function $087e637c79acc198$var$createAriaKeyboardAttrs(handler) {
        return {
            tabIndex: 0,
            onKeyDown (ev) {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    handler(ev);
                    ev.preventDefault();
                }
            }
        };
    }
    let $087e637c79acc198$var$guidNumber = 0;
    function $087e637c79acc198$export$39b482c5e57630a8() {
        $087e637c79acc198$var$guidNumber += 1;
        return String($087e637c79acc198$var$guidNumber);
    }
    function $087e637c79acc198$export$9fa96a7d116ea3ce() {
        document.body.classList.add('fc-not-allowed');
    }
    function $087e637c79acc198$export$92108d983e8ee699() {
        document.body.classList.remove('fc-not-allowed');
    }
    function $087e637c79acc198$export$d24c54395ce0c509(el) {
        el.style.userSelect = 'none';
        el.addEventListener('selectstart', $087e637c79acc198$export$d29e374196577086);
    }
    function $087e637c79acc198$export$6554612db691658e(el) {
        el.style.userSelect = '';
        el.removeEventListener('selectstart', $087e637c79acc198$export$d29e374196577086);
    }
    function $087e637c79acc198$export$493d36ec626b6698(el) {
        el.addEventListener('contextmenu', $087e637c79acc198$export$d29e374196577086);
    }
    function $087e637c79acc198$export$1fbe638ecf81657e(el) {
        el.removeEventListener('contextmenu', $087e637c79acc198$export$d29e374196577086);
    }
    function $087e637c79acc198$export$7a38258bbe170828(input) {
        let specs = [];
        let tokens = [];
        let i;
        let token;
        if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
        else if (typeof input === 'function') tokens = [
            input
        ];
        else if (Array.isArray(input)) tokens = input;
        for(i = 0; i < tokens.length; i += 1){
            token = tokens[i];
            if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
                field: token.substring(1),
                order: -1
            } : {
                field: token,
                order: 1
            });
            else if (typeof token === 'function') specs.push({
                func: token
            });
        }
        return specs;
    }
    function $087e637c79acc198$export$2f6ca3d3b1f80bf5(obj0, obj1, fieldSpecs) {
        let i;
        let cmp;
        for(i = 0; i < fieldSpecs.length; i += 1){
            cmp = $087e637c79acc198$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
            if (cmp) return cmp;
        }
        return 0;
    }
    function $087e637c79acc198$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
        if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
        return $087e637c79acc198$export$8a5498727ef6be21(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
    }
    function $087e637c79acc198$export$8a5498727ef6be21(a, b) {
        if (!a && !b) return 0;
        if (b == null) return -1;
        if (a == null) return 1;
        if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
        return a - b;
    }
    function $087e637c79acc198$export$1a82df3d29112e01(val, len) {
        let s = String(val);
        return '000'.substr(0, len - s.length) + s;
    }
    function $087e637c79acc198$export$35e795649ee09318(formatter, args, fallbackText) {
        if (typeof formatter === 'function') return formatter(...args);
        if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
        return fallbackText;
    }
    function $087e637c79acc198$export$d66dc83d8cfc8dd(a, b) {
        return a - b;
    }
    function $087e637c79acc198$export$306ddfe3a8403e2(n) {
        return n % 1 === 0;
    }
    function $087e637c79acc198$var$computeSmallestCellWidth(cellEl) {
        let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
        let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
        if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className');
        if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
        return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + contentWidthEl.getBoundingClientRect().width;
    }
    const $087e637c79acc198$var$INTERNAL_UNITS = [
        'years',
        'months',
        'days',
        'milliseconds'
    ];
    const $087e637c79acc198$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
    function $087e637c79acc198$export$4368d992c4eafac0(input, unit) {
        if (typeof input === 'string') return $087e637c79acc198$var$parseString(input);
        if (typeof input === 'object' && input) return $087e637c79acc198$var$parseObject(input);
        if (typeof input === 'number') return $087e637c79acc198$var$parseObject({
            [unit || 'milliseconds']: input
        });
        return null;
    }
    function $087e637c79acc198$var$parseString(s) {
        let m = $087e637c79acc198$var$PARSE_RE.exec(s);
        if (m) {
            let sign = m[1] ? -1 : 1;
            return {
                years: 0,
                months: 0,
                days: sign * (m[2] ? parseInt(m[2], 10) : 0),
                milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + (m[4] ? parseInt(m[4], 10) : 0) * 60000 + (m[5] ? parseInt(m[5], 10) : 0) * 1000 + (m[6] ? parseInt(m[6], 10) : 0))
            };
        }
        return null;
    }
    function $087e637c79acc198$var$parseObject(obj) {
        let duration = {
            years: obj.years || obj.year || 0,
            months: obj.months || obj.month || 0,
            days: obj.days || obj.day || 0,
            milliseconds: (obj.hours || obj.hour || 0) * 3600000 + (obj.minutes || obj.minute || 0) * 60000 + (obj.seconds || obj.second || 0) * 1000 + (obj.milliseconds || obj.millisecond || obj.ms || 0)
        };
        let weeks = obj.weeks || obj.week;
        if (weeks) {
            duration.days += weeks * 7;
            duration.specifiedWeeks = true;
        }
        return duration;
    }
    function $087e637c79acc198$var$durationsEqual(d0, d1) {
        return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
    }
    function $087e637c79acc198$export$acf3ba20e47771d(dur) {
        if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
        return 0;
    }
    function $087e637c79acc198$export$b169257caa88022a(d0, d1) {
        return {
            years: d0.years + d1.years,
            months: d0.months + d1.months,
            days: d0.days + d1.days,
            milliseconds: d0.milliseconds + d1.milliseconds
        };
    }
    function $087e637c79acc198$export$2408f22a0fab9ae5(d1, d0) {
        return {
            years: d1.years - d0.years,
            months: d1.months - d0.months,
            days: d1.days - d0.days,
            milliseconds: d1.milliseconds - d0.milliseconds
        };
    }
    function $087e637c79acc198$export$847533e5bf524f5f(d, n) {
        return {
            years: d.years * n,
            months: d.months * n,
            days: d.days * n,
            milliseconds: d.milliseconds * n
        };
    }
    function $087e637c79acc198$var$asRoughYears(dur) {
        return $087e637c79acc198$var$asRoughDays(dur) / 365;
    }
    function $087e637c79acc198$var$asRoughMonths(dur) {
        return $087e637c79acc198$var$asRoughDays(dur) / 30;
    }
    function $087e637c79acc198$var$asRoughDays(dur) {
        return $087e637c79acc198$export$4e222d082f82ee97(dur) / 864e5;
    }
    function $087e637c79acc198$export$4b170465d7badfa1(dur) {
        return $087e637c79acc198$export$4e222d082f82ee97(dur) / 60000;
    }
    function $087e637c79acc198$export$479ac0420f53ed26(dur) {
        return $087e637c79acc198$export$4e222d082f82ee97(dur) / 1000;
    }
    function $087e637c79acc198$export$4e222d082f82ee97(dur) {
        return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
    }
    function $087e637c79acc198$export$56350196709588fc(numerator, denominator) {
        let res = null;
        for(let i = 0; i < $087e637c79acc198$var$INTERNAL_UNITS.length; i += 1){
            let unit = $087e637c79acc198$var$INTERNAL_UNITS[i];
            if (denominator[unit]) {
                let localRes = numerator[unit] / denominator[unit];
                if (!$087e637c79acc198$export$306ddfe3a8403e2(localRes) || res !== null && res !== localRes) return null;
                res = localRes;
            } else if (numerator[unit]) return null;
        }
        return res;
    }
    function $087e637c79acc198$export$db3b6bfb95261072(dur) {
        let ms = dur.milliseconds;
        if (ms) {
            if (ms % 1000 !== 0) return {
                unit: 'millisecond',
                value: ms
            };
            if (ms % 60000 !== 0) return {
                unit: 'second',
                value: ms / 1000
            };
            if (ms % 3600000 !== 0) return {
                unit: 'minute',
                value: ms / 60000
            };
            if (ms) return {
                unit: 'hour',
                value: ms / 3600000
            };
        }
        if (dur.days) {
            if (dur.specifiedWeeks && dur.days % 7 === 0) return {
                unit: 'week',
                value: dur.days / 7
            };
            return {
                unit: 'day',
                value: dur.days
            };
        }
        if (dur.months) return {
            unit: 'month',
            value: dur.months
        };
        if (dur.years) return {
            unit: 'year',
            value: dur.years
        };
        return {
            unit: 'millisecond',
            value: 0
        };
    }
    function $087e637c79acc198$export$9d398bebfec1c039(array, exactVal) {
        let removeCnt = 0;
        let i = 0;
        while(i < array.length)if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt += 1;
        } else i += 1;
        return removeCnt;
    }
    function $087e637c79acc198$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
        if (a0 === a1) return true;
        let len = a0.length;
        let i;
        if (len !== a1.length) return false;
        for(i = 0; i < len; i += 1){
            if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
        }
        return true;
    }
    const $087e637c79acc198$var$DAY_IDS = [
        'sun',
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat'
    ];
    function $087e637c79acc198$export$31e67cf12fc9668(m, n) {
        let a = $087e637c79acc198$var$dateToUtcArray(m);
        a[2] += n * 7;
        return $087e637c79acc198$var$arrayToUtcDate(a);
    }
    function $087e637c79acc198$export$9e5f44173e64f162(m, n) {
        let a = $087e637c79acc198$var$dateToUtcArray(m);
        a[2] += n;
        return $087e637c79acc198$var$arrayToUtcDate(a);
    }
    function $087e637c79acc198$export$136fd86de524d3c2(m, n) {
        let a = $087e637c79acc198$var$dateToUtcArray(m);
        a[6] += n;
        return $087e637c79acc198$var$arrayToUtcDate(a);
    }
    function $087e637c79acc198$export$62d08d6fa708df47(m0, m1) {
        return $087e637c79acc198$export$a36fb7d24305ed9d(m0, m1) / 7;
    }
    function $087e637c79acc198$export$a36fb7d24305ed9d(m0, m1) {
        return (m1.valueOf() - m0.valueOf()) / 86400000;
    }
    function $087e637c79acc198$var$diffHours(m0, m1) {
        return (m1.valueOf() - m0.valueOf()) / 3600000;
    }
    function $087e637c79acc198$var$diffMinutes(m0, m1) {
        return (m1.valueOf() - m0.valueOf()) / 60000;
    }
    function $087e637c79acc198$var$diffSeconds(m0, m1) {
        return (m1.valueOf() - m0.valueOf()) / 1000;
    }
    function $087e637c79acc198$export$5521614468b862fb(m0, m1) {
        let m0day = $087e637c79acc198$export$ae1af26003f05816(m0);
        let m1day = $087e637c79acc198$export$ae1af26003f05816(m1);
        return {
            years: 0,
            months: 0,
            days: Math.round($087e637c79acc198$export$a36fb7d24305ed9d(m0day, m1day)),
            milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
        };
    }
    function $087e637c79acc198$export$b4d5ecaefe2b27f3(m0, m1) {
        let d = $087e637c79acc198$export$d141bba7fdc215a3(m0, m1);
        if (d !== null && d % 7 === 0) return d / 7;
        return null;
    }
    function $087e637c79acc198$export$d141bba7fdc215a3(m0, m1) {
        if ($087e637c79acc198$var$timeAsMs(m0) === $087e637c79acc198$var$timeAsMs(m1)) return Math.round($087e637c79acc198$export$a36fb7d24305ed9d(m0, m1));
        return null;
    }
    function $087e637c79acc198$export$ae1af26003f05816(m) {
        return $087e637c79acc198$var$arrayToUtcDate([
            m.getUTCFullYear(),
            m.getUTCMonth(),
            m.getUTCDate()
        ]);
    }
    function $087e637c79acc198$var$startOfHour(m) {
        return $087e637c79acc198$var$arrayToUtcDate([
            m.getUTCFullYear(),
            m.getUTCMonth(),
            m.getUTCDate(),
            m.getUTCHours()
        ]);
    }
    function $087e637c79acc198$var$startOfMinute(m) {
        return $087e637c79acc198$var$arrayToUtcDate([
            m.getUTCFullYear(),
            m.getUTCMonth(),
            m.getUTCDate(),
            m.getUTCHours(),
            m.getUTCMinutes()
        ]);
    }
    function $087e637c79acc198$var$startOfSecond(m) {
        return $087e637c79acc198$var$arrayToUtcDate([
            m.getUTCFullYear(),
            m.getUTCMonth(),
            m.getUTCDate(),
            m.getUTCHours(),
            m.getUTCMinutes(),
            m.getUTCSeconds()
        ]);
    }
    function $087e637c79acc198$var$weekOfYear(marker, dow, doy) {
        let y = marker.getUTCFullYear();
        let w = $087e637c79acc198$var$weekOfGivenYear(marker, y, dow, doy);
        if (w < 1) return $087e637c79acc198$var$weekOfGivenYear(marker, y - 1, dow, doy);
        let nextW = $087e637c79acc198$var$weekOfGivenYear(marker, y + 1, dow, doy);
        if (nextW >= 1) return Math.min(w, nextW);
        return w;
    }
    function $087e637c79acc198$var$weekOfGivenYear(marker, year, dow, doy) {
        let firstWeekStart = $087e637c79acc198$var$arrayToUtcDate([
            year,
            0,
            1 + $087e637c79acc198$var$firstWeekOffset(year, dow, doy)
        ]);
        let dayStart = $087e637c79acc198$export$ae1af26003f05816(marker);
        let days = Math.round($087e637c79acc198$export$a36fb7d24305ed9d(firstWeekStart, dayStart));
        return Math.floor(days / 7) + 1;
    }
    function $087e637c79acc198$var$firstWeekOffset(year, dow, doy) {
        let fwd = 7 + dow - doy;
        let fwdlw = (7 + $087e637c79acc198$var$arrayToUtcDate([
            year,
            0,
            fwd
        ]).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    function $087e637c79acc198$var$dateToLocalArray(date) {
        return [
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
            date.getMilliseconds()
        ];
    }
    function $087e637c79acc198$var$arrayToLocalDate(a) {
        return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
    }
    function $087e637c79acc198$var$dateToUtcArray(date) {
        return [
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
            date.getUTCMilliseconds()
        ];
    }
    function $087e637c79acc198$var$arrayToUtcDate(a) {
        if (a.length === 1) a = a.concat([
            0
        ]);
        return new Date(Date.UTC(...a));
    }
    function $087e637c79acc198$export$55ff3cc1821e8445(m) {
        return !isNaN(m.valueOf());
    }
    function $087e637c79acc198$var$timeAsMs(m) {
        return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
    }
    function $087e637c79acc198$export$45d219bdcd8ac53c(marker, timeZoneOffset, stripZeroTime = false) {
        let s = marker.toISOString();
        s = s.replace('.000', '');
        if (stripZeroTime) s = s.replace('T00:00:00Z', '');
        if (s.length > 10) {
            if (timeZoneOffset == null) s = s.replace('Z', '');
            else if (timeZoneOffset !== 0) s = s.replace('Z', $087e637c79acc198$var$formatTimeZoneOffset(timeZoneOffset, true));
        }
        return s;
    }
    function $087e637c79acc198$export$5dbe06c6d8c68cfb(marker) {
        return marker.toISOString().replace(/T.*$/, '');
    }
    function $087e637c79acc198$export$26a0a7676ca7aa04(marker) {
        return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
    }
    function $087e637c79acc198$export$f438b12253c2b499(marker) {
        return $087e637c79acc198$export$1a82df3d29112e01(marker.getUTCHours(), 2) + ':' + $087e637c79acc198$export$1a82df3d29112e01(marker.getUTCMinutes(), 2) + ':' + $087e637c79acc198$export$1a82df3d29112e01(marker.getUTCSeconds(), 2);
    }
    function $087e637c79acc198$var$formatTimeZoneOffset(minutes, doIso = false) {
        let sign = minutes < 0 ? '-' : '+';
        let abs = Math.abs(minutes);
        let hours = Math.floor(abs / 60);
        let mins = Math.round(abs % 60);
        if (doIso) return `${sign + $087e637c79acc198$export$1a82df3d29112e01(hours, 2)}:${$087e637c79acc198$export$1a82df3d29112e01(mins, 2)}`;
        return `GMT${sign}${hours}${mins ? `:${$087e637c79acc198$export$1a82df3d29112e01(mins, 2)}` : ''}`;
    }
    function $087e637c79acc198$export$4a5767248b18ef41(workerFunc, resEquality, teardownFunc) {
        let currentArgs;
        let currentRes;
        return function(...newArgs) {
            if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
            else if (!$087e637c79acc198$export$23f2a1d2818174ef(currentArgs, newArgs)) {
                if (teardownFunc) teardownFunc(currentRes);
                let res = workerFunc.apply(this, newArgs);
                if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
            }
            currentArgs = newArgs;
            return currentRes;
        };
    }
    function $087e637c79acc198$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
        let currentArg;
        let currentRes;
        return (newArg)=>{
            if (!currentArg) currentRes = workerFunc.call(this, newArg);
            else if (!$087e637c79acc198$export$ebd11618f299a286(currentArg, newArg)) {
                if (teardownFunc) teardownFunc(currentRes);
                let res = workerFunc.call(this, newArg);
                if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
            }
            currentArg = newArg;
            return currentRes;
        };
    }
    function $087e637c79acc198$export$890c4ad488842ce7(workerFunc, resEquality, teardownFunc) {
        let currentArgSets = [];
        let currentResults = [];
        return (newArgSets)=>{
            let currentLen = currentArgSets.length;
            let newLen = newArgSets.length;
            let i = 0;
            for(; i < currentLen; i += 1){
                if (!newArgSets[i]) {
                    if (teardownFunc) teardownFunc(currentResults[i]);
                } else if (!$087e637c79acc198$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                    if (teardownFunc) teardownFunc(currentResults[i]);
                    let res = workerFunc.apply(this, newArgSets[i]);
                    if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
                }
            }
            for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
            currentArgSets = newArgSets;
            currentResults.splice(newLen);
            return currentResults;
        };
    }
    function $087e637c79acc198$export$24baa2b76016ce0e(workerFunc, resEquality, teardownFunc) {
        let currentArgHash = {};
        let currentResHash = {};
        return (newArgHash)=>{
            let newResHash = {};
            for(let key in newArgHash){
                if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
                else if (!$087e637c79acc198$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                    if (teardownFunc) teardownFunc(currentResHash[key]);
                    let res = workerFunc.apply(this, newArgHash[key]);
                    newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
                } else newResHash[key] = currentResHash[key];
            }
            currentArgHash = newArgHash;
            currentResHash = newResHash;
            return newResHash;
        };
    }
    const $087e637c79acc198$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
        week: 3,
        separator: 0,
        omitZeroMinute: 0,
        meridiem: 0,
        omitCommas: 0
    };
    const $087e637c79acc198$var$STANDARD_DATE_PROP_SEVERITIES = {
        timeZoneName: 7,
        era: 6,
        year: 5,
        month: 4,
        day: 2,
        weekday: 2,
        hour: 1,
        minute: 1,
        second: 1
    };
    const $087e637c79acc198$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i;
    const $087e637c79acc198$var$COMMA_RE = /,/g;
    const $087e637c79acc198$var$MULTI_SPACE_RE = /\s+/g;
    const $087e637c79acc198$var$LTR_RE = /\u200e/g;
    const $087e637c79acc198$var$UTC_RE = /UTC|GMT/;
    class $087e637c79acc198$var$NativeFormatter {
        constructor(formatSettings){
            let standardDateProps = {};
            let extendedSettings = {};
            let severity = 0;
            for(let name in formatSettings)if (name in $087e637c79acc198$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
                extendedSettings[name] = formatSettings[name];
                severity = Math.max($087e637c79acc198$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], severity);
            } else {
                standardDateProps[name] = formatSettings[name];
                if (name in $087e637c79acc198$var$STANDARD_DATE_PROP_SEVERITIES) severity = Math.max($087e637c79acc198$var$STANDARD_DATE_PROP_SEVERITIES[name], severity);
            }
            this.standardDateProps = standardDateProps;
            this.extendedSettings = extendedSettings;
            this.severity = severity;
            this.buildFormattingFunc = $087e637c79acc198$export$4a5767248b18ef41($087e637c79acc198$var$buildFormattingFunc);
        }
        format(date, context) {
            return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
        }
        formatRange(start, end, context, betterDefaultSeparator) {
            let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
            let diffSeverity = $087e637c79acc198$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
            if (!diffSeverity) return this.format(start, context);
            let biggestUnitForPartial = diffSeverity;
            if (biggestUnitForPartial > 1 && (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1;
            let full0 = this.format(start, context);
            let full1 = this.format(end, context);
            if (full0 === full1) return full0;
            let partialDateProps = $087e637c79acc198$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
            let partialFormattingFunc = $087e637c79acc198$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
            let partial0 = partialFormattingFunc(start);
            let partial1 = partialFormattingFunc(end);
            let insertion = $087e637c79acc198$var$findCommonInsertion(full0, partial0, full1, partial1);
            let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
            if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
            return full0 + separator + full1;
        }
        getLargestUnit() {
            switch(this.severity){
                case 7:
                case 6:
                case 5:
                    return 'year';
                case 4:
                    return 'month';
                case 3:
                    return 'week';
                case 2:
                    return 'day';
                default:
                    return 'time';
            }
        }
    }
    function $087e637c79acc198$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
        let standardDatePropCnt = Object.keys(standardDateProps).length;
        if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>$087e637c79acc198$var$formatTimeZoneOffset(date.timeZoneOffset);
        if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$087e637c79acc198$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
        return $087e637c79acc198$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
    }
    function $087e637c79acc198$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
        standardDateProps = Object.assign({}, standardDateProps);
        extendedSettings = Object.assign({}, extendedSettings);
        $087e637c79acc198$var$sanitizeSettings(standardDateProps, extendedSettings);
        standardDateProps.timeZone = 'UTC';
        let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
        let zeroFormat;
        if (extendedSettings.omitZeroMinute) {
            let zeroProps = Object.assign({}, standardDateProps);
            delete zeroProps.minute;
            zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
        }
        return (date)=>{
            let { marker: marker } = date;
            let format;
            if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
            else format = normalFormat;
            let s = format.format(marker);
            return $087e637c79acc198$var$postProcess(s, date, standardDateProps, extendedSettings, context);
        };
    }
    function $087e637c79acc198$var$sanitizeSettings(standardDateProps, extendedSettings) {
        if (standardDateProps.timeZoneName) {
            if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
            if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
        }
        if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
        if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
    }
    function $087e637c79acc198$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
        s = s.replace($087e637c79acc198$var$LTR_RE, '');
        if (standardDateProps.timeZoneName === 'short') s = $087e637c79acc198$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $087e637c79acc198$var$formatTimeZoneOffset(date.timeZoneOffset));
        if (extendedSettings.omitCommas) s = s.replace($087e637c79acc198$var$COMMA_RE, '').trim();
        if (extendedSettings.omitZeroMinute) s = s.replace(':00', '');
        if (extendedSettings.meridiem === false) s = s.replace($087e637c79acc198$var$MERIDIEM_RE, '').trim();
        else if (extendedSettings.meridiem === 'narrow') s = s.replace($087e637c79acc198$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
        else if (extendedSettings.meridiem === 'short') s = s.replace($087e637c79acc198$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
        else if (extendedSettings.meridiem === 'lowercase') s = s.replace($087e637c79acc198$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
        s = s.replace($087e637c79acc198$var$MULTI_SPACE_RE, ' ');
        s = s.trim();
        return s;
    }
    function $087e637c79acc198$var$injectTzoStr(s, tzoStr) {
        let replaced = false;
        s = s.replace($087e637c79acc198$var$UTC_RE, ()=>{
            replaced = true;
            return tzoStr;
        });
        if (!replaced) s += ` ${tzoStr}`;
        return s;
    }
    function $087e637c79acc198$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
        let parts = [];
        if (display === 'long') parts.push(weekTextLong);
        else if (display === 'short' || display === 'narrow') parts.push(weekText);
        if (display === 'long' || display === 'short') parts.push(' ');
        parts.push(locale.simpleNumberFormat.format(num));
        if (locale.options.direction === 'rtl') parts.reverse();
        return parts.join('');
    }
    function $087e637c79acc198$var$computeMarkerDiffSeverity(d0, d1, ca) {
        if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
        if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
        if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
        if ($087e637c79acc198$var$timeAsMs(d0) !== $087e637c79acc198$var$timeAsMs(d1)) return 1;
        return 0;
    }
    function $087e637c79acc198$var$computePartialFormattingOptions(options, biggestUnit) {
        let partialOptions = {};
        for(let name in options)if (!(name in $087e637c79acc198$var$STANDARD_DATE_PROP_SEVERITIES) || $087e637c79acc198$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
        return partialOptions;
    }
    function $087e637c79acc198$var$findCommonInsertion(full0, partial0, full1, partial1) {
        let i0 = 0;
        while(i0 < full0.length){
            let found0 = full0.indexOf(partial0, i0);
            if (found0 === -1) break;
            let before0 = full0.substr(0, found0);
            i0 = found0 + partial0.length;
            let after0 = full0.substr(i0);
            let i1 = 0;
            while(i1 < full1.length){
                let found1 = full1.indexOf(partial1, i1);
                if (found1 === -1) break;
                let before1 = full1.substr(0, found1);
                i1 = found1 + partial1.length;
                let after1 = full1.substr(i1);
                if (before0 === before1 && after0 === after1) return {
                    before: before0,
                    after: after0
                };
            }
        }
        return null;
    }
    function $087e637c79acc198$var$expandZonedMarker(dateInfo, calendarSystem) {
        let a = calendarSystem.markerToArray(dateInfo.marker);
        return {
            marker: dateInfo.marker,
            timeZoneOffset: dateInfo.timeZoneOffset,
            array: a,
            year: a[0],
            month: a[1],
            day: a[2],
            hour: a[3],
            minute: a[4],
            second: a[5],
            millisecond: a[6]
        };
    }
    function $087e637c79acc198$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
        let startInfo = $087e637c79acc198$var$expandZonedMarker(start, context.calendarSystem);
        let endInfo = end ? $087e637c79acc198$var$expandZonedMarker(end, context.calendarSystem) : null;
        return {
            date: startInfo,
            start: startInfo,
            end: endInfo,
            timeZone: context.timeZone,
            localeCodes: context.locale.codes,
            defaultSeparator: betterDefaultSeparator || context.defaultSeparator
        };
    }
    class $087e637c79acc198$var$CmdFormatter {
        constructor(cmdStr){
            this.cmdStr = cmdStr;
        }
        format(date, context, betterDefaultSeparator) {
            return context.cmdFormatter(this.cmdStr, $087e637c79acc198$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
        }
        formatRange(start, end, context, betterDefaultSeparator) {
            return context.cmdFormatter(this.cmdStr, $087e637c79acc198$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
        }
    }
    class $087e637c79acc198$var$FuncFormatter {
        constructor(func){
            this.func = func;
        }
        format(date, context, betterDefaultSeparator) {
            return this.func($087e637c79acc198$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
        }
        formatRange(start, end, context, betterDefaultSeparator) {
            return this.func($087e637c79acc198$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
        }
    }
    function $087e637c79acc198$export$efccba1c4a2ef57b(input) {
        if (typeof input === 'object' && input) return new $087e637c79acc198$var$NativeFormatter(input);
        if (typeof input === 'string') return new $087e637c79acc198$var$CmdFormatter(input);
        if (typeof input === 'function') return new $087e637c79acc198$var$FuncFormatter(input);
        return null;
    }
    const $087e637c79acc198$export$3a1a48c8f6ef640e = {
        navLinkDayClick: $087e637c79acc198$export$882b5998b3b9117c,
        navLinkWeekClick: $087e637c79acc198$export$882b5998b3b9117c,
        duration: $087e637c79acc198$export$4368d992c4eafac0,
        bootstrapFontAwesome: $087e637c79acc198$export$882b5998b3b9117c,
        buttonIcons: $087e637c79acc198$export$882b5998b3b9117c,
        customButtons: $087e637c79acc198$export$882b5998b3b9117c,
        defaultAllDayEventDuration: $087e637c79acc198$export$4368d992c4eafac0,
        defaultTimedEventDuration: $087e637c79acc198$export$4368d992c4eafac0,
        nextDayThreshold: $087e637c79acc198$export$4368d992c4eafac0,
        scrollTime: $087e637c79acc198$export$4368d992c4eafac0,
        scrollTimeReset: Boolean,
        slotMinTime: $087e637c79acc198$export$4368d992c4eafac0,
        slotMaxTime: $087e637c79acc198$export$4368d992c4eafac0,
        dayPopoverFormat: $087e637c79acc198$export$efccba1c4a2ef57b,
        slotDuration: $087e637c79acc198$export$4368d992c4eafac0,
        snapDuration: $087e637c79acc198$export$4368d992c4eafac0,
        headerToolbar: $087e637c79acc198$export$882b5998b3b9117c,
        footerToolbar: $087e637c79acc198$export$882b5998b3b9117c,
        defaultRangeSeparator: String,
        titleRangeSeparator: String,
        forceEventDuration: Boolean,
        dayHeaders: Boolean,
        dayHeaderFormat: $087e637c79acc198$export$efccba1c4a2ef57b,
        dayHeaderClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        dayHeaderContent: $087e637c79acc198$export$882b5998b3b9117c,
        dayHeaderDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        dayHeaderWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        dayCellClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        dayCellContent: $087e637c79acc198$export$882b5998b3b9117c,
        dayCellDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        dayCellWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        initialView: String,
        aspectRatio: Number,
        weekends: Boolean,
        weekNumberCalculation: $087e637c79acc198$export$882b5998b3b9117c,
        weekNumbers: Boolean,
        weekNumberClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        weekNumberContent: $087e637c79acc198$export$882b5998b3b9117c,
        weekNumberDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        weekNumberWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        editable: Boolean,
        viewClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        viewDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        viewWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        nowIndicator: Boolean,
        nowIndicatorClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        nowIndicatorContent: $087e637c79acc198$export$882b5998b3b9117c,
        nowIndicatorDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        nowIndicatorWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        showNonCurrentDates: Boolean,
        lazyFetching: Boolean,
        startParam: String,
        endParam: String,
        timeZoneParam: String,
        timeZone: String,
        locales: $087e637c79acc198$export$882b5998b3b9117c,
        locale: $087e637c79acc198$export$882b5998b3b9117c,
        themeSystem: String,
        dragRevertDuration: Number,
        dragScroll: Boolean,
        allDayMaintainDuration: Boolean,
        unselectAuto: Boolean,
        dropAccept: $087e637c79acc198$export$882b5998b3b9117c,
        eventOrder: $087e637c79acc198$export$7a38258bbe170828,
        eventOrderStrict: Boolean,
        handleWindowResize: Boolean,
        windowResizeDelay: Number,
        longPressDelay: Number,
        eventDragMinDistance: Number,
        expandRows: Boolean,
        height: $087e637c79acc198$export$882b5998b3b9117c,
        contentHeight: $087e637c79acc198$export$882b5998b3b9117c,
        direction: String,
        weekNumberFormat: $087e637c79acc198$export$efccba1c4a2ef57b,
        eventResizableFromStart: Boolean,
        displayEventTime: Boolean,
        displayEventEnd: Boolean,
        weekText: String,
        weekTextLong: String,
        progressiveEventRendering: Boolean,
        businessHours: $087e637c79acc198$export$882b5998b3b9117c,
        initialDate: $087e637c79acc198$export$882b5998b3b9117c,
        now: $087e637c79acc198$export$882b5998b3b9117c,
        eventDataTransform: $087e637c79acc198$export$882b5998b3b9117c,
        stickyHeaderDates: $087e637c79acc198$export$882b5998b3b9117c,
        stickyFooterScrollbar: $087e637c79acc198$export$882b5998b3b9117c,
        viewHeight: $087e637c79acc198$export$882b5998b3b9117c,
        defaultAllDay: Boolean,
        eventSourceFailure: $087e637c79acc198$export$882b5998b3b9117c,
        eventSourceSuccess: $087e637c79acc198$export$882b5998b3b9117c,
        eventDisplay: String,
        eventStartEditable: Boolean,
        eventDurationEditable: Boolean,
        eventOverlap: $087e637c79acc198$export$882b5998b3b9117c,
        eventConstraint: $087e637c79acc198$export$882b5998b3b9117c,
        eventAllow: $087e637c79acc198$export$882b5998b3b9117c,
        eventBackgroundColor: String,
        eventBorderColor: String,
        eventTextColor: String,
        eventColor: String,
        eventClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        eventContent: $087e637c79acc198$export$882b5998b3b9117c,
        eventDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        eventWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        selectConstraint: $087e637c79acc198$export$882b5998b3b9117c,
        selectOverlap: $087e637c79acc198$export$882b5998b3b9117c,
        selectAllow: $087e637c79acc198$export$882b5998b3b9117c,
        droppable: Boolean,
        unselectCancel: String,
        slotLabelFormat: $087e637c79acc198$export$882b5998b3b9117c,
        slotLaneClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        slotLaneContent: $087e637c79acc198$export$882b5998b3b9117c,
        slotLaneDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        slotLaneWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        slotLabelClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        slotLabelContent: $087e637c79acc198$export$882b5998b3b9117c,
        slotLabelDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        slotLabelWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        dayMaxEvents: $087e637c79acc198$export$882b5998b3b9117c,
        dayMaxEventRows: $087e637c79acc198$export$882b5998b3b9117c,
        dayMinWidth: Number,
        slotLabelInterval: $087e637c79acc198$export$4368d992c4eafac0,
        allDayText: String,
        allDayClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        allDayContent: $087e637c79acc198$export$882b5998b3b9117c,
        allDayDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        allDayWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        slotMinWidth: Number,
        navLinks: Boolean,
        eventTimeFormat: $087e637c79acc198$export$efccba1c4a2ef57b,
        rerenderDelay: Number,
        moreLinkText: $087e637c79acc198$export$882b5998b3b9117c,
        moreLinkHint: $087e637c79acc198$export$882b5998b3b9117c,
        selectMinDistance: Number,
        selectable: Boolean,
        selectLongPressDelay: Number,
        eventLongPressDelay: Number,
        selectMirror: Boolean,
        eventMaxStack: Number,
        eventMinHeight: Number,
        eventMinWidth: Number,
        eventShortHeight: Number,
        slotEventOverlap: Boolean,
        plugins: $087e637c79acc198$export$882b5998b3b9117c,
        firstDay: Number,
        dayCount: Number,
        dateAlignment: String,
        dateIncrement: $087e637c79acc198$export$4368d992c4eafac0,
        hiddenDays: $087e637c79acc198$export$882b5998b3b9117c,
        fixedWeekCount: Boolean,
        validRange: $087e637c79acc198$export$882b5998b3b9117c,
        visibleRange: $087e637c79acc198$export$882b5998b3b9117c,
        titleFormat: $087e637c79acc198$export$882b5998b3b9117c,
        eventInteractive: Boolean,
        noEventsText: String,
        viewHint: $087e637c79acc198$export$882b5998b3b9117c,
        navLinkHint: $087e637c79acc198$export$882b5998b3b9117c,
        closeHint: String,
        timeHint: String,
        eventHint: String,
        moreLinkClick: $087e637c79acc198$export$882b5998b3b9117c,
        moreLinkClassNames: $087e637c79acc198$export$882b5998b3b9117c,
        moreLinkContent: $087e637c79acc198$export$882b5998b3b9117c,
        moreLinkDidMount: $087e637c79acc198$export$882b5998b3b9117c,
        moreLinkWillUnmount: $087e637c79acc198$export$882b5998b3b9117c,
        monthStartFormat: $087e637c79acc198$export$efccba1c4a2ef57b,
        handleCustomRendering: $087e637c79acc198$export$882b5998b3b9117c,
        customRenderingMetaMap: $087e637c79acc198$export$882b5998b3b9117c,
        customRenderingReplacesEl: Boolean
    };
    const $087e637c79acc198$export$ef35774e6d314e91 = {
        eventDisplay: 'auto',
        defaultRangeSeparator: ' - ',
        titleRangeSeparator: ' \u2013 ',
        defaultTimedEventDuration: '01:00:00',
        defaultAllDayEventDuration: {
            day: 1
        },
        forceEventDuration: false,
        nextDayThreshold: '00:00:00',
        dayHeaders: true,
        initialView: '',
        aspectRatio: 1.35,
        headerToolbar: {
            start: 'title',
            center: '',
            end: 'today prev,next'
        },
        weekends: true,
        weekNumbers: false,
        weekNumberCalculation: 'local',
        editable: false,
        nowIndicator: false,
        scrollTime: '06:00:00',
        scrollTimeReset: true,
        slotMinTime: '00:00:00',
        slotMaxTime: '24:00:00',
        showNonCurrentDates: true,
        lazyFetching: true,
        startParam: 'start',
        endParam: 'end',
        timeZoneParam: 'timeZone',
        timeZone: 'local',
        locales: [],
        locale: '',
        themeSystem: 'standard',
        dragRevertDuration: 500,
        dragScroll: true,
        allDayMaintainDuration: false,
        unselectAuto: true,
        dropAccept: '*',
        eventOrder: 'start,-duration,allDay,title',
        dayPopoverFormat: {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        },
        handleWindowResize: true,
        windowResizeDelay: 100,
        longPressDelay: 1000,
        eventDragMinDistance: 5,
        expandRows: false,
        navLinks: false,
        selectable: false,
        eventMinHeight: 15,
        eventMinWidth: 30,
        eventShortHeight: 30,
        monthStartFormat: {
            month: 'long',
            day: 'numeric'
        }
    };
    const $087e637c79acc198$export$a07804094c3ecf2d = {
        datesSet: $087e637c79acc198$export$882b5998b3b9117c,
        eventsSet: $087e637c79acc198$export$882b5998b3b9117c,
        eventAdd: $087e637c79acc198$export$882b5998b3b9117c,
        eventChange: $087e637c79acc198$export$882b5998b3b9117c,
        eventRemove: $087e637c79acc198$export$882b5998b3b9117c,
        windowResize: $087e637c79acc198$export$882b5998b3b9117c,
        eventClick: $087e637c79acc198$export$882b5998b3b9117c,
        eventMouseEnter: $087e637c79acc198$export$882b5998b3b9117c,
        eventMouseLeave: $087e637c79acc198$export$882b5998b3b9117c,
        select: $087e637c79acc198$export$882b5998b3b9117c,
        unselect: $087e637c79acc198$export$882b5998b3b9117c,
        loading: $087e637c79acc198$export$882b5998b3b9117c,
        _unmount: $087e637c79acc198$export$882b5998b3b9117c,
        _beforeprint: $087e637c79acc198$export$882b5998b3b9117c,
        _afterprint: $087e637c79acc198$export$882b5998b3b9117c,
        _noEventDrop: $087e637c79acc198$export$882b5998b3b9117c,
        _noEventResize: $087e637c79acc198$export$882b5998b3b9117c,
        _resize: $087e637c79acc198$export$882b5998b3b9117c,
        _scrollRequest: $087e637c79acc198$export$882b5998b3b9117c
    };
    const $087e637c79acc198$export$c4ce752e73470fba = {
        buttonText: $087e637c79acc198$export$882b5998b3b9117c,
        buttonHints: $087e637c79acc198$export$882b5998b3b9117c,
        views: $087e637c79acc198$export$882b5998b3b9117c,
        plugins: $087e637c79acc198$export$882b5998b3b9117c,
        initialEvents: $087e637c79acc198$export$882b5998b3b9117c,
        events: $087e637c79acc198$export$882b5998b3b9117c,
        eventSources: $087e637c79acc198$export$882b5998b3b9117c
    };
    const $087e637c79acc198$export$56c0d5a1e737357d = {
        headerToolbar: $087e637c79acc198$var$isMaybeObjectsEqual,
        footerToolbar: $087e637c79acc198$var$isMaybeObjectsEqual,
        buttonText: $087e637c79acc198$var$isMaybeObjectsEqual,
        buttonHints: $087e637c79acc198$var$isMaybeObjectsEqual,
        buttonIcons: $087e637c79acc198$var$isMaybeObjectsEqual,
        dateIncrement: $087e637c79acc198$var$isMaybeObjectsEqual,
        plugins: $087e637c79acc198$var$isMaybeArraysEqual,
        events: $087e637c79acc198$var$isMaybeArraysEqual,
        eventSources: $087e637c79acc198$var$isMaybeArraysEqual,
        ['resources']: $087e637c79acc198$var$isMaybeArraysEqual
    };
    function $087e637c79acc198$var$isMaybeObjectsEqual(a, b) {
        if (typeof a === 'object' && typeof b === 'object' && a && b) return $087e637c79acc198$export$ebd11618f299a286(a, b);
        return a === b;
    }
    function $087e637c79acc198$var$isMaybeArraysEqual(a, b) {
        if (Array.isArray(a) && Array.isArray(b)) return $087e637c79acc198$export$23f2a1d2818174ef(a, b);
        return a === b;
    }
    const $087e637c79acc198$export$3722cfe417b6ed86 = {
        type: String,
        component: $087e637c79acc198$export$882b5998b3b9117c,
        buttonText: String,
        buttonTextKey: String,
        dateProfileGeneratorClass: $087e637c79acc198$export$882b5998b3b9117c,
        usesMinMaxTime: Boolean,
        classNames: $087e637c79acc198$export$882b5998b3b9117c,
        content: $087e637c79acc198$export$882b5998b3b9117c,
        didMount: $087e637c79acc198$export$882b5998b3b9117c,
        willUnmount: $087e637c79acc198$export$882b5998b3b9117c
    };
    function $087e637c79acc198$export$61196ced6d74a310(optionSets) {
        return $087e637c79acc198$export$953cecd6e717a553(optionSets, $087e637c79acc198$export$56c0d5a1e737357d);
    }
    function $087e637c79acc198$export$f38c853ae54ed474(input, refiners) {
        let refined = {};
        let extra = {};
        for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
        for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
        return {
            refined: refined,
            extra: extra
        };
    }
    function $087e637c79acc198$export$882b5998b3b9117c(raw) {
        return raw;
    }
    const { hasOwnProperty: $087e637c79acc198$var$hasOwnProperty } = Object.prototype;
    function $087e637c79acc198$export$953cecd6e717a553(propObjs, complexPropsMap) {
        let dest = {};
        if (complexPropsMap) {
            for(let name in complexPropsMap)if (complexPropsMap[name] === $087e637c79acc198$var$isMaybeObjectsEqual) {
                let complexObjs = [];
                for(let i = propObjs.length - 1; i >= 0; i -= 1){
                    let val = propObjs[i][name];
                    if (typeof val === 'object' && val) complexObjs.unshift(val);
                    else if (val !== undefined) {
                        dest[name] = val;
                        break;
                    }
                }
                if (complexObjs.length) dest[name] = $087e637c79acc198$export$953cecd6e717a553(complexObjs);
            }
        }
        for(let i = propObjs.length - 1; i >= 0; i -= 1){
            let props = propObjs[i];
            for(let name in props)if (!(name in dest)) dest[name] = props[name];
        }
        return dest;
    }
    function $087e637c79acc198$export$2d1720544b23b823(hash, func) {
        let filtered = {};
        for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
        return filtered;
    }
    function $087e637c79acc198$export$407448d2b89b1813(hash, func) {
        let newHash = {};
        for(let key in hash)newHash[key] = func(hash[key], key);
        return newHash;
    }
    function $087e637c79acc198$export$f1e1789686576879(a) {
        let hash = {};
        for (let item of a)hash[item] = true;
        return hash;
    }
    function $087e637c79acc198$export$625550452a3fa3ec(obj) {
        let a = [];
        for(let key in obj)a.push(obj[key]);
        return a;
    }
    function $087e637c79acc198$export$ebd11618f299a286(obj0, obj1) {
        if (obj0 === obj1) return true;
        for(let key in obj0)if ($087e637c79acc198$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) return false;
        }
        for(let key in obj1)if ($087e637c79acc198$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) return false;
        }
        return true;
    }
    const $087e637c79acc198$var$HANDLER_RE = /^on[A-Z]/;
    function $087e637c79acc198$var$isNonHandlerPropsEqual(obj0, obj1) {
        const keys = $087e637c79acc198$var$getUnequalProps(obj0, obj1);
        for (let key of keys){
            if (!$087e637c79acc198$var$HANDLER_RE.test(key)) return false;
        }
        return true;
    }
    function $087e637c79acc198$var$getUnequalProps(obj0, obj1) {
        let keys = [];
        for(let key in obj0){
            if ($087e637c79acc198$var$hasOwnProperty.call(obj0, key)) {
                if (!(key in obj1)) keys.push(key);
            }
        }
        for(let key in obj1){
            if ($087e637c79acc198$var$hasOwnProperty.call(obj1, key)) {
                if (obj0[key] !== obj1[key]) keys.push(key);
            }
        }
        return keys;
    }
    function $087e637c79acc198$export$23ebac1979863676(oldProps, newProps, equalityFuncs = {}) {
        if (oldProps === newProps) return true;
        for(let key in newProps){
            if (key in oldProps && $087e637c79acc198$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
            else return false;
        }
        for(let key in oldProps){
            if (!(key in newProps)) return false;
        }
        return true;
    }
    function $087e637c79acc198$var$isObjValsEqual(val0, val1, comparator) {
        if (val0 === val1 || comparator === true) return true;
        if (comparator) return comparator(val0, val1);
        return false;
    }
    function $087e637c79acc198$export$91477dc880baac21(hash, startIndex = 0, endIndex, step = 1) {
        let res = [];
        if (endIndex == null) endIndex = Object.keys(hash).length;
        for(let i = startIndex; i < endIndex; i += step){
            let val = hash[i];
            if (val !== undefined) res.push(val);
        }
        return res;
    }
    let $087e637c79acc198$var$calendarSystemClassMap = {};
    function $087e637c79acc198$var$registerCalendarSystem(name, theClass) {
        $087e637c79acc198$var$calendarSystemClassMap[name] = theClass;
    }
    function $087e637c79acc198$var$createCalendarSystem(name) {
        return new $087e637c79acc198$var$calendarSystemClassMap[name]();
    }
    class $087e637c79acc198$var$GregorianCalendarSystem {
        getMarkerYear(d) {
            return d.getUTCFullYear();
        }
        getMarkerMonth(d) {
            return d.getUTCMonth();
        }
        getMarkerDay(d) {
            return d.getUTCDate();
        }
        arrayToMarker(arr) {
            return $087e637c79acc198$var$arrayToUtcDate(arr);
        }
        markerToArray(marker) {
            return $087e637c79acc198$var$dateToUtcArray(marker);
        }
    }
    $087e637c79acc198$var$registerCalendarSystem('gregory', $087e637c79acc198$var$GregorianCalendarSystem);
    const $087e637c79acc198$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
    function $087e637c79acc198$export$674f8f4247a5112e(str) {
        let m = $087e637c79acc198$var$ISO_RE.exec(str);
        if (m) {
            let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
            if ($087e637c79acc198$export$55ff3cc1821e8445(marker)) {
                let timeZoneOffset = null;
                if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
                return {
                    marker: marker,
                    isTimeUnspecified: !m[6],
                    timeZoneOffset: timeZoneOffset
                };
            }
        }
        return null;
    }
    class $087e637c79acc198$export$db202ddc8be9136 {
        constructor(settings){
            let timeZone = this.timeZone = settings.timeZone;
            let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
            if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
            this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
            this.calendarSystem = $087e637c79acc198$var$createCalendarSystem(settings.calendarSystem);
            this.locale = settings.locale;
            this.weekDow = settings.locale.week.dow;
            this.weekDoy = settings.locale.week.doy;
            if (settings.weekNumberCalculation === 'ISO') {
                this.weekDow = 1;
                this.weekDoy = 4;
            }
            if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
            if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
            this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
            this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
            this.cmdFormatter = settings.cmdFormatter;
            this.defaultSeparator = settings.defaultSeparator;
        }
        createMarker(input) {
            let meta = this.createMarkerMeta(input);
            if (meta === null) return null;
            return meta.marker;
        }
        createNowMarker() {
            if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
            return $087e637c79acc198$var$arrayToUtcDate($087e637c79acc198$var$dateToLocalArray(new Date()));
        }
        createMarkerMeta(input) {
            if (typeof input === 'string') return this.parse(input);
            let marker = null;
            if (typeof input === 'number') marker = this.timestampToMarker(input);
            else if (input instanceof Date) {
                input = input.valueOf();
                if (!isNaN(input)) marker = this.timestampToMarker(input);
            } else if (Array.isArray(input)) marker = $087e637c79acc198$var$arrayToUtcDate(input);
            if (marker === null || !$087e637c79acc198$export$55ff3cc1821e8445(marker)) return null;
            return {
                marker: marker,
                isTimeUnspecified: false,
                forcedTzo: null
            };
        }
        parse(s) {
            let parts = $087e637c79acc198$export$674f8f4247a5112e(s);
            if (parts === null) return null;
            let { marker: marker } = parts;
            let forcedTzo = null;
            if (parts.timeZoneOffset !== null) {
                if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
                else forcedTzo = parts.timeZoneOffset;
            }
            return {
                marker: marker,
                isTimeUnspecified: parts.isTimeUnspecified,
                forcedTzo: forcedTzo
            };
        }
        getYear(marker) {
            return this.calendarSystem.getMarkerYear(marker);
        }
        getMonth(marker) {
            return this.calendarSystem.getMarkerMonth(marker);
        }
        getDay(marker) {
            return this.calendarSystem.getMarkerDay(marker);
        }
        add(marker, dur) {
            let a = this.calendarSystem.markerToArray(marker);
            a[0] += dur.years;
            a[1] += dur.months;
            a[2] += dur.days;
            a[6] += dur.milliseconds;
            return this.calendarSystem.arrayToMarker(a);
        }
        subtract(marker, dur) {
            let a = this.calendarSystem.markerToArray(marker);
            a[0] -= dur.years;
            a[1] -= dur.months;
            a[2] -= dur.days;
            a[6] -= dur.milliseconds;
            return this.calendarSystem.arrayToMarker(a);
        }
        addYears(marker, n) {
            let a = this.calendarSystem.markerToArray(marker);
            a[0] += n;
            return this.calendarSystem.arrayToMarker(a);
        }
        addMonths(marker, n) {
            let a = this.calendarSystem.markerToArray(marker);
            a[1] += n;
            return this.calendarSystem.arrayToMarker(a);
        }
        diffWholeYears(m0, m1) {
            let { calendarSystem: calendarSystem } = this;
            if ($087e637c79acc198$var$timeAsMs(m0) === $087e637c79acc198$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
            return null;
        }
        diffWholeMonths(m0, m1) {
            let { calendarSystem: calendarSystem } = this;
            if ($087e637c79acc198$var$timeAsMs(m0) === $087e637c79acc198$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
            return null;
        }
        greatestWholeUnit(m0, m1) {
            let n = this.diffWholeYears(m0, m1);
            if (n !== null) return {
                unit: 'year',
                value: n
            };
            n = this.diffWholeMonths(m0, m1);
            if (n !== null) return {
                unit: 'month',
                value: n
            };
            n = $087e637c79acc198$export$b4d5ecaefe2b27f3(m0, m1);
            if (n !== null) return {
                unit: 'week',
                value: n
            };
            n = $087e637c79acc198$export$d141bba7fdc215a3(m0, m1);
            if (n !== null) return {
                unit: 'day',
                value: n
            };
            n = $087e637c79acc198$var$diffHours(m0, m1);
            if ($087e637c79acc198$export$306ddfe3a8403e2(n)) return {
                unit: 'hour',
                value: n
            };
            n = $087e637c79acc198$var$diffMinutes(m0, m1);
            if ($087e637c79acc198$export$306ddfe3a8403e2(n)) return {
                unit: 'minute',
                value: n
            };
            n = $087e637c79acc198$var$diffSeconds(m0, m1);
            if ($087e637c79acc198$export$306ddfe3a8403e2(n)) return {
                unit: 'second',
                value: n
            };
            return {
                unit: 'millisecond',
                value: m1.valueOf() - m0.valueOf()
            };
        }
        countDurationsBetween(m0, m1, d) {
            let diff;
            if (d.years) {
                diff = this.diffWholeYears(m0, m1);
                if (diff !== null) return diff / $087e637c79acc198$var$asRoughYears(d);
            }
            if (d.months) {
                diff = this.diffWholeMonths(m0, m1);
                if (diff !== null) return diff / $087e637c79acc198$var$asRoughMonths(d);
            }
            if (d.days) {
                diff = $087e637c79acc198$export$d141bba7fdc215a3(m0, m1);
                if (diff !== null) return diff / $087e637c79acc198$var$asRoughDays(d);
            }
            return (m1.valueOf() - m0.valueOf()) / $087e637c79acc198$export$4e222d082f82ee97(d);
        }
        startOf(m, unit) {
            if (unit === 'year') return this.startOfYear(m);
            if (unit === 'month') return this.startOfMonth(m);
            if (unit === 'week') return this.startOfWeek(m);
            if (unit === 'day') return $087e637c79acc198$export$ae1af26003f05816(m);
            if (unit === 'hour') return $087e637c79acc198$var$startOfHour(m);
            if (unit === 'minute') return $087e637c79acc198$var$startOfMinute(m);
            if (unit === 'second') return $087e637c79acc198$var$startOfSecond(m);
            return null;
        }
        startOfYear(m) {
            return this.calendarSystem.arrayToMarker([
                this.calendarSystem.getMarkerYear(m)
            ]);
        }
        startOfMonth(m) {
            return this.calendarSystem.arrayToMarker([
                this.calendarSystem.getMarkerYear(m),
                this.calendarSystem.getMarkerMonth(m)
            ]);
        }
        startOfWeek(m) {
            return this.calendarSystem.arrayToMarker([
                this.calendarSystem.getMarkerYear(m),
                this.calendarSystem.getMarkerMonth(m),
                m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
            ]);
        }
        computeWeekNumber(marker) {
            if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
            return $087e637c79acc198$var$weekOfYear(marker, this.weekDow, this.weekDoy);
        }
        format(marker, formatter, dateOptions = {}) {
            return formatter.format({
                marker: marker,
                timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
            }, this);
        }
        formatRange(start, end, formatter, dateOptions = {}) {
            if (dateOptions.isEndExclusive) end = $087e637c79acc198$export$136fd86de524d3c2(end, -1);
            return formatter.formatRange({
                marker: start,
                timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
            }, {
                marker: end,
                timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
            }, this, dateOptions.defaultSeparator);
        }
        formatIso(marker, extraOptions = {}) {
            let timeZoneOffset = null;
            if (!extraOptions.omitTimeZoneOffset) {
                if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
                else timeZoneOffset = this.offsetForMarker(marker);
            }
            return $087e637c79acc198$export$45d219bdcd8ac53c(marker, timeZoneOffset, extraOptions.omitTime);
        }
        timestampToMarker(ms) {
            if (this.timeZone === 'local') return $087e637c79acc198$var$arrayToUtcDate($087e637c79acc198$var$dateToLocalArray(new Date(ms)));
            if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
            return $087e637c79acc198$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
        }
        offsetForMarker(m) {
            if (this.timeZone === 'local') return -$087e637c79acc198$var$arrayToLocalDate($087e637c79acc198$var$dateToUtcArray(m)).getTimezoneOffset();
            if (this.timeZone === 'UTC') return 0;
            if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($087e637c79acc198$var$dateToUtcArray(m));
            return null;
        }
        toDate(m, forcedTzo) {
            if (this.timeZone === 'local') return $087e637c79acc198$var$arrayToLocalDate($087e637c79acc198$var$dateToUtcArray(m));
            if (this.timeZone === 'UTC') return new Date(m.valueOf());
            if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
            return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($087e637c79acc198$var$dateToUtcArray(m)) * 60000);
        }
    }
    class $087e637c79acc198$export$971d5caa766a69d7 {
        constructor(calendarOptions){
            if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
        }
        setIconOverride(iconOverrideHash) {
            let iconClassesCopy;
            let buttonName;
            if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
                iconClassesCopy = Object.assign({}, this.iconClasses);
                for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
                this.iconClasses = iconClassesCopy;
            } else if (iconOverrideHash === false) this.iconClasses = {};
        }
        applyIconOverridePrefix(className) {
            let prefix = this.iconOverridePrefix;
            if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
            return className;
        }
        getClass(key) {
            return this.classes[key] || '';
        }
        getIconClass(buttonName, isRtl) {
            let className;
            if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
            else className = this.iconClasses[buttonName];
            if (className) return `${this.baseIconClass} ${className}`;
            return '';
        }
        getCustomButtonIconClass(customButtonProps) {
            let className;
            if (this.iconOverrideCustomButtonOption) {
                className = customButtonProps[this.iconOverrideCustomButtonOption];
                if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
            }
            return '';
        }
    }
    $087e637c79acc198$export$971d5caa766a69d7.prototype.classes = {};
    $087e637c79acc198$export$971d5caa766a69d7.prototype.iconClasses = {};
    $087e637c79acc198$export$971d5caa766a69d7.prototype.baseIconClass = '';
    $087e637c79acc198$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
    function $087e637c79acc198$export$7910e0436ed8d1de(runBeforeFlush) {
        runBeforeFlush();
        let oldDebounceRendering = $77d02.options.debounceRendering;
        let callbackQ = [];
        function execCallbackSync(callback) {
            callbackQ.push(callback);
        }
        $77d02.options.debounceRendering = execCallbackSync;
        $77d02.render($77d02.createElement($087e637c79acc198$var$FakeComponent, {}), document.createElement('div'));
        while(callbackQ.length)callbackQ.shift()();
        $77d02.options.debounceRendering = oldDebounceRendering;
    }
    class $087e637c79acc198$var$FakeComponent extends $77d02.Component {
        render() {
            return $77d02.createElement('div', {});
        }
        componentDidMount() {
            this.setState({});
        }
    }
    function $087e637c79acc198$export$995eb9fca571757(defaultValue) {
        let ContextType = $77d02.createContext(defaultValue);
        let origProvider = ContextType.Provider;
        ContextType.Provider = function() {
            let isNew = !this.getChildContext;
            let children = origProvider.apply(this, arguments);
            if (isNew) {
                let subs = [];
                this.shouldComponentUpdate = (_props)=>{
                    if (this.props.value !== _props.value) subs.forEach((c)=>{
                        c.context = _props.value;
                        c.forceUpdate();
                    });
                };
                this.sub = (c)=>{
                    subs.push(c);
                    let old = c.componentWillUnmount;
                    c.componentWillUnmount = ()=>{
                        subs.splice(subs.indexOf(c), 1);
                        old && old.call(c);
                    };
                };
            }
            return children;
        };
        return ContextType;
    }
    class $087e637c79acc198$export$c5d7c1ac98841e53 {
        constructor(execFunc, emitter, scrollTime, scrollTimeReset){
            this.execFunc = execFunc;
            this.emitter = emitter;
            this.scrollTime = scrollTime;
            this.scrollTimeReset = scrollTimeReset;
            this.handleScrollRequest = (request)=>{
                this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
                this.drain();
            };
            emitter.on('_scrollRequest', this.handleScrollRequest);
            this.fireInitialScroll();
        }
        detach() {
            this.emitter.off('_scrollRequest', this.handleScrollRequest);
        }
        update(isDatesNew) {
            if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll();
            else this.drain();
        }
        fireInitialScroll() {
            this.handleScrollRequest({
                time: this.scrollTime
            });
        }
        drain() {
            if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
        }
    }
    const $087e637c79acc198$export$e7c866399fa523f5 = $087e637c79acc198$export$995eb9fca571757({});
    function $087e637c79acc198$export$efca4cbe5dd06740(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
        return {
            dateEnv: dateEnv,
            options: viewOptions,
            pluginHooks: pluginHooks,
            emitter: emitter,
            dispatch: dispatch,
            getCurrentData: getCurrentData,
            calendarApi: calendarApi,
            viewSpec: viewSpec,
            viewApi: viewApi,
            dateProfileGenerator: dateProfileGenerator,
            theme: theme,
            isRtl: viewOptions.direction === 'rtl',
            addResizeHandler (handler) {
                emitter.on('_resize', handler);
            },
            removeResizeHandler (handler) {
                emitter.off('_resize', handler);
            },
            createScrollResponder (execFunc) {
                return new $087e637c79acc198$export$c5d7c1ac98841e53(execFunc, emitter, $087e637c79acc198$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
            },
            registerInteractiveComponent: registerInteractiveComponent,
            unregisterInteractiveComponent: unregisterInteractiveComponent
        };
    }
    class $087e637c79acc198$export$6559d589eb85fbb6 extends (0, $77d02.Component) {
        shouldComponentUpdate(nextProps, nextState) {
            if (this.debug) console.log($087e637c79acc198$var$getUnequalProps(nextProps, this.props), $087e637c79acc198$var$getUnequalProps(nextState, this.state));
            return !$087e637c79acc198$export$23ebac1979863676(this.props, nextProps, this.propEquality) || !$087e637c79acc198$export$23ebac1979863676(this.state, nextState, this.stateEquality);
        }
        safeSetState(newState) {
            if (!$087e637c79acc198$export$23ebac1979863676(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
        }
    }
    $087e637c79acc198$export$6559d589eb85fbb6.addPropsEquality = $087e637c79acc198$var$addPropsEquality;
    $087e637c79acc198$export$6559d589eb85fbb6.addStateEquality = $087e637c79acc198$var$addStateEquality;
    $087e637c79acc198$export$6559d589eb85fbb6.contextType = $087e637c79acc198$export$e7c866399fa523f5;
    $087e637c79acc198$export$6559d589eb85fbb6.prototype.propEquality = {};
    $087e637c79acc198$export$6559d589eb85fbb6.prototype.stateEquality = {};
    class $087e637c79acc198$export$78acf4525d8a74c4 extends $087e637c79acc198$export$6559d589eb85fbb6 {
    }
    $087e637c79acc198$export$78acf4525d8a74c4.contextType = $087e637c79acc198$export$e7c866399fa523f5;
    function $087e637c79acc198$var$addPropsEquality(propEquality) {
        let hash = Object.create(this.prototype.propEquality);
        Object.assign(hash, propEquality);
        this.prototype.propEquality = hash;
    }
    function $087e637c79acc198$var$addStateEquality(stateEquality) {
        let hash = Object.create(this.prototype.stateEquality);
        Object.assign(hash, stateEquality);
        this.prototype.stateEquality = hash;
    }
    function $087e637c79acc198$export$8743009a87fcb00f(ref, current) {
        if (typeof ref === 'function') ref(current);
        else if (ref) ref.current = current;
    }
    class $087e637c79acc198$var$ContentInjector extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.id = $087e637c79acc198$export$39b482c5e57630a8();
            this.queuedDomNodes = [];
            this.currentDomNodes = [];
            this.handleEl = (el)=>{
                if (this.props.elRef) $087e637c79acc198$export$8743009a87fcb00f(this.props.elRef, el);
            };
        }
        render() {
            const { props: props, context: context } = this;
            const { options: options } = context;
            const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
            const attrs = $087e637c79acc198$export$a274e22fb40f762e(props);
            let useDefault = false;
            let innerContent;
            let queuedDomNodes = [];
            let currentGeneratorMeta;
            if (customGenerator != null) {
                const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $77d02.createElement)) : customGenerator;
                if (customGeneratorRes === true) useDefault = true;
                else {
                    const isObject = customGeneratorRes && typeof customGeneratorRes === 'object';
                    if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                        __html: customGeneratorRes.html
                    };
                    else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                    else if (!isObject && typeof customGeneratorRes !== 'function') innerContent = customGeneratorRes;
                    else currentGeneratorMeta = customGeneratorRes;
                }
            } else useDefault = !$087e637c79acc198$var$hasCustomRenderingHandler(props.generatorName, options);
            if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
            this.queuedDomNodes = queuedDomNodes;
            this.currentGeneratorMeta = currentGeneratorMeta;
            return (0, $77d02.createElement)(props.elTag, attrs, innerContent);
        }
        componentDidMount() {
            this.applyQueueudDomNodes();
            this.triggerCustomRendering(true);
        }
        componentDidUpdate() {
            this.applyQueueudDomNodes();
            this.triggerCustomRendering(true);
        }
        componentWillUnmount() {
            this.triggerCustomRendering(false);
        }
        triggerCustomRendering(isActive) {
            var _a;
            const { props: props, context: context } = this;
            const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
            if (handleCustomRendering) {
                const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
                if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                    id: this.id,
                    isActive: isActive,
                    containerEl: this.base,
                    reportNewContainerEl: this.handleEl,
                    generatorMeta: generatorMeta
                }, props), {
                    elClasses: (props.elClasses || []).filter($087e637c79acc198$var$isTruthy)
                }));
            }
        }
        applyQueueudDomNodes() {
            const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
            const el = this.base;
            if (!$087e637c79acc198$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
                currentDomNodes.forEach($087e637c79acc198$export$c03999cb2f36933f);
                for (let newNode of queuedDomNodes)el.appendChild(newNode);
                this.currentDomNodes = queuedDomNodes;
            }
        }
    }
    $087e637c79acc198$var$ContentInjector.addPropsEquality({
        elClasses: $087e637c79acc198$export$23f2a1d2818174ef,
        elStyle: $087e637c79acc198$export$ebd11618f299a286,
        elAttrs: $087e637c79acc198$var$isNonHandlerPropsEqual,
        renderProps: $087e637c79acc198$export$ebd11618f299a286
    });
    function $087e637c79acc198$var$hasCustomRenderingHandler(generatorName, options) {
        var _a;
        return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
    }
    function $087e637c79acc198$export$a274e22fb40f762e(props, extraClassNames) {
        const attrs = Object.assign(Object.assign({}, props.elAttrs), {
            ref: props.elRef
        });
        if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
        if (props.elStyle) attrs.style = props.elStyle;
        return attrs;
    }
    function $087e637c79acc198$var$isTruthy(val) {
        return Boolean(val);
    }
    const $087e637c79acc198$export$2219238a014317b0 = $087e637c79acc198$export$995eb9fca571757(0);
    class $087e637c79acc198$export$e7094788287c5e9b extends (0, $77d02.Component) {
        constructor(){
            super(...arguments);
            this.InnerContent = $087e637c79acc198$var$InnerContentInjector.bind(undefined, this);
            this.handleRootEl = (el)=>{
                this.rootEl = el;
                if (this.props.elRef) $087e637c79acc198$export$8743009a87fcb00f(this.props.elRef, el);
            };
        }
        render() {
            const { props: props } = this;
            const generatedClassNames = $087e637c79acc198$var$generateClassNames(props.classNameGenerator, props.renderProps);
            if (props.children) {
                const elAttrs = $087e637c79acc198$export$a274e22fb40f762e(props, generatedClassNames);
                const children = props.children(this.InnerContent, props.renderProps, elAttrs);
                if (props.elTag) return (0, $77d02.createElement)(props.elTag, elAttrs, children);
                else return children;
            } else return (0, $77d02.createElement)($087e637c79acc198$var$ContentInjector, Object.assign(Object.assign({}, props), {
                elRef: this.handleRootEl,
                elTag: props.elTag || 'div',
                elClasses: (props.elClasses || []).concat(generatedClassNames),
                renderId: this.context
            }));
        }
        componentDidMount() {
            var _a, _b;
            (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                el: this.rootEl || this.base
            }));
        }
        componentWillUnmount() {
            var _a, _b;
            (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                el: this.rootEl || this.base
            }));
        }
    }
    $087e637c79acc198$export$e7094788287c5e9b.contextType = $087e637c79acc198$export$2219238a014317b0;
    function $087e637c79acc198$var$InnerContentInjector(containerComponent, props) {
        const parentProps = containerComponent.props;
        return (0, $77d02.createElement)($087e637c79acc198$var$ContentInjector, Object.assign({
            renderProps: parentProps.renderProps,
            generatorName: parentProps.generatorName,
            customGenerator: parentProps.customGenerator,
            defaultGenerator: parentProps.defaultGenerator,
            renderId: containerComponent.context
        }, props));
    }
    function $087e637c79acc198$var$generateClassNames(classNameGenerator, renderProps) {
        const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
        return typeof classNames === 'string' ? [
            classNames
        ] : classNames;
    }
    class $087e637c79acc198$export$e9316ff9106cdb75 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        render() {
            let { props: props, context: context } = this;
            let { options: options } = context;
            let renderProps = {
                view: context.viewApi
            };
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, Object.assign({}, props, {
                elTag: props.elTag || 'div',
                elClasses: [
                    ...$087e637c79acc198$export$8b22cf2602fb60ce(props.viewSpec),
                    ...props.elClasses || []
                ],
                renderProps: renderProps,
                classNameGenerator: options.viewClassNames,
                generatorName: undefined,
                didMount: options.viewDidMount,
                willUnmount: options.viewWillUnmount
            }), ()=>props.children);
        }
    }
    function $087e637c79acc198$export$8b22cf2602fb60ce(viewSpec) {
        return [
            `fc-${viewSpec.type}-view`,
            'fc-view'
        ];
    }
    function $087e637c79acc198$var$parseRange(input, dateEnv) {
        let start = null;
        let end = null;
        if (input.start) start = dateEnv.createMarker(input.start);
        if (input.end) end = dateEnv.createMarker(input.end);
        if (!start && !end) return null;
        if (start && end && end < start) return null;
        return {
            start: start,
            end: end
        };
    }
    function $087e637c79acc198$var$invertRanges(ranges, constraintRange) {
        let invertedRanges = [];
        let { start: start } = constraintRange;
        let i;
        let dateRange;
        ranges.sort($087e637c79acc198$var$compareRanges);
        for(i = 0; i < ranges.length; i += 1){
            dateRange = ranges[i];
            if (dateRange.start > start) invertedRanges.push({
                start: start,
                end: dateRange.start
            });
            if (dateRange.end > start) start = dateRange.end;
        }
        if (start < constraintRange.end) invertedRanges.push({
            start: start,
            end: constraintRange.end
        });
        return invertedRanges;
    }
    function $087e637c79acc198$var$compareRanges(range0, range1) {
        return range0.start.valueOf() - range1.start.valueOf();
    }
    function $087e637c79acc198$export$7ccc53e8f1e7dfc5(range0, range1) {
        let { start: start, end: end } = range0;
        let newRange = null;
        if (range1.start !== null) {
            if (start === null) start = range1.start;
            else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
        }
        if (range1.end != null) {
            if (end === null) end = range1.end;
            else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
        }
        if (start === null || end === null || start < end) newRange = {
            start: start,
            end: end
        };
        return newRange;
    }
    function $087e637c79acc198$export$f074adc9fbd50943(range0, range1) {
        return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
    }
    function $087e637c79acc198$export$ad4aebacdcaf47f8(range0, range1) {
        return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
    }
    function $087e637c79acc198$export$4ae495d48253603d(outerRange, innerRange) {
        return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
    }
    function $087e637c79acc198$export$2329c99376c9d0a4(range, date) {
        return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
    }
    function $087e637c79acc198$var$constrainMarkerToRange(date, range) {
        if (range.start != null && date < range.start) return range.start;
        if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
        return date;
    }
    function $087e637c79acc198$var$computeAlignedDayRange(timedRange) {
        let dayCnt = Math.floor($087e637c79acc198$export$a36fb7d24305ed9d(timedRange.start, timedRange.end)) || 1;
        let start = $087e637c79acc198$export$ae1af26003f05816(timedRange.start);
        let end = $087e637c79acc198$export$9e5f44173e64f162(start, dayCnt);
        return {
            start: start,
            end: end
        };
    }
    function $087e637c79acc198$export$28f7fcd39efa255(timedRange, nextDayThreshold = $087e637c79acc198$export$4368d992c4eafac0(0)) {
        let startDay = null;
        let endDay = null;
        if (timedRange.end) {
            endDay = $087e637c79acc198$export$ae1af26003f05816(timedRange.end);
            let endTimeMS = timedRange.end.valueOf() - endDay.valueOf();
            if (endTimeMS && endTimeMS >= $087e637c79acc198$export$4e222d082f82ee97(nextDayThreshold)) endDay = $087e637c79acc198$export$9e5f44173e64f162(endDay, 1);
        }
        if (timedRange.start) {
            startDay = $087e637c79acc198$export$ae1af26003f05816(timedRange.start);
            if (endDay && endDay <= startDay) endDay = $087e637c79acc198$export$9e5f44173e64f162(startDay, 1);
        }
        return {
            start: startDay,
            end: endDay
        };
    }
    function $087e637c79acc198$export$3d12bd131bb975d1(range) {
        let visibleRange = $087e637c79acc198$export$28f7fcd39efa255(range);
        return $087e637c79acc198$export$a36fb7d24305ed9d(visibleRange.start, visibleRange.end) > 1;
    }
    function $087e637c79acc198$export$91c6e00c14e7e6fd(date0, date1, dateEnv, largeUnit) {
        if (largeUnit === 'year') return $087e637c79acc198$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
        if (largeUnit === 'month') return $087e637c79acc198$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
        return $087e637c79acc198$export$5521614468b862fb(date0, date1);
    }
    function $087e637c79acc198$export$9bb611d729802a56(currentDate, action) {
        switch(action.type){
            case 'CHANGE_DATE':
                return action.dateMarker;
            default:
                return currentDate;
        }
    }
    function $087e637c79acc198$export$d66501df72047452(options, dateEnv) {
        let initialDateInput = options.initialDate;
        if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
        return $087e637c79acc198$export$c3950d9923825c02(options.now, dateEnv);
    }
    function $087e637c79acc198$export$c3950d9923825c02(nowInput, dateEnv) {
        if (typeof nowInput === 'function') nowInput = nowInput();
        if (nowInput == null) return dateEnv.createNowMarker();
        return dateEnv.createMarker(nowInput);
    }
    class $087e637c79acc198$export$25ce5a424b770e84 {
        constructor(props){
            this.props = props;
            this.nowDate = $087e637c79acc198$export$c3950d9923825c02(props.nowInput, props.dateEnv);
            this.initHiddenDays();
        }
        buildPrev(currentDateProfile, currentDate, forceToValid) {
            let { dateEnv: dateEnv } = this.props;
            let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
            return this.build(prevDate, -1, forceToValid);
        }
        buildNext(currentDateProfile, currentDate, forceToValid) {
            let { dateEnv: dateEnv } = this.props;
            let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
            return this.build(nextDate, 1, forceToValid);
        }
        build(currentDate, direction, forceToValid = true) {
            let { props: props } = this;
            let validRange;
            let currentInfo;
            let isRangeAllDay;
            let renderRange;
            let activeRange;
            let isValid;
            validRange = this.buildValidRange();
            validRange = this.trimHiddenDays(validRange);
            if (forceToValid) currentDate = $087e637c79acc198$var$constrainMarkerToRange(currentDate, validRange);
            currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
            isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
            renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
            renderRange = this.trimHiddenDays(renderRange);
            activeRange = renderRange;
            if (!props.showNonCurrentDates) activeRange = $087e637c79acc198$export$7ccc53e8f1e7dfc5(activeRange, currentInfo.range);
            activeRange = this.adjustActiveRange(activeRange);
            activeRange = $087e637c79acc198$export$7ccc53e8f1e7dfc5(activeRange, validRange);
            isValid = $087e637c79acc198$export$ad4aebacdcaf47f8(currentInfo.range, validRange);
            if (!$087e637c79acc198$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
            return {
                currentDate: currentDate,
                validRange: validRange,
                currentRange: currentInfo.range,
                currentRangeUnit: currentInfo.unit,
                isRangeAllDay: isRangeAllDay,
                activeRange: activeRange,
                renderRange: renderRange,
                slotMinTime: props.slotMinTime,
                slotMaxTime: props.slotMaxTime,
                isValid: isValid,
                dateIncrement: this.buildDateIncrement(currentInfo.duration)
            };
        }
        buildValidRange() {
            let input = this.props.validRangeInput;
            let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.nowDate) : input;
            return this.refineRange(simpleInput) || {
                start: null,
                end: null
            };
        }
        buildCurrentRangeInfo(date, direction) {
            let { props: props } = this;
            let duration = null;
            let unit = null;
            let range = null;
            let dayCount;
            if (props.duration) {
                duration = props.duration;
                unit = props.durationUnit;
                range = this.buildRangeFromDuration(date, direction, duration, unit);
            } else if (dayCount = this.props.dayCount) {
                unit = 'day';
                range = this.buildRangeFromDayCount(date, direction, dayCount);
            } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
            else {
                duration = this.getFallbackDuration();
                unit = $087e637c79acc198$export$db3b6bfb95261072(duration).unit;
                range = this.buildRangeFromDuration(date, direction, duration, unit);
            }
            return {
                duration: duration,
                unit: unit,
                range: range
            };
        }
        getFallbackDuration() {
            return $087e637c79acc198$export$4368d992c4eafac0({
                day: 1
            });
        }
        adjustActiveRange(range) {
            let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
            let { start: start, end: end } = range;
            if (usesMinMaxTime) {
                if ($087e637c79acc198$var$asRoughDays(slotMinTime) < 0) {
                    start = $087e637c79acc198$export$ae1af26003f05816(start);
                    start = dateEnv.add(start, slotMinTime);
                }
                if ($087e637c79acc198$var$asRoughDays(slotMaxTime) > 1) {
                    end = $087e637c79acc198$export$ae1af26003f05816(end);
                    end = $087e637c79acc198$export$9e5f44173e64f162(end, -1);
                    end = dateEnv.add(end, slotMaxTime);
                }
            }
            return {
                start: start,
                end: end
            };
        }
        buildRangeFromDuration(date, direction, duration, unit) {
            let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
            let start;
            let end;
            let res;
            if (!dateAlignment) {
                let { dateIncrement: dateIncrement } = this.props;
                if (dateIncrement) {
                    if ($087e637c79acc198$export$4e222d082f82ee97(dateIncrement) < $087e637c79acc198$export$4e222d082f82ee97(duration)) dateAlignment = $087e637c79acc198$export$db3b6bfb95261072(dateIncrement).unit;
                    else dateAlignment = unit;
                } else dateAlignment = unit;
            }
            if ($087e637c79acc198$var$asRoughDays(duration) <= 1) {
                if (this.isHiddenDay(start)) {
                    start = this.skipHiddenDays(start, direction);
                    start = $087e637c79acc198$export$ae1af26003f05816(start);
                }
            }
            function computeRes() {
                start = dateEnv.startOf(date, dateAlignment);
                end = dateEnv.add(start, duration);
                res = {
                    start: start,
                    end: end
                };
            }
            computeRes();
            if (!this.trimHiddenDays(res)) {
                date = this.skipHiddenDays(date, direction);
                computeRes();
            }
            return res;
        }
        buildRangeFromDayCount(date, direction, dayCount) {
            let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
            let runningCount = 0;
            let start = date;
            let end;
            if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
            start = $087e637c79acc198$export$ae1af26003f05816(start);
            start = this.skipHiddenDays(start, direction);
            end = start;
            do {
                end = $087e637c79acc198$export$9e5f44173e64f162(end, 1);
                if (!this.isHiddenDay(end)) runningCount += 1;
            }while (runningCount < dayCount)
            return {
                start: start,
                end: end
            };
        }
        buildCustomVisibleRange(date) {
            let { props: props } = this;
            let input = props.visibleRangeInput;
            let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
            let range = this.refineRange(simpleInput);
            if (range && (range.start == null || range.end == null)) return null;
            return range;
        }
        buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
            return currentRange;
        }
        buildDateIncrement(fallback) {
            let { dateIncrement: dateIncrement } = this.props;
            let customAlignment;
            if (dateIncrement) return dateIncrement;
            if (customAlignment = this.props.dateAlignment) return $087e637c79acc198$export$4368d992c4eafac0(1, customAlignment);
            if (fallback) return fallback;
            return $087e637c79acc198$export$4368d992c4eafac0({
                days: 1
            });
        }
        refineRange(rangeInput) {
            if (rangeInput) {
                let range = $087e637c79acc198$var$parseRange(rangeInput, this.props.dateEnv);
                if (range) range = $087e637c79acc198$export$28f7fcd39efa255(range);
                return range;
            }
            return null;
        }
        initHiddenDays() {
            let hiddenDays = this.props.hiddenDays || [];
            let isHiddenDayHash = [];
            let dayCnt = 0;
            let i;
            if (this.props.weekends === false) hiddenDays.push(0, 6);
            for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
            if (!dayCnt) throw new Error('invalid hiddenDays');
            this.isHiddenDayHash = isHiddenDayHash;
        }
        trimHiddenDays(range) {
            let { start: start, end: end } = range;
            if (start) start = this.skipHiddenDays(start);
            if (end) end = this.skipHiddenDays(end, -1, true);
            if (start == null || end == null || start < end) return {
                start: start,
                end: end
            };
            return null;
        }
        isHiddenDay(day) {
            if (day instanceof Date) day = day.getUTCDay();
            return this.isHiddenDayHash[day];
        }
        skipHiddenDays(date, inc = 1, isExclusive = false) {
            while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $087e637c79acc198$export$9e5f44173e64f162(date, inc);
            return date;
        }
    }
    function $087e637c79acc198$export$3b513254972cfc9c(defId, range, forcedStartTzo, forcedEndTzo) {
        return {
            instanceId: $087e637c79acc198$export$39b482c5e57630a8(),
            defId: defId,
            range: range,
            forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
            forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
        };
    }
    function $087e637c79acc198$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
        for(let i = 0; i < recurringTypes.length; i += 1){
            let parsed = recurringTypes[i].parse(refined, dateEnv);
            if (parsed) {
                let { allDay: allDay } = refined;
                if (allDay == null) {
                    allDay = defaultAllDay;
                    if (allDay == null) {
                        allDay = parsed.allDayGuess;
                        if (allDay == null) allDay = false;
                    }
                }
                return {
                    allDay: allDay,
                    duration: parsed.duration,
                    typeData: parsed.typeData,
                    typeId: i
                };
            }
        }
        return null;
    }
    function $087e637c79acc198$var$expandRecurring(eventStore, framingRange, context) {
        let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
        let { defs: defs, instances: instances } = eventStore;
        instances = $087e637c79acc198$export$2d1720544b23b823(instances, (instance)=>!defs[instance.defId].recurringDef);
        for(let defId in defs){
            let def = defs[defId];
            if (def.recurringDef) {
                let { duration: duration } = def.recurringDef;
                if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
                let starts = $087e637c79acc198$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
                for (let start of starts){
                    let instance = $087e637c79acc198$export$3b513254972cfc9c(defId, {
                        start: start,
                        end: dateEnv.add(start, duration)
                    });
                    instances[instance.instanceId] = instance;
                }
            }
        }
        return {
            defs: defs,
            instances: instances
        };
    }
    function $087e637c79acc198$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
        let typeDef = recurringTypes[eventDef.recurringDef.typeId];
        let markers = typeDef.expand(eventDef.recurringDef.typeData, {
            start: dateEnv.subtract(framingRange.start, duration),
            end: framingRange.end
        }, dateEnv);
        if (eventDef.allDay) markers = markers.map($087e637c79acc198$export$ae1af26003f05816);
        return markers;
    }
    const $087e637c79acc198$var$EVENT_NON_DATE_REFINERS = {
        id: String,
        groupId: String,
        title: String,
        url: String,
        interactive: Boolean
    };
    const $087e637c79acc198$var$EVENT_DATE_REFINERS = {
        start: $087e637c79acc198$export$882b5998b3b9117c,
        end: $087e637c79acc198$export$882b5998b3b9117c,
        date: $087e637c79acc198$export$882b5998b3b9117c,
        allDay: Boolean
    };
    const $087e637c79acc198$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $087e637c79acc198$var$EVENT_NON_DATE_REFINERS), $087e637c79acc198$var$EVENT_DATE_REFINERS), {
        extendedProps: $087e637c79acc198$export$882b5998b3b9117c
    });
    function $087e637c79acc198$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $087e637c79acc198$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
        let { refined: refined, extra: extra } = $087e637c79acc198$export$ab83b03e4111b1d0(raw, context, refiners);
        let defaultAllDay = $087e637c79acc198$var$computeIsDefaultAllDay(eventSource, context);
        let recurringRes = $087e637c79acc198$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
        if (recurringRes) {
            let def = $087e637c79acc198$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
            def.recurringDef = {
                typeId: recurringRes.typeId,
                typeData: recurringRes.typeData,
                duration: recurringRes.duration
            };
            return {
                def: def,
                instance: null
            };
        }
        let singleRes = $087e637c79acc198$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
        if (singleRes) {
            let def = $087e637c79acc198$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
            let instance = $087e637c79acc198$export$3b513254972cfc9c(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
            if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
            return {
                def: def,
                instance: instance
            };
        }
        return null;
    }
    function $087e637c79acc198$export$ab83b03e4111b1d0(raw, context, refiners = $087e637c79acc198$var$buildEventRefiners(context)) {
        return $087e637c79acc198$export$f38c853ae54ed474(raw, refiners);
    }
    function $087e637c79acc198$var$buildEventRefiners(context) {
        return Object.assign(Object.assign(Object.assign({}, $087e637c79acc198$var$EVENT_UI_REFINERS), $087e637c79acc198$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
    }
    function $087e637c79acc198$export$21579262ef46735b(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
        let def = {
            title: refined.title || '',
            groupId: refined.groupId || '',
            publicId: refined.id || '',
            url: refined.url || '',
            recurringDef: null,
            defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $087e637c79acc198$export$39b482c5e57630a8(),
            sourceId: sourceId,
            allDay: allDay,
            hasEnd: hasEnd,
            interactive: refined.interactive,
            ui: $087e637c79acc198$export$3a6d5c9ae78a2c08(refined, context),
            extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
        };
        for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
        Object.freeze(def.ui.classNames);
        Object.freeze(def.extendedProps);
        return def;
    }
    function $087e637c79acc198$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
        let { allDay: allDay } = refined;
        let startMeta;
        let startMarker = null;
        let hasEnd = false;
        let endMeta;
        let endMarker = null;
        let startInput = refined.start != null ? refined.start : refined.date;
        startMeta = context.dateEnv.createMarkerMeta(startInput);
        if (startMeta) startMarker = startMeta.marker;
        else if (!allowOpenRange) return null;
        if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
        if (allDay == null) {
            if (defaultAllDay != null) allDay = defaultAllDay;
            else allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
        }
        if (allDay && startMarker) startMarker = $087e637c79acc198$export$ae1af26003f05816(startMarker);
        if (endMeta) {
            endMarker = endMeta.marker;
            if (allDay) endMarker = $087e637c79acc198$export$ae1af26003f05816(endMarker);
            if (startMarker && endMarker <= startMarker) endMarker = null;
        }
        if (endMarker) hasEnd = true;
        else if (!allowOpenRange) {
            hasEnd = context.options.forceEventDuration || false;
            endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
        }
        return {
            allDay: allDay,
            hasEnd: hasEnd,
            range: {
                start: startMarker,
                end: endMarker
            },
            forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
            forcedEndTzo: endMeta ? endMeta.forcedTzo : null
        };
    }
    function $087e637c79acc198$var$computeIsDefaultAllDay(eventSource, context) {
        let res = null;
        if (eventSource) res = eventSource.defaultAllDay;
        if (res == null) res = context.options.defaultAllDay;
        return res;
    }
    function $087e637c79acc198$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
        let eventStore = $087e637c79acc198$export$7f8ddf7c7c20b3cd();
        let eventRefiners = $087e637c79acc198$var$buildEventRefiners(context);
        for (let rawEvent of rawEvents){
            let tuple = $087e637c79acc198$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
            if (tuple) $087e637c79acc198$export$9d0e2d13d04f7070(tuple, eventStore);
        }
        return eventStore;
    }
    function $087e637c79acc198$export$9d0e2d13d04f7070(tuple, eventStore = $087e637c79acc198$export$7f8ddf7c7c20b3cd()) {
        eventStore.defs[tuple.def.defId] = tuple.def;
        if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
        return eventStore;
    }
    function $087e637c79acc198$export$1ee57be6f6687d2c(eventStore, instanceId) {
        let instance = eventStore.instances[instanceId];
        if (instance) {
            let def = eventStore.defs[instance.defId];
            let newStore = $087e637c79acc198$var$filterEventStoreDefs(eventStore, (lookDef)=>$087e637c79acc198$var$isEventDefsGrouped(def, lookDef));
            newStore.defs[def.defId] = def;
            newStore.instances[instance.instanceId] = instance;
            return newStore;
        }
        return $087e637c79acc198$export$7f8ddf7c7c20b3cd();
    }
    function $087e637c79acc198$var$isEventDefsGrouped(def0, def1) {
        return Boolean(def0.groupId && def0.groupId === def1.groupId);
    }
    function $087e637c79acc198$export$7f8ddf7c7c20b3cd() {
        return {
            defs: {},
            instances: {}
        };
    }
    function $087e637c79acc198$export$317a3d46287192d8(store0, store1) {
        return {
            defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
            instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
        };
    }
    function $087e637c79acc198$var$filterEventStoreDefs(eventStore, filterFunc) {
        let defs = $087e637c79acc198$export$2d1720544b23b823(eventStore.defs, filterFunc);
        let instances = $087e637c79acc198$export$2d1720544b23b823(eventStore.instances, (instance)=>defs[instance.defId]);
        return {
            defs: defs,
            instances: instances
        };
    }
    function $087e637c79acc198$var$excludeSubEventStore(master, sub) {
        let { defs: defs, instances: instances } = master;
        let filteredDefs = {};
        let filteredInstances = {};
        for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
        for(let instanceId in instances)if (!sub.instances[instanceId] && filteredDefs[instances[instanceId].defId]) filteredInstances[instanceId] = instances[instanceId];
        return {
            defs: filteredDefs,
            instances: filteredInstances
        };
    }
    function $087e637c79acc198$var$normalizeConstraint(input, context) {
        if (Array.isArray(input)) return $087e637c79acc198$var$parseEvents(input, null, context, true);
        if (typeof input === 'object' && input) return $087e637c79acc198$var$parseEvents([
            input
        ], null, context, true);
        if (input != null) return String(input);
        return null;
    }
    function $087e637c79acc198$export$d377dcb2b61d6c4e(raw) {
        if (Array.isArray(raw)) return raw;
        if (typeof raw === 'string') return raw.split(/\s+/);
        return [];
    }
    const $087e637c79acc198$var$EVENT_UI_REFINERS = {
        display: String,
        editable: Boolean,
        startEditable: Boolean,
        durationEditable: Boolean,
        constraint: $087e637c79acc198$export$882b5998b3b9117c,
        overlap: $087e637c79acc198$export$882b5998b3b9117c,
        allow: $087e637c79acc198$export$882b5998b3b9117c,
        className: $087e637c79acc198$export$d377dcb2b61d6c4e,
        classNames: $087e637c79acc198$export$d377dcb2b61d6c4e,
        color: String,
        backgroundColor: String,
        borderColor: String,
        textColor: String
    };
    const $087e637c79acc198$var$EMPTY_EVENT_UI = {
        display: null,
        startEditable: null,
        durationEditable: null,
        constraints: [],
        overlap: null,
        allows: [],
        backgroundColor: '',
        borderColor: '',
        textColor: '',
        classNames: []
    };
    function $087e637c79acc198$export$3a6d5c9ae78a2c08(refined, context) {
        let constraint = $087e637c79acc198$var$normalizeConstraint(refined.constraint, context);
        return {
            display: refined.display || null,
            startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
            durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
            constraints: constraint != null ? [
                constraint
            ] : [],
            overlap: refined.overlap != null ? refined.overlap : null,
            allows: refined.allow != null ? [
                refined.allow
            ] : [],
            backgroundColor: refined.backgroundColor || refined.color || '',
            borderColor: refined.borderColor || refined.color || '',
            textColor: refined.textColor || '',
            classNames: (refined.className || []).concat(refined.classNames || [])
        };
    }
    function $087e637c79acc198$export$1a8f5705751d8277(uis) {
        return uis.reduce($087e637c79acc198$var$combineTwoEventUis, $087e637c79acc198$var$EMPTY_EVENT_UI);
    }
    function $087e637c79acc198$var$combineTwoEventUis(item0, item1) {
        return {
            display: item1.display != null ? item1.display : item0.display,
            startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
            durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
            constraints: item0.constraints.concat(item1.constraints),
            overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
            allows: item0.allows.concat(item1.allows),
            backgroundColor: item1.backgroundColor || item0.backgroundColor,
            borderColor: item1.borderColor || item0.borderColor,
            textColor: item1.textColor || item0.textColor,
            classNames: item0.classNames.concat(item1.classNames)
        };
    }
    const $087e637c79acc198$var$EVENT_SOURCE_REFINERS = {
        id: String,
        defaultAllDay: Boolean,
        url: String,
        format: String,
        events: $087e637c79acc198$export$882b5998b3b9117c,
        eventDataTransform: $087e637c79acc198$export$882b5998b3b9117c,
        success: $087e637c79acc198$export$882b5998b3b9117c,
        failure: $087e637c79acc198$export$882b5998b3b9117c
    };
    function $087e637c79acc198$export$ffb5f4729a158638(raw, context, refiners = $087e637c79acc198$export$dda1d9f60106f0e9(context)) {
        let rawObj;
        if (typeof raw === 'string') rawObj = {
            url: raw
        };
        else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
            events: raw
        };
        else if (typeof raw === 'object' && raw) rawObj = raw;
        if (rawObj) {
            let { refined: refined, extra: extra } = $087e637c79acc198$export$f38c853ae54ed474(rawObj, refiners);
            let metaRes = $087e637c79acc198$var$buildEventSourceMeta(refined, context);
            if (metaRes) return {
                _raw: raw,
                isFetching: false,
                latestFetchId: '',
                fetchRange: null,
                defaultAllDay: refined.defaultAllDay,
                eventDataTransform: refined.eventDataTransform,
                success: refined.success,
                failure: refined.failure,
                publicId: refined.id || '',
                sourceId: $087e637c79acc198$export$39b482c5e57630a8(),
                sourceDefId: metaRes.sourceDefId,
                meta: metaRes.meta,
                ui: $087e637c79acc198$export$3a6d5c9ae78a2c08(refined, context),
                extendedProps: extra
            };
        }
        return null;
    }
    function $087e637c79acc198$export$dda1d9f60106f0e9(context) {
        return Object.assign(Object.assign(Object.assign({}, $087e637c79acc198$var$EVENT_UI_REFINERS), $087e637c79acc198$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
    }
    function $087e637c79acc198$var$buildEventSourceMeta(raw, context) {
        let defs = context.pluginHooks.eventSourceDefs;
        for(let i = defs.length - 1; i >= 0; i -= 1){
            let def = defs[i];
            let meta = def.parseMeta(raw);
            if (meta) return {
                sourceDefId: i,
                meta: meta
            };
        }
        return null;
    }
    function $087e637c79acc198$export$b4171a6734a65d42(eventStore, action, eventSources, dateProfile, context) {
        switch(action.type){
            case 'RECEIVE_EVENTS':
                return $087e637c79acc198$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
            case 'RESET_RAW_EVENTS':
                return $087e637c79acc198$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
            case 'ADD_EVENTS':
                return $087e637c79acc198$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
            case 'RESET_EVENTS':
                return action.eventStore;
            case 'MERGE_EVENTS':
                return $087e637c79acc198$export$317a3d46287192d8(eventStore, action.eventStore);
            case 'PREV':
            case 'NEXT':
            case 'CHANGE_DATE':
            case 'CHANGE_VIEW_TYPE':
                if (dateProfile) return $087e637c79acc198$var$expandRecurring(eventStore, dateProfile.activeRange, context);
                return eventStore;
            case 'REMOVE_EVENTS':
                return $087e637c79acc198$var$excludeSubEventStore(eventStore, action.eventStore);
            case 'REMOVE_EVENT_SOURCE':
                return $087e637c79acc198$var$excludeEventsBySourceId(eventStore, action.sourceId);
            case 'REMOVE_ALL_EVENT_SOURCES':
                return $087e637c79acc198$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId);
            case 'REMOVE_ALL_EVENTS':
                return $087e637c79acc198$export$7f8ddf7c7c20b3cd();
            default:
                return eventStore;
        }
    }
    function $087e637c79acc198$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
        if (eventSource && fetchId === eventSource.latestFetchId) {
            let subset = $087e637c79acc198$var$parseEvents($087e637c79acc198$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
            if (fetchRange) subset = $087e637c79acc198$var$expandRecurring(subset, fetchRange, context);
            return $087e637c79acc198$export$317a3d46287192d8($087e637c79acc198$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
        }
        return eventStore;
    }
    function $087e637c79acc198$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
        const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $087e637c79acc198$var$buildPublicIdMaps(existingEventStore);
        let newEventStore = $087e637c79acc198$var$parseEvents($087e637c79acc198$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
        return $087e637c79acc198$var$expandRecurring(newEventStore, activeRange, context);
    }
    function $087e637c79acc198$var$transformRawEvents(rawEvents, eventSource, context) {
        let calEachTransform = context.options.eventDataTransform;
        let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
        if (sourceEachTransform) rawEvents = $087e637c79acc198$var$transformEachRawEvent(rawEvents, sourceEachTransform);
        if (calEachTransform) rawEvents = $087e637c79acc198$var$transformEachRawEvent(rawEvents, calEachTransform);
        return rawEvents;
    }
    function $087e637c79acc198$var$transformEachRawEvent(rawEvents, func) {
        let refinedEvents;
        if (!func) refinedEvents = rawEvents;
        else {
            refinedEvents = [];
            for (let rawEvent of rawEvents){
                let refinedEvent = func(rawEvent);
                if (refinedEvent) refinedEvents.push(refinedEvent);
                else if (refinedEvent == null) refinedEvents.push(rawEvent);
            }
        }
        return refinedEvents;
    }
    function $087e637c79acc198$var$addEvent(eventStore, subset, expandRange, context) {
        if (expandRange) subset = $087e637c79acc198$var$expandRecurring(subset, expandRange, context);
        return $087e637c79acc198$export$317a3d46287192d8(eventStore, subset);
    }
    function $087e637c79acc198$export$3466f893ebf79586(eventStore, oldDateEnv, newDateEnv) {
        let { defs: defs } = eventStore;
        let instances = $087e637c79acc198$export$407448d2b89b1813(eventStore.instances, (instance)=>{
            let def = defs[instance.defId];
            if (def.allDay || def.recurringDef) return instance;
            return Object.assign(Object.assign({}, instance), {
                range: {
                    start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                    end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
                },
                forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
                forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
            });
        });
        return {
            defs: defs,
            instances: instances
        };
    }
    function $087e637c79acc198$var$excludeEventsBySourceId(eventStore, sourceId) {
        return $087e637c79acc198$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
    }
    function $087e637c79acc198$var$excludeInstances(eventStore, removals) {
        return {
            defs: eventStore.defs,
            instances: $087e637c79acc198$export$2d1720544b23b823(eventStore.instances, (instance)=>!removals[instance.instanceId])
        };
    }
    function $087e637c79acc198$var$buildPublicIdMaps(eventStore) {
        const { defs: defs, instances: instances } = eventStore;
        const defIdMap = {};
        const instanceIdMap = {};
        for(let defId in defs){
            const def = defs[defId];
            const { publicId: publicId } = def;
            if (publicId) defIdMap[publicId] = defId;
        }
        for(let instanceId in instances){
            const instance = instances[instanceId];
            const def = defs[instance.defId];
            const { publicId: publicId } = def;
            if (publicId) instanceIdMap[publicId] = instanceId;
        }
        return {
            defIdMap: defIdMap,
            instanceIdMap: instanceIdMap
        };
    }
    class $087e637c79acc198$export$a9c23c6ac3fc3eca {
        constructor(){
            this.handlers = {};
            this.thisContext = null;
        }
        setThisContext(thisContext) {
            this.thisContext = thisContext;
        }
        setOptions(options) {
            this.options = options;
        }
        on(type, handler) {
            $087e637c79acc198$var$addToHash(this.handlers, type, handler);
        }
        off(type, handler) {
            $087e637c79acc198$var$removeFromHash(this.handlers, type, handler);
        }
        trigger(type, ...args) {
            let attachedHandlers = this.handlers[type] || [];
            let optionHandler = this.options && this.options[type];
            let handlers = [].concat(optionHandler || [], attachedHandlers);
            for (let handler of handlers)handler.apply(this.thisContext, args);
        }
        hasHandlers(type) {
            return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
        }
    }
    function $087e637c79acc198$var$addToHash(hash, type, handler) {
        (hash[type] || (hash[type] = [])).push(handler);
    }
    function $087e637c79acc198$var$removeFromHash(hash, type, handler) {
        if (handler) {
            if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
        } else delete hash[type];
    }
    const $087e637c79acc198$var$DEF_DEFAULTS = {
        startTime: '09:00',
        endTime: '17:00',
        daysOfWeek: [
            1,
            2,
            3,
            4,
            5
        ],
        display: 'inverse-background',
        classNames: 'fc-non-business',
        groupId: '_businessHours'
    };
    function $087e637c79acc198$export$71cec2538cb2c617(input, context) {
        return $087e637c79acc198$var$parseEvents($087e637c79acc198$var$refineInputs(input), null, context);
    }
    function $087e637c79acc198$var$refineInputs(input) {
        let rawDefs;
        if (input === true) rawDefs = [
            {}
        ];
        else if (Array.isArray(input)) rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
        else if (typeof input === 'object' && input) rawDefs = [
            input
        ];
        else rawDefs = [];
        rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $087e637c79acc198$var$DEF_DEFAULTS), rawDef));
        return rawDefs;
    }
    function $087e637c79acc198$export$9ddbdd0bfc5623a(selection, pev, context) {
        context.emitter.trigger('select', Object.assign(Object.assign({}, $087e637c79acc198$var$buildDateSpanApiWithContext(selection, context)), {
            jsEvent: pev ? pev.origEvent : null,
            view: context.viewApi || context.calendarApi.view
        }));
    }
    function $087e637c79acc198$var$triggerDateUnselect(pev, context) {
        context.emitter.trigger('unselect', {
            jsEvent: pev ? pev.origEvent : null,
            view: context.viewApi || context.calendarApi.view
        });
    }
    function $087e637c79acc198$var$buildDateSpanApiWithContext(dateSpan, context) {
        let props = {};
        for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
        Object.assign(props, $087e637c79acc198$var$buildDateSpanApi(dateSpan, context.dateEnv));
        return props;
    }
    function $087e637c79acc198$export$1776704b6532a19a(allDay, marker, context) {
        let { dateEnv: dateEnv, options: options } = context;
        let end = marker;
        if (allDay) {
            end = $087e637c79acc198$export$ae1af26003f05816(end);
            end = dateEnv.add(end, options.defaultAllDayEventDuration);
        } else end = dateEnv.add(end, options.defaultTimedEventDuration);
        return end;
    }
    function $087e637c79acc198$export$6d1e945284085e64(eventStore, eventConfigBase, mutation, context) {
        let eventConfigs = $087e637c79acc198$var$compileEventUis(eventStore.defs, eventConfigBase);
        let dest = $087e637c79acc198$export$7f8ddf7c7c20b3cd();
        for(let defId in eventStore.defs){
            let def = eventStore.defs[defId];
            dest.defs[defId] = $087e637c79acc198$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
        }
        for(let instanceId in eventStore.instances){
            let instance = eventStore.instances[instanceId];
            let def = dest.defs[instance.defId];
            dest.instances[instanceId] = $087e637c79acc198$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
        }
        return dest;
    }
    function $087e637c79acc198$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
        let standardProps = mutation.standardProps || {};
        if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true;
        let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
            ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
        });
        if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
        for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
        if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
        return copy;
    }
    function $087e637c79acc198$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
        let { dateEnv: dateEnv } = context;
        let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
        let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
        let copy = Object.assign({}, eventInstance);
        if (forceAllDay) copy.range = $087e637c79acc198$var$computeAlignedDayRange(copy.range);
        if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
            start: dateEnv.add(copy.range.start, mutation.datesDelta),
            end: dateEnv.add(copy.range.end, mutation.datesDelta)
        };
        if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
            start: dateEnv.add(copy.range.start, mutation.startDelta),
            end: copy.range.end
        };
        if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
            start: copy.range.start,
            end: dateEnv.add(copy.range.end, mutation.endDelta)
        };
        if (clearEnd) copy.range = {
            start: copy.range.start,
            end: $087e637c79acc198$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context)
        };
        if (eventDef.allDay) copy.range = {
            start: $087e637c79acc198$export$ae1af26003f05816(copy.range.start),
            end: $087e637c79acc198$export$ae1af26003f05816(copy.range.end)
        };
        if (copy.range.end < copy.range.start) copy.range.end = $087e637c79acc198$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context);
        return copy;
    }
    class $087e637c79acc198$var$EventSourceImpl {
        constructor(context, internalEventSource){
            this.context = context;
            this.internalEventSource = internalEventSource;
        }
        remove() {
            this.context.dispatch({
                type: 'REMOVE_EVENT_SOURCE',
                sourceId: this.internalEventSource.sourceId
            });
        }
        refetch() {
            this.context.dispatch({
                type: 'FETCH_EVENT_SOURCES',
                sourceIds: [
                    this.internalEventSource.sourceId
                ],
                isRefetch: true
            });
        }
        get id() {
            return this.internalEventSource.publicId;
        }
        get url() {
            return this.internalEventSource.meta.url;
        }
        get format() {
            return this.internalEventSource.meta.format;
        }
    }
    class $087e637c79acc198$export$34aec0b863436764 {
        constructor(context, def, instance){
            this._context = context;
            this._def = def;
            this._instance = instance || null;
        }
        setProp(name, val) {
            if (name in $087e637c79acc198$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
            else if (name === 'id') {
                val = $087e637c79acc198$var$EVENT_NON_DATE_REFINERS[name](val);
                this.mutate({
                    standardProps: {
                        publicId: val
                    }
                });
            } else if (name in $087e637c79acc198$var$EVENT_NON_DATE_REFINERS) {
                val = $087e637c79acc198$var$EVENT_NON_DATE_REFINERS[name](val);
                this.mutate({
                    standardProps: {
                        [name]: val
                    }
                });
            } else if (name in $087e637c79acc198$var$EVENT_UI_REFINERS) {
                let ui = $087e637c79acc198$var$EVENT_UI_REFINERS[name](val);
                if (name === 'color') ui = {
                    backgroundColor: val,
                    borderColor: val
                };
                else if (name === 'editable') ui = {
                    startEditable: val,
                    durationEditable: val
                };
                else ui = {
                    [name]: val
                };
                this.mutate({
                    standardProps: {
                        ui: ui
                    }
                });
            } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
        }
        setExtendedProp(name, val) {
            this.mutate({
                extendedProps: {
                    [name]: val
                }
            });
        }
        setStart(startInput, options = {}) {
            let { dateEnv: dateEnv } = this._context;
            let start = dateEnv.createMarker(startInput);
            if (start && this._instance) {
                let instanceRange = this._instance.range;
                let startDelta = $087e637c79acc198$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity);
                if (options.maintainDuration) this.mutate({
                    datesDelta: startDelta
                });
                else this.mutate({
                    startDelta: startDelta
                });
            }
        }
        setEnd(endInput, options = {}) {
            let { dateEnv: dateEnv } = this._context;
            let end;
            if (endInput != null) {
                end = dateEnv.createMarker(endInput);
                if (!end) return;
            }
            if (this._instance) {
                if (end) {
                    let endDelta = $087e637c79acc198$export$91c6e00c14e7e6fd(this._instance.range.end, end, dateEnv, options.granularity);
                    this.mutate({
                        endDelta: endDelta
                    });
                } else this.mutate({
                    standardProps: {
                        hasEnd: false
                    }
                });
            }
        }
        setDates(startInput, endInput, options = {}) {
            let { dateEnv: dateEnv } = this._context;
            let standardProps = {
                allDay: options.allDay
            };
            let start = dateEnv.createMarker(startInput);
            let end;
            if (!start) return;
            if (endInput != null) {
                end = dateEnv.createMarker(endInput);
                if (!end) return;
            }
            if (this._instance) {
                let instanceRange = this._instance.range;
                if (options.allDay === true) instanceRange = $087e637c79acc198$var$computeAlignedDayRange(instanceRange);
                let startDelta = $087e637c79acc198$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity);
                if (end) {
                    let endDelta = $087e637c79acc198$export$91c6e00c14e7e6fd(instanceRange.end, end, dateEnv, options.granularity);
                    if ($087e637c79acc198$var$durationsEqual(startDelta, endDelta)) this.mutate({
                        datesDelta: startDelta,
                        standardProps: standardProps
                    });
                    else this.mutate({
                        startDelta: startDelta,
                        endDelta: endDelta,
                        standardProps: standardProps
                    });
                } else {
                    standardProps.hasEnd = false;
                    this.mutate({
                        datesDelta: startDelta,
                        standardProps: standardProps
                    });
                }
            }
        }
        moveStart(deltaInput) {
            let delta = $087e637c79acc198$export$4368d992c4eafac0(deltaInput);
            if (delta) this.mutate({
                startDelta: delta
            });
        }
        moveEnd(deltaInput) {
            let delta = $087e637c79acc198$export$4368d992c4eafac0(deltaInput);
            if (delta) this.mutate({
                endDelta: delta
            });
        }
        moveDates(deltaInput) {
            let delta = $087e637c79acc198$export$4368d992c4eafac0(deltaInput);
            if (delta) this.mutate({
                datesDelta: delta
            });
        }
        setAllDay(allDay, options = {}) {
            let standardProps = {
                allDay: allDay
            };
            let { maintainDuration: maintainDuration } = options;
            if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
            if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
            this.mutate({
                standardProps: standardProps
            });
        }
        formatRange(formatInput) {
            let { dateEnv: dateEnv } = this._context;
            let instance = this._instance;
            let formatter = $087e637c79acc198$export$efccba1c4a2ef57b(formatInput);
            if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                forcedStartTzo: instance.forcedStartTzo,
                forcedEndTzo: instance.forcedEndTzo
            });
            return dateEnv.format(instance.range.start, formatter, {
                forcedTzo: instance.forcedStartTzo
            });
        }
        mutate(mutation) {
            let instance = this._instance;
            if (instance) {
                let def = this._def;
                let context = this._context;
                let { eventStore: eventStore } = context.getCurrentData();
                let relevantEvents = $087e637c79acc198$export$1ee57be6f6687d2c(eventStore, instance.instanceId);
                let eventConfigBase = {
                    '': {
                        display: '',
                        startEditable: true,
                        durationEditable: true,
                        constraints: [],
                        overlap: null,
                        allows: [],
                        backgroundColor: '',
                        borderColor: '',
                        textColor: '',
                        classNames: []
                    }
                };
                relevantEvents = $087e637c79acc198$export$6d1e945284085e64(relevantEvents, eventConfigBase, mutation, context);
                let oldEvent = new $087e637c79acc198$export$34aec0b863436764(context, def, instance);
                this._def = relevantEvents.defs[def.defId];
                this._instance = relevantEvents.instances[instance.instanceId];
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: relevantEvents
                });
                context.emitter.trigger('eventChange', {
                    oldEvent: oldEvent,
                    event: this,
                    relatedEvents: $087e637c79acc198$export$90a7f3efeed30595(relevantEvents, context, instance),
                    revert () {
                        context.dispatch({
                            type: 'RESET_EVENTS',
                            eventStore: eventStore
                        });
                    }
                });
            }
        }
        remove() {
            let context = this._context;
            let asStore = $087e637c79acc198$var$eventApiToStore(this);
            context.dispatch({
                type: 'REMOVE_EVENTS',
                eventStore: asStore
            });
            context.emitter.trigger('eventRemove', {
                event: this,
                relatedEvents: [],
                revert () {
                    context.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: asStore
                    });
                }
            });
        }
        get source() {
            let { sourceId: sourceId } = this._def;
            if (sourceId) return new $087e637c79acc198$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
            return null;
        }
        get start() {
            return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
        }
        get end() {
            return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
        }
        get startStr() {
            let instance = this._instance;
            if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
                omitTime: this._def.allDay,
                forcedTzo: instance.forcedStartTzo
            });
            return '';
        }
        get endStr() {
            let instance = this._instance;
            if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
                omitTime: this._def.allDay,
                forcedTzo: instance.forcedEndTzo
            });
            return '';
        }
        get id() {
            return this._def.publicId;
        }
        get groupId() {
            return this._def.groupId;
        }
        get allDay() {
            return this._def.allDay;
        }
        get title() {
            return this._def.title;
        }
        get url() {
            return this._def.url;
        }
        get display() {
            return this._def.ui.display || 'auto';
        }
        get startEditable() {
            return this._def.ui.startEditable;
        }
        get durationEditable() {
            return this._def.ui.durationEditable;
        }
        get constraint() {
            return this._def.ui.constraints[0] || null;
        }
        get overlap() {
            return this._def.ui.overlap;
        }
        get allow() {
            return this._def.ui.allows[0] || null;
        }
        get backgroundColor() {
            return this._def.ui.backgroundColor;
        }
        get borderColor() {
            return this._def.ui.borderColor;
        }
        get textColor() {
            return this._def.ui.textColor;
        }
        get classNames() {
            return this._def.ui.classNames;
        }
        get extendedProps() {
            return this._def.extendedProps;
        }
        toPlainObject(settings = {}) {
            let def = this._def;
            let { ui: ui } = def;
            let { startStr: startStr, endStr: endStr } = this;
            let res = {
                allDay: def.allDay
            };
            if (def.title) res.title = def.title;
            if (startStr) res.start = startStr;
            if (endStr) res.end = endStr;
            if (def.publicId) res.id = def.publicId;
            if (def.groupId) res.groupId = def.groupId;
            if (def.url) res.url = def.url;
            if (ui.display && ui.display !== 'auto') res.display = ui.display;
            if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
            else {
                if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
                if (ui.borderColor) res.borderColor = ui.borderColor;
            }
            if (ui.textColor) res.textColor = ui.textColor;
            if (ui.classNames.length) res.classNames = ui.classNames;
            if (Object.keys(def.extendedProps).length) {
                if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
                else res.extendedProps = def.extendedProps;
            }
            return res;
        }
        toJSON() {
            return this.toPlainObject();
        }
    }
    function $087e637c79acc198$var$eventApiToStore(eventApi) {
        let def = eventApi._def;
        let instance = eventApi._instance;
        return {
            defs: {
                [def.defId]: def
            },
            instances: instance ? {
                [instance.instanceId]: instance
            } : {}
        };
    }
    function $087e637c79acc198$export$90a7f3efeed30595(eventStore, context, excludeInstance) {
        let { defs: defs, instances: instances } = eventStore;
        let eventApis = [];
        let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
        for(let id in instances){
            let instance = instances[id];
            let def = defs[instance.defId];
            if (instance.instanceId !== excludeInstanceId) eventApis.push(new $087e637c79acc198$export$34aec0b863436764(context, def, instance));
        }
        return eventApis;
    }
    function $087e637c79acc198$export$c9170ad7d4cd7e57(eventStore, eventUiBases, framingRange, nextDayThreshold) {
        let inverseBgByGroupId = {};
        let inverseBgByDefId = {};
        let defByGroupId = {};
        let bgRanges = [];
        let fgRanges = [];
        let eventUis = $087e637c79acc198$var$compileEventUis(eventStore.defs, eventUiBases);
        for(let defId in eventStore.defs){
            let def = eventStore.defs[defId];
            let ui = eventUis[def.defId];
            if (ui.display === 'inverse-background') {
                if (def.groupId) {
                    inverseBgByGroupId[def.groupId] = [];
                    if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
                } else inverseBgByDefId[defId] = [];
            }
        }
        for(let instanceId in eventStore.instances){
            let instance = eventStore.instances[instanceId];
            let def = eventStore.defs[instance.defId];
            let ui = eventUis[def.defId];
            let origRange = instance.range;
            let normalRange = !def.allDay && nextDayThreshold ? $087e637c79acc198$export$28f7fcd39efa255(origRange, nextDayThreshold) : origRange;
            let slicedRange = $087e637c79acc198$export$7ccc53e8f1e7dfc5(normalRange, framingRange);
            if (slicedRange) {
                if (ui.display === 'inverse-background') {
                    if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                    else inverseBgByDefId[instance.defId].push(slicedRange);
                } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                    def: def,
                    ui: ui,
                    instance: instance,
                    range: slicedRange,
                    isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                    isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
                });
            }
        }
        for(let groupId in inverseBgByGroupId){
            let ranges = inverseBgByGroupId[groupId];
            let invertedRanges = $087e637c79acc198$var$invertRanges(ranges, framingRange);
            for (let invertedRange of invertedRanges){
                let def = defByGroupId[groupId];
                let ui = eventUis[def.defId];
                bgRanges.push({
                    def: def,
                    ui: ui,
                    instance: null,
                    range: invertedRange,
                    isStart: false,
                    isEnd: false
                });
            }
        }
        for(let defId in inverseBgByDefId){
            let ranges = inverseBgByDefId[defId];
            let invertedRanges = $087e637c79acc198$var$invertRanges(ranges, framingRange);
            for (let invertedRange of invertedRanges)bgRanges.push({
                def: eventStore.defs[defId],
                ui: eventUis[defId],
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
        return {
            bg: bgRanges,
            fg: fgRanges
        };
    }
    function $087e637c79acc198$export$a91cd623adc48128(def) {
        return def.ui.display === 'background' || def.ui.display === 'inverse-background';
    }
    function $087e637c79acc198$var$setElSeg(el, seg) {
        el.fcSeg = seg;
    }
    function $087e637c79acc198$export$71511d61b312f219(el) {
        return el.fcSeg || el.parentNode.fcSeg || null;
    }
    function $087e637c79acc198$var$compileEventUis(eventDefs, eventUiBases) {
        return $087e637c79acc198$export$407448d2b89b1813(eventDefs, (eventDef)=>$087e637c79acc198$var$compileEventUi(eventDef, eventUiBases));
    }
    function $087e637c79acc198$var$compileEventUi(eventDef, eventUiBases) {
        let uis = [];
        if (eventUiBases['']) uis.push(eventUiBases['']);
        if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
        uis.push(eventDef.ui);
        return $087e637c79acc198$export$1a8f5705751d8277(uis);
    }
    function $087e637c79acc198$export$4d522598b426bb73(segs, eventOrderSpecs) {
        let objs = segs.map($087e637c79acc198$var$buildSegCompareObj);
        objs.sort((obj0, obj1)=>$087e637c79acc198$export$2f6ca3d3b1f80bf5(obj0, obj1, eventOrderSpecs));
        return objs.map((c)=>c._seg);
    }
    function $087e637c79acc198$var$buildSegCompareObj(seg) {
        let { eventRange: eventRange } = seg;
        let eventDef = eventRange.def;
        let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
        let start = range.start ? range.start.valueOf() : 0;
        let end = range.end ? range.end.valueOf() : 0;
        return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
            id: eventDef.publicId,
            start: start,
            end: end,
            duration: end - start,
            allDay: Number(eventDef.allDay),
            _seg: seg
        });
    }
    function $087e637c79acc198$var$computeSegDraggable(seg, context) {
        let { pluginHooks: pluginHooks } = context;
        let transformers = pluginHooks.isDraggableTransformers;
        let { def: def, ui: ui } = seg.eventRange;
        let val = ui.startEditable;
        for (let transformer of transformers)val = transformer(val, def, ui, context);
        return val;
    }
    function $087e637c79acc198$var$computeSegStartResizable(seg, context) {
        return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
    }
    function $087e637c79acc198$var$computeSegEndResizable(seg, context) {
        return seg.isEnd && seg.eventRange.ui.durationEditable;
    }
    function $087e637c79acc198$export$993a080e5cb62d74(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
        let { dateEnv: dateEnv, options: options } = context;
        let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
        let eventDef = seg.eventRange.def;
        let eventInstance = seg.eventRange.instance;
        if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
        if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
        let wholeEventStart = eventInstance.range.start;
        let wholeEventEnd = eventInstance.range.end;
        let segStart = startOverride || seg.start || seg.eventRange.range.start;
        let segEnd = endOverride || seg.end || seg.eventRange.range.end;
        let isStartDay = $087e637c79acc198$export$ae1af26003f05816(wholeEventStart).valueOf() === $087e637c79acc198$export$ae1af26003f05816(segStart).valueOf();
        let isEndDay = $087e637c79acc198$export$ae1af26003f05816($087e637c79acc198$export$136fd86de524d3c2(wholeEventEnd, -1)).valueOf() === $087e637c79acc198$export$ae1af26003f05816($087e637c79acc198$export$136fd86de524d3c2(segEnd, -1)).valueOf();
        if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
            segStart = isStartDay ? wholeEventStart : segStart;
            segEnd = isEndDay ? wholeEventEnd : segEnd;
            if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
                forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
                forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
            });
            return dateEnv.format(segStart, timeFormat, {
                forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
            });
        }
        return '';
    }
    function $087e637c79acc198$export$6dabbe08653f866f(seg, todayRange, nowDate) {
        let segRange = seg.eventRange.range;
        return {
            isPast: segRange.end < (nowDate || todayRange.start),
            isFuture: segRange.start >= (nowDate || todayRange.end),
            isToday: todayRange && $087e637c79acc198$export$2329c99376c9d0a4(todayRange, segRange.start)
        };
    }
    function $087e637c79acc198$var$getEventClassNames(props) {
        let classNames = [
            'fc-event'
        ];
        if (props.isMirror) classNames.push('fc-event-mirror');
        if (props.isDraggable) classNames.push('fc-event-draggable');
        if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
        if (props.isDragging) classNames.push('fc-event-dragging');
        if (props.isResizing) classNames.push('fc-event-resizing');
        if (props.isSelected) classNames.push('fc-event-selected');
        if (props.isStart) classNames.push('fc-event-start');
        if (props.isEnd) classNames.push('fc-event-end');
        if (props.isPast) classNames.push('fc-event-past');
        if (props.isToday) classNames.push('fc-event-today');
        if (props.isFuture) classNames.push('fc-event-future');
        return classNames;
    }
    function $087e637c79acc198$export$1314441b8d04e1d5(eventRange) {
        return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
    }
    function $087e637c79acc198$export$e0c3a065614c6254(seg, context) {
        let { def: def, instance: instance } = seg.eventRange;
        let { url: url } = def;
        if (url) return {
            href: url
        };
        let { emitter: emitter, options: options } = context;
        let { eventInteractive: eventInteractive } = options;
        if (eventInteractive == null) {
            eventInteractive = def.interactive;
            if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
        }
        if (eventInteractive) return $087e637c79acc198$var$createAriaKeyboardAttrs((ev)=>{
            emitter.trigger('eventClick', {
                el: ev.target,
                event: new $087e637c79acc198$export$34aec0b863436764(context, def, instance),
                jsEvent: ev,
                view: context.viewApi
            });
        });
        return {};
    }
    const $087e637c79acc198$var$STANDARD_PROPS = {
        start: $087e637c79acc198$export$882b5998b3b9117c,
        end: $087e637c79acc198$export$882b5998b3b9117c,
        allDay: Boolean
    };
    function $087e637c79acc198$var$parseDateSpan(raw, dateEnv, defaultDuration) {
        let span = $087e637c79acc198$var$parseOpenDateSpan(raw, dateEnv);
        let { range: range } = span;
        if (!range.start) return null;
        if (!range.end) {
            if (defaultDuration == null) return null;
            range.end = dateEnv.add(range.start, defaultDuration);
        }
        return span;
    }
    function $087e637c79acc198$var$parseOpenDateSpan(raw, dateEnv) {
        let { refined: standardProps, extra: extra } = $087e637c79acc198$export$f38c853ae54ed474(raw, $087e637c79acc198$var$STANDARD_PROPS);
        let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
        let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
        let { allDay: allDay } = standardProps;
        if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
        return Object.assign({
            range: {
                start: startMeta ? startMeta.marker : null,
                end: endMeta ? endMeta.marker : null
            },
            allDay: allDay
        }, extra);
    }
    function $087e637c79acc198$export$151db275011178c4(span0, span1) {
        return $087e637c79acc198$export$f074adc9fbd50943(span0.range, span1.range) && span0.allDay === span1.allDay && $087e637c79acc198$var$isSpanPropsEqual(span0, span1);
    }
    function $087e637c79acc198$var$isSpanPropsEqual(span0, span1) {
        for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
            if (span0[propName] !== span1[propName]) return false;
        }
        for(let propName in span0){
            if (!(propName in span1)) return false;
        }
        return true;
    }
    function $087e637c79acc198$var$buildDateSpanApi(span, dateEnv) {
        return Object.assign(Object.assign({}, $087e637c79acc198$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
            allDay: span.allDay
        });
    }
    function $087e637c79acc198$export$342063e11d6c3cad(range, dateEnv, omitTime) {
        return Object.assign(Object.assign({}, $087e637c79acc198$var$buildRangeApi(range, dateEnv, omitTime)), {
            timeZone: dateEnv.timeZone
        });
    }
    function $087e637c79acc198$var$buildRangeApi(range, dateEnv, omitTime) {
        return {
            start: dateEnv.toDate(range.start),
            end: dateEnv.toDate(range.end),
            startStr: dateEnv.formatIso(range.start, {
                omitTime: omitTime
            }),
            endStr: dateEnv.formatIso(range.end, {
                omitTime: omitTime
            })
        };
    }
    function $087e637c79acc198$var$fabricateEventRange(dateSpan, eventUiBases, context) {
        let res = $087e637c79acc198$export$ab83b03e4111b1d0({
            editable: false
        }, context);
        let def = $087e637c79acc198$export$21579262ef46735b(res.refined, res.extra, '', dateSpan.allDay, true, context);
        return {
            def: def,
            ui: $087e637c79acc198$var$compileEventUi(def, eventUiBases),
            instance: $087e637c79acc198$export$3b513254972cfc9c(def.defId, dateSpan.range),
            range: dateSpan.range,
            isStart: true,
            isEnd: true
        };
    }
    function $087e637c79acc198$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
        let isResolved = false;
        let wrappedSuccess = function(res) {
            if (!isResolved) {
                isResolved = true;
                normalizedSuccessCallback(res);
            }
        };
        let wrappedFailure = function(error) {
            if (!isResolved) {
                isResolved = true;
                normalizedFailureCallback(error);
            }
        };
        let res = func(wrappedSuccess, wrappedFailure);
        if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
    }
    class $087e637c79acc198$export$ee7c8ad385a60b7b extends Error {
        constructor(message, response){
            super(message);
            this.response = response;
        }
    }
    function $087e637c79acc198$export$43caf9889c228507(method, url, params) {
        method = method.toUpperCase();
        const fetchOptions = {
            method: method
        };
        if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
        else {
            fetchOptions.body = new URLSearchParams(params);
            fetchOptions.headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
        }
        return fetch(url, fetchOptions).then((fetchRes)=>{
            if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
                return [
                    parsedResponse,
                    fetchRes
                ];
            }, ()=>{
                throw new $087e637c79acc198$export$ee7c8ad385a60b7b('Failure parsing JSON', fetchRes);
            });
            else throw new $087e637c79acc198$export$ee7c8ad385a60b7b('Request failed', fetchRes);
        });
    }
    let $087e637c79acc198$var$canVGrowWithinCell;
    function $087e637c79acc198$export$667d3bf0c5f83305() {
        if ($087e637c79acc198$var$canVGrowWithinCell == null) $087e637c79acc198$var$canVGrowWithinCell = $087e637c79acc198$var$computeCanVGrowWithinCell();
        return $087e637c79acc198$var$canVGrowWithinCell;
    }
    function $087e637c79acc198$var$computeCanVGrowWithinCell() {
        if (typeof document === 'undefined') return true;
        let el = document.createElement('div');
        el.style.position = 'absolute';
        el.style.top = '0px';
        el.style.left = '0px';
        el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
        el.querySelector('table').style.height = '100px';
        el.querySelector('div').style.height = '100%';
        document.body.appendChild(el);
        let div = el.querySelector('div');
        let possible = div.offsetHeight > 0;
        document.body.removeChild(el);
        return possible;
    }
    class $087e637c79acc198$export$555508cbc6add439 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.state = {
                forPrint: false
            };
            this.handleBeforePrint = ()=>{
                this.setState({
                    forPrint: true
                });
            };
            this.handleAfterPrint = ()=>{
                this.setState({
                    forPrint: false
                });
            };
        }
        render() {
            let { props: props } = this;
            let { options: options } = props;
            let { forPrint: forPrint } = this.state;
            let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
            let height = !isHeightAuto && options.height != null ? options.height : '';
            let classNames = [
                'fc',
                forPrint ? 'fc-media-print' : 'fc-media-screen',
                `fc-direction-${options.direction}`,
                props.theme.getClass('root')
            ];
            if (!$087e637c79acc198$export$667d3bf0c5f83305()) classNames.push('fc-liquid-hack');
            return props.children(classNames, height, isHeightAuto, forPrint);
        }
        componentDidMount() {
            let { emitter: emitter } = this.props;
            emitter.on('_beforeprint', this.handleBeforePrint);
            emitter.on('_afterprint', this.handleAfterPrint);
        }
        componentWillUnmount() {
            let { emitter: emitter } = this.props;
            emitter.off('_beforeprint', this.handleBeforePrint);
            emitter.off('_afterprint', this.handleAfterPrint);
        }
    }
    class $087e637c79acc198$export$dc98b0b04f4c7758 {
        constructor(settings){
            this.component = settings.component;
            this.isHitComboAllowed = settings.isHitComboAllowed || null;
        }
        destroy() {}
    }
    function $087e637c79acc198$export$2e2af4578d910ddf(component, input) {
        return {
            component: component,
            el: input.el,
            useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
            isHitComboAllowed: input.isHitComboAllowed || null
        };
    }
    function $087e637c79acc198$export$aff10ba49ece4b91(settings) {
        return {
            [settings.component.uid]: settings
        };
    }
    const $087e637c79acc198$export$a93c5207d687da10 = {};
    class $087e637c79acc198$export$a9c996f45e5784d0 {
        getCurrentData() {
            return this.currentDataManager.getCurrentData();
        }
        dispatch(action) {
            this.currentDataManager.dispatch(action);
        }
        get view() {
            return this.getCurrentData().viewApi;
        }
        batchRendering(callback) {
            callback();
        }
        updateSize() {
            this.trigger('_resize', true);
        }
        setOption(name, val) {
            this.dispatch({
                type: 'SET_OPTION',
                optionName: name,
                rawOptionValue: val
            });
        }
        getOption(name) {
            return this.currentDataManager.currentCalendarOptionsInput[name];
        }
        getAvailableLocaleCodes() {
            return Object.keys(this.getCurrentData().availableRawLocales);
        }
        on(handlerName, handler) {
            let { currentDataManager: currentDataManager } = this;
            if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
            else console.warn(`Unknown listener name '${handlerName}'`);
        }
        off(handlerName, handler) {
            this.currentDataManager.emitter.off(handlerName, handler);
        }
        trigger(handlerName, ...args) {
            this.currentDataManager.emitter.trigger(handlerName, ...args);
        }
        changeView(viewType, dateOrRange) {
            this.batchRendering(()=>{
                this.unselect();
                if (dateOrRange) {
                    if (dateOrRange.start && dateOrRange.end) {
                        this.dispatch({
                            type: 'CHANGE_VIEW_TYPE',
                            viewType: viewType
                        });
                        this.dispatch({
                            type: 'SET_OPTION',
                            optionName: 'visibleRange',
                            rawOptionValue: dateOrRange
                        });
                    } else {
                        let { dateEnv: dateEnv } = this.getCurrentData();
                        this.dispatch({
                            type: 'CHANGE_VIEW_TYPE',
                            viewType: viewType,
                            dateMarker: dateEnv.createMarker(dateOrRange)
                        });
                    }
                } else this.dispatch({
                    type: 'CHANGE_VIEW_TYPE',
                    viewType: viewType
                });
            });
        }
        zoomTo(dateMarker, viewType) {
            let state = this.getCurrentData();
            let spec;
            viewType = viewType || 'day';
            spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
            this.unselect();
            if (spec) this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: spec.type,
                dateMarker: dateMarker
            });
            else this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: dateMarker
            });
        }
        getUnitViewSpec(unit) {
            let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
            let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
            let i;
            let spec;
            for(let viewType in viewSpecs)viewTypes.push(viewType);
            for(i = 0; i < viewTypes.length; i += 1){
                spec = viewSpecs[viewTypes[i]];
                if (spec) {
                    if (spec.singleUnit === unit) return spec;
                }
            }
            return null;
        }
        prev() {
            this.unselect();
            this.dispatch({
                type: 'PREV'
            });
        }
        next() {
            this.unselect();
            this.dispatch({
                type: 'NEXT'
            });
        }
        prevYear() {
            let state = this.getCurrentData();
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.addYears(state.currentDate, -1)
            });
        }
        nextYear() {
            let state = this.getCurrentData();
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.addYears(state.currentDate, 1)
            });
        }
        today() {
            let state = this.getCurrentData();
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: $087e637c79acc198$export$c3950d9923825c02(state.calendarOptions.now, state.dateEnv)
            });
        }
        gotoDate(zonedDateInput) {
            let state = this.getCurrentData();
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.createMarker(zonedDateInput)
            });
        }
        incrementDate(deltaInput) {
            let state = this.getCurrentData();
            let delta = $087e637c79acc198$export$4368d992c4eafac0(deltaInput);
            if (delta) {
                this.unselect();
                this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: state.dateEnv.add(state.currentDate, delta)
                });
            }
        }
        getDate() {
            let state = this.getCurrentData();
            return state.dateEnv.toDate(state.currentDate);
        }
        formatDate(d, formatter) {
            let { dateEnv: dateEnv } = this.getCurrentData();
            return dateEnv.format(dateEnv.createMarker(d), $087e637c79acc198$export$efccba1c4a2ef57b(formatter));
        }
        formatRange(d0, d1, settings) {
            let { dateEnv: dateEnv } = this.getCurrentData();
            return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $087e637c79acc198$export$efccba1c4a2ef57b(settings), settings);
        }
        formatIso(d, omitTime) {
            let { dateEnv: dateEnv } = this.getCurrentData();
            return dateEnv.formatIso(dateEnv.createMarker(d), {
                omitTime: omitTime
            });
        }
        select(dateOrObj, endDate) {
            let selectionInput;
            if (endDate == null) {
                if (dateOrObj.start != null) selectionInput = dateOrObj;
                else selectionInput = {
                    start: dateOrObj,
                    end: null
                };
            } else selectionInput = {
                start: dateOrObj,
                end: endDate
            };
            let state = this.getCurrentData();
            let selection = $087e637c79acc198$var$parseDateSpan(selectionInput, state.dateEnv, $087e637c79acc198$export$4368d992c4eafac0({
                days: 1
            }));
            if (selection) {
                this.dispatch({
                    type: 'SELECT_DATES',
                    selection: selection
                });
                $087e637c79acc198$export$9ddbdd0bfc5623a(selection, null, state);
            }
        }
        unselect(pev) {
            let state = this.getCurrentData();
            if (state.dateSelection) {
                this.dispatch({
                    type: 'UNSELECT_DATES'
                });
                $087e637c79acc198$var$triggerDateUnselect(pev, state);
            }
        }
        addEvent(eventInput, sourceInput) {
            if (eventInput instanceof $087e637c79acc198$export$34aec0b863436764) {
                let def = eventInput._def;
                let instance = eventInput._instance;
                let currentData = this.getCurrentData();
                if (!currentData.eventStore.defs[def.defId]) {
                    this.dispatch({
                        type: 'ADD_EVENTS',
                        eventStore: $087e637c79acc198$export$9d0e2d13d04f7070({
                            def: def,
                            instance: instance
                        })
                    });
                    this.triggerEventAdd(eventInput);
                }
                return eventInput;
            }
            let state = this.getCurrentData();
            let eventSource;
            if (sourceInput instanceof $087e637c79acc198$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
            else if (typeof sourceInput === 'boolean') {
                if (sourceInput) [eventSource] = $087e637c79acc198$export$625550452a3fa3ec(state.eventSources);
            } else if (sourceInput != null) {
                let sourceApi = this.getEventSourceById(sourceInput);
                if (!sourceApi) {
                    console.warn(`Could not find an event source with ID "${sourceInput}"`);
                    return null;
                }
                eventSource = sourceApi.internalEventSource;
            }
            let tuple = $087e637c79acc198$var$parseEvent(eventInput, eventSource, state, false);
            if (tuple) {
                let newEventApi = new $087e637c79acc198$export$34aec0b863436764(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: $087e637c79acc198$export$9d0e2d13d04f7070(tuple)
                });
                this.triggerEventAdd(newEventApi);
                return newEventApi;
            }
            return null;
        }
        triggerEventAdd(eventApi) {
            let { emitter: emitter } = this.getCurrentData();
            emitter.trigger('eventAdd', {
                event: eventApi,
                relatedEvents: [],
                revert: ()=>{
                    this.dispatch({
                        type: 'REMOVE_EVENTS',
                        eventStore: $087e637c79acc198$var$eventApiToStore(eventApi)
                    });
                }
            });
        }
        getEventById(id) {
            let state = this.getCurrentData();
            let { defs: defs, instances: instances } = state.eventStore;
            id = String(id);
            for(let defId in defs){
                let def = defs[defId];
                if (def.publicId === id) {
                    if (def.recurringDef) return new $087e637c79acc198$export$34aec0b863436764(state, def, null);
                    for(let instanceId in instances){
                        let instance = instances[instanceId];
                        if (instance.defId === def.defId) return new $087e637c79acc198$export$34aec0b863436764(state, def, instance);
                    }
                }
            }
            return null;
        }
        getEvents() {
            let currentData = this.getCurrentData();
            return $087e637c79acc198$export$90a7f3efeed30595(currentData.eventStore, currentData);
        }
        removeAllEvents() {
            this.dispatch({
                type: 'REMOVE_ALL_EVENTS'
            });
        }
        getEventSources() {
            let state = this.getCurrentData();
            let sourceHash = state.eventSources;
            let sourceApis = [];
            for(let internalId in sourceHash)sourceApis.push(new $087e637c79acc198$var$EventSourceImpl(state, sourceHash[internalId]));
            return sourceApis;
        }
        getEventSourceById(id) {
            let state = this.getCurrentData();
            let sourceHash = state.eventSources;
            id = String(id);
            for(let sourceId in sourceHash){
                if (sourceHash[sourceId].publicId === id) return new $087e637c79acc198$var$EventSourceImpl(state, sourceHash[sourceId]);
            }
            return null;
        }
        addEventSource(sourceInput) {
            let state = this.getCurrentData();
            if (sourceInput instanceof $087e637c79acc198$var$EventSourceImpl) {
                if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                    type: 'ADD_EVENT_SOURCES',
                    sources: [
                        sourceInput.internalEventSource
                    ]
                });
                return sourceInput;
            }
            let eventSource = $087e637c79acc198$export$ffb5f4729a158638(sourceInput, state);
            if (eventSource) {
                this.dispatch({
                    type: 'ADD_EVENT_SOURCES',
                    sources: [
                        eventSource
                    ]
                });
                return new $087e637c79acc198$var$EventSourceImpl(state, eventSource);
            }
            return null;
        }
        removeAllEventSources() {
            this.dispatch({
                type: 'REMOVE_ALL_EVENT_SOURCES'
            });
        }
        refetchEvents() {
            this.dispatch({
                type: 'FETCH_EVENT_SOURCES',
                isRefetch: true
            });
        }
        scrollToTime(timeInput) {
            let time = $087e637c79acc198$export$4368d992c4eafac0(timeInput);
            if (time) this.trigger('_scrollRequest', {
                time: time
            });
        }
    }
    function $087e637c79acc198$export$cf2f7c5792f80b46(point, rect) {
        return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
    }
    function $087e637c79acc198$export$158acd800e1ef08b(rect1, rect2) {
        let res = {
            left: Math.max(rect1.left, rect2.left),
            right: Math.min(rect1.right, rect2.right),
            top: Math.max(rect1.top, rect2.top),
            bottom: Math.min(rect1.bottom, rect2.bottom)
        };
        if (res.left < res.right && res.top < res.bottom) return res;
        return false;
    }
    function $087e637c79acc198$export$a05254e7c3aeba6e(rect, deltaX, deltaY) {
        return {
            left: rect.left + deltaX,
            right: rect.right + deltaX,
            top: rect.top + deltaY,
            bottom: rect.bottom + deltaY
        };
    }
    function $087e637c79acc198$export$53a70dd1ebbae346(point, rect) {
        return {
            left: Math.min(Math.max(point.left, rect.left), rect.right),
            top: Math.min(Math.max(point.top, rect.top), rect.bottom)
        };
    }
    function $087e637c79acc198$export$a33b77bbdbb8366c(rect) {
        return {
            left: (rect.left + rect.right) / 2,
            top: (rect.top + rect.bottom) / 2
        };
    }
    function $087e637c79acc198$export$b9a6b53f9be3734(point1, point2) {
        return {
            left: point1.left - point2.left,
            top: point1.top - point2.top
        };
    }
    const $087e637c79acc198$var$EMPTY_EVENT_STORE = $087e637c79acc198$export$7f8ddf7c7c20b3cd();
    class $087e637c79acc198$export$e171bab687b50e0 {
        constructor(){
            this.getKeysForEventDefs = $087e637c79acc198$export$4a5767248b18ef41(this._getKeysForEventDefs);
            this.splitDateSelection = $087e637c79acc198$export$4a5767248b18ef41(this._splitDateSpan);
            this.splitEventStore = $087e637c79acc198$export$4a5767248b18ef41(this._splitEventStore);
            this.splitIndividualUi = $087e637c79acc198$export$4a5767248b18ef41(this._splitIndividualUi);
            this.splitEventDrag = $087e637c79acc198$export$4a5767248b18ef41(this._splitInteraction);
            this.splitEventResize = $087e637c79acc198$export$4a5767248b18ef41(this._splitInteraction);
            this.eventUiBuilders = {};
        }
        splitProps(props) {
            let keyInfos = this.getKeyInfo(props);
            let defKeys = this.getKeysForEventDefs(props.eventStore);
            let dateSelections = this.splitDateSelection(props.dateSelection);
            let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys);
            let eventStores = this.splitEventStore(props.eventStore, defKeys);
            let eventDrags = this.splitEventDrag(props.eventDrag);
            let eventResizes = this.splitEventResize(props.eventResize);
            let splitProps = {};
            this.eventUiBuilders = $087e637c79acc198$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $087e637c79acc198$export$4a5767248b18ef41($087e637c79acc198$var$buildEventUiForKey));
            for(let key in keyInfos){
                let keyInfo = keyInfos[key];
                let eventStore = eventStores[key] || $087e637c79acc198$var$EMPTY_EVENT_STORE;
                let buildEventUi = this.eventUiBuilders[key];
                splitProps[key] = {
                    businessHours: keyInfo.businessHours || props.businessHours,
                    dateSelection: dateSelections[key] || null,
                    eventStore: eventStore,
                    eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                    eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                    eventDrag: eventDrags[key] || null,
                    eventResize: eventResizes[key] || null
                };
            }
            return splitProps;
        }
        _splitDateSpan(dateSpan) {
            let dateSpans = {};
            if (dateSpan) {
                let keys = this.getKeysForDateSpan(dateSpan);
                for (let key of keys)dateSpans[key] = dateSpan;
            }
            return dateSpans;
        }
        _getKeysForEventDefs(eventStore) {
            return $087e637c79acc198$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
        }
        _splitEventStore(eventStore, defKeys) {
            let { defs: defs, instances: instances } = eventStore;
            let splitStores = {};
            for(let defId in defs)for (let key of defKeys[defId]){
                if (!splitStores[key]) splitStores[key] = $087e637c79acc198$export$7f8ddf7c7c20b3cd();
                splitStores[key].defs[defId] = defs[defId];
            }
            for(let instanceId in instances){
                let instance = instances[instanceId];
                for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
            }
            return splitStores;
        }
        _splitIndividualUi(eventUiBases, defKeys) {
            let splitHashes = {};
            for(let defId in eventUiBases){
                if (defId) for (let key of defKeys[defId]){
                    if (!splitHashes[key]) splitHashes[key] = {};
                    splitHashes[key][defId] = eventUiBases[defId];
                }
            }
            return splitHashes;
        }
        _splitInteraction(interaction) {
            let splitStates = {};
            if (interaction) {
                let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
                let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
                let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
                let populate = (key)=>{
                    if (!splitStates[key]) splitStates[key] = {
                        affectedEvents: affectedStores[key] || $087e637c79acc198$var$EMPTY_EVENT_STORE,
                        mutatedEvents: mutatedStores[key] || $087e637c79acc198$var$EMPTY_EVENT_STORE,
                        isEvent: interaction.isEvent
                    };
                };
                for(let key in affectedStores)populate(key);
                for(let key in mutatedStores)populate(key);
            }
            return splitStates;
        }
    }
    function $087e637c79acc198$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
        let baseParts = [];
        if (allUi) baseParts.push(allUi);
        if (eventUiForKey) baseParts.push(eventUiForKey);
        let stuff = {
            '': $087e637c79acc198$export$1a8f5705751d8277(baseParts)
        };
        if (individualUi) Object.assign(stuff, individualUi);
        return stuff;
    }
    function $087e637c79acc198$export$a17c37559e1db147(date, todayRange, nowDate, dateProfile) {
        return {
            dow: date.getUTCDay(),
            isDisabled: Boolean(dateProfile && !$087e637c79acc198$export$2329c99376c9d0a4(dateProfile.activeRange, date)),
            isOther: Boolean(dateProfile && !$087e637c79acc198$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
            isToday: Boolean(todayRange && $087e637c79acc198$export$2329c99376c9d0a4(todayRange, date)),
            isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
            isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
        };
    }
    function $087e637c79acc198$export$527e9aa3390079e9(meta, theme) {
        let classNames = [
            'fc-day',
            `fc-day-${$087e637c79acc198$var$DAY_IDS[meta.dow]}`
        ];
        if (meta.isDisabled) classNames.push('fc-day-disabled');
        else {
            if (meta.isToday) {
                classNames.push('fc-day-today');
                classNames.push(theme.getClass('today'));
            }
            if (meta.isPast) classNames.push('fc-day-past');
            if (meta.isFuture) classNames.push('fc-day-future');
            if (meta.isOther) classNames.push('fc-day-other');
        }
        return classNames;
    }
    function $087e637c79acc198$export$fef3dfd9bad05307(meta, theme) {
        let classNames = [
            'fc-slot',
            `fc-slot-${$087e637c79acc198$var$DAY_IDS[meta.dow]}`
        ];
        if (meta.isDisabled) classNames.push('fc-slot-disabled');
        else {
            if (meta.isToday) {
                classNames.push('fc-slot-today');
                classNames.push(theme.getClass('today'));
            }
            if (meta.isPast) classNames.push('fc-slot-past');
            if (meta.isFuture) classNames.push('fc-slot-future');
        }
        return classNames;
    }
    const $087e637c79acc198$var$DAY_FORMAT = $087e637c79acc198$export$efccba1c4a2ef57b({
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const $087e637c79acc198$var$WEEK_FORMAT = $087e637c79acc198$export$efccba1c4a2ef57b({
        week: 'long'
    });
    function $087e637c79acc198$export$8c78c7c36408ea29(context, dateMarker, viewType = 'day', isTabbable = true) {
        const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
        let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $087e637c79acc198$var$WEEK_FORMAT : $087e637c79acc198$var$DAY_FORMAT);
        if (options.navLinks) {
            let zonedDate = dateEnv.toDate(dateMarker);
            const handleInteraction = (ev)=>{
                let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
                if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
                else {
                    if (typeof customAction === 'string') viewType = customAction;
                    calendarApi.zoomTo(dateMarker, viewType);
                }
            };
            return Object.assign({
                title: $087e637c79acc198$export$35e795649ee09318(options.navLinkHint, [
                    dateStr,
                    zonedDate
                ], dateStr),
                'data-navlink': ''
            }, isTabbable ? $087e637c79acc198$var$createAriaClickAttrs(handleInteraction) : {
                onClick: handleInteraction
            });
        }
        return {
            'aria-label': dateStr
        };
    }
    let $087e637c79acc198$var$_isRtlScrollbarOnLeft = null;
    function $087e637c79acc198$export$6735ce526161c7bd() {
        if ($087e637c79acc198$var$_isRtlScrollbarOnLeft === null) $087e637c79acc198$var$_isRtlScrollbarOnLeft = $087e637c79acc198$var$computeIsRtlScrollbarOnLeft();
        return $087e637c79acc198$var$_isRtlScrollbarOnLeft;
    }
    function $087e637c79acc198$var$computeIsRtlScrollbarOnLeft() {
        let outerEl = document.createElement('div');
        $087e637c79acc198$export$2ed0fc6709e59212(outerEl, {
            position: 'absolute',
            top: -1000,
            left: 0,
            border: 0,
            padding: 0,
            overflow: 'scroll',
            direction: 'rtl'
        });
        outerEl.innerHTML = '<div></div>';
        document.body.appendChild(outerEl);
        let innerEl = outerEl.firstChild;
        let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
        $087e637c79acc198$export$c03999cb2f36933f(outerEl);
        return res;
    }
    let $087e637c79acc198$var$_scrollbarWidths;
    function $087e637c79acc198$export$c7ca7e4bc4f8a16e() {
        if (!$087e637c79acc198$var$_scrollbarWidths) $087e637c79acc198$var$_scrollbarWidths = $087e637c79acc198$var$computeScrollbarWidths();
        return $087e637c79acc198$var$_scrollbarWidths;
    }
    function $087e637c79acc198$var$computeScrollbarWidths() {
        let el = document.createElement('div');
        el.style.overflow = 'scroll';
        el.style.position = 'absolute';
        el.style.top = '-9999px';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        let res = $087e637c79acc198$var$computeScrollbarWidthsForEl(el);
        document.body.removeChild(el);
        return res;
    }
    function $087e637c79acc198$var$computeScrollbarWidthsForEl(el) {
        return {
            x: el.offsetHeight - el.clientHeight,
            y: el.offsetWidth - el.clientWidth
        };
    }
    function $087e637c79acc198$export$39c1cc7c062529d4(el, getPadding = false) {
        let computedStyle = window.getComputedStyle(el);
        let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
        let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
        let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
        let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
        let badScrollbarWidths = $087e637c79acc198$var$computeScrollbarWidthsForEl(el);
        let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
        let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
        let res = {
            borderLeft: borderLeft,
            borderRight: borderRight,
            borderTop: borderTop,
            borderBottom: borderBottom,
            scrollbarBottom: scrollbarBottom,
            scrollbarLeft: 0,
            scrollbarRight: 0
        };
        if ($087e637c79acc198$export$6735ce526161c7bd() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
        else res.scrollbarRight = scrollbarLeftRight;
        if (getPadding) {
            res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
            res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
            res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
            res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
        }
        return res;
    }
    function $087e637c79acc198$export$53c86fa97d611818(el, goWithinPadding = false, doFromWindowViewport) {
        let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $087e637c79acc198$export$c18d01048907ea92(el);
        let edges = $087e637c79acc198$export$39c1cc7c062529d4(el, goWithinPadding);
        let res = {
            left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
            right: outerRect.right - edges.borderRight - edges.scrollbarRight,
            top: outerRect.top + edges.borderTop,
            bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
        };
        if (goWithinPadding) {
            res.left += edges.paddingLeft;
            res.right -= edges.paddingRight;
            res.top += edges.paddingTop;
            res.bottom -= edges.paddingBottom;
        }
        return res;
    }
    function $087e637c79acc198$export$c18d01048907ea92(el) {
        let rect = el.getBoundingClientRect();
        return {
            left: rect.left + window.pageXOffset,
            top: rect.top + window.pageYOffset,
            right: rect.right + window.pageXOffset,
            bottom: rect.bottom + window.pageYOffset
        };
    }
    function $087e637c79acc198$var$computeClippedClientRect(el) {
        let clippingParents = $087e637c79acc198$export$7a0bdf7d4a91ea88(el);
        let rect = el.getBoundingClientRect();
        for (let clippingParent of clippingParents){
            let intersection = $087e637c79acc198$export$158acd800e1ef08b(rect, clippingParent.getBoundingClientRect());
            if (intersection) rect = intersection;
            else return null;
        }
        return rect;
    }
    function $087e637c79acc198$export$7a0bdf7d4a91ea88(el) {
        let parents = [];
        while(el instanceof HTMLElement){
            let computedStyle = window.getComputedStyle(el);
            if (computedStyle.position === 'fixed') break;
            if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
            el = el.parentNode;
        }
        return parents;
    }
    class $087e637c79acc198$export$7060da4b5db56fb9 {
        constructor(originEl, els, isHorizontal, isVertical){
            this.els = els;
            let originClientRect = this.originClientRect = originEl.getBoundingClientRect();
            if (isHorizontal) this.buildElHorizontals(originClientRect.left);
            if (isVertical) this.buildElVerticals(originClientRect.top);
        }
        buildElHorizontals(originClientLeft) {
            let lefts = [];
            let rights = [];
            for (let el of this.els){
                let rect = el.getBoundingClientRect();
                lefts.push(rect.left - originClientLeft);
                rights.push(rect.right - originClientLeft);
            }
            this.lefts = lefts;
            this.rights = rights;
        }
        buildElVerticals(originClientTop) {
            let tops = [];
            let bottoms = [];
            for (let el of this.els){
                let rect = el.getBoundingClientRect();
                tops.push(rect.top - originClientTop);
                bottoms.push(rect.bottom - originClientTop);
            }
            this.tops = tops;
            this.bottoms = bottoms;
        }
        leftToIndex(leftPosition) {
            let { lefts: lefts, rights: rights } = this;
            let len = lefts.length;
            let i;
            for(i = 0; i < len; i += 1){
                if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
            }
            return undefined;
        }
        topToIndex(topPosition) {
            let { tops: tops, bottoms: bottoms } = this;
            let len = tops.length;
            let i;
            for(i = 0; i < len; i += 1){
                if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
            }
            return undefined;
        }
        getWidth(leftIndex) {
            return this.rights[leftIndex] - this.lefts[leftIndex];
        }
        getHeight(topIndex) {
            return this.bottoms[topIndex] - this.tops[topIndex];
        }
        similarTo(otherCache) {
            return $087e637c79acc198$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $087e637c79acc198$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $087e637c79acc198$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $087e637c79acc198$var$similarNumArrays(this.rights || [], otherCache.rights || []);
        }
    }
    function $087e637c79acc198$var$similarNumArrays(a, b) {
        const len = a.length;
        if (len !== b.length) return false;
        for(let i = 0; i < len; i++){
            if (Math.round(a[i]) !== Math.round(b[i])) return false;
        }
        return true;
    }
    class $087e637c79acc198$export$c5d1328b37d47994 {
        getMaxScrollTop() {
            return this.getScrollHeight() - this.getClientHeight();
        }
        getMaxScrollLeft() {
            return this.getScrollWidth() - this.getClientWidth();
        }
        canScrollVertically() {
            return this.getMaxScrollTop() > 0;
        }
        canScrollHorizontally() {
            return this.getMaxScrollLeft() > 0;
        }
        canScrollUp() {
            return this.getScrollTop() > 0;
        }
        canScrollDown() {
            return this.getScrollTop() < this.getMaxScrollTop();
        }
        canScrollLeft() {
            return this.getScrollLeft() > 0;
        }
        canScrollRight() {
            return this.getScrollLeft() < this.getMaxScrollLeft();
        }
    }
    class $087e637c79acc198$export$d22783b3c2400a3a extends $087e637c79acc198$export$c5d1328b37d47994 {
        constructor(el){
            super();
            this.el = el;
        }
        getScrollTop() {
            return this.el.scrollTop;
        }
        getScrollLeft() {
            return this.el.scrollLeft;
        }
        setScrollTop(top) {
            this.el.scrollTop = top;
        }
        setScrollLeft(left) {
            this.el.scrollLeft = left;
        }
        getScrollWidth() {
            return this.el.scrollWidth;
        }
        getScrollHeight() {
            return this.el.scrollHeight;
        }
        getClientHeight() {
            return this.el.clientHeight;
        }
        getClientWidth() {
            return this.el.clientWidth;
        }
    }
    class $087e637c79acc198$export$7f557e5eb95176c2 extends $087e637c79acc198$export$c5d1328b37d47994 {
        getScrollTop() {
            return window.pageYOffset;
        }
        getScrollLeft() {
            return window.pageXOffset;
        }
        setScrollTop(n) {
            window.scroll(window.pageXOffset, n);
        }
        setScrollLeft(n) {
            window.scroll(n, window.pageYOffset);
        }
        getScrollWidth() {
            return document.documentElement.scrollWidth;
        }
        getScrollHeight() {
            return document.documentElement.scrollHeight;
        }
        getClientHeight() {
            return document.documentElement.clientHeight;
        }
        getClientWidth() {
            return document.documentElement.clientWidth;
        }
    }
    class $087e637c79acc198$export$51b138e5a065c2bb extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.uid = $087e637c79acc198$export$39b482c5e57630a8();
        }
        prepareHits() {}
        queryHit(positionLeft, positionTop, elWidth, elHeight) {
            return null;
        }
        isValidSegDownEl(el) {
            return !this.props.eventDrag && !this.props.eventResize && !$087e637c79acc198$export$3d8c2f653ac9d0b9(el, '.fc-event-mirror');
        }
        isValidDateDownEl(el) {
            return !$087e637c79acc198$export$3d8c2f653ac9d0b9(el, '.fc-event:not(.fc-bg-event)') && !$087e637c79acc198$export$3d8c2f653ac9d0b9(el, '.fc-more-link') && !$087e637c79acc198$export$3d8c2f653ac9d0b9(el, 'a[data-navlink]') && !$087e637c79acc198$export$3d8c2f653ac9d0b9(el, '.fc-popover');
        }
    }
    class $087e637c79acc198$export$766bf7dcfb630b6c {
        constructor(timeZoneName){
            this.timeZoneName = timeZoneName;
        }
    }
    class $087e637c79acc198$export$2e63b696b2c9441b {
        constructor(){
            this.strictOrder = false;
            this.allowReslicing = false;
            this.maxCoord = -1;
            this.maxStackCnt = -1;
            this.levelCoords = [];
            this.entriesByLevel = [];
            this.stackCnts = {};
        }
        addSegs(inputs) {
            let hiddenEntries = [];
            for (let input of inputs)this.insertEntry(input, hiddenEntries);
            return hiddenEntries;
        }
        insertEntry(entry, hiddenEntries) {
            let insertion = this.findInsertion(entry);
            if (this.isInsertionValid(insertion, entry)) {
                this.insertEntryAt(entry, insertion);
                return 1;
            }
            return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
        }
        isInsertionValid(insertion, entry) {
            return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
        }
        handleInvalidInsertion(insertion, entry, hiddenEntries) {
            if (this.allowReslicing && insertion.touchingEntry) return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
            hiddenEntries.push(entry);
            return 0;
        }
        splitEntry(entry, barrier, hiddenEntries) {
            let partCnt = 0;
            let splitHiddenEntries = [];
            let entrySpan = entry.span;
            let barrierSpan = barrier.span;
            if (entrySpan.start < barrierSpan.start) partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: {
                    start: entrySpan.start,
                    end: barrierSpan.start
                }
            }, splitHiddenEntries);
            if (entrySpan.end > barrierSpan.end) partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: {
                    start: barrierSpan.end,
                    end: entrySpan.end
                }
            }, splitHiddenEntries);
            if (partCnt) {
                hiddenEntries.push({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: $087e637c79acc198$export$b2bcef12bcefba04(barrierSpan, entrySpan)
                }, ...splitHiddenEntries);
                return partCnt;
            }
            hiddenEntries.push(entry);
            return 0;
        }
        insertEntryAt(entry, insertion) {
            let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
            if (insertion.lateral === -1) {
                $087e637c79acc198$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
                $087e637c79acc198$var$insertAt(entriesByLevel, insertion.level, [
                    entry
                ]);
            } else $087e637c79acc198$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
            this.stackCnts[$087e637c79acc198$export$eb84e45a33f6ba7c(entry)] = insertion.stackCnt;
        }
        findInsertion(newEntry) {
            let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
            let levelCnt = levelCoords.length;
            let candidateCoord = 0;
            let touchingLevel = -1;
            let touchingLateral = -1;
            let touchingEntry = null;
            let stackCnt = 0;
            for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
                let trackingCoord = levelCoords[trackingLevel];
                if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) break;
                let trackingEntries = entriesByLevel[trackingLevel];
                let trackingEntry;
                let searchRes = $087e637c79acc198$export$b0165a7e514844(trackingEntries, newEntry.span.start, $087e637c79acc198$export$d76842aa27385215);
                let lateralIndex = searchRes[0] + searchRes[1];
                while((trackingEntry = trackingEntries[lateralIndex]) && trackingEntry.span.start < newEntry.span.end){
                    let trackingEntryBottom = trackingCoord + trackingEntry.thickness;
                    if (trackingEntryBottom > candidateCoord) {
                        candidateCoord = trackingEntryBottom;
                        touchingEntry = trackingEntry;
                        touchingLevel = trackingLevel;
                        touchingLateral = lateralIndex;
                    }
                    if (trackingEntryBottom === candidateCoord) stackCnt = Math.max(stackCnt, stackCnts[$087e637c79acc198$export$eb84e45a33f6ba7c(trackingEntry)] + 1);
                    lateralIndex += 1;
                }
            }
            let destLevel = 0;
            if (touchingEntry) {
                destLevel = touchingLevel + 1;
                while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
            }
            let destLateral = -1;
            if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $087e637c79acc198$export$b0165a7e514844(entriesByLevel[destLevel], newEntry.span.end, $087e637c79acc198$export$d76842aa27385215)[0];
            return {
                touchingLevel: touchingLevel,
                touchingLateral: touchingLateral,
                touchingEntry: touchingEntry,
                stackCnt: stackCnt,
                levelCoord: candidateCoord,
                level: destLevel,
                lateral: destLateral
            };
        }
        toRects() {
            let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
            let levelCnt = entriesByLevel.length;
            let rects = [];
            for(let level = 0; level < levelCnt; level += 1){
                let entries = entriesByLevel[level];
                let levelCoord = levelCoords[level];
                for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                    levelCoord: levelCoord
                }));
            }
            return rects;
        }
    }
    function $087e637c79acc198$export$d76842aa27385215(entry) {
        return entry.span.end;
    }
    function $087e637c79acc198$export$eb84e45a33f6ba7c(entry) {
        return entry.index + ':' + entry.span.start;
    }
    function $087e637c79acc198$export$381353cf1dd55255(entries) {
        let merges = [];
        for (let entry of entries){
            let filteredMerges = [];
            let hungryMerge = {
                span: entry.span,
                entries: [
                    entry
                ]
            };
            for (let merge of merges)if ($087e637c79acc198$export$b2bcef12bcefba04(merge.span, hungryMerge.span)) hungryMerge = {
                entries: merge.entries.concat(hungryMerge.entries),
                span: $087e637c79acc198$var$joinSpans(merge.span, hungryMerge.span)
            };
            else filteredMerges.push(merge);
            filteredMerges.push(hungryMerge);
            merges = filteredMerges;
        }
        return merges;
    }
    function $087e637c79acc198$var$joinSpans(span0, span1) {
        return {
            start: Math.min(span0.start, span1.start),
            end: Math.max(span0.end, span1.end)
        };
    }
    function $087e637c79acc198$export$b2bcef12bcefba04(span0, span1) {
        let start = Math.max(span0.start, span1.start);
        let end = Math.min(span0.end, span1.end);
        if (start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    function $087e637c79acc198$var$insertAt(arr, index, item) {
        arr.splice(index, 0, item);
    }
    function $087e637c79acc198$export$b0165a7e514844(a, searchVal, getItemVal) {
        let startIndex = 0;
        let endIndex = a.length;
        if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
            0,
            0
        ];
        if (searchVal > getItemVal(a[endIndex - 1])) return [
            endIndex,
            0
        ];
        while(startIndex < endIndex){
            let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
            let middleVal = getItemVal(a[middleIndex]);
            if (searchVal < middleVal) endIndex = middleIndex;
            else if (searchVal > middleVal) startIndex = middleIndex + 1;
            else return [
                middleIndex,
                1
            ];
        }
        return [
            startIndex,
            0
        ];
    }
    class $087e637c79acc198$export$60bb826a6acf3081 {
        constructor(el, selector){
            this.emitter = new $087e637c79acc198$export$a9c23c6ac3fc3eca();
        }
        destroy() {}
        setMirrorIsVisible(bool) {}
        setMirrorNeedsRevert(bool) {}
        setAutoScrollEnabled(bool) {}
    }
    const $087e637c79acc198$export$27d1aff6bea49709 = {};
    const $087e637c79acc198$var$DRAG_META_REFINERS = {
        startTime: $087e637c79acc198$export$4368d992c4eafac0,
        duration: $087e637c79acc198$export$4368d992c4eafac0,
        create: Boolean,
        sourceId: String
    };
    function $087e637c79acc198$export$1abb261478089fe6(raw) {
        let { refined: refined, extra: extra } = $087e637c79acc198$export$f38c853ae54ed474(raw, $087e637c79acc198$var$DRAG_META_REFINERS);
        return {
            startTime: refined.startTime || null,
            duration: refined.duration || null,
            create: refined.create != null ? refined.create : true,
            sourceId: refined.sourceId,
            leftoverProps: extra
        };
    }
    function $087e637c79acc198$export$1ddf2d01943a3512(datesRepDistinctDays, dayCnt) {
        if (!datesRepDistinctDays || dayCnt > 10) return $087e637c79acc198$export$efccba1c4a2ef57b({
            weekday: 'short'
        });
        if (dayCnt > 1) return $087e637c79acc198$export$efccba1c4a2ef57b({
            weekday: 'short',
            month: 'numeric',
            day: 'numeric',
            omitCommas: true
        });
        return $087e637c79acc198$export$efccba1c4a2ef57b({
            weekday: 'long'
        });
    }
    const $087e637c79acc198$var$CLASS_NAME = 'fc-col-header-cell';
    function $087e637c79acc198$var$renderInner$1(renderProps) {
        return renderProps.text;
    }
    class $087e637c79acc198$export$ebb8f7cd71856fb9 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        render() {
            let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
            let { props: props } = this;
            let { date: date, dateProfile: dateProfile } = props;
            let dayMeta = $087e637c79acc198$export$a17c37559e1db147(date, props.todayRange, null, dateProfile);
            let classNames = [
                $087e637c79acc198$var$CLASS_NAME
            ].concat($087e637c79acc198$export$527e9aa3390079e9(dayMeta, theme));
            let text = dateEnv.format(date, props.dayHeaderFormat);
            let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $087e637c79acc198$export$8c78c7c36408ea29(this.context, date) : {};
            let renderProps = Object.assign(Object.assign(Object.assign({
                date: dateEnv.toDate(date),
                view: viewApi
            }, props.extraRenderProps), {
                text: text
            }), dayMeta);
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, {
                elTag: "th",
                elClasses: classNames,
                elAttrs: Object.assign({
                    role: 'columnheader',
                    colSpan: props.colSpan,
                    'data-date': !dayMeta.isDisabled ? $087e637c79acc198$export$5dbe06c6d8c68cfb(date) : undefined
                }, props.extraDataAttrs),
                renderProps: renderProps,
                generatorName: "dayHeaderContent",
                customGenerator: options.dayHeaderContent,
                defaultGenerator: $087e637c79acc198$var$renderInner$1,
                classNameGenerator: options.dayHeaderClassNames,
                didMount: options.dayHeaderDidMount,
                willUnmount: options.dayHeaderWillUnmount
            }, (InnerContainer)=>(0, $77d02.createElement)("div", {
                    className: "fc-scrollgrid-sync-inner"
                }, !dayMeta.isDisabled && (0, $77d02.createElement)(InnerContainer, {
                    elTag: "a",
                    elAttrs: navLinkAttrs,
                    elClasses: [
                        'fc-col-header-cell-cushion',
                        props.isSticky && 'fc-sticky'
                    ]
                })));
        }
    }
    const $087e637c79acc198$var$WEEKDAY_FORMAT = $087e637c79acc198$export$efccba1c4a2ef57b({
        weekday: 'long'
    });
    class $087e637c79acc198$export$45aabb5431c2d04f extends $087e637c79acc198$export$78acf4525d8a74c4 {
        render() {
            let { props: props } = this;
            let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
            let date = $087e637c79acc198$export$9e5f44173e64f162(new Date(259200000), props.dow);
            let dateMeta = {
                dow: props.dow,
                isDisabled: false,
                isFuture: false,
                isPast: false,
                isToday: false,
                isOther: false
            };
            let text = dateEnv.format(date, props.dayHeaderFormat);
            let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
                date: date
            }, dateMeta), {
                view: viewApi
            }), props.extraRenderProps), {
                text: text
            });
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, {
                elTag: "th",
                elClasses: [
                    $087e637c79acc198$var$CLASS_NAME,
                    ...$087e637c79acc198$export$527e9aa3390079e9(dateMeta, theme),
                    ...props.extraClassNames || []
                ],
                elAttrs: Object.assign({
                    role: 'columnheader',
                    colSpan: props.colSpan
                }, props.extraDataAttrs),
                renderProps: renderProps,
                generatorName: "dayHeaderContent",
                customGenerator: options.dayHeaderContent,
                defaultGenerator: $087e637c79acc198$var$renderInner$1,
                classNameGenerator: options.dayHeaderClassNames,
                didMount: options.dayHeaderDidMount,
                willUnmount: options.dayHeaderWillUnmount
            }, (InnerContent)=>(0, $77d02.createElement)("div", {
                    className: "fc-scrollgrid-sync-inner"
                }, (0, $77d02.createElement)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        'fc-col-header-cell-cushion',
                        props.isSticky && 'fc-sticky'
                    ],
                    elAttrs: {
                        'aria-label': dateEnv.format(date, $087e637c79acc198$var$WEEKDAY_FORMAT)
                    }
                })));
        }
    }
    class $087e637c79acc198$export$6e4b1d19c6e2e012 extends (0, $77d02.Component) {
        constructor(props, context){
            super(props, context);
            this.initialNowDate = $087e637c79acc198$export$c3950d9923825c02(context.options.now, context.dateEnv);
            this.initialNowQueriedMs = new Date().valueOf();
            this.state = this.computeTiming().currentState;
        }
        render() {
            let { props: props, state: state } = this;
            return props.children(state.nowDate, state.todayRange);
        }
        componentDidMount() {
            this.setTimeout();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.unit !== this.props.unit) {
                this.clearTimeout();
                this.setTimeout();
            }
        }
        componentWillUnmount() {
            this.clearTimeout();
        }
        computeTiming() {
            let { props: props, context: context } = this;
            let unroundedNow = $087e637c79acc198$export$136fd86de524d3c2(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
            let currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
            let nextUnitStart = context.dateEnv.add(currentUnitStart, $087e637c79acc198$export$4368d992c4eafac0(1, props.unit));
            let waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
            waitMs = Math.min(86400000, waitMs);
            return {
                currentState: {
                    nowDate: currentUnitStart,
                    todayRange: $087e637c79acc198$var$buildDayRange(currentUnitStart)
                },
                nextState: {
                    nowDate: nextUnitStart,
                    todayRange: $087e637c79acc198$var$buildDayRange(nextUnitStart)
                },
                waitMs: waitMs
            };
        }
        setTimeout() {
            let { nextState: nextState, waitMs: waitMs } = this.computeTiming();
            this.timeoutId = setTimeout(()=>{
                this.setState(nextState, ()=>{
                    this.setTimeout();
                });
            }, waitMs);
        }
        clearTimeout() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }
    $087e637c79acc198$export$6e4b1d19c6e2e012.contextType = $087e637c79acc198$export$e7c866399fa523f5;
    function $087e637c79acc198$var$buildDayRange(date) {
        let start = $087e637c79acc198$export$ae1af26003f05816(date);
        let end = $087e637c79acc198$export$9e5f44173e64f162(start, 1);
        return {
            start: start,
            end: end
        };
    }
    class $087e637c79acc198$export$ebc5e65867841cbe extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.createDayHeaderFormatter = $087e637c79acc198$export$4a5767248b18ef41($087e637c79acc198$var$createDayHeaderFormatter);
        }
        render() {
            let { context: context } = this;
            let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
            let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
            return (0, $77d02.createElement)($087e637c79acc198$export$6e4b1d19c6e2e012, {
                unit: "day"
            }, (nowDate, todayRange)=>(0, $77d02.createElement)("tr", {
                    role: "row"
                }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, $77d02.createElement)($087e637c79acc198$export$ebb8f7cd71856fb9, {
                        key: date.toISOString(),
                        date: date,
                        dateProfile: dateProfile,
                        todayRange: todayRange,
                        colCnt: dates.length,
                        dayHeaderFormat: dayHeaderFormat
                    }) : (0, $77d02.createElement)($087e637c79acc198$export$45aabb5431c2d04f, {
                        key: date.getUTCDay(),
                        dow: date.getUTCDay(),
                        dayHeaderFormat: dayHeaderFormat
                    }))));
        }
    }
    function $087e637c79acc198$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
        return explicitFormat || $087e637c79acc198$export$1ddf2d01943a3512(datesRepDistinctDays, dateCnt);
    }
    class $087e637c79acc198$export$2538633961795d6b {
        constructor(range, dateProfileGenerator){
            let date = range.start;
            let { end: end } = range;
            let indices = [];
            let dates = [];
            let dayIndex = -1;
            while(date < end){
                if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5);
                else {
                    dayIndex += 1;
                    indices.push(dayIndex);
                    dates.push(date);
                }
                date = $087e637c79acc198$export$9e5f44173e64f162(date, 1);
            }
            this.dates = dates;
            this.indices = indices;
            this.cnt = dates.length;
        }
        sliceRange(range) {
            let firstIndex = this.getDateDayIndex(range.start);
            let lastIndex = this.getDateDayIndex($087e637c79acc198$export$9e5f44173e64f162(range.end, -1));
            let clippedFirstIndex = Math.max(0, firstIndex);
            let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
            clippedFirstIndex = Math.ceil(clippedFirstIndex);
            clippedLastIndex = Math.floor(clippedLastIndex);
            if (clippedFirstIndex <= clippedLastIndex) return {
                firstIndex: clippedFirstIndex,
                lastIndex: clippedLastIndex,
                isStart: firstIndex === clippedFirstIndex,
                isEnd: lastIndex === clippedLastIndex
            };
            return null;
        }
        getDateDayIndex(date) {
            let { indices: indices } = this;
            let dayOffset = Math.floor($087e637c79acc198$export$a36fb7d24305ed9d(this.dates[0], date));
            if (dayOffset < 0) return indices[0] - 1;
            if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
            return indices[dayOffset];
        }
    }
    class $087e637c79acc198$export$dabba94403d45c8e {
        constructor(daySeries, breakOnWeeks){
            let { dates: dates } = daySeries;
            let daysPerRow;
            let firstDay;
            let rowCnt;
            if (breakOnWeeks) {
                firstDay = dates[0].getUTCDay();
                for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                    if (dates[daysPerRow].getUTCDay() === firstDay) break;
                }
                rowCnt = Math.ceil(dates.length / daysPerRow);
            } else {
                rowCnt = 1;
                daysPerRow = dates.length;
            }
            this.rowCnt = rowCnt;
            this.colCnt = daysPerRow;
            this.daySeries = daySeries;
            this.cells = this.buildCells();
            this.headerDates = this.buildHeaderDates();
        }
        buildCells() {
            let rows = [];
            for(let row = 0; row < this.rowCnt; row += 1){
                let cells = [];
                for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
                rows.push(cells);
            }
            return rows;
        }
        buildCell(row, col) {
            let date = this.daySeries.dates[row * this.colCnt + col];
            return {
                key: date.toISOString(),
                date: date
            };
        }
        buildHeaderDates() {
            let dates = [];
            for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
            return dates;
        }
        sliceRange(range) {
            let { colCnt: colCnt } = this;
            let seriesSeg = this.daySeries.sliceRange(range);
            let segs = [];
            if (seriesSeg) {
                let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
                let index = firstIndex;
                while(index <= lastIndex){
                    let row = Math.floor(index / colCnt);
                    let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                    segs.push({
                        row: row,
                        firstCol: index % colCnt,
                        lastCol: (nextIndex - 1) % colCnt,
                        isStart: seriesSeg.isStart && index === firstIndex,
                        isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                    });
                    index = nextIndex;
                }
            }
            return segs;
        }
    }
    class $087e637c79acc198$export$6b179bb11f7fd3a0 {
        constructor(){
            this.sliceBusinessHours = $087e637c79acc198$export$4a5767248b18ef41(this._sliceBusinessHours);
            this.sliceDateSelection = $087e637c79acc198$export$4a5767248b18ef41(this._sliceDateSpan);
            this.sliceEventStore = $087e637c79acc198$export$4a5767248b18ef41(this._sliceEventStore);
            this.sliceEventDrag = $087e637c79acc198$export$4a5767248b18ef41(this._sliceInteraction);
            this.sliceEventResize = $087e637c79acc198$export$4a5767248b18ef41(this._sliceInteraction);
            this.forceDayIfListItem = false;
        }
        sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
            let { eventUiBases: eventUiBases } = props;
            let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
            return {
                dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
                businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
                fgEventSegs: eventSegs.fg,
                bgEventSegs: eventSegs.bg,
                eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
                eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
                eventSelection: props.eventSelection
            };
        }
        sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
            return this._sliceDateSpan({
                range: {
                    start: date,
                    end: $087e637c79acc198$export$136fd86de524d3c2(date, 1)
                },
                allDay: false
            }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
        }
        _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
            if (!businessHours) return [];
            return this._sliceEventStore($087e637c79acc198$var$expandRecurring(businessHours, $087e637c79acc198$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
        }
        _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
            if (eventStore) {
                let rangeRes = $087e637c79acc198$export$c9170ad7d4cd7e57(eventStore, eventUiBases, $087e637c79acc198$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                return {
                    bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                    fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
                };
            }
            return {
                bg: [],
                fg: []
            };
        }
        _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
            if (!interaction) return null;
            let rangeRes = $087e637c79acc198$export$c9170ad7d4cd7e57(interaction.mutatedEvents, eventUiBases, $087e637c79acc198$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
                affectedInstances: interaction.affectedEvents.instances,
                isEvent: interaction.isEvent
            };
        }
        _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
            if (!dateSpan) return [];
            let activeRange = $087e637c79acc198$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
            let activeDateSpanRange = $087e637c79acc198$export$7ccc53e8f1e7dfc5(dateSpan.range, activeRange);
            if (activeDateSpanRange) {
                dateSpan = Object.assign(Object.assign({}, dateSpan), {
                    range: activeDateSpanRange
                });
                let eventRange = $087e637c79acc198$var$fabricateEventRange(dateSpan, eventUiBases, context);
                let segs = this.sliceRange(dateSpan.range, ...extraArgs);
                for (let seg of segs)seg.eventRange = eventRange;
                return segs;
            }
            return [];
        }
        sliceEventRanges(eventRanges, extraArgs) {
            let segs = [];
            for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
            return segs;
        }
        sliceEventRange(eventRange, extraArgs) {
            let dateRange = eventRange.range;
            if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
                start: dateRange.start,
                end: $087e637c79acc198$export$9e5f44173e64f162(dateRange.start, 1)
            };
            let segs = this.sliceRange(dateRange, ...extraArgs);
            for (let seg of segs){
                seg.eventRange = eventRange;
                seg.isStart = eventRange.isStart && seg.isStart;
                seg.isEnd = eventRange.isEnd && seg.isEnd;
            }
            return segs;
        }
    }
    function $087e637c79acc198$var$computeActiveRange(dateProfile, isComponentAllDay) {
        let range = dateProfile.activeRange;
        if (isComponentAllDay) return range;
        return {
            start: $087e637c79acc198$export$136fd86de524d3c2(range.start, dateProfile.slotMinTime.milliseconds),
            end: $087e637c79acc198$export$136fd86de524d3c2(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
        };
    }
    function $087e637c79acc198$export$c667925124dac624(interaction, dateProfile, context) {
        let { instances: instances } = interaction.mutatedEvents;
        for(let instanceId in instances){
            if (!$087e637c79acc198$export$4ae495d48253603d(dateProfile.validRange, instances[instanceId].range)) return false;
        }
        return $087e637c79acc198$var$isNewPropsValid({
            eventDrag: interaction
        }, context);
    }
    function $087e637c79acc198$export$c69d65aa55814164(dateSelection, dateProfile, context) {
        if (!$087e637c79acc198$export$4ae495d48253603d(dateProfile.validRange, dateSelection.range)) return false;
        return $087e637c79acc198$var$isNewPropsValid({
            dateSelection: dateSelection
        }, context);
    }
    function $087e637c79acc198$var$isNewPropsValid(newProps, context) {
        let calendarState = context.getCurrentData();
        let props = Object.assign({
            businessHours: calendarState.businessHours,
            dateSelection: '',
            eventStore: calendarState.eventStore,
            eventUiBases: calendarState.eventUiBases,
            eventSelection: '',
            eventDrag: null,
            eventResize: null
        }, newProps);
        return (context.pluginHooks.isPropsValid || $087e637c79acc198$export$545a72cc0d3f00b0)(props, context);
    }
    function $087e637c79acc198$export$545a72cc0d3f00b0(state, context, dateSpanMeta = {}, filterConfig) {
        if (state.eventDrag && !$087e637c79acc198$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
        if (state.dateSelection && !$087e637c79acc198$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
        return true;
    }
    function $087e637c79acc198$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
        let currentState = context.getCurrentData();
        let interaction = state.eventDrag;
        let subjectEventStore = interaction.mutatedEvents;
        let subjectDefs = subjectEventStore.defs;
        let subjectInstances = subjectEventStore.instances;
        let subjectConfigs = $087e637c79acc198$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
            '': currentState.selectionConfig
        });
        if (filterConfig) subjectConfigs = $087e637c79acc198$export$407448d2b89b1813(subjectConfigs, filterConfig);
        let otherEventStore = $087e637c79acc198$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
        let otherDefs = otherEventStore.defs;
        let otherInstances = otherEventStore.instances;
        let otherConfigs = $087e637c79acc198$var$compileEventUis(otherDefs, state.eventUiBases);
        for(let subjectInstanceId in subjectInstances){
            let subjectInstance = subjectInstances[subjectInstanceId];
            let subjectRange = subjectInstance.range;
            let subjectConfig = subjectConfigs[subjectInstance.defId];
            let subjectDef = subjectDefs[subjectInstance.defId];
            if (!$087e637c79acc198$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
            let { eventOverlap: eventOverlap } = context.options;
            let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
            for(let otherInstanceId in otherInstances){
                let otherInstance = otherInstances[otherInstanceId];
                if ($087e637c79acc198$export$ad4aebacdcaf47f8(subjectRange, otherInstance.range)) {
                    let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                    if (otherOverlap === false && interaction.isEvent) return false;
                    if (subjectConfig.overlap === false) return false;
                    if (eventOverlapFunc && !eventOverlapFunc(new $087e637c79acc198$export$34aec0b863436764(context, otherDefs[otherInstance.defId], otherInstance), new $087e637c79acc198$export$34aec0b863436764(context, subjectDef, subjectInstance))) return false;
                }
            }
            let calendarEventStore = currentState.eventStore;
            for (let subjectAllow of subjectConfig.allows){
                let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                    range: subjectInstance.range,
                    allDay: subjectDef.allDay
                });
                let origDef = calendarEventStore.defs[subjectDef.defId];
                let origInstance = calendarEventStore.instances[subjectInstanceId];
                let eventApi;
                if (origDef) eventApi = new $087e637c79acc198$export$34aec0b863436764(context, origDef, origInstance);
                else eventApi = new $087e637c79acc198$export$34aec0b863436764(context, subjectDef);
                if (!subjectAllow($087e637c79acc198$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
            }
        }
        return true;
    }
    function $087e637c79acc198$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
        let relevantEventStore = state.eventStore;
        let relevantDefs = relevantEventStore.defs;
        let relevantInstances = relevantEventStore.instances;
        let selection = state.dateSelection;
        let selectionRange = selection.range;
        let { selectionConfig: selectionConfig } = context.getCurrentData();
        if (filterConfig) selectionConfig = filterConfig(selectionConfig);
        if (!$087e637c79acc198$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
        let { selectOverlap: selectOverlap } = context.options;
        let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
        for(let relevantInstanceId in relevantInstances){
            let relevantInstance = relevantInstances[relevantInstanceId];
            if ($087e637c79acc198$export$ad4aebacdcaf47f8(selectionRange, relevantInstance.range)) {
                if (selectionConfig.overlap === false) return false;
                if (selectOverlapFunc && !selectOverlapFunc(new $087e637c79acc198$export$34aec0b863436764(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
            }
        }
        for (let selectionAllow of selectionConfig.allows){
            let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
            if (!selectionAllow($087e637c79acc198$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
        }
        return true;
    }
    function $087e637c79acc198$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
        for (let constraint of constraints){
            if (!$087e637c79acc198$var$anyRangesContainRange($087e637c79acc198$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
        }
        return true;
    }
    function $087e637c79acc198$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
        if (constraint === 'businessHours') return $087e637c79acc198$var$eventStoreToRanges($087e637c79acc198$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
        if (typeof constraint === 'string') return $087e637c79acc198$var$eventStoreToRanges($087e637c79acc198$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
        if (typeof constraint === 'object' && constraint) return $087e637c79acc198$var$eventStoreToRanges($087e637c79acc198$var$expandRecurring(constraint, subjectRange, context));
        return [];
    }
    function $087e637c79acc198$var$eventStoreToRanges(eventStore) {
        let { instances: instances } = eventStore;
        let ranges = [];
        for(let instanceId in instances)ranges.push(instances[instanceId].range);
        return ranges;
    }
    function $087e637c79acc198$var$anyRangesContainRange(outerRanges, innerRange) {
        for (let outerRange of outerRanges){
            if ($087e637c79acc198$export$4ae495d48253603d(outerRange, innerRange)) return true;
        }
        return false;
    }
    const $087e637c79acc198$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
    class $087e637c79acc198$export$807f1ba34db587c7 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.handleEl = (el)=>{
                this.el = el;
                $087e637c79acc198$export$8743009a87fcb00f(this.props.elRef, el);
            };
        }
        render() {
            let { props: props } = this;
            let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
            let isAbsolute = liquid && liquidIsAbsolute;
            let className = [
                'fc-scroller'
            ];
            if (liquid) {
                if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
                else className.push('fc-scroller-liquid');
            }
            return (0, $77d02.createElement)("div", {
                ref: this.handleEl,
                className: className.join(' '),
                style: {
                    overflowX: props.overflowX,
                    overflowY: props.overflowY,
                    left: isAbsolute && -(props.overcomeLeft || 0) || '',
                    right: isAbsolute && -(props.overcomeRight || 0) || '',
                    bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                    marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                    marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                    marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                    maxHeight: props.maxHeight || ''
                }
            }, props.children);
        }
        needsXScrolling() {
            if ($087e637c79acc198$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
            let { el: el } = this;
            let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
            let { children: children } = el;
            for(let i = 0; i < children.length; i += 1){
                let childEl = children[i];
                if (childEl.getBoundingClientRect().width > realClientWidth) return true;
            }
            return false;
        }
        needsYScrolling() {
            if ($087e637c79acc198$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
            let { el: el } = this;
            let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
            let { children: children } = el;
            for(let i = 0; i < children.length; i += 1){
                let childEl = children[i];
                if (childEl.getBoundingClientRect().height > realClientHeight) return true;
            }
            return false;
        }
        getXScrollbarWidth() {
            if ($087e637c79acc198$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
            return this.el.offsetHeight - this.el.clientHeight;
        }
        getYScrollbarWidth() {
            if ($087e637c79acc198$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
            return this.el.offsetWidth - this.el.clientWidth;
        }
    }
    class $087e637c79acc198$export$49e6ee724f7f1ace {
        constructor(masterCallback){
            this.masterCallback = masterCallback;
            this.currentMap = {};
            this.depths = {};
            this.callbackMap = {};
            this.handleValue = (val, key)=>{
                let { depths: depths, currentMap: currentMap } = this;
                let removed = false;
                let added = false;
                if (val !== null) {
                    removed = key in currentMap;
                    currentMap[key] = val;
                    depths[key] = (depths[key] || 0) + 1;
                    added = true;
                } else {
                    depths[key] -= 1;
                    if (!depths[key]) {
                        delete currentMap[key];
                        delete this.callbackMap[key];
                        removed = true;
                    }
                }
                if (this.masterCallback) {
                    if (removed) this.masterCallback(null, String(key));
                    if (added) this.masterCallback(val, String(key));
                }
            };
        }
        createRef(key) {
            let refCallback = this.callbackMap[key];
            if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
                this.handleValue(val, String(key));
            };
            return refCallback;
        }
        collect(startIndex, endIndex, step) {
            return $087e637c79acc198$export$91477dc880baac21(this.currentMap, startIndex, endIndex, step);
        }
        getAll() {
            return $087e637c79acc198$export$625550452a3fa3ec(this.currentMap);
        }
    }
    function $087e637c79acc198$export$f5339a28e56d1baf(chunkEls) {
        let shrinkCells = $087e637c79acc198$export$9f4f30ee63539e24(chunkEls, '.fc-scrollgrid-shrink');
        let largestWidth = 0;
        for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $087e637c79acc198$var$computeSmallestCellWidth(shrinkCell));
        return Math.ceil(largestWidth);
    }
    function $087e637c79acc198$export$4f33f238a5c1ad77(props, sectionConfig) {
        return props.liquid && sectionConfig.liquid;
    }
    function $087e637c79acc198$export$7fe88b5920ffddd2(props, sectionConfig) {
        return sectionConfig.maxHeight != null || $087e637c79acc198$export$4f33f238a5c1ad77(props, sectionConfig);
    }
    function $087e637c79acc198$export$df7c425476ed4f2(sectionConfig, chunkConfig, arg, isHeader) {
        let { expandRows: expandRows } = arg;
        let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $77d02.createElement)('table', {
            role: 'presentation',
            className: [
                chunkConfig.tableClassName,
                sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
            ].join(' '),
            style: {
                minWidth: arg.tableMinWidth,
                width: arg.clientWidth,
                height: expandRows ? arg.clientHeight : ''
            }
        }, arg.tableColGroupNode, (0, $77d02.createElement)(isHeader ? 'thead' : 'tbody', {
            role: 'presentation'
        }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
        return content;
    }
    function $087e637c79acc198$export$4ad369a19af21c23(cols0, cols1) {
        return $087e637c79acc198$export$23f2a1d2818174ef(cols0, cols1, $087e637c79acc198$export$ebd11618f299a286);
    }
    function $087e637c79acc198$export$101619b11a34a0bd(cols, shrinkWidth) {
        let colNodes = [];
        for (let colProps of cols){
            let span = colProps.span || 1;
            for(let i = 0; i < span; i += 1)colNodes.push((0, $77d02.createElement)("col", {
                style: {
                    width: colProps.width === 'shrink' ? $087e637c79acc198$export$1ec7a8278ebd1290(shrinkWidth) : colProps.width || '',
                    minWidth: colProps.minWidth || ''
                }
            }));
        }
        return (0, $77d02.createElement)('colgroup', {}, ...colNodes);
    }
    function $087e637c79acc198$export$1ec7a8278ebd1290(shrinkWidth) {
        return shrinkWidth == null ? 4 : shrinkWidth;
    }
    function $087e637c79acc198$export$65ab0ebced932b79(cols) {
        for (let col of cols){
            if (col.width === 'shrink') return true;
        }
        return false;
    }
    function $087e637c79acc198$export$60e660859c376841(liquid, context) {
        let classNames = [
            'fc-scrollgrid',
            context.theme.getClass('table')
        ];
        if (liquid) classNames.push('fc-scrollgrid-liquid');
        return classNames;
    }
    function $087e637c79acc198$export$df838d0240c938cf(sectionConfig, wholeTableVGrow) {
        let classNames = [
            'fc-scrollgrid-section',
            `fc-scrollgrid-section-${sectionConfig.type}`,
            sectionConfig.className
        ];
        if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
        if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
        return classNames;
    }
    function $087e637c79acc198$export$89e9012e902952b6(arg) {
        return (0, $77d02.createElement)("div", {
            className: "fc-scrollgrid-sticky-shim",
            style: {
                width: arg.clientWidth,
                minWidth: arg.tableMinWidth
            }
        });
    }
    function $087e637c79acc198$export$a1edd97dd51cd48d(options) {
        let { stickyHeaderDates: stickyHeaderDates } = options;
        if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
        return stickyHeaderDates;
    }
    function $087e637c79acc198$export$54c4fabc2291e9c0(options) {
        let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
        if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
        return stickyFooterScrollbar;
    }
    class $087e637c79acc198$export$add49c223b9ce4ea extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.processCols = $087e637c79acc198$export$4a5767248b18ef41((a)=>a, $087e637c79acc198$export$4ad369a19af21c23);
            this.renderMicroColGroup = $087e637c79acc198$export$4a5767248b18ef41($087e637c79acc198$export$101619b11a34a0bd);
            this.scrollerRefs = new $087e637c79acc198$export$49e6ee724f7f1ace();
            this.scrollerElRefs = new $087e637c79acc198$export$49e6ee724f7f1ace(this._handleScrollerEl.bind(this));
            this.state = {
                shrinkWidth: null,
                forceYScrollbars: false,
                scrollerClientWidths: {},
                scrollerClientHeights: {}
            };
            this.handleSizing = ()=>{
                this.safeSetState(Object.assign({
                    shrinkWidth: this.computeShrinkWidth()
                }, this.computeScrollerDims()));
            };
        }
        render() {
            let { props: props, state: state, context: context } = this;
            let sectionConfigs = props.sections || [];
            let cols = this.processCols(props.cols);
            let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
            let classNames = $087e637c79acc198$export$60e660859c376841(props.liquid, context);
            if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
            let configCnt = sectionConfigs.length;
            let configI = 0;
            let currentConfig;
            let headSectionNodes = [];
            let bodySectionNodes = [];
            let footSectionNodes = [];
            while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
                headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                configI += 1;
            }
            while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
                bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
                configI += 1;
            }
            while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
                footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                configI += 1;
            }
            let isBuggy = !$087e637c79acc198$export$667d3bf0c5f83305();
            const roleAttrs = {
                role: 'rowgroup'
            };
            return (0, $77d02.createElement)('table', {
                role: 'grid',
                className: classNames.join(' '),
                style: {
                    height: props.height
                }
            }, Boolean(!isBuggy && headSectionNodes.length) && (0, $77d02.createElement)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $77d02.createElement)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $77d02.createElement)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, $77d02.createElement)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
        }
        renderSection(sectionConfig, microColGroupNode, isHeader) {
            if ('outerContent' in sectionConfig) return (0, $77d02.createElement)((0, $77d02.Fragment), {
                key: sectionConfig.key
            }, sectionConfig.outerContent);
            return (0, $77d02.createElement)("tr", {
                key: sectionConfig.key,
                role: "presentation",
                className: $087e637c79acc198$export$df838d0240c938cf(sectionConfig, this.props.liquid).join(' ')
            }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
        }
        renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
            if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
            let { props: props } = this;
            let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
            let needsYScrolling = $087e637c79acc198$export$7fe88b5920ffddd2(props, sectionConfig);
            let isLiquid = $087e637c79acc198$export$4f33f238a5c1ad77(props, sectionConfig);
            let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
            let sectionKey = sectionConfig.key;
            let content = $087e637c79acc198$export$df7c425476ed4f2(sectionConfig, chunkConfig, {
                tableColGroupNode: microColGroupNode,
                tableMinWidth: '',
                clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
                clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
                expandRows: sectionConfig.expandRows,
                syncRowHeights: false,
                rowSyncHeights: [],
                reportRowHeightChange: ()=>{}
            }, isHeader);
            return (0, $77d02.createElement)(isHeader ? 'th' : 'td', {
                ref: chunkConfig.elRef,
                role: 'presentation'
            }, (0, $77d02.createElement)("div", {
                className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
            }, (0, $77d02.createElement)($087e637c79acc198$export$807f1ba34db587c7, {
                ref: this.scrollerRefs.createRef(sectionKey),
                elRef: this.scrollerElRefs.createRef(sectionKey),
                overflowY: overflowY,
                overflowX: !props.liquid ? 'visible' : 'hidden',
                maxHeight: sectionConfig.maxHeight,
                liquid: isLiquid,
                liquidIsAbsolute: true
            }, content)));
        }
        _handleScrollerEl(scrollerEl, key) {
            let section = $087e637c79acc198$var$getSectionByKey(this.props.sections, key);
            if (section) $087e637c79acc198$export$8743009a87fcb00f(section.chunk.scrollerElRef, scrollerEl);
        }
        componentDidMount() {
            this.handleSizing();
            this.context.addResizeHandler(this.handleSizing);
        }
        componentDidUpdate() {
            this.handleSizing();
        }
        componentWillUnmount() {
            this.context.removeResizeHandler(this.handleSizing);
        }
        computeShrinkWidth() {
            return $087e637c79acc198$export$65ab0ebced932b79(this.props.cols) ? $087e637c79acc198$export$f5339a28e56d1baf(this.scrollerElRefs.getAll()) : 0;
        }
        computeScrollerDims() {
            let scrollbarWidth = $087e637c79acc198$export$c7ca7e4bc4f8a16e();
            let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
            let forceYScrollbars = false;
            let scrollerClientWidths = {};
            let scrollerClientHeights = {};
            for(let sectionKey in scrollerRefs.currentMap){
                let scroller = scrollerRefs.currentMap[sectionKey];
                if (scroller && scroller.needsYScrolling()) {
                    forceYScrollbars = true;
                    break;
                }
            }
            for (let section of this.props.sections){
                let sectionKey = section.key;
                let scrollerEl = scrollerElRefs.currentMap[sectionKey];
                if (scrollerEl) {
                    let harnessEl = scrollerEl.parentNode;
                    scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y : 0));
                    scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
                }
            }
            return {
                forceYScrollbars: forceYScrollbars,
                scrollerClientWidths: scrollerClientWidths,
                scrollerClientHeights: scrollerClientHeights
            };
        }
    }
    $087e637c79acc198$export$add49c223b9ce4ea.addStateEquality({
        scrollerClientWidths: $087e637c79acc198$export$ebd11618f299a286,
        scrollerClientHeights: $087e637c79acc198$export$ebd11618f299a286
    });
    function $087e637c79acc198$var$getSectionByKey(sections, key) {
        for (let section of sections){
            if (section.key === key) return section;
        }
        return null;
    }
    class $087e637c79acc198$export$1343a74baacb0543 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.handleEl = (el)=>{
                this.el = el;
                if (el) $087e637c79acc198$var$setElSeg(el, this.props.seg);
            };
        }
        render() {
            const { props: props, context: context } = this;
            const { options: options } = context;
            const { seg: seg } = props;
            const { eventRange: eventRange } = seg;
            const { ui: ui } = eventRange;
            const renderProps = {
                event: new $087e637c79acc198$export$34aec0b863436764(context, eventRange.def, eventRange.instance),
                view: context.viewApi,
                timeText: props.timeText,
                textColor: ui.textColor,
                backgroundColor: ui.backgroundColor,
                borderColor: ui.borderColor,
                isDraggable: !props.disableDragging && $087e637c79acc198$var$computeSegDraggable(seg, context),
                isStartResizable: !props.disableResizing && $087e637c79acc198$var$computeSegStartResizable(seg, context),
                isEndResizable: !props.disableResizing && $087e637c79acc198$var$computeSegEndResizable(seg),
                isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
                isStart: Boolean(seg.isStart),
                isEnd: Boolean(seg.isEnd),
                isPast: Boolean(props.isPast),
                isFuture: Boolean(props.isFuture),
                isToday: Boolean(props.isToday),
                isSelected: Boolean(props.isSelected),
                isDragging: Boolean(props.isDragging),
                isResizing: Boolean(props.isResizing)
            };
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, Object.assign({}, props, {
                elRef: this.handleEl,
                elClasses: [
                    ...$087e637c79acc198$var$getEventClassNames(renderProps),
                    ...seg.eventRange.ui.classNames,
                    ...props.elClasses || []
                ],
                renderProps: renderProps,
                generatorName: "eventContent",
                customGenerator: options.eventContent,
                defaultGenerator: props.defaultGenerator,
                classNameGenerator: options.eventClassNames,
                didMount: options.eventDidMount,
                willUnmount: options.eventWillUnmount
            }));
        }
        componentDidUpdate(prevProps) {
            if (this.el && this.props.seg !== prevProps.seg) $087e637c79acc198$var$setElSeg(this.el, this.props.seg);
        }
    }
    class $087e637c79acc198$export$d92db8a7dc823bb0 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        render() {
            let { props: props, context: context } = this;
            let { options: options } = context;
            let { seg: seg } = props;
            let { ui: ui } = seg.eventRange;
            let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
            let timeText = $087e637c79acc198$export$993a080e5cb62d74(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
            return (0, $77d02.createElement)($087e637c79acc198$export$1343a74baacb0543, Object.assign({}, props, {
                elTag: "a",
                elStyle: {
                    borderColor: ui.borderColor,
                    backgroundColor: ui.backgroundColor
                },
                elAttrs: $087e637c79acc198$export$e0c3a065614c6254(seg, context),
                defaultGenerator: $087e637c79acc198$var$renderInnerContent$1,
                timeText: timeText
            }), (InnerContent, eventContentArg)=>(0, $77d02.createElement)((0, $77d02.Fragment), null, (0, $77d02.createElement)(InnerContent, {
                    elTag: "div",
                    elClasses: [
                        'fc-event-main'
                    ],
                    elStyle: {
                        color: eventContentArg.textColor
                    }
                }), Boolean(eventContentArg.isStartResizable) && (0, $77d02.createElement)("div", {
                    className: "fc-event-resizer fc-event-resizer-start"
                }), Boolean(eventContentArg.isEndResizable) && (0, $77d02.createElement)("div", {
                    className: "fc-event-resizer fc-event-resizer-end"
                })));
        }
    }
    function $087e637c79acc198$var$renderInnerContent$1(innerProps) {
        return (0, $77d02.createElement)("div", {
            className: "fc-event-main-frame"
        }, innerProps.timeText && (0, $77d02.createElement)("div", {
            className: "fc-event-time"
        }, innerProps.timeText), (0, $77d02.createElement)("div", {
            className: "fc-event-title-container"
        }, (0, $77d02.createElement)("div", {
            className: "fc-event-title fc-sticky"
        }, innerProps.event.title || (0, $77d02.createElement)((0, $77d02.Fragment), null, "\u00A0"))));
    }
    const $087e637c79acc198$export$c1df809846363ebe = (props)=>(0, $77d02.createElement)($087e637c79acc198$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { options: options } = context;
            let renderProps = {
                isAxis: props.isAxis,
                date: context.dateEnv.toDate(props.date),
                view: context.viewApi
            };
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, Object.assign({}, props, {
                elTag: props.elTag || 'div',
                renderProps: renderProps,
                generatorName: "nowIndicatorContent",
                customGenerator: options.nowIndicatorContent,
                classNameGenerator: options.nowIndicatorClassNames,
                didMount: options.nowIndicatorDidMount,
                willUnmount: options.nowIndicatorWillUnmount
            }));
        });
    const $087e637c79acc198$var$DAY_NUM_FORMAT = $087e637c79acc198$export$efccba1c4a2ef57b({
        day: 'numeric'
    });
    class $087e637c79acc198$export$b975d55abac2bbe3 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.refineRenderProps = $087e637c79acc198$export$df995fae86a55f06($087e637c79acc198$var$refineRenderProps);
        }
        render() {
            let { props: props, context: context } = this;
            let { options: options } = context;
            let renderProps = this.refineRenderProps({
                date: props.date,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                isMonthStart: props.isMonthStart || false,
                showDayNumber: props.showDayNumber,
                extraRenderProps: props.extraRenderProps,
                viewApi: context.viewApi,
                dateEnv: context.dateEnv,
                monthStartFormat: options.monthStartFormat
            });
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, Object.assign({}, props, {
                elClasses: [
                    ...$087e637c79acc198$export$527e9aa3390079e9(renderProps, context.theme),
                    ...props.elClasses || []
                ],
                elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                    'data-date': $087e637c79acc198$export$5dbe06c6d8c68cfb(props.date)
                }),
                renderProps: renderProps,
                generatorName: "dayCellContent",
                customGenerator: options.dayCellContent,
                defaultGenerator: props.defaultGenerator,
                classNameGenerator: renderProps.isDisabled ? undefined : options.dayCellClassNames,
                didMount: options.dayCellDidMount,
                willUnmount: options.dayCellWillUnmount
            }));
        }
    }
    function $087e637c79acc198$export$b02498c06ddfef28(options) {
        return Boolean(options.dayCellContent || $087e637c79acc198$var$hasCustomRenderingHandler('dayCellContent', options));
    }
    function $087e637c79acc198$var$refineRenderProps(raw) {
        let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
        let dayMeta = $087e637c79acc198$export$a17c37559e1db147(date, raw.todayRange, null, dateProfile);
        let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $087e637c79acc198$var$DAY_NUM_FORMAT) : '';
        return Object.assign(Object.assign(Object.assign({
            date: dateEnv.toDate(date),
            view: raw.viewApi
        }, dayMeta), {
            isMonthStart: isMonthStart,
            dayNumberText: dayNumberText
        }), raw.extraRenderProps);
    }
    class $087e637c79acc198$export$cd571ca6d1702b73 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        render() {
            let { props: props } = this;
            let { seg: seg } = props;
            return (0, $77d02.createElement)($087e637c79acc198$export$1343a74baacb0543, {
                elTag: "div",
                elClasses: [
                    'fc-bg-event'
                ],
                elStyle: {
                    backgroundColor: seg.eventRange.ui.backgroundColor
                },
                defaultGenerator: $087e637c79acc198$var$renderInnerContent,
                seg: seg,
                timeText: "",
                isDragging: false,
                isResizing: false,
                isDateSelecting: false,
                isSelected: false,
                isPast: props.isPast,
                isFuture: props.isFuture,
                isToday: props.isToday,
                disableDragging: true,
                disableResizing: true
            });
        }
    }
    function $087e637c79acc198$var$renderInnerContent(props) {
        let { title: title } = props.event;
        return title && (0, $77d02.createElement)("div", {
            className: "fc-event-title"
        }, props.event.title);
    }
    function $087e637c79acc198$export$87b6ab1c2cb8b955(fillType) {
        return (0, $77d02.createElement)("div", {
            className: `fc-${fillType}`
        });
    }
    const $087e637c79acc198$export$a3c9165b94390bcd = (props)=>(0, $77d02.createElement)($087e637c79acc198$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { dateEnv: dateEnv, options: options } = context;
            let { date: date } = props;
            let format = options.weekNumberFormat || props.defaultFormat;
            let num = dateEnv.computeWeekNumber(date);
            let text = dateEnv.format(date, format);
            let renderProps = {
                num: num,
                text: text,
                date: date
            };
            return (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, Object.assign({}, props, {
                renderProps: renderProps,
                generatorName: "weekNumberContent",
                customGenerator: options.weekNumberContent,
                defaultGenerator: $087e637c79acc198$var$renderInner,
                classNameGenerator: options.weekNumberClassNames,
                didMount: options.weekNumberDidMount,
                willUnmount: options.weekNumberWillUnmount
            }));
        });
    function $087e637c79acc198$var$renderInner(innerProps) {
        return innerProps.text;
    }
    const $087e637c79acc198$var$PADDING_FROM_VIEWPORT = 10;
    class $087e637c79acc198$var$Popover extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.state = {
                titleId: $087e637c79acc198$export$a8550f7dbe79f93a()
            };
            this.handleRootEl = (el)=>{
                this.rootEl = el;
                if (this.props.elRef) $087e637c79acc198$export$8743009a87fcb00f(this.props.elRef, el);
            };
            this.handleDocumentMouseDown = (ev)=>{
                const target = $087e637c79acc198$export$738ab4df8bf92ae9(ev);
                if (!this.rootEl.contains(target)) this.handleCloseClick();
            };
            this.handleDocumentKeyDown = (ev)=>{
                if (ev.key === 'Escape') this.handleCloseClick();
            };
            this.handleCloseClick = ()=>{
                let { onClose: onClose } = this.props;
                if (onClose) onClose();
            };
        }
        render() {
            let { theme: theme, options: options } = this.context;
            let { props: props, state: state } = this;
            let classNames = [
                'fc-popover',
                theme.getClass('popover')
            ].concat(props.extraClassNames || []);
            return (0, $j8P0R.createPortal)((0, $77d02.createElement)("div", Object.assign({}, props.extraAttrs, {
                id: props.id,
                className: classNames.join(' '),
                "aria-labelledby": state.titleId,
                ref: this.handleRootEl
            }), (0, $77d02.createElement)("div", {
                className: 'fc-popover-header ' + theme.getClass('popoverHeader')
            }, (0, $77d02.createElement)("span", {
                className: "fc-popover-title",
                id: state.titleId
            }, props.title), (0, $77d02.createElement)("span", {
                className: 'fc-popover-close ' + theme.getIconClass('close'),
                title: options.closeHint,
                onClick: this.handleCloseClick
            })), (0, $77d02.createElement)("div", {
                className: 'fc-popover-body ' + theme.getClass('popoverContent')
            }, props.children)), props.parentEl);
        }
        componentDidMount() {
            document.addEventListener('mousedown', this.handleDocumentMouseDown);
            document.addEventListener('keydown', this.handleDocumentKeyDown);
            this.updateSize();
        }
        componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleDocumentMouseDown);
            document.removeEventListener('keydown', this.handleDocumentKeyDown);
        }
        updateSize() {
            let { isRtl: isRtl } = this.context;
            let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
            let { rootEl: rootEl } = this;
            let alignmentRect = $087e637c79acc198$var$computeClippedClientRect(alignmentEl);
            if (alignmentRect) {
                let popoverDims = rootEl.getBoundingClientRect();
                let popoverTop = alignGridTop ? $087e637c79acc198$export$3d8c2f653ac9d0b9(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
                let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
                popoverTop = Math.max(popoverTop, $087e637c79acc198$var$PADDING_FROM_VIEWPORT);
                popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $087e637c79acc198$var$PADDING_FROM_VIEWPORT - popoverDims.width);
                popoverLeft = Math.max(popoverLeft, $087e637c79acc198$var$PADDING_FROM_VIEWPORT);
                let origin = rootEl.offsetParent.getBoundingClientRect();
                $087e637c79acc198$export$2ed0fc6709e59212(rootEl, {
                    top: popoverTop - origin.top,
                    left: popoverLeft - origin.left
                });
            }
        }
    }
    class $087e637c79acc198$var$MorePopover extends $087e637c79acc198$export$51b138e5a065c2bb {
        constructor(){
            super(...arguments);
            this.handleRootEl = (rootEl)=>{
                this.rootEl = rootEl;
                if (rootEl) this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    useEventCenter: false
                });
                else this.context.unregisterInteractiveComponent(this);
            };
        }
        render() {
            let { options: options, dateEnv: dateEnv } = this.context;
            let { props: props } = this;
            let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
            let title = dateEnv.format(startDate, options.dayPopoverFormat);
            return (0, $77d02.createElement)($087e637c79acc198$export$b975d55abac2bbe3, {
                elRef: this.handleRootEl,
                date: startDate,
                dateProfile: dateProfile,
                todayRange: todayRange
            }, (InnerContent, renderProps, elAttrs)=>(0, $77d02.createElement)($087e637c79acc198$var$Popover, {
                    elRef: elAttrs.ref,
                    id: props.id,
                    title: title,
                    extraClassNames: [
                        'fc-more-popover'
                    ].concat(elAttrs.className || []),
                    extraAttrs: elAttrs,
                    parentEl: props.parentEl,
                    alignmentEl: props.alignmentEl,
                    alignGridTop: props.alignGridTop,
                    onClose: props.onClose
                }, $087e637c79acc198$export$b02498c06ddfef28(options) && (0, $77d02.createElement)(InnerContent, {
                    elTag: "div",
                    elClasses: [
                        'fc-more-popover-misc'
                    ]
                }), props.children));
        }
        queryHit(positionLeft, positionTop, elWidth, elHeight) {
            let { rootEl: rootEl, props: props } = this;
            if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
                dateProfile: props.dateProfile,
                dateSpan: Object.assign({
                    allDay: !props.forceTimed,
                    range: {
                        start: props.startDate,
                        end: props.endDate
                    }
                }, props.extraDateSpan),
                dayEl: rootEl,
                rect: {
                    left: 0,
                    top: 0,
                    right: elWidth,
                    bottom: elHeight
                },
                layer: 1
            };
            return null;
        }
    }
    class $087e637c79acc198$export$cbfbec548517f2b6 extends $087e637c79acc198$export$78acf4525d8a74c4 {
        constructor(){
            super(...arguments);
            this.state = {
                isPopoverOpen: false,
                popoverId: $087e637c79acc198$export$a8550f7dbe79f93a()
            };
            this.handleLinkEl = (linkEl)=>{
                this.linkEl = linkEl;
                if (this.props.elRef) $087e637c79acc198$export$8743009a87fcb00f(this.props.elRef, linkEl);
            };
            this.handleClick = (ev)=>{
                let { props: props, context: context } = this;
                let { moreLinkClick: moreLinkClick } = context.options;
                let date = $087e637c79acc198$var$computeRange(props).start;
                function buildPublicSeg(seg) {
                    let { def: def, instance: instance, range: range } = seg.eventRange;
                    return {
                        event: new $087e637c79acc198$export$34aec0b863436764(context, def, instance),
                        start: context.dateEnv.toDate(range.start),
                        end: context.dateEnv.toDate(range.end),
                        isStart: seg.isStart,
                        isEnd: seg.isEnd
                    };
                }
                if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                    date: date,
                    allDay: Boolean(props.allDayDate),
                    allSegs: props.allSegs.map(buildPublicSeg),
                    hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                    isPopoverOpen: true
                });
                else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
            };
            this.handlePopoverClose = ()=>{
                this.setState({
                    isPopoverOpen: false
                });
            };
        }
        render() {
            let { props: props, state: state } = this;
            return (0, $77d02.createElement)($087e637c79acc198$export$e7c866399fa523f5.Consumer, null, (context)=>{
                let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
                let { moreLinkText: moreLinkText } = options;
                let { moreCnt: moreCnt } = props;
                let range = $087e637c79acc198$var$computeRange(props);
                let text = typeof moreLinkText === 'function' ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
                let hint = $087e637c79acc198$export$35e795649ee09318(options.moreLinkHint, [
                    moreCnt
                ], text);
                let renderProps = {
                    num: moreCnt,
                    shortText: `+${moreCnt}`,
                    text: text,
                    view: viewApi
                };
                return (0, $77d02.createElement)((0, $77d02.Fragment), null, Boolean(props.moreCnt) && (0, $77d02.createElement)($087e637c79acc198$export$e7094788287c5e9b, {
                    elTag: props.elTag || 'a',
                    elRef: this.handleLinkEl,
                    elClasses: [
                        ...props.elClasses || [],
                        'fc-more-link'
                    ],
                    elStyle: props.elStyle,
                    elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $087e637c79acc198$var$createAriaClickAttrs(this.handleClick)), {
                        title: hint,
                        'aria-expanded': state.isPopoverOpen,
                        'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                    }),
                    renderProps: renderProps,
                    generatorName: "moreLinkContent",
                    customGenerator: options.moreLinkContent,
                    defaultGenerator: props.defaultGenerator || $087e637c79acc198$var$renderMoreLinkInner,
                    classNameGenerator: options.moreLinkClassNames,
                    didMount: options.moreLinkDidMount,
                    willUnmount: options.moreLinkWillUnmount
                }, props.children), state.isPopoverOpen && (0, $77d02.createElement)($087e637c79acc198$var$MorePopover, {
                    id: state.popoverId,
                    startDate: range.start,
                    endDate: range.end,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    extraDateSpan: props.extraDateSpan,
                    parentEl: this.parentEl,
                    alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                    alignGridTop: props.alignGridTop,
                    forceTimed: props.forceTimed,
                    onClose: this.handlePopoverClose
                }, props.popoverContent()));
            });
        }
        componentDidMount() {
            this.updateParentEl();
        }
        componentDidUpdate() {
            this.updateParentEl();
        }
        updateParentEl() {
            if (this.linkEl) this.parentEl = $087e637c79acc198$export$3d8c2f653ac9d0b9(this.linkEl, '.fc-view-harness');
        }
    }
    function $087e637c79acc198$var$renderMoreLinkInner(props) {
        return props.text;
    }
    function $087e637c79acc198$var$computeRange(props) {
        if (props.allDayDate) return {
            start: props.allDayDate,
            end: $087e637c79acc198$export$9e5f44173e64f162(props.allDayDate, 1)
        };
        let { hiddenSegs: hiddenSegs } = props;
        return {
            start: $087e637c79acc198$export$bde1ed0f60b38f2f(hiddenSegs),
            end: $087e637c79acc198$var$computeLatestSegEnd(hiddenSegs)
        };
    }
    function $087e637c79acc198$export$bde1ed0f60b38f2f(segs) {
        return segs.reduce($087e637c79acc198$var$pickEarliestStart).eventRange.range.start;
    }
    function $087e637c79acc198$var$pickEarliestStart(seg0, seg1) {
        return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
    }
    function $087e637c79acc198$var$computeLatestSegEnd(segs) {
        return segs.reduce($087e637c79acc198$var$pickLatestEnd).eventRange.range.end;
    }
    function $087e637c79acc198$var$pickLatestEnd(seg0, seg1) {
        return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
    }
    class $087e637c79acc198$var$Store {
        constructor(){
            this.handlers = [];
        }
        set(value) {
            this.currentValue = value;
            for (let handler of this.handlers)handler(value);
        }
        subscribe(handler) {
            this.handlers.push(handler);
            if (this.currentValue !== undefined) handler(this.currentValue);
        }
    }
    class $087e637c79acc198$export$aea64bc1b6f8f415 extends $087e637c79acc198$var$Store {
        constructor(){
            super(...arguments);
            this.map = new Map();
        }
        handle(customRendering) {
            const { map: map } = this;
            let updated = false;
            if (customRendering.isActive) {
                map.set(customRendering.id, customRendering);
                updated = true;
            } else if (map.has(customRendering.id)) {
                map.delete(customRendering.id);
                updated = true;
            }
            if (updated) this.set(map);
        }
    }
});
parcelRegister("77d02", function(module, exports) {
    $parcel$export(module.exports, "options", ()=>$52e3454efe139461$export$41c562ebe57d11e2);
    $parcel$export(module.exports, "isValidElement", ()=>$52e3454efe139461$export$a8257692ac88316c);
    $parcel$export(module.exports, "createElement", ()=>$52e3454efe139461$export$c8a8987d4410bf2d);
    $parcel$export(module.exports, "createRef", ()=>$52e3454efe139461$export$7d1e3a5e95ceca43);
    $parcel$export(module.exports, "Fragment", ()=>$52e3454efe139461$export$ffb0004e005737fa);
    $parcel$export(module.exports, "Component", ()=>$52e3454efe139461$export$16fa2f45be04daa8);
    $parcel$export(module.exports, "toChildArray", ()=>$52e3454efe139461$export$47e4c5b300681277);
    $parcel$export(module.exports, "render", ()=>$52e3454efe139461$export$b3890eb0ae9dca99);
    $parcel$export(module.exports, "hydrate", ()=>$52e3454efe139461$export$fa8d919ba61d84db);
    $parcel$export(module.exports, "cloneElement", ()=>$52e3454efe139461$export$e530037191fcd5d7);
    $parcel$export(module.exports, "createContext", ()=>$52e3454efe139461$export$fd42f52fd3ae1109);
    var $52e3454efe139461$var$n, $52e3454efe139461$export$41c562ebe57d11e2, $52e3454efe139461$var$u, $52e3454efe139461$export$a8257692ac88316c, $52e3454efe139461$var$t, $52e3454efe139461$var$r, $52e3454efe139461$var$o, $52e3454efe139461$var$f, $52e3454efe139461$var$e, $52e3454efe139461$var$c = {}, $52e3454efe139461$var$s = [], $52e3454efe139461$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    function $52e3454efe139461$var$h(n, l) {
        for(var u in l)n[u] = l[u];
        return n;
    }
    function $52e3454efe139461$var$v(n) {
        var l = n.parentNode;
        l && l.removeChild(n);
    }
    function $52e3454efe139461$export$c8a8987d4410bf2d(l, u, i) {
        var t, r, o, f = {};
        for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
        if (arguments.length > 2 && (f.children = arguments.length > 3 ? $52e3454efe139461$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
        return $52e3454efe139461$var$p(l, f, t, r, null);
    }
    function $52e3454efe139461$var$p(n, i, t, r, o) {
        var f = {
            type: n,
            props: i,
            key: t,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == o ? ++$52e3454efe139461$var$u : o
        };
        return null == o && null != $52e3454efe139461$export$41c562ebe57d11e2.vnode && $52e3454efe139461$export$41c562ebe57d11e2.vnode(f), f;
    }
    function $52e3454efe139461$export$7d1e3a5e95ceca43() {
        return {
            current: null
        };
    }
    function $52e3454efe139461$export$ffb0004e005737fa(n) {
        return n.children;
    }
    function $52e3454efe139461$var$k(n, l, u, i, t) {
        var r;
        for(r in u)"children" === r || "key" === r || r in l || $52e3454efe139461$var$g(n, r, null, u[r], i);
        for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $52e3454efe139461$var$g(n, r, l[r], u[r], i);
    }
    function $52e3454efe139461$var$b(n, l, u) {
        "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $52e3454efe139461$var$a.test(l) ? u : u + "px";
    }
    function $52e3454efe139461$var$g(n, l, u, i, t) {
        var r;
        n: if ("style" === l) {
            if ("string" == typeof u) n.style.cssText = u;
            else {
                if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $52e3454efe139461$var$b(n.style, l, "");
                if (u) for(l in u)i && u[l] === i[l] || $52e3454efe139461$var$b(n.style, l, u[l]);
            }
        } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $52e3454efe139461$var$w : $52e3454efe139461$var$m, r) : n.removeEventListener(l, r ? $52e3454efe139461$var$w : $52e3454efe139461$var$m, r);
        else if ("dangerouslySetInnerHTML" !== l) {
            if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
                n[l] = null == u ? "" : u;
                break n;
            } catch (n) {}
            "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
        }
    }
    function $52e3454efe139461$var$m(n) {
        $52e3454efe139461$var$t = !0;
        try {
            return this.l[n.type + !1]($52e3454efe139461$export$41c562ebe57d11e2.event ? $52e3454efe139461$export$41c562ebe57d11e2.event(n) : n);
        } finally{
            $52e3454efe139461$var$t = !1;
        }
    }
    function $52e3454efe139461$var$w(n) {
        $52e3454efe139461$var$t = !0;
        try {
            return this.l[n.type + !0]($52e3454efe139461$export$41c562ebe57d11e2.event ? $52e3454efe139461$export$41c562ebe57d11e2.event(n) : n);
        } finally{
            $52e3454efe139461$var$t = !1;
        }
    }
    function $52e3454efe139461$export$16fa2f45be04daa8(n, l) {
        this.props = n, this.context = l;
    }
    function $52e3454efe139461$var$A(n, l) {
        if (null == l) return n.__ ? $52e3454efe139461$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
        for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
        return "function" == typeof n.type ? $52e3454efe139461$var$A(n) : null;
    }
    function $52e3454efe139461$var$P(n) {
        var l, u;
        if (null != (n = n.__) && null != n.__c) {
            for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
                n.__e = n.__c.base = u.__e;
                break;
            }
            return $52e3454efe139461$var$P(n);
        }
    }
    function $52e3454efe139461$var$C(n) {
        $52e3454efe139461$var$t ? setTimeout(n) : $52e3454efe139461$var$f(n);
    }
    function $52e3454efe139461$var$T(n) {
        (!n.__d && (n.__d = !0) && $52e3454efe139461$var$r.push(n) && !$52e3454efe139461$var$$.__r++ || $52e3454efe139461$var$o !== $52e3454efe139461$export$41c562ebe57d11e2.debounceRendering) && (($52e3454efe139461$var$o = $52e3454efe139461$export$41c562ebe57d11e2.debounceRendering) || $52e3454efe139461$var$C)($52e3454efe139461$var$$);
    }
    function $52e3454efe139461$var$$() {
        var n, l, u, i, t, o, f, e;
        for($52e3454efe139461$var$r.sort(function(n, l) {
            return n.__v.__b - l.__v.__b;
        }); n = $52e3454efe139461$var$r.shift();)n.__d && (l = $52e3454efe139461$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $52e3454efe139461$var$h({}, o)).__v = o.__v + 1, $52e3454efe139461$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
            f
        ] : null, i, null == f ? $52e3454efe139461$var$A(o) : f, o.__h), $52e3454efe139461$var$N(i, o), o.__e != f && $52e3454efe139461$var$P(o)), $52e3454efe139461$var$r.length > l && $52e3454efe139461$var$r.sort(function(n, l) {
            return n.__v.__b - l.__v.__b;
        }));
        $52e3454efe139461$var$$.__r = 0;
    }
    function $52e3454efe139461$var$H(n, l, u, i, t, r, o, f, e, a) {
        var h, v, y, d, k, b, g, m = i && i.__k || $52e3454efe139461$var$s, w = m.length;
        for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $52e3454efe139461$var$p(null, d, null, null, d) : Array.isArray(d) ? $52e3454efe139461$var$p($52e3454efe139461$export$ffb0004e005737fa, {
            children: d
        }, null, null, null) : d.__b > 0 ? $52e3454efe139461$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
            if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
            else for(v = 0; v < w; v++){
                if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                    m[v] = void 0;
                    break;
                }
                y = null;
            }
            $52e3454efe139461$var$M(n, d, y = y || $52e3454efe139461$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $52e3454efe139461$var$I(d, e, n) : e = $52e3454efe139461$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $52e3454efe139461$var$A(y));
        }
        for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $52e3454efe139461$var$L(i).nextSibling), $52e3454efe139461$var$q(m[h], m[h]));
        if (g) for(h = 0; h < g.length; h++)$52e3454efe139461$var$S(g[h], g[++h], g[++h]);
    }
    function $52e3454efe139461$var$I(n, l, u) {
        for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $52e3454efe139461$var$I(i, l, u) : $52e3454efe139461$var$z(u, i, i, t, i.__e, l));
        return l;
    }
    function $52e3454efe139461$export$47e4c5b300681277(n, l) {
        return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
            $52e3454efe139461$export$47e4c5b300681277(n, l);
        }) : l.push(n)), l;
    }
    function $52e3454efe139461$var$z(n, l, u, i, t, r) {
        var o, f, e;
        if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
        else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
        else {
            for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
            n.insertBefore(t, r), o = r;
        }
        return void 0 !== o ? o : t.nextSibling;
    }
    function $52e3454efe139461$var$L(n) {
        var l, u, i;
        if (null == n.type || "string" == typeof n.type) return n.__e;
        if (n.__k) {
            for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $52e3454efe139461$var$L(u))) return i;
        }
        return null;
    }
    function $52e3454efe139461$var$M(n, u, i, t, r, o, f, e, c) {
        var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
        if (void 0 !== u.constructor) return null;
        null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
            e
        ]), (s = $52e3454efe139461$export$41c562ebe57d11e2.__b) && s(u);
        try {
            n: if ("function" == typeof $) {
                if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $52e3454efe139461$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $52e3454efe139461$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $52e3454efe139461$var$h({}, a.__s)), $52e3454efe139461$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
                else {
                    if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                        for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                            n && (n.__ = u);
                        }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                        a._sb = [], a.__h.length && f.push(a);
                        break n;
                    }
                    null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                        a.componentDidUpdate(y, p, d);
                    });
                }
                if (a.context = m, a.props = b, a.__P = n, A = $52e3454efe139461$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                    for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                    a._sb = [];
                } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
                while (a.__d && ++P < 25)
                a.state = a.__s, null != a.getChildContext && (t = $52e3454efe139461$var$h($52e3454efe139461$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $52e3454efe139461$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $52e3454efe139461$var$H(n, Array.isArray(T) ? T : [
                    T
                ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
            } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $52e3454efe139461$var$O(i.__e, u, i, t, r, o, f, c);
            (s = $52e3454efe139461$export$41c562ebe57d11e2.diffed) && s(u);
        } catch (n) {
            u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $52e3454efe139461$export$41c562ebe57d11e2.__e(n, u, i);
        }
    }
    function $52e3454efe139461$var$N(n, u) {
        $52e3454efe139461$export$41c562ebe57d11e2.__c && $52e3454efe139461$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
            try {
                n = u.__h, u.__h = [], n.some(function(n) {
                    n.call(u);
                });
            } catch (n) {
                $52e3454efe139461$export$41c562ebe57d11e2.__e(n, u.__v);
            }
        });
    }
    function $52e3454efe139461$var$O(l, u, i, t, r, o, f, e) {
        var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
        if ("svg" === d && (r = !0), null != o) {
            for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
                l = s, o[_] = null;
                break;
            }
        }
        if (null == l) {
            if (null === d) return document.createTextNode(p);
            l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
        }
        if (null === d) y === p || e && l.data === p || (l.data = p);
        else {
            if (o = o && $52e3454efe139461$var$n.call(l.childNodes), a = (y = i.props || $52e3454efe139461$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
                if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
                (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
            }
            if ($52e3454efe139461$var$k(l, p, y, r, e), h) u.__k = [];
            else if (_ = u.props.children, $52e3454efe139461$var$H(l, Array.isArray(_) ? _ : [
                _
            ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $52e3454efe139461$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $52e3454efe139461$var$v(o[_]);
            e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $52e3454efe139461$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $52e3454efe139461$var$g(l, "checked", _, y.checked, !1));
        }
        return l;
    }
    function $52e3454efe139461$var$S(n, u, i) {
        try {
            "function" == typeof n ? n(u) : n.current = u;
        } catch (n) {
            $52e3454efe139461$export$41c562ebe57d11e2.__e(n, i);
        }
    }
    function $52e3454efe139461$var$q(n, u, i) {
        var t, r;
        if ($52e3454efe139461$export$41c562ebe57d11e2.unmount && $52e3454efe139461$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $52e3454efe139461$var$S(t, null, u)), null != (t = n.__c)) {
            if (t.componentWillUnmount) try {
                t.componentWillUnmount();
            } catch (n) {
                $52e3454efe139461$export$41c562ebe57d11e2.__e(n, u);
            }
            t.base = t.__P = null, n.__c = void 0;
        }
        if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $52e3454efe139461$var$q(t[r], u, i || "function" != typeof n.type);
        i || null == n.__e || $52e3454efe139461$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
    }
    function $52e3454efe139461$var$B(n, l, u) {
        return this.constructor(n, u);
    }
    function $52e3454efe139461$export$b3890eb0ae9dca99(u, i, t) {
        var r, o, f;
        $52e3454efe139461$export$41c562ebe57d11e2.__ && $52e3454efe139461$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $52e3454efe139461$var$M(i, u = (!r && t || i).__k = $52e3454efe139461$export$c8a8987d4410bf2d($52e3454efe139461$export$ffb0004e005737fa, null, [
            u
        ]), o || $52e3454efe139461$var$c, $52e3454efe139461$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
            t
        ] : o ? null : i.firstChild ? $52e3454efe139461$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $52e3454efe139461$var$N(f, u);
    }
    function $52e3454efe139461$export$fa8d919ba61d84db(n, l) {
        $52e3454efe139461$export$b3890eb0ae9dca99(n, l, $52e3454efe139461$export$fa8d919ba61d84db);
    }
    function $52e3454efe139461$export$e530037191fcd5d7(l, u, i) {
        var t, r, o, f = $52e3454efe139461$var$h({}, l.props);
        for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
        return arguments.length > 2 && (f.children = arguments.length > 3 ? $52e3454efe139461$var$n.call(arguments, 2) : i), $52e3454efe139461$var$p(l.type, f, t || l.key, r || l.ref, null);
    }
    function $52e3454efe139461$export$fd42f52fd3ae1109(n, l) {
        var u = {
            __c: l = "__cC" + $52e3454efe139461$var$e++,
            __: n,
            Consumer: function(n, l) {
                return n.children(l);
            },
            Provider: function(n) {
                var u, i;
                return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                    return i;
                }, this.shouldComponentUpdate = function(n) {
                    this.props.value !== n.value && u.some(function(n) {
                        n.__e = !0, $52e3454efe139461$var$T(n);
                    });
                }, this.sub = function(n) {
                    u.push(n);
                    var l = n.componentWillUnmount;
                    n.componentWillUnmount = function() {
                        u.splice(u.indexOf(n), 1), l && l.call(n);
                    };
                }), n.children;
            }
        };
        return u.Provider.__ = u.Consumer.contextType = u;
    }
    $52e3454efe139461$var$n = $52e3454efe139461$var$s.slice, $52e3454efe139461$export$41c562ebe57d11e2 = {
        __e: function(n, l, u, i) {
            for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
                if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
            } catch (l) {
                n = l;
            }
            throw n;
        }
    }, $52e3454efe139461$var$u = 0, $52e3454efe139461$export$a8257692ac88316c = function(n) {
        return null != n && void 0 === n.constructor;
    }, $52e3454efe139461$var$t = !1, $52e3454efe139461$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
        var u;
        u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $52e3454efe139461$var$h({}, this.state), "function" == typeof n && (n = n($52e3454efe139461$var$h({}, u), this.props)), n && $52e3454efe139461$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $52e3454efe139461$var$T(this));
    }, $52e3454efe139461$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
        this.__v && (this.__e = !0, n && this.__h.push(n), $52e3454efe139461$var$T(this));
    }, $52e3454efe139461$export$16fa2f45be04daa8.prototype.render = $52e3454efe139461$export$ffb0004e005737fa, $52e3454efe139461$var$r = [], $52e3454efe139461$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $52e3454efe139461$var$$.__r = 0, $52e3454efe139461$var$e = 0;
});
parcelRegister("j8P0R", function(module, exports) {
    $parcel$export(module.exports, "createPortal", ()=>$def655c2cf511095$export$d39a5bbd09211389);
    var $77d02 = parcelRequire("77d02");
    var $73iWa = parcelRequire("73iWa");
    function $def655c2cf511095$var$g(n, t) {
        for(var e in t)n[e] = t[e];
        return n;
    }
    function $def655c2cf511095$var$C(n, t) {
        for(var e in n)if ("__source" !== e && !(e in t)) return !0;
        for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
        return !1;
    }
    function $def655c2cf511095$var$E(n, t) {
        return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
    }
    function $def655c2cf511095$export$221d75b3f55bb0bd(n) {
        this.props = n;
    }
    function $def655c2cf511095$export$7c73462e0d25e514(n, e) {
        function r(n) {
            var t = this.props.ref, r = t == n.ref;
            return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $def655c2cf511095$var$C(this.props, n);
        }
        function u(e) {
            return this.shouldComponentUpdate = r, (0, $77d02.createElement)(n, e);
        }
        return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
    }
    ($def655c2cf511095$export$221d75b3f55bb0bd.prototype = new (0, $77d02.Component)).isPureReactComponent = !0, $def655c2cf511095$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
        return $def655c2cf511095$var$C(this.props, n) || $def655c2cf511095$var$C(this.state, t);
    };
    var $def655c2cf511095$var$x = (0, $77d02.options).__b;
    (0, $77d02.options).__b = function(n) {
        n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $def655c2cf511095$var$x && $def655c2cf511095$var$x(n);
    };
    var $def655c2cf511095$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
    function $def655c2cf511095$export$257a8862b851cb5b(n) {
        function t(t) {
            var e = $def655c2cf511095$var$g({}, t);
            return delete e.ref, n(e, t.ref || null);
        }
        return t.$$typeof = $def655c2cf511095$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
    }
    var $def655c2cf511095$var$A = function(n, t) {
        return null == n ? null : (0, $77d02.toChildArray)((0, $77d02.toChildArray)(n).map(t));
    }, $def655c2cf511095$export$dca3b0875bd9a954 = {
        map: $def655c2cf511095$var$A,
        forEach: $def655c2cf511095$var$A,
        count: function(n) {
            return n ? (0, $77d02.toChildArray)(n).length : 0;
        },
        only: function(n) {
            var t = (0, $77d02.toChildArray)(n);
            if (1 !== t.length) throw "Children.only";
            return t[0];
        },
        toArray: (0, $77d02.toChildArray)
    }, $def655c2cf511095$var$T = (0, $77d02.options).__e;
    (0, $77d02.options).__e = function(n, t, e, r) {
        if (n.then) {
            for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
        }
        $def655c2cf511095$var$T(n, t, e, r);
    };
    var $def655c2cf511095$var$I = (0, $77d02.options).unmount;
    function $def655c2cf511095$var$L(n, t, e) {
        return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
            "function" == typeof n.__c && n.__c();
        }), n.__c.__H = null), null != (n = $def655c2cf511095$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
            return $def655c2cf511095$var$L(n, t, e);
        })), n;
    }
    function $def655c2cf511095$var$U(n, t, e) {
        return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
            return $def655c2cf511095$var$U(n, t, e);
        }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
    }
    function $def655c2cf511095$export$74bf444e3cd11ea5() {
        this.__u = 0, this.t = null, this.__b = null;
    }
    function $def655c2cf511095$var$F(n) {
        var t = n.__.__c;
        return t && t.__a && t.__a(n);
    }
    function $def655c2cf511095$export$488013bae63b21da(n) {
        var e, r, u;
        function o(o) {
            if (e || (e = n()).then(function(n) {
                r = n.default || n;
            }, function(n) {
                u = n;
            }), u) throw u;
            if (!r) throw e;
            return (0, $77d02.createElement)(r, o);
        }
        return o.displayName = "Lazy", o.__f = !0, o;
    }
    function $def655c2cf511095$export$998bcd577473dd93() {
        this.u = null, this.o = null;
    }
    (0, $77d02.options).unmount = function(n) {
        var t = n.__c;
        t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $def655c2cf511095$var$I && $def655c2cf511095$var$I(n);
    }, ($def655c2cf511095$export$74bf444e3cd11ea5.prototype = new (0, $77d02.Component)).__c = function(n, t) {
        var e = t.__c, r = this;
        null == r.t && (r.t = []), r.t.push(e);
        var u = $def655c2cf511095$var$F(r.__v), o = !1, i = function() {
            o || (o = !0, e.__R = null, u ? u(l) : l());
        };
        e.__R = i;
        var l = function() {
            if (!--r.__u) {
                if (r.state.__a) {
                    var n = r.state.__a;
                    r.__v.__k[0] = $def655c2cf511095$var$U(n, n.__c.__P, n.__c.__O);
                }
                var t;
                for(r.setState({
                    __a: r.__b = null
                }); t = r.t.pop();)t.forceUpdate();
            }
        }, c = !0 === t.__h;
        r.__u++ || c || r.setState({
            __a: r.__b = r.__v.__k[0]
        }), n.then(i, i);
    }, $def655c2cf511095$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
        this.t = [];
    }, $def655c2cf511095$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
        if (this.__b) {
            if (this.__v.__k) {
                var r = document.createElement("div"), o = this.__v.__k[0].__c;
                this.__v.__k[0] = $def655c2cf511095$var$L(this.__b, r, o.__O = o.__P);
            }
            this.__b = null;
        }
        var i = e.__a && (0, $77d02.createElement)((0, $77d02.Fragment), null, n.fallback);
        return i && (i.__h = null), [
            (0, $77d02.createElement)((0, $77d02.Fragment), null, e.__a ? null : n.children),
            i
        ];
    };
    var $def655c2cf511095$var$W = function(n, t, e) {
        if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
            for(; e.length > 3;)e.pop()();
            if (e[1] < e[0]) break;
            n.u = e = e[2];
        }
    };
    function $def655c2cf511095$var$P(n) {
        return this.getChildContext = function() {
            return n.context;
        }, n.children;
    }
    function $def655c2cf511095$var$$(n) {
        var e = this, r = n.i;
        e.componentWillUnmount = function() {
            (0, $77d02.render)(null, e.l), e.l = null, e.i = null;
        }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            appendChild: function(n) {
                this.childNodes.push(n), e.i.appendChild(n);
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.i.appendChild(n);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
            }
        }), (0, $77d02.render)((0, $77d02.createElement)($def655c2cf511095$var$P, {
            context: e.context
        }, n.__v), e.l)) : e.l && e.componentWillUnmount();
    }
    function $def655c2cf511095$export$d39a5bbd09211389(n, e) {
        var r = (0, $77d02.createElement)($def655c2cf511095$var$$, {
            __v: n,
            i: e
        });
        return r.containerInfo = e, r;
    }
    ($def655c2cf511095$export$998bcd577473dd93.prototype = new (0, $77d02.Component)).__a = function(n) {
        var t = this, e = $def655c2cf511095$var$F(t.__v), r = t.o.get(n);
        return r[0]++, function(u) {
            var o = function() {
                t.props.revealOrder ? (r.push(u), $def655c2cf511095$var$W(t, n, r)) : u();
            };
            e ? e(o) : o();
        };
    }, $def655c2cf511095$export$998bcd577473dd93.prototype.render = function(n) {
        this.u = null, this.o = new Map;
        var t = (0, $77d02.toChildArray)(n.children);
        n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
        for(var e = t.length; e--;)this.o.set(t[e], this.u = [
            1,
            0,
            this.u
        ]);
        return n.children;
    }, $def655c2cf511095$export$998bcd577473dd93.prototype.componentDidUpdate = $def655c2cf511095$export$998bcd577473dd93.prototype.componentDidMount = function() {
        var n = this;
        this.o.forEach(function(t, e) {
            $def655c2cf511095$var$W(n, e, t);
        });
    };
    var $def655c2cf511095$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $def655c2cf511095$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $def655c2cf511095$var$H = "undefined" != typeof document, $def655c2cf511095$var$Z = function(n) {
        return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
    };
    function $def655c2cf511095$export$b3890eb0ae9dca99(n, t, e) {
        return null == t.__k && (t.textContent = ""), (0, $77d02.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
    }
    function $def655c2cf511095$export$fa8d919ba61d84db(n, t, e) {
        return (0, $77d02.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
    }
    (0, $77d02.Component).prototype.isReactComponent = {}, [
        "componentWillMount",
        "componentWillReceiveProps",
        "componentWillUpdate"
    ].forEach(function(t) {
        Object.defineProperty((0, $77d02.Component).prototype, t, {
            configurable: !0,
            get: function() {
                return this["UNSAFE_" + t];
            },
            set: function(n) {
                Object.defineProperty(this, t, {
                    configurable: !0,
                    writable: !0,
                    value: n
                });
            }
        });
    });
    var $def655c2cf511095$var$G = (0, $77d02.options).event;
    function $def655c2cf511095$var$J() {}
    function $def655c2cf511095$var$K() {
        return this.cancelBubble;
    }
    function $def655c2cf511095$var$Q() {
        return this.defaultPrevented;
    }
    (0, $77d02.options).event = function(n) {
        return $def655c2cf511095$var$G && (n = $def655c2cf511095$var$G(n)), n.persist = $def655c2cf511095$var$J, n.isPropagationStopped = $def655c2cf511095$var$K, n.isDefaultPrevented = $def655c2cf511095$var$Q, n.nativeEvent = n;
    };
    var $def655c2cf511095$var$X, $def655c2cf511095$var$nn = {
        configurable: !0,
        get: function() {
            return this.class;
        }
    }, $def655c2cf511095$var$tn = (0, $77d02.options).vnode;
    (0, $77d02.options).vnode = function(n) {
        var t = n.type, e = n.props, u = e;
        if ("string" == typeof t) {
            var o = -1 === t.indexOf("-");
            for(var i in u = {}, e){
                var l = e[i];
                $def655c2cf511095$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$def655c2cf511095$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $def655c2cf511095$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
            }
            "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $77d02.toChildArray)(e.children).forEach(function(n) {
                n.props.selected = -1 != u.value.indexOf(n.props.value);
            })), "select" == t && null != u.defaultValue && (u.value = (0, $77d02.toChildArray)(e.children).forEach(function(n) {
                n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
            })), n.props = u, e.class != e.className && ($def655c2cf511095$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $def655c2cf511095$var$nn));
        }
        n.$$typeof = $def655c2cf511095$var$z, $def655c2cf511095$var$tn && $def655c2cf511095$var$tn(n);
    };
    var $def655c2cf511095$var$en = (0, $77d02.options).__r;
    (0, $77d02.options).__r = function(n) {
        $def655c2cf511095$var$en && $def655c2cf511095$var$en(n), $def655c2cf511095$var$X = n.__c;
    };
    var $def655c2cf511095$export$ae55be85d98224ed = {
        ReactCurrentDispatcher: {
            current: {
                readContext: function(n) {
                    return $def655c2cf511095$var$X.__n[n.__c].props.value;
                }
            }
        }
    }, $def655c2cf511095$export$83d89fbfd8236492 = "17.0.2";
    function $def655c2cf511095$export$d38cd72104c1f0e9(n) {
        return (0, $77d02.createElement).bind(null, n);
    }
    function $def655c2cf511095$export$a8257692ac88316c(n) {
        return !!n && n.$$typeof === $def655c2cf511095$var$z;
    }
    function $def655c2cf511095$export$e530037191fcd5d7(n) {
        return $def655c2cf511095$export$a8257692ac88316c(n) ? (0, $77d02.cloneElement).apply(null, arguments) : n;
    }
    function $def655c2cf511095$export$502457920280e6be(n) {
        return !!n.__k && ((0, $77d02.render)(null, n), !0);
    }
    function $def655c2cf511095$export$466bfc07425424d5(n) {
        return n && (n.base || 1 === n.nodeType && n) || null;
    }
    var $def655c2cf511095$export$c78a37762a8d58e1 = function(n, t) {
        return n(t);
    }, $def655c2cf511095$export$cd75ccfd720a3cd4 = function(n, t) {
        return n(t);
    }, $def655c2cf511095$export$5f8d39834fd61797 = (0, $77d02.Fragment);
    function $def655c2cf511095$export$7568632d0d33d16d(n) {
        n();
    }
    function $def655c2cf511095$export$6a7bc4e911dc01cf(n) {
        return n;
    }
    function $def655c2cf511095$export$7b286972b8d8ccbf() {
        return [
            !1,
            $def655c2cf511095$export$7568632d0d33d16d
        ];
    }
    var $def655c2cf511095$export$aaabe4eda9ed9969 = (0, $73iWa.useLayoutEffect);
    function $def655c2cf511095$export$306c0aa65ff9ec16(n, t) {
        var e = t(), r = (0, $73iWa.useState)({
            h: {
                __: e,
                v: t
            }
        }), u = r[0].h, o = r[1];
        return (0, $73iWa.useLayoutEffect)(function() {
            u.__ = e, u.v = t, $def655c2cf511095$var$E(u.__, t()) || o({
                h: u
            });
        }, [
            n,
            e,
            t
        ]), (0, $73iWa.useEffect)(function() {
            return $def655c2cf511095$var$E(u.__, u.v()) || o({
                h: u
            }), n(function() {
                $def655c2cf511095$var$E(u.__, u.v()) || o({
                    h: u
                });
            });
        }, [
            n
        ]), e;
    }
    var $def655c2cf511095$export$2e2bcd8739ae039 = {
        useState: (0, $73iWa.useState),
        useId: (0, $73iWa.useId),
        useReducer: (0, $73iWa.useReducer),
        useEffect: (0, $73iWa.useEffect),
        useLayoutEffect: (0, $73iWa.useLayoutEffect),
        useInsertionEffect: $def655c2cf511095$export$aaabe4eda9ed9969,
        useTransition: $def655c2cf511095$export$7b286972b8d8ccbf,
        useDeferredValue: $def655c2cf511095$export$6a7bc4e911dc01cf,
        useSyncExternalStore: $def655c2cf511095$export$306c0aa65ff9ec16,
        startTransition: $def655c2cf511095$export$7568632d0d33d16d,
        useRef: (0, $73iWa.useRef),
        useImperativeHandle: (0, $73iWa.useImperativeHandle),
        useMemo: (0, $73iWa.useMemo),
        useCallback: (0, $73iWa.useCallback),
        useContext: (0, $73iWa.useContext),
        useDebugValue: (0, $73iWa.useDebugValue),
        version: "17.0.2",
        Children: $def655c2cf511095$export$dca3b0875bd9a954,
        render: $def655c2cf511095$export$b3890eb0ae9dca99,
        hydrate: $def655c2cf511095$export$fa8d919ba61d84db,
        unmountComponentAtNode: $def655c2cf511095$export$502457920280e6be,
        createPortal: $def655c2cf511095$export$d39a5bbd09211389,
        createElement: (0, $77d02.createElement),
        createContext: (0, $77d02.createContext),
        createFactory: $def655c2cf511095$export$d38cd72104c1f0e9,
        cloneElement: $def655c2cf511095$export$e530037191fcd5d7,
        createRef: (0, $77d02.createRef),
        Fragment: (0, $77d02.Fragment),
        isValidElement: $def655c2cf511095$export$a8257692ac88316c,
        findDOMNode: $def655c2cf511095$export$466bfc07425424d5,
        Component: (0, $77d02.Component),
        PureComponent: $def655c2cf511095$export$221d75b3f55bb0bd,
        memo: $def655c2cf511095$export$7c73462e0d25e514,
        forwardRef: $def655c2cf511095$export$257a8862b851cb5b,
        flushSync: $def655c2cf511095$export$cd75ccfd720a3cd4,
        unstable_batchedUpdates: $def655c2cf511095$export$c78a37762a8d58e1,
        StrictMode: $def655c2cf511095$export$5f8d39834fd61797,
        Suspense: $def655c2cf511095$export$74bf444e3cd11ea5,
        SuspenseList: $def655c2cf511095$export$998bcd577473dd93,
        lazy: $def655c2cf511095$export$488013bae63b21da,
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $def655c2cf511095$export$ae55be85d98224ed
    };
});
parcelRegister("73iWa", function(module, exports) {
    $parcel$export(module.exports, "useState", ()=>$522780b89954ae09$export$60241385465d0a34);
    $parcel$export(module.exports, "useReducer", ()=>$522780b89954ae09$export$13e3392192263954);
    $parcel$export(module.exports, "useEffect", ()=>$522780b89954ae09$export$6d9c69b0de29b591);
    $parcel$export(module.exports, "useLayoutEffect", ()=>$522780b89954ae09$export$e5c5a5f917a5871c);
    $parcel$export(module.exports, "useRef", ()=>$522780b89954ae09$export$b8f5890fc79d6aca);
    $parcel$export(module.exports, "useMemo", ()=>$522780b89954ae09$export$1538c33de8887b59);
    $parcel$export(module.exports, "useImperativeHandle", ()=>$522780b89954ae09$export$d5a552a76deda3c2);
    $parcel$export(module.exports, "useCallback", ()=>$522780b89954ae09$export$35808ee640e87ca7);
    $parcel$export(module.exports, "useContext", ()=>$522780b89954ae09$export$fae74005e78b1a27);
    $parcel$export(module.exports, "useDebugValue", ()=>$522780b89954ae09$export$dc8fbce3eb94dc1e);
    $parcel$export(module.exports, "useId", ()=>$522780b89954ae09$export$f680877a34711e37);
    var $77d02 = parcelRequire("77d02");
    var $522780b89954ae09$var$t, $522780b89954ae09$var$r, $522780b89954ae09$var$u, $522780b89954ae09$var$i, $522780b89954ae09$var$o = 0, $522780b89954ae09$var$f = [], $522780b89954ae09$var$c = [], $522780b89954ae09$var$e = (0, $77d02.options).__b, $522780b89954ae09$var$a = (0, $77d02.options).__r, $522780b89954ae09$var$v = (0, $77d02.options).diffed, $522780b89954ae09$var$l = (0, $77d02.options).__c, $522780b89954ae09$var$m = (0, $77d02.options).unmount;
    function $522780b89954ae09$var$d(t, u) {
        (0, $77d02.options).__h && (0, $77d02.options).__h($522780b89954ae09$var$r, t, $522780b89954ae09$var$o || u), $522780b89954ae09$var$o = 0;
        var i = $522780b89954ae09$var$r.__H || ($522780b89954ae09$var$r.__H = {
            __: [],
            __h: []
        });
        return t >= i.__.length && i.__.push({
            __V: $522780b89954ae09$var$c
        }), i.__[t];
    }
    function $522780b89954ae09$export$60241385465d0a34(n) {
        return $522780b89954ae09$var$o = 1, $522780b89954ae09$export$13e3392192263954($522780b89954ae09$var$B, n);
    }
    function $522780b89954ae09$export$13e3392192263954(n, u, i) {
        var o = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 2);
        if (o.t = n, !o.__c && (o.__ = [
            i ? i(u) : $522780b89954ae09$var$B(void 0, u),
            function(n) {
                var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
                t !== r && (o.__N = [
                    r,
                    o.__[1]
                ], o.__c.setState({}));
            }
        ], o.__c = $522780b89954ae09$var$r, !$522780b89954ae09$var$r.u)) {
            $522780b89954ae09$var$r.u = !0;
            var f = $522780b89954ae09$var$r.shouldComponentUpdate;
            $522780b89954ae09$var$r.shouldComponentUpdate = function(n, t, r) {
                if (!o.__c.__H) return !0;
                var u = o.__c.__H.__.filter(function(n) {
                    return n.__c;
                });
                if (u.every(function(n) {
                    return !n.__N;
                })) return !f || f.call(this, n, t, r);
                var i = !1;
                return u.forEach(function(n) {
                    if (n.__N) {
                        var t = n.__[0];
                        n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                    }
                }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
            };
        }
        return o.__N || o.__;
    }
    function $522780b89954ae09$export$6d9c69b0de29b591(u, i) {
        var o = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 3);
        !(0, $77d02.options).__s && $522780b89954ae09$var$z(o.__H, i) && (o.__ = u, o.i = i, $522780b89954ae09$var$r.__H.__h.push(o));
    }
    function $522780b89954ae09$export$e5c5a5f917a5871c(u, i) {
        var o = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 4);
        !(0, $77d02.options).__s && $522780b89954ae09$var$z(o.__H, i) && (o.__ = u, o.i = i, $522780b89954ae09$var$r.__h.push(o));
    }
    function $522780b89954ae09$export$b8f5890fc79d6aca(n) {
        return $522780b89954ae09$var$o = 5, $522780b89954ae09$export$1538c33de8887b59(function() {
            return {
                current: n
            };
        }, []);
    }
    function $522780b89954ae09$export$d5a552a76deda3c2(n, t, r) {
        $522780b89954ae09$var$o = 6, $522780b89954ae09$export$e5c5a5f917a5871c(function() {
            return "function" == typeof n ? (n(t()), function() {
                return n(null);
            }) : n ? (n.current = t(), function() {
                return n.current = null;
            }) : void 0;
        }, null == r ? r : r.concat(n));
    }
    function $522780b89954ae09$export$1538c33de8887b59(n, r) {
        var u = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 7);
        return $522780b89954ae09$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
    }
    function $522780b89954ae09$export$35808ee640e87ca7(n, t) {
        return $522780b89954ae09$var$o = 8, $522780b89954ae09$export$1538c33de8887b59(function() {
            return n;
        }, t);
    }
    function $522780b89954ae09$export$fae74005e78b1a27(n) {
        var u = $522780b89954ae09$var$r.context[n.__c], i = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 9);
        return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($522780b89954ae09$var$r)), u.props.value) : n.__;
    }
    function $522780b89954ae09$export$dc8fbce3eb94dc1e(t, r) {
        (0, $77d02.options).useDebugValue && (0, $77d02.options).useDebugValue(r ? r(t) : t);
    }
    function $522780b89954ae09$export$c052f6604b7d51fe(n) {
        var u = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 10), i = $522780b89954ae09$export$60241385465d0a34();
        return u.__ = n, $522780b89954ae09$var$r.componentDidCatch || ($522780b89954ae09$var$r.componentDidCatch = function(n, t) {
            u.__ && u.__(n, t), i[1](n);
        }), [
            i[0],
            function() {
                i[1](void 0);
            }
        ];
    }
    function $522780b89954ae09$export$f680877a34711e37() {
        var n = $522780b89954ae09$var$d($522780b89954ae09$var$t++, 11);
        if (!n.__) {
            for(var u = $522780b89954ae09$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
            var i = u.__m || (u.__m = [
                0,
                0
            ]);
            n.__ = "P" + i[0] + "-" + i[1]++;
        }
        return n.__;
    }
    function $522780b89954ae09$var$b() {
        for(var t; t = $522780b89954ae09$var$f.shift();)if (t.__P && t.__H) try {
            t.__H.__h.forEach($522780b89954ae09$var$k), t.__H.__h.forEach($522780b89954ae09$var$w), t.__H.__h = [];
        } catch (r) {
            t.__H.__h = [], (0, $77d02.options).__e(r, t.__v);
        }
    }
    (0, $77d02.options).__b = function(n) {
        $522780b89954ae09$var$r = null, $522780b89954ae09$var$e && $522780b89954ae09$var$e(n);
    }, (0, $77d02.options).__r = function(n) {
        $522780b89954ae09$var$a && $522780b89954ae09$var$a(n), $522780b89954ae09$var$t = 0;
        var i = ($522780b89954ae09$var$r = n.__c).__H;
        i && ($522780b89954ae09$var$u === $522780b89954ae09$var$r ? (i.__h = [], $522780b89954ae09$var$r.__h = [], i.__.forEach(function(n) {
            n.__N && (n.__ = n.__N), n.__V = $522780b89954ae09$var$c, n.__N = n.i = void 0;
        })) : (i.__h.forEach($522780b89954ae09$var$k), i.__h.forEach($522780b89954ae09$var$w), i.__h = [])), $522780b89954ae09$var$u = $522780b89954ae09$var$r;
    }, (0, $77d02.options).diffed = function(t) {
        $522780b89954ae09$var$v && $522780b89954ae09$var$v(t);
        var o = t.__c;
        o && o.__H && (o.__H.__h.length && (1 !== $522780b89954ae09$var$f.push(o) && $522780b89954ae09$var$i === (0, $77d02.options).requestAnimationFrame || (($522780b89954ae09$var$i = (0, $77d02.options).requestAnimationFrame) || $522780b89954ae09$var$j)($522780b89954ae09$var$b)), o.__H.__.forEach(function(n) {
            n.i && (n.__H = n.i), n.__V !== $522780b89954ae09$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $522780b89954ae09$var$c;
        })), $522780b89954ae09$var$u = $522780b89954ae09$var$r = null;
    }, (0, $77d02.options).__c = function(t, r) {
        r.some(function(t) {
            try {
                t.__h.forEach($522780b89954ae09$var$k), t.__h = t.__h.filter(function(n) {
                    return !n.__ || $522780b89954ae09$var$w(n);
                });
            } catch (u) {
                r.some(function(n) {
                    n.__h && (n.__h = []);
                }), r = [], (0, $77d02.options).__e(u, t.__v);
            }
        }), $522780b89954ae09$var$l && $522780b89954ae09$var$l(t, r);
    }, (0, $77d02.options).unmount = function(t) {
        $522780b89954ae09$var$m && $522780b89954ae09$var$m(t);
        var r, u = t.__c;
        u && u.__H && (u.__H.__.forEach(function(n) {
            try {
                $522780b89954ae09$var$k(n);
            } catch (n) {
                r = n;
            }
        }), u.__H = void 0, r && (0, $77d02.options).__e(r, u.__v));
    };
    var $522780b89954ae09$var$g = "function" == typeof requestAnimationFrame;
    function $522780b89954ae09$var$j(n) {
        var t, r = function() {
            clearTimeout(u), $522780b89954ae09$var$g && cancelAnimationFrame(t), setTimeout(n);
        }, u = setTimeout(r, 100);
        $522780b89954ae09$var$g && (t = requestAnimationFrame(r));
    }
    function $522780b89954ae09$var$k(n) {
        var t = $522780b89954ae09$var$r, u = n.__c;
        "function" == typeof u && (n.__c = void 0, u()), $522780b89954ae09$var$r = t;
    }
    function $522780b89954ae09$var$w(n) {
        var t = $522780b89954ae09$var$r;
        n.__c = n.__(), $522780b89954ae09$var$r = t;
    }
    function $522780b89954ae09$var$z(n, t) {
        return !n || n.length !== t.length || t.some(function(t, r) {
            return t !== n[r];
        });
    }
    function $522780b89954ae09$var$B(n, t) {
        return "function" == typeof t ? t(n) : t;
    }
});
parcelRegister("9uFES", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e973ad854e2ef21$export$2e2bcd8739ae039);
    var $5nZSg;
    var $cy76D;
    var $6e973ad854e2ef21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5nZSg")).createPlugin)({
        name: '@fullcalendar/daygrid',
        initialView: 'dayGridMonth',
        views: {
            dayGrid: {
                component: (0, (0, parcelRequire("cy76D")).DayGridView),
                dateProfileGeneratorClass: (0, (0, parcelRequire("cy76D")).TableDateProfileGenerator)
            },
            dayGridDay: {
                type: 'dayGrid',
                duration: {
                    days: 1
                }
            },
            dayGridWeek: {
                type: 'dayGrid',
                duration: {
                    weeks: 1
                }
            },
            dayGridMonth: {
                type: 'dayGrid',
                duration: {
                    months: 1
                },
                fixedWeekCount: true
            },
            dayGridYear: {
                type: 'dayGrid',
                duration: {
                    years: 1
                }
            }
        }
    });
});
parcelRegister("cy76D", function(module, exports) {
    $parcel$export(module.exports, "DayGridView", ()=>$025b955b6a80424b$export$39eed66de95896e5);
    $parcel$export(module.exports, "TableDateProfileGenerator", ()=>$025b955b6a80424b$export$9fcce6e2d16ec31d);
    var $Jd88K;
    var $77d02 = parcelRequire("77d02");
    class $025b955b6a80424b$export$b3c27e869d856b7 extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.headerElRef = (0, $77d02.createRef)();
        }
        renderSimpleLayout(headerRowContent, bodyContent) {
            let { props: props, context: context } = this;
            let sections = [];
            let stickyHeaderDates = (0, (0, parcelRequire("Jd88K")).cc)(context.options);
            if (headerRowContent) sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunk: {
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            });
            sections.push({
                type: 'body',
                key: 'body',
                liquid: true,
                chunk: {
                    content: bodyContent
                }
            });
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).ct), {
                elClasses: [
                    'fc-daygrid'
                ],
                viewSpec: context.viewSpec
            }, (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).b$), {
                liquid: !props.isHeightAuto && !props.forPrint,
                collapsibleWidth: props.forPrint,
                cols: [],
                sections: sections
            }));
        }
        renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
            let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
            if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
            let { props: props, context: context } = this;
            let stickyHeaderDates = !props.forPrint && (0, (0, parcelRequire("Jd88K")).cc)(context.options);
            let stickyFooterScrollbar = !props.forPrint && (0, (0, parcelRequire("Jd88K")).cb)(context.options);
            let sections = [];
            if (headerRowContent) sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunks: [
                    {
                        key: 'main',
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent
                    }
                ]
            });
            sections.push({
                type: 'body',
                key: 'body',
                liquid: true,
                chunks: [
                    {
                        key: 'main',
                        content: bodyContent
                    }
                ]
            });
            if (stickyFooterScrollbar) sections.push({
                type: 'footer',
                key: 'footer',
                isSticky: true,
                chunks: [
                    {
                        key: 'main',
                        content: (0, (0, parcelRequire("Jd88K")).ca)
                    }
                ]
            });
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).ct), {
                elClasses: [
                    'fc-daygrid'
                ],
                viewSpec: context.viewSpec
            }, (0, $77d02.createElement)(ScrollGrid, {
                liquid: !props.isHeightAuto && !props.forPrint,
                forPrint: props.forPrint,
                collapsibleWidth: props.forPrint,
                colGroups: [
                    {
                        cols: [
                            {
                                span: colCnt,
                                minWidth: dayMinWidth
                            }
                        ]
                    }
                ],
                sections: sections
            }));
        }
    }
    function $025b955b6a80424b$var$splitSegsByRow(segs, rowCnt) {
        let byRow = [];
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
        for (let seg of segs)byRow[seg.row].push(seg);
        return byRow;
    }
    function $025b955b6a80424b$var$splitSegsByFirstCol(segs, colCnt) {
        let byCol = [];
        for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
        for (let seg of segs)byCol[seg.firstCol].push(seg);
        return byCol;
    }
    function $025b955b6a80424b$var$splitInteractionByRow(ui, rowCnt) {
        let byRow = [];
        if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
        else {
            for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
                affectedInstances: ui.affectedInstances,
                isEvent: ui.isEvent,
                segs: []
            };
            for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
        }
        return byRow;
    }
    const $025b955b6a80424b$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, (0, parcelRequire("Jd88K")).w)({
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: true,
        meridiem: 'narrow'
    });
    function $025b955b6a80424b$var$hasListItemDisplay(seg) {
        let { display: display } = seg.eventRange.ui;
        return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && seg.isStart && seg.isEnd;
    }
    class $025b955b6a80424b$var$TableBlockEvent extends (0, (0, parcelRequire("Jd88K")).X) {
        render() {
            let { props: props } = this;
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cj), Object.assign({}, props, {
                elClasses: [
                    'fc-daygrid-event',
                    'fc-daygrid-block-event',
                    'fc-h-event'
                ],
                defaultTimeFormat: $025b955b6a80424b$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
                defaultDisplayEventEnd: props.defaultDisplayEventEnd,
                disableResizing: !props.seg.eventRange.def.allDay
            }));
        }
    }
    class $025b955b6a80424b$var$TableListItemEvent extends (0, (0, parcelRequire("Jd88K")).X) {
        render() {
            let { props: props, context: context } = this;
            let { options: options } = context;
            let { seg: seg } = props;
            let timeFormat = options.eventTimeFormat || $025b955b6a80424b$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
            let timeText = (0, (0, parcelRequire("Jd88K")).bQ)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cn), Object.assign({}, props, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-event',
                    'fc-daygrid-dot-event'
                ],
                elAttrs: (0, (0, parcelRequire("Jd88K")).bU)(props.seg, context),
                defaultGenerator: $025b955b6a80424b$var$renderInnerContent,
                timeText: timeText,
                isResizing: false,
                isDateSelecting: false
            }));
        }
    }
    function $025b955b6a80424b$var$renderInnerContent(renderProps) {
        return (0, $77d02.createElement)((0, $77d02.Fragment), null, (0, $77d02.createElement)("div", {
            className: "fc-daygrid-event-dot",
            style: {
                borderColor: renderProps.borderColor || renderProps.backgroundColor
            }
        }), renderProps.timeText && (0, $77d02.createElement)("div", {
            className: "fc-event-time"
        }, renderProps.timeText), (0, $77d02.createElement)("div", {
            className: "fc-event-title"
        }, renderProps.event.title || (0, $77d02.createElement)((0, $77d02.Fragment), null, "\u00A0")));
    }
    class $025b955b6a80424b$var$TableCellMoreLink extends (0, (0, parcelRequire("Jd88K")).X) {
        constructor(){
            super(...arguments);
            this.compileSegs = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$compileSegs);
        }
        render() {
            let { props: props } = this;
            let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cr), {
                elClasses: [
                    'fc-daygrid-more-link'
                ],
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                allDayDate: props.allDayDate,
                moreCnt: props.moreCnt,
                allSegs: allSegs,
                hiddenSegs: invisibleSegs,
                alignmentElRef: props.alignmentElRef,
                alignGridTop: props.alignGridTop,
                extraDateSpan: props.extraDateSpan,
                popoverContent: ()=>{
                    let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                    return (0, $77d02.createElement)((0, $77d02.Fragment), null, allSegs.map((seg)=>{
                        let instanceId = seg.eventRange.instance.instanceId;
                        return (0, $77d02.createElement)("div", {
                            className: "fc-daygrid-event-harness",
                            key: instanceId,
                            style: {
                                visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                            }
                        }, $025b955b6a80424b$var$hasListItemDisplay(seg) ? (0, $77d02.createElement)($025b955b6a80424b$var$TableListItemEvent, Object.assign({
                            seg: seg,
                            isDragging: false,
                            isSelected: instanceId === props.eventSelection,
                            defaultDisplayEventEnd: false
                        }, (0, (0, parcelRequire("Jd88K")).bS)(seg, props.todayRange))) : (0, $77d02.createElement)($025b955b6a80424b$var$TableBlockEvent, Object.assign({
                            seg: seg,
                            isDragging: false,
                            isResizing: false,
                            isDateSelecting: false,
                            isSelected: instanceId === props.eventSelection,
                            defaultDisplayEventEnd: false
                        }, (0, (0, parcelRequire("Jd88K")).bS)(seg, props.todayRange))));
                    }));
                }
            });
        }
    }
    function $025b955b6a80424b$var$compileSegs(singlePlacements) {
        let allSegs = [];
        let invisibleSegs = [];
        for (let placement of singlePlacements){
            allSegs.push(placement.seg);
            if (!placement.isVisible) invisibleSegs.push(placement.seg);
        }
        return {
            allSegs: allSegs,
            invisibleSegs: invisibleSegs
        };
    }
    const $025b955b6a80424b$var$DEFAULT_WEEK_NUM_FORMAT = (0, (0, parcelRequire("Jd88K")).w)({
        week: 'narrow'
    });
    class $025b955b6a80424b$var$TableCell extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.rootElRef = (0, $77d02.createRef)();
            this.state = {
                dayNumberId: (0, (0, parcelRequire("Jd88K")).a5)()
            };
            this.handleRootEl = (el)=>{
                (0, (0, parcelRequire("Jd88K")).Y)(this.rootElRef, el);
                (0, (0, parcelRequire("Jd88K")).Y)(this.props.elRef, el);
            };
        }
        render() {
            let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
            let { options: options, dateEnv: dateEnv } = context;
            let { date: date, dateProfile: dateProfile } = props;
            const isMonthStart = props.showDayNumber && $025b955b6a80424b$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cl), {
                elTag: "td",
                elRef: this.handleRootEl,
                elClasses: [
                    'fc-daygrid-day',
                    ...props.extraClassNames || []
                ],
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                    'aria-labelledby': state.dayNumberId
                } : {}), {
                    role: 'gridcell'
                }),
                defaultGenerator: $025b955b6a80424b$var$renderTopInner,
                date: date,
                dateProfile: dateProfile,
                todayRange: props.todayRange,
                showDayNumber: props.showDayNumber,
                isMonthStart: isMonthStart,
                extraRenderProps: props.extraRenderProps
            }, (InnerContent, renderProps)=>(0, $77d02.createElement)("div", {
                    ref: props.innerElRef,
                    className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                    style: {
                        minHeight: props.minHeight
                    }
                }, props.showWeekNumber && (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cq), {
                    elTag: "a",
                    elClasses: [
                        'fc-daygrid-week-number'
                    ],
                    elAttrs: (0, (0, parcelRequire("Jd88K")).b0)(context, date, 'week'),
                    date: date,
                    defaultFormat: $025b955b6a80424b$var$DEFAULT_WEEK_NUM_FORMAT
                }), !renderProps.isDisabled && (props.showDayNumber || (0, (0, parcelRequire("Jd88K")).cm)(options) || props.forceDayTop) ? (0, $77d02.createElement)("div", {
                    className: "fc-daygrid-day-top"
                }, (0, $77d02.createElement)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        'fc-daygrid-day-number',
                        isMonthStart && 'fc-daygrid-month-start'
                    ],
                    elAttrs: Object.assign(Object.assign({}, (0, (0, parcelRequire("Jd88K")).b0)(context, date)), {
                        id: state.dayNumberId
                    })
                })) : props.showDayNumber ? (0, $77d02.createElement)("div", {
                    className: "fc-daygrid-day-top",
                    style: {
                        visibility: 'hidden'
                    }
                }, (0, $77d02.createElement)("a", {
                    className: "fc-daygrid-day-number"
                }, "\u00A0")) : undefined, (0, $77d02.createElement)("div", {
                    className: "fc-daygrid-day-events",
                    ref: props.fgContentElRef
                }, props.fgContent, (0, $77d02.createElement)("div", {
                    className: "fc-daygrid-day-bottom",
                    style: {
                        marginTop: props.moreMarginTop
                    }
                }, (0, $77d02.createElement)($025b955b6a80424b$var$TableCellMoreLink, {
                    allDayDate: date,
                    singlePlacements: props.singlePlacements,
                    moreCnt: props.moreCnt,
                    alignmentElRef: rootElRef,
                    alignGridTop: !props.showDayNumber,
                    extraDateSpan: props.extraDateSpan,
                    dateProfile: props.dateProfile,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    todayRange: props.todayRange
                }))), (0, $77d02.createElement)("div", {
                    className: "fc-daygrid-day-bg"
                }, props.bgContent)));
        }
    }
    function $025b955b6a80424b$var$renderTopInner(props) {
        return props.dayNumberText || (0, $77d02.createElement)((0, $77d02.Fragment), null, "\u00A0");
    }
    function $025b955b6a80424b$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
        const { start: currentStart, end: currentEnd } = currentRange;
        const currentEndIncl = (0, (0, parcelRequire("Jd88K")).bg)(currentEnd, -1);
        const currentFirstYear = dateEnv.getYear(currentStart);
        const currentFirstMonth = dateEnv.getMonth(currentStart);
        const currentLastYear = dateEnv.getYear(currentEndIncl);
        const currentLastMonth = dateEnv.getMonth(currentEndIncl);
        return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(date.valueOf() === currentStart.valueOf() || dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
    }
    function $025b955b6a80424b$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, eventInstanceHeights, maxContentHeight, cells) {
        let hierarchy = new $025b955b6a80424b$var$DayGridSegHierarchy();
        hierarchy.allowReslicing = true;
        hierarchy.strictOrder = strictOrder;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            hierarchy.maxCoord = maxContentHeight;
            hierarchy.hiddenConsumes = true;
        } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
        else if (typeof dayMaxEventRows === 'number') {
            hierarchy.maxStackCnt = dayMaxEventRows;
            hierarchy.hiddenConsumes = true;
        }
        let segInputs = [];
        let unknownHeightSegs = [];
        for(let i = 0; i < segs.length; i += 1){
            let seg = segs[i];
            let { instanceId: instanceId } = seg.eventRange.instance;
            let eventHeight = eventInstanceHeights[instanceId];
            if (eventHeight != null) segInputs.push({
                index: i,
                thickness: eventHeight,
                span: {
                    start: seg.firstCol,
                    end: seg.lastCol + 1
                }
            });
            else unknownHeightSegs.push(seg);
        }
        let hiddenEntries = hierarchy.addSegs(segInputs);
        let segRects = hierarchy.toRects();
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $025b955b6a80424b$var$placeRects(segRects, segs, cells);
        let moreCnts = [];
        let moreMarginTops = [];
        for (let seg of unknownHeightSegs){
            multiColPlacements[seg.firstCol].push({
                seg: seg,
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
                seg: $025b955b6a80424b$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
        for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
        for (let hiddenEntry of hiddenEntries){
            let seg = segs[hiddenEntry.index];
            let hiddenSpan = hiddenEntry.span;
            multiColPlacements[hiddenSpan.start].push({
                seg: $025b955b6a80424b$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
                moreCnts[col] += 1;
                singleColPlacements[col].push({
                    seg: $025b955b6a80424b$var$resliceSeg(seg, col, col + 1, cells),
                    isVisible: false,
                    isAbsolute: false,
                    absoluteTop: 0,
                    marginTop: 0
                });
            }
        }
        for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
        return {
            singleColPlacements: singleColPlacements,
            multiColPlacements: multiColPlacements,
            moreCnts: moreCnts,
            moreMarginTops: moreMarginTops
        };
    }
    function $025b955b6a80424b$var$placeRects(allRects, segs, cells) {
        let rectsByEachCol = $025b955b6a80424b$var$groupRectsByEachCol(allRects, cells.length);
        let singleColPlacements = [];
        let multiColPlacements = [];
        let leftoverMargins = [];
        for(let col = 0; col < cells.length; col += 1){
            let rects = rectsByEachCol[col];
            let singlePlacements = [];
            let currentHeight = 0;
            let currentMarginTop = 0;
            for (let rect of rects){
                let seg = segs[rect.index];
                singlePlacements.push({
                    seg: $025b955b6a80424b$var$resliceSeg(seg, col, col + 1, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: rect.levelCoord - currentHeight
                });
                currentHeight = rect.levelCoord + rect.thickness;
            }
            let multiPlacements = [];
            currentHeight = 0;
            currentMarginTop = 0;
            for (let rect of rects){
                let seg = segs[rect.index];
                let isAbsolute = rect.span.end - rect.span.start > 1;
                let isFirstCol = rect.span.start === col;
                currentMarginTop += rect.levelCoord - currentHeight;
                currentHeight = rect.levelCoord + rect.thickness;
                if (isAbsolute) {
                    currentMarginTop += rect.thickness;
                    if (isFirstCol) multiPlacements.push({
                        seg: $025b955b6a80424b$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect.levelCoord,
                        marginTop: 0
                    });
                } else if (isFirstCol) {
                    multiPlacements.push({
                        seg: $025b955b6a80424b$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                        isVisible: true,
                        isAbsolute: false,
                        absoluteTop: rect.levelCoord,
                        marginTop: currentMarginTop
                    });
                    currentMarginTop = 0;
                }
            }
            singleColPlacements.push(singlePlacements);
            multiColPlacements.push(multiPlacements);
            leftoverMargins.push(currentMarginTop);
        }
        return {
            singleColPlacements: singleColPlacements,
            multiColPlacements: multiColPlacements,
            leftoverMargins: leftoverMargins
        };
    }
    function $025b955b6a80424b$var$groupRectsByEachCol(rects, colCnt) {
        let rectsByEachCol = [];
        for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
        for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
        return rectsByEachCol;
    }
    function $025b955b6a80424b$var$resliceSeg(seg, spanStart, spanEnd, cells) {
        if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
        let eventRange = seg.eventRange;
        let origRange = eventRange.range;
        let slicedRange = (0, (0, parcelRequire("Jd88K")).n)(origRange, {
            start: cells[spanStart].date,
            end: (0, (0, parcelRequire("Jd88K")).q)(cells[spanEnd - 1].date, 1)
        });
        return Object.assign(Object.assign({}, seg), {
            firstCol: spanStart,
            lastCol: spanEnd - 1,
            eventRange: {
                def: eventRange.def,
                ui: Object.assign(Object.assign({}, eventRange.ui), {
                    durationEditable: false
                }),
                instance: eventRange.instance,
                range: slicedRange
            },
            isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
            isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
        });
    }
    class $025b955b6a80424b$var$DayGridSegHierarchy extends (0, (0, parcelRequire("Jd88K")).bA) {
        constructor(){
            super(...arguments);
            this.hiddenConsumes = false;
            this.forceHidden = {};
        }
        addSegs(segInputs) {
            const hiddenSegs = super.addSegs(segInputs);
            const { entriesByLevel: entriesByLevel } = this;
            const excludeHidden = (entry)=>!this.forceHidden[(0, (0, parcelRequire("Jd88K")).bB)(entry)];
            for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
            return hiddenSegs;
        }
        handleInvalidInsertion(insertion, entry, hiddenEntries) {
            const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
            const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
            if (this.hiddenConsumes && touchingEntry) {
                const touchingEntryId = (0, (0, parcelRequire("Jd88K")).bB)(touchingEntry);
                if (!forceHidden[touchingEntryId]) {
                    if (this.allowReslicing) {
                        const placeholderEntry = Object.assign(Object.assign({}, touchingEntry), {
                            span: (0, (0, parcelRequire("Jd88K")).bF)(touchingEntry.span, entry.span)
                        });
                        const placeholderEntryId = (0, (0, parcelRequire("Jd88K")).bB)(placeholderEntry);
                        forceHidden[placeholderEntryId] = true;
                        entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry;
                        this.splitEntry(touchingEntry, entry, hiddenEntries);
                    } else {
                        forceHidden[touchingEntryId] = true;
                        hiddenEntries.push(touchingEntry);
                    }
                }
            }
            return super.handleInvalidInsertion(insertion, entry, hiddenEntries);
        }
    }
    class $025b955b6a80424b$var$TableRow extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.cellElRefs = new (0, (0, parcelRequire("Jd88K")).cf)();
            this.frameElRefs = new (0, (0, parcelRequire("Jd88K")).cf)();
            this.fgElRefs = new (0, (0, parcelRequire("Jd88K")).cf)();
            this.segHarnessRefs = new (0, (0, parcelRequire("Jd88K")).cf)();
            this.rootElRef = (0, $77d02.createRef)();
            this.state = {
                framePositions: null,
                maxContentHeight: null,
                eventInstanceHeights: {}
            };
            this.handleResize = (isForced)=>{
                if (isForced) this.updateSizing(true);
            };
        }
        render() {
            let { props: props, state: state, context: context } = this;
            let { options: options } = context;
            let colCnt = props.cells.length;
            let businessHoursByCol = $025b955b6a80424b$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
            let bgEventSegsByCol = $025b955b6a80424b$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
            let highlightSegsByCol = $025b955b6a80424b$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
            let mirrorSegsByCol = $025b955b6a80424b$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
            let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $025b955b6a80424b$var$computeFgSegPlacement((0, (0, parcelRequire("Jd88K")).bR)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.eventInstanceHeights, state.maxContentHeight, props.cells);
            let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
            return (0, $77d02.createElement)("tr", {
                ref: this.rootElRef,
                role: "row"
            }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
                let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                let mirrorFgNodes = this.renderFgSegs(col, $025b955b6a80424b$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                return (0, $77d02.createElement)($025b955b6a80424b$var$TableCell, {
                    key: cell.key,
                    elRef: this.cellElRefs.createRef(cell.key),
                    innerElRef: this.frameElRefs.createRef(cell.key),
                    dateProfile: props.dateProfile,
                    date: cell.date,
                    showDayNumber: props.showDayNumbers,
                    showWeekNumber: props.showWeekNumbers && col === 0,
                    forceDayTop: props.showWeekNumbers,
                    todayRange: props.todayRange,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    extraRenderProps: cell.extraRenderProps,
                    extraDataAttrs: cell.extraDataAttrs,
                    extraClassNames: cell.extraClassNames,
                    extraDateSpan: cell.extraDateSpan,
                    moreCnt: moreCnts[col],
                    moreMarginTop: moreMarginTops[col],
                    singlePlacements: singleColPlacements[col],
                    fgContentElRef: this.fgElRefs.createRef(cell.key),
                    fgContent: (0, $77d02.createElement)((0, $77d02.Fragment), null, (0, $77d02.createElement)((0, $77d02.Fragment), null, normalFgNodes), (0, $77d02.createElement)((0, $77d02.Fragment), null, mirrorFgNodes)),
                    bgContent: (0, $77d02.createElement)((0, $77d02.Fragment), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                    minHeight: props.cellMinHeight
                });
            }));
        }
        componentDidMount() {
            this.updateSizing(true);
            this.context.addResizeHandler(this.handleResize);
        }
        componentDidUpdate(prevProps, prevState) {
            let currentProps = this.props;
            this.updateSizing(!(0, (0, parcelRequire("Jd88K")).A)(prevProps, currentProps));
        }
        componentWillUnmount() {
            this.context.removeResizeHandler(this.handleResize);
        }
        getHighlightSegs() {
            let { props: props } = this;
            if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
            if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
            return props.dateSelectionSegs;
        }
        getMirrorSegs() {
            let { props: props } = this;
            if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
            return [];
        }
        renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
            let { context: context } = this;
            let { eventSelection: eventSelection } = this.props;
            let { framePositions: framePositions } = this.state;
            let defaultDisplayEventEnd = this.props.cells.length === 1;
            let isMirror = isDragging || isResizing || isDateSelecting;
            let nodes = [];
            if (framePositions) for (let placement of segPlacements){
                let { seg: seg } = placement;
                let { instanceId: instanceId } = seg.eventRange.instance;
                let key = instanceId + ':' + col;
                let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                let isAbsolute = placement.isAbsolute;
                let left = '';
                let right = '';
                if (isAbsolute) {
                    if (context.isRtl) {
                        right = 0;
                        left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                    } else {
                        left = 0;
                        right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                    }
                }
                nodes.push((0, $77d02.createElement)("div", {
                    className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                    key: key,
                    ref: isMirror ? null : this.segHarnessRefs.createRef(key),
                    style: {
                        visibility: isVisible ? '' : 'hidden',
                        marginTop: isAbsolute ? '' : placement.marginTop,
                        top: isAbsolute ? placement.absoluteTop : '',
                        left: left,
                        right: right
                    }
                }, $025b955b6a80424b$var$hasListItemDisplay(seg) ? (0, $77d02.createElement)($025b955b6a80424b$var$TableListItemEvent, Object.assign({
                    seg: seg,
                    isDragging: isDragging,
                    isSelected: instanceId === eventSelection,
                    defaultDisplayEventEnd: defaultDisplayEventEnd
                }, (0, (0, parcelRequire("Jd88K")).bS)(seg, todayRange))) : (0, $77d02.createElement)($025b955b6a80424b$var$TableBlockEvent, Object.assign({
                    seg: seg,
                    isDragging: isDragging,
                    isResizing: isResizing,
                    isDateSelecting: isDateSelecting,
                    isSelected: instanceId === eventSelection,
                    defaultDisplayEventEnd: defaultDisplayEventEnd
                }, (0, (0, parcelRequire("Jd88K")).bS)(seg, todayRange)))));
            }
            return nodes;
        }
        renderFillSegs(segs, fillType) {
            let { isRtl: isRtl } = this.context;
            let { todayRange: todayRange } = this.props;
            let { framePositions: framePositions } = this.state;
            let nodes = [];
            if (framePositions) for (let seg of segs){
                let leftRightCss = isRtl ? {
                    right: 0,
                    left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
                } : {
                    left: 0,
                    right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
                };
                nodes.push((0, $77d02.createElement)("div", {
                    key: (0, (0, parcelRequire("Jd88K")).bT)(seg.eventRange),
                    className: "fc-daygrid-bg-harness",
                    style: leftRightCss
                }, fillType === 'bg-event' ? (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).cp), Object.assign({
                    seg: seg
                }, (0, (0, parcelRequire("Jd88K")).bS)(seg, todayRange))) : (0, (0, parcelRequire("Jd88K")).co)(fillType)));
            }
            return (0, $77d02.createElement)((0, $77d02.Fragment), {}, ...nodes);
        }
        updateSizing(isExternalSizingChange) {
            let { props: props, state: state, frameElRefs: frameElRefs } = this;
            if (!props.forPrint && props.clientWidth !== null) {
                if (isExternalSizingChange) {
                    let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                    if (frameEls.length) {
                        let originEl = this.rootElRef.current;
                        let newPositionCache = new (0, (0, parcelRequire("Jd88K")).ba)(originEl, frameEls, true, false);
                        if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                            framePositions: new (0, (0, parcelRequire("Jd88K")).ba)(originEl, frameEls, true, false)
                        });
                    }
                }
                const oldInstanceHeights = this.state.eventInstanceHeights;
                const newInstanceHeights = this.queryEventInstanceHeights();
                const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
                this.safeSetState({
                    eventInstanceHeights: Object.assign(Object.assign({}, oldInstanceHeights), newInstanceHeights),
                    maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
                });
            }
        }
        queryEventInstanceHeights() {
            let segElMap = this.segHarnessRefs.currentMap;
            let eventInstanceHeights = {};
            for(let key in segElMap){
                let height = Math.round(segElMap[key].getBoundingClientRect().height);
                let instanceId = key.split(':')[0];
                eventInstanceHeights[instanceId] = Math.max(eventInstanceHeights[instanceId] || 0, height);
            }
            return eventInstanceHeights;
        }
        computeMaxContentHeight() {
            let firstKey = this.props.cells[0].key;
            let cellEl = this.cellElRefs.currentMap[firstKey];
            let fcContainerEl = this.fgElRefs.currentMap[firstKey];
            return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
        }
        getCellEls() {
            let elMap = this.cellElRefs.currentMap;
            return this.props.cells.map((cell)=>elMap[cell.key]);
        }
    }
    $025b955b6a80424b$var$TableRow.addStateEquality({
        eventInstanceHeights: (0, (0, parcelRequire("Jd88K")).A)
    });
    function $025b955b6a80424b$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
        if (!mirrorSegs.length) return [];
        let topsByInstanceId = $025b955b6a80424b$var$buildAbsoluteTopHash(colPlacements);
        return mirrorSegs.map((seg)=>({
                seg: seg,
                isVisible: true,
                isAbsolute: true,
                absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
                marginTop: 0
            }));
    }
    function $025b955b6a80424b$var$buildAbsoluteTopHash(colPlacements) {
        let topsByInstanceId = {};
        for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
        return topsByInstanceId;
    }
    class $025b955b6a80424b$export$d955b1c53830e05a extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.splitBusinessHourSegs = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitSegsByRow);
            this.splitBgEventSegs = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitSegsByRow);
            this.splitFgEventSegs = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitSegsByRow);
            this.splitDateSelectionSegs = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitSegsByRow);
            this.splitEventDrag = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitInteractionByRow);
            this.splitEventResize = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$var$splitInteractionByRow);
            this.rowRefs = new (0, (0, parcelRequire("Jd88K")).cf)();
        }
        render() {
            let { props: props, context: context } = this;
            let rowCnt = props.cells.length;
            let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
            let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
            let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
            let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
            let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
            let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
            let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
            return (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).ch), {
                unit: "day"
            }, (nowDate, todayRange)=>(0, $77d02.createElement)((0, $77d02.Fragment), null, props.cells.map((cells, row)=>(0, $77d02.createElement)($025b955b6a80424b$var$TableRow, {
                        ref: this.rowRefs.createRef(row),
                        key: cells.length ? cells[0].date.toISOString() : row,
                        showDayNumbers: rowCnt > 1,
                        showWeekNumbers: props.showWeekNumbers,
                        todayRange: todayRange,
                        dateProfile: props.dateProfile,
                        cells: cells,
                        renderIntro: props.renderRowIntro,
                        businessHourSegs: businessHourSegsByRow[row],
                        eventSelection: props.eventSelection,
                        bgEventSegs: bgEventSegsByRow[row].filter($025b955b6a80424b$var$isSegAllDay),
                        fgEventSegs: fgEventSegsByRow[row],
                        dateSelectionSegs: dateSelectionSegsByRow[row],
                        eventDrag: eventDragByRow[row],
                        eventResize: eventResizeByRow[row],
                        dayMaxEvents: props.dayMaxEvents,
                        dayMaxEventRows: props.dayMaxEventRows,
                        clientWidth: props.clientWidth,
                        clientHeight: props.clientHeight,
                        cellMinHeight: cellMinHeight,
                        forPrint: props.forPrint
                    }))));
        }
        componentDidMount() {
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            this.rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (this.rootEl) this.context.registerInteractiveComponent(this, {
                el: this.rootEl,
                isHitComboAllowed: this.props.isHitComboAllowed
            });
        }
        componentWillUnmount() {
            if (this.rootEl) {
                this.context.unregisterInteractiveComponent(this);
                this.rootEl = null;
            }
        }
        prepareHits() {
            this.rowPositions = new (0, (0, parcelRequire("Jd88K")).ba)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
            this.colPositions = new (0, (0, parcelRequire("Jd88K")).ba)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
        }
        queryHit(positionLeft, positionTop) {
            let { colPositions: colPositions, rowPositions: rowPositions } = this;
            let col = colPositions.leftToIndex(positionLeft);
            let row = rowPositions.topToIndex(positionTop);
            if (row != null && col != null) {
                let cell = this.props.cells[row][col];
                return {
                    dateProfile: this.props.dateProfile,
                    dateSpan: Object.assign({
                        range: this.getCellRange(row, col),
                        allDay: true
                    }, cell.extraDateSpan),
                    dayEl: this.getCellEl(row, col),
                    rect: {
                        left: colPositions.lefts[col],
                        right: colPositions.rights[col],
                        top: rowPositions.tops[row],
                        bottom: rowPositions.bottoms[row]
                    },
                    layer: 0
                };
            }
            return null;
        }
        getCellEl(row, col) {
            return this.rowRefs.currentMap[row].getCellEls()[col];
        }
        getCellRange(row, col) {
            let start = this.props.cells[row][col].date;
            let end = (0, (0, parcelRequire("Jd88K")).q)(start, 1);
            return {
                start: start,
                end: end
            };
        }
    }
    function $025b955b6a80424b$var$isSegAllDay(seg) {
        return seg.eventRange.def.allDay;
    }
    class $025b955b6a80424b$export$54ec01a60f47d33d extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.elRef = (0, $77d02.createRef)();
            this.needsScrollReset = false;
        }
        render() {
            let { props: props } = this;
            let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
            let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
            if (limitViaBalanced && !expandRows) {
                limitViaBalanced = false;
                dayMaxEventRows = null;
                dayMaxEvents = null;
            }
            let classNames = [
                'fc-daygrid-body',
                limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
                expandRows ? '' : 'fc-daygrid-body-natural'
            ];
            return (0, $77d02.createElement)("div", {
                ref: this.elRef,
                className: classNames.join(' '),
                style: {
                    width: props.clientWidth,
                    minWidth: props.tableMinWidth
                }
            }, (0, $77d02.createElement)("table", {
                role: "presentation",
                className: "fc-scrollgrid-sync-table",
                style: {
                    width: props.clientWidth,
                    minWidth: props.tableMinWidth,
                    height: expandRows ? props.clientHeight : ''
                }
            }, props.colGroupNode, (0, $77d02.createElement)("tbody", {
                role: "presentation"
            }, (0, $77d02.createElement)($025b955b6a80424b$export$d955b1c53830e05a, {
                dateProfile: props.dateProfile,
                cells: props.cells,
                renderRowIntro: props.renderRowIntro,
                showWeekNumbers: props.showWeekNumbers,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                businessHourSegs: props.businessHourSegs,
                bgEventSegs: props.bgEventSegs,
                fgEventSegs: props.fgEventSegs,
                dateSelectionSegs: props.dateSelectionSegs,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                dayMaxEvents: dayMaxEvents,
                dayMaxEventRows: dayMaxEventRows,
                forPrint: props.forPrint,
                isHitComboAllowed: props.isHitComboAllowed
            }))));
        }
        componentDidMount() {
            this.requestScrollReset();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
            else this.flushScrollReset();
        }
        requestScrollReset() {
            this.needsScrollReset = true;
            this.flushScrollReset();
        }
        flushScrollReset() {
            if (this.needsScrollReset && this.props.clientWidth) {
                const subjectEl = $025b955b6a80424b$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
                if (subjectEl) {
                    const originEl = subjectEl.closest('.fc-daygrid-body');
                    const scrollEl = originEl.closest('.fc-scroller');
                    const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                    scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0;
                }
                this.needsScrollReset = false;
            }
        }
    }
    function $025b955b6a80424b$var$getScrollSubjectEl(containerEl, dateProfile) {
        let el;
        if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, (0, parcelRequire("Jd88K")).bx)(dateProfile.currentDate)}-01"]`);
        if (!el) el = containerEl.querySelector(`[data-date="${(0, (0, parcelRequire("Jd88K")).bv)(dateProfile.currentDate)}"]`);
        return el;
    }
    class $025b955b6a80424b$export$eb38be9553e58392 extends (0, (0, parcelRequire("Jd88K")).bW) {
        constructor(){
            super(...arguments);
            this.forceDayIfListItem = true;
        }
        sliceRange(dateRange, dayTableModel) {
            return dayTableModel.sliceRange(dateRange);
        }
    }
    class $025b955b6a80424b$export$cd402b7558adf371 extends (0, (0, parcelRequire("Jd88K")).be) {
        constructor(){
            super(...arguments);
            this.slicer = new $025b955b6a80424b$export$eb38be9553e58392();
            this.tableRef = (0, $77d02.createRef)();
        }
        render() {
            let { props: props, context: context } = this;
            return (0, $77d02.createElement)($025b955b6a80424b$export$54ec01a60f47d33d, Object.assign({
                ref: this.tableRef
            }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
                dateProfile: props.dateProfile,
                cells: props.dayTableModel.cells,
                colGroupNode: props.colGroupNode,
                tableMinWidth: props.tableMinWidth,
                renderRowIntro: props.renderRowIntro,
                dayMaxEvents: props.dayMaxEvents,
                dayMaxEventRows: props.dayMaxEventRows,
                showWeekNumbers: props.showWeekNumbers,
                expandRows: props.expandRows,
                headerAlignElRef: props.headerAlignElRef,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                forPrint: props.forPrint
            }));
        }
    }
    class $025b955b6a80424b$export$39eed66de95896e5 extends $025b955b6a80424b$export$b3c27e869d856b7 {
        constructor(){
            super(...arguments);
            this.buildDayTableModel = (0, (0, parcelRequire("Jd88K")).y)($025b955b6a80424b$export$61e79f95d746b006);
            this.headerRef = (0, $77d02.createRef)();
            this.tableRef = (0, $77d02.createRef)();
        }
        render() {
            let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
            let { props: props } = this;
            let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
            let headerContent = options.dayHeaders && (0, $77d02.createElement)((0, (0, parcelRequire("Jd88K")).bK), {
                ref: this.headerRef,
                dateProfile: props.dateProfile,
                dates: dayTableModel.headerDates,
                datesRepDistinctDays: dayTableModel.rowCnt === 1
            });
            let bodyContent = (contentArg)=>(0, $77d02.createElement)($025b955b6a80424b$export$cd402b7558adf371, {
                    ref: this.tableRef,
                    dateProfile: props.dateProfile,
                    dayTableModel: dayTableModel,
                    businessHours: props.businessHours,
                    dateSelection: props.dateSelection,
                    eventStore: props.eventStore,
                    eventUiBases: props.eventUiBases,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    nextDayThreshold: options.nextDayThreshold,
                    colGroupNode: contentArg.tableColGroupNode,
                    tableMinWidth: contentArg.tableMinWidth,
                    dayMaxEvents: options.dayMaxEvents,
                    dayMaxEventRows: options.dayMaxEventRows,
                    showWeekNumbers: options.weekNumbers,
                    expandRows: !props.isHeightAuto,
                    headerAlignElRef: this.headerElRef,
                    clientWidth: contentArg.clientWidth,
                    clientHeight: contentArg.clientHeight,
                    forPrint: props.forPrint
                });
            return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
        }
    }
    function $025b955b6a80424b$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
        let daySeries = new (0, (0, parcelRequire("Jd88K")).bO)(dateProfile.renderRange, dateProfileGenerator);
        return new (0, (0, parcelRequire("Jd88K")).bV)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
    }
    class $025b955b6a80424b$export$9fcce6e2d16ec31d extends (0, (0, parcelRequire("Jd88K")).S) {
        buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
            let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
            let { props: props } = this;
            return $025b955b6a80424b$export$a2ad67969be9f247({
                currentRange: renderRange,
                snapToWeek: /^(year|month)$/.test(currentRangeUnit),
                fixedWeekCount: props.fixedWeekCount,
                dateEnv: props.dateEnv
            });
        }
    }
    function $025b955b6a80424b$export$a2ad67969be9f247(props) {
        let { dateEnv: dateEnv, currentRange: currentRange } = props;
        let { start: start, end: end } = currentRange;
        let endOfWeek;
        if (props.snapToWeek) {
            start = dateEnv.startOfWeek(start);
            endOfWeek = dateEnv.startOfWeek(end);
            if (endOfWeek.valueOf() !== end.valueOf()) end = (0, (0, parcelRequire("Jd88K")).bh)(endOfWeek, 1);
        }
        if (props.fixedWeekCount) {
            let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, (0, parcelRequire("Jd88K")).q)(currentRange.end, -1)));
            let rowCnt = Math.ceil((0, (0, parcelRequire("Jd88K")).bi)(lastMonthRenderStart, end));
            end = (0, (0, parcelRequire("Jd88K")).bh)(end, 6 - rowCnt);
        }
        return {
            start: start,
            end: end
        };
    }
    var $025b955b6a80424b$var$css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
    (0, (0, parcelRequire("Jd88K")).cw)($025b955b6a80424b$var$css_248z);
});
parcelRegister("fHusM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6e28085a086a4ad$export$2e2bcd8739ae039);
    var $5nZSg;
    var $Jd88K;
    (0, (0, parcelRequire("Jd88K")).bI).touchMouseIgnoreWait = 500;
    let $b6e28085a086a4ad$var$ignoreMouseDepth = 0;
    let $b6e28085a086a4ad$var$listenerCnt = 0;
    let $b6e28085a086a4ad$var$isWindowTouchMoveCancelled = false;
    class $b6e28085a086a4ad$var$PointerDragging {
        constructor(containerEl){
            this.subjectEl = null;
            this.selector = '';
            this.handleSelector = '';
            this.shouldIgnoreMove = false;
            this.shouldWatchScroll = true;
            this.isDragging = false;
            this.isTouchDragging = false;
            this.wasTouchScroll = false;
            this.handleMouseDown = (ev)=>{
                if (!this.shouldIgnoreMouse() && $b6e28085a086a4ad$var$isPrimaryMouseButton(ev) && this.tryStart(ev)) {
                    let pev = this.createEventFromMouse(ev, true);
                    this.emitter.trigger('pointerdown', pev);
                    this.initScrollWatch(pev);
                    if (!this.shouldIgnoreMove) document.addEventListener('mousemove', this.handleMouseMove);
                    document.addEventListener('mouseup', this.handleMouseUp);
                }
            };
            this.handleMouseMove = (ev)=>{
                let pev = this.createEventFromMouse(ev);
                this.recordCoords(pev);
                this.emitter.trigger('pointermove', pev);
            };
            this.handleMouseUp = (ev)=>{
                document.removeEventListener('mousemove', this.handleMouseMove);
                document.removeEventListener('mouseup', this.handleMouseUp);
                this.emitter.trigger('pointerup', this.createEventFromMouse(ev));
                this.cleanup();
            };
            this.handleTouchStart = (ev)=>{
                if (this.tryStart(ev)) {
                    this.isTouchDragging = true;
                    let pev = this.createEventFromTouch(ev, true);
                    this.emitter.trigger('pointerdown', pev);
                    this.initScrollWatch(pev);
                    let targetEl = ev.target;
                    if (!this.shouldIgnoreMove) targetEl.addEventListener('touchmove', this.handleTouchMove);
                    targetEl.addEventListener('touchend', this.handleTouchEnd);
                    targetEl.addEventListener('touchcancel', this.handleTouchEnd);
                    window.addEventListener('scroll', this.handleTouchScroll, true);
                }
            };
            this.handleTouchMove = (ev)=>{
                let pev = this.createEventFromTouch(ev);
                this.recordCoords(pev);
                this.emitter.trigger('pointermove', pev);
            };
            this.handleTouchEnd = (ev)=>{
                if (this.isDragging) {
                    let targetEl = ev.target;
                    targetEl.removeEventListener('touchmove', this.handleTouchMove);
                    targetEl.removeEventListener('touchend', this.handleTouchEnd);
                    targetEl.removeEventListener('touchcancel', this.handleTouchEnd);
                    window.removeEventListener('scroll', this.handleTouchScroll, true);
                    this.emitter.trigger('pointerup', this.createEventFromTouch(ev));
                    this.cleanup();
                    this.isTouchDragging = false;
                    $b6e28085a086a4ad$var$startIgnoringMouse();
                }
            };
            this.handleTouchScroll = ()=>{
                this.wasTouchScroll = true;
            };
            this.handleScroll = (ev)=>{
                if (!this.shouldIgnoreMove) {
                    let pageX = window.pageXOffset - this.prevScrollX + this.prevPageX;
                    let pageY = window.pageYOffset - this.prevScrollY + this.prevPageY;
                    this.emitter.trigger('pointermove', {
                        origEvent: ev,
                        isTouch: this.isTouchDragging,
                        subjectEl: this.subjectEl,
                        pageX: pageX,
                        pageY: pageY,
                        deltaX: pageX - this.origPageX,
                        deltaY: pageY - this.origPageY
                    });
                }
            };
            this.containerEl = containerEl;
            this.emitter = new (0, (0, parcelRequire("Jd88K")).E)();
            containerEl.addEventListener('mousedown', this.handleMouseDown);
            containerEl.addEventListener('touchstart', this.handleTouchStart, {
                passive: true
            });
            $b6e28085a086a4ad$var$listenerCreated();
        }
        destroy() {
            this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
            this.containerEl.removeEventListener('touchstart', this.handleTouchStart, {
                passive: true
            });
            $b6e28085a086a4ad$var$listenerDestroyed();
        }
        tryStart(ev) {
            let subjectEl = this.querySubjectEl(ev);
            let downEl = ev.target;
            if (subjectEl && (!this.handleSelector || (0, (0, parcelRequire("Jd88K")).$)(downEl, this.handleSelector))) {
                this.subjectEl = subjectEl;
                this.isDragging = true;
                this.wasTouchScroll = false;
                return true;
            }
            return false;
        }
        cleanup() {
            $b6e28085a086a4ad$var$isWindowTouchMoveCancelled = false;
            this.isDragging = false;
            this.subjectEl = null;
            this.destroyScrollWatch();
        }
        querySubjectEl(ev) {
            if (this.selector) return (0, (0, parcelRequire("Jd88K")).$)(ev.target, this.selector);
            return this.containerEl;
        }
        shouldIgnoreMouse() {
            return $b6e28085a086a4ad$var$ignoreMouseDepth || this.isTouchDragging;
        }
        cancelTouchScroll() {
            if (this.isDragging) $b6e28085a086a4ad$var$isWindowTouchMoveCancelled = true;
        }
        initScrollWatch(ev) {
            if (this.shouldWatchScroll) {
                this.recordCoords(ev);
                window.addEventListener('scroll', this.handleScroll, true);
            }
        }
        recordCoords(ev) {
            if (this.shouldWatchScroll) {
                this.prevPageX = ev.pageX;
                this.prevPageY = ev.pageY;
                this.prevScrollX = window.pageXOffset;
                this.prevScrollY = window.pageYOffset;
            }
        }
        destroyScrollWatch() {
            if (this.shouldWatchScroll) window.removeEventListener('scroll', this.handleScroll, true);
        }
        createEventFromMouse(ev, isFirst) {
            let deltaX = 0;
            let deltaY = 0;
            if (isFirst) {
                this.origPageX = ev.pageX;
                this.origPageY = ev.pageY;
            } else {
                deltaX = ev.pageX - this.origPageX;
                deltaY = ev.pageY - this.origPageY;
            }
            return {
                origEvent: ev,
                isTouch: false,
                subjectEl: this.subjectEl,
                pageX: ev.pageX,
                pageY: ev.pageY,
                deltaX: deltaX,
                deltaY: deltaY
            };
        }
        createEventFromTouch(ev, isFirst) {
            let touches = ev.touches;
            let pageX;
            let pageY;
            let deltaX = 0;
            let deltaY = 0;
            if (touches && touches.length) {
                pageX = touches[0].pageX;
                pageY = touches[0].pageY;
            } else {
                pageX = ev.pageX;
                pageY = ev.pageY;
            }
            if (isFirst) {
                this.origPageX = pageX;
                this.origPageY = pageY;
            } else {
                deltaX = pageX - this.origPageX;
                deltaY = pageY - this.origPageY;
            }
            return {
                origEvent: ev,
                isTouch: true,
                subjectEl: this.subjectEl,
                pageX: pageX,
                pageY: pageY,
                deltaX: deltaX,
                deltaY: deltaY
            };
        }
    }
    function $b6e28085a086a4ad$var$isPrimaryMouseButton(ev) {
        return ev.button === 0 && !ev.ctrlKey;
    }
    function $b6e28085a086a4ad$var$startIgnoringMouse() {
        $b6e28085a086a4ad$var$ignoreMouseDepth += 1;
        setTimeout(()=>{
            $b6e28085a086a4ad$var$ignoreMouseDepth -= 1;
        }, (0, (0, parcelRequire("Jd88K")).bI).touchMouseIgnoreWait);
    }
    function $b6e28085a086a4ad$var$listenerCreated() {
        $b6e28085a086a4ad$var$listenerCnt += 1;
        if ($b6e28085a086a4ad$var$listenerCnt === 1) window.addEventListener('touchmove', $b6e28085a086a4ad$var$onWindowTouchMove, {
            passive: false
        });
    }
    function $b6e28085a086a4ad$var$listenerDestroyed() {
        $b6e28085a086a4ad$var$listenerCnt -= 1;
        if (!$b6e28085a086a4ad$var$listenerCnt) window.removeEventListener('touchmove', $b6e28085a086a4ad$var$onWindowTouchMove, {
            passive: false
        });
    }
    function $b6e28085a086a4ad$var$onWindowTouchMove(ev) {
        if ($b6e28085a086a4ad$var$isWindowTouchMoveCancelled) ev.preventDefault();
    }
    class $b6e28085a086a4ad$var$ElementMirror {
        constructor(){
            this.isVisible = false;
            this.sourceEl = null;
            this.mirrorEl = null;
            this.sourceElRect = null;
            this.parentNode = document.body;
            this.zIndex = 9999;
            this.revertDuration = 0;
        }
        start(sourceEl, pageX, pageY) {
            this.sourceEl = sourceEl;
            this.sourceElRect = this.sourceEl.getBoundingClientRect();
            this.origScreenX = pageX - window.pageXOffset;
            this.origScreenY = pageY - window.pageYOffset;
            this.deltaX = 0;
            this.deltaY = 0;
            this.updateElPosition();
        }
        handleMove(pageX, pageY) {
            this.deltaX = pageX - window.pageXOffset - this.origScreenX;
            this.deltaY = pageY - window.pageYOffset - this.origScreenY;
            this.updateElPosition();
        }
        setIsVisible(bool) {
            if (bool) {
                if (!this.isVisible) {
                    if (this.mirrorEl) this.mirrorEl.style.display = '';
                    this.isVisible = bool;
                    this.updateElPosition();
                }
            } else if (this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = 'none';
                this.isVisible = bool;
            }
        }
        stop(needsRevertAnimation, callback) {
            let done = ()=>{
                this.cleanup();
                callback();
            };
            if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && (this.deltaX || this.deltaY)) this.doRevertAnimation(done, this.revertDuration);
            else setTimeout(done, 0);
        }
        doRevertAnimation(callback, revertDuration) {
            let mirrorEl = this.mirrorEl;
            let finalSourceElRect = this.sourceEl.getBoundingClientRect();
            mirrorEl.style.transition = 'top ' + revertDuration + 'ms,' + 'left ' + revertDuration + 'ms';
            (0, (0, parcelRequire("Jd88K")).aP)(mirrorEl, {
                left: finalSourceElRect.left,
                top: finalSourceElRect.top
            });
            (0, (0, parcelRequire("Jd88K")).b2)(mirrorEl, ()=>{
                mirrorEl.style.transition = '';
                callback();
            });
        }
        cleanup() {
            if (this.mirrorEl) {
                (0, (0, parcelRequire("Jd88K")).aO)(this.mirrorEl);
                this.mirrorEl = null;
            }
            this.sourceEl = null;
        }
        updateElPosition() {
            if (this.sourceEl && this.isVisible) (0, (0, parcelRequire("Jd88K")).aP)(this.getMirrorEl(), {
                left: this.sourceElRect.left + this.deltaX,
                top: this.sourceElRect.top + this.deltaY
            });
        }
        getMirrorEl() {
            let sourceElRect = this.sourceElRect;
            let mirrorEl = this.mirrorEl;
            if (!mirrorEl) {
                mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true);
                mirrorEl.style.userSelect = 'none';
                mirrorEl.classList.add('fc-event-dragging');
                (0, (0, parcelRequire("Jd88K")).aP)(mirrorEl, {
                    position: 'fixed',
                    zIndex: this.zIndex,
                    visibility: '',
                    boxSizing: 'border-box',
                    width: sourceElRect.right - sourceElRect.left,
                    height: sourceElRect.bottom - sourceElRect.top,
                    right: 'auto',
                    bottom: 'auto',
                    margin: 0
                });
                this.parentNode.appendChild(mirrorEl);
            }
            return mirrorEl;
        }
    }
    class $b6e28085a086a4ad$var$ScrollGeomCache extends (0, (0, parcelRequire("Jd88K")).bb) {
        constructor(scrollController, doesListening){
            super();
            this.handleScroll = ()=>{
                this.scrollTop = this.scrollController.getScrollTop();
                this.scrollLeft = this.scrollController.getScrollLeft();
                this.handleScrollChange();
            };
            this.scrollController = scrollController;
            this.doesListening = doesListening;
            this.scrollTop = this.origScrollTop = scrollController.getScrollTop();
            this.scrollLeft = this.origScrollLeft = scrollController.getScrollLeft();
            this.scrollWidth = scrollController.getScrollWidth();
            this.scrollHeight = scrollController.getScrollHeight();
            this.clientWidth = scrollController.getClientWidth();
            this.clientHeight = scrollController.getClientHeight();
            this.clientRect = this.computeClientRect();
            if (this.doesListening) this.getEventTarget().addEventListener('scroll', this.handleScroll);
        }
        destroy() {
            if (this.doesListening) this.getEventTarget().removeEventListener('scroll', this.handleScroll);
        }
        getScrollTop() {
            return this.scrollTop;
        }
        getScrollLeft() {
            return this.scrollLeft;
        }
        setScrollTop(top) {
            this.scrollController.setScrollTop(top);
            if (!this.doesListening) {
                this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
                this.handleScrollChange();
            }
        }
        setScrollLeft(top) {
            this.scrollController.setScrollLeft(top);
            if (!this.doesListening) {
                this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
                this.handleScrollChange();
            }
        }
        getClientWidth() {
            return this.clientWidth;
        }
        getClientHeight() {
            return this.clientHeight;
        }
        getScrollWidth() {
            return this.scrollWidth;
        }
        getScrollHeight() {
            return this.scrollHeight;
        }
        handleScrollChange() {}
    }
    class $b6e28085a086a4ad$var$ElementScrollGeomCache extends $b6e28085a086a4ad$var$ScrollGeomCache {
        constructor(el, doesListening){
            super(new (0, (0, parcelRequire("Jd88K")).bc)(el), doesListening);
        }
        getEventTarget() {
            return this.scrollController.el;
        }
        computeClientRect() {
            return (0, (0, parcelRequire("Jd88K")).b3)(this.scrollController.el);
        }
    }
    class $b6e28085a086a4ad$var$WindowScrollGeomCache extends $b6e28085a086a4ad$var$ScrollGeomCache {
        constructor(doesListening){
            super(new (0, (0, parcelRequire("Jd88K")).bd)(), doesListening);
        }
        getEventTarget() {
            return window;
        }
        computeClientRect() {
            return {
                left: this.scrollLeft,
                right: this.scrollLeft + this.clientWidth,
                top: this.scrollTop,
                bottom: this.scrollTop + this.clientHeight
            };
        }
        handleScrollChange() {
            this.clientRect = this.computeClientRect();
        }
    }
    const $b6e28085a086a4ad$var$getTime = typeof performance === 'function' ? performance.now : Date.now;
    class $b6e28085a086a4ad$var$AutoScroller {
        constructor(){
            this.isEnabled = true;
            this.scrollQuery = [
                window,
                '.fc-scroller'
            ];
            this.edgeThreshold = 50;
            this.maxVelocity = 300;
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.isAnimating = false;
            this.scrollCaches = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.animate = ()=>{
                if (this.isAnimating) {
                    let edge = this.computeBestEdge(this.pointerScreenX + window.pageXOffset, this.pointerScreenY + window.pageYOffset);
                    if (edge) {
                        let now = $b6e28085a086a4ad$var$getTime();
                        this.handleSide(edge, (now - this.msSinceRequest) / 1000);
                        this.requestAnimation(now);
                    } else this.isAnimating = false;
                }
            };
        }
        start(pageX, pageY, scrollStartEl) {
            if (this.isEnabled) {
                this.scrollCaches = this.buildCaches(scrollStartEl);
                this.pointerScreenX = null;
                this.pointerScreenY = null;
                this.everMovedUp = false;
                this.everMovedDown = false;
                this.everMovedLeft = false;
                this.everMovedRight = false;
                this.handleMove(pageX, pageY);
            }
        }
        handleMove(pageX, pageY) {
            if (this.isEnabled) {
                let pointerScreenX = pageX - window.pageXOffset;
                let pointerScreenY = pageY - window.pageYOffset;
                let yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
                let xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
                if (yDelta < 0) this.everMovedUp = true;
                else if (yDelta > 0) this.everMovedDown = true;
                if (xDelta < 0) this.everMovedLeft = true;
                else if (xDelta > 0) this.everMovedRight = true;
                this.pointerScreenX = pointerScreenX;
                this.pointerScreenY = pointerScreenY;
                if (!this.isAnimating) {
                    this.isAnimating = true;
                    this.requestAnimation($b6e28085a086a4ad$var$getTime());
                }
            }
        }
        stop() {
            if (this.isEnabled) {
                this.isAnimating = false;
                for (let scrollCache of this.scrollCaches)scrollCache.destroy();
                this.scrollCaches = null;
            }
        }
        requestAnimation(now) {
            this.msSinceRequest = now;
            requestAnimationFrame(this.animate);
        }
        handleSide(edge, seconds) {
            let { scrollCache: scrollCache } = edge;
            let { edgeThreshold: edgeThreshold } = this;
            let invDistance = edgeThreshold - edge.distance;
            let velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * this.maxVelocity * seconds;
            let sign = 1;
            switch(edge.name){
                case 'left':
                    sign = -1;
                case 'right':
                    scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                    break;
                case 'top':
                    sign = -1;
                case 'bottom':
                    scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                    break;
            }
        }
        computeBestEdge(left, top) {
            let { edgeThreshold: edgeThreshold } = this;
            let bestSide = null;
            let scrollCaches = this.scrollCaches || [];
            for (let scrollCache of scrollCaches){
                let rect = scrollCache.clientRect;
                let leftDist = left - rect.left;
                let rightDist = rect.right - left;
                let topDist = top - rect.top;
                let bottomDist = rect.bottom - top;
                if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                    if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                        scrollCache: scrollCache,
                        name: 'top',
                        distance: topDist
                    };
                    if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                        scrollCache: scrollCache,
                        name: 'bottom',
                        distance: bottomDist
                    };
                    if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                        scrollCache: scrollCache,
                        name: 'left',
                        distance: leftDist
                    };
                    if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                        scrollCache: scrollCache,
                        name: 'right',
                        distance: rightDist
                    };
                }
            }
            return bestSide;
        }
        buildCaches(scrollStartEl) {
            return this.queryScrollEls(scrollStartEl).map((el)=>{
                if (el === window) return new $b6e28085a086a4ad$var$WindowScrollGeomCache(false);
                return new $b6e28085a086a4ad$var$ElementScrollGeomCache(el, false);
            });
        }
        queryScrollEls(scrollStartEl) {
            let els = [];
            for (let query of this.scrollQuery)if (typeof query === 'object') els.push(query);
            else els.push(...Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query)));
            return els;
        }
    }
    class $b6e28085a086a4ad$var$FeaturefulElementDragging extends (0, (0, parcelRequire("Jd88K")).bH) {
        constructor(containerEl, selector){
            super(containerEl);
            this.containerEl = containerEl;
            this.delay = null;
            this.minDistance = 0;
            this.touchScrollAllowed = true;
            this.mirrorNeedsRevert = false;
            this.isInteracting = false;
            this.isDragging = false;
            this.isDelayEnded = false;
            this.isDistanceSurpassed = false;
            this.delayTimeoutId = null;
            this.onPointerDown = (ev)=>{
                if (!this.isDragging) {
                    this.isInteracting = true;
                    this.isDelayEnded = false;
                    this.isDistanceSurpassed = false;
                    (0, (0, parcelRequire("Jd88K")).ar)(document.body);
                    (0, (0, parcelRequire("Jd88K")).at)(document.body);
                    if (!ev.isTouch) ev.origEvent.preventDefault();
                    this.emitter.trigger('pointerdown', ev);
                    if (this.isInteracting && !this.pointer.shouldIgnoreMove) {
                        this.mirror.setIsVisible(false);
                        this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY);
                        this.startDelay(ev);
                        if (!this.minDistance) this.handleDistanceSurpassed(ev);
                    }
                }
            };
            this.onPointerMove = (ev)=>{
                if (this.isInteracting) {
                    this.emitter.trigger('pointermove', ev);
                    if (!this.isDistanceSurpassed) {
                        let minDistance = this.minDistance;
                        let distanceSq;
                        let { deltaX: deltaX, deltaY: deltaY } = ev;
                        distanceSq = deltaX * deltaX + deltaY * deltaY;
                        if (distanceSq >= minDistance * minDistance) this.handleDistanceSurpassed(ev);
                    }
                    if (this.isDragging) {
                        if (ev.origEvent.type !== 'scroll') {
                            this.mirror.handleMove(ev.pageX, ev.pageY);
                            this.autoScroller.handleMove(ev.pageX, ev.pageY);
                        }
                        this.emitter.trigger('dragmove', ev);
                    }
                }
            };
            this.onPointerUp = (ev)=>{
                if (this.isInteracting) {
                    this.isInteracting = false;
                    (0, (0, parcelRequire("Jd88K")).as)(document.body);
                    (0, (0, parcelRequire("Jd88K")).au)(document.body);
                    this.emitter.trigger('pointerup', ev);
                    if (this.isDragging) {
                        this.autoScroller.stop();
                        this.tryStopDrag(ev);
                    }
                    if (this.delayTimeoutId) {
                        clearTimeout(this.delayTimeoutId);
                        this.delayTimeoutId = null;
                    }
                }
            };
            let pointer = this.pointer = new $b6e28085a086a4ad$var$PointerDragging(containerEl);
            pointer.emitter.on('pointerdown', this.onPointerDown);
            pointer.emitter.on('pointermove', this.onPointerMove);
            pointer.emitter.on('pointerup', this.onPointerUp);
            if (selector) pointer.selector = selector;
            this.mirror = new $b6e28085a086a4ad$var$ElementMirror();
            this.autoScroller = new $b6e28085a086a4ad$var$AutoScroller();
        }
        destroy() {
            this.pointer.destroy();
            this.onPointerUp({});
        }
        startDelay(ev) {
            if (typeof this.delay === 'number') this.delayTimeoutId = setTimeout(()=>{
                this.delayTimeoutId = null;
                this.handleDelayEnd(ev);
            }, this.delay);
            else this.handleDelayEnd(ev);
        }
        handleDelayEnd(ev) {
            this.isDelayEnded = true;
            this.tryStartDrag(ev);
        }
        handleDistanceSurpassed(ev) {
            this.isDistanceSurpassed = true;
            this.tryStartDrag(ev);
        }
        tryStartDrag(ev) {
            if (this.isDelayEnded && this.isDistanceSurpassed) {
                if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                    this.isDragging = true;
                    this.mirrorNeedsRevert = false;
                    this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                    this.emitter.trigger('dragstart', ev);
                    if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
                }
            }
        }
        tryStopDrag(ev) {
            this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
        }
        stopDrag(ev) {
            this.isDragging = false;
            this.emitter.trigger('dragend', ev);
        }
        setIgnoreMove(bool) {
            this.pointer.shouldIgnoreMove = bool;
        }
        setMirrorIsVisible(bool) {
            this.mirror.setIsVisible(bool);
        }
        setMirrorNeedsRevert(bool) {
            this.mirrorNeedsRevert = bool;
        }
        setAutoScrollEnabled(bool) {
            this.autoScroller.isEnabled = bool;
        }
    }
    class $b6e28085a086a4ad$var$OffsetTracker {
        constructor(el){
            this.origRect = (0, (0, parcelRequire("Jd88K")).b6)(el);
            this.scrollCaches = (0, (0, parcelRequire("Jd88K")).b5)(el).map((scrollEl)=>new $b6e28085a086a4ad$var$ElementScrollGeomCache(scrollEl, true));
        }
        destroy() {
            for (let scrollCache of this.scrollCaches)scrollCache.destroy();
        }
        computeLeft() {
            let left = this.origRect.left;
            for (let scrollCache of this.scrollCaches)left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
            return left;
        }
        computeTop() {
            let top = this.origRect.top;
            for (let scrollCache of this.scrollCaches)top += scrollCache.origScrollTop - scrollCache.getScrollTop();
            return top;
        }
        isWithinClipping(pageX, pageY) {
            let point = {
                left: pageX,
                top: pageY
            };
            for (let scrollCache of this.scrollCaches){
                if (!$b6e28085a086a4ad$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, (0, parcelRequire("Jd88K")).aF)(point, scrollCache.clientRect)) return false;
            }
            return true;
        }
    }
    function $b6e28085a086a4ad$var$isIgnoredClipping(node) {
        let tagName = node.tagName;
        return tagName === 'HTML' || tagName === 'BODY';
    }
    class $b6e28085a086a4ad$var$HitDragging {
        constructor(dragging, droppableStore){
            this.useSubjectCenter = false;
            this.requireInitial = true;
            this.initialHit = null;
            this.movingHit = null;
            this.finalHit = null;
            this.handlePointerDown = (ev)=>{
                let { dragging: dragging } = this;
                this.initialHit = null;
                this.movingHit = null;
                this.finalHit = null;
                this.prepareHits();
                this.processFirstCoord(ev);
                if (this.initialHit || !this.requireInitial) {
                    dragging.setIgnoreMove(false);
                    this.emitter.trigger('pointerdown', ev);
                } else dragging.setIgnoreMove(true);
            };
            this.handleDragStart = (ev)=>{
                this.emitter.trigger('dragstart', ev);
                this.handleMove(ev, true);
            };
            this.handleDragMove = (ev)=>{
                this.emitter.trigger('dragmove', ev);
                this.handleMove(ev);
            };
            this.handlePointerUp = (ev)=>{
                this.releaseHits();
                this.emitter.trigger('pointerup', ev);
            };
            this.handleDragEnd = (ev)=>{
                if (this.movingHit) this.emitter.trigger('hitupdate', null, true, ev);
                this.finalHit = this.movingHit;
                this.movingHit = null;
                this.emitter.trigger('dragend', ev);
            };
            this.droppableStore = droppableStore;
            dragging.emitter.on('pointerdown', this.handlePointerDown);
            dragging.emitter.on('dragstart', this.handleDragStart);
            dragging.emitter.on('dragmove', this.handleDragMove);
            dragging.emitter.on('pointerup', this.handlePointerUp);
            dragging.emitter.on('dragend', this.handleDragEnd);
            this.dragging = dragging;
            this.emitter = new (0, (0, parcelRequire("Jd88K")).E)();
        }
        processFirstCoord(ev) {
            let origPoint = {
                left: ev.pageX,
                top: ev.pageY
            };
            let adjustedPoint = origPoint;
            let subjectEl = ev.subjectEl;
            let subjectRect;
            if (subjectEl instanceof HTMLElement) {
                subjectRect = (0, (0, parcelRequire("Jd88K")).b6)(subjectEl);
                adjustedPoint = (0, (0, parcelRequire("Jd88K")).aG)(adjustedPoint, subjectRect);
            }
            let initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
            if (initialHit) {
                if (this.useSubjectCenter && subjectRect) {
                    let slicedSubjectRect = (0, (0, parcelRequire("Jd88K")).aE)(subjectRect, initialHit.rect);
                    if (slicedSubjectRect) adjustedPoint = (0, (0, parcelRequire("Jd88K")).aH)(slicedSubjectRect);
                }
                this.coordAdjust = (0, (0, parcelRequire("Jd88K")).aI)(adjustedPoint, origPoint);
            } else this.coordAdjust = {
                left: 0,
                top: 0
            };
        }
        handleMove(ev, forceHandle) {
            let hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
            if (forceHandle || !$b6e28085a086a4ad$var$isHitsEqual(this.movingHit, hit)) {
                this.movingHit = hit;
                this.emitter.trigger('hitupdate', hit, false, ev);
            }
        }
        prepareHits() {
            this.offsetTrackers = (0, (0, parcelRequire("Jd88K")).a)(this.droppableStore, (interactionSettings)=>{
                interactionSettings.component.prepareHits();
                return new $b6e28085a086a4ad$var$OffsetTracker(interactionSettings.el);
            });
        }
        releaseHits() {
            let { offsetTrackers: offsetTrackers } = this;
            for(let id in offsetTrackers)offsetTrackers[id].destroy();
            this.offsetTrackers = {};
        }
        queryHitForOffset(offsetLeft, offsetTop) {
            let { droppableStore: droppableStore, offsetTrackers: offsetTrackers } = this;
            let bestHit = null;
            for(let id in droppableStore){
                let component = droppableStore[id].component;
                let offsetTracker = offsetTrackers[id];
                if (offsetTracker && offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                    let originLeft = offsetTracker.computeLeft();
                    let originTop = offsetTracker.computeTop();
                    let positionLeft = offsetLeft - originLeft;
                    let positionTop = offsetTop - originTop;
                    let { origRect: origRect } = offsetTracker;
                    let width = origRect.right - origRect.left;
                    let height = origRect.bottom - origRect.top;
                    if (positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                        let hit = component.queryHit(positionLeft, positionTop, width, height);
                        if (hit && (0, (0, parcelRequire("Jd88K")).b9)(hit.dateProfile.activeRange, hit.dateSpan.range) && (!bestHit || hit.layer > bestHit.layer)) {
                            hit.componentId = id;
                            hit.context = component.context;
                            hit.rect.left += originLeft;
                            hit.rect.right += originLeft;
                            hit.rect.top += originTop;
                            hit.rect.bottom += originTop;
                            bestHit = hit;
                        }
                    }
                }
            }
            return bestHit;
        }
    }
    function $b6e28085a086a4ad$var$isHitsEqual(hit0, hit1) {
        if (!hit0 && !hit1) return true;
        if (Boolean(hit0) !== Boolean(hit1)) return false;
        return (0, (0, parcelRequire("Jd88K")).bf)(hit0.dateSpan, hit1.dateSpan);
    }
    function $b6e28085a086a4ad$var$buildDatePointApiWithContext(dateSpan, context) {
        let props = {};
        for (let transform of context.pluginHooks.datePointTransforms)Object.assign(props, transform(dateSpan, context));
        Object.assign(props, $b6e28085a086a4ad$var$buildDatePointApi(dateSpan, context.dateEnv));
        return props;
    }
    function $b6e28085a086a4ad$var$buildDatePointApi(span, dateEnv) {
        return {
            date: dateEnv.toDate(span.range.start),
            dateStr: dateEnv.formatIso(span.range.start, {
                omitTime: span.allDay
            }),
            allDay: span.allDay
        };
    }
    class $b6e28085a086a4ad$var$DateClicking extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.handlePointerDown = (pev)=>{
                let { dragging: dragging } = this;
                let downEl = pev.origEvent.target;
                dragging.setIgnoreMove(!this.component.isValidDateDownEl(downEl));
            };
            this.handleDragEnd = (ev)=>{
                let { component: component } = this;
                let { pointer: pointer } = this.dragging;
                if (!pointer.wasTouchScroll) {
                    let { initialHit: initialHit, finalHit: finalHit } = this.hitDragging;
                    if (initialHit && finalHit && $b6e28085a086a4ad$var$isHitsEqual(initialHit, finalHit)) {
                        let { context: context } = component;
                        let arg = Object.assign(Object.assign({}, $b6e28085a086a4ad$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                            dayEl: initialHit.dayEl,
                            jsEvent: ev.origEvent,
                            view: context.viewApi || context.calendarApi.view
                        });
                        context.emitter.trigger('dateClick', arg);
                    }
                }
            };
            this.dragging = new $b6e28085a086a4ad$var$FeaturefulElementDragging(settings.el);
            this.dragging.autoScroller.isEnabled = false;
            let hitDragging = this.hitDragging = new $b6e28085a086a4ad$var$HitDragging(this.dragging, (0, (0, parcelRequire("Jd88K")).bG)(settings));
            hitDragging.emitter.on('pointerdown', this.handlePointerDown);
            hitDragging.emitter.on('dragend', this.handleDragEnd);
        }
        destroy() {
            this.dragging.destroy();
        }
    }
    class $b6e28085a086a4ad$var$DateSelecting extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.dragSelection = null;
            this.handlePointerDown = (ev)=>{
                let { component: component, dragging: dragging } = this;
                let { options: options } = component.context;
                let canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
                dragging.setIgnoreMove(!canSelect);
                dragging.delay = ev.isTouch ? $b6e28085a086a4ad$var$getComponentTouchDelay$1(component) : null;
            };
            this.handleDragStart = (ev)=>{
                this.component.context.calendarApi.unselect(ev);
            };
            this.handleHitUpdate = (hit, isFinal)=>{
                let { context: context } = this.component;
                let dragSelection = null;
                let isInvalid = false;
                if (hit) {
                    let initialHit = this.hitDragging.initialHit;
                    let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                    if (!disallowed) dragSelection = $b6e28085a086a4ad$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                    if (!dragSelection || !(0, (0, parcelRequire("Jd88K")).b_)(dragSelection, hit.dateProfile, context)) {
                        isInvalid = true;
                        dragSelection = null;
                    }
                }
                if (dragSelection) context.dispatch({
                    type: 'SELECT_DATES',
                    selection: dragSelection
                });
                else if (!isFinal) context.dispatch({
                    type: 'UNSELECT_DATES'
                });
                if (!isInvalid) (0, (0, parcelRequire("Jd88K")).aw)();
                else (0, (0, parcelRequire("Jd88K")).ax)();
                if (!isFinal) this.dragSelection = dragSelection;
            };
            this.handlePointerUp = (pev)=>{
                if (this.dragSelection) {
                    (0, (0, parcelRequire("Jd88K")).cu)(this.dragSelection, pev, this.component.context);
                    this.dragSelection = null;
                }
            };
            let { component: component } = settings;
            let { options: options } = component.context;
            let dragging = this.dragging = new $b6e28085a086a4ad$var$FeaturefulElementDragging(settings.el);
            dragging.touchScrollAllowed = false;
            dragging.minDistance = options.selectMinDistance || 0;
            dragging.autoScroller.isEnabled = options.dragScroll;
            let hitDragging = this.hitDragging = new $b6e28085a086a4ad$var$HitDragging(this.dragging, (0, (0, parcelRequire("Jd88K")).bG)(settings));
            hitDragging.emitter.on('pointerdown', this.handlePointerDown);
            hitDragging.emitter.on('dragstart', this.handleDragStart);
            hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
            hitDragging.emitter.on('pointerup', this.handlePointerUp);
        }
        destroy() {
            this.dragging.destroy();
        }
    }
    function $b6e28085a086a4ad$var$getComponentTouchDelay$1(component) {
        let { options: options } = component.context;
        let delay = options.selectLongPressDelay;
        if (delay == null) delay = options.longPressDelay;
        return delay;
    }
    function $b6e28085a086a4ad$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
        let dateSpan0 = hit0.dateSpan;
        let dateSpan1 = hit1.dateSpan;
        let ms = [
            dateSpan0.range.start,
            dateSpan0.range.end,
            dateSpan1.range.start,
            dateSpan1.range.end
        ];
        ms.sort((0, (0, parcelRequire("Jd88K")).av));
        let props = {};
        for (let transformer of dateSelectionTransformers){
            let res = transformer(hit0, hit1);
            if (res === false) return null;
            if (res) Object.assign(props, res);
        }
        props.range = {
            start: ms[0],
            end: ms[3]
        };
        props.allDay = dateSpan0.allDay;
        return props;
    }
    class $b6e28085a086a4ad$var$EventDragging extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.subjectEl = null;
            this.subjectSeg = null;
            this.isDragging = false;
            this.eventRange = null;
            this.relevantEvents = null;
            this.receivingContext = null;
            this.validMutation = null;
            this.mutatedRelevantEvents = null;
            this.handlePointerDown = (ev)=>{
                let origTarget = ev.origEvent.target;
                let { component: component, dragging: dragging } = this;
                let { mirror: mirror } = dragging;
                let { options: options } = component.context;
                let initialContext = component.context;
                this.subjectEl = ev.subjectEl;
                let subjectSeg = this.subjectSeg = (0, (0, parcelRequire("Jd88K"))._)(ev.subjectEl);
                let eventRange = this.eventRange = subjectSeg.eventRange;
                let eventInstanceId = eventRange.instance.instanceId;
                this.relevantEvents = (0, (0, parcelRequire("Jd88K")).aV)(initialContext.getCurrentData().eventStore, eventInstanceId);
                dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
                dragging.delay = ev.isTouch && eventInstanceId !== component.props.eventSelection ? $b6e28085a086a4ad$var$getComponentTouchDelay(component) : null;
                if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
                else mirror.parentNode = (0, (0, parcelRequire("Jd88K")).$)(origTarget, '.fc');
                mirror.revertDuration = options.dragRevertDuration;
                let isValid = component.isValidSegDownEl(origTarget) && !(0, (0, parcelRequire("Jd88K")).$)(origTarget, '.fc-event-resizer');
                dragging.setIgnoreMove(!isValid);
                this.isDragging = isValid && ev.subjectEl.classList.contains('fc-event-draggable');
            };
            this.handleDragStart = (ev)=>{
                let initialContext = this.component.context;
                let eventRange = this.eventRange;
                let eventInstanceId = eventRange.instance.instanceId;
                if (ev.isTouch) {
                    if (eventInstanceId !== this.component.props.eventSelection) initialContext.dispatch({
                        type: 'SELECT_EVENT',
                        eventInstanceId: eventInstanceId
                    });
                } else initialContext.dispatch({
                    type: 'UNSELECT_EVENT'
                });
                if (this.isDragging) {
                    initialContext.calendarApi.unselect(ev);
                    initialContext.emitter.trigger('eventDragStart', {
                        el: this.subjectEl,
                        event: new (0, (0, parcelRequire("Jd88K")).a0)(initialContext, eventRange.def, eventRange.instance),
                        jsEvent: ev.origEvent,
                        view: initialContext.viewApi
                    });
                }
            };
            this.handleHitUpdate = (hit, isFinal)=>{
                if (!this.isDragging) return;
                let relevantEvents = this.relevantEvents;
                let initialHit = this.hitDragging.initialHit;
                let initialContext = this.component.context;
                let receivingContext = null;
                let mutation = null;
                let mutatedRelevantEvents = null;
                let isInvalid = false;
                let interaction = {
                    affectedEvents: relevantEvents,
                    mutatedEvents: (0, (0, parcelRequire("Jd88K")).H)(),
                    isEvent: true
                };
                if (hit) {
                    receivingContext = hit.context;
                    let receivingOptions = receivingContext.options;
                    if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                        mutation = $b6e28085a086a4ad$var$computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                        if (mutation) {
                            mutatedRelevantEvents = (0, (0, parcelRequire("Jd88K")).bX)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                            interaction.mutatedEvents = mutatedRelevantEvents;
                            if (!(0, (0, parcelRequire("Jd88K")).bZ)(interaction, hit.dateProfile, receivingContext)) {
                                isInvalid = true;
                                mutation = null;
                                mutatedRelevantEvents = null;
                                interaction.mutatedEvents = (0, (0, parcelRequire("Jd88K")).H)();
                            }
                        }
                    } else receivingContext = null;
                }
                this.displayDrag(receivingContext, interaction);
                if (!isInvalid) (0, (0, parcelRequire("Jd88K")).aw)();
                else (0, (0, parcelRequire("Jd88K")).ax)();
                if (!isFinal) {
                    if (initialContext === receivingContext && $b6e28085a086a4ad$var$isHitsEqual(initialHit, hit)) mutation = null;
                    this.dragging.setMirrorNeedsRevert(!mutation);
                    this.dragging.setMirrorIsVisible(!hit || !this.subjectEl.getRootNode().querySelector('.fc-event-mirror'));
                    this.receivingContext = receivingContext;
                    this.validMutation = mutation;
                    this.mutatedRelevantEvents = mutatedRelevantEvents;
                }
            };
            this.handlePointerUp = ()=>{
                if (!this.isDragging) this.cleanup();
            };
            this.handleDragEnd = (ev)=>{
                if (this.isDragging) {
                    let initialContext = this.component.context;
                    let initialView = initialContext.viewApi;
                    let { receivingContext: receivingContext, validMutation: validMutation } = this;
                    let eventDef = this.eventRange.def;
                    let eventInstance = this.eventRange.instance;
                    let eventApi = new (0, (0, parcelRequire("Jd88K")).a0)(initialContext, eventDef, eventInstance);
                    let relevantEvents = this.relevantEvents;
                    let mutatedRelevantEvents = this.mutatedRelevantEvents;
                    let { finalHit: finalHit } = this.hitDragging;
                    this.clearDrag();
                    initialContext.emitter.trigger('eventDragStop', {
                        el: this.subjectEl,
                        event: eventApi,
                        jsEvent: ev.origEvent,
                        view: initialView
                    });
                    if (validMutation) {
                        if (receivingContext === initialContext) {
                            let updatedEventApi = new (0, (0, parcelRequire("Jd88K")).a0)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                            initialContext.dispatch({
                                type: 'MERGE_EVENTS',
                                eventStore: mutatedRelevantEvents
                            });
                            let eventChangeArg = {
                                oldEvent: eventApi,
                                event: updatedEventApi,
                                relatedEvents: (0, (0, parcelRequire("Jd88K")).v)(mutatedRelevantEvents, initialContext, eventInstance),
                                revert () {
                                    initialContext.dispatch({
                                        type: 'MERGE_EVENTS',
                                        eventStore: relevantEvents
                                    });
                                }
                            };
                            let transformed = {};
                            for (let transformer of initialContext.getCurrentData().pluginHooks.eventDropTransformers)Object.assign(transformed, transformer(validMutation, initialContext));
                            initialContext.emitter.trigger('eventDrop', Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                                el: ev.subjectEl,
                                delta: validMutation.datesDelta,
                                jsEvent: ev.origEvent,
                                view: initialView
                            }));
                            initialContext.emitter.trigger('eventChange', eventChangeArg);
                        } else if (receivingContext) {
                            let eventRemoveArg = {
                                event: eventApi,
                                relatedEvents: (0, (0, parcelRequire("Jd88K")).v)(relevantEvents, initialContext, eventInstance),
                                revert () {
                                    initialContext.dispatch({
                                        type: 'MERGE_EVENTS',
                                        eventStore: relevantEvents
                                    });
                                }
                            };
                            initialContext.emitter.trigger('eventLeave', Object.assign(Object.assign({}, eventRemoveArg), {
                                draggedEl: ev.subjectEl,
                                view: initialView
                            }));
                            initialContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: relevantEvents
                            });
                            initialContext.emitter.trigger('eventRemove', eventRemoveArg);
                            let addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                            let addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                            let addedEventApi = new (0, (0, parcelRequire("Jd88K")).a0)(receivingContext, addedEventDef, addedEventInstance);
                            receivingContext.dispatch({
                                type: 'MERGE_EVENTS',
                                eventStore: mutatedRelevantEvents
                            });
                            let eventAddArg = {
                                event: addedEventApi,
                                relatedEvents: (0, (0, parcelRequire("Jd88K")).v)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                                revert () {
                                    receivingContext.dispatch({
                                        type: 'REMOVE_EVENTS',
                                        eventStore: mutatedRelevantEvents
                                    });
                                }
                            };
                            receivingContext.emitter.trigger('eventAdd', eventAddArg);
                            if (ev.isTouch) receivingContext.dispatch({
                                type: 'SELECT_EVENT',
                                eventInstanceId: eventInstance.instanceId
                            });
                            receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $b6e28085a086a4ad$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                                draggedEl: ev.subjectEl,
                                jsEvent: ev.origEvent,
                                view: finalHit.context.viewApi
                            }));
                            receivingContext.emitter.trigger('eventReceive', Object.assign(Object.assign({}, eventAddArg), {
                                draggedEl: ev.subjectEl,
                                view: finalHit.context.viewApi
                            }));
                        }
                    } else initialContext.emitter.trigger('_noEventDrop');
                }
                this.cleanup();
            };
            let { component: component } = this;
            let { options: options } = component.context;
            let dragging = this.dragging = new $b6e28085a086a4ad$var$FeaturefulElementDragging(settings.el);
            dragging.pointer.selector = $b6e28085a086a4ad$var$EventDragging.SELECTOR;
            dragging.touchScrollAllowed = false;
            dragging.autoScroller.isEnabled = options.dragScroll;
            let hitDragging = this.hitDragging = new $b6e28085a086a4ad$var$HitDragging(this.dragging, (0, (0, parcelRequire("Jd88K")).a7));
            hitDragging.useSubjectCenter = settings.useEventCenter;
            hitDragging.emitter.on('pointerdown', this.handlePointerDown);
            hitDragging.emitter.on('dragstart', this.handleDragStart);
            hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
            hitDragging.emitter.on('pointerup', this.handlePointerUp);
            hitDragging.emitter.on('dragend', this.handleDragEnd);
        }
        destroy() {
            this.dragging.destroy();
        }
        displayDrag(nextContext, state) {
            let initialContext = this.component.context;
            let prevContext = this.receivingContext;
            if (prevContext && prevContext !== nextContext) {
                if (prevContext === initialContext) prevContext.dispatch({
                    type: 'SET_EVENT_DRAG',
                    state: {
                        affectedEvents: state.affectedEvents,
                        mutatedEvents: (0, (0, parcelRequire("Jd88K")).H)(),
                        isEvent: true
                    }
                });
                else prevContext.dispatch({
                    type: 'UNSET_EVENT_DRAG'
                });
            }
            if (nextContext) nextContext.dispatch({
                type: 'SET_EVENT_DRAG',
                state: state
            });
        }
        clearDrag() {
            let initialCalendar = this.component.context;
            let { receivingContext: receivingContext } = this;
            if (receivingContext) receivingContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
            if (initialCalendar !== receivingContext) initialCalendar.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
        }
        cleanup() {
            this.subjectSeg = null;
            this.isDragging = false;
            this.eventRange = null;
            this.relevantEvents = null;
            this.receivingContext = null;
            this.validMutation = null;
            this.mutatedRelevantEvents = null;
        }
    }
    $b6e28085a086a4ad$var$EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
    function $b6e28085a086a4ad$var$computeEventMutation(hit0, hit1, massagers) {
        let dateSpan0 = hit0.dateSpan;
        let dateSpan1 = hit1.dateSpan;
        let date0 = dateSpan0.range.start;
        let date1 = dateSpan1.range.start;
        let standardProps = {};
        if (dateSpan0.allDay !== dateSpan1.allDay) {
            standardProps.allDay = dateSpan1.allDay;
            standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
            if (dateSpan1.allDay) date0 = (0, (0, parcelRequire("Jd88K")).o)(date0);
        }
        let delta = (0, (0, parcelRequire("Jd88K")).aA)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
        if (delta.milliseconds) standardProps.allDay = false;
        let mutation = {
            datesDelta: delta,
            standardProps: standardProps
        };
        for (let massager of massagers)massager(mutation, hit0, hit1);
        return mutation;
    }
    function $b6e28085a086a4ad$var$getComponentTouchDelay(component) {
        let { options: options } = component.context;
        let delay = options.eventLongPressDelay;
        if (delay == null) delay = options.longPressDelay;
        return delay;
    }
    class $b6e28085a086a4ad$var$EventResizing extends (0, (0, parcelRequire("Jd88K")).Z) {
        constructor(settings){
            super(settings);
            this.draggingSegEl = null;
            this.draggingSeg = null;
            this.eventRange = null;
            this.relevantEvents = null;
            this.validMutation = null;
            this.mutatedRelevantEvents = null;
            this.handlePointerDown = (ev)=>{
                let { component: component } = this;
                let segEl = this.querySegEl(ev);
                let seg = (0, (0, parcelRequire("Jd88K"))._)(segEl);
                let eventRange = this.eventRange = seg.eventRange;
                this.dragging.minDistance = component.context.options.eventDragMinDistance;
                this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && this.component.props.eventSelection !== eventRange.instance.instanceId);
            };
            this.handleDragStart = (ev)=>{
                let { context: context } = this.component;
                let eventRange = this.eventRange;
                this.relevantEvents = (0, (0, parcelRequire("Jd88K")).aV)(context.getCurrentData().eventStore, this.eventRange.instance.instanceId);
                let segEl = this.querySegEl(ev);
                this.draggingSegEl = segEl;
                this.draggingSeg = (0, (0, parcelRequire("Jd88K"))._)(segEl);
                context.calendarApi.unselect();
                context.emitter.trigger('eventResizeStart', {
                    el: segEl,
                    event: new (0, (0, parcelRequire("Jd88K")).a0)(context, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                });
            };
            this.handleHitUpdate = (hit, isFinal, ev)=>{
                let { context: context } = this.component;
                let relevantEvents = this.relevantEvents;
                let initialHit = this.hitDragging.initialHit;
                let eventInstance = this.eventRange.instance;
                let mutation = null;
                let mutatedRelevantEvents = null;
                let isInvalid = false;
                let interaction = {
                    affectedEvents: relevantEvents,
                    mutatedEvents: (0, (0, parcelRequire("Jd88K")).H)(),
                    isEvent: true
                };
                if (hit) {
                    let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                    if (!disallowed) mutation = $b6e28085a086a4ad$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
                }
                if (mutation) {
                    mutatedRelevantEvents = (0, (0, parcelRequire("Jd88K")).bX)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                    interaction.mutatedEvents = mutatedRelevantEvents;
                    if (!(0, (0, parcelRequire("Jd88K")).bZ)(interaction, hit.dateProfile, context)) {
                        isInvalid = true;
                        mutation = null;
                        mutatedRelevantEvents = null;
                        interaction.mutatedEvents = null;
                    }
                }
                if (mutatedRelevantEvents) context.dispatch({
                    type: 'SET_EVENT_RESIZE',
                    state: interaction
                });
                else context.dispatch({
                    type: 'UNSET_EVENT_RESIZE'
                });
                if (!isInvalid) (0, (0, parcelRequire("Jd88K")).aw)();
                else (0, (0, parcelRequire("Jd88K")).ax)();
                if (!isFinal) {
                    if (mutation && $b6e28085a086a4ad$var$isHitsEqual(initialHit, hit)) mutation = null;
                    this.validMutation = mutation;
                    this.mutatedRelevantEvents = mutatedRelevantEvents;
                }
            };
            this.handleDragEnd = (ev)=>{
                let { context: context } = this.component;
                let eventDef = this.eventRange.def;
                let eventInstance = this.eventRange.instance;
                let eventApi = new (0, (0, parcelRequire("Jd88K")).a0)(context, eventDef, eventInstance);
                let relevantEvents = this.relevantEvents;
                let mutatedRelevantEvents = this.mutatedRelevantEvents;
                context.emitter.trigger('eventResizeStop', {
                    el: this.draggingSegEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                });
                if (this.validMutation) {
                    let updatedEventApi = new (0, (0, parcelRequire("Jd88K")).a0)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                    context.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: mutatedRelevantEvents
                    });
                    let eventChangeArg = {
                        oldEvent: eventApi,
                        event: updatedEventApi,
                        relatedEvents: (0, (0, parcelRequire("Jd88K")).v)(mutatedRelevantEvents, context, eventInstance),
                        revert () {
                            context.dispatch({
                                type: 'MERGE_EVENTS',
                                eventStore: relevantEvents
                            });
                        }
                    };
                    context.emitter.trigger('eventResize', Object.assign(Object.assign({}, eventChangeArg), {
                        el: this.draggingSegEl,
                        startDelta: this.validMutation.startDelta || (0, (0, parcelRequire("Jd88K")).d)(0),
                        endDelta: this.validMutation.endDelta || (0, (0, parcelRequire("Jd88K")).d)(0),
                        jsEvent: ev.origEvent,
                        view: context.viewApi
                    }));
                    context.emitter.trigger('eventChange', eventChangeArg);
                } else context.emitter.trigger('_noEventResize');
                this.draggingSeg = null;
                this.relevantEvents = null;
                this.validMutation = null;
            };
            let { component: component } = settings;
            let dragging = this.dragging = new $b6e28085a086a4ad$var$FeaturefulElementDragging(settings.el);
            dragging.pointer.selector = '.fc-event-resizer';
            dragging.touchScrollAllowed = false;
            dragging.autoScroller.isEnabled = component.context.options.dragScroll;
            let hitDragging = this.hitDragging = new $b6e28085a086a4ad$var$HitDragging(this.dragging, (0, (0, parcelRequire("Jd88K")).bG)(settings));
            hitDragging.emitter.on('pointerdown', this.handlePointerDown);
            hitDragging.emitter.on('dragstart', this.handleDragStart);
            hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
            hitDragging.emitter.on('dragend', this.handleDragEnd);
        }
        destroy() {
            this.dragging.destroy();
        }
        querySegEl(ev) {
            return (0, (0, parcelRequire("Jd88K")).$)(ev.subjectEl, '.fc-event');
        }
    }
    function $b6e28085a086a4ad$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
        let dateEnv = hit0.context.dateEnv;
        let date0 = hit0.dateSpan.range.start;
        let date1 = hit1.dateSpan.range.start;
        let delta = (0, (0, parcelRequire("Jd88K")).aA)(date0, date1, dateEnv, hit0.largeUnit);
        if (isFromStart) {
            if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
                startDelta: delta
            };
        } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
            endDelta: delta
        };
        return null;
    }
    class $b6e28085a086a4ad$var$UnselectAuto {
        constructor(context){
            this.context = context;
            this.isRecentPointerDateSelect = false;
            this.matchesCancel = false;
            this.matchesEvent = false;
            this.onSelect = (selectInfo)=>{
                if (selectInfo.jsEvent) this.isRecentPointerDateSelect = true;
            };
            this.onDocumentPointerDown = (pev)=>{
                let unselectCancel = this.context.options.unselectCancel;
                let downEl = (0, (0, parcelRequire("Jd88K")).aR)(pev.origEvent);
                this.matchesCancel = !!(0, (0, parcelRequire("Jd88K")).$)(downEl, unselectCancel);
                this.matchesEvent = !!(0, (0, parcelRequire("Jd88K")).$)(downEl, $b6e28085a086a4ad$var$EventDragging.SELECTOR);
            };
            this.onDocumentPointerUp = (pev)=>{
                let { context: context } = this;
                let { documentPointer: documentPointer } = this;
                let calendarState = context.getCurrentData();
                if (!documentPointer.wasTouchScroll) {
                    if (calendarState.dateSelection && !this.isRecentPointerDateSelect) {
                        let unselectAuto = context.options.unselectAuto;
                        if (unselectAuto && (!unselectAuto || !this.matchesCancel)) context.calendarApi.unselect(pev);
                    }
                    if (calendarState.eventSelection && !this.matchesEvent) context.dispatch({
                        type: 'UNSELECT_EVENT'
                    });
                }
                this.isRecentPointerDateSelect = false;
            };
            let documentPointer = this.documentPointer = new $b6e28085a086a4ad$var$PointerDragging(document);
            documentPointer.shouldIgnoreMove = true;
            documentPointer.shouldWatchScroll = false;
            documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
            documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
            context.emitter.on('select', this.onSelect);
        }
        destroy() {
            this.context.emitter.off('select', this.onSelect);
            this.documentPointer.destroy();
        }
    }
    const $b6e28085a086a4ad$var$OPTION_REFINERS = {
        fixedMirrorParent: (0, (0, parcelRequire("Jd88K")).l)
    };
    const $b6e28085a086a4ad$var$LISTENER_REFINERS = {
        dateClick: (0, (0, parcelRequire("Jd88K")).l),
        eventDragStart: (0, (0, parcelRequire("Jd88K")).l),
        eventDragStop: (0, (0, parcelRequire("Jd88K")).l),
        eventDrop: (0, (0, parcelRequire("Jd88K")).l),
        eventResizeStart: (0, (0, parcelRequire("Jd88K")).l),
        eventResizeStop: (0, (0, parcelRequire("Jd88K")).l),
        eventResize: (0, (0, parcelRequire("Jd88K")).l),
        drop: (0, (0, parcelRequire("Jd88K")).l),
        eventReceive: (0, (0, parcelRequire("Jd88K")).l),
        eventLeave: (0, (0, parcelRequire("Jd88K")).l)
    };
    class $b6e28085a086a4ad$var$ExternalElementDragging {
        constructor(dragging, suppliedDragMeta){
            this.receivingContext = null;
            this.droppableEvent = null;
            this.suppliedDragMeta = null;
            this.dragMeta = null;
            this.handleDragStart = (ev)=>{
                this.dragMeta = this.buildDragMeta(ev.subjectEl);
            };
            this.handleHitUpdate = (hit, isFinal, ev)=>{
                let { dragging: dragging } = this.hitDragging;
                let receivingContext = null;
                let droppableEvent = null;
                let isInvalid = false;
                let interaction = {
                    affectedEvents: (0, (0, parcelRequire("Jd88K")).H)(),
                    mutatedEvents: (0, (0, parcelRequire("Jd88K")).H)(),
                    isEvent: this.dragMeta.create
                };
                if (hit) {
                    receivingContext = hit.context;
                    if (this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                        droppableEvent = $b6e28085a086a4ad$var$computeEventForDateSpan(hit.dateSpan, this.dragMeta, receivingContext);
                        interaction.mutatedEvents = (0, (0, parcelRequire("Jd88K")).aW)(droppableEvent);
                        isInvalid = !(0, (0, parcelRequire("Jd88K")).bZ)(interaction, hit.dateProfile, receivingContext);
                        if (isInvalid) {
                            interaction.mutatedEvents = (0, (0, parcelRequire("Jd88K")).H)();
                            droppableEvent = null;
                        }
                    }
                }
                this.displayDrag(receivingContext, interaction);
                dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
                if (!isInvalid) (0, (0, parcelRequire("Jd88K")).aw)();
                else (0, (0, parcelRequire("Jd88K")).ax)();
                if (!isFinal) {
                    dragging.setMirrorNeedsRevert(!droppableEvent);
                    this.receivingContext = receivingContext;
                    this.droppableEvent = droppableEvent;
                }
            };
            this.handleDragEnd = (pev)=>{
                let { receivingContext: receivingContext, droppableEvent: droppableEvent } = this;
                this.clearDrag();
                if (receivingContext && droppableEvent) {
                    let finalHit = this.hitDragging.finalHit;
                    let finalView = finalHit.context.viewApi;
                    let dragMeta = this.dragMeta;
                    receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $b6e28085a086a4ad$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                        draggedEl: pev.subjectEl,
                        jsEvent: pev.origEvent,
                        view: finalView
                    }));
                    if (dragMeta.create) {
                        let addingEvents = (0, (0, parcelRequire("Jd88K")).aW)(droppableEvent);
                        receivingContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: addingEvents
                        });
                        if (pev.isTouch) receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: droppableEvent.instance.instanceId
                        });
                        receivingContext.emitter.trigger('eventReceive', {
                            event: new (0, (0, parcelRequire("Jd88K")).a0)(receivingContext, droppableEvent.def, droppableEvent.instance),
                            relatedEvents: [],
                            revert () {
                                receivingContext.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: addingEvents
                                });
                            },
                            draggedEl: pev.subjectEl,
                            view: finalView
                        });
                    }
                }
                this.receivingContext = null;
                this.droppableEvent = null;
            };
            let hitDragging = this.hitDragging = new $b6e28085a086a4ad$var$HitDragging(dragging, (0, (0, parcelRequire("Jd88K")).a7));
            hitDragging.requireInitial = false;
            hitDragging.emitter.on('dragstart', this.handleDragStart);
            hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
            hitDragging.emitter.on('dragend', this.handleDragEnd);
            this.suppliedDragMeta = suppliedDragMeta;
        }
        buildDragMeta(subjectEl) {
            if (typeof this.suppliedDragMeta === 'object') return (0, (0, parcelRequire("Jd88K")).bJ)(this.suppliedDragMeta);
            if (typeof this.suppliedDragMeta === 'function') return (0, (0, parcelRequire("Jd88K")).bJ)(this.suppliedDragMeta(subjectEl));
            return $b6e28085a086a4ad$var$getDragMetaFromEl(subjectEl);
        }
        displayDrag(nextContext, state) {
            let prevContext = this.receivingContext;
            if (prevContext && prevContext !== nextContext) prevContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
            if (nextContext) nextContext.dispatch({
                type: 'SET_EVENT_DRAG',
                state: state
            });
        }
        clearDrag() {
            if (this.receivingContext) this.receivingContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
        }
        canDropElOnCalendar(el, receivingContext) {
            let dropAccept = receivingContext.options.dropAccept;
            if (typeof dropAccept === 'function') return dropAccept.call(receivingContext.calendarApi, el);
            if (typeof dropAccept === 'string' && dropAccept) return Boolean((0, (0, parcelRequire("Jd88K")).aQ)(el, dropAccept));
            return true;
        }
    }
    function $b6e28085a086a4ad$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
        let defProps = Object.assign({}, dragMeta.leftoverProps);
        for (let transform of context.pluginHooks.externalDefTransforms)Object.assign(defProps, transform(dateSpan, dragMeta));
        let { refined: refined, extra: extra } = (0, (0, parcelRequire("Jd88K")).al)(defProps, context);
        let def = (0, (0, parcelRequire("Jd88K")).ak)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
        let start = dateSpan.range.start;
        if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
        let end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, (0, parcelRequire("Jd88K")).cv)(dateSpan.allDay, start, context);
        let instance = (0, (0, parcelRequire("Jd88K")).aj)(def.defId, {
            start: start,
            end: end
        });
        return {
            def: def,
            instance: instance
        };
    }
    function $b6e28085a086a4ad$var$getDragMetaFromEl(el) {
        let str = $b6e28085a086a4ad$var$getEmbeddedElData(el, 'event');
        let obj = str ? JSON.parse(str) : {
            create: false
        };
        return (0, (0, parcelRequire("Jd88K")).bJ)(obj);
    }
    (0, (0, parcelRequire("Jd88K")).bI).dataAttrPrefix = '';
    function $b6e28085a086a4ad$var$getEmbeddedElData(el, name) {
        let prefix = (0, (0, parcelRequire("Jd88K")).bI).dataAttrPrefix;
        let prefixedName = (prefix ? prefix + '-' : '') + name;
        return el.getAttribute('data-' + prefixedName) || '';
    }
    class $b6e28085a086a4ad$export$f2a139e5d18b9882 {
        constructor(el, settings = {}){
            this.handlePointerDown = (ev)=>{
                let { dragging: dragging } = this;
                let { minDistance: minDistance, longPressDelay: longPressDelay } = this.settings;
                dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, (0, parcelRequire("Jd88K")).B).eventDragMinDistance;
                dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, (0, parcelRequire("Jd88K")).B).longPressDelay : 0;
            };
            this.handleDragStart = (ev)=>{
                if (ev.isTouch && this.dragging.delay && ev.subjectEl.classList.contains('fc-event')) this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
            };
            this.settings = settings;
            let dragging = this.dragging = new $b6e28085a086a4ad$var$FeaturefulElementDragging(el);
            dragging.touchScrollAllowed = false;
            if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
            if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo;
            dragging.emitter.on('pointerdown', this.handlePointerDown);
            dragging.emitter.on('dragstart', this.handleDragStart);
            new $b6e28085a086a4ad$var$ExternalElementDragging(dragging, settings.eventData);
        }
        destroy() {
            this.dragging.destroy();
        }
    }
    class $b6e28085a086a4ad$var$InferredElementDragging extends (0, (0, parcelRequire("Jd88K")).bH) {
        constructor(containerEl){
            super(containerEl);
            this.shouldIgnoreMove = false;
            this.mirrorSelector = '';
            this.currentMirrorEl = null;
            this.handlePointerDown = (ev)=>{
                this.emitter.trigger('pointerdown', ev);
                if (!this.shouldIgnoreMove) this.emitter.trigger('dragstart', ev);
            };
            this.handlePointerMove = (ev)=>{
                if (!this.shouldIgnoreMove) this.emitter.trigger('dragmove', ev);
            };
            this.handlePointerUp = (ev)=>{
                this.emitter.trigger('pointerup', ev);
                if (!this.shouldIgnoreMove) this.emitter.trigger('dragend', ev);
            };
            let pointer = this.pointer = new $b6e28085a086a4ad$var$PointerDragging(containerEl);
            pointer.emitter.on('pointerdown', this.handlePointerDown);
            pointer.emitter.on('pointermove', this.handlePointerMove);
            pointer.emitter.on('pointerup', this.handlePointerUp);
        }
        destroy() {
            this.pointer.destroy();
        }
        setIgnoreMove(bool) {
            this.shouldIgnoreMove = bool;
        }
        setMirrorIsVisible(bool) {
            if (bool) {
                if (this.currentMirrorEl) {
                    this.currentMirrorEl.style.visibility = '';
                    this.currentMirrorEl = null;
                }
            } else {
                let mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
                if (mirrorEl) {
                    this.currentMirrorEl = mirrorEl;
                    mirrorEl.style.visibility = 'hidden';
                }
            }
        }
    }
    class $b6e28085a086a4ad$export$51e5e9a9728fcd8f {
        constructor(containerOrSettings, settings){
            let containerEl = document;
            if (containerOrSettings === document || containerOrSettings instanceof Element) {
                containerEl = containerOrSettings;
                settings = settings || {};
            } else settings = containerOrSettings || {};
            let dragging = this.dragging = new $b6e28085a086a4ad$var$InferredElementDragging(containerEl);
            if (typeof settings.itemSelector === 'string') dragging.pointer.selector = settings.itemSelector;
            else if (containerEl === document) dragging.pointer.selector = '[data-event]';
            if (typeof settings.mirrorSelector === 'string') dragging.mirrorSelector = settings.mirrorSelector;
            new $b6e28085a086a4ad$var$ExternalElementDragging(dragging, settings.eventData);
        }
        destroy() {
            this.dragging.destroy();
        }
    }
    var $b6e28085a086a4ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5nZSg")).createPlugin)({
        name: '@fullcalendar/interaction',
        componentInteractions: [
            $b6e28085a086a4ad$var$DateClicking,
            $b6e28085a086a4ad$var$DateSelecting,
            $b6e28085a086a4ad$var$EventDragging,
            $b6e28085a086a4ad$var$EventResizing
        ],
        calendarInteractions: [
            $b6e28085a086a4ad$var$UnselectAuto
        ],
        elementDraggingImpl: $b6e28085a086a4ad$var$FeaturefulElementDragging,
        optionRefiners: $b6e28085a086a4ad$var$OPTION_REFINERS,
        listenerRefiners: $b6e28085a086a4ad$var$LISTENER_REFINERS
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("bG3pQ", function(module, exports) {
    $parcel$export(module.exports, "openViewFromEmbed", ()=>$b6fc163d26910ed9$export$a29603f2eb9b6da6);
    const $b6fc163d26910ed9$export$a29603f2eb9b6da6 = (param)=>{
        const cleanUrl = window.location.href.replace('/embed', '');
        const currentUrl = new URL(cleanUrl);
        if (param != null) currentUrl.searchParams.append(param.key, param.value);
        window.open(currentUrl.href, '_blank');
    };
});
parcelRegister("e21nk", function(module, exports) {
    $parcel$export(module.exports, "BusinessDocumentTitle", ()=>$aa5670652f17dfc4$export$416064ba09d98e69);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $54qG5;
    const $aa5670652f17dfc4$export$416064ba09d98e69 = (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        });
    });
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("6sVa1", function(module, exports) {
    $parcel$export(module.exports, "GqlsRealtime", ()=>$c64a00289bd38048$export$ad092969d774a1ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Zr0i;
    var $cm8b5;
    var $heNNl;
    var $dXq4S;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $1T4FF;
    var $x3opw;
    var $8EXvJ;
    var $8hBpB;
    var $bGo96;
    const $c64a00289bd38048$export$ad092969d774a1ab = (0, $5uXOq.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, (0, parcelRequire("1T4FF")).DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const siteId = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        });
        const realtimeIds = (0, (0, parcelRequire("1Zr0i")).useRealtimeContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const createSubsExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const createSubsExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const createSubsExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const realtimeEventExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        const realtimeEventExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        const realtimeEventExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        createSubsExperienceStart();
        const extraEventDataRef = (0, $5uXOq.useRef)({
            appId: appId,
            entityId: entityId
        });
        extraEventDataRef.current.appId = appId;
        extraEventDataRef.current.entityId = entityId;
        const onReceiveRef = (0, $5uXOq.useRef)(onReceive);
        onReceiveRef.current = onReceive;
        const handleReceive = (0, $5uXOq.useCallback)((event)=>{
            realtimeEventExperienceStart();
            try {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                    ...extraEventDataRef.current,
                    realtimeEvent: event.type
                });
                onReceiveRef.current(event);
                realtimeEventExperienceSuccess({
                    realtimeEvent: event.type
                });
            } catch (error) {
                realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error, {
                    realtimeEvent: event.type
                });
            }
        }, [
            createAnalyticsEvent,
            realtimeEventExperienceStart,
            realtimeEventExperienceSuccess,
            realtimeEventExperienceFail
        ]);
        const handleReactError = (0, $5uXOq.useCallback)((_location, error, event)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
            createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
        }, [
            createAnalyticsEvent,
            createSubsExperienceFail
        ]);
        const handleSubscriptionError = (0, $5uXOq.useCallback)((errorMessage, operationName)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
                errorMessage: errorMessage,
                operationName: operationName,
                ...extraEventDataRef.current
            });
        }, [
            createAnalyticsEvent
        ]);
        const subscriptions = (0, $5uXOq.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGo96")).UpdateIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("x3opw")).CreateIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8EXvJ")).DeleteIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8hBpB")).FieldMutationSubscription), {
                    siteId: siteId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }))), [
            cloudId,
            siteId,
            realtimeIds,
            eventsToSubscribeTo,
            handleReceive,
            handleSubscriptionError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const realtimeEvents = {
                issueCreated: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT)),
                issueUpdated: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT)),
                issueDeleted: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT)),
                fieldMutation: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT))
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
                ...extraEventDataRef.current,
                ...realtimeEvents,
                subscriptions: realtimeIds.length * eventsToSubscribeTo.length
            });
            createSubsExperienceSuccess();
        }, [
            subscriptions,
            createAnalyticsEvent,
            realtimeIds,
            eventsToSubscribeTo,
            createSubsExperienceSuccess
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
            const extraEventData = extraEventDataRef.current;
            return ()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "gqlsRealtime",
            packageName: "jiraBusinessGqlsRealtime",
            extraEventData: extraEventDataRef.current,
            onError: handleReactError
        }, subscriptions);
    });
});
parcelRegister("1Zr0i", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$6a65786548fb921c$export$64d242981d970821);
    $parcel$export(module.exports, "useRealtimeContext", ()=>$6a65786548fb921c$export$f39c07717ad8c35b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6a65786548fb921c$var$RealtimeContext = (0, $5uXOq.createContext)([]);
    const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
        const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
            ids
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
            value: projectsIds
        }, children);
    };
    const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);
});
parcelRegister("1T4FF", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATED_EVENT", ()=>$ac829f3b425e0434$export$b22a14d5dac59664);
    $parcel$export(module.exports, "ISSUE_DELETED_EVENT", ()=>$ac829f3b425e0434$export$25fa37e5059c5a99);
    $parcel$export(module.exports, "ISSUE_UPDATED_EVENT", ()=>$ac829f3b425e0434$export$b22142e61b3fdbee);
    $parcel$export(module.exports, "FIELD_MUTATION_EVENT", ()=>$ac829f3b425e0434$export$eddbca92a5bee91f);
    $parcel$export(module.exports, "ISSUE_EVENTS", ()=>$ac829f3b425e0434$export$f01b4f4e297998a0);
    $parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", ()=>$ac829f3b425e0434$export$edc58098c8ddf4cb);
    $parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", ()=>$ac829f3b425e0434$export$75b82bac1ec985d9);
    $parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", ()=>$ac829f3b425e0434$export$245947dc0e8c134b);
    const $ac829f3b425e0434$export$b22a14d5dac59664 = 'avi:jira:created:issue';
    const $ac829f3b425e0434$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
    const $ac829f3b425e0434$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
    const $ac829f3b425e0434$export$eddbca92a5bee91f = 'avi:jira:field:updated';
    const $ac829f3b425e0434$export$f01b4f4e297998a0 = [
        $ac829f3b425e0434$export$b22a14d5dac59664,
        $ac829f3b425e0434$export$25fa37e5059c5a99,
        $ac829f3b425e0434$export$b22142e61b3fdbee
    ];
    const $ac829f3b425e0434$export$edc58098c8ddf4cb = $ac829f3b425e0434$export$f01b4f4e297998a0;
    const $ac829f3b425e0434$export$b8b9d90f9e5bd72b = 'jiraBusinessGqlsRealtime';
    const $ac829f3b425e0434$export$75b82bac1ec985d9 = {
        experience: 'createSubscriptions',
        packageName: $ac829f3b425e0434$export$b8b9d90f9e5bd72b,
        teamName: 'jira-warepil'
    };
    const $ac829f3b425e0434$export$245947dc0e8c134b = {
        experience: 'realtimeEvent',
        packageName: $ac829f3b425e0434$export$b8b9d90f9e5bd72b,
        teamName: 'jira-warepil'
    };
});
parcelRegister("x3opw", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueSubscription", ()=>$04c21e90a72c6b66$export$7876efe7a86fd4f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $04c21e90a72c6b66$var$operationName = 'JwmIssueCreatedSubscription';
    const $04c21e90a72c6b66$export$7876efe7a86fd4f1 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $d3fb5f72d359d914$export$89cddb5ca4c806e4),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $04c21e90a72c6b66$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $04c21e90a72c6b66$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueCreatedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT),
                        payload: payload
                    });
                }
            }
        });
        return null;
    });
});
parcelRegister("WnsY2", function(module, exports) {
    $parcel$export(module.exports, "useSubscribe", ()=>$292b86c5ae12bc26$export$d3d523392640272);
    var $5uXOq = parcelRequire("5uXOq");
    var $laTox;
    var $jcw0u;
    var $cfDZ3;
    var $lWhTC;
    var $hoQbP;
    var $1Uhm6;
    const $292b86c5ae12bc26$var$noop = ()=>{};
    const $292b86c5ae12bc26$var$subscribe = (payload, sink)=>{
        const client = (0, (0, parcelRequire("lWhTC")).getClient)();
        if (!client) return;
        const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
        const { next: next, error: error, complete: complete = $292b86c5ae12bc26$var$noop } = sink;
        let requestId;
        return client.subscribe({
            query: query,
            variables: variables,
            operationName: operationName,
            extensions: {
                ...extensions ?? {}
            }
        }, {
            next: (value)=>{
                const aggRequestId = value?.extensions?.agg?.request_id;
                if (aggRequestId) requestId = aggRequestId;
                next(value);
            },
            complete: complete,
            error: (sinkError)=>{
                const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                };
                error?.(errorInfo, attributes);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraGraphqlSubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    };
    const $292b86c5ae12bc26$export$d3d523392640272 = (payload, sink)=>{
        (0, $5uXOq.useEffect)(()=>{
            let unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
            let timeout;
            const onVisibilityChange = ()=>{
                if ((0, (0, parcelRequire("laTox")).isPageVisible)()) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = undefined;
                    } else unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
                } else if (!timeout) timeout = setTimeout(()=>{
                    unsubscribe?.();
                    unsubscribe = undefined;
                    timeout = undefined;
                }, (0, $37d1b046897e548f$export$1ad8434180c5936c));
            };
            if (!(0, (0, parcelRequire("hoQbP")).isSSR)()) window.addEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChange);
            return ()=>{
                window.removeEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChange);
                unsubscribe?.();
            };
        }, [
            payload,
            sink
        ]);
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("3qoA4", function(module, exports) {
    $parcel$export(module.exports, "isIssueEvent", ()=>$ca6633b6fecadea7$export$734ba008b9d9e61c);
    $parcel$export(module.exports, "getResponseError", ()=>$ca6633b6fecadea7$export$135f2bf83a3d73b1);
    var $1T4FF;
    const $ca6633b6fecadea7$export$734ba008b9d9e61c = (event)=>(0, (0, parcelRequire("1T4FF")).ISSUE_EVENTS).includes(event.type);
    const $ca6633b6fecadea7$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;
});
const $d3fb5f72d359d914$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;
parcelRegister("8EXvJ", function(module, exports) {
    $parcel$export(module.exports, "DeleteIssueSubscription", ()=>$642754f18ab6266b$export$cba4fc39801f6792);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $dXq4S;
    var $1T4FF;
    var $3qoA4;
    const $642754f18ab6266b$var$operationName = 'JwmIssueDeletedSubscription';
    const $642754f18ab6266b$export$cba4fc39801f6792 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $36128e87a5f55340$export$9c299c317f46fdc4),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $642754f18ab6266b$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $642754f18ab6266b$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueDeletedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT),
                        payload: {
                            ...payload,
                            issueId: (0, (0, parcelRequire("dXq4S")).getAriConfig)(payload.resource).resourceId
                        }
                    });
                }
            }
        });
        return null;
    });
});
const $36128e87a5f55340$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        resource
      }
    }
  }
`;
parcelRegister("8hBpB", function(module, exports) {
    $parcel$export(module.exports, "FieldMutationSubscription", ()=>$4521bfd09c42e07c$export$d82ea923ea48fa52);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $4521bfd09c42e07c$var$operationName = 'JwmFieldMutationSubscription';
    const $4521bfd09c42e07c$export$d82ea923ea48fa52 = (0, $5uXOq.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $0831eb0e06b13614$export$2e75a8174f7cddb8),
            operationName: $4521bfd09c42e07c$var$operationName,
            variables: {
                siteId: siteId
            }
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $4521bfd09c42e07c$var$operationName);
                else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                    type: (0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT),
                    payload: {}
                });
            }
        });
        return null;
    });
});
const $0831eb0e06b13614$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;
parcelRegister("bGo96", function(module, exports) {
    $parcel$export(module.exports, "UpdateIssueSubscription", ()=>$0971ff6ea0a776a8$export$51fac6481c0b4595);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $0971ff6ea0a776a8$var$operationName = 'JwmIssueUpdatedSubscription';
    const $0971ff6ea0a776a8$export$51fac6481c0b4595 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $fabb0a5a91b2db55$export$54c41e3133084b81),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $0971ff6ea0a776a8$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $0971ff6ea0a776a8$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueUpdatedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT),
                        payload: payload
                    });
                }
            }
        });
        return null;
    });
});
const $fabb0a5a91b2db55$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;
parcelRegister("3kVj2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9988a92625a64f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $hE5wF;
    var $2gCtH;
    var $gjEtj;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $l8ruj;
    var $kxZPA;
    var $ieDtd;
    const $e9988a92625a64f1$export$843a6e93936e3b60 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("apmLb")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
    });
    const $e9988a92625a64f1$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $fcf97b7a09088940$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
        const [, setSelectedIssue] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
            setSelectedIssue
        ]);
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setSidebarContent(null);
            setDetailViewAsSidebar();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const viewModeOptions = (0, $5uXOq.useMemo)(()=>!viewModeSwitchDisabled ? {
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            } : undefined, [
            onSwitchToModal,
            onSwitchToSidebar,
            viewModeSwitchDisabled
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-modal-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            packageName: isSoftwareProject ? 'software' : 'business',
            id: "issue-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "modal-issue-app",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e9988a92625a64f1$export$843a6e93936e3b60, {
            analyticsSource: analyticsSource,
            issueKey: issueKey,
            onClose: onClose,
            onChange: onChange,
            onIssueDeleteSuccess: onDeleteSuccess,
            onIssueKeyChange: onIssueKeyChange,
            viewModeOptions: viewModeOptions
        })))));
    };
    var $e9988a92625a64f1$export$2e2bcd8739ae039 = $e9988a92625a64f1$var$ModalIssueAppWrapper;
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
parcelRegister("apmLb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8SBrF")
    ]).then(()=>parcelRequire('2555l'));
});
parcelRegister("ksKCJ", function(module, exports) {
    $parcel$export(module.exports, "SidebarIssueView", ()=>$15a07712b759f270$export$ccdf533f42a8d6f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bUSNl;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $cZ5o7;
    var $2ax5r;
    const $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
    const $15a07712b759f270$var$callWhenIdle = (callback)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
        else setTimeout(callback, 3000);
    };
    const $15a07712b759f270$export$ccdf533f42a8d6f8 = (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
        const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, (0, parcelRequire("2ax5r")).useSetSidebarStyleVar)();
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            onClose();
        }, [
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (issueKey === prevIssueKey && !!content) return;
            if (issueKey) {
                const newContent = (0, ($parcel$interopDefault($5uXOq))).createElement($15a07712b759f270$var$CSSAntiCorruptionLayer, {
                    key: $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ5o7")).SidebarIssueApp), {
                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey),
                    onClose: onCloseSidebar,
                    analyticsSource: analyticsSource,
                    onChange: onChange,
                    onIssueDeleteSuccess: onIssueDeleteSuccess,
                    isSoftwareProject: isSoftwareProject
                }));
                setSidebarContent(newContent);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
            } else {
                if (content?.key === $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
            }
        }, [
            analyticsSource,
            content,
            createAnalyticsEvent,
            isSoftwareProject,
            issueKey,
            onChange,
            onCloseSidebar,
            onIssueDeleteSuccess,
            prevIssueKey,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $15a07712b759f270$var$callWhenIdle(()=>{
                (0, (0, parcelRequire("cZ5o7")).IssueApp).preload();
            });
        }, []);
        return null;
    });
    const $15a07712b759f270$var$CSSAntiCorruptionLayer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cZ5o7", function(module, exports) {
    $parcel$export(module.exports, "IssueApp", ()=>$f0984329e6d3d9e6$export$35dd9ab573b87c3f);
    $parcel$export(module.exports, "SidebarIssueApp", ()=>$f0984329e6d3d9e6$export$e402f7c18d4d7f37);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bUSNl;
    var $2gCtH;
    var $7eqRV;
    var $lfTZh;
    var $1XJ20;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $c65JB;
    var $l8ruj;
    var $kxZPA;
    const $f0984329e6d3d9e6$export$35dd9ab573b87c3f = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jO7eF")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $f0984329e6d3d9e6$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
        const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
            setCurrentIssueKey(nextIssueKey);
        }, []);
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        (0, $5uXOq.useEffect)(()=>{
            if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
        }, [
            currentIssueKey,
            issueKey,
            prevIssueKey
        ]);
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsSidebar();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const PACKAGE_NAME = (0, $5uXOq.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
            isSoftwareProject
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-sidebar-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-app",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7eqRV")).IssueBoundary), {
            packageName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0984329e6d3d9e6$export$35dd9ab573b87c3f, {
            viewModeOptions: {
                viewMode: 'SIDEBAR',
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            },
            issueKey: currentIssueKey,
            analyticsSource: analyticsSource,
            shouldShowCloseButton: true,
            onClose: onClose,
            onIssueKeyChange: onIssueKeyChange,
            shouldSetInitialFocus: true,
            shouldShowRootProjectsBreadcrumb: true,
            onIssueDeleteSuccess: onIssueDeleteSuccess,
            onIssueDeleteFailure: (0, ($parcel$interopDefault($8Rkzz))),
            isSpaEnabled: false,
            isLoadedWithPage: false,
            onChange: onChange
        })))));
    };
});
parcelRegister("7eqRV", function(module, exports) {
    $parcel$export(module.exports, "IssueBoundary", ()=>$e3c8771effba3477$export$fbf48ede0cf52b5a);
    $parcel$export(module.exports, "IssueModalBoundary", ()=>$e3c8771effba3477$export$74d408982642a541);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $gjEtj;
    var $lfTZh;
    var $c65JB;
    const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isEmbedView: isEmbedView
            })
        }, children));
    const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "issue-modal",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-modal-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isModalView: true
            })
        }, children));
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("2ax5r", function(module, exports) {
    $parcel$export(module.exports, "useSetSidebarStyleVar", ()=>$f33586d1e0f68dde$export$70b20cd72362e39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $5e5zm;
    const $f33586d1e0f68dde$var$MARGIN = 24;
    const $f33586d1e0f68dde$export$70b20cd72362e39d = ()=>{
        const [{ content: content, sidebarWidth: sidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { setWidth: setWidth } = (0, (0, parcelRequire("5e5zm")).useDetailPanelActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (content !== null) {
                document.documentElement?.style.setProperty((0, $563deb1efef5771e$export$c83c5cba188418d8), `${sidebarWidth}px`);
                setWidth(sidebarWidth + $f33586d1e0f68dde$var$MARGIN);
            } else document.documentElement?.style.removeProperty((0, $563deb1efef5771e$export$c83c5cba188418d8));
            return ()=>{
                setWidth(0);
            };
        }, [
            content,
            setWidth,
            sidebarWidth
        ]);
    };
});
const $563deb1efef5771e$export$c83c5cba188418d8 = '--detailPanelWidth';
parcelRegister("kzL7M", function(module, exports) {
    $parcel$export(module.exports, "PageVisibility", ()=>$598dc46c30d3c9ff$export$ddb3b5bf3df25efc);
    var $5uXOq = parcelRequire("5uXOq");
    var $laWvb;
    var $laTox;
    const $598dc46c30d3c9ff$export$e39301eefbc90236 = 500;
    const $598dc46c30d3c9ff$export$ddb3b5bf3df25efc = ({ onChange: onChange })=>{
        const [onVisibilityChangeDebounced] = (0, (0, parcelRequire("laWvb")).default)(()=>{
            onChange({
                isVisible: (0, (0, parcelRequire("laTox")).isPageVisible)()
            });
        }, $598dc46c30d3c9ff$export$e39301eefbc90236);
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChangeDebounced);
            return ()=>{
                window.removeEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChangeDebounced);
            };
        }, [
            onVisibilityChangeDebounced
        ]);
        return null;
    };
});
parcelRegister("8HvEs", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAnalytics", ()=>$0eced7986dcab954$export$ec3c3b39c046a620);
    var $5uXOq = parcelRequire("5uXOq");
    var $fNobW;
    var $2nbdU;
    var $3vR0I;
    var $7Wnap;
    const $0eced7986dcab954$export$ec3c3b39c046a620 = (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
        const loadingRef = (0, $5uXOq.useRef)(loading);
        loadingRef.current = loading;
        if (loading === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "performance-analytics-loading"
        });
        const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
        const product = view.startsWith('software') ? 'jsw' : 'jwm';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).PageLoadMetrics), {
            view: view,
            attributes: attributes,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3vR0I")).FirstInteractionMetric), {
            view: view,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nbdU")).default), {
            viewId: `${product}.${view}`,
            scrollElement: scrollElement,
            itemsCount: itemsCount,
            attributes: attributes
        }));
    });
});
parcelRegister("2nbdU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$551da07557368f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
    const $551da07557368f71$export$46962be62755f053 = (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const samplingCount = (0, $5uXOq.useRef)(0);
        const frames = (0, $5uXOq.useRef)(0);
        const rafId = (0, $5uXOq.useRef)(null);
        const start = (0, $5uXOq.useRef)(0);
        (0, $5uXOq.useEffect)(()=>{
            const container = scrollElement ?? document;
            const hasScrollCapture = true;
            const tick = ()=>{
                if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                    frames.current += 1;
                    rafId.current = requestAnimationFrame(tick);
                } else {
                    const stopTime = performance.now();
                    const elapsedMs = stopTime - start.current;
                    const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                    const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                    frames.current = 0;
                    const attr = {
                        ...attributes || {},
                        itemsCount: itemsCount,
                        avgFrameDuration: avgFrameDuration,
                        fps: fps
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
                }
            };
            const handleOnScroll = ()=>{
                samplingCount.current += 1;
                if (samplingCount.current !== samplingRate) return;
                samplingCount.current = 0;
                start.current = performance.now();
                tick();
            };
            container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
                if (rafId.current) cancelAnimationFrame(rafId.current);
            };
        }, [
            scrollElement,
            createAnalyticsEvent,
            itemsCount,
            samplingRate,
            viewId,
            attributes
        ]);
        return null;
    });
    var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;
});
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;
parcelRegister("3vR0I", function(module, exports) {
    $parcel$export(module.exports, "FirstInteractionMetric", ()=>$43e497a79074b7d0$export$70b569bf2edd0b7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
            const hasScrollCapture = true;
            const startTime = performance.now();
            const handleFirstClick = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('click', handleFirstClick);
            };
            const handleFirstScroll = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
            container.addEventListener('click', handleFirstClick);
            container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('click', handleFirstClick);
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
        }, [
            createAnalyticsEvent,
            view,
            product
        ]);
        return null;
    };
});
parcelRegister("7Wnap", function(module, exports) {
    $parcel$export(module.exports, "RenderStartMark", ()=>$4c177752bab6a832$export$2128f295d6adb861);
    $parcel$export(module.exports, "PageLoadMetrics", ()=>$4c177752bab6a832$export$66b33c055cbb625e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    var $gN11a;
    const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
        if (loading === true) return null;
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
        return null;
    };
    const $4c177752bab6a832$export$66b33c055cbb625e = (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
        const metric = (0, (0, parcelRequire("gN11a")).pageLoadMetrics)[view];
        return metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: `${product}.${view}`,
            metric: metric,
            extra: attributes
        });
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("kI8fv", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$97dc17209ae59841$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $97dc17209ae59841$export$683480f191c0e3ea = (element, callback)=>{
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (element && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(element);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            element,
            callback
        ]);
        return null;
    };
});
parcelRegister("7yduy", function(module, exports) {
    $parcel$export(module.exports, "JWMSpaStatePageReady", ()=>$150b436063f0aaae$export$d54524c142a057f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZw8H;
    const $150b436063f0aaae$export$d54524c142a057f = ()=>{
        const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            let id = window.requestAnimationFrame(()=>{
                id = window.requestAnimationFrame(()=>{
                    setIsReady(true);
                });
            });
            return ()=>{
                window.cancelAnimationFrame(id);
            };
        }, []);
        if (!isReady) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null);
    };
});
parcelRegister("467lJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc639d9ac2372482$export$2e2bcd8739ae039);
    var $8BkAH;
    var $8hiuq;
    var $l7mS2;
    var $5jDRa;
    var $dc639d9ac2372482$export$2e2bcd8739ae039 = {
        forbidden: (0, parcelRequire("8BkAH")).default,
        genericError: (0, parcelRequire("8hiuq")).default,
        serverError: (0, parcelRequire("l7mS2")).default,
        unauthorized: (0, parcelRequire("5jDRa")).default
    };
});
parcelRegister("8BkAH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47acdb71562a5159$export$2e2bcd8739ae039);
    var $7VHMR;
    const $47acdb71562a5159$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.forbidden.title",
            "defaultMessage": "You don't have permission to do that"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.forbidden.description",
            "defaultMessage": "Ask your Jira admin for help."
        }
    });
    var $47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $47acdb71562a5159$var$messages.title,
            description: $47acdb71562a5159$var$messages.description
        });
});
parcelRegister("8hiuq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffd4533bf12eb3f1$export$2e2bcd8739ae039);
    var $7VHMR;
    const $ffd4533bf12eb3f1$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.generic-error.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.generic-error.description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
    var $ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $ffd4533bf12eb3f1$var$messages.title,
            description: $ffd4533bf12eb3f1$var$messages.description
        });
});
parcelRegister("l7mS2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31a915dd4c1d2142$export$2e2bcd8739ae039);
    var $7VHMR;
    const $31a915dd4c1d2142$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.server-error.title",
            "defaultMessage": "We're having some trouble"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.server-error.description",
            "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
        }
    });
    var $31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $31a915dd4c1d2142$var$messages.title,
            description: $31a915dd4c1d2142$var$messages.description
        });
});
parcelRegister("5jDRa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8754751d720d57d4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8754751d720d57d4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.unauthorized.title",
            "defaultMessage": "You're logged out"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.unauthorized.description",
            "defaultMessage": "Log back in and try again."
        }
    });
    var $8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $8754751d720d57d4$var$messages.title,
            description: $8754751d720d57d4$var$messages.description
        });
});
parcelRegister("LJaTB", function(module, exports) {
    $parcel$export(module.exports, "FlagRenderer", ()=>$2de6889b93863972$export$7c38ebd1f7ca6a5a);
    var $hkhmi;
    var $34Vv8;
    const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("hkhmi")).default));
});
parcelRegister("hkhmi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2971dd786c0add8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHfPB;
    class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { flagService: flagService, flag: flag } = this.props;
            if (flagService) this.flagId = flagService.showFlag(flag);
        }
        componentWillUnmount() {
            const { flagService: flagService } = this.props;
            if (flagService && this.flagId) flagService.dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(this.flagId));
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4kK95", function(module, exports) {
    $parcel$export(module.exports, "DateOnly", ()=>$a1048e23edd181e2$export$988b361b394263b6);
    $parcel$export(module.exports, "toDateOnly", ()=>$a1048e23edd181e2$export$b0961ad8aee63b8b);
    const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
    const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    const $a1048e23edd181e2$var$daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
        if ([
            year,
            month,
            day
        ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
        if (year < 0) return false;
        if (month < 1 || month > 12) return false;
        if (day < 1) return false;
        if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
        return true;
    };
    const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
    class $a1048e23edd181e2$export$988b361b394263b6 {
        static isISODateString(dateString) {
            try {
                $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
            } catch (e) {
                if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
                throw e;
            }
            return true;
        }
        static fromISODateString(dateString) {
            const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
            if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            const [, year, month, day] = matches;
            return new $a1048e23edd181e2$export$988b361b394263b6(...[
                year,
                month,
                day
            ].map((s)=>Number.parseInt(s, 10)));
        }
        static fromDateAccordingToLocalTime(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
        static fromDateAccordingToUTC(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        }
        static compare(a, b) {
            if (a.year === b.year) {
                if (a.month === b.month) {
                    if (a.day === b.day) return 0;
                    return a.day < b.day ? -1 : 1;
                }
                return a.month < b.month ? -1 : 1;
            }
            return a.year < b.year ? -1 : 1;
        }
        constructor(year, month, day){
            if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            this.year = year;
            this.month = month;
            this.day = day;
        }
        getYear() {
            return this.year;
        }
        getMonth() {
            return this.month;
        }
        getDay() {
            return this.day;
        }
        toISOString() {
            return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
        }
        toUTCDate() {
            return new Date(Date.UTC(this.year, this.month - 1, this.day));
        }
        toLocalDate() {
            const localDate = new Date();
            const currentMonth = localDate.getMonth();
            localDate.setFullYear(this.year);
            localDate.setHours(0);
            localDate.setMinutes(0);
            localDate.setSeconds(0);
            localDate.setMilliseconds(0);
            localDate.setDate(this.day);
            if (localDate.getMonth() !== currentMonth) {
                localDate.setMonth(this.month - 1);
                localDate.setDate(this.day);
            } else localDate.setMonth(this.month - 1);
            return localDate;
        }
        equals(dateOnly) {
            return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
        }
    }
    const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("9BwsJ", function(module, exports) {
    $parcel$export(module.exports, "useReleaseFlyoutUFOExperienceContext", ()=>$afeff55d68f38da1$export$92bb45d6cb76f856);
    $parcel$export(module.exports, "ReleaseFlyoutUFOContextProvider", ()=>$afeff55d68f38da1$export$e899799198712d11);
    var $5uXOq = parcelRequire("5uXOq");
    const $afeff55d68f38da1$export$be2189340abbfede = 'UNKNOWN';
    const $afeff55d68f38da1$var$defaultUFOContext = {
        location: $afeff55d68f38da1$export$be2189340abbfede,
        suffixKey: $afeff55d68f38da1$export$be2189340abbfede
    };
    const $afeff55d68f38da1$var$ReleaseFlyoutUFOContext = (0, $5uXOq.createContext)($afeff55d68f38da1$var$defaultUFOContext);
    const $afeff55d68f38da1$export$92bb45d6cb76f856 = ()=>(0, $5uXOq.useContext)($afeff55d68f38da1$var$ReleaseFlyoutUFOContext);
    const $afeff55d68f38da1$export$e899799198712d11 = (0, $5uXOq.memo)(({ children: children, ...props })=>{
        const context = (0, $5uXOq.useMemo)(()=>({
                ...$afeff55d68f38da1$var$defaultUFOContext,
                ...props
            }), [
            props
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($afeff55d68f38da1$var$ReleaseFlyoutUFOContext.Provider, {
            value: context
        }, children);
    });
});
parcelRegister("3t5QD", function(module, exports) {
    $parcel$export(module.exports, "ConditionalNudgeWrapper", ()=>$44a5067dcee1bfd9$export$56d544c4f479b7fb);
    var $5uXOq = parcelRequire("5uXOq");
    const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
        if (conditionsToApplyWrapper && !false && children !== null && children !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("2Qe3m", function(module, exports) {
    $parcel$export(module.exports, "AddItemsCalendarNudgeAsync", ()=>$383f06d24bc67a81$export$51cf9fa6568e150c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $383f06d24bc67a81$var$AddItemsCalendarNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iDyXx")).then((exportedModule)=>exportedModule.AddItemsCalendarNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-calendar-and-timeline-nudge-tour/add-items-calendar/index.tsx"
    });
    const $383f06d24bc67a81$export$51cf9fa6568e150c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$df53a339af97f102),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$69aca8ebee0d34c8)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "trello-crossflow-add-items-calendar-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($383f06d24bc67a81$var$AddItemsCalendarNudgeLazy, null, children)));
    $383f06d24bc67a81$export$51cf9fa6568e150c.displayName = 'AddItemsCalendarNudgeAsync';
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("iDyXx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gsG6J").then(()=>parcelRequire('7juNJ'));
});
parcelRegister("4O2fF", function(module, exports) {
    $parcel$export(module.exports, "AddItemsCalendarNudgeAsync", ()=>$97358a3383b40c4d$export$51cf9fa6568e150c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $97358a3383b40c4d$var$AddItemsCalendarNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fTU3M")).then((exportedModule)=>exportedModule.AddItemsCalendarNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-calendar-nudge-tour/add-items-calendar/index.tsx"
    });
    const $97358a3383b40c4d$export$51cf9fa6568e150c = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$fb9c6e63a7490968),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-items-calendar-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97358a3383b40c4d$var$AddItemsCalendarNudgeLazy, null, children)));
    $97358a3383b40c4d$export$51cf9fa6568e150c.displayName = 'AddItemsCalendarNudgeAsync';
});
parcelRegister("fTU3M", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("SOGzD").then(()=>parcelRequire('6tWf0'));
});
parcelRegister("65zj8", function(module, exports) {
    $parcel$export(module.exports, "useCalendarReleasesForMultipleProjectsInitializer", ()=>$3ab4b6b3d8178a08$export$6043efe7205d8fa2);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $4Pf62;
    var $pa9q9;
    var $5cvFd;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    var $hqBSi;
    var $3RCti;
    var $a4LjM;
    var $kfKf8;
    var $cb8h6;
    var $i0jvn;
    const $3ab4b6b3d8178a08$var$defaultCalendarReleasesState = {
        releases: [],
        isLoading: false,
        error: null,
        connectedProjects: []
    };
    const $3ab4b6b3d8178a08$var$CalendarReleasesInternal = (0, $5uXOq.memo)(({ releaseDateBefore: releaseDateBefore, releaseDateAfter: releaseDateAfter, projectId: projectId, releasesDataDispatch: releasesDataDispatch })=>{
        const { connectedProjects: connectedProjects, error: initConnectedProjectError } = (0, (0, parcelRequire("3RCti")).useGetConnectedProjects)(projectId);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { fetchReleases: fetchReleases } = (0, (0, parcelRequire("5cvFd")).useFetchReleases)();
        const [hideSoftwareRelease] = (0, (0, parcelRequire("a4LjM")).useHideSoftwareRelease)();
        (0, $5uXOq.useEffect)(()=>{
            releasesDataDispatch({
                type: (0, $1b23561ab4bb345a$export$eb2216992bc2d237)
            });
            (0, (0, parcelRequire("kfKf8")).loadSoftwareReleasesExperience).start();
        }, [
            releasesDataDispatch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (initConnectedProjectError) {
                const location = 'Did not fetch releases due to failing to fetch the connected project(s)';
                (0, (0, parcelRequire("kfKf8")).loadSoftwareReleasesExperience).failure({
                    metadata: {
                        location: location,
                        error: initConnectedProjectError.message
                    }
                });
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("cb8h6")).default).fetchReleasesErrorTitle,
                    description: (0, (0, parcelRequire("cb8h6")).default).fetchReleasesErrorMessage
                });
            }
        }, [
            initConnectedProjectError,
            showFlag
        ]);
        (0, $5uXOq.useEffect)(()=>{
            async function fetchData() {
                if (connectedProjects) {
                    if (connectedProjects.length && !hideSoftwareRelease) try {
                        releasesDataDispatch({
                            type: (0, $1b23561ab4bb345a$export$d99edfcf00e3ed71),
                            connectedProjects: connectedProjects
                        });
                        const projectAris = connectedProjects.map((connectedProject)=>connectedProject.resourceId);
                        const releasesByProjects = await fetchReleases({
                            projectAris: projectAris,
                            releaseDateBefore: releaseDateBefore,
                            releaseDateAfter: releaseDateAfter
                        });
                        releasesDataDispatch({
                            type: (0, $1b23561ab4bb345a$export$5c547463520b2dea),
                            releases: (0, (0, parcelRequire("i0jvn")).transformData)(releasesByProjects ?? [])
                        });
                        (0, (0, parcelRequire("kfKf8")).loadSoftwareReleasesExperience).success();
                    } catch (err) {
                        releasesDataDispatch({
                            type: (0, $1b23561ab4bb345a$export$ec4825154d679381),
                            error: err
                        });
                        showFlag({
                            type: 'error',
                            title: (0, (0, parcelRequire("cb8h6")).default).fetchReleasesErrorTitle,
                            description: (0, (0, parcelRequire("cb8h6")).default).fetchReleasesErrorMessage
                        });
                        (0, (0, parcelRequire("kfKf8")).loadSoftwareReleasesExperience).failure({
                            metadata: {
                                error: err?.message
                            }
                        });
                    }
                    else releasesDataDispatch({
                        type: (0, $1b23561ab4bb345a$export$63955a3a3260374f),
                        connectedProjects: connectedProjects
                    });
                }
            }
            fetchData();
        }, [
            connectedProjects,
            fetchReleases,
            hideSoftwareRelease,
            releaseDateAfter,
            releaseDateBefore,
            releasesDataDispatch,
            showFlag
        ]);
        return null;
    });
    const $3ab4b6b3d8178a08$export$6043efe7205d8fa2 = (request)=>{
        const [calendarReleasesData, releasesDataDispatch] = (0, $5uXOq.useReducer)($3ab4b6b3d8178a08$var$releasesDataReducer, $3ab4b6b3d8178a08$var$defaultCalendarReleasesState);
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const { releaseDateAfter: releaseDateAfter, releaseDateBefore: releaseDateBefore } = request;
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const hasSoftwareLicence = licensedProducts?.[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SOFTWARE];
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const appEdition = (0, (0, parcelRequire("ldyPw")).editionToEditionKey)((0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_CORE), appEditions));
        const [hideSoftwareRelease] = (0, (0, parcelRequire("a4LjM")).useHideSoftwareRelease)();
        const CalendarReleasesInitializer = (0, $5uXOq.useCallback)(()=>hasSoftwareLicence ? (0, ($parcel$interopDefault($5uXOq))).createElement($3ab4b6b3d8178a08$var$CalendarReleasesInternal, {
                projectId: entity.id,
                releaseDateAfter: releaseDateAfter,
                releaseDateBefore: releaseDateBefore,
                releasesDataDispatch: releasesDataDispatch
            }) : null, [
            releaseDateAfter,
            releaseDateBefore,
            entity,
            hasSoftwareLicence
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                releasesCount: calendarReleasesData.releases.length ?? 0,
                connectedProjectsCount: calendarReleasesData.connectedProjects.length ?? 0,
                hasConnectedProject: calendarReleasesData.connectedProjects.length > 0,
                releasesToggleOn: !hideSoftwareRelease,
                edition: appEdition
            }), [
            appEdition,
            calendarReleasesData.connectedProjects.length,
            calendarReleasesData.releases.length,
            hideSoftwareRelease
        ]);
        return {
            CalendarReleasesInitializer: CalendarReleasesInitializer,
            calendarReleasesData: calendarReleasesData,
            analyticsAttributes: analyticsAttributes
        };
    };
    const $3ab4b6b3d8178a08$var$releasesDataReducer = (state, action)=>{
        switch(action.type){
            case 0, $1b23561ab4bb345a$export$eb2216992bc2d237:
                return {
                    ...state,
                    isLoading: true
                };
            case 0, $1b23561ab4bb345a$export$63955a3a3260374f:
                return {
                    releases: [],
                    isLoading: false,
                    error: null,
                    connectedProjects: action.connectedProjects
                };
            case 0, $1b23561ab4bb345a$export$d99edfcf00e3ed71:
                return {
                    releases: [],
                    isLoading: true,
                    error: null,
                    connectedProjects: action.connectedProjects
                };
            case 0, $1b23561ab4bb345a$export$5c547463520b2dea:
                return {
                    ...state,
                    releases: action.releases,
                    isLoading: false
                };
            case 0, $1b23561ab4bb345a$export$ec4825154d679381:
                return {
                    ...state,
                    isLoading: false,
                    error: action.error
                };
            default:
                return state;
        }
    };
});
parcelRegister("5cvFd", function(module, exports) {
    $parcel$export(module.exports, "useFetchReleases", ()=>$3c716241d7821ea0$export$2d15c1d07b1fa2ec);
    var $6CSac;
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $jlq4V;
    var $jcw0u;
    var $5yJb9;
    var $6CSac;
    const $3c716241d7821ea0$export$2d15c1d07b1fa2ec = ()=>{
        const fetchReleases = (0, $5uXOq.useCallback)(async ({ projectAris: projectAris, releaseDateAfter: releaseDateAfter, releaseDateBefore: releaseDateBefore, first: first = 50 })=>{
            if (projectAris?.length === 0) return [];
            const query = (0, (0, parcelRequire("6CSac")).default);
            const variables = {
                projectAris: projectAris,
                releaseDateAfter: releaseDateBefore.toISOString(),
                releaseDateBefore: releaseDateAfter.toISOString(),
                first: first
            };
            try {
                const request = (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables, {
                    fetchPolicy: 'store-or-network'
                });
                (0, (0, parcelRequire("5yJb9")).default)().retain((0, $eiowN.createOperationDescriptor)((0, (0, parcelRequire("6CSac")).default), variables));
                const releasesResponse = await request.toPromise();
                const errors = releasesResponse?.errors;
                if (errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(errors);
                if ((0, ($parcel$interopDefault($hGgHi)))(releasesResponse?.jira?.versionsForProjects?.edges)) return [];
                return releasesResponse.jira.versionsForProjects.edges.map((edge)=>edge?.node);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchReleasesJiraBusinessCalendarQuery',
                        packageName: 'jiraSharedSoftwareDates',
                        teamName: 'jira-werewolves'
                    },
                    error: error
                });
                throw error;
            }
        }, []);
        return {
            fetchReleases: fetchReleases
        };
    };
});
parcelRegister("6CSac", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9637b7b54e102a8$export$2e2bcd8739ae039);
    const $d9637b7b54e102a8$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAris"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "releaseDateAfter"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "releaseDateBefore"
        }, v4 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": [
                    "RELEASED",
                    "UNRELEASED"
                ]
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            {
                "kind": "Variable",
                "name": "jiraProjectIds",
                "variableName": "projectAris"
            },
            {
                "kind": "Variable",
                "name": "releaseDateAfter",
                "variableName": "releaseDateAfter"
            },
            {
                "kind": "Variable",
                "name": "releaseDateBefore",
                "variableName": "releaseDateBefore"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "versionId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "name"
        }, v9 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v10 = {
            "kind": "ScalarField",
            "name": "status"
        }, v11 = {
            "kind": "ScalarField",
            "name": "description"
        }, v12 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v13 = {
            "kind": "ScalarField",
            "name": "releaseDate"
        }, v14 = {
            "kind": "ScalarField",
            "name": "key"
        }, v15 = {
            "kind": "ScalarField",
            "name": "large"
        }, v16 = {
            "kind": "ScalarField",
            "name": "small"
        }, v17 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v18 = [
            {
                "kind": "Literal",
                "name": "filters",
                "value": {
                    "statusCategories": "DONE"
                }
            }
        ], v19 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v20 = [
            {
                "kind": "Literal",
                "name": "filters",
                "value": {
                    "statusCategories": "IN_PROGRESS"
                }
            }
        ], v21 = [
            {
                "kind": "Literal",
                "name": "filters",
                "value": {
                    "statusCategories": "TODO"
                }
            }
        ], v22 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v23 = [
            v19
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3
                ],
                "kind": "Fragment",
                "name": "useFetchReleasesJiraBusinessCalendarQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "versionsForProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6,
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7,
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.versionId"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8,
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.name"
                                                    },
                                                    v9,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10,
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.status"
                                                    },
                                                    v11,
                                                    v12,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v13,
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.releaseDate"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v14,
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.project.key"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8,
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.project.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v15,
                                                                                "action": "NONE",
                                                                                "path": "jira.versionsForProjects.edges.node.project.avatar.large"
                                                                            },
                                                                            v16,
                                                                            v17
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.project.avatar"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.project"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "alias": "doneIssues",
                                                            "args": v18,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v19,
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.doneIssues.totalCount"
                                                                }
                                                            ],
                                                            "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
                                                        },
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.doneIssues"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "alias": "inprogressIssues",
                                                            "args": v20,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v19,
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.inprogressIssues.totalCount"
                                                                }
                                                            ],
                                                            "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
                                                        },
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.inprogressIssues"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "alias": "todoIssues",
                                                            "args": v21,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v19,
                                                                    "action": "NONE",
                                                                    "path": "jira.versionsForProjects.edges.node.todoIssues.totalCount"
                                                                }
                                                            ],
                                                            "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
                                                        },
                                                        "action": "NONE",
                                                        "path": "jira.versionsForProjects.edges.node.todoIssues"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "calendarReleaseForMultipleProjects_businessCalendar"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v22
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v2,
                    v3,
                    v0
                ],
                "kind": "Operation",
                "name": "useFetchReleasesJiraBusinessCalendarQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "versionsForProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    v7,
                                                    v8,
                                                    v9,
                                                    v10,
                                                    v11,
                                                    v12,
                                                    v13,
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v8,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    v15,
                                                                    v16,
                                                                    v17,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "xsmall"
                                                                    }
                                                                ]
                                                            },
                                                            v6,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectTypeName"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "alias": "doneIssues",
                                                        "args": v18,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v23,
                                                        "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
                                                    },
                                                    {
                                                        "alias": "inprogressIssues",
                                                        "args": v20,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v23,
                                                        "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
                                                    },
                                                    {
                                                        "alias": "todoIssues",
                                                        "args": v21,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v23,
                                                        "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "driver",
                                                        "plural": false,
                                                        "selections": [
                                                            v17,
                                                            v8,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                            },
                                                            v6
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraVersionPlanScenarioValues",
                                                        "kind": "LinkedField",
                                                        "name": "planScenarioValues",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "scenarioType"
                                                            },
                                                            v12,
                                                            v13,
                                                            v11
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v22
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b31503dee820ff4c6db5d90498895a0c51b3ce9ba9aa5c23c0ac0b68d0b3ab0d",
                "metadata": {},
                "name": "useFetchReleasesJiraBusinessCalendarQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d9637b7b54e102a8$var$node.hash = "1ac078be3c6f7c265dc02f750d1be94e";
    var $d9637b7b54e102a8$export$2e2bcd8739ae039 = $d9637b7b54e102a8$var$node;
});
parcelRegister("a4LjM", function(module, exports) {
    $parcel$export(module.exports, "useHideSoftwareRelease", ()=>$8736588f611e08e5$export$ad2cbfe3f82a4109);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    const $8736588f611e08e5$export$ad2cbfe3f82a4109 = ()=>{
        const [hideSoftwareRelease, persistSoftwareRelease] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).HIDE_SOFTWARE_RELEASE_PREFERENCE));
        const setSoftwareRelease = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistSoftwareRelease(hide ? 'true' : undefined, action), [
            persistSoftwareRelease
        ]);
        return [
            hideSoftwareRelease === 'true',
            setSoftwareRelease
        ];
    };
});
parcelRegister("kfKf8", function(module, exports) {
    $parcel$export(module.exports, "loadSoftwareReleasesExperience", ()=>$1947ef4d31147926$export$aee45ec8f53150ef);
    var $atdLB;
    var $duUGa;
    const $1947ef4d31147926$export$aee45ec8f53150ef = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jira-business.calendar.load-software-releases-experience', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    });
});
parcelRegister("cb8h6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$442506035d931323$export$2e2bcd8739ae039);
    var $7VHMR;
    var $442506035d931323$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fetchReleasesErrorTitle: {
            "id": "business-calendar.controllers.calendar-releases-for-multi-projects.fetch-releases-error-title",
            "defaultMessage": "We couldn't load your releases"
        },
        fetchReleasesErrorMessage: {
            "id": "business-calendar.controllers.calendar-releases-for-multi-projects.fetch-releases-error-message",
            "defaultMessage": "Refresh the page to try again."
        }
    });
});
const $1b23561ab4bb345a$export$eb2216992bc2d237 = 'initialise';
const $1b23561ab4bb345a$export$63955a3a3260374f = 'projects_loaded';
const $1b23561ab4bb345a$export$d99edfcf00e3ed71 = 'fetching_releases';
const $1b23561ab4bb345a$export$5c547463520b2dea = 'releases_loaded';
const $1b23561ab4bb345a$export$ec4825154d679381 = 'error';
parcelRegister("i0jvn", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$a9c009f53b93e8e8$export$3ceb62baab058c6b);
    var $f9ece;
    var $gwejS;
    const $a9c009f53b93e8e8$var$isValidRelease = (node)=>node?.releaseDate != null;
    const $a9c009f53b93e8e8$export$3ceb62baab058c6b = (releases)=>releases.filter($a9c009f53b93e8e8$var$isValidRelease).map((release)=>{
            const endDate = (0, (0, parcelRequire("gwejS")).default)(new Date(release.releaseDate), 1);
            return {
                allDay: true,
                title: release.name,
                start: (0, (0, parcelRequire("f9ece")).default)(release.releaseDate, 'UTC', 'yyyy-MM-dd'),
                end: (0, (0, parcelRequire("f9ece")).default)(endDate, 'UTC', 'yyyy-MM-dd'),
                editable: false,
                extendedProps: {
                    release: release
                }
            };
        });
});
parcelRegister("8qzrN", function(module, exports) {
    $parcel$export(module.exports, "useCalendarIssues", ()=>$17ece5a0c9133d6e$export$df3a0f3f54d2f1cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $gULOk;
    var $gaw3m;
    var $6SS1C;
    const $17ece5a0c9133d6e$var$EMPTY = [];
    const $17ece5a0c9133d6e$export$df3a0f3f54d2f1cb = (request)=>{
        const { loading: loading, error: error, refetch: refetch, data: data } = (0, (0, parcelRequire("gaw3m")).useCalendarIssues)(request);
        const [override, setOverride] = (0, $5uXOq.useState)(null);
        const setOptimisticItem = (0, $5uXOq.useCallback)((newIssue)=>{
            if (newIssue == null) setOverride(null);
            else setOverride(data != null ? [
                ...data,
                newIssue
            ] : [
                newIssue
            ]);
        }, [
            data
        ]);
        const refetchFn = (0, $5uXOq.useCallback)(async (newIssue)=>{
            if (newIssue) setOptimisticItem(newIssue);
            await refetch();
            setOptimisticItem(null);
        }, [
            setOptimisticItem,
            refetch
        ]);
        const items = override ?? data ?? $17ece5a0c9133d6e$var$EMPTY;
        const parsedIssues = (0, $5uXOq.useMemo)(()=>{
            const analyticsAttributes = {
                issuesInView: items.length,
                issuesInTodoStatus: 0,
                issuesInProgressStatus: 0,
                issuesInDoneStatus: 0
            };
            const incrementStatusAttributes = (statusCategoryId)=>{
                const { statusCategoryForId: statusCategoryForId, TODO: TODO, IN_PROGRESS: IN_PROGRESS, DONE: DONE } = (0, (0, parcelRequire("gULOk")));
                const status = statusCategoryForId(statusCategoryId);
                switch(status){
                    case TODO:
                        analyticsAttributes.issuesInTodoStatus += 1;
                        break;
                    case IN_PROGRESS:
                        analyticsAttributes.issuesInProgressStatus += 1;
                        break;
                    case DONE:
                        analyticsAttributes.issuesInDoneStatus += 1;
                        break;
                    default:
                        break;
                }
            };
            const fullCalendarIssues = items.map((item)=>{
                incrementStatusAttributes(item.statusCategoryId);
                return (0, (0, parcelRequire("6SS1C")).issueToFullCalendarEvent)(item);
            });
            return {
                fullCalendarIssues: fullCalendarIssues,
                analyticsAttributes: analyticsAttributes
            };
        }, [
            items
        ]);
        return {
            issues: parsedIssues.fullCalendarIssues,
            analyticsAttributes: parsedIssues.analyticsAttributes,
            loading: loading,
            error: error,
            refetch: refetchFn,
            setOptimisticItem: setOptimisticItem
        };
    };
});
parcelRegister("gaw3m", function(module, exports) {
    $parcel$export(module.exports, "useCalendarIssues", ()=>$0ed8ceeb0082dfa1$export$df3a0f3f54d2f1cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $kRkJF;
    var $1T1ir;
    var $cvbVg;
    var $9SwwX;
    var $gN11a;
    var $jcw0u;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $dAmbh;
    var $koeKL;
    var $cm4aA;
    var $bX4wk;
    var $848a3;
    var $8Sqif;
    const $0ed8ceeb0082dfa1$var$QUERY_NAME = 'calendarViewItemsQuery';
    let $0ed8ceeb0082dfa1$var$allCalendarItems = [];
    const $0ed8ceeb0082dfa1$export$df3a0f3f54d2f1cb = (request)=>{
        const { data: startDateField, loading: startDateFieldLoading } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'calendar'
        });
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const [hasLoadingStarted, setHasLoadingStarted] = (0, $5uXOq.useState)(false);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const defaultVariables = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                first: (0, (0, parcelRequire("bX4wk")).CALENDAR_ITEM_PAGE_SIZE),
                fieldIds: (0, (0, parcelRequire("bX4wk")).CALENDAR_ITEM_FIELDS)
            }), [
            cloudId
        ]);
        let startDateFieldId = null;
        if (startDateField?.id) [, startDateFieldId] = startDateField.id.split('_');
        const { loading: loading, error: error, data: data, loadFirstPage: loadFirstPage, isLoadingNextPage: isLoadingNextPage, loadNextPage: loadNextPage, refetch: refetch } = (0, (0, parcelRequire("cvbVg")).useJqlPagination)({
            variables: {
                ...defaultVariables,
                jql: (0, (0, parcelRequire("8Sqif")).toQuery)(request, quickFiltersJql, startDateFieldId)
            },
            query: (0, (0, parcelRequire("848a3")).QUERY),
            fetchPolicy: 'cache-and-network',
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $0ed8ceeb0082dfa1$var$QUERY_NAME,
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    attributes: {
                        message: 'Failed to fetch issues for calendar view',
                        isPaginationEnabled: true
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, (0, parcelRequire("gN11a")).markViewMetric)('calendar', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            },
            onCompleted: (responseData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$0ed8ceeb0082dfa1$var$QUERY_NAME} succeeded`, {
                    issueCount: (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(responseData, 'list')?.totalCount,
                    isPaginationEnabled: true
                });
                if (isSearching) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'calendarSimpleSearchQuery succeeded');
                (0, (0, parcelRequire("gN11a")).markViewMetric)('calendar', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            },
            onPaginationError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $0ed8ceeb0082dfa1$var$QUERY_NAME,
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    attributes: {
                        message: 'Pagination failed to fetch issues for calendar view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (startDateFieldLoading) return;
            (0, (0, parcelRequire("gN11a")).markViewMetric)('calendar', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }, [
            startDateFieldLoading
        ]);
        const _data = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, 'list');
        const hasNextPage = _data?.pageInfo?.hasNextPage ?? false;
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoadingNextPage && hasNextPage) {
                loadNextPage();
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$0ed8ceeb0082dfa1$var$QUERY_NAME} loadNextPage`, {
                    issueCount: _data?.totalCount,
                    isPaginationEnabled: true
                });
            }
        }, [
            isLoadingNextPage,
            hasNextPage,
            loadNextPage,
            createAnalyticsEvent,
            _data?.totalCount
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (!loading && !isLoadingNextPage && !hasNextPage) $0ed8ceeb0082dfa1$var$allCalendarItems = (0, (0, parcelRequire("cm4aA")).transformData)({
                edges: _data?.edges || [],
                areUnscheduledItems: false
            });
        }, [
            hasNextPage,
            isLoadingNextPage,
            loading,
            _data
        ]);
        const refetchFn = (0, $5uXOq.useCallback)(async (refetchRequest)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('business-calendar-refetch-before-available-fix')) refetchRequest ? await refetch?.({
                ...defaultVariables,
                jql: (0, (0, parcelRequire("8Sqif")).toQuery)(refetchRequest)
            }) : await refetch?.();
            else {
                if (refetchRequest === undefined) {
                    await refetch();
                    return;
                }
                await refetch({
                    ...defaultVariables,
                    jql: (0, (0, parcelRequire("8Sqif")).toQuery)(refetchRequest)
                });
            }
        }, [
            defaultVariables,
            refetch
        ]);
        return {
            loading: hasLoadingStarted ? loading || isLoadingNextPage : true,
            error: error,
            refetch: refetchFn,
            data: $0ed8ceeb0082dfa1$var$allCalendarItems
        };
    };
});
parcelRegister("cvbVg", function(module, exports) {
    $parcel$export(module.exports, "useIssuePagination", ()=>$0bf39943290cab91$export$b49565a42289e6b);
    $parcel$export(module.exports, "useJqlPagination", ()=>$0bf39943290cab91$export$9408824d9baedabc);
    $parcel$export(module.exports, "useRefreshInterval", ()=>$0bf39943290cab91$export$7cfdc4e3bbeb1790);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $5tTFS;
    var $9SwwX;
    const $0bf39943290cab91$var$paginationOptionsForIssuesByJql = {
        uniqueId: 'issueId',
        filter: 'jql'
    };
    function $0bf39943290cab91$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
        const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
        const _data = data && (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, listName, onError);
        const hasNextPage = _data?.pageInfo?.hasNextPage || false;
        const endCursor = _data?.pageInfo?.endCursor || '';
        const fetchMore = (0, (0, parcelRequire("9SwwX")).useFetchMore)({
            query: query,
            variables: variables
        });
        const onErrorRef = (0, $5uXOq.useRef)();
        onErrorRef.current = onError;
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setIsLoadingNextPage(false);
        }, [
            resetWhenChanged
        ]);
        const updateQueryAGGCompliant = (0, $5uXOq.useCallback)((prev, { fetchMoreResult: fetchMoreResult })=>{
            setIsLoadingNextPage(false);
            if (!fetchMoreResult) return prev;
            const edges = [
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(prev, listName)?.edges || [],
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
            ];
            return {
                jira: {
                    ...fetchMoreResult.jira,
                    [listName]: {
                        ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName),
                        edges: (0, ($parcel$interopDefault($3JOCw)))(edges, (edge)=>edge?.node && edge.node[uniqueId])
                    }
                }
            };
        }, [
            setIsLoadingNextPage,
            listName,
            uniqueId
        ]);
        const next = (0, $5uXOq.useCallback)((after)=>{
            setIsLoadingNextPage(true);
            fetchMore({
                after: after,
                onError: onErrorRef.current,
                errorPolicy: errorPolicy,
                updateQuery: updateQueryAGGCompliant
            });
        }, [
            fetchMore,
            updateQueryAGGCompliant,
            errorPolicy
        ]);
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            isLoadingNextPage: isLoadingNextPage,
            next: next
        };
    }
    const $0bf39943290cab91$export$b49565a42289e6b = (options)=>$0bf39943290cab91$export$f80c710216eae131({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
        const [inFlightPage, setInFlightPage] = (0, $5uXOq.useState)();
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setInFlightPage(null);
        }, [
            resetWhenChanged
        ]);
        const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy || 'network-only',
            onCompleted: onCompleted,
            onError: onError
        });
        if (data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
        const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $0bf39943290cab91$export$f80c710216eae131({
            data: data,
            variables: variables,
            listName: 'list',
            onError: onPaginationError,
            errorPolicy: errorPolicy,
            query: query,
            uniqueId: uniqueId,
            filter: filter
        });
        const loadNextPage = (0, $5uXOq.useCallback)(()=>{
            if (!hasNextPage || endCursor === inFlightPage || loading) return;
            setInFlightPage(endCursor);
            next(endCursor);
            onNextPageLoaded && onNextPageLoaded();
        }, [
            endCursor,
            hasNextPage,
            inFlightPage,
            next,
            onNextPageLoaded,
            loading
        ]);
        return {
            loading: loading,
            error: error,
            data: data,
            loadFirstPage: loadFirstPage,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loadNextPage: loadNextPage,
            refetch: refetch
        };
    };
    const $0bf39943290cab91$export$9408824d9baedabc = (options)=>$0bf39943290cab91$export$ea10f704343077db({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (interval == null) return ()=>{};
            const timer = setTimeout(()=>{
                if (condition) callback();
            }, interval * 1000);
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            interval,
            callback,
            condition
        ]);
    };
});
parcelRegister("9SwwX", function(module, exports) {
    $parcel$export(module.exports, "useFetchMore", ()=>$0f8617a70c5d6b6c$export$d84f34af2f3f5d9f);
    $parcel$export(module.exports, "getAGGCompliantData", ()=>$0f8617a70c5d6b6c$export$5a178cf599565b50);
    var $5tTFS;
    var $e3a3O;
    var $8Qi2I;
    var $c9Ur7;
    var $fPruT;
    function $0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
        const variablesWithAfter = {
            ...variables,
            after: after
        };
        return client.query({
            query: query,
            variables: variablesWithAfter,
            fetchPolicy: 'no-cache',
            errorPolicy: errorPolicy
        }).then((response)=>{
            if (!response) return;
            if (response.errors) {
                onError && onError(new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: response.errors
                }));
                if (errorPolicy === 'none') return;
            }
            if (response.data == null) return;
            const prevData = client.readQuery({
                query: query,
                variables: variables
            });
            if (prevData == null) return;
            const newData = updateQuery(prevData, {
                fetchMoreResult: response.data,
                variables: variablesWithAfter
            });
            client.writeQuery({
                query: query,
                variables: variables,
                notifyOnNetworkStatusChange: true,
                data: newData
            });
        }).catch((err)=>{
            onError && onError(err);
        });
    }
    function $0f8617a70c5d6b6c$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, (0, parcelRequire("8Qi2I")).useDeepMemo)(()=>(options)=>$0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({
                    ...options,
                    variables: variables,
                    query: query,
                    client: client
                }), [
            client,
            variables,
            query
        ]);
    }
    function $0f8617a70c5d6b6c$export$5a178cf599565b50(data, listName, onError) {
        if (listName && data?.jira?.[listName]) {
            const _data = data.jira[listName];
            if (_data?.__typename === 'QueryError') {
                const queryError = new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
                if (queryError.extensions?.find((ex)=>ex.statusCode === 401)) throw new (0, (0, parcelRequire("fPruT")).AuthenticationError)(_data.message);
                if (onError) {
                    onError(_data);
                    return undefined;
                }
                throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
            }
            return _data;
        }
        return undefined;
    }
});
parcelRegister("8Qi2I", function(module, exports) {
    $parcel$export(module.exports, "useDeepMemo", ()=>$5b0bf94477e3396a$export$722debc0e56fea39);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $5b0bf94477e3396a$export$722debc0e56fea39 = (memoFn, deps)=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, ($parcel$interopDefault($ajpes)))(ref.current.deps, deps)) ref.current = {
            value: memoFn(),
            deps: deps
        };
        return ref.current.value;
    };
});
parcelRegister("c9Ur7", function(module, exports) {
    $parcel$export(module.exports, "QueryError", ()=>$835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
    const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
    class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.extensions = payload.extensions;
            this.message = payload.message ?? '';
            this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
        }
    }
});
parcelRegister("fPruT", function(module, exports) {
    $parcel$export(module.exports, "AuthenticationError", ()=>$95af1b43dc18895e$export$cf0c46b07324e9c5);
    class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
        constructor(message){
            super(message);
            this.name = 'AuthenticationError';
            this.skipSentry = true;
            this.statusCode = 401;
        }
    }
});
parcelRegister("cm4aA", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$88595bd1fd519638$export$3ceb62baab058c6b);
    var $hE5wF;
    var $5fc53;
    var $4kK95;
    const $88595bd1fd519638$var$getField = (field)=>{
        const fieldId = field?.aliasFieldId || field?.fieldId;
        switch(fieldId){
            case 'issuekey':
                return {
                    key: field.text
                };
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                return {
                    iconUrl: field.issueType?.avatar.medium,
                    issueTypeId: field.issueType.issueTypeId,
                    issueTypeName: field.issueType.name
                };
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return {
                    summary: field.text
                };
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return {
                    statusName: field.status.name,
                    statusCategoryId: Number(field.status.statusCategory.statusCategoryId)
                };
            case 0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID:
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                return {
                    [fieldId]: (field.date && (0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(field.date)) ?? null
                };
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                return {
                    assignee: (field.user && {
                        avatarUrl: field.user.picture,
                        displayName: field.user.name
                    }) ?? null
                };
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return {
                    priority: (field.priority && {
                        name: field.priority.name,
                        iconUrl: field.priority.iconUrl,
                        priorityId: field.fieldId
                    }) ?? null
                };
            default:
                return {};
        }
    };
    function $88595bd1fd519638$export$3ceb62baab058c6b({ edges: edges, areUnscheduledItems: areUnscheduledItems }) {
        if (edges == null || !Array.isArray(edges)) return null;
        return edges.reduce((transformedData, edge)=>{
            const populateItem = (acc, field)=>({
                    ...acc,
                    ...$88595bd1fd519638$var$getField(field)
                });
            if (Array.isArray(edge.node?.fields)) {
                const item = edge.node.fields.reduce(populateItem, {
                    id: edge.node.issueId,
                    duedate: null,
                    priority: null,
                    startdate: null
                });
                if (!item.startdate && item.duedate) item.startdate = item.duedate;
                if (areUnscheduledItems === true && item.duedate === null || !areUnscheduledItems && item.duedate != null) transformedData.push(item);
            }
            return transformedData;
        }, []);
    }
});
parcelRegister("bX4wk", function(module, exports) {
    $parcel$export(module.exports, "UNSCHEDULED_ITEMS_JQL", ()=>$157578b437f73410$export$bd50fb8fcd57e608);
    $parcel$export(module.exports, "CALENDAR_ITEM_FIELDS", ()=>$157578b437f73410$export$57af0e69848e8950);
    $parcel$export(module.exports, "CALENDAR_ITEM_PAGE_SIZE", ()=>$157578b437f73410$export$c44784f85d554d7e);
    const $157578b437f73410$export$bd50fb8fcd57e608 = "duedate IS NULL AND StatusCategory != 'Complete'";
    const $157578b437f73410$export$57af0e69848e8950 = [
        'assignee',
        'duedate',
        'issuekey',
        'issuetype',
        'priority',
        'startdate',
        'status',
        'summary'
    ];
    const $157578b437f73410$export$c44784f85d554d7e = 100;
});
parcelRegister("8Sqif", function(module, exports) {
    $parcel$export(module.exports, "toQuery", ()=>$6d0d9273cac43f1c$export$da99e50c1f5e8cc8);
    const $6d0d9273cac43f1c$export$57e0860e1b9181ad = ({ jqlContext: jqlContext, dueDateFieldId: dueDateFieldId, startOfMonthDate: startOfMonthDate, endOfMonthDate: endOfMonthDate, quickFiltersJql: quickFiltersJql, startDateFieldId: startDateFieldId })=>{
        const startOfMonthDateISOString = startOfMonthDate.toISOString();
        const endOfMonthDateISOString = endOfMonthDate.toISOString();
        const inThisMonthQuery = (fieldName)=>`(${fieldName} != NULL AND ${fieldName}>=${startOfMonthDateISOString} AND ${fieldName}<=${endOfMonthDateISOString})`;
        const isDueDateInMonthQuery = inThisMonthQuery(dueDateFieldId);
        let defaultClauseWithSubTasks;
        if (startDateFieldId != null) {
            const startDateFieldQuery = `cf[${startDateFieldId}]`;
            const isStartDateInMonthQuery = inThisMonthQuery(startDateFieldQuery);
            const isStartDateAndDueDateWithinMonthQuery = `(${dueDateFieldId} != NULL AND ${startDateFieldQuery} != NULL AND ${dueDateFieldId}>=${startOfMonthDateISOString} AND ${startDateFieldQuery}<=${endOfMonthDateISOString})`;
            defaultClauseWithSubTasks = [
                isDueDateInMonthQuery,
                isStartDateInMonthQuery,
                isStartDateAndDueDateWithinMonthQuery
            ].join(' OR ');
        } else defaultClauseWithSubTasks = isDueDateInMonthQuery;
        const jql = [
            jqlContext,
            `(${defaultClauseWithSubTasks})`
        ];
        if (quickFiltersJql != null) jql.push(quickFiltersJql);
        return `${jql.join(' AND ')} ORDER BY "${dueDateFieldId}" ASC`;
    };
    const $6d0d9273cac43f1c$export$da99e50c1f5e8cc8 = ({ jqlContext: jqlContext, startDate: startDate, endDate: endDate }, quickFiltersJql, startDateFieldId)=>$6d0d9273cac43f1c$export$57e0860e1b9181ad({
            jqlContext: jqlContext,
            dueDateFieldId: 'duedate',
            startOfMonthDate: startDate,
            endOfMonthDate: endDate,
            quickFiltersJql: quickFiltersJql,
            startDateFieldId: startDateFieldId
        });
});
parcelRegister("6SS1C", function(module, exports) {
    $parcel$export(module.exports, "issueToFullCalendarEvent", ()=>$546e363bb5080c44$export$4f106a147d2332e5);
    var $gwejS;
    const $546e363bb5080c44$export$4f106a147d2332e5 = (issue)=>({
            title: issue.key,
            extendedProps: {
                issue: issue
            },
            allDay: true,
            start: issue.startdate.toLocalDate(),
            end: (0, (0, parcelRequire("gwejS")).default)(issue.duedate.toLocalDate(), 1)
        });
});
parcelRegister("RHNrk", function(module, exports) {
    $parcel$export(module.exports, "useDragUnscheduledItem", ()=>$a23ac0ee22a30c7a$export$e4ab074e96ad329a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k7m40;
    var $jj52j;
    var $cm8b5;
    var $jJZqs;
    var $4kK95;
    var $8zOmE;
    var $2NMNM;
    var $e39Vk;
    var $gXGDg;
    var $f42Sq;
    var $6PeUX;
    var $Y6wBa;
    var $2f0va;
    const $a23ac0ee22a30c7a$var$CELL_ID_PREFIX = 'cell-date';
    const $a23ac0ee22a30c7a$var$getElementAdapter = ()=>(0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>Promise.resolve((parcelRequire("7gWdR"))), {
            moduleId: "a81eb583"
        });
    const $a23ac0ee22a30c7a$var$addDraggingClassToCalendar = (calendarElement)=>{
        calendarElement.classList.add((0, (0, parcelRequire("f42Sq")).DRAGGING_UNSCHEDULED_ITEM_CLASS_NAME));
    };
    const $a23ac0ee22a30c7a$var$removeDraggingClassFromCalendar = (calendarElement)=>{
        calendarElement.classList.remove((0, (0, parcelRequire("f42Sq")).DRAGGING_UNSCHEDULED_ITEM_CLASS_NAME));
    };
    const $a23ac0ee22a30c7a$export$e4ab074e96ad329a = ({ setPlaceholder: setPlaceholder, setIsSaving: setIsSaving, refetch: refetch, calendarWrapperRef: calendarWrapperRef })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("f42Sq")).SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("f42Sq")).SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("f42Sq")).SCHEDULE_ITEM_EXPERIENCE));
        const decrementCount = (0, (0, parcelRequire("Y6wBa")).useDecrementUnscheduledItemsCount)();
        const updateDates = (0, (0, parcelRequire("2f0va")).useUpdateDates)();
        const [updateIssueParams, setUpdateIssueParams] = (0, $5uXOq.useState)(null);
        const cleanHighlightDays = (0, $5uXOq.useCallback)(()=>{
            if (typeof document !== 'undefined') {
                const elements = document.getElementsByClassName('fc-daygrid-day-frame');
                Array.from(elements).forEach((element)=>element.classList.remove('fc-highlight'));
            }
        }, []);
        const highlightDays = (0, $5uXOq.useCallback)((params)=>{
            if (typeof document !== 'undefined') {
                const elements = document.getElementsByClassName('fc-daygrid-day-frame');
                Array.from(elements).forEach((element)=>{
                    const elementDate = element.id.split('_')[1];
                    const elementDateMapped = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date(elementDate));
                    const { startDate: startDate, dueDate: dueDate } = params;
                    if ((0, (0, parcelRequire("4kK95")).DateOnly).compare(startDate, elementDateMapped) === 0 || (0, (0, parcelRequire("4kK95")).DateOnly).compare(dueDate, elementDateMapped) === 0 || (0, (0, parcelRequire("4kK95")).DateOnly).compare(startDate, elementDateMapped) === -1 && (0, (0, parcelRequire("4kK95")).DateOnly).compare(dueDate, elementDateMapped) === 1 || (0, (0, parcelRequire("4kK95")).DateOnly).compare(startDate, elementDateMapped) === 1 && (0, (0, parcelRequire("4kK95")).DateOnly).compare(dueDate, elementDateMapped) === -1) element.classList.add('fc-highlight');
                    else element.classList.remove('fc-highlight');
                });
            }
        }, []);
        const dayCellDidMount = (0, $5uXOq.useCallback)(({ el: el, date: date })=>{
            if (!el) return;
            const firstChild = el.firstChild;
            if (firstChild) {
                const mappedDate = (0, (0, parcelRequire("k7m40")).default)(date, 'yyyy-MM-dd');
                firstChild.id = `${$a23ac0ee22a30c7a$var$CELL_ID_PREFIX}_${mappedDate}`;
            }
            $a23ac0ee22a30c7a$var$getElementAdapter().onComplete(({ dropTargetForElements: dropTargetForElements })=>dropTargetForElements({
                    element: el,
                    getData: ()=>({
                            date: date
                        }),
                    onDragEnter: ({ self: self, source: source })=>{
                        const selfDate = self.data.date;
                        const issue = source.data.issue;
                        if (issue.startdate) highlightDays({
                            startDate: issue.startdate,
                            dueDate: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(selfDate)
                        });
                        else {
                            const element = self.element;
                            const firstDiv = element.firstChild;
                            if (firstDiv) firstDiv.classList.add('fc-highlight');
                        }
                    },
                    onDragLeave: ({ self: self, source: source })=>{
                        const element = self.element;
                        const issue = source.data.issue;
                        const firstDiv = element.firstChild;
                        if (!issue.startdate && firstDiv) firstDiv.classList.remove('fc-highlight');
                    },
                    onDrop: ({ self: self, source: source })=>{
                        const selfDate = self.data.date;
                        const issue = source.data.issue;
                        const mappedNewDate = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(selfDate);
                        const element = self.element;
                        const firstDiv = element.firstChild;
                        if (firstDiv && !issue.startdate) firstDiv.classList.remove('fc-highlight');
                        else cleanHighlightDays();
                        setPlaceholder({
                            title: issue.key,
                            extendedProps: {
                                issue: {
                                    ...issue,
                                    ...!issue.startdate ? {
                                        startdate: mappedNewDate
                                    } : {},
                                    duedate: mappedNewDate
                                }
                            },
                            allDay: true,
                            start: mappedNewDate.toLocalDate(),
                            end: mappedNewDate.toLocalDate()
                        });
                        setIsSaving(true);
                        const newDueDate = (0, (0, parcelRequire("jj52j")).default)(date, {
                            representation: 'date'
                        });
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'unscheduledItem dropped', {
                            newDueDate: newDueDate
                        });
                        setUpdateIssueParams({
                            issueKey: issue.key,
                            issueId: issue.id,
                            ...!issue.startdate ? {
                                newStartDate: (0, (0, parcelRequire("jj52j")).default)(date, {
                                    representation: 'date'
                                })
                            } : {},
                            newDueDate: newDueDate
                        });
                    }
                }));
        }, [
            highlightDays,
            setPlaceholder,
            setIsSaving,
            createAnalyticsEvent,
            cleanHighlightDays
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (calendarWrapperRef?.current) {
                const element = calendarWrapperRef.current;
                $a23ac0ee22a30c7a$var$getElementAdapter().onComplete(({ dropTargetForElements: dropTargetForElements })=>{
                    dropTargetForElements({
                        element: element,
                        onDragEnter: ()=>{
                            $a23ac0ee22a30c7a$var$addDraggingClassToCalendar(calendarWrapperRef.current?.firstChild);
                        },
                        onDragLeave: ()=>{
                            cleanHighlightDays();
                            $a23ac0ee22a30c7a$var$removeDraggingClassFromCalendar(calendarWrapperRef.current?.firstChild);
                        },
                        onDrop: ()=>{
                            $a23ac0ee22a30c7a$var$removeDraggingClassFromCalendar(calendarWrapperRef.current?.firstChild);
                        }
                    });
                });
            }
        }, [
            calendarWrapperRef,
            cleanHighlightDays
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (updateIssueParams) {
                startExperience();
                (async ()=>{
                    try {
                        await updateDates(updateIssueParams);
                        await refetch(undefined);
                        setPlaceholder(null);
                        decrementCount();
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem success', {
                            ...updateIssueParams
                        });
                        markExperienceSuccess();
                    } catch (error) {
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem failed', {
                            error: error,
                            ...updateIssueParams
                        });
                        if (error instanceof (0, (0, parcelRequire("6PeUX")).NotFoundError) || (0, (0, parcelRequire("jJZqs")).isValidationError)(error)) markExperienceSuccess();
                        else markExperienceFailed('schedule an item has failed', error);
                        setPlaceholder(null);
                    } finally{
                        setUpdateIssueParams(null);
                        setIsSaving(false);
                    }
                })();
            }
        }, [
            updateIssueParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gXGDg")).waitForAllResources)([
                (0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>Promise.resolve((parcelRequire("4hDdm"))), {
                    moduleId: "8a3e47ea"
                }),
                $a23ac0ee22a30c7a$var$getElementAdapter(),
                (0, (0, parcelRequire("e39Vk")).importForInteraction)(()=>(parcelRequire("a2HnD")), {
                    moduleId: "63a9d67a"
                })
            ]).onComplete(([{ combine: combine }, { monitorForElements: monitorForElements }, { autoScroller: autoScroller }])=>{
                combine(monitorForElements({
                    onDragStart: ({ location: location })=>{
                        autoScroller.start({
                            input: location.current.input
                        });
                    },
                    onDrop: ()=>{
                        autoScroller.stop();
                    },
                    onDrag: ({ location: location })=>{
                        autoScroller.updateInput({
                            input: location.current.input
                        });
                    }
                }), ()=>autoScroller.stop());
            });
        }, []);
        return {
            dayCellDidMount: dayCellDidMount
        };
    };
});
parcelRegister("e39Vk", function(module, exports) {
    $parcel$export(module.exports, "importForInteraction", ()=>$1224ecfa51385ab0$export$5b50cea0b44df65b);
    var $eIMrK;
    var $eYVtd;
    var $iyWSs;
    const $1224ecfa51385ab0$var$cache = (0, (0, parcelRequire("eIMrK")).createCache)(new Map());
    function $1224ecfa51385ab0$export$5b50cea0b44df65b(loader, opts) {
        const resource = $1224ecfa51385ab0$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("eYVtd")).JSResource)(()=>(0, (0, parcelRequire("iyWSs")).postTask)(loader, {
                    priority: 'user-visible'
                }), opts));
        resource.load().catch(()=>{});
        return resource;
    }
});
parcelRegister("gXGDg", function(module, exports) {
    $parcel$export(module.exports, "waitForAllResources", ()=>$29bb74f10fe3539e$export$c33694368275e0ee);
    function $29bb74f10fe3539e$export$c33694368275e0ee(resources) {
        return {
            onComplete (onLoad, onError) {
                const cleanups = [];
                const values = new Array(resources.length);
                let completed = false;
                const dispose = ()=>{
                    cleanups.forEach((cleanup)=>cleanup());
                    cleanups.length = 0;
                };
                const done = ()=>{
                    dispose();
                    completed = true;
                };
                let loadedResources = 0;
                for(let i = 0; i < resources.length && !completed; i++){
                    const completable = resources[i];
                    cleanups.push(completable.onComplete((value)=>{
                        values[i] = value;
                        loadedResources++;
                        if (loadedResources === resources.length) {
                            onLoad(values);
                            done();
                        }
                    }, (error)=>{
                        onError?.(error);
                        done();
                    }));
                }
                return dispose;
            }
        };
    }
});
parcelRegister("6PeUX", function(module, exports) {
    $parcel$export(module.exports, "NotFoundError", ()=>$c37e794ff9cbb1c4$export$78c95b58762d2106);
    $parcel$export(module.exports, "useUpdateDates", ()=>$c37e794ff9cbb1c4$export$c7328a9ad2ddb604);
    var $5uXOq = parcelRequire("5uXOq");
    var $f9ece;
    var $jlq4V;
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    var $3fAi8;
    var $dXq4S;
    var $dAmbh;
    var $koeKL;
    const $c37e794ff9cbb1c4$var$QUERY_NAME = 'JWMCalendarUpdateDates';
    class $c37e794ff9cbb1c4$export$78c95b58762d2106 extends (0, (0, parcelRequire("jJZqs")).ValidationError) {
        constructor(){
            super('Issue not found');
        }
    }
    const $c37e794ff9cbb1c4$export$c7328a9ad2ddb604 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldsValuesActions)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        return (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, issueId: issueId, newStartDate: newStartDate, newDueDate: newDueDate })=>{
            try {
                const variables = {
                    input: {
                        issueId: (0, (0, parcelRequire("dXq4S")).createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'issue',
                            resourceId: String(issueId)
                        }),
                        operation: 'SET'
                    }
                };
                if (newStartDate != null) variables.input.startDate = {
                    fieldId: 'startdate',
                    date: {
                        formattedDate: (0, (0, parcelRequire("f9ece")).default)(new Date(newStartDate), 'UTC', 'dd/MMM/yyyy')
                    }
                };
                if (newDueDate != null) variables.input.dueDate = {
                    fieldId: 'duedate',
                    date: {
                        formattedDate: (0, (0, parcelRequire("f9ece")).default)(new Date(newDueDate), 'UTC', 'dd/MMM/yyyy')
                    }
                };
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$c37e794ff9cbb1c4$var$QUERY_NAME}`, {
                    body: JSON.stringify({
                        query: (0, $d3d1363fc6b0f257$export$2b91517d6d5b4365),
                        variables: variables
                    })
                });
                if (response.data?.scheduleTimelineJwmItem == null) {
                    const errors = response.errors?.[0];
                    const statusCode = errors?.extensions?.statusCode;
                    if (statusCode === 404) throw new $c37e794ff9cbb1c4$export$78c95b58762d2106();
                    else if (errors && statusCode && statusCode >= 400 && statusCode < 500 && errors.message.length > 0) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)(errors.message);
                    else throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(errors);
                }
                const result = response.data.scheduleTimelineJwmItem;
                if (!result.success) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(result.errors);
                setFieldValue(issueKey, 'duedate', newDueDate);
                if (startDateField && newStartDate != null) setFieldValue(issueKey, startDateField.id, newStartDate);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $c37e794ff9cbb1c4$var$QUERY_NAME,
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, [
            cloudId,
            setFieldValue,
            startDateField
        ]);
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
const $d3d1363fc6b0f257$export$2b91517d6d5b4365 = `
mutation JWMCalendarUpdateDates($input: JWMScheduleTimelineItemInput!) {
  scheduleTimelineJwmItem(input: $input) {
    success
    errors {
      message
      extensions {
        statusCode
        errorType
      }
    }
  }
}`;
parcelRegister("Y6wBa", function(module, exports) {
    $parcel$export(module.exports, "useUnscheduledItemsCount", ()=>$b2464dfcddf37eb6$export$893cf3ca394fd658);
    $parcel$export(module.exports, "useDecrementUnscheduledItemsCount", ()=>$b2464dfcddf37eb6$export$879bb202180bb724);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $asqbQ;
    var $3sQ5x;
    var $iXqE5;
    var $1GbSu;
    const $b2464dfcddf37eb6$var$initEntity = (entityId)=>({ setState: setState })=>{
            setState({
                count: 0,
                entityId: entityId
            });
        };
    const $b2464dfcddf37eb6$var$setCount = (count)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                count: count
            });
        };
    const $b2464dfcddf37eb6$var$decrementCount = ()=>({ getState: getState, setState: setState })=>{
            const count = Math.max(0, getState().count - 1);
            setState({
                ...getState(),
                count: count
            });
        };
    const $b2464dfcddf37eb6$var$actions = {
        initEntity: $b2464dfcddf37eb6$var$initEntity,
        setCount: $b2464dfcddf37eb6$var$setCount,
        decrementCount: $b2464dfcddf37eb6$var$decrementCount
    };
    const $b2464dfcddf37eb6$var$initialState = {
        count: 0,
        entityId: ''
    };
    const $b2464dfcddf37eb6$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $b2464dfcddf37eb6$var$initialState,
        actions: $b2464dfcddf37eb6$var$actions,
        name: 'JWMUnscheduledItemsCount'
    });
    const $b2464dfcddf37eb6$var$useStore = (0, (0, parcelRequire("3sQ5x")).createHook)($b2464dfcddf37eb6$var$Store);
    const $b2464dfcddf37eb6$export$893cf3ca394fd658 = ()=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const [{ count: count, entityId: entityId }, actors] = $b2464dfcddf37eb6$var$useStore();
        const fetchCount = (0, (0, parcelRequire("1GbSu")).useUnscheduledItemsCount)();
        (0, $5uXOq.useEffect)(()=>{
            const fetch = async ()=>{
                if (entity == null || entityId === entity.id) return;
                try {
                    actors.initEntity(entity.id);
                    const total = await fetchCount();
                    actors.setCount(total);
                } catch (error) {}
            };
            fetch();
        }, [
            actors,
            entity,
            entityId,
            fetchCount
        ]);
        const updateCount = (0, $5uXOq.useCallback)(async ()=>{
            if (entity == null) return;
            try {
                const total = await fetchCount();
                actors.setCount(total);
            } catch (error) {}
        }, [
            actors,
            entity,
            fetchCount
        ]);
        (0, (0, parcelRequire("asqbQ")).useIssueEvents)(updateCount);
        return count;
    };
    const $b2464dfcddf37eb6$export$879bb202180bb724 = ()=>{
        const [, actors] = $b2464dfcddf37eb6$var$useStore();
        return actors.decrementCount;
    };
});
parcelRegister("1GbSu", function(module, exports) {
    $parcel$export(module.exports, "useUnscheduledItemsCount", ()=>$97f22b37030f7ef4$export$893cf3ca394fd658);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $jlq4V;
    var $jcw0u;
    var $eusud;
    var $9OXo1;
    var $bX4wk;
    const $97f22b37030f7ef4$var$QUERY_NAME = 'JWMCalendarUnscheduledItemsCount';
    const $97f22b37030f7ef4$export$893cf3ca394fd658 = ()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        return (0, $5uXOq.useCallback)(async ()=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$97f22b37030f7ef4$var$QUERY_NAME}`, {
                    body: JSON.stringify({
                        query: (0, $0b71c779ef287cd3$export$2b91517d6d5b4365),
                        variables: {
                            cloudId: cloudId,
                            jql: `${jqlContext} AND ${(0, (0, parcelRequire("bX4wk")).UNSCHEDULED_ITEMS_JQL)}`
                        }
                    })
                });
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                if (response.data == null) throw new Error('GraphQL response has no data');
                return response.data.jira.unscheduledCount?.totalCount ?? 0;
            } catch (restError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $97f22b37030f7ef4$var$QUERY_NAME,
                        packageName: 'jiraBusinessCalendar',
                        teamName: 'jira-yurree'
                    },
                    error: restError,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw restError;
            }
        }, [
            cloudId,
            jqlContext
        ]);
    };
});
const $0b71c779ef287cd3$export$2b91517d6d5b4365 = `
  query JWMCalendarUnscheduledItemsCount($cloudId: ID!, $jql: String!) {
    jira {
      unscheduledCount: jwmViewItems(cloudId: $cloudId, jql: $jql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
  }
`;
parcelRegister("2f0va", function(module, exports) {
    $parcel$export(module.exports, "useUpdateDates", ()=>$6d7b7446e25c6495$export$c7328a9ad2ddb604);
    var $5uXOq = parcelRequire("5uXOq");
    var $jJZqs;
    var $pa9q9;
    var $6PeUX;
    var $4bUx1;
    const $6d7b7446e25c6495$var$UPDATE_FAILED_FLAG = {
        type: 'error',
        title: (0, (0, parcelRequire("4bUx1")).default).errorTitle,
        description: (0, (0, parcelRequire("4bUx1")).default).errorMessage
    };
    const $6d7b7446e25c6495$var$ISSUE_NOT_FOUND = {
        type: 'error',
        title: (0, (0, parcelRequire("4bUx1")).default).notFoundErrorTitle,
        description: (0, (0, parcelRequire("4bUx1")).default).notFoundErrorMessage
    };
    const $6d7b7446e25c6495$export$c7328a9ad2ddb604 = ()=>{
        const updateDates = (0, (0, parcelRequire("6PeUX")).useUpdateDates)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, issueId: issueId, newStartDate: newStartDate, newDueDate: newDueDate })=>{
            try {
                await updateDates({
                    issueKey: issueKey,
                    issueId: issueId,
                    newStartDate: newStartDate,
                    newDueDate: newDueDate
                });
            } catch (error) {
                if (error instanceof (0, (0, parcelRequire("6PeUX")).NotFoundError)) showFlag($6d7b7446e25c6495$var$ISSUE_NOT_FOUND);
                else if ((0, (0, parcelRequire("jJZqs")).isValidationError)(error)) showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("4bUx1")).default).errorTitle,
                    description: error.message
                });
                else showFlag($6d7b7446e25c6495$var$UPDATE_FAILED_FLAG);
                throw error;
            }
        }, [
            showFlag,
            updateDates
        ]);
    };
});
parcelRegister("4bUx1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f38d203ac4609900$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f38d203ac4609900$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-calendar.controllers.update-dates.error-title",
            "defaultMessage": "We couldn't save the issue"
        },
        errorMessage: {
            "id": "business-calendar.controllers.update-dates.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        notFoundErrorTitle: {
            "id": "business-calendar.controllers.update-dates.not-found-error-title",
            "defaultMessage": "Issue not found"
        },
        notFoundErrorMessage: {
            "id": "business-calendar.controllers.update-dates.not-found-error-message",
            "defaultMessage": "Looks like this issue has been removed."
        }
    });
});
parcelRegister("a2HnD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5A1SC").then(()=>parcelRequire('41Tr4'));
});
parcelRegister("3H67w", function(module, exports) {
    $parcel$export(module.exports, "useUnscheduledSidebar", ()=>$7e82e68685d34c0c$export$2fa6197b723c6a61);
    $parcel$export(module.exports, "useUnscheduledItems", ()=>$7e82e68685d34c0c$export$a98876883b295850);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXhsp;
    var $AeWM3;
    var $bUSNl;
    var $hE5wF;
    var $1T1ir;
    var $1tESh;
    var $asqbQ;
    var $l8Afc;
    var $8zOmE;
    var $ieDtd;
    var $24lru;
    const $7e82e68685d34c0c$var$UNSCHEDULED_SIDEBAR_CONTENT_KEY = 'unscheduledSidebar';
    const $7e82e68685d34c0c$export$2fa6197b723c6a61 = ({ UnscheduledSidebar: UnscheduledSidebar, cleanSelectedIssueKey: cleanSelectedIssueKey })=>{
        const [selectedIssueKey, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const [showIssueFromUnscheduledSidebar, setShowIssueFromUnscheduledSidebar] = (0, $5uXOq.useState)(false);
        const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const [isUnscheduledItemsSidebar, setIsUnscheduledItemsSidebar] = (0, $5uXOq.useState)(false);
        const isUnscheduledSidebarOpen = (0, $5uXOq.useMemo)(()=>content?.key === $7e82e68685d34c0c$var$UNSCHEDULED_SIDEBAR_CONTENT_KEY, [
            content
        ]);
        const onClickIssue = (0, $5uXOq.useCallback)((issueKey)=>{
            setShowIssueFromUnscheduledSidebar(true);
            setSelectedIssueKey(issueKey);
        }, [
            setSelectedIssueKey
        ]);
        const onCloseUnscheduledSidebar = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'unscheduledSidebarButton', {
                open: false
            });
            setIsUnscheduledItemsSidebar(false);
            setSidebarContent(null);
        }, [
            setSidebarContent
        ]);
        const onClickUnscheduledButton = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            if (isUnscheduledItemsSidebar) onCloseUnscheduledSidebar(e, analyticsEvent);
            else {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'unscheduledSidebarButton', {
                    open: true
                });
                setIsUnscheduledItemsSidebar(true);
                cleanSelectedIssueKey(undefined);
            }
        }, [
            cleanSelectedIssueKey,
            onCloseUnscheduledSidebar,
            isUnscheduledItemsSidebar
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!content || content && content?.key !== $7e82e68685d34c0c$var$UNSCHEDULED_SIDEBAR_CONTENT_KEY) setIsUnscheduledItemsSidebar(false);
        }, [
            content
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isUnscheduledItemsSidebar) {
                const unescheduledContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
                    key: $7e82e68685d34c0c$var$UNSCHEDULED_SIDEBAR_CONTENT_KEY,
                    client: (0, (0, parcelRequire("aXhsp")).default)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(UnscheduledSidebar, {
                    onCloseSidebar: onCloseUnscheduledSidebar,
                    onClickIssue: onClickIssue
                }));
                setSidebarContent(unescheduledContent);
            }
        }, [
            setSidebarContent,
            UnscheduledSidebar,
            onCloseUnscheduledSidebar,
            isUnscheduledItemsSidebar,
            onClickIssue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!selectedIssueKey) setShowIssueFromUnscheduledSidebar(false);
        }, [
            selectedIssueKey
        ]);
        return {
            showIssueFromUnscheduledSidebar: showIssueFromUnscheduledSidebar,
            isUnscheduledSidebarOpen: isUnscheduledSidebarOpen,
            onCloseUnscheduledSidebar: onCloseUnscheduledSidebar,
            onClickUnscheduledButton: onClickUnscheduledButton
        };
    };
    const $7e82e68685d34c0c$export$a98876883b295850 = ()=>{
        const [searchText, setSearchText] = (0, $5uXOq.useState)('');
        const { jql: jqlSimpleSearch, highlight: highlight } = (0, (0, parcelRequire("1T1ir")).useSearchText)(searchText);
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [sortDirection, setSortDirection] = (0, $5uXOq.useState)('ASC');
        const params = (0, $5uXOq.useMemo)(()=>({
                sortDirection: sortDirection,
                jqlSimpleSearch: jqlSimpleSearch,
                jqlFilters: (0, (0, parcelRequire("1tESh")).serialiseJql)(filters) ?? ''
            }), [
            sortDirection,
            jqlSimpleSearch,
            filters
        ]);
        const { data: data, error: error, loading: loading, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage, hasNextPage: hasNextPage, refetch: refetch } = (0, (0, parcelRequire("24lru")).useUnscheduledItems)(params);
        const refresh = (0, $5uXOq.useCallback)(()=>{
            refetch();
        }, [
            refetch
        ]);
        (0, (0, parcelRequire("asqbQ")).useIssueEvents)(refresh);
        const { onScroll: onScroll } = (0, (0, parcelRequire("l8Afc")).useScrollToEnd)({
            onScrollToEnd: loadNextPage,
            isDisabled: isLoadingNextPage || !hasNextPage,
            options: {
                onEndReachedThreshold: 150
            }
        });
        const toggleSortDirection = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'setSortDirectionUnscheduledItems');
            setSortDirection((currentState)=>{
                if (currentState === 'ASC') return 'DESC';
                return 'ASC';
            });
        }, []);
        const onClearFilters = (0, $5uXOq.useCallback)(()=>{
            setSearchText('');
            setFilters({});
        }, []);
        return {
            issues: data,
            loading: loading,
            onScroll: onScroll,
            sortDirection: sortDirection,
            toggleSortDirection: toggleSortDirection,
            searchText: searchText,
            setSearchText: setSearchText,
            highlight: highlight,
            filters: filters,
            setFilters: setFilters,
            onClearFilters: onClearFilters,
            isLoadingNextPage: isLoadingNextPage,
            error: error
        };
    };
});
parcelRegister("l8Afc", function(module, exports) {
    $parcel$export(module.exports, "useScrollToEnd", ()=>$ebddd9e1f1864b8e$export$296d94f94d195283);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    const $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD = 300;
    const $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME = 16;
    const $ebddd9e1f1864b8e$export$296d94f94d195283 = ({ onScrollToEnd: onScrollToEnd, isDisabled: isDisabled, options: options })=>{
        const onEndReachedThreshold = options?.onEndReachedThreshold ?? $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD;
        const throttleTime = options?.throttleTime ?? $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME;
        const calculateEndReached = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($34ck9)))(({ clientHeight: clientHeight, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
                const distanceFromEnd = scrollHeight - scrollTop - clientHeight;
                if (distanceFromEnd < onEndReachedThreshold && isDisabled !== true) onScrollToEnd();
            }, throttleTime), [
            onScrollToEnd,
            throttleTime,
            isDisabled,
            onEndReachedThreshold
        ]);
        const onScroll = (0, $5uXOq.useCallback)((event)=>{
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = event.currentTarget;
            calculateEndReached({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, [
            calculateEndReached
        ]);
        return {
            onScroll: onScroll
        };
    };
});
parcelRegister("24lru", function(module, exports) {
    $parcel$export(module.exports, "useUnscheduledItems", ()=>$1525c942fadb889f$export$a98876883b295850);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $5YBrl;
    var $cvbVg;
    var $9SwwX;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $cm4aA;
    var $bX4wk;
    var $1oqZx;
    var $cpBH7;
    const $1525c942fadb889f$var$QUERY_NAME = 'unscheduledItemsCalendarViewQuery';
    const $1525c942fadb889f$var$PAGE_SIZE = 50;
    const $1525c942fadb889f$export$a98876883b295850 = ({ sortDirection: sortDirection, jqlFilters: jqlFilters, jqlSimpleSearch: jqlSimpleSearch })=>{
        const [isInitialised, setIsInitialised] = (0, $5uXOq.useState)(false);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const variables = (0, $5uXOq.useMemo)(()=>{
            const jql = [
                (0, (0, parcelRequire("bX4wk")).UNSCHEDULED_ITEMS_JQL)
            ];
            if (jqlFilters) jql.push(jqlFilters);
            if (jqlSimpleSearch) jql.push(jqlSimpleSearch);
            return (0, (0, parcelRequire("egmQO")).getVariables)({
                jqlContext: jqlContext,
                fieldIds: (0, (0, parcelRequire("bX4wk")).CALENDAR_ITEM_FIELDS),
                sorting: {
                    sortBy: 'created',
                    direction: sortDirection
                },
                quickFiltersJql: `${jql.join(' AND ')}`
            });
        }, [
            jqlFilters,
            jqlSimpleSearch,
            jqlContext,
            sortDirection
        ]);
        const doFireErrorAnalytics = (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $1525c942fadb889f$var$QUERY_NAME,
                    packageName: 'jiraBusinessCalendar',
                    teamName: 'jira-yurree'
                },
                error: Array.isArray(error) && error.length > 0 ? error[0] : error,
                attributes: {
                    message: 'Failed to fetch unscheduled items in calendar'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const { loading: loading, error: error, data: data, loadFirstPage: loadFirstPage, isLoadingNextPage: isLoadingNextPage, loadNextPage: loadNextPage, refetch: refetch } = (0, (0, parcelRequire("cvbVg")).useJqlPagination)({
            variables: {
                cloudId: cloudId,
                ...variables,
                first: $1525c942fadb889f$var$PAGE_SIZE
            },
            query: (0, (0, parcelRequire("1oqZx")).QUERY),
            onError: (apolloError)=>{
                if (data) showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("cpBH7")).default).errorTitle,
                    description: (0, (0, parcelRequire("cpBH7")).default).errorMessage
                });
                doFireErrorAnalytics(apolloError);
            },
            onCompleted: (responseData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$1525c942fadb889f$var$QUERY_NAME} succeeded`, {
                    issueCount: (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(responseData, 'list')?.totalCount,
                    sortDirection: sortDirection,
                    isSearching: !!jqlSimpleSearch
                });
            },
            onPaginationError: doFireErrorAnalytics,
            fetchPolicy: 'cache-and-network'
        });
        (0, $5uXOq.useEffect)(()=>{
            loadFirstPage();
            setIsInitialised(true);
        }, []);
        const _data = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, 'list');
        const allUnscheduledItems = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("cm4aA")).transformData)({
                edges: _data?.edges || null,
                areUnscheduledItems: true
            }), [
            _data
        ]);
        const fetchNextPage = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$1525c942fadb889f$var$QUERY_NAME} loadNextPage`, {
                issueCount: _data?.totalCount
            });
            loadNextPage();
        }, [
            createAnalyticsEvent,
            _data?.totalCount,
            loadNextPage
        ]);
        return {
            loading: loading || !isInitialised,
            error: error,
            data: allUnscheduledItems,
            isLoadingNextPage: isLoadingNextPage,
            hasNextPage: _data?.pageInfo?.hasNextPage ?? false,
            loadNextPage: fetchNextPage,
            refetch: refetch
        };
    };
});
parcelRegister("1oqZx", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$ec8397060ddd51c5$export$2b91517d6d5b4365);
    var $5cllN;
    var $848a3;
    const $ec8397060ddd51c5$export$2b91517d6d5b4365 = (0, (0, parcelRequire("5cllN")).default)`
  query JWMCalendarUnscheduledItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${(0, (0, parcelRequire("848a3")).VIEW_ITEM_FRAGMENT)}
`;
});
parcelRegister("cpBH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4de8a59205553dd8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4de8a59205553dd8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "business-calendar.services.unscheduled-items.error-title",
            "defaultMessage": "Something's gone wrong"
        },
        errorMessage: {
            "id": "business-calendar.services.unscheduled-items.error-message",
            "defaultMessage": "Check your connection, then give it another try."
        }
    });
});
parcelRegister("iHu7r", function(module, exports) {
    $parcel$export(module.exports, "useWeekStartDay", ()=>$9175ac9cd3b8f130$export$e042842d4791d205);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $1p96B;
    var $DVljb;
    var $3sQ5x;
    var $iXqE5;
    var $2K3K9;
    const $9175ac9cd3b8f130$export$86880b4b2e1a2384 = 'calendar.week.start.day';
    const $9175ac9cd3b8f130$var$DEFAULT_WEEK_START_DAY = 0;
    const $9175ac9cd3b8f130$var$actions = {
        setWeekStartDay: (weekStartDay)=>({ setState: setState })=>setState({
                    weekStartDay: weekStartDay
                })
    };
    const $9175ac9cd3b8f130$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            weekStartDay: $9175ac9cd3b8f130$var$DEFAULT_WEEK_START_DAY
        },
        actions: $9175ac9cd3b8f130$var$actions,
        name: 'JWMCalendarWeekStartDayStore'
    });
    const $9175ac9cd3b8f130$var$useWeekStartDayStore = (0, (0, parcelRequire("3sQ5x")).createHook)($9175ac9cd3b8f130$var$Store);
    const $9175ac9cd3b8f130$export$e042842d4791d205 = ()=>{
        const localStorage = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2K3K9")).getLocalStorage)(), []);
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const [{ weekStartDay: weekStartDay }, { setWeekStartDay: setWeekStartDayHook }] = $9175ac9cd3b8f130$var$useWeekStartDayStore();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const startDay = localStorage.get($9175ac9cd3b8f130$export$86880b4b2e1a2384) ?? (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("1p96B")).getLocale)(locale), 'options.weekStartsOn', $9175ac9cd3b8f130$var$DEFAULT_WEEK_START_DAY);
            setWeekStartDayHook(startDay);
        }, [
            localStorage,
            locale,
            setWeekStartDayHook
        ]);
        const setWeekStartDay = (0, $5uXOq.useCallback)((startDay)=>{
            setWeekStartDayHook(startDay);
            try {
                localStorage.set($9175ac9cd3b8f130$export$86880b4b2e1a2384, startDay);
            } catch (e) {}
        }, [
            localStorage,
            setWeekStartDayHook
        ]);
        return [
            weekStartDay,
            setWeekStartDay
        ];
    };
});
parcelRegister("2K3K9", function(module, exports) {
    $parcel$export(module.exports, "getLocalStorage", ()=>$4c309be0bf0a7447$export$d3720feff416e85b);
    var $bSSG7;
    const $4c309be0bf0a7447$export$d3720feff416e85b = ()=>(0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_calendar-view');
});
parcelRegister("jQtQM", function(module, exports) {
    $parcel$export(module.exports, "CalendarIssue", ()=>$ae1174d68287898b$export$e6f76ba8cfa7d54a);
    $parcel$export(module.exports, "EventWrapper", ()=>$ae1174d68287898b$export$571dc7bd07acf6ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $ujWmd;
    var $4DXCl;
    var $8eD1D;
    var $3bDjY;
    var $1T1ir;
    var $cLGgz;
    var $jjlQu;
    var $gULOk;
    var $koVbs;
    var $4kK95;
    var $k2wwp;
    var $2IfYP;
    const $ae1174d68287898b$var$isBeforeToday = (dateOnly)=>(0, (0, parcelRequire("4kK95")).DateOnly).compare(dateOnly, (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(new Date())) === -1;
    const $ae1174d68287898b$var$getColorScheme = (statusCategoryId, isPast, formatMessage)=>{
        const { statusCategoryForId: statusCategoryForId, TODO: TODO, IN_PROGRESS: IN_PROGRESS, DONE: DONE } = (0, (0, parcelRequire("gULOk")));
        const statusCategory = statusCategoryForId(statusCategoryId);
        if (statusCategory !== DONE && isPast) return {
            backgroundColor: `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})`,
            color: `var(--ds-text-danger, ${0, $829f609a65d26a98$export$2837b5a1a71d5c02})`,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8eD1D"))))), {
                label: formatMessage((0, (0, parcelRequire("2IfYP")).default).overdueLabel),
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                size: "small"
            })
        };
        switch(statusCategory){
            case IN_PROGRESS:
                return {
                    backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                    color: `var(--ds-text-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`
                };
            case DONE:
                return {
                    backgroundColor: `var(--ds-background-success, ${0, $829f609a65d26a98$export$8a6341c32b6a3ee6})`,
                    color: `var(--ds-text-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4DXCl"))))), {
                        label: formatMessage((0, (0, parcelRequire("2IfYP")).default).doneLabel),
                        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
                        size: "small"
                    }),
                    opacity: isPast ? 0.8 : undefined
                };
            case TODO:
            default:
                return {
                    backgroundColor: `var(--ds-background-accent-gray-subtler, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                    color: `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                };
        }
    };
    const $ae1174d68287898b$var$empty = ()=>null;
    const $ae1174d68287898b$export$b0ef258570775578 = ({ summary: summary })=>{
        const highlight = (0, (0, parcelRequire("1T1ir")).useSimpleSearchHighlight)();
        const shouldHighlight = highlight.length > 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$var$IssueSummaryWrapper, null, shouldHighlight ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2wwp")).default), {
            highlight: highlight,
            text: summary
        }) : summary);
    };
    const $ae1174d68287898b$var$TEST_ID = 'business-calendar.ui.calendar-view.calendar-issue.event-wrapper';
    const $ae1174d68287898b$export$e6f76ba8cfa7d54a = ({ issue: issue, onClick: onClick })=>{
        const { key: key, summary: summary, duedate: duedate, assignee: assignee, iconUrl: iconUrl, statusCategoryId: statusCategoryId } = issue;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isDraggingAllowed = !(0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(issue.id);
        const tooltipMessage = (0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(issue.id) ? summary : `${key}: ${summary}`;
        const { icon: icon, backgroundColor: backgroundColor, color: color, opacity: opacity } = $ae1174d68287898b$var$getColorScheme(statusCategoryId, $ae1174d68287898b$var$isBeforeToday(duedate), formatMessage);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$export$571dc7bd07acf6ac, {
            backgroundColor: backgroundColor,
            color: color,
            "data-testid": $ae1174d68287898b$var$TEST_ID,
            isDraggingAllowed: isDraggingAllowed,
            onClick: isDraggingAllowed ? onClick : undefined,
            opacity: opacity
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$var$TypeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
            url: iconUrl,
            fallback: $ae1174d68287898b$var$empty
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$var$IssueWrapper, null, key, " ", (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$export$b0ef258570775578, {
            summary: summary
        })), Boolean(icon) && (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$var$IconWrapper, null, icon), assignee != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: assignee.displayName ?? null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ae1174d68287898b$var$AssigneeAvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            borderColor: "transparent",
            appearance: "circle",
            src: assignee.avatarUrl ?? undefined,
            size: "xsmall"
        })))));
    };
    const $ae1174d68287898b$var$IssueWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $ae1174d68287898b$var$AssigneeAvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18u01b66",
                __cmplp.className
            ])
        });
    });
    const $ae1174d68287898b$export$571dc7bd07acf6ac = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDraggingAllowed: isDraggingAllowed, backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_117mjwj": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor || 'transparent'),
                "--_yg3wm5": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color || 'inherit'),
                "--_ky1gp3": (0, (0, parcelRequire("lD23V")).default)(__cmplp.opacity || 1)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itidpf _1bsb1osq _y3gn1e5h _1yt418iy _1e0c116y _1n261g80 _1tkegktf _11c81oud _2rkoglpi _4cvr1h6o _bfhkrydl _syaz1qao _tzy44r9k",
                __cmplp.isDraggingAllowed ? "_80om1kw7" : "_80om13gf",
                __cmplp.className
            ])
        });
    });
    const $ae1174d68287898b$var$IssueSummaryWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48pbfng",
                __cmplp.className
            ])
        });
    });
    const $ae1174d68287898b$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $ae1174d68287898b$var$TypeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ipxbi _u5f3h9hh _4cvr1h6o _1bah1h6o _1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("8eD1D", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5fede72888329403$var$_react = $5fede72888329403$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5fede72888329403$var$_clock = $5fede72888329403$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $5fede72888329403$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5fede72888329403$var$EditorRecentIcon = (props)=>$5fede72888329403$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.305 12.282q.055.137.165.248l2 2a.75.75 0 0 0 1.06-1.06l-1.78-1.78V9a.75.75 0 1 0-1.5 0v3q.001.156.059.292ZM12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12"/></svg>`
        }, props, {
            newIcon: $5fede72888329403$var$_clock.default
        }));
    $5fede72888329403$var$EditorRecentIcon.displayName = 'EditorRecentIcon';
    var $5fede72888329403$var$_default = module.exports.default = $5fede72888329403$var$EditorRecentIcon;
});
parcelRegister("jjlQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f7206d8a029d15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4R6GH;
    const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                url: undefined,
                title: undefined,
                alt: undefined,
                width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                fallback: undefined
            };
        }
        render() {
            const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
            const width = this.convertSize(this.props.width);
            const height = this.convertSize(this.props.height);
            if (this.state.isBroken && fallback) return fallback();
            if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
                src: url,
                width: width,
                height: height,
                title: title ?? undefined,
                alt: alt ?? '',
                onError: this.onError,
                draggable: false
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('jfp-1020-use-compiled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $e7f7206d8a029d15$var$placeholderStyles,
                style: {
                    height: height,
                    width: width
                },
                backgroundColor: "color.background.input.hovered",
                testId: "common-components-async-icon.placeholder"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
                width: width,
                height: height,
                "data-testid": "common-components-async-icon.placeholder"
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isBroken: false
            };
            this.onError = ()=>{
                this.setState({
                    isBroken: true
                });
            };
            this.convertSize = (size)=>size ? `${size}px` : '0';
        }
    }
    const $e7f7206d8a029d15$var$ImagePlaceholder = (0, $47bDC.default).span.withConfig({
        componentId: "owe24v-0"
    })((props)=>({
            height: props.height,
            width: props.width,
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            borderRadius: '3px',
            display: 'flex',
            flex: 'none'
        }));
    const $e7f7206d8a029d15$var$placeholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    });
    const $e7f7206d8a029d15$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("k2wwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e37bd657627b5db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1H6kL;
    var $cM7El;
    const $5e37bd657627b5db$var$HighlightTextWithParser = (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
        const parts = (0, (0, parcelRequire("1H6kL")).getParts)(highlight, text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cM7El")).default), {
            parts: parts
        });
    });
    var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;
});
parcelRegister("1H6kL", function(module, exports) {
    $parcel$export(module.exports, "removeAccents", ()=>$0b92ef830f5aa8e4$export$f3f2882e8b11d731);
    $parcel$export(module.exports, "getParts", ()=>$0b92ef830f5aa8e4$export$a3aee8a24a54661f);
    var $8QDwl = parcelRequire("8QDwl");
    var $ajpes = parcelRequire("ajpes");
    var $3JOCw = parcelRequire("3JOCw");
    var $8QpSo;
    const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, (0, parcelRequire("8QpSo")).default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, (0, parcelRequire("8QpSo")).default)((highlight)=>{
        const escapedFilter = highlight.map((phrase)=>(0, ($parcel$interopDefault($8QDwl)))(phrase)).join('|');
        return new RegExp(escapedFilter, 'gmi');
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
    const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
            type: 'text',
            content: content
        });
    const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
            type: 'highlight',
            content: content
        });
    const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
        const ms = [];
        let m = regExp.exec(str);
        while(m){
            ms.push(m);
            m = regExp.exec(str);
        }
        return ms;
    };
    const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
        if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
            $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
        ];
        const parts = [];
        const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
        const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
        const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
        const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
        const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
        const highlightMatches = (0, ($parcel$interopDefault($3JOCw)))([
            ...textWithoutAccentsMatches,
            ...textMatches
        ], 'index');
        let currentPosition = 0;
        highlightMatches.forEach((match)=>{
            const matchText = text.slice(match.index, match.index + match[0].length);
            const leading = text.slice(currentPosition, match.index);
            if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
            parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
            currentPosition = match.index + matchText.length;
        });
        const trailing = text.slice(currentPosition);
        if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
        return parts;
    };
});
parcelRegister("cM7El", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328475be93221885$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e9H98;
    const $328475be93221885$var$HighlightText = ({ parts: parts })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
            if (part.type === 'text') return part.content;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9H98")).Mark), {
                key: i
            }, part.content);
        }));
    var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;
});
parcelRegister("e9H98", function(module, exports) {
    $parcel$export(module.exports, "Mark", ()=>$ef706e6c8afab51f$export$c9d15bcfc6d42044);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ef706e6c8afab51f$export$c9d15bcfc6d42044 = (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkwtfv _syaz1fxt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2IfYP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db2383b467dc5239$export$2e2bcd8739ae039);
    var $7VHMR;
    var $db2383b467dc5239$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        overdueLabel: {
            "id": "business-calendar.calendar-view.calendar-issue.overdue-label",
            "defaultMessage": "Overdue"
        },
        doneLabel: {
            "id": "business-calendar.calendar-view.calendar-issue.done-label",
            "defaultMessage": "Done"
        }
    });
});
parcelRegister("7w6wS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b3c3ad311ff0149$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $pyK8a;
    var $gULOk;
    var $4kK95;
    var $8YElJ;
    var $bao5F;
    const $5b3c3ad311ff0149$export$b5edfd83cea598db = ({ withInlineCreate: withInlineCreate, startStr: startStr, endStr: endStr, setOptimisticItem: setOptimisticItem, onDismiss: onDismiss, request: request, onCreatingStart: onCreatingStart, onCreatingStop: onCreatingStop })=>{
        const [isInlineCreateOpen, setIsInlineCreateOpen] = (0, $5uXOq.useState)(withInlineCreate);
        const { addToCache: addToCache } = (0, (0, parcelRequire("8YElJ")).useCacheActions)();
        const onPrepareIssueContext = (0, $5uXOq.useCallback)(()=>({
                startDate: new Date(startStr),
                dueDate: (0, (0, parcelRequire("pyK8a")).default)(new Date(endStr), 1)
            }), [
            startStr,
            endStr
        ]);
        const onSubmit = (0, $5uXOq.useCallback)(async (payload)=>{
            const optimisticItem = {
                summary: payload.optimisticIssuePayload.summary,
                issueTypeId: payload.optimisticIssuePayload.issueType.id,
                key: '',
                id: payload.optimisticIssuePayload.issueId,
                statusCategoryId: (0, (0, parcelRequire("gULOk")).StatusCategoryIds).new,
                assignee: null,
                duedate: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(new Date(payload.optimisticIssuePayload.dueDate)),
                startdate: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(new Date(payload.optimisticIssuePayload.startDate)),
                iconUrl: payload.optimisticIssuePayload.issueType.avatarUrl
            };
            setOptimisticItem(optimisticItem);
            setIsInlineCreateOpen(false);
            onCreatingStart();
            try {
                const newCalendarIssue = await payload.promise;
                if (newCalendarIssue) addToCache(request, newCalendarIssue);
            } catch (e) {} finally{
                setOptimisticItem(null);
                onCreatingStop();
            }
        }, [
            setOptimisticItem,
            onCreatingStart,
            addToCache,
            request,
            onCreatingStop
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5b3c3ad311ff0149$var$PlaceholderContainer, {
            "data-testid": "business-calendar.ui.calendar-view.calendar-placeholder"
        }, isInlineCreateOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bao5F")).default), {
            onClose: onDismiss,
            onPrepareIssueContext: onPrepareIssueContext,
            onSubmit: onSubmit,
            renderTrigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement($5b3c3ad311ff0149$var$Trigger, null))
        }));
    };
    var $5b3c3ad311ff0149$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5b3c3ad311ff0149$export$b5edfd83cea598db);
    const $5b3c3ad311ff0149$var$Trigger = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tke1f4h",
                __cmplp.className
            ])
        });
    });
    const $5b3c3ad311ff0149$var$PlaceholderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itidpf _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _80om73ad _1tke1f4h _2rko1y44 _bfhk29zg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8YElJ", function(module, exports) {
    $parcel$export(module.exports, "useCacheActions", ()=>$eec9e6681ed85995$export$f79bd85e41a6298f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $kRkJF;
    var $dAmbh;
    var $848a3;
    var $8Sqif;
    const $eec9e6681ed85995$export$f79bd85e41a6298f = ()=>{
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'calendar'
        });
        const startDateFieldId = startDateField?.id ? startDateField.id.split('_')[1] : null;
        const addToCache = (0, $5uXOq.useCallback)((request, newCalendarIssue)=>{
            const variables = {
                jql: (0, (0, parcelRequire("8Sqif")).toQuery)(request, quickFiltersJql, startDateFieldId)
            };
            const cacheData = client.readQuery({
                query: (0, (0, parcelRequire("848a3")).QUERY),
                variables: variables
            });
            client.writeQuery({
                query: (0, (0, parcelRequire("848a3")).QUERY),
                variables: variables,
                data: {
                    jira: {
                        ...cacheData.jira,
                        list: {
                            ...cacheData.jira.list,
                            edges: [
                                ...cacheData.jira.list.edges,
                                {
                                    node: newCalendarIssue,
                                    __typename: 'JiraWorkManagementViewItemEdge'
                                }
                            ]
                        }
                    }
                }
            });
        }, [
            client,
            quickFiltersJql,
            startDateFieldId
        ]);
        return {
            addToCache: addToCache
        };
    };
});
parcelRegister("bao5F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a54f2d1cd00c5ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lfTZh;
    var $kxZPA;
    const $0a54f2d1cd00c5ea$var$LazyIssueCreatePopover = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("l9Mzr")), {
        ssr: false,
        moduleId: "./src/packages/business/calendar/src/ui/calendar-view/calendar-placeholder/issue-create-popover/main.tsx"
    });
    var $0a54f2d1cd00c5ea$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-create-popover",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0a54f2d1cd00c5ea$var$LazyIssueCreatePopover, props));
});
parcelRegister("l9Mzr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4rjBB")
    ]).then(()=>parcelRequire('kA2G2'));
});
parcelRegister("1gwj3", function(module, exports) {
    $parcel$export(module.exports, "CalendarReleaseMultiProjectOnboardingModal", ()=>$176b6ae39efb5a91$export$95e7883b1d0193cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $kbqIt;
    var $cg6Y0;
    var $eGLgs;
    var $ivDCs;
    var $4mO32;
    var $2tT7R;
    var $9OXo1;
    var $8BVbI;
    const $176b6ae39efb5a91$export$e117a78df53fbda8 = 'jwm-show-multi_jsw_proj-releases-in-cal';
    const $176b6ae39efb5a91$export$ef6aa888835485ea = 'jwm_cal_show_multi_jsw_proj_releases';
    const $176b6ae39efb5a91$var$ENV_STAGING = 'staging';
    const $176b6ae39efb5a91$var$STARGATE_URL = '/gateway/api';
    function $176b6ae39efb5a91$export$95e7883b1d0193cc() {
        const MODAL_ENGAGEMENT_ID = (0, (0, parcelRequire("2tT7R")).useEnvironment)() === $176b6ae39efb5a91$var$ENV_STAGING ? $176b6ae39efb5a91$export$e117a78df53fbda8 : $176b6ae39efb5a91$export$ef6aa888835485ea;
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, $176b6ae39efb5a91$var$STARGATE_URL), [
            cloudId
        ]);
        const [isEnrolled, stopEnrolment] = (0, (0, parcelRequire("kbqIt")).useCoordination)(coordinationClient, MODAL_ENGAGEMENT_ID);
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("cg6Y0")).calendarReleasesModalEntrypoint), {});
        const [, moreMenuActions] = (0, (0, parcelRequire("8BVbI")).useCalendarMoreMenuStore)();
        const ctaAction = ()=>{
            stopEnrolment();
            moreMenuActions.open('jsw-multi-proj-release-modal');
        };
        const [modalLoaded, setModalLoaded] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isEnrolled && !modalLoaded) {
                setModalLoaded(true);
                entryPointActions.load();
            }
        }, [
            isEnrolled,
            entryPointActions,
            setModalLoaded,
            modalLoaded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            entryPointActions: entryPointActions,
            id: "calendar-releases-multi-projects-modal",
            packageName: "calendar-releases-multi-projects-modal",
            teamName: "jira-werewolves",
            runtimeProps: {
                onActionClick: ctaAction,
                onDismissClick: stopEnrolment
            }
        });
    }
});
parcelRegister("cg6Y0", function(module, exports) {
    $parcel$export(module.exports, "calendarReleasesModalEntrypoint", ()=>$6b561c7dc79e24c5$export$fac809ed8e6a4ff0);
    var $eufEc;
    var $fEDBv;
    const $6b561c7dc79e24c5$export$fac809ed8e6a4ff0 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("gkxsj")), {
            moduleId: "c4a8456b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("gkxsj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("89MA4").then(()=>parcelRequire('doXKl'));
});
parcelRegister("eGLgs", function(module, exports) {
    $parcel$export(module.exports, "CoordinationClient", ()=>$754c27d37ccd1133$export$580a2294c917898c);
    $parcel$export(module.exports, "default", ()=>$754c27d37ccd1133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZhen;
    var $jcYbC;
    var $8Mq6c;
    var $TTRxY;
    var $ioD1B;
    var $fG5AJ;
    var $10xFf;
    var $4Pf62;
    var $4R6GH;
    var $j8DrX;
    var $14XJw;
    var $7qPn9;
    const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    class $754c27d37ccd1133$export$580a2294c917898c extends (0, (0, parcelRequire("8Mq6c")).default) {
        constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
            const environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment'));
            const getEnvironmentType = (env)=>{
                if (env === 'prod') return (0, (0, parcelRequire("iZhen")).envType).PROD;
                if (env === 'staging') return (0, (0, parcelRequire("iZhen")).envType).STAGING;
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            };
            const enableChoreographer = (0, (0, parcelRequire("10xFf")).shouldBeChoreographed)({
                messageType: messageType
            }) && !isAlreadyChoreographedAtAncestor;
            const coordinationOptions = {
                enableChoreographer: enableChoreographer,
                envType: getEnvironmentType(environment),
                additionalData: {
                    sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
                }
            };
            super({
                cloudId: cloudId,
                stargateUrl: stargateUrl,
                orgId: orgId,
                isFedRAMPEnvironment: false,
                coordinationOptions: coordinationOptions
            });
            this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
            this.enableChoreographer = enableChoreographer;
            this.onMessageDisposition = onMessageDisposition;
            this.isDebugModeEnabled = (0, (0, parcelRequire("4R6GH")).fg)('ep-external-message-debug-mode');
        }
        async start(messageId) {
            if (this.isDebugModeEnabled) {
                const serverResponse = await super.start(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
                if (!shouldShowMessage) {
                    const didStop = await super.stop(messageId);
                    if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                }
                return shouldShowMessage;
            }
            return this.shouldUseMockClient ? false : super.start(messageId).then((didStart)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStart;
            });
        }
        async stop(messageId) {
            return this.shouldUseMockClient ? true : super.stop(messageId).then((didStop)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStop;
            });
        }
    }
    function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const stargateUrl = '/gateway/api';
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
        const { fallback: fallback, messageId: messageId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: client.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcYbC")).default), {
            client: client,
            fallback: fallback,
            messageId: messageId
        }, props.children));
    }
});
parcelRegister("ioD1B", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerContextProvider", ()=>$c141e5ba3428702a$export$c3226151caaf2fbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    const $c141e5ba3428702a$var$choreographedStatusContextValue = {
        isAlreadyChoreographedAtAncestor: true
    };
    const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
        return shouldUseChoreographerContextProvider ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG5AJ")).ChoreographedStatusContext).Provider, {
            value: $c141e5ba3428702a$var$choreographedStatusContextValue
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("ivDCs", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointContainer", ()=>$832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $8Bm0k;
    var $c5vfY;
    const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        const props = (0, $5uXOq.useMemo)(()=>({
                ...runtimeProps,
                onClose () {
                    runtimeProps.onClose?.();
                    unload();
                }
            }), [
            runtimeProps,
            unload
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, entryPointReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            errorFallback: errorFallback || 'flag',
            placeholderName: "modal-entry-point-container",
            runtimeProps: props
        }));
    };
});
parcelRegister("8BVbI", function(module, exports) {
    $parcel$export(module.exports, "useCalendarMoreMenuStore", ()=>$1100da4b45edc51a$export$4e9080c9be761eb2);
    var $3sQ5x;
    var $iXqE5;
    const $1100da4b45edc51a$export$d4c72bab9d6cc13a = {
        isOpen: false,
        openTrigger: null
    };
    const $1100da4b45edc51a$export$e324594224ef24da = {
        open: (trigger)=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    openTrigger: trigger
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false,
                    openTrigger: null
                });
            }
    };
    const $1100da4b45edc51a$export$719f730cf69cde03 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $1100da4b45edc51a$export$d4c72bab9d6cc13a,
        actions: $1100da4b45edc51a$export$e324594224ef24da,
        name: 'calendar-more-menu-store'
    });
    const $1100da4b45edc51a$export$4e9080c9be761eb2 = (0, (0, parcelRequire("3sQ5x")).createHook)($1100da4b45edc51a$export$719f730cf69cde03);
});
parcelRegister("NqSu5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9ccb05e08f8fb0a$export$2e2bcd8739ae039);
    var $kno24;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $8zOmE;
    var $2NMNM;
    var $eYxYU;
    var $6INXs;
    var $eRAtL;
    const $c9ccb05e08f8fb0a$export$f1fea2e43aec515a = ({ releaseRef: releaseRef })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onToggleMenu = ()=>setIsOpen((prevState)=>!prevState);
        const onCloseMenu = ()=>setIsOpen(false);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kno24")).default), releaseRef);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: onCloseMenu,
            placement: "top-start",
            shouldRenderToParent: true,
            autoFocus: false,
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYxYU")).ReleaseFlyout), {
                    versionRef: version,
                    onClose: onCloseMenu,
                    actionMenuItems: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eRAtL")).LearnMoreItem), {
                        onClosePopup: onCloseMenu
                    }),
                    opensReleaseInNewWindow: true
                }),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement($c9ccb05e08f8fb0a$var$EventWrapper, {
                    onClick: ()=>{
                        onToggleMenu();
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'calendarReleaseItem clicked', {
                            popupOpening: !isOpen
                        });
                    },
                    "data-testid": "business-calendar.ui.calendar-view.calendar-release-for-multiple-projects.event-wrapper"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6INXs")).default), {
                    size: "small"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $c9ccb05e08f8fb0a$var$releaseWrapperStyle
                }, version.name)))
        });
    };
    var $c9ccb05e08f8fb0a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c9ccb05e08f8fb0a$export$f1fea2e43aec515a);
    const $c9ccb05e08f8fb0a$var$EventWrapper = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itidpf _1bsb1osq _y3gn1e5h _1yt41sq2 _1e0c1txw _1n261g80 _80omtlke _1tkegktf _vwz4gktf _2rkoglpi _4cvr1h6o _bfhk1b0i _syaz15cr",
                __cmplp.className
            ])
        });
    });
    const $c9ccb05e08f8fb0a$var$releaseWrapperStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 500,
        lineHeight: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`
    });
});
parcelRegister("kno24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a163f5bdba5b3c0$export$2e2bcd8739ae039);
    const $3a163f5bdba5b3c0$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "calendarReleaseForMultipleProjects_businessCalendar",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_ReleaseFlyout"
            }
        ],
        "type": "JiraVersion"
    };
    $3a163f5bdba5b3c0$var$node.hash = "e339015d411a63c6030802c78dc22b59";
    var $3a163f5bdba5b3c0$export$2e2bcd8739ae039 = $3a163f5bdba5b3c0$var$node;
});
parcelRegister("eYxYU", function(module, exports) {
    $parcel$export(module.exports, "ReleaseFlyout", ()=>$677747f2a5adceb6$export$47d6fd1d733362d9);
    var $3vlSA;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4mBKK;
    var $8Uumt = parcelRequire("8Uumt");
    var $i28qQ;
    var $2Ljwn;
    var $lLLkM;
    var $jUUuf;
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $41j30;
    var $6xUNT;
    var $7IWsp;
    var $heNNl;
    var $4R6GH;
    var $koVbs;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $ce4pa;
    var $dnjeJ;
    var $4KeoM;
    var $1wnDu;
    var $gNRYR;
    var $9BwsJ;
    var $9lSpq;
    var $dxcuo;
    var $7qM12;
    var $1PFZf;
    const $677747f2a5adceb6$var$StatusLabel = {
        UNRELEASED: (0, (0, parcelRequire("1PFZf")).messages).unreleasedStatusLabel,
        RELEASED: (0, (0, parcelRequire("1PFZf")).messages).releasedStatusLabel,
        OVERDUE: (0, (0, parcelRequire("1PFZf")).messages).overdueStatusLabel
    };
    const $677747f2a5adceb6$var$LozengeAppearance = {
        UNRELEASED: 'inprogress',
        RELEASED: 'success',
        OVERDUE: 'removed'
    };
    const $677747f2a5adceb6$var$handleErrorBoundaryError = (viewReleaseFlyoutExperience)=>{
        viewReleaseFlyoutExperience.failure();
    };
    const $677747f2a5adceb6$export$3a3f842b4cca323c = ({ actionMenuItems: actionMenuItems, versionRef: versionRef, viewReleaseFlyoutExperience: viewReleaseFlyoutExperience, onClose: onClose, opensReleaseInNewWindow: opensReleaseInNewWindow = false })=>{
        (0, (0, parcelRequire("dnjeJ")).useUFOComponentExperience)(viewReleaseFlyoutExperience);
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("3vlSA")).default), versionRef);
        const doneCount = data.doneIssues?.totalCount ?? 0;
        const inprogressCount = data.inprogressIssues?.totalCount ?? 0;
        const todoCount = data.todoIssues?.totalCount ?? 0;
        const totalCount = doneCount + inprogressCount + todoCount;
        const donePercentage = totalCount > 0 ? doneCount / totalCount * 100 : 0;
        const [isOverdue, numberDaysOverdue] = (0, $5uXOq.useMemo)(()=>{
            const releaseDate = data.planScenarioValues?.releaseDate ?? data.releaseDate;
            const overdueDays = data.status !== 'RELEASED' && releaseDate != null ? Math.max((0, (0, parcelRequire("4mBKK")).default)(new Date(), (0, (0, parcelRequire("gNRYR")).toLocalDate)(releaseDate)), 0) : 0;
            return [
                overdueDays > 0,
                overdueDays
            ];
        }, [
            data
        ]);
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const onReleaseLinkClicked = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'releaseFlyout');
        }, []);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                isOverdue: isOverdue,
                isReleased: data.status === 'RELEASED'
            }), [
            data.status,
            isOverdue
        ]);
        const isNewlyAddedScenarioType = data.planScenarioValues?.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED;
        const startDate = data.planScenarioValues?.startDate ?? data.startDate;
        const releaseDate = data.planScenarioValues?.releaseDate ?? data.releaseDate;
        const versionName = data.planScenarioValues?.name ?? data.name;
        const description = data.planScenarioValues?.description !== null && data.planScenarioValues?.description !== undefined ? data.planScenarioValues?.description : data.description;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: "InlineDialog",
            sourceName: "releaseFlyout",
            attributes: analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $677747f2a5adceb6$var$containerStackStyles,
            space: "space.200",
            testId: "release-flyout.ui.stack",
            role: "group"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            xcss: $677747f2a5adceb6$var$titleContainerInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050",
            xcss: $677747f2a5adceb6$var$titleInlineStyles
        }, (0, (0, parcelRequire("4R6GH")).fg)('enghealth-12479-jsw-board-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
            spacing: "none",
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("jUUuf"))))),
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jUUuf"))))), {
            label: "",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$Title, null, formatMessage((0, (0, parcelRequire("1PFZf")).messages).releaseLabel))), actionMenuItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lSpq")).ActionsMenu), null, actionMenuItems), (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$CloseButton, {
            onClick: onClose,
            "data-testid": "release-flyout.ui.close-button"
        }, (0, (0, parcelRequire("4R6GH")).fg)('enghealth-12479-jsw-board-visual-refresh') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))), {
            spacing: "none",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))),
            label: formatMessage((0, (0, parcelRequire("1PFZf")).messages).closeButtonLabel),
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            label: formatMessage((0, (0, parcelRequire("1PFZf")).messages).closeButtonLabel),
            size: "small"
        }))), (data.status === 'RELEASED' || data.status === 'UNRELEASED') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignBlock: "start",
            space: "space.050",
            xcss: $677747f2a5adceb6$var$fieldValueInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "release-flyout.ui.status",
            appearance: $677747f2a5adceb6$var$LozengeAppearance[isOverdue ? 'OVERDUE' : data.status]
        }, formatMessage($677747f2a5adceb6$var$StatusLabel[isOverdue ? 'OVERDUE' : data.status])))), isOverdue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignInline: "end",
            space: "space.050",
            xcss: $677747f2a5adceb6$var$fieldValueInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$OverdueDays, {
            "data-testid": "release-flyout.ui.overdue-warning"
        }, formatMessage((0, (0, parcelRequire("1PFZf")).messages).overdueDaysLabel, {
            numberDaysOverdue: numberDaysOverdue
        })))), versionName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$nameInlineStyles
        }, !isNewlyAddedScenarioType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            "data-testid": "release-flyout.ui.link",
            to: `/projects/${data.project?.key}/versions/${data.versionId}`,
            style: {
                color: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            },
            onClick: onReleaseLinkClicked,
            ...opensReleaseInNewWindow ? {
                target: '_blank',
                rel: 'noreferrer'
            } : {}
        }, versionName) : versionName, data.planScenarioValues?.name && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wnDu")).ChangeIndicator), null)), description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$descriptionInlineStyles
        }, description, data.planScenarioValues?.description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wnDu")).ChangeIndicator), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: "release-flyout.ui.progress",
            space: "space.050",
            xcss: $677747f2a5adceb6$var$progressContainerStackStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            spread: "space-between",
            xcss: $677747f2a5adceb6$var$fieldLabelInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage((0, (0, parcelRequire("1PFZf")).messages).progressLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$ProgressPercentage, null, `${formatMessage((0, (0, parcelRequire("1PFZf")).messages).doneProgressLabel, {
            percent: Math.floor(donePercentage)
        })}`)), doneCount || inprogressCount || todoCount ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xUNT")).default), {
            sum: totalCount,
            height: (0, (0, parcelRequire("dxcuo")).PROGRESS_BAR_HEIGHT),
            borderRadius: (0, (0, parcelRequire("dxcuo")).PROGRESS_BAR_BORDER_RADIUS)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
            value: doneCount,
            color: (0, (0, parcelRequire("dxcuo")).DONE_COLOR),
            tooltipContent: formatMessage((0, (0, parcelRequire("1PFZf")).messages).doneToolTipsText, {
                count: doneCount,
                totalCount: totalCount
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
            value: inprogressCount,
            color: (0, (0, parcelRequire("dxcuo")).IN_PROGRESS_COLOR),
            tooltipContent: formatMessage((0, (0, parcelRequire("1PFZf")).messages).inProgressToolTipsText, {
                count: inprogressCount,
                totalCount: totalCount
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
            value: todoCount,
            color: (0, (0, parcelRequire("dxcuo")).TODO_COLOR),
            tooltipContent: formatMessage((0, (0, parcelRequire("1PFZf")).messages).toDoToolTipsText, {
                count: todoCount,
                totalCount: totalCount
            })
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$EmptyProgressBar, null)), (startDate || releaseDate) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, startDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: "release-flyout.ui.start-date",
            alignBlock: "start",
            space: "space.050",
            xcss: $677747f2a5adceb6$var$fieldValueInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$fieldLabelInlineStyles
        }, formatMessage((0, (0, parcelRequire("1PFZf")).messages).startDateLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $677747f2a5adceb6$var$wrapperStyles
        }, formatDate((0, (0, parcelRequire("gNRYR")).toLocalDate)(startDate), (0, (0, parcelRequire("4KeoM")).DEFAULT_FORMAT_DATE_OPTIONS)), data.planScenarioValues?.startDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wnDu")).ChangeIndicator), null))), releaseDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: "release-flyout.ui.release-date",
            alignBlock: "start",
            space: "space.050",
            xcss: [
                $677747f2a5adceb6$var$fieldValueInlineStyles,
                isOverdue && $677747f2a5adceb6$var$overdueTextStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$fieldLabelInlineStyles
        }, formatMessage((0, (0, parcelRequire("1PFZf")).messages).releaseDateLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $677747f2a5adceb6$var$wrapperStyles
        }, formatDate((0, (0, parcelRequire("gNRYR")).toLocalDate)(releaseDate), (0, (0, parcelRequire("4KeoM")).DEFAULT_FORMAT_DATE_OPTIONS)), data.planScenarioValues?.releaseDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wnDu")).ChangeIndicator), null)))), data.project?.name && data.project?.avatar?.xsmall && data.project?.projectTypeName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: "release-flyout.ui.project",
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$fieldLabelInlineStyles
        }, formatMessage((0, (0, parcelRequire("1PFZf")).messages).projectLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$ProjectAvatar, {
            alt: `${data.project.name} project avatar`,
            src: data.project.avatar.xsmall
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $677747f2a5adceb6$var$projectNameStyles
        }, data.project.name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $677747f2a5adceb6$var$projectMetadataStyles
        }, data.project.projectTypeName)))), data.driver?.name && data.driver?.picture && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: "release-flyout.ui.driver",
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $677747f2a5adceb6$var$fieldLabelInlineStyles
        }, formatMessage((0, (0, parcelRequire("1PFZf")).messages).driverLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $677747f2a5adceb6$var$fieldValueInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$var$DriverAvatar, {
            alt: `${data.driver.name} avatar`,
            src: data.driver.picture
        }), data.driver.name)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ce4pa")).ExperienceSuccess), {
            experience: viewReleaseFlyoutExperience
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $677747f2a5adceb6$export$47d6fd1d733362d9 = (props)=>{
        const { location: location, suffixKey: suffixKey } = (0, (0, parcelRequire("9BwsJ")).useReleaseFlyoutUFOExperienceContext)();
        const viewReleaseFlyoutExperience = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qM12")).createViewReleaseFlyoutExperience)(location, suffixKey), [
            location,
            suffixKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "release-flyout",
            packageName: "jiraReleaseFlyout",
            teamName: "a4t-tanuki",
            onError: ()=>$677747f2a5adceb6$var$handleErrorBoundaryError(viewReleaseFlyoutExperience)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$export$3a3f842b4cca323c, {
            viewReleaseFlyoutExperience: viewReleaseFlyoutExperience,
            ...props
        }));
    };
    const $677747f2a5adceb6$var$ReleaseFlyoutEntryPoint = ({ props: props })=>{
        const { location: location, suffixKey: suffixKey } = (0, (0, parcelRequire("9BwsJ")).useReleaseFlyoutUFOExperienceContext)();
        const viewReleaseFlyoutExperience = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qM12")).createViewReleaseFlyoutExperience)(location, suffixKey), [
            location,
            suffixKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($677747f2a5adceb6$export$3a3f842b4cca323c, {
            viewReleaseFlyoutExperience: viewReleaseFlyoutExperience,
            ...props
        });
    };
    var $677747f2a5adceb6$export$2e2bcd8739ae039 = $677747f2a5adceb6$var$ReleaseFlyoutEntryPoint;
    const $677747f2a5adceb6$var$containerStackStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200',
        width: '280px'
    });
    const $677747f2a5adceb6$var$titleContainerInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: "var(--ds-space-300, 24px)"
    });
    const $677747f2a5adceb6$var$titleInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        color: 'color.text.subtlest'
    });
    const $677747f2a5adceb6$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "h6", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1kw7 _11c816g6",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$CloseButton = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw _11q7glyw _80omtlke",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$nameInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: 'font.body.large',
        fontWeight: 500,
        lineHeight: '23px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        position: 'relative'
    });
    const $677747f2a5adceb6$var$descriptionInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        position: 'relative'
    });
    const $677747f2a5adceb6$var$progressContainerStackStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.050',
        marginBottom: 'space.100'
    });
    const $677747f2a5adceb6$var$fieldValueInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text'
    });
    const $677747f2a5adceb6$var$fieldLabelInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text.subtle'
    });
    const $677747f2a5adceb6$var$projectNameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text'
    });
    const $677747f2a5adceb6$var$projectMetadataStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text.subtlest'
    });
    const $677747f2a5adceb6$var$overdueTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.red'
    });
    const $677747f2a5adceb6$var$ProjectAvatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ejb _1bsb1ejb _2rko1sit",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$ProgressPercentage = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1qfn",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$EmptyProgressBar = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _4t3ii2wt _11q71t45 _2rko1psr _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$DriverAvatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ejb _1bsb1ejb _2rko1ssb",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$OverdueDays = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c816g6 _syazmut4",
                __cmplp.className
            ])
        });
    });
    const $677747f2a5adceb6$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        display: 'block'
    });
});
parcelRegister("3vlSA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffb3fd504d48b47d$export$2e2bcd8739ae039);
    const $ffb3fd504d48b47d$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "name"
        }, v1 = {
            "kind": "ScalarField",
            "name": "description"
        }, v2 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v3 = {
            "kind": "ScalarField",
            "name": "releaseDate"
        }, v4 = [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ];
        return {
            "argumentDefinitions": [
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "viewId"
                }
            ],
            "kind": "Fragment",
            "name": "ui_ReleaseFlyout",
            "selections": [
                v0,
                v1,
                v2,
                v3,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "versionId"
                },
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v0,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectTypeName"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                        v0,
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                },
                {
                    "alias": "doneIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": "DONE"
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": v4,
                    "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
                },
                {
                    "alias": "inprogressIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": "IN_PROGRESS"
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": v4,
                    "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
                },
                {
                    "alias": "todoIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": "TODO"
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": v4,
                    "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraVersionPlanScenarioValues",
                    "kind": "LinkedField",
                    "name": "planScenarioValues",
                    "plural": false,
                    "selections": [
                        v0,
                        {
                            "kind": "ScalarField",
                            "name": "scenarioType"
                        },
                        v2,
                        v3,
                        v1
                    ]
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $ffb3fd504d48b47d$var$node.hash = "e3708200d327829cca2acf59f693f184";
    var $ffb3fd504d48b47d$export$2e2bcd8739ae039 = $ffb3fd504d48b47d$var$node;
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("6xUNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d12efc7cca969bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $7IWsp;
    class $d12efc7cca969bbb$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                children: null,
                sum: 0,
                remainingTooltipContent: '',
                backgroundColor: (0, $829f609a65d26a98$exports).N30,
                height: 10
            };
        }
        validateElementsAndCalculateElementsWidth() {
            const { children: children } = this.props;
            let sumOfElementsValues = 0;
            const validatedElements = [];
            (0, $5uXOq.Children).map(children, (child)=>{
                const childEl = child;
                if (childEl.props.value && childEl.props.value > 0) {
                    sumOfElementsValues += childEl.props.value;
                    validatedElements.push(childEl);
                }
            });
            return {
                validatedElements: validatedElements,
                elementsSum: sumOfElementsValues
            };
        }
        render() {
            const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding } = this.props;
            if (!children) return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: backgroundColor,
                elementsGrow: 0,
                elementsHeight: height,
                borderRadius: borderRadius
            });
            const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
            const remaining = sum - elementsSum;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                ...this.props,
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
                elementsHeight: height,
                borderRadius: borderRadius,
                tooltipHoverPadding: tooltipHoverPadding,
                role: "status",
                ariaLive: "polite"
            }, validatedElements, remaining > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
                value: remaining,
                tooltipContent: remainingTooltipContent,
                color: backgroundColor,
                tooltipHoverPadding: tooltipHoverPadding
            }));
        }
    }
    const $d12efc7cca969bbb$var$ProgressWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1750df9-0"
    })`width:100%;height:${(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
        const radius = `${borderRadius || elementsHeight / 2}px`;
        return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
    }}}`;
    $d12efc7cca969bbb$var$ProgressWrapper.displayName = 'ProgressWrapper';
});
parcelRegister("7IWsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719ee7d438676972$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $3bDjY;
    const $719ee7d438676972$var$SingleElementWithTooltip = (props)=>{
        const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
        const TooltipTag = (0, $5uXOq.useMemo)(()=>(0, $5uXOq.forwardRef)((tagProps, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                    elementGrow: value,
                    color: color,
                    innerRef: ref,
                    tooltipHoverPadding: tooltipHoverPadding,
                    ...tagProps,
                    ...typeof tooltipContent === 'string' ? {
                        role: 'button',
                        'aria-label': tooltipContent,
                        alt: tooltipContent,
                        tabIndex: 0
                    } : {}
                })), [
            color,
            value,
            tooltipContent,
            tooltipHoverPadding
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            position: position,
            tag: TooltipTag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null)));
    };
    class $719ee7d438676972$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                value: 0,
                tooltipContent: ''
            };
        }
        render() {
            const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
            const hasTooltipContent = Boolean(tooltipContent);
            if (hasTooltipContent) return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElementWithTooltip, {
                ...this.props,
                tooltipContent: tooltipContent
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                elementGrow: value,
                color: color,
                alt: tooltipContent
            });
        }
    }
    const $719ee7d438676972$var$SingleElement = (0, $47bDC.default).div.withConfig({
        componentId: "sc-234u1k-0"
    })`flex-grow:${(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
    $719ee7d438676972$var$SingleElement.displayName = 'SingleElement';
});
parcelRegister("TTKUQ", function(module, exports) {
    $parcel$export(module.exports, "DefaultDateFormat", ()=>$5e0415637054ea24$export$14ae725d0cc7daa1);
    $parcel$export(module.exports, "EXPORT_FILE_DATE_FORMAT", ()=>$5e0415637054ea24$export$363270f5bff80927);
    $parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", ()=>$5e0415637054ea24$export$c8c7cce628cf5c4e);
    $parcel$export(module.exports, "DIRECTIONS", ()=>$5e0415637054ea24$export$4aabe0d20c9c03b3);
    $parcel$export(module.exports, "PLANNING_UNITS", ()=>$5e0415637054ea24$export$c56f9fa2106f4847);
    $parcel$export(module.exports, "CROSS_PROJECT_RELEASE", ()=>$5e0415637054ea24$export$7b04eb9e81ba1c56);
    $parcel$export(module.exports, "NONE", ()=>$5e0415637054ea24$export$c53d0f541b41b88e);
    $parcel$export(module.exports, "PROJECT", ()=>$5e0415637054ea24$export$fe791c4fa892e400);
    $parcel$export(module.exports, "RELEASE", ()=>$5e0415637054ea24$export$5c698591c0e586a2);
    $parcel$export(module.exports, "ASCENDING", ()=>$5e0415637054ea24$export$6e386ac144cffab5);
    $parcel$export(module.exports, "DEFAULT", ()=>$5e0415637054ea24$export$e6952b12ade67489);
    $parcel$export(module.exports, "LINES", ()=>$5e0415637054ea24$export$e0de529f548a9140);
    $parcel$export(module.exports, "COUNT", ()=>$5e0415637054ea24$export$d61684373eacdf61);
    $parcel$export(module.exports, "ENTITY", ()=>$5e0415637054ea24$export$fa20de1d199f87ac);
    $parcel$export(module.exports, "SCENARIO_TYPE", ()=>$5e0415637054ea24$export$6952e648aa2551c8);
    $parcel$export(module.exports, "GROUPING", ()=>$5e0415637054ea24$export$a9c30cbc241a4f57);
    $parcel$export(module.exports, "STRING", ()=>$5e0415637054ea24$export$a0e01ba2ebef17f2);
    $parcel$export(module.exports, "ISSUE_FIELD_TYPES", ()=>$5e0415637054ea24$export$a8827164bd516a88);
    $parcel$export(module.exports, "SORT_DIRECTION", ()=>$5e0415637054ea24$export$2e66878530bcbbc7);
    $parcel$export(module.exports, "COMPLETED_SPRINTS_GROUP", ()=>$5e0415637054ea24$export$cc61be5f9aa609ee);
    $parcel$export(module.exports, "COMPLETED_RELEASES_GROUP", ()=>$5e0415637054ea24$export$93d3dc39c0269fe3);
    $parcel$export(module.exports, "RELEASE_STATUSES", ()=>$5e0415637054ea24$export$7082e4b62554b72d);
    $parcel$export(module.exports, "RELEASE_STATUSES_APPEARANCE_SPA", ()=>$5e0415637054ea24$export$311d2f5af921faaa);
    $parcel$export(module.exports, "CustomFieldTypes", ()=>$5e0415637054ea24$export$331c42b4f42400fb);
    $parcel$export(module.exports, "CustomFieldTypesToDataType", ()=>$5e0415637054ea24$export$fea945adb3660cc7);
    $parcel$export(module.exports, "CustomFields", ()=>$5e0415637054ea24$export$a1d1fd7da6e94a65);
    $parcel$export(module.exports, "PREVIEW_OPACITY", ()=>$5e0415637054ea24$export$8ffcc37b9e9dd572);
    $parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES_CONST", ()=>$5e0415637054ea24$export$16f1a8408ee71016);
    $parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES", ()=>$5e0415637054ea24$export$2b1f4448b6b508db);
    $parcel$export(module.exports, "ISSUE_STATUS_APPEARANCE", ()=>$5e0415637054ea24$export$86fc137548f2fce5);
    $parcel$export(module.exports, "SPRINT_STATES", ()=>$5e0415637054ea24$export$73a0206a4dc59760);
    $parcel$export(module.exports, "EXTERNAL_SPRINT", ()=>$5e0415637054ea24$export$f1b6d0605ff9b7e6);
    $parcel$export(module.exports, "DEFAULT_FIELD_WIDTH", ()=>$5e0415637054ea24$export$e5d805200f62f81d);
    $parcel$export(module.exports, "SCOPE_ROW_HEIGHT", ()=>$5e0415637054ea24$export$6edf6d7514b31ffa);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_SCOPE_WIDTH", ()=>$5e0415637054ea24$export$a705d305be7bd15d);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_FIELDS_WIDTH", ()=>$5e0415637054ea24$export$9a8b9408dd2830b);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH", ()=>$5e0415637054ea24$export$4cd768253686885b);
    $parcel$export(module.exports, "NUM_ISSUES_IN_EXPORT_PREVIEW", ()=>$5e0415637054ea24$export$36a3ce28e91ef989);
    $parcel$export(module.exports, "AUTO_SCHEDULE_OVERWRITE", ()=>$5e0415637054ea24$export$de3ef5bf994b7018);
    $parcel$export(module.exports, "ISSUE_VALUES", ()=>$5e0415637054ea24$export$f9c0c7ff9184db0);
    $parcel$export(module.exports, "PlanningUnits", ()=>$5e0415637054ea24$export$448fe702ac76034a);
    $parcel$export(module.exports, "UNDEFINED_KEY", ()=>$5e0415637054ea24$export$75989ea7860b85e9);
    $parcel$export(module.exports, "STICKY_HEADER_CONTAINER_PREFIX", ()=>$5e0415637054ea24$export$6bc4f75201f6f12e);
    $parcel$export(module.exports, "CHECKBOX_STATES", ()=>$5e0415637054ea24$export$e3c19de1b019757c);
    $parcel$export(module.exports, "PLUGIN_PERMISSION", ()=>$5e0415637054ea24$export$3bf3c26d6d69f3b1);
    $parcel$export(module.exports, "SHARE_AS", ()=>$5e0415637054ea24$export$40628b030ac72445);
    $parcel$export(module.exports, "SCHEDULE_MODE", ()=>$5e0415637054ea24$export$5b1b1523594baa6e);
    $parcel$export(module.exports, "INSTANCE_USER_ROLE", ()=>$5e0415637054ea24$export$b4d5766fd1973953);
    $parcel$export(module.exports, "PLAN_USER_ROLE", ()=>$5e0415637054ea24$export$183f45c476faaff2);
    $parcel$export(module.exports, "ISSUE_LINK_DIRECTION", ()=>$5e0415637054ea24$export$deea8c9ae0e3c1ca);
    $parcel$export(module.exports, "ISSUE_SOURCE_TYPES", ()=>$5e0415637054ea24$export$86e2f9653c14c34);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$5e0415637054ea24$export$f048d91ccaf92408);
    $parcel$export(module.exports, "PROFILE_KEYS", ()=>$5e0415637054ea24$export$4eb5c0330ef8fab4);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5e0415637054ea24$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", ()=>$5e0415637054ea24$export$f27a837467ec20e5);
    $parcel$export(module.exports, "ERROR_REPORTING_TEAM", ()=>$5e0415637054ea24$export$cfeee2ee86ead336);
    $parcel$export(module.exports, "MAX_BULK_CHANGE_ISSUES", ()=>$5e0415637054ea24$export$bf7af18c7898a31);
    $parcel$export(module.exports, "DEPENDENCY_SETTINGS", ()=>$5e0415637054ea24$export$37e30ab04b9b1705);
    $parcel$export(module.exports, "HORIZONTAL_SCROLL_OFFSET", ()=>$5e0415637054ea24$export$e24665e8d921f93e);
    $parcel$export(module.exports, "PROJECT_TYPE_KEY", ()=>$5e0415637054ea24$export$22ed55708a9d1966);
    $parcel$export(module.exports, "ZOOM_LEVELS", ()=>$5e0415637054ea24$export$8b7222fa92892b49);
    $parcel$export(module.exports, "TIMELINE_MODES", ()=>$5e0415637054ea24$export$bbbec7054427e57b);
    $parcel$export(module.exports, "CUSTOM_DATE_RANGES", ()=>$5e0415637054ea24$export$b0f7807f8d64b44a);
    $parcel$export(module.exports, "VALID_LEADING_TIME_FOR_DEPENDENCIES", ()=>$5e0415637054ea24$export$46a3b4b81e5a44ac);
    $parcel$export(module.exports, "NOTIFY_WATCHERS_KEY", ()=>$5e0415637054ea24$export$954b02519e22ad3c);
    $parcel$export(module.exports, "TIMELINE_SHARE_TYPE", ()=>$5e0415637054ea24$export$cb60c924e8198091);
    $parcel$export(module.exports, "DEPENDENCY_REPORT_SHARE_TYPE", ()=>$5e0415637054ea24$export$16c8656f8d888a96);
    $parcel$export(module.exports, "SECTION_KEYS", ()=>$5e0415637054ea24$export$d37ffa307efd6838);
    $parcel$export(module.exports, "SECTION_ITEM_KEYS", ()=>$5e0415637054ea24$export$cb4feb832f4bb576);
    $parcel$export(module.exports, "ORIGINAL_STATUS_TRANSITION", ()=>$5e0415637054ea24$export$ce125fc0306b71a0);
    $parcel$export(module.exports, "BREAKDOWN_SPRINT_CAPACITY_BY", ()=>$5e0415637054ea24$export$c773c9bd947df9ae);
    $parcel$export(module.exports, "IPH_IDS", ()=>$5e0415637054ea24$export$253194752488840a);
    var $flnZx;
    const $5e0415637054ea24$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
    const $5e0415637054ea24$export$1d279fd478aab274 = 'dd/MMM/yy';
    const $5e0415637054ea24$export$10b28f765b682c36 = 'yyyy-MM-dd';
    const $5e0415637054ea24$export$ce46174a69ff80b3 = 'DD MMM YYYY h:mma';
    const $5e0415637054ea24$export$4255b3d650213d61 = 'D MMM';
    const $5e0415637054ea24$export$cc2582ada357cd5 = 'D MMM YYYY';
    const $5e0415637054ea24$export$363270f5bff80927 = 'DDMMYYYY';
    const $5e0415637054ea24$export$c8c7cce628cf5c4e = 'SCEN-';
    const $5e0415637054ea24$export$4aabe0d20c9c03b3 = {
        AFTER: 'after',
        BEFORE: 'before'
    };
    const $5e0415637054ea24$export$c56f9fa2106f4847 = {
        STORY_POINTS: 'StoryPoints',
        DAYS: 'Days',
        HOURS: 'Hours'
    };
    const $5e0415637054ea24$export$f8f7545d2bb78afb = 'ASSIGNEE';
    const $5e0415637054ea24$export$6d7021166edc895c = 'REPORTER';
    const $5e0415637054ea24$export$af1e30ebbae9df3b = 'COMPONENT';
    const $5e0415637054ea24$export$3d393c30a30490eb = 'GOALS';
    const $5e0415637054ea24$export$a75a0417fc96ea63 = 'IDEAS';
    const $5e0415637054ea24$export$7b04eb9e81ba1c56 = 'CROSS_PROJECT_RELEASE';
    const $5e0415637054ea24$export$76a449e52fa0e1e8 = 'ISSUE';
    const $5e0415637054ea24$export$37aee82a3cb1e8f7 = 'LABEL';
    const $5e0415637054ea24$export$c53d0f541b41b88e = 'NONE';
    const $5e0415637054ea24$export$fe791c4fa892e400 = 'PROJECT';
    const $5e0415637054ea24$export$5c698591c0e586a2 = 'RELEASE';
    const $5e0415637054ea24$export$84ba8fa7099b85b = 'RESOURCE';
    const $5e0415637054ea24$export$bc8b984358922f81 = 'TEAM';
    const $5e0415637054ea24$export$c3d7e0f1e63de60e = 'RANK';
    const $5e0415637054ea24$export$6e386ac144cffab5 = 'ASCENDING';
    const $5e0415637054ea24$export$f634ff5a7f1c8f3 = 'DESCENDING';
    const $5e0415637054ea24$export$a316570a0dbfd2b0 = 'SPRINT';
    const $5e0415637054ea24$export$3e0a40c59fa4032 = 'PLANNED_CAPACITY';
    const $5e0415637054ea24$export$e6952b12ade67489 = 'default';
    const $5e0415637054ea24$export$e0de529f548a9140 = 'lines';
    const $5e0415637054ea24$export$d61684373eacdf61 = 'count';
    const $5e0415637054ea24$export$fa20de1d199f87ac = {
        ISSUE: $5e0415637054ea24$export$76a449e52fa0e1e8,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        CROSS_PROJECT_RELEASE: $5e0415637054ea24$export$7b04eb9e81ba1c56,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81,
        RESOURCE: $5e0415637054ea24$export$84ba8fa7099b85b,
        PLANNED_CAPACITY: $5e0415637054ea24$export$3e0a40c59fa4032,
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
        NONE: $5e0415637054ea24$export$c53d0f541b41b88e
    };
    const $5e0415637054ea24$export$6952e648aa2551c8 = {
        ADDED: 'ADDED',
        UPDATED: 'UPDATED',
        DELETED: 'DELETED',
        DELETEDFROMJIRA: 'DELETEDFROMJIRA',
        NONE: 'NONE',
        MULTIPLE: 'MULTIPLE',
        EXCLUDED: 'EXCLUDED',
        ADDEDEXISTING: 'ADDEDEXISTING',
        UNKNOWN: 'UNKNOWN'
    };
    const $5e0415637054ea24$export$a9c30cbc241a4f57 = {
        NONE: $5e0415637054ea24$export$c53d0f541b41b88e,
        ASSIGNEE: $5e0415637054ea24$export$f8f7545d2bb78afb,
        COMPONENT: $5e0415637054ea24$export$af1e30ebbae9df3b,
        GOALS: $5e0415637054ea24$export$3d393c30a30490eb,
        IDEAS: $5e0415637054ea24$export$a75a0417fc96ea63,
        LABEL: $5e0415637054ea24$export$37aee82a3cb1e8f7,
        PROJECT: $5e0415637054ea24$export$fe791c4fa892e400,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        REPORTER: $5e0415637054ea24$export$6d7021166edc895c,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81,
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0
    };
    const $5e0415637054ea24$export$a0e01ba2ebef17f2 = 'string';
    const $5e0415637054ea24$export$501a7fac1df67a49 = 'date';
    const $5e0415637054ea24$export$4e8bcd47a31d751c = 'number';
    const $5e0415637054ea24$export$a8827164bd516a88 = {
        DATE: $5e0415637054ea24$export$501a7fac1df67a49,
        STRING: $5e0415637054ea24$export$a0e01ba2ebef17f2,
        NUMBER: $5e0415637054ea24$export$4e8bcd47a31d751c
    };
    const $5e0415637054ea24$export$2e66878530bcbbc7 = {
        ASCENDING: $5e0415637054ea24$export$6e386ac144cffab5,
        DESCENDING: $5e0415637054ea24$export$f634ff5a7f1c8f3
    };
    const $5e0415637054ea24$export$cc61be5f9aa609ee = 'COMPLETED_SPRINTS_GROUP';
    const $5e0415637054ea24$export$93d3dc39c0269fe3 = 'COMPLETED_RELEASES_GROUP';
    const $5e0415637054ea24$var$UNRELEASED = '0';
    const $5e0415637054ea24$var$RELEASED = '1';
    const $5e0415637054ea24$var$OFFTRACK = '2';
    const $5e0415637054ea24$var$ONTRACK = '3';
    const $5e0415637054ea24$export$7082e4b62554b72d = {
        UNRELEASED: $5e0415637054ea24$var$UNRELEASED,
        RELEASED: $5e0415637054ea24$var$RELEASED,
        OFFTRACK: $5e0415637054ea24$var$OFFTRACK,
        ONTRACK: $5e0415637054ea24$var$ONTRACK
    };
    const $5e0415637054ea24$export$311d2f5af921faaa = {
        [$5e0415637054ea24$var$UNRELEASED]: 'inprogress',
        [$5e0415637054ea24$var$RELEASED]: 'success',
        [$5e0415637054ea24$var$OFFTRACK]: 'removed',
        [$5e0415637054ea24$var$ONTRACK]: 'inprogress'
    };
    const $5e0415637054ea24$export$331c42b4f42400fb = {
        AssetObject: 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype',
        TextField: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        SingleSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
        MultiSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
        DatePicker: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
        NumberField: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        MultiCheckboxes: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
        RadioButtons: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
        UserPicker: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
        Url: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
        Labels: 'com.atlassian.jira.plugin.system.customfieldtypes:labels'
    };
    const $5e0415637054ea24$export$fea945adb3660cc7 = {
        [$5e0415637054ea24$export$331c42b4f42400fb.DatePicker]: $5e0415637054ea24$export$a8827164bd516a88.DATE,
        [$5e0415637054ea24$export$331c42b4f42400fb.NumberField]: $5e0415637054ea24$export$a8827164bd516a88.NUMBER,
        [$5e0415637054ea24$export$331c42b4f42400fb.SingleSelect]: $5e0415637054ea24$export$a8827164bd516a88.STRING
    };
    const $5e0415637054ea24$export$a1d1fd7da6e94a65 = {
        WritableFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.DatePicker,
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.NumberField,
            $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.TextField,
            $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
        ],
        ReadOnlyFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.Url,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ],
        FilterableFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ],
        GroupableSingleValueFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
        ],
        GroupableMultiValueFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ]
    };
    const $5e0415637054ea24$export$8ffcc37b9e9dd572 = 0.5;
    const $5e0415637054ea24$export$16f1a8408ee71016 = {
        TODO: 2,
        INPROGRESS: 4,
        DONE: 3
    };
    const $5e0415637054ea24$export$2b1f4448b6b508db = {
        TODO: 2,
        INPROGRESS: 4,
        DONE: 3
    };
    const $5e0415637054ea24$export$86fc137548f2fce5 = {
        [$5e0415637054ea24$export$2b1f4448b6b508db.TODO]: 'default',
        [$5e0415637054ea24$export$2b1f4448b6b508db.INPROGRESS]: 'inprogress',
        [$5e0415637054ea24$export$2b1f4448b6b508db.DONE]: 'success'
    };
    const $5e0415637054ea24$export$73a0206a4dc59760 = {
        CLOSED: 'CLOSED',
        ACTIVE: 'ACTIVE',
        FUTURE: 'FUTURE'
    };
    const $5e0415637054ea24$export$f1b6d0605ff9b7e6 = 'EXTERNAL_SPRINT';
    const $5e0415637054ea24$export$8c8dab1ad613072e = 3000;
    const $5e0415637054ea24$export$e5d805200f62f81d = {
        SMALL: 64,
        MEDIUM: 128,
        LARGE: 160,
        EXTRALARGE: 240
    };
    const $5e0415637054ea24$export$6edf6d7514b31ffa = 40;
    const $5e0415637054ea24$export$a705d305be7bd15d = 440;
    const $5e0415637054ea24$export$9a8b9408dd2830b = 600;
    const $5e0415637054ea24$export$4cd768253686885b = 900;
    const $5e0415637054ea24$export$36a3ce28e91ef989 = 20;
    const $5e0415637054ea24$export$f777897e7e87cb69 = 'ALL_VALUES';
    const $5e0415637054ea24$export$2933446418f07e42 = 'EMPTY_VALUES_ONLY';
    const $5e0415637054ea24$export$de3ef5bf994b7018 = {
        ALL_VALUES: $5e0415637054ea24$export$f777897e7e87cb69,
        EMPTY_VALUES_ONLY: $5e0415637054ea24$export$2933446418f07e42
    };
    const $5e0415637054ea24$export$f9c0c7ff9184db0 = {
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81
    };
    const $5e0415637054ea24$export$448fe702ac76034a = {
        storyPoints: 'StoryPoints',
        days: 'Days',
        hours: 'Hours'
    };
    const $5e0415637054ea24$export$75989ea7860b85e9 = 'UNDEFINED';
    const $5e0415637054ea24$export$6bc4f75201f6f12e = 'sticky-header-cell';
    const $5e0415637054ea24$export$e3c19de1b019757c = {
        CHECKED: 'checked',
        UNCHECKED: 'unchecked',
        INDETERMINATE: 'indeterminate'
    };
    const $5e0415637054ea24$export$3bf3c26d6d69f3b1 = {
        VIEWER: 'Viewer',
        FULL_EDITOR: 'FullEditor',
        NON_PUBLISHING_EDITOR: 'NonPublishingEditor'
    };
    const $5e0415637054ea24$export$40628b030ac72445 = {
        LINK: 'Link',
        EMBED: 'Embed',
        CONFLUENCE: 'Confluence',
        CSV: 'Csv',
        PNG: 'Png',
        DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
    };
    const $5e0415637054ea24$export$5b1b1523594baa6e = {
        kanban: 'Kanban',
        scrum: 'Scrum'
    };
    const $5e0415637054ea24$export$b4d5766fd1973953 = {
        ADMIN: 'Admin',
        EDITOR: 'Editor',
        VIEWER: 'Viewer',
        RESTRICTED_USER: 'Restricted'
    };
    const $5e0415637054ea24$export$183f45c476faaff2 = {
        EDITOR: 'Editor',
        VIEWER: 'Viewer',
        REPORT_CONSUMER: 'ReportConsumer',
        CONFLUENCE_CONSUMER: 'ConfluenceConsumer'
    };
    const $5e0415637054ea24$export$deea8c9ae0e3c1ca = {
        OUTWARD: 'outward',
        INWARD: 'inward'
    };
    const $5e0415637054ea24$export$86e2f9653c14c34 = {
        PROJECT: 'Project',
        BOARD: 'Board',
        FILTER: 'Filter'
    };
    const $5e0415637054ea24$export$5b6c28c7dca07ad7 = 'portfolio-3';
    const $5e0415637054ea24$export$d39436cd641938a9 = 'portfolio-3.create-plan-wizard';
    const $5e0415637054ea24$export$f048d91ccaf92408 = {
        COMMIT_CHANGES_TIME_TO_SAVE: 'commit-changes.time-to-save',
        COMMIT_CHANGES_TIME_TO_PERSIST: 'commit-changes.time-to-persist',
        RENDER_APP: 'page-plan.render-app',
        EXPORT_PNG: {
            INITIAL_PREVIEW: 'page-plan.export-png.initial-preview',
            SUBSEQUENT_PREVIEW: 'page-plan.export-png.subsequent-preview',
            EXPORT: 'page-plan.export-png.export'
        }
    };
    const $5e0415637054ea24$export$4eb5c0330ef8fab4 = {
        RENDER: {
            SCOPE_TABLE: 'renderScopeTable'
        },
        EXPORT_PNG: {
            INITIAL_LOAD: 'page-plan.export-png.profile.initial-load',
            REACT_RENDER: 'page-plan.export-png.profile.react-render',
            PREPARE_FOR_EXPORT: 'page-plan.export-png.profile.prepare-for-export',
            CANVAS_RENDER: 'page-plan.export-png.profile.canvas-render'
        }
    };
    const $5e0415637054ea24$export$b8b9d90f9e5bd72b = 'jiraPortfolio3Portfolio';
    const $5e0415637054ea24$export$f27a837467ec20e5 = {
        APP: 'app',
        ROADMAP: 'roadmapTab',
        TEAMS: 'teamsTab',
        RELEASES: 'releasesTab',
        DEPENDENCIES: 'dependenciesTab',
        SETTINGS: 'settings',
        REDUX: 'redux',
        REDUX_SAGA: 'reduxSaga',
        PLAN_WIZARD: 'planWizard',
        UNHANDLED: 'unhandled',
        ENVIRONMENT: 'environment',
        GIC: 'GIC',
        SUMMARY: 'summaryTab'
    };
    const $5e0415637054ea24$export$cfeee2ee86ead336 = 'advanced-roadmaps';
    const $5e0415637054ea24$export$bf7af18c7898a31 = 100;
    const $5e0415637054ea24$export$37e30ab04b9b1705 = {
        DEFAULT: $5e0415637054ea24$export$e6952b12ade67489,
        LINES: $5e0415637054ea24$export$e0de529f548a9140,
        COUNT: $5e0415637054ea24$export$d61684373eacdf61
    };
    const $5e0415637054ea24$export$e24665e8d921f93e = 1e6;
    const $5e0415637054ea24$export$22ed55708a9d1966 = {
        SOFTWARE: 'software',
        WORK_MANAGEMENT: 'business',
        SERVICE_MANAGEMENT: 'service_desk'
    };
    const $5e0415637054ea24$export$8b7222fa92892b49 = {
        WEEKS: 'weeks',
        MONTHS: 'months',
        QUARTERS: 'quarters',
        YEARS: 'years'
    };
    const $5e0415637054ea24$export$bbbec7054427e57b = {
        ...$5e0415637054ea24$export$8b7222fa92892b49,
        CUSTOM: 'custom'
    };
    const $5e0415637054ea24$export$b0f7807f8d64b44a = {
        SMALL: 14,
        MEDIUM: 93,
        LARGE: 364
    };
    const $5e0415637054ea24$export$46a3b4b81e5a44ac = (0, (0, parcelRequire("flnZx")).ONE_DAY);
    const $5e0415637054ea24$export$e433769a2e1c823 = 1 / 7 * 100;
    const $5e0415637054ea24$export$954b02519e22ad3c = 'jira.user.arj.notify.watchers';
    const $5e0415637054ea24$export$cb60c924e8198091 = 'timeline';
    const $5e0415637054ea24$export$16c8656f8d888a96 = 'dependency-report';
    const $5e0415637054ea24$export$d37ffa307efd6838 = {
        MAIN: 'main-sections',
        FIELD: 'fields-section',
        LIST_MAIN: 'list-main-sections',
        LIST_FIELD: 'list-fields-section'
    };
    const $5e0415637054ea24$export$cb4feb832f4bb576 = {
        SCOPE: 'scope-column',
        FIELDS: 'fields-column',
        TIMELINE: 'timeline-column'
    };
    const $5e0415637054ea24$export$ce125fc0306b71a0 = {
        id: '__original_status_transition_id__',
        name: '__original_status_transition_name__'
    };
    const $5e0415637054ea24$export$c773c9bd947df9ae = {
        STATUS: 'status',
        ESTIMATE: 'estimate'
    };
    const $5e0415637054ea24$export$253194752488840a = {
        AUTO_SCHEDULE: '72BaKCMhh1aBiQprnER3pL',
        SHARE_CONFLUENCE: '8xdMiPoU4Fr4KWxzGJdXL',
        WARNING_CENTER: '5NX3sX9eqNEXSGhi4cMQ4L',
        SAVED_VIEWS: '636NO7TUPjErcJvohzMo9f',
        MANAGE_SAVED_VIEWS: '59mAhBw1bktXGV50c5c3ax',
        DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
        SUMMARY: '2lAziig1qpzuPCelr0CWB3',
        TEAMS: '30yplH4RxkjUZwmNwOxT2k',
        TEAM_CAPACITY: '1iT8GgcEZ2tikuwlnTq8Ij',
        DEPENDENCIES_REPORT: '2N5Dc7LkkoTjytZVPp9PQV',
        ISSUE_SOURCE: '1HTUp4iLEAeRVWDAI6pCaB',
        EXCLUSION_RULES: '2okV00HG5KCXjcw9oxv2kv',
        PERMISSIONS: '2GnX12bqw32MnTSVnDooC'
    };
});
parcelRegister("flnZx", function(module, exports) {
    $parcel$export(module.exports, "ONE_HOUR", ()=>$baaac68c54c7e711$export$82541edf19e5e3b0);
    $parcel$export(module.exports, "ONE_DAY", ()=>$baaac68c54c7e711$export$a97a1358cbb650ab);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$baaac68c54c7e711$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "isISOCompatible", ()=>$baaac68c54c7e711$export$19585d8c4023da60);
    $parcel$export(module.exports, "dateDiffFromUTC", ()=>$baaac68c54c7e711$export$c0a5d57ff50684cd);
    $parcel$export(module.exports, "endOfUtcDay", ()=>$baaac68c54c7e711$export$28816be40db3c661);
    $parcel$export(module.exports, "startOfUtcDay", ()=>$baaac68c54c7e711$export$5232bbb29ed7bb90);
    $parcel$export(module.exports, "startOfUtcWeek", ()=>$baaac68c54c7e711$export$beda72ac2de463b);
    $parcel$export(module.exports, "startOfUtcMonth", ()=>$baaac68c54c7e711$export$6f42959055abfd71);
    $parcel$export(module.exports, "buildStartOfUtcQuarter", ()=>$baaac68c54c7e711$export$2fc2f60e244962d8);
    $parcel$export(module.exports, "buildStartOfUtcYear", ()=>$baaac68c54c7e711$export$d9d30b5ea3d906ae);
    $parcel$export(module.exports, "distanceInWordsWithPolarity", ()=>$baaac68c54c7e711$export$6c9763c5fdf1d9bf);
    $parcel$export(module.exports, "distanceInWordsToNowWithPolarity", ()=>$baaac68c54c7e711$export$2b43273db3dc8a06);
    $parcel$export(module.exports, "endOfUtcWeek", ()=>$baaac68c54c7e711$export$cd5772ae045b582a);
    $parcel$export(module.exports, "endOfUtcMonth", ()=>$baaac68c54c7e711$export$7eaba70871f25263);
    $parcel$export(module.exports, "buildEndOfUtcQuarter", ()=>$baaac68c54c7e711$export$15d62cfd22087517);
    $parcel$export(module.exports, "buildEndOfUtcYear", ()=>$baaac68c54c7e711$export$ea7270449a050df5);
    $parcel$export(module.exports, "getWorkingMillionSecondsBetweenTwoDates", ()=>$baaac68c54c7e711$export$11174f5b39020529);
    $parcel$export(module.exports, "convertShortFormatDate", ()=>$baaac68c54c7e711$export$51353e55e1015915);
    $parcel$export(module.exports, "distanceInWordsByShortFormat", ()=>$baaac68c54c7e711$export$6fd795612f323dcc);
    $parcel$export(module.exports, "getRelativeDates", ()=>$baaac68c54c7e711$export$f1b9e31b5813ebf9);
    $parcel$export(module.exports, "getWeekStartDay", ()=>$baaac68c54c7e711$export$99291c0265ff1d37);
    var $9XE6b = parcelRequire("9XE6b");
    var $cRGLB = parcelRequire("cRGLB");
    var $gwejS;
    var $3DR3e;
    var $16v6W;
    var $2kh23;
    var $jNuzB;
    var $2753q;
    var $pyK8a;
    var $kAAot;
    var $4PxOH;
    var $7myQy;
    var $1p96B;
    var $gh61P;
    const $baaac68c54c7e711$export$82541edf19e5e3b0 = 3600000;
    const $baaac68c54c7e711$export$a97a1358cbb650ab = 86400000;
    const $baaac68c54c7e711$export$8187f416f1cc43d8 = 7 * $baaac68c54c7e711$export$a97a1358cbb650ab;
    const $baaac68c54c7e711$export$3ff59674890cae52 = $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
    const $baaac68c54c7e711$export$5dddd410b460512a = /^\d{4}-\d{2}-\d{2}\s?/;
    const $baaac68c54c7e711$export$f5b73408663c3e14 = /^\d{2}\/\w{3}\/\d{2}\s?/;
    const $baaac68c54c7e711$export$63484a545c40ee32 = /^\d{2}\/\w{3}\/\d{4}\s?/;
    const $baaac68c54c7e711$export$ce02ba817385328 = (str)=>new Date(`${str} UTC`).getTime();
    const $baaac68c54c7e711$export$f7a957134186c558 = (date)=>{
        if ($baaac68c54c7e711$export$5dddd410b460512a.test(date)) {
            const trimmedDate = date.substring(0, 10);
            return new Date(trimmedDate);
        }
        if ($baaac68c54c7e711$export$63484a545c40ee32.test(date)) {
            const trimmedDate = date.substring(0, 11);
            const parsedDate = (0, (0, parcelRequire("2753q")).default)(trimmedDate, 'dd/MMM/yyyy', new Date());
            const time = parsedDate.getTime();
            const timeOffset = parsedDate.getTimezoneOffset() * 60000;
            return new Date(time - timeOffset);
        }
        if ($baaac68c54c7e711$export$f5b73408663c3e14.test(date)) {
            const trimmedDate = date.substring(0, 9);
            const parsedDate = (0, (0, parcelRequire("2753q")).default)(trimmedDate, 'dd/MMM/yy', new Date());
            const time = parsedDate.getTime();
            const timeOffset = parsedDate.getTimezoneOffset() * 60000;
            return new Date(time - timeOffset);
        }
        throw new Error(`Non ISO date format provided to create UTC date: ${date}`);
    };
    const $baaac68c54c7e711$export$19585d8c4023da60 = (date)=>$baaac68c54c7e711$export$f5b73408663c3e14.test(date) || $baaac68c54c7e711$export$5dddd410b460512a.test(date);
    const $baaac68c54c7e711$export$c0a5d57ff50684cd = ()=>{
        const now = new Date();
        const tzInHours = -now.getTimezoneOffset() / 60;
        const utcHours = (now.getHours() + now.getMinutes() / 60 - tzInHours + 24) % 24;
        if (utcHours + tzInHours > 24) return 1;
        if (utcHours + tzInHours < 0) return -1;
        return 0;
    };
    const $baaac68c54c7e711$export$28816be40db3c661 = (date)=>new Date((0, parcelRequire("7myQy")).default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(23, 59, 59, 999);
    const $baaac68c54c7e711$export$5232bbb29ed7bb90 = (date)=>new Date((0, parcelRequire("7myQy")).default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(0, 0, 0, 0);
    const $baaac68c54c7e711$export$beda72ac2de463b = (value)=>{
        const startOfDay = $baaac68c54c7e711$export$5232bbb29ed7bb90(new Date(value).getTime());
        const dayOfWeek = new Date(startOfDay).getUTCDay();
        const millisecondsToSubstract = $baaac68c54c7e711$export$a97a1358cbb650ab * dayOfWeek;
        const date = new Date(startOfDay - millisecondsToSubstract);
        const year = date.getUTCFullYear();
        const month = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0');
        const day = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCDate()}`, 2, '0');
        const startOfWeek = new Date(`${year}-${month}-${day}T00:00:00Z`);
        return startOfWeek;
    };
    const $baaac68c54c7e711$export$6f42959055abfd71 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0');
        const startOfMonth = new Date(`${year}-${month}-01T00:00:00Z`);
        return startOfMonth;
    };
    const $baaac68c54c7e711$export$f8d6d59f9413fa73 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const UTCmonth = date.getUTCMonth();
        let month;
        if (UTCmonth >= 0 && UTCmonth <= 2) month = '01';
        else if (UTCmonth >= 3 && UTCmonth <= 5) month = '04';
        else if (UTCmonth >= 6 && UTCmonth <= 8) month = '07';
        else month = '10';
        const startOfQuarter = new Date(`${year}-${month}-01T00:00:00Z`);
        return startOfQuarter;
    };
    const $baaac68c54c7e711$export$2fc2f60e244962d8 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const year = date.getUTCFullYear();
            const month = date.getUTCMonth() + 1;
            const nextFYStartMonth = fyStartMonth + 12;
            let firstMonthOfThisQuarter = nextFYStartMonth;
            while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
            const willWrapToPreviousYear = firstMonthOfThisQuarter < 1;
            const dateString = `${willWrapToPreviousYear ? year - 1 : year}-${willWrapToPreviousYear ? 12 + firstMonthOfThisQuarter : `0${firstMonthOfThisQuarter}`.slice(-2)}-01T00:00:00Z`;
            return new Date(dateString);
        };
    const $baaac68c54c7e711$export$fea0669370045ef2 = (value)=>{
        const date = new Date(value);
        const startOfYear = new Date(`${date.getUTCFullYear()}-01-01T00:00:00Z`);
        return startOfYear;
    };
    const $baaac68c54c7e711$export$d9d30b5ea3d906ae = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const currentUtcYear = date.getUTCFullYear();
            const currentUtcMonth = date.getUTCMonth() + 1;
            return new Date(`${currentUtcYear - (currentUtcMonth >= fyStartMonth ? 0 : 1)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`);
        };
    const $baaac68c54c7e711$export$55d224f4c8cb5e91 = ()=>{
        if (Date.prototype.__msh_oldSetFullYear) Date.prototype.setFullYear = function setFullYear(...args) {
            const d = new Date(this);
            d.__msh_oldSetFullYear && d.__msh_oldSetFullYear.call(d, ...args);
            if (d.getMonth() !== this.getMonth()) this.setDate(28);
            return this.__msh_oldSetFullYear ? this.__msh_oldSetFullYear.call(this, ...args) : Number.NaN;
        };
    };
    const $baaac68c54c7e711$export$b767725b8ed07921 = ()=>{
        if (globalThis.document) {
            if (globalThis.document.readyState === 'loading') globalThis.document.addEventListener('DOMContentLoaded', $baaac68c54c7e711$export$55d224f4c8cb5e91);
            else $baaac68c54c7e711$export$55d224f4c8cb5e91();
        }
    };
    $baaac68c54c7e711$export$b767725b8ed07921();
    const $baaac68c54c7e711$export$6c9763c5fdf1d9bf = (fromDate, toDate, locale)=>{
        const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
        const distanceStr = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate, {
            locale: locale !== undefined ? (0, (0, parcelRequire("1p96B")).getLocale)(locale) : undefined
        });
        return distanceStr.split(' ').map((str)=>Number.isNaN(Number(str)) ? str : `${sign}${str}`).join(' ');
    };
    const $baaac68c54c7e711$export$2b43273db3dc8a06 = (locale, date)=>$baaac68c54c7e711$export$6c9763c5fdf1d9bf(Date.now(), date, locale);
    const $baaac68c54c7e711$export$cd5772ae045b582a = (value)=>{
        const startOfWeek = $baaac68c54c7e711$export$beda72ac2de463b(value);
        const endOfWeek = startOfWeek.getTime() + 7 * $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
        return new Date(endOfWeek);
    };
    const $baaac68c54c7e711$export$7eaba70871f25263 = (value)=>{
        const date = new Date(value);
        let year = date.getUTCFullYear();
        let month = date.getUTCMonth();
        month++;
        if (month > 11) {
            month = 0;
            year++;
        }
        const paddedMonth = (0, ($parcel$interopDefault($cRGLB)))(`${month + 1}`, 2, '0');
        const firstDayOfNextYear = new Date(`${year}-${paddedMonth}-01T00:00:00.000Z`);
        const endOfYear = new Date(firstDayOfNextYear.getTime() - 1);
        return endOfYear;
    };
    const $baaac68c54c7e711$export$893511aa1d64d04 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const UTCmonth = date.getUTCMonth();
        let month;
        let day = '31';
        if (UTCmonth >= 0 && UTCmonth <= 2) month = '03';
        else if (UTCmonth >= 3 && UTCmonth <= 5) {
            month = '06';
            day = '30';
        } else if (UTCmonth >= 6 && UTCmonth <= 8) {
            month = '09';
            day = '30';
        } else month = '12';
        const lastDayOfQuarter = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
        return lastDayOfQuarter;
    };
    const $baaac68c54c7e711$export$15d62cfd22087517 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const year = date.getUTCFullYear();
            const month = date.getUTCMonth() + 1;
            const nextFYStartMonth = fyStartMonth + 12;
            let firstMonthOfThisQuarter = nextFYStartMonth;
            while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
            const firstMonthOfNextQuarter = firstMonthOfThisQuarter + 3;
            const willWrapToNextYear = firstMonthOfNextQuarter > 12;
            if (willWrapToNextYear) return new Date(new Date(`${year + 1}-0${firstMonthOfNextQuarter % 12}-01T00:00:00Z`).getTime() - 1);
            return new Date(new Date(`${year}-${`0${firstMonthOfNextQuarter}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
        };
    const $baaac68c54c7e711$export$73a64972c33eed9e = (value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        return new Date(`${currentUtcYear}-12-31T23:59:59.999Z`);
    };
    const $baaac68c54c7e711$export$ea7270449a050df5 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const currentUtcYear = date.getUTCFullYear();
            const currentUtcMonth = date.getUTCMonth() + 1;
            return new Date(new Date(`${currentUtcYear + (currentUtcMonth >= fyStartMonth ? 1 : 0)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
        };
    const $baaac68c54c7e711$export$66ad6b2cba030df5 = (startTime, endTime)=>(0, (0, parcelRequire("jNuzB")).default)($baaac68c54c7e711$export$beda72ac2de463b(startTime), $baaac68c54c7e711$export$beda72ac2de463b(endTime));
    const $baaac68c54c7e711$export$dbbb7786eda0de5f = (value)=>{
        const startTimeOfUtcWeek = $baaac68c54c7e711$export$beda72ac2de463b(value).getTime();
        return {
            start: startTimeOfUtcWeek + $baaac68c54c7e711$export$a97a1358cbb650ab,
            end: startTimeOfUtcWeek + 6 * $baaac68c54c7e711$export$a97a1358cbb650ab
        };
    };
    const $baaac68c54c7e711$export$11174f5b39020529 = (startTime, endTime)=>{
        const { start: startWorkingTimeOfStartTime, end: endWorkingTimeOfStartTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(startTime);
        if ($baaac68c54c7e711$export$66ad6b2cba030df5(startTime, endTime)) {
            if (endTime < startWorkingTimeOfStartTime || startTime > endWorkingTimeOfStartTime) return 0;
            return Math.min(endWorkingTimeOfStartTime, endTime) - Math.max(startWorkingTimeOfStartTime, startTime);
        }
        const { start: startWorkingTimeOfEndTime, end: endWorkingTimeOfEndTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(endTime);
        const weeks = Math.floor((startWorkingTimeOfEndTime - endWorkingTimeOfStartTime) / $baaac68c54c7e711$export$8187f416f1cc43d8);
        const workingMillionSecondsOfMiddleWeeks = weeks * (5 * $baaac68c54c7e711$export$a97a1358cbb650ab);
        const workingMillionSecondsOfFirstWeek = startTime > endWorkingTimeOfStartTime ? 0 : endWorkingTimeOfStartTime - Math.max(startTime, startWorkingTimeOfStartTime);
        const workingMillionSecondsOfLastWeek = endTime < startWorkingTimeOfEndTime ? 0 : Math.min(endTime, endWorkingTimeOfEndTime) - startWorkingTimeOfEndTime;
        return workingMillionSecondsOfFirstWeek + workingMillionSecondsOfLastWeek + workingMillionSecondsOfMiddleWeeks;
    };
    const $baaac68c54c7e711$var$getUnifiedEnglishDateUnit = (unitStr)=>{
        const regx = /((\w+)(?=s))|([^s]+)/g;
        const resultArr = unitStr.match(regx);
        if (Array.isArray(resultArr) && resultArr.length > 0) return resultArr[0];
        return unitStr;
    };
    const $baaac68c54c7e711$export$51353e55e1015915 = (number, unit, localeStr)=>new Intl.NumberFormat(localeStr, {
            style: 'unit',
            unit: unit,
            unitDisplay: 'narrow'
        }).format(number);
    const $baaac68c54c7e711$export$6fd795612f323dcc = (fromDate, toDate, localeStr)=>{
        const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
        const distanceStr = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate);
        const distanceStrArray = distanceStr.split(' ');
        const locale = (0, (0, parcelRequire("1p96B")).getLocale)(localeStr);
        if (distanceStrArray.length === 2) {
            const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[1]);
            const number = distanceStrArray[0];
            return `${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
        }
        if (distanceStrArray.length === 3) {
            const suffix = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate, {
                locale: locale
            }).split(' ')[0];
            const number = distanceStrArray[1];
            const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[2]);
            return `${suffix} ${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
        }
        return distanceStr;
    };
    const $baaac68c54c7e711$export$f1b9e31b5813ebf9 = ({ toNowUnitCount: toNowUnitCount = 0, fromNowUnitCount: fromNowUnitCount = 0, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit }, today)=>{
        const start = toNowUnit === (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS ? (0, (0, parcelRequire("4PxOH")).default)(today, toNowUnitCount) : (0, (0, parcelRequire("kAAot")).default)(today, toNowUnitCount);
        const end = fromNowUnit === (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS ? (0, (0, parcelRequire("16v6W")).default)(today, fromNowUnitCount) : (0, (0, parcelRequire("3DR3e")).default)(today, fromNowUnitCount);
        if (toNowUnitCount === 0 && fromNowUnitCount === 0) return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
        };
        if (toNowUnitCount && fromNowUnitCount || toNowUnitCount) return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90((0, (0, parcelRequire("gwejS")).default)(start, 1).getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
        };
        return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661((0, (0, parcelRequire("pyK8a")).default)(end, 1).getTime())
        };
    };
    const $baaac68c54c7e711$export$99291c0265ff1d37 = (locale)=>(0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("1p96B")).getLocale)(locale), 'options.weekStartsOn', (0, (0, parcelRequire("gh61P")).DEFAULT_WEEK_START_DAY));
});
parcelRegister("cRGLB", function(module, exports) {
    var $9tfrR = parcelRequire("9tfrR");
    var $ifYxh = parcelRequire("ifYxh");
    var $kPZpS = parcelRequire("kPZpS");
    var $jJVtR = parcelRequire("jJVtR");
    function $95db9be3f601d040$var$padStart(string, length, chars) {
        string = $jJVtR(string);
        length = $kPZpS(length);
        var strLength = length ? $ifYxh(string) : 0;
        return length && strLength < length ? $9tfrR(length - strLength, chars) + string : string;
    }
    module.exports = $95db9be3f601d040$var$padStart;
});
parcelRegister("9tfrR", function(module, exports) {
    var $kkyYH = parcelRequire("kkyYH");
    var $kHBB0 = parcelRequire("kHBB0");
    var $gvFfr = parcelRequire("gvFfr");
    var $axH2S = parcelRequire("axH2S");
    var $ifYxh = parcelRequire("ifYxh");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $6e52ce3a438da7ad$var$nativeCeil = Math.ceil;
    function $6e52ce3a438da7ad$var$createPadding(length, chars) {
        chars = chars === undefined ? ' ' : $kHBB0(chars);
        var charsLength = chars.length;
        if (charsLength < 2) return charsLength ? $kkyYH(chars, length) : chars;
        var result = $kkyYH(chars, $6e52ce3a438da7ad$var$nativeCeil(length / $ifYxh(chars)));
        return $axH2S(chars) ? $gvFfr($jx6Tp(result), 0, length).join('') : result.slice(0, length);
    }
    module.exports = $6e52ce3a438da7ad$var$createPadding;
});
parcelRegister("kkyYH", function(module, exports) {
    var $ecd0ced035e30e58$var$MAX_SAFE_INTEGER = 9007199254740991;
    var $ecd0ced035e30e58$var$nativeFloor = Math.floor;
    function $ecd0ced035e30e58$var$baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > $ecd0ced035e30e58$var$MAX_SAFE_INTEGER) return result;
        do {
            if (n % 2) result += string;
            n = $ecd0ced035e30e58$var$nativeFloor(n / 2);
            if (n) string += string;
        }while (n)
        return result;
    }
    module.exports = $ecd0ced035e30e58$var$baseRepeat;
});
parcelRegister("ifYxh", function(module, exports) {
    var $dkmPN = parcelRequire("dkmPN");
    var $axH2S = parcelRequire("axH2S");
    var $61ekh = parcelRequire("61ekh");
    function $d4a895dd16218f22$var$stringSize(string) {
        return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
    }
    module.exports = $d4a895dd16218f22$var$stringSize;
});
parcelRegister("dkmPN", function(module, exports) {
    var $8hdQS = parcelRequire("8hdQS");
    var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
    module.exports = $9b3edb0cff432526$var$asciiSize;
});
parcelRegister("61ekh", function(module, exports) {
    var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
    var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
    var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
        $461df2ef275f3803$var$rsNonAstral,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair
    ].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
        $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
        $461df2ef275f3803$var$rsCombo,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair,
        $461df2ef275f3803$var$rsAstral
    ].join('|') + ')';
    var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
    function $461df2ef275f3803$var$unicodeSize(string) {
        var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
        while($461df2ef275f3803$var$reUnicode.test(string))++result;
        return result;
    }
    module.exports = $461df2ef275f3803$var$unicodeSize;
});
parcelRegister("7myQy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55c59e4aaf37a546$export$2e2bcd8739ae039);
    var $c9RLn;
    var $55c59e4aaf37a546$var$is = (0, (0, parcelRequire("c9RLn")).default)(function is(Ctor, val) {
        return val != null && val.constructor === Ctor || val instanceof Ctor;
    });
    var $55c59e4aaf37a546$export$2e2bcd8739ae039 = $55c59e4aaf37a546$var$is;
});
parcelRegister("c9RLn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8da0078a7b144f9d$export$2e2bcd8739ae039);
    var $ccUYa;
    var $iU24A;
    function $8da0078a7b144f9d$export$2e2bcd8739ae039(fn) {
        return function f2(a, b) {
            switch(arguments.length){
                case 0:
                    return f2;
                case 1:
                    return (0, (0, parcelRequire("iU24A")).default)(a) ? f2 : (0, (0, parcelRequire("ccUYa")).default)(function(_b) {
                        return fn(a, _b);
                    });
                default:
                    return (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(b) ? f2 : (0, (0, parcelRequire("iU24A")).default)(a) ? (0, (0, parcelRequire("ccUYa")).default)(function(_a) {
                        return fn(_a, b);
                    }) : (0, (0, parcelRequire("iU24A")).default)(b) ? (0, (0, parcelRequire("ccUYa")).default)(function(_b) {
                        return fn(a, _b);
                    }) : fn(a, b);
            }
        };
    }
});
parcelRegister("ccUYa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e32cbf2c9cb3af3$export$2e2bcd8739ae039);
    var $iU24A;
    function $8e32cbf2c9cb3af3$export$2e2bcd8739ae039(fn) {
        return function f1(a) {
            if (arguments.length === 0 || (0, (0, parcelRequire("iU24A")).default)(a)) return f1;
            else return fn.apply(this, arguments);
        };
    }
});
parcelRegister("iU24A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc2f10a18a9bb545$export$2e2bcd8739ae039);
    function $dc2f10a18a9bb545$export$2e2bcd8739ae039(a) {
        return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }
});
parcelRegister("gh61P", function(module, exports) {
    $parcel$export(module.exports, "longDateFormat", ()=>$874bf1b243ba3957$export$7bc415832e79e22c);
    $parcel$export(module.exports, "dateMonthFormat", ()=>$874bf1b243ba3957$export$f9c3f52e4a5f8635);
    $parcel$export(module.exports, "longDateTimeFormat", ()=>$874bf1b243ba3957$export$f2f390060309965);
    $parcel$export(module.exports, "shortDateFormat", ()=>$874bf1b243ba3957$export$1a445e44d9863af);
    $parcel$export(module.exports, "weekdayFormat", ()=>$874bf1b243ba3957$export$faf60e60fca9bed1);
    $parcel$export(module.exports, "weekdayFormatLong", ()=>$874bf1b243ba3957$export$a28e4d9035dd351c);
    $parcel$export(module.exports, "DateUnits", ()=>$874bf1b243ba3957$export$c7e7da0fa6bb60a7);
    $parcel$export(module.exports, "DATE_UNIT_MAX_VALUES", ()=>$874bf1b243ba3957$export$637d8b0948b783c7);
    $parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", ()=>$874bf1b243ba3957$export$78e07fecfaf51c7b);
    $parcel$export(module.exports, "DefaultDateFormat", ()=>$874bf1b243ba3957$export$14ae725d0cc7daa1);
    $parcel$export(module.exports, "IsoDateFormat", ()=>$874bf1b243ba3957$export$7288711b5316ff78);
    $parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", ()=>$874bf1b243ba3957$export$845e1054649a85c2);
    const $874bf1b243ba3957$export$7bc415832e79e22c = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$f9c3f52e4a5f8635 = {
        day: '2-digit',
        month: 'short',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$352fb2bc78f82ff2 = {
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$f2f390060309965 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$1a445e44d9863af = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$faf60e60fca9bed1 = {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$a28e4d9035dd351c = {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$c7e7da0fa6bb60a7 = {
        DAYS: 'days',
        MONTHS: 'months',
        WEEKS: 'weeks'
    };
    const $874bf1b243ba3957$export$637d8b0948b783c7 = {
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.DAYS]: 3650,
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.WEEKS]: 520,
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.MONTHS]: 120
    };
    const $874bf1b243ba3957$export$78e07fecfaf51c7b = {
        FIXED: 'fixed',
        RELATIVE: 'relative'
    };
    const $874bf1b243ba3957$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
    const $874bf1b243ba3957$export$7288711b5316ff78 = 'YYYY-MM-DD';
    const $874bf1b243ba3957$export$845e1054649a85c2 = 0;
});
parcelRegister("dnjeJ", function(module, exports) {
    $parcel$export(module.exports, "useUFOComponentExperience", ()=>$44448c24118cb590$export$30ab340faaed55d4);
    var $5uXOq = parcelRequire("5uXOq");
    const $44448c24118cb590$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                experience.abort();
            };
        }, []);
        $44448c24118cb590$var$useConstructor(()=>experience.start());
        return null;
    };
});
parcelRegister("4KeoM", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_FORMAT_DATE_OPTIONS", ()=>$08ba26fd52bcbf31$export$1c08f1abc265df73);
    const $08ba26fd52bcbf31$export$1c08f1abc265df73 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
});
parcelRegister("1wnDu", function(module, exports) {
    $parcel$export(module.exports, "ChangeIndicator", ()=>$596bbca81bf38e44$export$eb0ebb5fe48d40a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $596bbca81bf38e44$export$eb0ebb5fe48d40a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $596bbca81bf38e44$var$triangleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 100 100",
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "10"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            points: "0,0  100,0  100,100",
            style: {
                fill: `var(--ds-background-warning-bold-hovered, ${(0, $829f609a65d26a98$export$59619663aa6500fb)})`
            }
        })));
    const $596bbca81bf38e44$var$triangleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        width: '10px',
        top: '-5px',
        right: 'space.0',
        overflow: 'hidden'
    });
});
parcelRegister("gNRYR", function(module, exports) {
    $parcel$export(module.exports, "toLocalDate", ()=>$91d18bb4adafb881$export$c9880e139f8587b4);
    var $eZDAP;
    function $91d18bb4adafb881$export$270a607c7c060bad(dateString) {
        return dateString?.replace(/T.*/, '');
    }
    function $91d18bb4adafb881$export$c9880e139f8587b4(utcDateString) {
        const dateString = $91d18bb4adafb881$export$270a607c7c060bad(utcDateString);
        if (!dateString) return new Date(NaN);
        return (0, (0, parcelRequire("eZDAP")).default)(dateString);
    }
});
parcelRegister("9lSpq", function(module, exports) {
    $parcel$export(module.exports, "ActionsMenu", ()=>$aa2245c0482a6626$export$dcd7272559c21ebc);
    $parcel$export(module.exports, "ActionMenuItem", ()=>$aa2245c0482a6626$export$24feb92aa21c4329);
    var $9ViVN;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $3oUqw;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $8Oxp7;
    var $7aNGr;
    const $aa2245c0482a6626$export$dcd7272559c21ebc = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            testId: "release-flyout.ui.actions-menu.dropdown-menu",
            placement: "bottom-start",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    testId: "release-flyout.ui.actions-menu.button",
                    "aria-label": formatMessage((0, (0, parcelRequire("8Oxp7")).messages).menuButton),
                    ref: triggerRef,
                    appearance: "subtle",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: "",
                        size: "small"
                    })
                })
        }, children);
    };
    const $aa2245c0482a6626$export$24feb92aa21c4329 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), props, children);
    const $aa2245c0482a6626$export$a7807fbba35bc229 = ({ versionRef: versionRef, onEditRelease: onEditRelease, onClosePopup: onClosePopup })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("9ViVN")).default), versionRef);
        const onViewRelease = ()=>{
            window.open((0, (0, parcelRequire("7aNGr")).getTimelineUrl)(), '_blank');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'releaseViewed'
            }), 'releaseFlyout');
            onClosePopup();
        };
        const onViewFilteredIssues = ()=>{
            window.open((0, (0, parcelRequire("7aNGr")).getTimelineUrl)(data.versionId), '_blank');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'viewFilteredIssues'
            }), 'releaseFlyout');
            onClosePopup();
        };
        const onEdit = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'versionEdit'
            }), 'releaseFlyout');
            onEditRelease();
            onClosePopup();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            testId: "release-flyout.ui.actions-menu.dropdown-menu",
            placement: "bottom-start",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    testId: "release-flyout.ui.actions-menu.button",
                    "aria-label": formatMessage((0, (0, parcelRequire("8Oxp7")).messages).menuButton),
                    ref: triggerRef,
                    appearance: "subtle",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: "",
                        size: "small"
                    })
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewRelease
        }, formatMessage((0, (0, parcelRequire("8Oxp7")).messages).viewRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewFilteredIssues
        }, formatMessage((0, (0, parcelRequire("8Oxp7")).messages).filterIssuesByRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            isDisabled: !data.canEdit,
            onClick: onEdit
        }, formatMessage((0, (0, parcelRequire("8Oxp7")).messages).editRelease)));
    };
});
parcelRegister("9ViVN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfc0d327bec1174c$export$2e2bcd8739ae039);
    const $bfc0d327bec1174c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "actionsMenu_ReleaseFlyout",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "versionId"
            },
            {
                "kind": "ScalarField",
                "name": "canEdit"
            }
        ],
        "type": "JiraVersion"
    };
    $bfc0d327bec1174c$var$node.hash = "74085ef5ab69dbc936e42420ec5c32a0";
    var $bfc0d327bec1174c$export$2e2bcd8739ae039 = $bfc0d327bec1174c$var$node;
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("8Oxp7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1c7d44848171a0d9$export$defe85febe8b728c);
    var $7VHMR;
    const $1c7d44848171a0d9$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        menuButton: {
            "id": "release-flyout.actions-menu.menu-button",
            "defaultMessage": "more actions menu button"
        },
        viewRelease: {
            "id": "release-flyout.actions-menu.view-release",
            "defaultMessage": "View release in project"
        },
        filterIssuesByRelease: {
            "id": "release-flyout.actions-menu.filter-issues-by-release",
            "defaultMessage": "Filter issues by this release"
        },
        editRelease: {
            "id": "release-flyout.actions-menu.edit-release",
            "defaultMessage": "Edit release"
        }
    });
});
parcelRegister("7aNGr", function(module, exports) {
    $parcel$export(module.exports, "getTimelineUrl", ()=>$4f97fe0500c96ff1$export$e4c621e965d06f96);
    const $4f97fe0500c96ff1$export$e4c621e965d06f96 = (versionId, location = window.location)=>{
        const timelineUrl = `${location.pathname.split('/calendar')[0]}/timeline`;
        if (versionId) return `${timelineUrl}?version=${versionId}`;
        return timelineUrl;
    };
});
parcelRegister("dxcuo", function(module, exports) {
    $parcel$export(module.exports, "TODO_COLOR", ()=>$466efdd02fb21044$export$9a2ce699a8e88c00);
    $parcel$export(module.exports, "IN_PROGRESS_COLOR", ()=>$466efdd02fb21044$export$dc4e31a90347554e);
    $parcel$export(module.exports, "DONE_COLOR", ()=>$466efdd02fb21044$export$f2a648c26a91297f);
    $parcel$export(module.exports, "PROGRESS_BAR_HEIGHT", ()=>$466efdd02fb21044$export$cc6cd6bda2304549);
    $parcel$export(module.exports, "PROGRESS_BAR_BORDER_RADIUS", ()=>$466efdd02fb21044$export$d22aea75d90db6fe);
    const $466efdd02fb21044$export$9a2ce699a8e88c00 = `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
    const $466efdd02fb21044$export$dc4e31a90347554e = `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$exports).B500})`;
    const $466efdd02fb21044$export$f2a648c26a91297f = `var(--ds-icon-accent-green, ${(0, $829f609a65d26a98$exports).G500})`;
    const $466efdd02fb21044$export$cc6cd6bda2304549 = 6;
    const $466efdd02fb21044$export$d22aea75d90db6fe = 23;
});
parcelRegister("7qM12", function(module, exports) {
    $parcel$export(module.exports, "createViewReleaseFlyoutExperience", ()=>$49c98db356e719dc$export$1b2b7e23ce6dbb48);
    var $atdLB;
    var $duUGa;
    const $49c98db356e719dc$export$1b2b7e23ce6dbb48 = (location, suffixKey)=>new (0, (0, parcelRequire("duUGa")).UFOExperience)(`view-release-flyout-${location}-${suffixKey}`, {
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
        });
});
parcelRegister("1PFZf", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3e72d010d84106d5$export$defe85febe8b728c);
    var $7VHMR;
    const $3e72d010d84106d5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseLabel: {
            "id": "release-flyout.release-label",
            "defaultMessage": "RELEASE"
        },
        closeButtonLabel: {
            "id": "release-flyout.close-button-label",
            "defaultMessage": "Close the release layout"
        },
        releasedStatusLabel: {
            "id": "release-flyout.released-status-label",
            "defaultMessage": "RELEASED"
        },
        unreleasedStatusLabel: {
            "id": "release-flyout.unreleased-status-label",
            "defaultMessage": "UNRELEASED"
        },
        overdueStatusLabel: {
            "id": "release-flyout.overdue-status-label",
            "defaultMessage": "OVERDUE"
        },
        overdueDaysLabel: {
            "id": "release-flyout.overdue-days-label",
            "defaultMessage": "{numberDaysOverdue} {numberDaysOverdue, plural, =1 {day} other {days}} overdue"
        },
        startDateLabel: {
            "id": "release-flyout.start-date-label",
            "defaultMessage": "Start date"
        },
        releaseDateLabel: {
            "id": "release-flyout.release-date-label",
            "defaultMessage": "Release date"
        },
        projectLabel: {
            "id": "release-flyout.project-label",
            "defaultMessage": "Project"
        },
        driverLabel: {
            "id": "release-flyout.driver-label",
            "defaultMessage": "Driver"
        },
        progressLabel: {
            "id": "release-flyout.progress-label",
            "defaultMessage": "Progress"
        },
        doneLabel: {
            "id": "release-flyout.done-label",
            "defaultMessage": "done"
        },
        doneProgressLabel: {
            "id": "release-flyout.done-progress-label",
            "defaultMessage": "{percent}% done"
        },
        toDoToolTipsText: {
            "id": "release-flyout.to-do-tool-tips-text",
            "defaultMessage": "To Do: {count} of {totalCount} {totalCount, plural, =0 {issue} one {issue} other {issues}}"
        },
        inProgressToolTipsText: {
            "id": "release-flyout.in-progress-tool-tips-text",
            "defaultMessage": "In Progress: {count} of {totalCount} {totalCount, plural, =0 {issue} one {issue} other {issues}}"
        },
        doneToolTipsText: {
            "id": "release-flyout.done-tool-tips-text",
            "defaultMessage": "Done: {count} of {totalCount} {totalCount, plural, =0 {issue} one {issue} other {issues}}"
        }
    });
});
parcelRegister("6INXs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$251b5e4d67f11998$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $esjuM;
    const $251b5e4d67f11998$var$Icon = ({ size: size = 'medium' })=>(0, ($parcel$interopDefault($5uXOq))).createElement($251b5e4d67f11998$var$Wrapper, {
            iconSize: size
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("esjuM"))))), {
            color: "currentColor",
            spacing: size === 'small' ? 'none' : 'spacious',
            LEGACY_size: size,
            label: ""
        }));
    var $251b5e4d67f11998$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($251b5e4d67f11998$var$Icon);
    const $251b5e4d67f11998$var$SMALL_ICON_SIZE = 16;
    const $251b5e4d67f11998$var$MEDIUM_ICON_SIZE = 24;
    const $251b5e4d67f11998$var$getIconSize = ({ iconSize: iconSize })=>iconSize === 'small' ? $251b5e4d67f11998$var$SMALL_ICON_SIZE : $251b5e4d67f11998$var$MEDIUM_ICON_SIZE;
    const $251b5e4d67f11998$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_2ylchh": (0, (0, parcelRequire("lD23V")).default)($251b5e4d67f11998$var$getIconSize, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbktuk _4t3iktuk _2hwx1b66 _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eRAtL", function(module, exports) {
    $parcel$export(module.exports, "LearnMoreItem", ()=>$29c69f42cf13f0f9$export$6a36e86a5070576d);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $9lSpq;
    var $f42Sq;
    var $jiOaT;
    const $29c69f42cf13f0f9$export$6a36e86a5070576d = ({ onClosePopup: onClosePopup })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (typeof window !== 'undefined') window.open((0, (0, parcelRequire("f42Sq")).RELEASES_IN_CALENDAR_SUPPORT_ARTICLE), '_blank');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'infoLink'
            }), 'releaseFlyout');
            onClosePopup();
        }, [
            createAnalyticsEvent,
            onClosePopup
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lSpq")).ActionMenuItem), {
            onClick: onClick
        }, formatMessage((0, (0, parcelRequire("jiOaT")).messages).learnMore));
    };
});
parcelRegister("jiOaT", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7100c0bb7f4395f8$export$defe85febe8b728c);
    var $7VHMR;
    const $7100c0bb7f4395f8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        learnMore: {
            "id": "business-calendar.calendar-view.calendar-release-for-multiple-projects.learn-more-item.learn-more",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("8fX1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$566129420bc829cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $566129420bc829cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        calendarHeading: {
            "id": "business-calendar.calendar-view.calendar-heading",
            "defaultMessage": "Calendar"
        }
    });
});
parcelRegister("82SCS", function(module, exports) {
    $parcel$export(module.exports, "Toolbar", ()=>$820b1df860cff64f$export$4c260019440d418f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $a88oa;
    var $h1toL;
    var $5Fk4Z;
    var $3bDjY;
    var $lQFjJ;
    var $e7xKu;
    var $17ot5;
    var $5hI3W;
    var $4Mmyc;
    var $17X6Y;
    var $ccsmj;
    var $4R6GH;
    var $koVbs;
    var $22OQR;
    var $dAmbh;
    var $5GqLe;
    var $3t5QD;
    var $qFY65;
    var $6XjOz;
    var $2M3ip;
    var $8BVbI;
    var $l06k4;
    var $Y6wBa;
    var $gDHD8;
    var $2rLXY;
    const $820b1df860cff64f$export$4c260019440d418f = ({ onTodayClick: onTodayClick, onNextClick: onNextClick, onPrevClick: onPrevClick, onUnscheduledClick: onUnscheduledClick, currentViewStartDateOnly: currentViewStartDateOnly, isDisabled: isDisabled, isUnscheduledSidebarOpen: isUnscheduledSidebarOpen })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const [hideDoneItems, setHideDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const { inviteButtonInteraction: inviteButtonInteraction, hasInviteButton: hasInviteButton, hasPresence: hasPresence, hasShareButton: hasShareButton, hasUnscheduledButton: hasUnscheduledButton, hasFilterCustomFields: hasFilterCustomFields, hasSoftwareReleases: hasSoftwareReleases } = (0, (0, parcelRequire("l06k4")).useCalendarFeatures)();
        const count = (0, (0, parcelRequire("Y6wBa")).useUnscheduledItemsCount)();
        const { loading: startDateFieldLoading } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const shareButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccsmj")).JWMShareButton), {
            shareTitle: (0, (0, parcelRequire("gDHD8")).default).shareTitle,
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).CALENDAR,
            shareContentType: "calendar"
        });
        const searchBar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Mmyc")).SimpleSearchField), {
            placeholder: (0, (0, parcelRequire("gDHD8")).default).simpleSearch,
            view: "calendar"
        });
        const addPeopleWithPresence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17X6Y")).default), {
            view: "calendar",
            isPresenceEnabledInContext: hasPresence,
            isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
            hasInviteButton: hasInviteButton,
            allowCustomFields: (0, (0, parcelRequire("4R6GH")).fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? hasFilterCustomFields : false
        });
        const currentMonth = (0, ($parcel$interopDefault($5uXOq))).createElement($820b1df860cff64f$var$CurrentMonthWrapper, null, formatDate(currentViewStartDateOnly.toLocalDate(), {
            year: 'numeric',
            month: 'long'
        }));
        const previousMonthButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("gDHD8")).default).prevMonthButton)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a88oa"))))), {
                label: formatMessage((0, (0, parcelRequire("gDHD8")).default).prevMonthButton)
            }),
            isLoading: isDisabled,
            appearance: "subtle",
            onClick: onPrevClick,
            testId: "business-calendar.ui.calendar-view.toolbar.prev"
        }));
        const nextMonthButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("gDHD8")).default).nextMonthButton)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
                label: formatMessage((0, (0, parcelRequire("gDHD8")).default).nextMonthButton)
            }),
            isLoading: isDisabled,
            appearance: "subtle",
            onClick: onNextClick,
            testId: "business-calendar.ui.calendar-view.toolbar.next"
        }));
        const todayButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatDate(Date.now(), {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            isDisabled: isDisabled,
            onClick: onTodayClick,
            testId: "business-calendar.ui.calendar-view.toolbar.today"
        }, formatMessage((0, (0, parcelRequire("gDHD8")).default).todayButton)));
        const unscheduledButton = hasUnscheduledButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            isDisabled: startDateFieldLoading,
            onClick: onUnscheduledClick,
            isSelected: isUnscheduledSidebarOpen,
            "aria-expanded": isUnscheduledSidebarOpen,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2M3ip")).default), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("gDHD8")).default).unscheduled)
            }),
            appearance: "subtle",
            testId: "business-calendar.ui.calendar-view.toolbar.unscheduled"
        }, count ? `${formatMessage((0, (0, parcelRequire("gDHD8")).default).unscheduled)} (${count > 999 ? '999+' : count})` : `${formatMessage((0, (0, parcelRequire("gDHD8")).default).unscheduled)}`);
        const [moreMenuState, moreMenuActions] = (0, (0, parcelRequire("8BVbI")).useCalendarMoreMenuStore)();
        const onShow = (0, $5uXOq.useCallback)(()=>moreMenuActions.open('calendar-more-button'), [
            moreMenuActions
        ]);
        const shareActionButton = hasShareButton && shareButton;
        const filters = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5hI3W")).Filters), {
            view: "calendar",
            allowCustomFields: hasFilterCustomFields
        });
        const wrappedMoreMenu = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rLXY")).default), {
            hideDoneItems: Boolean(hideDoneItems),
            onChangeHideDoneItems: setHideDoneItems,
            forceVisibility: moreMenuState.isOpen
        });
        const moreMenu = (0, (0, parcelRequire("e7xKu")).isJwmTemplateBundlesEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "calendarMoreMenuSpotlight"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3t5QD")).ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: hasSoftwareReleases,
            Wrapper: (0, (0, parcelRequire("6XjOz")).CalendarReleasesNudgeAsync),
            onShow: onShow
        }, wrappedMoreMenu)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3t5QD")).ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: hasSoftwareReleases,
            Wrapper: (0, (0, parcelRequire("6XjOz")).CalendarReleasesNudgeAsync),
            onShow: onShow
        }, wrappedMoreMenu);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qFY65")).NavigateCalendarNudgeAsync), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).ActionsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).LeftActionsWrapper), null, searchBar, addPeopleWithPresence), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).RightActionsWrapper), null, currentMonth, previousMonthButton, nextMonthButton, todayButton, shareActionButton, unscheduledButton, filters, moreMenu)));
    };
    const $820b1df860cff64f$var$CurrentMonthWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1fw0",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("lQFjJ", function(module, exports) {
    $parcel$export(module.exports, "ActionsWrapper", ()=>$31ed5059f3fb9550$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "ActionsWrapperStyled", ()=>$31ed5059f3fb9550$export$ac9cdc71f29d2899);
    $parcel$export(module.exports, "LeftActionsWrapper", ()=>$31ed5059f3fb9550$export$42cb1c7ab389bf4d);
    $parcel$export(module.exports, "RightActionsWrapper", ()=>$31ed5059f3fb9550$export$4aa2cd250ec24dcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dCm1o;
    var $bUSNl;
    const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
        const [{ content: content }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
            sidebarOpen: !!content,
            "data-testid": testId,
            isVisualRefreshEnabledFG: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, children);
    };
    const $31ed5059f3fb9550$var$CenterAlignedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10qff79": (0, (0, parcelRequire("lD23V")).default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1ylp _18s8l1uc _1n261g80 _bfhk1iew _18k9ad7r",
                __cmplp.isVisualRefreshEnabledFG ? "_1yt41big" : "_1yt46hdp",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;
});
parcelRegister("e7xKu", function(module, exports) {
    $parcel$export(module.exports, "isJwmTemplateBundlesEnabled", ()=>$7d828c869f709a15$export$b9595e1ee168b117);
    var $6s1PB;
    const $7d828c869f709a15$export$b9595e1ee168b117 = ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jwm_template_bundles_experiment', 'cohort', 'variation');
    const $7d828c869f709a15$export$6df5130e98d74ad2 = ()=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jwm_help_sample_users_create_projects');
        return expConfig.get('ctaType', 'none');
    };
});
parcelRegister("5hI3W", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$afeed5d78bb3bf98$export$92a576f896a9bf72);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $co1wz;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $l8ruj;
    var $lM9c1;
    var $1TU9r;
    var $gxGcZ;
    var $dpQnO;
    var $ab4a1;
    var $6xNkv;
    const $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault = [
        'ACTIVE_SPRINTS'
    ];
    const $afeed5d78bb3bf98$export$92a576f896a9bf72 = (0, $5uXOq.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const allowedFieldTypes = (0, (0, parcelRequire("gxGcZ")).useAllowedFieldTypes)(inputAllowedFieldTypes);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const close = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const toggle = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((prevIsOpen)=>!prevIsOpen);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
        }, [
            createAnalyticsEvent
        ]);
        const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, (0, parcelRequire("1TU9r")).useDeserialiseJqlFiltersWithContext)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
        (0, $5uXOq.useEffect)(()=>{
            if (handleHasFiltersApplied) handleHasFiltersApplied(count);
        }, [
            count,
            handleHasFiltersApplied
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')) (0, (0, parcelRequire("lM9c1")).useGoalsFilterAnalyticsEvent)({
            filters: filters,
            view: view
        });
        const hasFiltersApplied = count > 0 || hasFilterError;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: close,
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab4a1")).MenuContent), {
                    "data-testid": "business-filters.ui.filters.menu-content",
                    count: count,
                    fieldConfig: fieldConfig,
                    filters: filters,
                    quickFilters: quickFilters,
                    setQuickFilters: setQuickFilters,
                    setFilters: setFilters,
                    hiddenQuickFilters: hiddenQuickFilters,
                    view: view,
                    allowCustomFields: allowCustomFields,
                    allowSavedFilters: allowSavedFilters,
                    hasFilterError: hasFilterError
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xNkv")).Trigger), {
                    ...triggerProps,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') && {
                        appearance: appearance
                    },
                    count: count,
                    hasFiltersApplied: hasFiltersApplied,
                    isSelected: isOpen,
                    onClick: toggle
                }),
            shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds'),
            strategy: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
        }), customFieldsLoader));
    });
});
parcelRegister("lM9c1", function(module, exports) {
    $parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", ()=>$a083b46fb378eaf3$export$c9b2aef46b42c898);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $8DJTW;
    const $a083b46fb378eaf3$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { data: filterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const goalField = (0, $5uXOq.useMemo)(()=>filterFields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)), [
            filterFields
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (goalField && filters[goalField.id]) {
                const goalsFilter = filters[goalField.id];
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                    source: view,
                    goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
                });
            }
        }, [
            createAnalyticsEvent,
            filters,
            goalField,
            view
        ]);
    };
});
parcelRegister("8DJTW", function(module, exports) {
    $parcel$export(module.exports, "useFilterFields", ()=>$058acf7f8802e33f$export$b2d30fa5478b571a);
    var $5uXOq = parcelRequire("5uXOq");
    var $g4ZHz;
    const $058acf7f8802e33f$export$b2d30fa5478b571a = ()=>{
        const { data: fields, loading: loading } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        const data = (0, $5uXOq.useMemo)(()=>fields?.map((field)=>({
                    id: field.jqlTerm,
                    name: field.displayName,
                    type: field.type
                })) ?? [], [
            fields
        ]);
        return {
            data: data,
            loading: loading,
            error: undefined
        };
    };
});
parcelRegister("1TU9r", function(module, exports) {
    $parcel$export(module.exports, "DeserialisedFiltersProvider", ()=>$fbaf3c30d9711dbc$export$c5640c1fbeb250b6);
    $parcel$export(module.exports, "useDeserialisedFilters", ()=>$fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7);
    $parcel$export(module.exports, "useDeserialiseJqlFilters", ()=>$fbaf3c30d9711dbc$export$eaa578dc219a620a);
    $parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", ()=>$fbaf3c30d9711dbc$export$87f52da20e747485);
    var $5uXOq = parcelRequire("5uXOq");
    var $g9ql5;
    var $8DJTW;
    var $17ot5;
    var $l4Ejo;
    var $dpQnO;
    var $2RV6Z;
    const $fbaf3c30d9711dbc$var$DEFAULT_VALUE = {
        filters: {}
    };
    const $fbaf3c30d9711dbc$var$DeserialisedFiltersContext = (0, $5uXOq.createContext)($fbaf3c30d9711dbc$var$DEFAULT_VALUE);
    const $fbaf3c30d9711dbc$export$c5640c1fbeb250b6 = ({ children: children })=>{
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const value = (0, $5uXOq.useMemo)(()=>({
                filters: filters,
                setFilters: setFilters,
                isLoading: isLoading,
                setIsLoading: setIsLoading
            }), [
            filters,
            isLoading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fbaf3c30d9711dbc$var$DeserialisedFiltersContext.Provider, {
            value: value
        }, children);
    };
    const $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7 = ()=>(0, $5uXOq.useContext)($fbaf3c30d9711dbc$var$DeserialisedFiltersContext);
    const $fbaf3c30d9711dbc$var$EMPTY_FILTER = {};
    const $fbaf3c30d9711dbc$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
        const { jql: jql, setFilter: setFilter } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, (0, parcelRequire("g9ql5")).useFieldConfigWithCustomFields)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [error, setError] = (0, $5uXOq.useState)(null);
        const hasFilterError = error != null;
        const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $5uXOq.useState)(false);
        const [filtersCache, setFiltersCache] = (0, $5uXOq.useState)({});
        const { data: filterFields, loading: isLoadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
            if (!Object.keys(fieldConfig).length) return;
            if (jql != null && filters === filtersCache[jql]) return;
            if (hasFilterError && jql != null) return;
            if (jql == null) {
                if (hasFilterError) setError(null);
                if (filters !== $fbaf3c30d9711dbc$var$EMPTY_FILTER) setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (quickFiltersJql !== null) {
                setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (filtersCache[jql]) {
                setFilters(filtersCache[jql]);
                return;
            }
            setIsDeserialisingFilters(true);
            (0, (0, parcelRequire("2RV6Z")).deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
                setFilters(result);
                setFiltersCache({
                    ...filtersCache,
                    [jql]: result
                });
            }).catch((e)=>{
                setError(e);
            }).finally(()=>{
                setIsDeserialisingFilters(false);
            });
        }, [
            hasFilterError,
            quickFiltersJql,
            error,
            filters,
            isLoadingFieldConfig,
            isLoadingFilterFields,
            fieldConfig,
            jql,
            filtersCache,
            filterFields,
            resolvers,
            isDeserialisingFilters
        ]);
        (0, (0, parcelRequire("17ot5")).useInferHideDoneItemsWithFilters)({
            filters: filters
        });
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilter,
            loading: isLoadingFieldConfig || isDeserialisingFilters
        };
    };
    const $fbaf3c30d9711dbc$export$87f52da20e747485 = (props)=>{
        const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $fbaf3c30d9711dbc$export$eaa578dc219a620a(props);
        const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
        (0, $5uXOq.useEffect)(()=>{
            if (setContextFilters) setContextFilters(filters);
        }, [
            filters,
            setContextFilters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (setIsLoadingFilters) setIsLoadingFilters(loading);
        }, [
            loading,
            setIsLoadingFilters
        ]);
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilters
        };
    };
});
parcelRegister("g9ql5", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigWithCustomFields", ()=>$937abfae1d89db7d$export$9f6dc7e3584916fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    var $5FlVd;
    var $RjSi3;
    var $cLe9v;
    const $937abfae1d89db7d$var$emptySet = new Set();
    const $937abfae1d89db7d$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
        const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, (0, parcelRequire("cLe9v")).useFieldConfig)({
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId
        });
        (0, $5uXOq.useEffect)(()=>{
            setFieldConfig({
                fieldConfig: fieldConfig,
                resolvers: resolvers,
                loading: loading
            });
        }, [
            fieldConfig,
            resolvers,
            loading,
            setFieldConfig
        ]);
        return null;
    };
    const $937abfae1d89db7d$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
        const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $5uXOq.useMemo)(()=>{
            const newTypes = new Set(allowedFieldTypes);
            const oldTypes = new Set();
            (0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
                if (allowedFieldTypes.has(type)) {
                    newTypes.delete(type);
                    oldTypes.add(type);
                }
            });
            return [
                newTypes,
                oldTypes
            ];
        }, [
            allowedFieldTypes
        ]);
        const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
        const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
        const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
        const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, (0, parcelRequire("RjSi3")).useFieldConfigV2)({
            view: view,
            allowedFieldTypes: newAllowedFieldTypes
        });
        const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $5uXOq.useState)({
            fieldConfig: {},
            resolvers: {},
            loading: shouldLoadOldFieldConfig
        });
        const customFieldsLoader = (0, $5uXOq.useMemo)(()=>{
            if (!shouldLoadOldFieldConfig) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($937abfae1d89db7d$var$CustomFieldsLoader, {
                allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $937abfae1d89db7d$var$emptySet,
                allowedAliasFieldId: allowedAliasFieldId,
                setFieldConfig: setFieldConfig
            });
        }, [
            allowCustomFields,
            allowedAliasFieldId,
            oldAllowedFieldTypes,
            shouldLoadOldFieldConfig
        ]);
        const { fetchUsers: fetchUsers } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes
        });
        const fieldConfig = (0, $5uXOq.useMemo)(()=>{
            const aliasFields = {};
            const otherFields = {};
            Object.keys(fieldConfigOld).forEach((id)=>{
                if (fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).USER_CF_TYPE)) fieldConfigOld[id] = {
                    ...fieldConfigOld[id],
                    loadOptions: fetchUsers
                };
                if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
                else otherFields[id] = fieldConfigOld[id];
            });
            return {
                ...otherFields,
                ...fieldConfigNew,
                ...aliasFields
            };
        }, [
            fieldConfigOld,
            fieldConfigNew,
            fetchUsers
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: {
                ...resolversOld,
                ...resolversNew
            },
            customFieldsLoader: customFieldsLoader,
            loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
        };
    };
});
parcelRegister("gzkAf", function(module, exports) {
    $parcel$export(module.exports, "POPUP_WIDTH", ()=>$92b04c6ea9a59b67$export$b6d617db656efcca);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$92b04c6ea9a59b67$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$92b04c6ea9a59b67$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$92b04c6ea9a59b67$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$92b04c6ea9a59b67$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$92b04c6ea9a59b67$export$fb22dccd99438559);
    $parcel$export(module.exports, "POPUP_OFFSET_TOP", ()=>$92b04c6ea9a59b67$export$15839778e99d81e7);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$92b04c6ea9a59b67$export$39aa3a14ebf850c7);
    $parcel$export(module.exports, "DATE_RANGE_TYPE", ()=>$92b04c6ea9a59b67$export$1178808c606e043b);
    $parcel$export(module.exports, "BUSINESS_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$c269ba5d631cb115);
    $parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$232814e45256d5dc);
    $parcel$export(module.exports, "IMPLEMENTED_TYPES", ()=>$92b04c6ea9a59b67$export$9615a3d79408a88a);
    $parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$a21166a4b76932b5);
    $parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", ()=>$92b04c6ea9a59b67$export$1989c7236a398e8a);
    var $gwIPs;
    var $5fc53;
    const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
    const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
    const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
    const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, (0, parcelRequire("gwIPs")).gridSize) / 2;
    const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $92b04c6ea9a59b67$export$fb22dccd99438559 = 14;
    const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
    const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
    const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
    const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
    const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        $92b04c6ea9a59b67$export$1178808c606e043b,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
    ];
    const $92b04c6ea9a59b67$export$232814e45256d5dc = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)
    ];
    const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
        ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
        ...$92b04c6ea9a59b67$export$232814e45256d5dc
    ]);
    const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ]);
    const $92b04c6ea9a59b67$export$90ca377eb0b24ff1 = {
        assignee: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        component: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        created: (0, (0, parcelRequire("5fc53")).CREATED),
        issuetype: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        labels: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        priority: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        project: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        reporter: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        status: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        updated: (0, (0, parcelRequire("5fc53")).UPDATED)
    };
    const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3.5;
    const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
    const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
    const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';
});
parcelRegister("5FlVd", function(module, exports) {
    $parcel$export(module.exports, "useFetchFieldValues", ()=>$b6820483a00ce3be$export$6cb851ed13e3949e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $hE5wF;
    var $5YBrl;
    var $jlq4V;
    var $4R6GH;
    var $eusud;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $b4fG8;
    var $34JdM;
    var $czmU8;
    var $84pWT;
    var $ldL1T;
    const $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50;
    const $b6820483a00ce3be$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
    const $b6820483a00ce3be$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$a48313dd44fc9855),
                    variables: {
                        cloudId: cloudId,
                        first: $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                        jql: jqlContext,
                        shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE))),
                        shouldFetchSoftwareFields: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE))),
                        shouldFetchParentField: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')),
                        shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')),
                        goalsJqlTerm: goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? goalsJqlTerm : '',
                        sprintsJqlContext: allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) ? `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}` : undefined
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            const hydratedValues = jqlURLParam ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParam) : null;
            const transformedInitialData = (0, (0, parcelRequire("ldL1T")).transformInitialData)(response.data);
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                return (0, (0, parcelRequire("84pWT")).mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
            }
            return transformedInitialData;
        } catch (err) {
            (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
        }
        return null;
    };
    const $b6820483a00ce3be$var$memoizedFetchInitialData = (0, (0, parcelRequire("8QpSo")).default)($b6820483a00ce3be$var$fetchInitialDataInternal);
    const $b6820483a00ce3be$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, (0, parcelRequire("34JdM")).EMPTY_TEAMS));
    const $b6820483a00ce3be$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const goalsJqlTerm = (0, (0, parcelRequire("ldL1T")).useGoalsJqlTerm)(filterFields);
        let fetchTeamsService = $b6820483a00ce3be$var$fetchTeamsServiceFnc;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) fetchTeamsService = (0, (0, parcelRequire("34JdM")).useFetchTeams)();
        const fetchInitialData = (0, $5uXOq.useCallback)(async ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
                $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
                fetchTeamsService({
                    first: $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS
                })
            ]).then((values)=>{
                let result = (0, (0, parcelRequire("b4fG8")).EMPTY_TRANSFORMED_DATA);
                values.forEach((value)=>{
                    result = {
                        ...result,
                        ...value
                    };
                });
                return result;
            });
            return $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
        }, [
            allowedFieldTypes,
            cloudId,
            fetchTeamsService,
            goalsJqlTerm,
            jqlContext
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$f8e8a5f34f6ea725),
                    variables: {
                        cloudId: cloudId,
                        first: first,
                        jqlTerm: fieldName,
                        jql: jqlContextProp ?? jqlContext,
                        searchString: query,
                        after: afterCursor
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return response.data.jira.jqlBuilder.fieldValues;
        }, [
            cloudId,
            jqlContext
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'labels',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchComponents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'component',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchPriorities = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'priority',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'assignee',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformUsers)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchIssueTypes = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'issuetype',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                let options = (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(fieldValuesData);
                if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: options
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            view
        ]);
        const fetchStatuses = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'status',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchCategories = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS })=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                    body: JSON.stringify({
                        query: (0, $c4148dc6c1f759d4$export$562e34ec948f373d),
                        variables: {
                            first: first,
                            jql: jqlContext,
                            searchQuery: query,
                            after: afterCursor
                        }
                    })
                });
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
                return {
                    totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformCategories)(response.data.jira.jwmCategoryOptions)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            jqlContext
        ]);
        const fetchSprints = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'sprint',
                    query: query,
                    first: first,
                    afterCursor: afterCursor,
                    jqlContext: `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}`
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformSprints)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            jqlContext
        ]);
        const fetchFixVersions = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'fixVersion',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchParents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'parent',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformParent)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchGoals = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            if (!goalsJqlTerm) return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
            try {
                const fieldValuesData = await fetchData({
                    fieldName: goalsJqlTerm,
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformGoals)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            goalsJqlTerm
        ]);
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchTeamsService({
                    query: query,
                    first: first,
                    after: afterCursor
                });
                return fieldValuesData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE];
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchTeamsService
        ]);
        return {
            fetchInitialData: fetchInitialData,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchPriorities: fetchPriorities,
            fetchUsers: fetchUsers,
            fetchIssueTypes: fetchIssueTypes,
            fetchStatuses: fetchStatuses,
            fetchCategories: fetchCategories,
            fetchSprints: fetchSprints,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                fetchFixVersions: fetchFixVersions,
                fetchParents: fetchParents,
                fetchTeams: fetchTeams
            } : {},
            fetchGoals: fetchGoals
        };
    };
});
parcelRegister("b4fG8", function(module, exports) {
    $parcel$export(module.exports, "transformPriorities", ()=>$7c1a01ddd808f237$export$86ca92dec35c4797);
    $parcel$export(module.exports, "transformUsers", ()=>$7c1a01ddd808f237$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformIssueTypes", ()=>$7c1a01ddd808f237$export$4c05e2584b34e4d8);
    $parcel$export(module.exports, "transformStatuses", ()=>$7c1a01ddd808f237$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformCategories", ()=>$7c1a01ddd808f237$export$1b389c47cf1df04e);
    $parcel$export(module.exports, "transformDefaultField", ()=>$7c1a01ddd808f237$export$6133e08eeff30d5f);
    $parcel$export(module.exports, "transformSprints", ()=>$7c1a01ddd808f237$export$6a33be7fc7f04943);
    $parcel$export(module.exports, "transformGoals", ()=>$7c1a01ddd808f237$export$673d4fceed3e8383);
    $parcel$export(module.exports, "transformParent", ()=>$7c1a01ddd808f237$export$87e9766fb5100314);
    $parcel$export(module.exports, "transformTeams", ()=>$7c1a01ddd808f237$export$fd398a52d6f57b46);
    $parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", ()=>$7c1a01ddd808f237$export$ca9df9cab9cc134f);
    $parcel$export(module.exports, "transformValuesData", ()=>$7c1a01ddd808f237$export$8e327b5f9ebc175d);
    var $3JOCw = parcelRequire("3JOCw");
    var $5fc53;
    var $dCm1o;
    const $7c1a01ddd808f237$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
    const $7c1a01ddd808f237$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
    const $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
    const $7c1a01ddd808f237$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node.priority.iconUrl || ''
            }));
    const $7c1a01ddd808f237$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node?.user?.picture || ''
            }));
    const $7c1a01ddd808f237$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                id: $7c1a01ddd808f237$var$getFirstIssueTypeId(node),
                avatar: $7c1a01ddd808f237$var$getFirstIssueTypeAvatar(node) || '',
                square: true,
                hierarchyLevel: $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel(node) || 0
            }));
    const $7c1a01ddd808f237$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                categoryId: node.statusCategory.statusCategoryId
            }));
    const $7c1a01ddd808f237$export$1b389c47cf1df04e = (data)=>{
        const transformedCategories = data.edges.map((edge)=>({
                cursor: edge?.cursor,
                value: edge.node.option.value,
                label: edge.node.option.value,
                color: edge.node.color
            }));
        return (0, ($parcel$interopDefault($3JOCw)))(transformedCategories, ({ value: value })=>value);
    };
    const $7c1a01ddd808f237$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName
            }));
    const $7c1a01ddd808f237$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.displayName,
                label: node.sprint?.name || ''
            }));
    const $7c1a01ddd808f237$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.goal.name || '',
                status: node.goal.status || ''
            }));
    const $7c1a01ddd808f237$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
            let avatar = '';
            if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
            return {
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: avatar,
                ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                    square: true
                }
            };
        });
    const $7c1a01ddd808f237$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
                cursor: data.pageInfo?.endCursor,
                value: node.team.id.replace('ari:cloud:identity::team/', ''),
                label: node.team.displayName || '',
                avatar: node.team.smallAvatarImageUrl || ''
            }));
    const $7c1a01ddd808f237$var$isIssueType = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issueTypes' in node);
    };
    const $7c1a01ddd808f237$var$isPriority = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'priority' in node);
    };
    const $7c1a01ddd808f237$var$isStatus = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'statusCategory' in node);
    };
    const $7c1a01ddd808f237$var$isSprint = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'sprint' in node);
    };
    const $7c1a01ddd808f237$var$isGoal = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'goal' in node);
    };
    const $7c1a01ddd808f237$var$isParent = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issue' in node);
    };
    const $7c1a01ddd808f237$var$isUser = (fieldValue)=>true;
    const $7c1a01ddd808f237$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
    const $7c1a01ddd808f237$export$ca9df9cab9cc134f = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $7c1a01ddd808f237$export$8e327b5f9ebc175d = (data)=>{
        const transformedData = {
            ...$7c1a01ddd808f237$export$ca9df9cab9cc134f
        };
        Object.entries(data).forEach(([key, fieldValue])=>{
            if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
                case 'issuetype':
                    if ($7c1a01ddd808f237$var$isIssueType(fieldValue)) transformedData.issuetype = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$4c05e2584b34e4d8(fieldValue)
                    };
                    break;
                case 'priority':
                    if ($7c1a01ddd808f237$var$isPriority(fieldValue)) transformedData.priority = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$86ca92dec35c4797(fieldValue)
                    };
                    break;
                case 'status':
                    if ($7c1a01ddd808f237$var$isStatus(fieldValue)) transformedData.status = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$20a57a5ec025f2d(fieldValue)
                    };
                    break;
                case 'component':
                case 'components':
                case 'fixVersions':
                case 'labels':
                    if ($7c1a01ddd808f237$var$isDefaultField(fieldValue)) {
                        const transformedKey = key === 'component' ? (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) : key;
                        transformedData[transformedKey] = {
                            totalCount: fieldValue.totalCount,
                            options: $7c1a01ddd808f237$export$6133e08eeff30d5f(fieldValue)
                        };
                    }
                    break;
                case 'parent':
                    if ($7c1a01ddd808f237$var$isParent(fieldValue)) transformedData[key] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$87e9766fb5100314(fieldValue)
                    };
                    break;
                default:
                    if ($7c1a01ddd808f237$var$isSprint(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$6a33be7fc7f04943(fieldValue)
                    };
                    else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $7c1a01ddd808f237$var$isUser(fieldValue)) {
                        const usersData = $7c1a01ddd808f237$export$fb8c90bfc4beaa59(fieldValue);
                        const userOptions = (0, ($parcel$interopDefault($3JOCw)))([
                            ...usersData,
                            ...transformedData.users?.options ?? []
                        ], ({ value: value })=>value);
                        transformedData.users = {
                            totalCount: userOptions.length,
                            options: userOptions
                        };
                    } else if ($7c1a01ddd808f237$var$isGoal(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$673d4fceed3e8383(fieldValue)
                    };
            }
        });
        return transformedData;
    };
});
parcelRegister("34JdM", function(module, exports) {
    $parcel$export(module.exports, "EMPTY_TEAMS", ()=>$96faa576a82047b8$export$37430da53242c305);
    $parcel$export(module.exports, "useFetchTeams", ()=>$96faa576a82047b8$export$da1ab223b3f1410c);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $5fc53;
    var $14XJw;
    var $koeKL;
    var $b4fG8;
    const $96faa576a82047b8$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
    const $96faa576a82047b8$export$37430da53242c305 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $96faa576a82047b8$export$da1ab223b3f1410c = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query, first: first = $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
            if (orgId) try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                    body: JSON.stringify({
                        query: (0, $31f39d27d8739895$export$cbe5a6af25588495),
                        variables: {
                            orgId: $96faa576a82047b8$var$prependOrgIdAri(orgId),
                            cloudId: cloudId,
                            queryString: query,
                            first: first,
                            after: after
                        }
                    })
                });
                const options = (0, (0, parcelRequire("b4fG8")).transformTeams)(response.data.team.teamSearchV2) || [];
                const totalCount = options.length >= first ? first : options.length;
                return {
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                        totalCount: totalCount,
                        options: options
                    }
                };
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchTeams',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch team filter data'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return $96faa576a82047b8$export$37430da53242c305;
        }, [
            cloudId,
            orgId
        ]);
        return fetchTeams;
    };
});
const $31f39d27d8739895$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;
parcelRegister("czmU8", function(module, exports) {
    $parcel$export(module.exports, "hydrateFilterValues", ()=>$3268558672fc0eb1$export$b18eef22aaa99c21);
    var $8QpSo;
    var $c9Ur7;
    var $jlq4V;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    const $3268558672fc0eb1$export$3361e9be8093ddcc = (fields)=>{
        const hydratedValues = {};
        fields.forEach((hydratedField)=>{
            if (!hydratedField) return;
            const { field: field, values: values } = hydratedField;
            if (!field || !values) return;
            hydratedValues[field.jqlTerm] = {
                edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                        node: item
                    })),
                totalCount: 0
            };
        });
        return hydratedValues;
    };
    const $3268558672fc0eb1$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? (0, $d73ce8e52a931002$export$2bd792833522f1f1) : (0, $d73ce8e52a931002$export$e8b5e80812d4a604),
                    variables: {
                        cloudId: cloudId,
                        jql: jqlContext
                    }
                })
            });
            if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
                if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
                throw new Error('Failed to fetch on hydrateFilterValuesService');
            }
            return $3268558672fc0eb1$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'JWMHydrateFilterValues',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $3268558672fc0eb1$export$b18eef22aaa99c21 = (0, (0, parcelRequire("8QpSo")).default)($3268558672fc0eb1$export$7a89edfb546e2344);
});
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT}
`;
parcelRegister("84pWT", function(module, exports) {
    $parcel$export(module.exports, "transformHydratedValues", ()=>$b845ee1bf81ff96f$export$56282b201a60959e);
    $parcel$export(module.exports, "mergeHydratedValues", ()=>$b845ee1bf81ff96f$export$8f60413c08081990);
    var $3JOCw = parcelRequire("3JOCw");
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $b845ee1bf81ff96f$var$transformHydratedValuesOld = (data)=>{
        const transformedHydratedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        Object.keys(data).forEach((key)=>{
            if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
                case 'issuetype':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(data[key])
                    };
                    return;
                case 'priority':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(data[key])
                    };
                    return;
                case 'status':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(data[key])
                    };
                    return;
                case 'labels':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                case 'component':
                    transformedHydratedData.components = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                default:
                    if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                        totalCount: 0,
                        options: (0, ($parcel$interopDefault($3JOCw)))([
                            ...(0, (0, parcelRequire("b4fG8")).transformUsers)(data[key]),
                            ...transformedHydratedData.users?.options ?? []
                        ], ({ value: value })=>value)
                    };
                    else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformSprints)(data[key])
                    };
            }
        });
        return transformedHydratedData;
    };
    const $b845ee1bf81ff96f$export$56282b201a60959e = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return (0, (0, parcelRequire("b4fG8")).transformValuesData)(data);
        return $b845ee1bf81ff96f$var$transformHydratedValuesOld(data);
    };
    const $b845ee1bf81ff96f$export$8f60413c08081990 = (initialData, hydratedValues)=>({
            labels: {
                totalCount: initialData.labels.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.labels.options,
                    ...initialData.labels.options
                ], ({ value: value })=>value)
            },
            components: {
                totalCount: initialData.components.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.components.options,
                    ...initialData.components.options
                ], ({ value: value })=>value)
            },
            priority: {
                totalCount: initialData.priority.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.priority.options,
                    ...initialData.priority.options
                ], ({ value: value })=>value)
            },
            users: {
                totalCount: initialData.users.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.users.options,
                    ...initialData.users.options
                ], ({ value: value })=>value)
            },
            issuetype: {
                totalCount: initialData.issuetype.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.issuetype.options,
                    ...initialData.issuetype.options
                ], ({ value: value })=>value)
            },
            status: {
                totalCount: initialData.status.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.status.options,
                    ...initialData.status.options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE],
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options,
                    ...initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            }
        });
});
const $c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $c4148dc6c1f759d4$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
parcelRegister("ldL1T", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$6a7ee4f9267edb3b$export$93219b8691fe49a0);
    $parcel$export(module.exports, "fireFieldValuesErrorAnalytics", ()=>$6a7ee4f9267edb3b$export$c3c62a63250fc6f8);
    $parcel$export(module.exports, "useGoalsJqlTerm", ()=>$6a7ee4f9267edb3b$export$674eff5ec8403101);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $jcw0u;
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $6a7ee4f9267edb3b$var$transformInitialCategories = (data)=>{
        if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
            totalCount: data.jira.jwmCategoryOptions.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformCategories)(data.jira.jwmCategoryOptions)
        };
        return undefined;
    };
    const $6a7ee4f9267edb3b$var$transformInitialDataOld = (data)=>{
        const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
        const transformedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
            totalCount: components.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(components)
        };
        if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
            totalCount: issuetype.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(issuetype)
        };
        if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
            totalCount: priority.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(priority)
        };
        if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
            totalCount: labels.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(labels)
        };
        if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
            totalCount: status.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(status)
        };
        if (users?.edges != null && Array.isArray(users.edges)) {
            const usersData = (0, (0, parcelRequire("b4fG8")).transformUsers)(users);
            const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, (0, parcelRequire("b4fG8")).transformUsers)(recentlyUsedUsers) : null;
            transformedData.users = {
                totalCount: users.totalCount,
                options: recentlyUsedUsersData != null ? (0, ($parcel$interopDefault($3JOCw)))([
                    ...recentlyUsedUsersData,
                    ...usersData
                ], ({ value: value })=>value) : usersData
            };
        }
        const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
        if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
        if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
            options: (0, (0, parcelRequire("b4fG8")).transformSprints)(sprints),
            totalCount: sprints.totalCount
        };
        return transformedData;
    };
    const $6a7ee4f9267edb3b$export$93219b8691fe49a0 = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
            const transformedData = (0, (0, parcelRequire("b4fG8")).transformValuesData)(data.jira.jqlBuilder);
            const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
            if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
            return transformedData;
        }
        return $6a7ee4f9267edb3b$var$transformInitialDataOld(data);
    };
    const $6a7ee4f9267edb3b$export$c3c62a63250fc6f8 = (errorId, errorMessage, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: errorId,
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: errorMessage
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $6a7ee4f9267edb3b$export$674eff5ec8403101 = (filterFields)=>{
        const goalsJqlTerm = (0, $5uXOq.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE))?.id, [
            filterFields
        ]);
        return goalsJqlTerm;
    };
});
parcelRegister("RjSi3", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigV2", ()=>$95c9fbd80a67ba2b$export$c041141a7ef797c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $aJfd5;
    var $4R6GH;
    var $koVbs;
    var $5fc53;
    var $5FlVd;
    var $8DJTW;
    var $gxGcZ;
    var $1qi71;
    const $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA = {
        initialUsers: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialLabels: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialComponents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialPriorities: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialIssueTypes: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialStatuses: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialCategories: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialSprints: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialFixVersions: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialParents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialGoals: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialTeams: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA
    };
    const $95c9fbd80a67ba2b$var$initialState = {
        data: undefined,
        loadingData: true
    };
    const $95c9fbd80a67ba2b$var$reducer = (state, action)=>{
        switch(action.type){
            case 'init':
                return $95c9fbd80a67ba2b$var$initialState;
            case 'fetch-data-success':
                return {
                    ...state,
                    data: action.value,
                    loadingData: false
                };
            case 'fetch-data-error':
                return {
                    ...state,
                    data: $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA,
                    loadingData: false
                };
            default:
                return state;
        }
    };
    const $95c9fbd80a67ba2b$var$emptyFieldValue = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectFieldData = (0, (0, parcelRequire("gxGcZ")).useProjectFilter)();
        const { data: filterFields, loading: loadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const [{ data: data, loadingData: loadingData }, dispatch] = (0, $5uXOq.useReducer)($95c9fbd80a67ba2b$var$reducer, $95c9fbd80a67ba2b$var$initialState);
        const userResolver = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            filterFields: filterFields
        });
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const businessEntityId = entity.id;
        const initialiseDefaultData = (0, $5uXOq.useCallback)(()=>{
            fetchInitialData().then((initialData)=>{
                dispatch({
                    type: 'fetch-data-success',
                    value: {
                        initialUsers: initialData?.users ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialLabels: initialData?.labels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialComponents: initialData?.components ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialPriorities: initialData?.priority ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialIssueTypes: initialData?.issuetype ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialStatuses: initialData?.status ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialCategories: initialData?.[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialSprints: initialData?.[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                            initialFixVersions: initialData?.[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialParents: initialData?.[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialTeams: initialData?.[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                        } : {},
                        initialGoals: initialData?.[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                    }
                });
            }).catch(()=>{
                dispatch({
                    type: 'fetch-data-error'
                });
            });
        }, [
            fetchInitialData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!loadingFilterFields) {
                dispatch({
                    type: 'init'
                });
                initialiseDefaultData();
            }
        }, [
            initialiseDefaultData,
            loadingFilterFields,
            businessEntityId
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $5uXOq.useMemo)(()=>{
            const fieldOptionsData = {
                priority: data?.initialPriorities ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                issuetype: data?.initialIssueTypes ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                status: data?.initialStatuses ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                users: data?.initialUsers ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                labels: data?.initialLabels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                components: data?.initialComponents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: data?.initialCategories ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: data?.initialSprints ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                project: projectFieldData,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                    [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: data?.initialParents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                } : {},
                [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: data?.initialGoals ?? $95c9fbd80a67ba2b$var$emptyFieldValue
            };
            return (0, (0, parcelRequire("1qi71")).getFilterFieldConfigAndResolvers)({
                view: view,
                formatMessage: formatMessage,
                allFields: filterFields,
                allowedFieldTypes: allowedFieldTypes,
                fieldOptionsData: fieldOptionsData,
                fetchUsers: fetchUsers,
                fetchLabels: fetchLabels,
                fetchComponents: fetchComponents,
                fetchCategories: fetchCategories,
                ...fetchOptions,
                userResolver: userResolver.current
            });
        }, [
            data?.initialPriorities,
            data?.initialIssueTypes,
            data?.initialStatuses,
            data?.initialUsers,
            data?.initialLabels,
            data?.initialComponents,
            data?.initialCategories,
            data?.initialSprints,
            data?.initialFixVersions,
            data?.initialParents,
            data?.initialGoals,
            data?.initialTeams,
            projectFieldData,
            view,
            formatMessage,
            filterFields,
            allowedFieldTypes,
            fetchUsers,
            fetchLabels,
            fetchComponents,
            fetchCategories,
            fetchOptions
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingData || loadingFilterFields || data == null
        };
    };
});
parcelRegister("aJfd5", function(module, exports) {
    $parcel$export(module.exports, "UserResolver", ()=>$c1905445333aa67f$export$723df28d03868f02);
    var $dJl1T;
    var $7f4tk;
    class $c1905445333aa67f$export$723df28d03868f02 {
        constructor(){
            this.getUsersFromAccountId = (accountIds)=>{
                const recoveredFromCache = [];
                const missingFromCache = [];
                accountIds.forEach((accountId)=>{
                    const user = this.cache.get(accountId);
                    if (user) recoveredFromCache.push(user);
                    else missingFromCache.push(accountId);
                });
                if (missingFromCache.length === 0) return Promise.resolve(recoveredFromCache);
                return (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && response.values.forEach((user)=>{
                        if (user) this.cache.set(user.accountId, user);
                    })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
                });
            };
            this.cache = new Map();
        }
    }
});
parcelRegister("gxGcZ", function(module, exports) {
    $parcel$export(module.exports, "FiltersProvider", ()=>$5ac2d1f4676106ae$export$905df3588d1d8c75);
    $parcel$export(module.exports, "useAssigneesFilterQuery", ()=>$5ac2d1f4676106ae$export$f39bce8705b01ff5);
    $parcel$export(module.exports, "useProjectFilter", ()=>$5ac2d1f4676106ae$export$b71768ffb8163578);
    $parcel$export(module.exports, "useAllowedFieldTypes", ()=>$5ac2d1f4676106ae$export$9dc8a291956c2fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
        assigneeQuery: '',
        projectFilter: {
            totalCount: 0,
            options: []
        }
    };
    const $5ac2d1f4676106ae$var$FiltersContext = (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
    const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
            const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
            const projectFilter = {
                totalCount: projects.length,
                options: projects.map((project)=>({
                        label: project.name,
                        value: String(project.id),
                        avatar: project.avatarUrl,
                        square: true
                    }))
            };
            return {
                assigneeQuery: assigneeQuery,
                projectFilter: projectFilter
            };
        }, [
            projects
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
            value: value
        }, children);
    };
    const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
    const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
    const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
        const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
        return (0, $5uXOq.useMemo)(()=>{
            const result = new Set(inputAllowedFieldTypes ?? (0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES));
            if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, (0, parcelRequire("5fc53")).PROJECT_TYPE));
            return result;
        }, [
            filtersContext,
            inputAllowedFieldTypes
        ]);
    };
});
parcelRegister("1qi71", function(module, exports) {
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$beea8d83023eb0fe$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $4R6GH;
    var $5fc53;
    var $dCm1o;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $j0h5m;
    const $beea8d83023eb0fe$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $beea8d83023eb0fe$var$getType = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
            case 0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).ProjectFilter;
            case 0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).GoalsSelectFilter;
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $beea8d83023eb0fe$var$getValues = (type, fieldOptionsData)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return fieldOptionsData.users;
            default:
                return fieldOptionsData[type];
        }
    };
    const $beea8d83023eb0fe$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$isCustomField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$beea8d83023eb0fe$export$fb8c90bfc4beaa59(response)));
    const $beea8d83023eb0fe$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("j0h5m")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter,
            fromLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).startDateLabel),
            toLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).dueDateLabel)
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id } = field;
            const fieldType = type ?? '';
            const fieldValues = $beea8d83023eb0fe$var$getValues(fieldType, fieldOptionsData);
            fieldConfig[id] = {
                label: name,
                type: $beea8d83023eb0fe$var$getType(fieldType),
                placeholder: formatMessage((0, (0, parcelRequire("j0h5m")).default).filterPlaceholder),
                options: fieldValues?.options || [],
                totalCount: fieldValues?.totalCount || 0,
                isCustomField: $beea8d83023eb0fe$var$isCustomField(fieldType),
                fieldConfigVersion: 2
            };
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) {
                let options = fieldValues?.options || [];
                if (view === 'board') {
                    options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                    fieldConfig[id].options = options;
                }
                if (fetchIssueTypes) {
                    fieldConfig[id].loadOptions = fetchIssueTypes;
                    fieldConfig[id].defaultOptions = options;
                }
            } else if ($beea8d83023eb0fe$var$isUserField(fieldType)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                resolvers[id] = $beea8d83023eb0fe$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noLabelsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noComponentsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noCategoriesLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).STATUS_TYPE) && fetchStatuses) {
                fieldConfig[id].loadOptions = fetchStatuses;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE) && fetchPriorities) {
                fieldConfig[id].loadOptions = fetchPriorities;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE) && fetchSprints) {
                fieldConfig[id].loadOptions = fetchSprints;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noSprintLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && fetchFixVersions && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchFixVersions;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noVersionLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE) && fetchParents && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchParents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noParentLabel),
                        isEmptyOption: true,
                        ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                            square: true
                        }
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE) && fetchGoals) {
                fieldConfig[id].loadOptions = fetchGoals;
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noGoalLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fetchTeams && fieldType === (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchTeams;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noTeamLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            }
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("gBF4Z", function(module, exports) {
    $parcel$export(module.exports, "FieldType", ()=>$8ecd5c1ebfc76de6$export$ed12481c953b8653);
    $parcel$export(module.exports, "isDateField", ()=>$8ecd5c1ebfc76de6$export$7d34c8548269835d);
    const $8ecd5c1ebfc76de6$export$ed12481c953b8653 = {
        AsyncSelectFilter: 'AsyncSelectFilter',
        AvatarSelectFilter: 'AvatarSelectFilter',
        AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
        PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
        LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
        PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
        LozengeSelectFilter: 'LozengeSelectFilter',
        PrioritySelectFilter: 'PrioritySelectFilter',
        CategorySelectFilter: 'CategorySelectFilter',
        GoalsSelectFilter: 'GoalsSelectFilter',
        PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
        NumberFilter: 'NumberFilter',
        SelectFilter: 'SelectFilter',
        SearchFilter: 'SearchFilter',
        TextFilter: 'TextFilter',
        DateFilter: 'DateFilter',
        ProjectFilter: 'ProjectFilter'
    };
    const $8ecd5c1ebfc76de6$export$7d34c8548269835d = (field)=>field.type === $8ecd5c1ebfc76de6$export$ed12481c953b8653.DateFilter;
});
parcelRegister("j0h5m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73773c42d63775af$export$2e2bcd8739ae039);
    var $7VHMR;
    var $73773c42d63775af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config-v2.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config-v2.date-range-label",
            "defaultMessage": "Date range"
        },
        startDateLabel: {
            "id": "business-filters.controllers.field-config-v2.start-date-label",
            "defaultMessage": "Start date"
        },
        dueDateLabel: {
            "id": "business-filters.controllers.field-config-v2.due-date-label",
            "defaultMessage": "Due date"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config-v2.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noLabelsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-labels-label",
            "defaultMessage": "No label"
        },
        noCategoriesLabel: {
            "id": "business-filters.controllers.field-config-v2.no-categories-label",
            "defaultMessage": "No category"
        },
        noComponentsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-components-label",
            "defaultMessage": "No component"
        },
        noSprintLabel: {
            "id": "business-filters.controllers.field-config-v2.no-sprint-label",
            "defaultMessage": "Backlog"
        },
        noVersionLabel: {
            "id": "business-filters.controllers.field-config-v2.no-version-label",
            "defaultMessage": "No version"
        },
        noParentLabel: {
            "id": "business-filters.controllers.field-config-v2.no-parent-label",
            "defaultMessage": "No parent"
        },
        noGoalLabel: {
            "id": "business-filters.controllers.field-config-v2.no-goal-label",
            "defaultMessage": "No goal"
        },
        noTeamLabel: {
            "id": "business-filters.controllers.field-config-v2.no-team-label",
            "defaultMessage": "No team"
        }
    });
});
parcelRegister("cLe9v", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfig", ()=>$bad07c14bc3eb691$export$70da50df1be2dbe1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $hE5wF;
    var $ftuRD;
    var $1T2vX;
    var $2H8QW;
    var $2Lcoi;
    var $aJfd5;
    var $jcw0u;
    var $7f4tk;
    var $koVbs;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $doZTA;
    var $czmU8;
    var $84pWT;
    var $8841m;
    var $1vUxa;
    var $e3P1V;
    const $bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS = 10;
    const $bad07c14bc3eb691$var$useFilterMapper = true;
    const $bad07c14bc3eb691$var$EMPTY_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_USER_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY = [];
    const $bad07c14bc3eb691$export$1fe8227c57fa0d68 = ()=>({
            initialUsers: {
                data: $bad07c14bc3eb691$var$EMPTY_USER_ARRAY,
                isLoading: false
            },
            initialLabels: {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            },
            initialComponents: {
                data: $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY,
                isLoading: false
            },
            initialCategories: {
                data: $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY,
                isLoading: false
            },
            projectKey: null
        });
    const $bad07c14bc3eb691$export$74cea4b24a6bc9fa = $bad07c14bc3eb691$export$1fe8227c57fa0d68();
    const $bad07c14bc3eb691$var$useForceUpdate = ()=>{
        const [, setValue] = (0, $5uXOq.useState)(0);
        return (0, $5uXOq.useCallback)(()=>setValue((value)=>value + 1), []);
    };
    const $bad07c14bc3eb691$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userResolver] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const forceUpdate = $bad07c14bc3eb691$var$useForceUpdate();
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const formattedCategoryOptions = (0, $5uXOq.useMemo)(()=>{
            const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
            return categoryOptions.map(({ value: value })=>({
                    label: value,
                    value: value
                }));
        }, [
            issueTypeData
        ]);
        const { statuses: statuses, loading: loadingStatuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const hydratedUsers = (0, $5uXOq.useRef)(null);
        const fetchInitialUsers = (0, $5uXOq.useCallback)(async ()=>{
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
            let users = [];
            const hydratedValues = jqlURLParamRef.current ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                hydratedUsers.current = transformedHydratedValues.users.options;
            }
            const url = `/rest/api/3/user/search?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=`;
            users = await (0, (0, parcelRequire("7f4tk")).default)(url);
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers = {
                data: users,
                isLoading: false
            };
            forceUpdate();
            return users;
        }, [
            cloudId,
            forceUpdate
        ]);
        const fetchInitialLabels = (0, $5uXOq.useCallback)(async ()=>{
            const url = `/rest/api/3/label?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}`;
            try {
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const labels = response.values;
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                    data: labels,
                    isLoading: false
                };
                forceUpdate();
                return labels;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterInitialLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch initial labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            };
            forceUpdate();
            return $bad07c14bc3eb691$var$EMPTY_ARRAY;
        }, [
            forceUpdate
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) {
                const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
                try {
                    const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                    return response;
                } catch (err) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'searchFilterUsers',
                            packageName: 'jiraBusinessFilters',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to search users',
                            errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            return $bad07c14bc3eb691$var$EMPTY_USER_ARRAY;
        }, [
            projectKey
        ]);
        const fetchProjectComponents = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) try {
                const response = await (0, (0, parcelRequire("2Lcoi")).fetchComponents)({
                    inputValue: query,
                    autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                    useFilterMapper: $bad07c14bc3eb691$var$useFilterMapper
                });
                return response;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterComponents',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch components',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return [];
        }, [
            projectKey
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)((query = '')=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'searchFilterLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }), []);
        const fetchProjectCategories = (0, $5uXOq.useCallback)((query = '')=>{
            const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
            return Promise.resolve(filteredCategoriesQuery ?? []);
        }, [
            formattedCategoryOptions
        ]);
        const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)
        });
        const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsEstimateData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (projectKey != null && ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey !== projectKey || $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.data === $bad07c14bc3eb691$var$EMPTY_USER_ARRAY)) {
                if ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                    $bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey = projectKey;
                    fetchInitialUsers();
                }
            }
        }, [
            fetchInitialUsers,
            fetchProjectComponents,
            projectKey,
            fetchInitialLabels,
            fetchProjectCategories,
            forceUpdate
        ]);
        const { data: initialUsers, isLoading: isLoadingUsers } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers;
        const { data: initialLabels, isLoading: isLoadingLabels } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels;
        const { data: initialComponents, isLoading: isLoadingComponents } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialComponents;
        const { data: initialCategories, isLoading: isLoadingCategories } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialCategories;
        const fieldOptionsData = (0, $5uXOq.useMemo)(()=>({
                priority: (0, (0, parcelRequire("e3P1V")).transformPriority)(priorityFieldConfig),
                issuetype: (0, (0, parcelRequire("e3P1V")).transformIssueType)(issueTypeData),
                status: (0, (0, parcelRequire("e3P1V")).transformStatuses)(statuses),
                users: (0, (0, parcelRequire("e3P1V")).transformUsers)(initialUsers),
                labels: (0, (0, parcelRequire("e3P1V")).transformLabels)(initialLabels),
                components: initialComponents,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialCategories,
                [(0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
                [(0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
            }), [
            priorityFieldConfig,
            issueTypeData,
            statuses,
            initialUsers,
            initialLabels,
            initialComponents,
            initialCategories,
            initialStoryPoints?.options,
            initialStoryPointsEstimate?.options
        ]);
        fieldOptionsData.users = (0, $5uXOq.useMemo)(()=>{
            if (hydratedUsers.current === null) return fieldOptionsData.users;
            return (0, ($parcel$interopDefault($3JOCw)))([
                ...hydratedUsers.current ?? [],
                ...fieldOptionsData.users ?? []
            ], ({ value: value })=>value);
        }, [
            fieldOptionsData
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, (0, parcelRequire("e3P1V")).getFilterFieldConfigAndResolvers)({
            formatMessage: formatMessage,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allFields: issueTypeData.fields,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, (0, parcelRequire("e3P1V")).transformUsers)(users || [])),
            fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, (0, parcelRequire("e3P1V")).transformLabelSuggestions)(labels) : []),
            fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
            fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
            userResolver: userResolver
        });
        const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingIssueTypesAndFields || loadingStatuses || fetching
        };
    };
});
parcelRegister("2H8QW", function(module, exports) {
    $parcel$export(module.exports, "getErrorType", ()=>$3122aab38ac46d24$export$e19f9f08a6d79fd2);
    var $jJZqs;
    const $3122aab38ac46d24$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
    const $3122aab38ac46d24$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
    const $3122aab38ac46d24$export$d46a05f8561f868a = 'OTHER';
    const $3122aab38ac46d24$export$c748438cec453c9f = {
        FAILED_TO_FETCH: 'Failed to fetch',
        NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
        NETWORK_REQUEST_FAILED: 'Network request failed',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        ABORTED: 'operation was aborted.',
        CANCELLED: 'cancelled',
        TIMEOUT: 'The request timed out.'
    };
    const $3122aab38ac46d24$var$isApolloClientNetworkError = (error)=>error.networkError !== undefined && error.networkError !== null;
    const $3122aab38ac46d24$export$e19f9f08a6d79fd2 = (error)=>{
        if (error == null) return $3122aab38ac46d24$export$9705762bba4e9e25;
        const message = String(error instanceof Error ? error.message : error).trim();
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode) return `FETCH_ERROR_${statusCode}`;
        }
        if ($3122aab38ac46d24$var$isApolloClientNetworkError(error)) return $3122aab38ac46d24$export$7453182ebe5973d4;
        const entry = Object.entries($3122aab38ac46d24$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        return entry ? entry[0] : $3122aab38ac46d24$export$d46a05f8561f868a;
    };
});
parcelRegister("2Lcoi", function(module, exports) {
    $parcel$export(module.exports, "fetchComponents", ()=>$14f8d378ed2868dc$export$4f703ddb7c8cc5b3);
    var $ebyGx = parcelRequire("ebyGx");
    var $2H8QW;
    var $jcw0u;
    var $eusud;
    var $lb7V6;
    const $14f8d378ed2868dc$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, queryParameters: queryParameters })=>{
        const mapperFunction = useFilterMapper === true ? (0, (0, parcelRequire("lb7V6")).mapComponentsToFilterOptions) : (0, (0, parcelRequire("lb7V6")).mapComponentsToOptions);
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify({
            query: inputValue,
            ...queryParameters
        });
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchProjectComponents',
                    packageName: 'jiraBusinessFetchComponents',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch jwm project components',
                    errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
});
parcelRegister("lb7V6", function(module, exports) {
    $parcel$export(module.exports, "mapComponentsToOptions", ()=>$4c5d47ac0f899709$export$85e44418187c2c1e);
    $parcel$export(module.exports, "mapComponentsToFilterOptions", ()=>$4c5d47ac0f899709$export$b4ef58d3e943e4d5);
    const $4c5d47ac0f899709$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
                label: name,
                value: componentId !== undefined ? String(componentId) : String(id)
            }));
    const $4c5d47ac0f899709$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
                label: name,
                value: name
            }));
});
parcelRegister("1vUxa", function(module, exports) {
    $parcel$export(module.exports, "useGroupItemValues", ()=>$f2df8273d684a2c0$export$f05af123f98299b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ccvFs;
    var $5YBrl;
    var $jlq4V;
    var $koVbs;
    var $g31qf;
    var $baeZQ;
    const $f2df8273d684a2c0$var$reducer = (state, action)=>{
        switch(action.type){
            case 'loading':
                return {
                    loading: true
                };
            case 'success':
                return {
                    loading: false,
                    data: action.payload
                };
            case 'error':
                return {
                    loading: false,
                    data: null
                };
            default:
                return state;
        }
    };
    const $f2df8273d684a2c0$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
        const [state, dispatch] = (0, $5uXOq.useReducer)($f2df8273d684a2c0$var$reducer, {
            loading: false
        });
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fetchDataAbortable = (0, (0, parcelRequire("ccvFs")).useAbortable)((0, (0, parcelRequire("g31qf")).fetchGroupItemValues));
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            try {
                dispatch({
                    type: 'loading'
                });
                const response = await fetchDataAbortable(groupFieldId, jqlContext);
                if (response.data?.items == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                dispatch({
                    type: 'success',
                    payload: (0, (0, parcelRequire("baeZQ")).transformInitialData)({
                        data: response.data,
                        formatMessage: formatMessage
                    })
                });
            } catch (error) {
                if (error === (0, (0, parcelRequire("ccvFs")).ABORTED)) return;
                dispatch({
                    type: 'error'
                });
            }
        }, [
            fetchDataAbortable,
            formatMessage,
            groupFieldId,
            jqlContext
        ]);
        return {
            fetch: fetch,
            data: state.data,
            loading: state.loading
        };
    };
});
parcelRegister("ccvFs", function(module, exports) {
    $parcel$export(module.exports, "ABORTED", ()=>$e04e223192d877be$export$23e29024ea698a35);
    $parcel$export(module.exports, "useAbortable", ()=>$e04e223192d877be$export$a487c7eb4387f959);
    var $5uXOq = parcelRequire("5uXOq");
    const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
    const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
        const prevControllerRef = (0, $5uXOq.useRef)(null);
        return (0, $5uXOq.useCallback)((...args)=>{
            if (prevControllerRef.current) prevControllerRef.current.abort();
            const controller = new AbortController();
            prevControllerRef.current = controller;
            return fetch(controller.signal, ...args).catch((error)=>{
                if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
                else throw error;
            });
        }, [
            fetch
        ]);
    };
});
parcelRegister("g31qf", function(module, exports) {
    $parcel$export(module.exports, "fetchGroupItemValues", ()=>$71087c8bd1916bd2$export$7e6e0c3f4468ce45);
    var $jcw0u;
    var $fZneA;
    var $eusud;
    const $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $71087c8bd1916bd2$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
        try {
            const variables = {
                fieldId: groupFieldId,
                first: $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS,
                jql: jqlContext
            };
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
                body: JSON.stringify({
                    query: (0, $626c877b75948b48$export$a48313dd44fc9855),
                    variables: variables
                })
            });
            return response;
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error) && !signal.aborted) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'initializeFilterGroupItemsData',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to initialize filter data using the group query'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $626c877b75948b48$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;
parcelRegister("baeZQ", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$a3e52c0a295405a4$export$93219b8691fe49a0);
    var $9D5f1;
    const $a3e52c0a295405a4$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
            totalCount: data.items.totalCount,
            options: data.items.edges.map((edge)=>{
                if (edge.node.field.floatValue == null) return {
                    value: null,
                    label: formatMessage((0, (0, parcelRequire("9D5f1")).default).noneOption)
                };
                const stringFloatValue = String(edge.node.field.floatValue);
                return {
                    value: stringFloatValue,
                    label: stringFloatValue
                };
            })
        });
});
parcelRegister("9D5f1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff2b830268d99634$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff2b830268d99634$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneOption: {
            "id": "business-filters.controllers.group-item-values.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("e3P1V", function(module, exports) {
    $parcel$export(module.exports, "transformPriority", ()=>$b808701b322de4e8$export$1b9f55a39456e911);
    $parcel$export(module.exports, "transformIssueType", ()=>$b808701b322de4e8$export$96520244689f81c1);
    $parcel$export(module.exports, "transformStatuses", ()=>$b808701b322de4e8$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformUsers", ()=>$b808701b322de4e8$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformLabels", ()=>$b808701b322de4e8$export$c072126708d93f04);
    $parcel$export(module.exports, "transformLabelSuggestions", ()=>$b808701b322de4e8$export$cdfcc40760c1a4f8);
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$b808701b322de4e8$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $hE5wF;
    var $5fc53;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $6S22M;
    const $b808701b322de4e8$export$1b9f55a39456e911 = (0, (0, parcelRequire("8QpSo")).default)((priorityFieldConfig)=>[
            ...priorityFieldConfig?.options || []
        ].reduce((acc, next)=>{
            acc.push({
                value: next.name,
                label: next.name,
                avatar: next.iconUrl || ''
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$96520244689f81c1 = (0, (0, parcelRequire("8QpSo")).default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
            acc.push({
                value: next.id,
                label: next.name,
                id: next.id,
                avatar: next.avatarUrl,
                square: true
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$20a57a5ec025f2d = (0, (0, parcelRequire("8QpSo")).default)((statuses)=>statuses.reduce((acc, next)=>{
            acc.push({
                value: next.untranslatedName,
                label: next.name,
                categoryId: next.statusCategory.id,
                id: Number(next.id)
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$c072126708d93f04 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels.reduce((acc, next)=>{
            acc.push({
                value: next || '',
                label: next
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$cdfcc40760c1a4f8 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
            acc.push({
                value: next.label || '',
                label: next.label
            });
            return acc;
        }, []));
    const $b808701b322de4e8$var$getType = ({ type: type })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $b808701b322de4e8$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
                label: value,
                value: value
            }));
    const $b808701b322de4e8$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return fieldOptionsData.users;
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return $b808701b322de4e8$var$getSelectCustomFieldValues(field);
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                if (aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID];
                return fieldOptionsData[type];
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
            default:
                return fieldOptionsData[type];
        }
    };
    const $b808701b322de4e8$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $b808701b322de4e8$var$isCustomField = (type)=>(0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).has(type);
    const $b808701b322de4e8$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$b808701b322de4e8$export$fb8c90bfc4beaa59(response)));
    const $b808701b322de4e8$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("6S22M")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
            if (type == null || aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return;
            const selectType = $b808701b322de4e8$var$getType({
                type: type
            });
            fieldConfig[id] = {
                systemType: type,
                label: name,
                type: selectType,
                placeholder: formatMessage((0, (0, parcelRequire("6S22M")).default).filterPlaceholder),
                options: $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData,
                    field: field,
                    aliasFieldId: aliasFieldId
                }),
                isCustomField: $b808701b322de4e8$var$isCustomField(type),
                fieldConfigVersion: 1
            };
            if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, (0, parcelRequire("6S22M")).default).typeLabel);
            if ($b808701b322de4e8$var$isUserField(type)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
                resolvers[id] = $b808701b322de4e8$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: 'EMPTY',
                        label: formatMessage((0, (0, parcelRequire("6S22M")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
            }
            if (type === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                    label: formatMessage((0, (0, parcelRequire("6S22M")).default).noneOption),
                    isEmptyOption: true
                }
            ];
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("6S22M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0167d244ddce5b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c0167d244ddce5b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config.date-range-label",
            "defaultMessage": "Date range"
        },
        typeLabel: {
            "id": "business-filters.controllers.field-config.type-label",
            "defaultMessage": "Type"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noneOption: {
            "id": "business-filters.controllers.field-config.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("2RV6Z", function(module, exports) {
    $parcel$export(module.exports, "deserialiseJql", ()=>$42cbf7cea9b7c40a$export$214464255b766962);
    var $3dHKF = parcelRequire("3dHKF");
    var $2nvJN = parcelRequire("2nvJN");
    var $pyK8a;
    var $f9ece;
    var $bv7J5;
    var $eK6AG;
    var $bzbto;
    var $4R6GH;
    var $5fc53;
    var $gBF4Z;
    var $7htvz;
    const $42cbf7cea9b7c40a$var$START_DATE_JQL = 'Start date[Date]';
    const $42cbf7cea9b7c40a$var$EMPTY = 'EMPTY';
    const $42cbf7cea9b7c40a$var$cleanString = (value)=>value.trim();
    const $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption = (filterField)=>{
        const allowedFieldTypes = new Set([
            (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
            (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('fix-parent-filter-loaded-in-pagination')) allowedFieldTypes.add((0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE));
        return allowedFieldTypes.has(filterField?.type ?? '');
    };
    const $42cbf7cea9b7c40a$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $42cbf7cea9b7c40a$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $42cbf7cea9b7c40a$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
        if (resolver && typeof resolver === 'function') {
            const ids = list.map((value)=>(0, (0, parcelRequire("4R6GH")).fg)('wanjel-fix-filters-including-whitespace') ? value : $42cbf7cea9b7c40a$var$cleanString(value));
            return resolver(ids);
        }
        const allowUnknownOption = $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption(filterField);
        return list.map((value)=>{
            const cleanValue = (0, (0, parcelRequire("4R6GH")).fg)('wanjel-fix-filters-including-whitespace') ? value : $42cbf7cea9b7c40a$var$cleanString(value);
            if (field && !(0, (0, parcelRequire("gBF4Z")).isDateField)(field) && Array.isArray(field.options)) {
                const optionInField = field.options.find((option)=>{
                    if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                    if (option.isEmptyOption) return value === $42cbf7cea9b7c40a$var$EMPTY;
                    return option.value === cleanValue;
                });
                if (!optionInField && allowUnknownOption) return {
                    value: cleanValue,
                    label: cleanValue
                };
                return optionInField;
            }
            return undefined;
        }).filter((item)=>item != null && 'value' in item);
    };
    class $42cbf7cea9b7c40a$export$5299115fe71e8b39 extends (0, (0, parcelRequire("bv7J5")).AbstractJastVisitor) {
        constructor(fieldConfig, filterFields, resolvers){
            super();
            this.getOption = (fieldName, items)=>$42cbf7cea9b7c40a$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
            this.visitCompoundClause = async (compoundClause)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('wanjel-fix-deserialise-filters-sentry-errors')) {
                    const clauseMap = {};
                    const operator = compoundClause.operator.value;
                    if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) {
                        const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                        return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
                    }
                    throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
                }
                const clauseMap = Promise.resolve({});
                const operator = compoundClause.operator.value;
                if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
                throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
            };
            this.parseDateOperand = (operator, operand)=>{
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) {
                    let date = (0, (0, parcelRequire("f9ece")).default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                    if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT)) date = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("pyK8a")).default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                    const dateType = operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT) ? 'to' : 'from';
                    return {
                        value: {
                            [dateType]: date
                        }
                    };
                }
                throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
            };
            this.parseSelectOperand = async (fieldName, operand)=>{
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
                    const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                    return (await Promise.all(optionPromises)).flatMap((option)=>option);
                }
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                    operand.value
                ]);
                if (operand?.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
                    {
                        isEmptyOption: true,
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: ''
                    }
                ];
                throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
            };
            this.visitTerminalClause = async (terminalClause)=>{
                const { field: field, operand: operand, operator: operator } = terminalClause;
                if (!operand || !operator) return Promise.resolve({});
                const getShouldConvertCustomField = (fieldName)=>!(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
                const fieldName = $42cbf7cea9b7c40a$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
                if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
                let value = [];
                if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_GT_EQUALS) || operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
                else if (operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_EQUALS) || operator.value === (0, (0, parcelRequire("bzbto")).OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
                else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
                return {
                    [fieldName]: value
                };
            };
            this.fieldConfig = fieldConfig;
            this.filterFields = filterFields;
            this.resolvers = resolvers;
        }
        visitNotClause() {
            throw new Error('JQL contains invalid clause: NOT');
        }
        defaultResult() {
            return Promise.resolve({});
        }
        async aggregateResult(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(await nextResult, await aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
        aggregateResultSync(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(nextResult, aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
    }
    const $42cbf7cea9b7c40a$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
        const builder = new (0, (0, parcelRequire("eK6AG")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
        const parser = new $42cbf7cea9b7c40a$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
        const parsedJql = await jast.query?.accept(parser);
        return parsedJql ?? {};
    };
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("ab4a1", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$1b74022ad6f4d372$export$479f0f2f71193efe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $hMVQe;
    var $kn3Xd;
    const $1b74022ad6f4d372$var$LazyMenuContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("i5AI2")), {
        moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
    });
    const $1b74022ad6f4d372$export$479f0f2f71193efe = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kn3Xd")).DropdownWrapper), {
            "data-testid": "business-filters.ui.filters.menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "menu-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMVQe")).MenuFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1b74022ad6f4d372$var$LazyMenuContent, props)));
});
parcelRegister("hMVQe", function(module, exports) {
    $parcel$export(module.exports, "MenuFallback", ()=>$a630aa0f7c48ef76$export$1198e585d599d03);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $a630aa0f7c48ef76$export$1198e585d599d03 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a630aa0f7c48ef76$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium",
            testId: "business-filters.common.ui.menu-fallback.spinner"
        }));
    const $a630aa0f7c48ef76$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kn3Xd", function(module, exports) {
    $parcel$export(module.exports, "DropdownWrapper", ()=>$5ca6b1e17ddf2f10$export$5f7211d21bfdae05);
    $parcel$export(module.exports, "ScrollableContent", ()=>$5ca6b1e17ddf2f10$export$6c560fdadeb11d78);
    $parcel$export(module.exports, "DropdownHeaderWrapper", ()=>$5ca6b1e17ddf2f10$export$e23294aded7a8a49);
    $parcel$export(module.exports, "DropdownHeaderButtons", ()=>$5ca6b1e17ddf2f10$export$53ca7a3701b98335);
    $parcel$export(module.exports, "FiltersListSeparator", ()=>$5ca6b1e17ddf2f10$export$1a67069896d998b9);
    $parcel$export(module.exports, "FiltersListWrapper", ()=>$5ca6b1e17ddf2f10$export$a5a9080bd2c85987);
    $parcel$export(module.exports, "Section", ()=>$5ca6b1e17ddf2f10$export$6e2c8f0811a474ce);
    $parcel$export(module.exports, "LastSection", ()=>$5ca6b1e17ddf2f10$export$1faf3c7558df435);
    $parcel$export(module.exports, "SectionMessageWrapper", ()=>$5ca6b1e17ddf2f10$export$c5e20d5e200edfe2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gzkAf;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT = 52;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
    const $5ca6b1e17ddf2f10$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6c560fdadeb11d78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uik9ob": (0, (0, parcelRequire("lD23V")).default)(`calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${(__cmplp.offsetTop ?? (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP)) + $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$e23294aded7a8a49 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
                __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$53ca7a3701b98335 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1a67069896d998b9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81alc _x3do13y8",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$a5a9080bd2c85987 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1faf3c7558df435 = (0, $5uXOq.forwardRef)(({ as: C = $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdidpf _zulpidpf",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5AI2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("44yBr")
    ]).then(()=>parcelRequire('lk6eZ'));
});
parcelRegister("6xNkv", function(module, exports) {
    $parcel$export(module.exports, "Trigger", ()=>$9499219f0b3ef189$export$41fb9f06171c75f4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bTqXB;
    var $hORKG;
    var $4R6GH;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $fj0YT;
    const $9499219f0b3ef189$var$FILTER_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bTqXB"))))), {
        label: "",
        size: "small"
    });
    const $9499219f0b3ef189$export$41fb9f06171c75f4 = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterMessageOld = (0, $5uXOq.useMemo)(()=>{
            if (count > 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            });
            if (hasFiltersApplied) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const filterMessage = (0, $5uXOq.useMemo)(()=>{
            if (hasFiltersApplied && count === 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const TriggerButton = withThemedButton ? (0, (0, parcelRequire("22OQR")).ThemedButton) : (0, (0, parcelRequire("fVnbM")).default);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            "aria-label": formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            }),
            ref: ref,
            isDisabled: isDisabled,
            isSelected: isSelected || count > 0,
            onClick: onClick,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconAfter: count === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                label: "",
                color: "currentColor"
            }) : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessage, count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$BadgeContents, null, count))) : (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            ref: ref,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconBefore: $9499219f0b3ef189$var$FILTER_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: (0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') ? appearance : 'subtle',
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessageOld));
    });
    const $9499219f0b3ef189$var$ButtonContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _zulp12x7 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9499219f0b3ef189$var$BadgeContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _bfhkllho _ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _4t3i1j6v _1ul91j6v _2rkogqwt _11c81oud",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fj0YT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$483bd49c4d6c7782$export$2e2bcd8739ae039);
    var $7VHMR;
    var $483bd49c4d6c7782$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filtersCount: {
            "id": "business-filters.filters.trigger.filters-count",
            "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
        },
        filterButton: {
            "id": "business-filters.filters.trigger.filter-button",
            "defaultMessage": "Filter"
        },
        buttonWithFilters: {
            "id": "business-filters.filters.trigger.button-with-filters",
            "defaultMessage": "Filters applied"
        },
        newLozenge: {
            "id": "business-filters.filters.trigger.new-lozenge",
            "defaultMessage": "New"
        },
        newLozengeTooltip: {
            "id": "business-filters.filters.trigger.new-lozenge-tooltip",
            "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
        }
    });
});
parcelRegister("4Mmyc", function(module, exports) {
    $parcel$export(module.exports, "SimpleSearchTextField", ()=>$c9154e4bfb02bfbe$export$63f96dda4bd4f7dc);
    $parcel$export(module.exports, "SimpleSearchField", ()=>$c9154e4bfb02bfbe$export$44e8ccf3428dc1d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $42CjB;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $8CUq3;
    var $kY99m;
    var $6cG4N;
    var $4R6GH;
    var $koVbs;
    var $jDrwg;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $l4v6E;
    var $1T1ir;
    var $emybt;
    const $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH = 184;
    const $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc = (0, $5uXOq.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId = 'searchfield', isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [searchValue, setSearchValue] = (0, $5uXOq.useState)(externalValue);
        const handleSearchChange = (0, $5uXOq.useCallback)((newValue)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
                view: view,
                ...(0, (0, parcelRequire("l4v6E")).getTextFieldAttributes)(newValue)
            });
            onChange(newValue);
        }, [
            createAnalyticsEvent,
            onChange,
            view
        ]);
        const [handleSearchChangeDebounced] = (0, (0, parcelRequire("jDrwg")).default)(handleSearchChange, 500);
        const handleChange = (0, $5uXOq.useCallback)((e)=>{
            setSearchValue(e.target.value);
            handleSearchChangeDebounced(e.target.value);
        }, [
            handleSearchChangeDebounced
        ]);
        const handleClear = (0, $5uXOq.useCallback)(()=>{
            setSearchValue('');
            handleSearchChangeDebounced('');
        }, [
            setSearchValue,
            handleSearchChangeDebounced
        ]);
        const themedIconPrimaryColor = isDisabled ? (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_DISABLED : (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_SUBTLEST;
        const Container = themedField ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? $c9154e4bfb02bfbe$var$ThemedContainer : $c9154e4bfb02bfbe$var$ThemedContainerOld : (0, $5uXOq.Fragment);
        (0, $5uXOq.useEffect)(()=>{
            setSearchValue(externalValue);
        }, [
            externalValue
        ]);
        const elemAfterSearchIcon = !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
        }) : null;
        let textFieldWidth;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ref: inputRef,
            "aria-describedby": describedbyId,
            testId: testId,
            value: searchValue,
            isCompact: true,
            placeholder: formatMessage(placeholder),
            "aria-label": label || formatMessage(placeholder),
            onChange: handleChange,
            onFocus: onFocus,
            isDisabled: isDisabled,
            elemAfterInput: searchValue !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                paddingInlineEnd: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'space.025' : undefined
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                        ...iconProps,
                        label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                        spacing: "none",
                        color: "var(--ds-text, #172B4D)",
                        LEGACY_size: "small",
                        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                testId: "business-filters.ui.simple-search-field.clear-button",
                onClick: handleClear
            })) : elemAfterSearchIcon,
            elemBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $c9154e4bfb02bfbe$var$iconStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
                color: "currentColor",
                label: "",
                spacing: "none"
            })),
            width: textFieldWidth,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_dzcou2gc"
            ])
        }));
    });
    const $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5 = (0, $5uXOq.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
        const [simpleSearch, setSimpleSearch] = (0, (0, parcelRequire("1T1ir")).useSimpleSearch)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleFocus = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
                view: view
            });
        }, [
            createAnalyticsEvent,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onChange) onChange(simpleSearch);
        }, [
            onChange,
            simpleSearch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$export$63f96dda4bd4f7dc, {
            view: view,
            onFocus: handleFocus,
            describedbyId: describedbyId,
            onChange: (text)=>{
                if (onChange) onChange(text);
                return setSimpleSearch(text);
            },
            value: simpleSearch,
            placeholder: placeholder
        }));
    });
    const $c9154e4bfb02bfbe$var$textFieldStyles = null;
    const $c9154e4bfb02bfbe$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginLeft: 'space.075'
    });
    const $c9154e4bfb02bfbe$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_6l8rjjc1 _x2xkjjc1 _sg3vjjc1 _w15ajjc1 _n8yf4zrn _jeievy9e _7n83frbu _1o8h13fh _n2ul1jo4",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$ThemedContainerOld = (0, $5uXOq.forwardRef)(({ as: C = $c9154e4bfb02bfbe$var$ThemedContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n8yfim6e",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
parcelRegister("l4v6E", function(module, exports) {
    $parcel$export(module.exports, "getTextFieldAttributes", ()=>$211f318fc379b0d9$export$dfd7972bcd113afb);
    const $211f318fc379b0d9$export$dfd7972bcd113afb = (value = '')=>{
        const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
        return {
            queryLength: value.length,
            wordCount: wordCount
        };
    };
});
parcelRegister("emybt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5a1b27b61b41126$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5a1b27b61b41126$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "business-filters.simple-search-field.clear",
            "defaultMessage": "Clear"
        }
    });
});
parcelRegister("17X6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a40c8fa5f1e21a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    var $e1OxR;
    const $0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("5Kdrw")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
    });
    const $0a40c8fa5f1e21a1$var$AddPeopleWithAvatar = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.invite-people.add-people-with-avatars",
            packageName: "jiraBusinessInvitePeople",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "invite-button-with-avatars",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$AvatarFallback, null)
        }, props?.hasInviteButton === false ? (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1OxR")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props))));
    const $0a40c8fa5f1e21a1$var$AvatarFallback = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp",
                __cmplp.className
            ])
        });
    });
    var $0a40c8fa5f1e21a1$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0a40c8fa5f1e21a1$var$AddPeopleWithAvatar);
});
parcelRegister("e1OxR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f3117b4e456671f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $7wK4b;
    var $bZLPe;
    const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
        const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        if (isModalOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZLPe")).ProjectInvitePeopleModal), {
            onModalClose: closeAddPeopleModal,
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        });
        return null;
    };
    const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7wK4b")).AddPeopleProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira-business.invite-people.ui.add-people",
            packageName: "jira-business.invite-people.ui.add-people",
            teamName: "jira-warepil"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
            "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        }))));
    var $0f3117b4e456671f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
    const $0f3117b4e456671f$var$InviteWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7wK4b", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleProvider", ()=>$3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
    $parcel$export(module.exports, "useAddPeople", ()=>$3ebbf4ad1e53c7be$export$93ea361ec674cff6);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $8zOmE;
    var $2NMNM;
    const $3ebbf4ad1e53c7be$var$AddPeopleContext = (0, $5uXOq.createContext)({
        triggerBtnRef: {
            current: null
        },
        isModalOpen: false,
        openAddPeopleModal: ()=>{},
        closeAddPeopleModal: ()=>{}
    });
    const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const triggerBtnRef = (0, $5uXOq.useRef)(null);
        const onCloseCallbackRef = (0, $5uXOq.useRef)();
        const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
            setIsModalOpen(true);
            const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
                source: source
            });
            if (onClose) onCloseCallbackRef.current = onClose;
        }, [
            createAnalyticsEvent,
            projectData.isSimplified
        ]);
        const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
            setIsModalOpen(false);
            if (typeof onCloseCallbackRef.current === 'function') {
                onCloseCallbackRef.current();
                onCloseCallbackRef.current = null;
            }
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                triggerBtnRef: triggerBtnRef,
                isModalOpen: isModalOpen,
                openAddPeopleModal: openAddPeopleModal,
                closeAddPeopleModal: closeAddPeopleModal
            }), [
            triggerBtnRef,
            isModalOpen,
            openAddPeopleModal,
            closeAddPeopleModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
            value: context
        }, children);
    };
    const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);
});
parcelRegister("bZLPe", function(module, exports) {
    $parcel$export(module.exports, "ProjectInvitePeopleModal", ()=>$74aeebd820c67267$export$6dfea89767cb5ac1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $2erM2;
    var $cb8cx;
    var $9AFuM;
    const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, (0, parcelRequire("2erM2")).useInviteModalHandlers)();
        if (!shouldUseInvitePeopleModal && projectData.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb8cx")).AddPeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AFuM")).InvitePeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError,
            source: source
        });
    };
});
parcelRegister("2erM2", function(module, exports) {
    $parcel$export(module.exports, "useInviteModalHandlers", ()=>$d23a63b1c343bca5$export$f696e14fc423d0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $99ejj;
    var $kPioc;
    const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
            const hasSentInvitation = inviteStatus === (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
            const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
            showFlag(hasSuccessfullyAddedPeople ? (0, (0, parcelRequire("kPioc")).createAddSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                projectKey: projectData.key
            }) : (0, (0, parcelRequire("kPioc")).createInviteSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                hasSentInvitation: hasSentInvitation
            }));
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
                inviteStatus: inviteStatus
            });
        }, [
            createAnalyticsEvent,
            showFlag,
            projectData
        ]);
        const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
            if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
                showFlag((0, (0, parcelRequire("kPioc")).createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
                return;
            }
            if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailGenericFlagConfig));
            else showFlag((0, (0, parcelRequire("kPioc")).inviteFailFlagConfig));
            const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
            if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `jwm${modalType}Invite`,
                    packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: errorMessage
                },
                error: new Error(errorMessage),
                sendToPrivacyUnsafeSplunk: true
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
        }, [
            createAnalyticsEvent,
            isSiteAdmin,
            showFlag
        ]);
        return {
            handleAddSuccess: handleAddSuccess,
            handleError: handleError
        };
    };
});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';
parcelRegister("99ejj", function(module, exports) {
    $parcel$export(module.exports, "InvitationStatusEnum", ()=>$e49e7d7763027049$export$2e0a7d2dc28c9a18);
    const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
        ACCESS_REQUESTED: 'ACCESS_REQUESTED',
        INVITED: 'INVITED'
    };
});
parcelRegister("kPioc", function(module, exports) {
    $parcel$export(module.exports, "inviteFailFlagConfig", ()=>$366128c003d2496b$export$95c6157ced8b3439);
    $parcel$export(module.exports, "inviteFailGenericFlagConfig", ()=>$366128c003d2496b$export$1108ab4b8a5d8a7d);
    $parcel$export(module.exports, "inviteFailBadRequestFlagConfig", ()=>$366128c003d2496b$export$7f2d6442eed4d708);
    $parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", ()=>$366128c003d2496b$export$c3bdacfc2255a9ed);
    $parcel$export(module.exports, "createInviteSuccessFlagConfig", ()=>$366128c003d2496b$export$d456881895c2a0b2);
    $parcel$export(module.exports, "createAddSuccessFlagConfig", ()=>$366128c003d2496b$export$cca35dec2a083169);
    $parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", ()=>$366128c003d2496b$export$251dc06b3962c565);
    var $8zOmE;
    var $6OFcj;
    const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
        if (totalPeopleAdded <= 0) return [
            agnosticDescription,
            {}
        ];
        return [
            specificDescription,
            {
                totalPeopleAddedMinusOne: totalPeopleAdded - 1,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }
        ];
    };
    const $366128c003d2496b$export$95c6157ced8b3439 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageDescription,
        actions: [
            {
                content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
            }
        ]
    };
    const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedGenericMessageDescription
    };
    const $366128c003d2496b$export$7f2d6442eed4d708 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedBadRequestMessageDescription
    };
    const $366128c003d2496b$export$c3bdacfc2255a9ed = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedNetworkErrorMessageDescription
    };
    const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
        if (!hasSentInvitation) return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            })
        };
        return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            })
        };
    };
    const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            actions: [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).peopleAddedManageAccess,
                    onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
                }
            ]
        });
    const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
            type: 'warning',
            title: (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorTitle,
            description: isSiteAdmin ? (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescriptionAdmin : (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescription,
            actions: isSiteAdmin ? [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).upgradePlan,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                        window.open('/admin/billing/applications', '_blank');
                    }
                },
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).viewUsers,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                        window.open('/admin/users', '_blank');
                    }
                }
            ] : [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                        window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                    }
                }
            ]
        });
});
parcelRegister("6OFcj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87007b6d35f6d31$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
            "defaultMessage": "Invitation sent"
        },
        inviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
            "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
        },
        inviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
            "defaultMessage": "You've successfully invited people to your business project."
        },
        inviteFailedMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
            "defaultMessage": "Something went wrong"
        },
        inviteFailedMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
        },
        inviteFailedMessageCta: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
            "defaultMessage": "Contact your admin"
        },
        inviteFailedGenericMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users, please try again."
        },
        inviteFailedBadRequestMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
        },
        inviteFailedNetworkErrorMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
        },
        requestInviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
            "defaultMessage": "Access request sent to your admin"
        },
        requestInviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
            "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
        },
        requestInviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
            "defaultMessage": "Your admin needs to approve access for people to your business project."
        },
        peopleAddedSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
            "defaultMessage": "New people added"
        },
        peopleAddedSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
            "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
            "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedManageAccess: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
            "defaultMessage": "Manage access"
        },
        userLimitInviteErrorTitle: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
            "defaultMessage": "Can't add more people"
        },
        userLimitInviteErrorDescriptionAdmin: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
            "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
        },
        userLimitInviteErrorDescription: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
            "defaultMessage": "You've reached your user limit. Contact your admin for help."
        },
        viewUsers: {
            "id": "business-invite-people.controllers.modal-handlers.view-users",
            "defaultMessage": "View users"
        },
        upgradePlan: {
            "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
            "defaultMessage": "Upgrade plan"
        }
    });
});
parcelRegister("cb8cx", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleModal", ()=>$4afbb4a2961eae5f$export$b28f48897cdf7241);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $daQYX;
    var $heNNl;
    var $lfTZh;
    var $5oFIy;
    var $itmJb;
    var $kxZPA;
    var $7wK4b;
    const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7HRyA")), {
        ssr: false,
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
        BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
        NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
        AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
        SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
        USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
    };
    const $4afbb4a2961eae5f$export$b28f48897cdf7241 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
        const { triggerBtnRef: triggerBtnRef } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
            onInviteSuccess({
                totalPeopleAdded: addedParties.length,
                email: addedParties[0]?.email || addedParties[0]?.displayName,
                modalType: 'Project'
            });
        }, [
            onInviteSuccess
        ]);
        const extractErrorCode = (message)=>{
            for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
                const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
                if (message.includes(errorMessage)) return errorCode;
            }
            return message;
        };
        const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
            const userInviteErrorsWithCode = {};
            errors.forEach((error)=>{
                const errorCode = extractErrorCode(error.message);
                if (errorCode) {
                    if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                    userInviteErrorsWithCode[errorCode].push(error);
                }
            });
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode;
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
        }, [
            onInviteError
        ]);
        const { id: id, key: key } = projectData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.add-people",
            packageName: "jira-business.project-invite-people-modal.add-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmProjectInviteComponent viewed"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-people-modal-lazy",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
            isOpen: true,
            triggerBtnRef: triggerBtnRef,
            onClose: onModalClose,
            onAddSuccess: handleInviteSuccess,
            onError: handleInviteFailure,
            projectId: id,
            projectKey: key,
            projectType: "business",
            isAdmin: isAdmin,
            baseUrl: "",
            analyticsPrefix: "",
            allowFlags: false,
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz)))
        })));
    });
});
parcelRegister("7HRyA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("9AFuM", function(module, exports) {
    $parcel$export(module.exports, "InvitePeopleModal", ()=>$5ae346fd9b1f20af$export$e3ec81c4d0451f63);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $9fuVs;
    var $65Ltd;
    var $heNNl;
    var $7NYq5;
    var $lfTZh;
    var $6jY6G;
    var $5oFIy;
    var $12hlA;
    var $14XJw;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    var $koeKL;
    var $itmJb;
    var $kxZPA;
    var $99ejj;
    const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("i57tV")), {
        ssr: false,
        moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
    });
    const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
        if (res.accessRequested?.length) return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).ACCESS_REQUESTED;
        return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
    };
    const $5ae346fd9b1f20af$var$LIST_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST)
    ];
    const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>res.failure !== undefined;
    const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
            if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
                const { message: message, status: status } = response.failure;
                onInviteError({
                    modalType: 'Instance',
                    errorMessage: message,
                    statusCode: status
                });
                return;
            }
            const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
            const { invited: invited, accessRequested: accessRequested } = response;
            onInviteSuccess({
                totalPeopleAdded: invited.length || accessRequested.length,
                email: invited[0]?.email || accessRequested[0]?.email || '',
                modalType: 'Instance',
                inviteStatus: inviteStatus
            });
        }, [
            onInviteError,
            onInviteSuccess
        ]);
        const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
            route
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.invite-people",
            packageName: "jira-business.project-invite-people-modal.invite-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal.invite-people",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NYq5")).JiraModal), {
            messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
            messageType: "transactional",
            onClose: onModalClose,
            width: "small",
            shouldScrollInViewport: true,
            testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmInstanceInviteComponent viewed"
        }), isSoftwareRoute ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12hlA")).default), {
            isOpen: true,
            cloudId: cloudId,
            projectId: projectData.id,
            jiraProjectKey: projectData.key,
            isSiteAdmin: isAdmin,
            onClose: onModalClose,
            appEdition: (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions),
            jiraProjectName: projectData.name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
            onSendHandler: onModalClose,
            onInviteCompletedHandler: onInviteCompleteHandler,
            onCancelHandler: onModalClose,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            continueUrl: window.location.href,
            enableThirdParty: true,
            source: source,
            orgId: orgId
        })))));
    });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("7NYq5", function(module, exports) {
    $parcel$export(module.exports, "JiraModal", ()=>$d308ab9275c4cac7$export$3782fcca1f68992e);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $10xFf;
    var $1WAOl;
    const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1WAOl")).ChoreographerModal), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), rest);
    };
    $d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';
});
parcelRegister("1WAOl", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerModal", ()=>$ae3d8c3c4e97b978$export$3f5d627caa6fc630);
    var $1R1Ge;
    var $cSWNW;
    const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("1R1Ge")).default));
});
parcelRegister("12hlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bc8c7c74346f034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $0bc8c7c74346f034$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jWZZk")), {
        moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
    });
    const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-invite-people-modal",
            packageName: "jira-project-invite-people-modal",
            teamName: "groot-growth"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
    var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;
});
parcelRegister("jWZZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6C6tQ")
    ]).then(()=>parcelRequire('3dNZP'));
});
parcelRegister("i57tV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gPcKY")
    ]).then(()=>parcelRequire('ddHJI'));
});
parcelRegister("5Kdrw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eeBXE")
    ]).then(()=>parcelRequire('62h3r'));
});
parcelRegister("ccsmj", function(module, exports) {
    $parcel$export(module.exports, "JWMShareButton", ()=>$e895e30d5d3d8dcc$export$b326da26415fdf10);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZX0t;
    var $12jwF;
    var $koVbs;
    var $22OQR;
    var $iL8EU;
    var $9j8is;
    var $fjgF8;
    var $4XKuc;
    const $e895e30d5d3d8dcc$var$SHARE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
        label: "",
        size: "small"
    });
    const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { shareIntegrations: shareIntegrations } = (0, (0, parcelRequire("9j8is")).useShareIntegrations)(shareContentType);
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const shareButtonRef = (0, $5uXOq.useRef)(null);
        const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                ...triggerProps,
                ref: shareButtonRef,
                onClick: onClick,
                isSelected: isSelected,
                iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("4XKuc")).default).share))), [
            formatMessage
        ]);
        const handleDialogClose = ()=>{
            onDialogClose?.();
            shareButtonRef?.current?.focus();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjgF8")).AsyncShareProjectNudge), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            isAutoOpenDialog: isAutoOpenDialog,
            integrationType: integrationType,
            triggerButtonStyle: "icon-with-text",
            productId: "jira",
            subProductId: "jira-core",
            shareLink: false ? '' : window.location.href,
            shareTitle: formatMessage(shareTitle),
            shareContentType: shareContentType,
            renderCustomTriggerButton: renderCustomTriggerButton,
            objectAri: entityAri,
            onDialogClose: handleDialogClose,
            copyTooltipText: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareTooltipText),
            shareIntegrations: shareIntegrations,
            integrationMode: "tabs",
            shareFormHelperMessage: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareJwmHelperMessage)
        }));
    };
});
parcelRegister("jZX0t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
    function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e8f17c524b03e26b$var$ShareIcon = (props)=>$e8f17c524b03e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $e8f17c524b03e26b$var$_share.default
        }));
    $e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
    var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;
});
parcelRegister("empdx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a746ae65a0e1944c$var$ShareIcon = (props)=>$a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
    var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;
});
parcelRegister("12jwF", function(module, exports) {
    $parcel$export(module.exports, "AriProvider", ()=>$d9a27a44a6301e03$export$c806f8ac05dc61fa);
    $parcel$export(module.exports, "useEntityAri", ()=>$d9a27a44a6301e03$export$badcacdc306567b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d9a27a44a6301e03$var$AriContext = (0, $5uXOq.createContext)('');
    const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
            value: ari
        }, children);
    const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $jZX0t;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("9j8is", function(module, exports) {
    $parcel$export(module.exports, "useShareIntegrations", ()=>$d021f3111fd4c646$export$58a9f7a7ab3466f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $bCdIp;
    var $pa9q9;
    var $koeKL;
    var $2UEtd;
    var $aMZmw;
    const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
            const reasons = [];
            if ((0, (0, parcelRequire("bCdIp")).default)()) reasons.push('notDesktop');
            if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) reasons.push('isFedRAMP');
            return reasons;
        }, []);
        const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
                {
                    type: 'Slack',
                    Icon: (0, (0, parcelRequire("aMZmw")).default),
                    Content: ({ onClose: onClose, changeTab: changeTab })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2UEtd")).ShareToSlack), {
                            showFlag: showFlag,
                            product: "jira",
                            channel: "productAnalytics",
                            onClose: onClose,
                            cloudId: cloudId,
                            changeTab: changeTab,
                            shareContentType: shareContentType
                        })
                }
            ] : [], [
            ineligibilityReasons.length,
            showFlag,
            cloudId,
            shareContentType
        ]);
        return {
            shareIntegrations: shareIntegrations
        };
    };
});
parcelRegister("2UEtd", function(module, exports) {
    $parcel$export(module.exports, "ShareToSlack", ()=>$168b88234834bfea$export$2cc56764fd9edb21);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $ldfcP;
    const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async-share-to-slack",
            packageName: "integrations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-to-slack",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldfcP")).StyledShareToSlackLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldfcP")).StyledShareToSlack), props)));
});
parcelRegister("ldfcP", function(module, exports) {
    $parcel$export(module.exports, "StyledShareToSlack", ()=>$d8ff40467b89e314$export$9aeb6210c91511b9);
    $parcel$export(module.exports, "StyledShareToSlackLoader", ()=>$d8ff40467b89e314$export$d3f97cc63e3ee02);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $3xc3R;
    const $d8ff40467b89e314$export$9aeb6210c91511b9 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("3xc3R")).LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8ax2b",
                __cmplp.className
            ])
        });
    });
    const $d8ff40467b89e314$export$d3f97cc63e3ee02 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("eZJjh")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3xc3R", function(module, exports) {
    $parcel$export(module.exports, "LazyShareToSlack", ()=>$0733f18014b5074d$export$24281652e6b89b3b);
    var $kxZPA;
    const $0733f18014b5074d$export$24281652e6b89b3b = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3MPjw")), {
        ssr: false,
        moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
    });
});
parcelRegister("3MPjw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("mbt92")
    ]).then(()=>parcelRequire('2B8HF'));
});
parcelRegister("aMZmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1ef732ae0096135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "4 4 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
            fill: "#ECB22E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("fjgF8", function(module, exports) {
    $parcel$export(module.exports, "AsyncShareProjectNudge", ()=>$7ce891b6fd7965bb$export$d95995d6ca76620b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("iEJkp")), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
    });
    const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-share-project-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));
});
parcelRegister("iEJkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qj8a").then(()=>parcelRequire('dRf63'));
});
parcelRegister("4XKuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ed6b88152ef6ea6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "business-invite-people.jwm-share-button.share",
            "defaultMessage": "Share"
        },
        shareTooltipText: {
            "id": "business-invite-people.jwm-share-button.share-tooltip-text",
            "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
        },
        shareJwmHelperMessage: {
            "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
            "defaultMessage": "This view, along with any applied groups and filters are shared"
        }
    });
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments',
        DEPENDENCIES: 'dependencies',
        INCREMENT: 'increment'
    };
});
parcelRegister("qFY65", function(module, exports) {
    $parcel$export(module.exports, "NavigateCalendarNudgeAsync", ()=>$229226faeafa8ca1$export$b490bac9f0bf9652);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $229226faeafa8ca1$var$NavigateCalendarNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jbf4k")).then((exportedModule)=>exportedModule.NavigateCalendarNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-calendar-nudge-tour/navigate-calendar/index.tsx"
    });
    const $229226faeafa8ca1$export$b490bac9f0bf9652 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$fb9c6e63a7490968),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$1e174cd1e0212f3a)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "navigate-calendar-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($229226faeafa8ca1$var$NavigateCalendarNudgeLazy, null, children)));
    $229226faeafa8ca1$export$b490bac9f0bf9652.displayName = 'NavigateCalendarNudgeAsync';
});
parcelRegister("jbf4k", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f3iG2").then(()=>parcelRequire('f3vXN'));
});
parcelRegister("6XjOz", function(module, exports) {
    $parcel$export(module.exports, "CalendarReleasesNudgeAsync", ()=>$387c41e06f3e64c2$export$2b32ab1b094afa23);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $387c41e06f3e64c2$var$CalendarReleasesNudgeLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8uPMX")).then((exportedModule)=>exportedModule.CalendarReleasesNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-calendar-releases/index.tsx"
    });
    const $387c41e06f3e64c2$export$2b32ab1b094afa23 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$791f56b3d78403cc),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$791f56b3d78403cc)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "calendar-releases-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($387c41e06f3e64c2$var$CalendarReleasesNudgeLazy, props, children)));
    $387c41e06f3e64c2$export$2b32ab1b094afa23.displayName = 'CalendarReleasesNudgeAsync';
});
parcelRegister("8uPMX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6FOHO").then(()=>parcelRequire('bsKpw'));
});
parcelRegister("2M3ip", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cbcf529c6fb7cb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $0cbcf529c6fb7cb9$var$UnscheduledIconSVG = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15 2C15.5128 2 15.9355 2.38602 15.9933 2.88336L16 3V4H18C19.0544 4 19.9182 4.81585 19.9945 5.85071L20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8V3C8 2.44771 8.44771 2 9 2C9.51284 2 9.93551 2.38602 9.99327 2.88336L10 3V4H14V3C14 2.44771 14.4477 2 15 2ZM18 11H6V18H18V11ZM8 6H6V9H18V6H16V7C16 7.55229 15.5523 8 15 8C14.4872 8 14.0645 7.61398 14.0067 7.11664L14 7V6H10V7C10 7.55229 9.55229 8 9 8C8.48716 8 8.06449 7.61398 8.00673 7.11664L8 7V6Z",
            fill: "currentColor"
        }));
    const $0cbcf529c6fb7cb9$var$UnscheduledIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $0cbcf529c6fb7cb9$var$UnscheduledIconSVG,
            ...props
        });
    var $0cbcf529c6fb7cb9$export$2e2bcd8739ae039 = $0cbcf529c6fb7cb9$var$UnscheduledIcon;
});
parcelRegister("gDHD8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb1c44b1b4a5adf1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cb1c44b1b4a5adf1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        todayButton: {
            "id": "business-calendar.calendar-view.toolbar.today-button",
            "defaultMessage": "Today"
        },
        nextMonthButton: {
            "id": "business-calendar.calendar-view.toolbar.next-month-button",
            "defaultMessage": "Next month"
        },
        prevMonthButton: {
            "id": "business-calendar.calendar-view.toolbar.prev-month-button",
            "defaultMessage": "Previous month"
        },
        shareTitle: {
            "id": "business-calendar.calendar-view.toolbar.share-title",
            "defaultMessage": "Calendar"
        },
        simpleSearch: {
            "id": "business-calendar.calendar-view.toolbar.simple-search",
            "defaultMessage": "Search calendar"
        },
        unscheduled: {
            "id": "business-calendar.calendar-view.toolbar.unscheduled",
            "defaultMessage": "Unscheduled"
        }
    });
});
parcelRegister("2rLXY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b0f6ae1641a31b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2SbUq;
    var $9zWht;
    const $4b0f6ae1641a31b7$var$MoreMenu = (0, $5uXOq.memo)(({ hideDoneItems: hideDoneItems, onChangeHideDoneItems: onChangeHideDoneItems, forceVisibility: forceVisibility })=>{
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9zWht")).default), {
                hideDoneItems: hideDoneItems,
                onChangeHideDoneItems: onChangeHideDoneItems
            }), [
            onChangeHideDoneItems,
            hideDoneItems
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2SbUq")).default), {
            renderContent: renderContent,
            forceVisibility: forceVisibility
        });
    });
    var $4b0f6ae1641a31b7$export$2e2bcd8739ae039 = $4b0f6ae1641a31b7$var$MoreMenu;
});
parcelRegister("2SbUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d5dde4b111cc89$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $1I7E8;
    var $co1wz;
    var $l8ruj;
    var $loRkl;
    const $86d5dde4b111cc89$var$MoreMenuCore = (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f1bdb30d4d079129$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
        (0, $5uXOq.useEffect)(()=>{
            setIsOpen(forceVisibility);
        }, [
            forceVisibility
        ]);
        const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($86d5dde4b111cc89$export$5f7211d21bfdae05, {
                width: minWidth
            }, renderContent(closeMenu)), [
            closeMenu,
            renderContent,
            minWidth
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loRkl")).default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: toggleMenu
            }), [
            isOpen,
            toggleMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-more-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: closeMenu,
            placement: "bottom-end",
            content: content,
            trigger: trigger,
            shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds'),
            strategy: (0, (0, parcelRequire("co1wz")).ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
        }));
    });
    var $86d5dde4b111cc89$export$2e2bcd8739ae039 = $86d5dde4b111cc89$var$MoreMenuCore;
    const $86d5dde4b111cc89$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_6f8077": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1hdq",
                __cmplp.className
            ])
        });
    });
});
const $f1bdb30d4d079129$export$8c68b096b2d5e9f6 = 320;
parcelRegister("loRkl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbbabf378481667d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8U6zd;
    var $3oUqw;
    var $7XYc4;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $dSexS;
    const $fbbabf378481667d$var$MORE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
        label: "",
        size: "small"
    });
    const $fbbabf378481667d$var$TriggerOld = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconBefore: $fbbabf378481667d$var$MORE_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle",
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel)
        }, formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton));
    });
    const $fbbabf378481667d$var$Trigger = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            isSelected: isSelected,
            onClick: onClick,
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel),
            title: formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton)
        });
    });
    var $fbbabf378481667d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $fbbabf378481667d$var$Trigger, $fbbabf378481667d$var$TriggerOld);
});
parcelRegister("dSexS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52d3441e2e3906d4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52d3441e2e3906d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreButton: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
            "defaultMessage": "More"
        },
        moreButtonLabel: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
            "defaultMessage": "More actions on the view options"
        }
    });
});
parcelRegister("9zWht", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f8af8fa0f51ebd5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2h2vc;
    var $lfTZh;
    var $kxZPA;
    const $5f8af8fa0f51ebd5$var$LazyMenuContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4bJX2")), {
        ssr: false,
        moduleId: "./src/packages/business/calendar/src/ui/calendar-view/toolbar/more-menu/more-menu-content/main.tsx"
    });
    var $5f8af8fa0f51ebd5$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "menu-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2h2vc")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5f8af8fa0f51ebd5$var$LazyMenuContent, props));
});
parcelRegister("2h2vc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b39db453d8ec83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $j6WEs;
    const $c4b39db453d8ec83$var$MenuFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6WEs")).SpinnerWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "medium"
        }));
    var $c4b39db453d8ec83$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c4b39db453d8ec83$var$MenuFallback);
});
parcelRegister("j6WEs", function(module, exports) {
    $parcel$export(module.exports, "SpinnerWrapper", ()=>$ef469de38bc42c7b$export$52b4dfd89a6b3a1b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ef469de38bc42c7b$export$52b4dfd89a6b3a1b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4bJX2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("c7H1h")
    ]).then(()=>parcelRequire('cTZQo'));
});
parcelRegister("86Mrh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2febee74e5d9fe1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $iXVV6;
    var $kxZPA;
    const $b2febee74e5d9fe1$var$PACKAGE_NAME = 'businessUnscheduledItemsInCalendarView';
    const $b2febee74e5d9fe1$export$a385628937f962e4 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("6Rwpb")), {
        moduleId: "./src/packages/business/calendar/src/ui/calendar-view/unscheduled-sidebar/index.tsx"
    });
    const $b2febee74e5d9fe1$var$AsyncUnscheduledSidebar = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: $b2febee74e5d9fe1$var$PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "unscheduled-side-bar",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b2febee74e5d9fe1$export$a385628937f962e4, props)));
    var $b2febee74e5d9fe1$export$2e2bcd8739ae039 = $b2febee74e5d9fe1$var$AsyncUnscheduledSidebar;
});
parcelRegister("6Rwpb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("6L97Z")),
        $6fhBS("Rvhoy")
    ]).then(()=>parcelRequire('1DC0I'));
});
parcelRegister("hdHHP", function(module, exports) {
    $parcel$export(module.exports, "getFullCalendarDateProfile", ()=>$88a10a92335a8e89$export$f79aec4f3b7ab494);
    $parcel$export(module.exports, "getInitialCalendarViewRangeDateOnly", ()=>$88a10a92335a8e89$export$d3ddeea15f22e54e);
    $parcel$export(module.exports, "monthsBetweenCurrentDateOnly", ()=>$88a10a92335a8e89$export$5345f7bcc6463aab);
    $parcel$export(module.exports, "calendarEventOrderSort", ()=>$88a10a92335a8e89$export$a6599049d127e1ae);
    var $gwejS;
    var $SzDmm;
    var $4kK95;
    const $88a10a92335a8e89$var$getInitialDates = ()=>{
        const date = new Date();
        return {
            firstDayOfTheMonth: new Date(date.getFullYear(), date.getMonth(), 1),
            lastDayOfTheMonth: new Date(date.getFullYear(), date.getMonth() + 1, 0),
            startDate: new Date(date.getFullYear(), date.getMonth(), -13),
            endDate: new Date(date.getFullYear(), date.getMonth() + 1, 14)
        };
    };
    const $88a10a92335a8e89$export$f79aec4f3b7ab494 = (fullCalendarApi)=>{
        const { currentRange: currentRange, activeRange: activeRange } = fullCalendarApi.getCurrentData().dateProfile;
        return {
            currentRange: currentRange,
            activeRange: activeRange
        };
    };
    const $88a10a92335a8e89$export$d3ddeea15f22e54e = ()=>{
        const { firstDayOfTheMonth: firstDayOfTheMonth, lastDayOfTheMonth: lastDayOfTheMonth, endDate: endDate, startDate: startDate } = $88a10a92335a8e89$var$getInitialDates();
        return {
            currentRange: {
                start: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(firstDayOfTheMonth),
                end: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(lastDayOfTheMonth)
            },
            activeRange: {
                start: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(startDate),
                end: (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToLocalTime(endDate)
            }
        };
    };
    const $88a10a92335a8e89$export$5345f7bcc6463aab = (dateOnly)=>{
        const today = new Date();
        const date = dateOnly.toLocalDate();
        return date.getMonth() - today.getMonth() + 12 * (date.getFullYear() - today.getFullYear());
    };
    const $88a10a92335a8e89$var$getIssue = (event)=>event?.extendedProps?.issue;
    const $88a10a92335a8e89$var$isPlaceholder = (event)=>$88a10a92335a8e89$var$getIssue(event) == null && !$88a10a92335a8e89$var$isReleaseEvent(event);
    const $88a10a92335a8e89$var$isOptimistic = (event)=>$88a10a92335a8e89$var$getIssue(event) && !$88a10a92335a8e89$var$getIssue(event)?.key;
    const $88a10a92335a8e89$var$isIssueEvent = (event)=>Boolean($88a10a92335a8e89$var$getIssue(event)?.key);
    const $88a10a92335a8e89$var$isReleaseEvent = (event)=>Boolean(event?.extendedProps?.release);
    const $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays = (event)=>{
        const issue = $88a10a92335a8e89$var$getIssue(event);
        return issue?.duedate && issue?.startdate ? (0, (0, parcelRequire("SzDmm")).default)((0, (0, parcelRequire("gwejS")).default)(issue?.duedate?.toUTCDate(), 1), issue?.startdate?.toUTCDate()) : 0;
    };
    const $88a10a92335a8e89$export$a6599049d127e1ae = (a, b)=>{
        if ($88a10a92335a8e89$var$isPlaceholder(a) && ($88a10a92335a8e89$var$isIssueEvent(b) || $88a10a92335a8e89$var$isReleaseEvent(b))) return -1;
        if ($88a10a92335a8e89$var$isPlaceholder(b) && ($88a10a92335a8e89$var$isIssueEvent(a) || $88a10a92335a8e89$var$isReleaseEvent(a))) return 1;
        if ($88a10a92335a8e89$var$isReleaseEvent(a) && !$88a10a92335a8e89$var$isReleaseEvent(b)) return $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(b) > 1 ? 1 : -1;
        if ($88a10a92335a8e89$var$isReleaseEvent(b) && !$88a10a92335a8e89$var$isReleaseEvent(a)) return $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(a) > 1 ? -1 : 1;
        if ($88a10a92335a8e89$var$isReleaseEvent(a) && $88a10a92335a8e89$var$isReleaseEvent(b)) return 0;
        if ($88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(a) > 1 || $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(b) > 1) {
            const daysDifference = $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(b) - $88a10a92335a8e89$var$getCalendarEventLengthInCalendarDays(a);
            if (daysDifference < 0) return -1;
            if (daysDifference > 0) return 1;
        }
        if (a?.start && b?.start) {
            const timeDifference = new Date(a.start).getTime() - new Date(b.start).getTime();
            if (timeDifference < 0) return -1;
            if (timeDifference > 0) return 1;
        }
        if (a?.title && b?.title) return b.title.localeCompare(a.title, undefined, {
            numeric: true
        });
        if ($88a10a92335a8e89$var$isOptimistic(a) && !$88a10a92335a8e89$var$isOptimistic(b)) return -1;
        if ($88a10a92335a8e89$var$isOptimistic(b) && !$88a10a92335a8e89$var$isOptimistic(a)) return 1;
        return 0;
    };
});
parcelRegister("7nKe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b120e66bf4d03608$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $12jwF;
    var $54qG5;
    var $5YBrl;
    var $1Zr0i;
    var $daQYX;
    var $cm8b5;
    var $gxGcZ;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $koeKL;
    var $lVJAU;
    var $k7McJ;
    var $8OqLl;
    const $b120e66bf4d03608$var$ProjectContextProvider = ({ children: children })=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = project?.id;
        const projectKey = project?.key;
        const projectType = project?.type;
        const isTeamManaged = Boolean(project?.isSimplified);
        const jqlContext = projectKey ? `project = '${projectKey}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isTeamManaged: isTeamManaged,
                projectType: projectType
            }), [
            projectId,
            isTeamManaged,
            projectType
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>project?.permissions?.viewIssues ? {
                name: project.name,
                id: String(project.id)
            } : null, [
            project
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectId ? [
                projectId
            ] : undefined, [
            projectId
        ]);
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        if (project?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        else if (project == null || entityData == null || error) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE),
            error: error
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectAri
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: String(project?.id),
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: String(project?.id)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        }), content);
    };
    var $b120e66bf4d03608$export$2e2bcd8739ae039 = $b120e66bf4d03608$var$ProjectContextProvider;
});
parcelRegister("k7McJ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", ()=>$47951bf9c4bef1f5$export$cb40bbf7ea51db63);
    const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
        experience: 'fetch-project',
        packageName: 'jiraBusinessEntityProjectProvider',
        teamName: 'wanjel'
    };
});
parcelRegister("8OqLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5cc2e237e9a9763$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a5cc2e237e9a9763$var$NotFoundComponent = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("imwWS")), {
        moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
    });
    const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "not-found-component",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
    var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;
});
parcelRegister("imwWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("azGse")
    ]).then(()=>parcelRequire('4zX1V'));
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
const $08d1cd363c5f7148$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $08d1cd363c5f7148$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $08d1cd363c5f7148$export$f27a837467ec20e5 = 'planWizard';
const $08d1cd363c5f7148$export$6afdd25b4da87159 = 30;
const $08d1cd363c5f7148$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $08d1cd363c5f7148$export$a8e537ef0c1e2586 = 'Days';
const $08d1cd363c5f7148$export$2a59d0fbc784e5c1 = '1';
const $08d1cd363c5f7148$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $08d1cd363c5f7148$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
